// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const ColorIdToColor = [
  "#2f3233",
  "#84949c",
  "#8e775e",
  "#f1e7d0",
  "#646f75",
  "#6a5a48",
  "#c9bfa9",
  "#7b8771",
  "#8a5b3b",
  "#6d585f",
  "#612526",
  "#5c6e6f",
  "#b3a65c",
  "#666666",
  "#8c8c8c",
  "#b3b3b3",
  "#cccccc",
  "#e6e6e6",
  "#a4b495",
  "#a0afb7",
  "#af9981",
  "#fbf3e3",
  "#b9caac",
  "#d8976b",
  "#b0939d",
  "#ac595a",
  "#97b1b2",
  "#ffeec0",
  "#ba774a",
  "#ff69b4",
  "#92747e",
  "#832f30",
  "#799395",
  "#f2f2ed",
  "#f2df77",
  "#b2a9a4",
  "#edece6",
  "#121617",
  "#eeecda",
  "#55544e",
  "#e8d9ba",
  "#f7f5e9",
  "#d1c0aa",
  "#050505",
  "#515255",
  "#615c50",
  "#f8fdff",
  "#2f2f30",
  "#676869",
  "#b9b8b2",
  "#53575e",
  "#e3e5e3",
  "#2f2f30",
  "#363535",
  "#585654",
  "#bc6646",
  "#c8d6e5",
  "#bad2db",
  "#e8e5da",
  "#e4dacd",
  "#a0a09e",
  "#605157",
  "#444c57",
  "#86837b",
  "#676869",
  "#b9b8b2",
  "#e9eae7",
  "#53575e",
  "#c8bfb5",
  "#c2c0bb",
  "#4b2929",
  "#303b39",
  "#403330",
  "#c2b6b6",
  "#756761",
  "#5e6259",
  "#727c7f",
  "#596368",
  "#23383f",
  "#bec1c3",
  "#2f2f30",
  "#313031",
  "#373a3a",
  "#e7e2da",
  "#edeae5",
  "#edece6",
  "#e3ded0",
  "#ccc9c0",
  "#4f4842",
  "#ccc5bd",
  "#867a6f",
  "#887b6c",
  "#d1c7b8",
  "#c0b2a2",
  "#beb5a9",
  "#6b645b",
  "#e0e0d9",
  "#a7a8a2",
  "#7f817e",
  "#636562",
  "#dcd2c3",
  "#60797d",
  "#657b83",
  "#b2ada4",
  "#9d9887",
  "#979fa5",
  "#939591",
  "#988f85",
  "#e3e5e3",
  "#2f2f30",
  "#676869",
  "#b9b8b2",
  "#53575e",
  "#e3e5e3",
  "#2f2f30",
  "#676869",
  "#949488",
  "#cfcbc2",
  "#f0eadc",
  "#eeefea",
  "#8aa3b1",
  "#626970",
  "#b9b8b2",
  "#cfcac7",
  "#978a7f",
  "#d9d7cb",
  "#cfbea9",
  "#bab9b6",
  "#e1d9c5",
  "#d8e0df",
  "#f5e1a6",
  "#d3ccc4",
  "#4f4d51",
  "#edece6",
  "#969eab",
  "#48423c",
  "#53575e",
  "#8e9698",
  "#d6dbd5",
  "#969d95",
  "#2f2f30",
  "#536872",
  "#e3e5e3",
  "#d1c0aa",
  "#2f2f30",
  "#676869",
  "#949488",
  "#cfcbc2",
  "#f0eadc",
  "#eeefea",
  "#8aa3b1",
  "#626970",
  "#b9b8b2",
  "#cfcac7",
  "#978a7f",
  "#d9d7cb",
  "#cfbea9",
  "#bab9b6",
  "#e1d9c5",
  "#d8e0df",
  "#f5e1a6",
  "#d3ccc4",
  "#4f4d51",
  "#edece6",
  "#969eab",
  "#48423c",
  "#53575e",
  "#666c78",
  "#bdc5b8",
  "#2f2f30",
  "#536872",
  "#e3e5e3",
  "#62615c",
  "#575b67",
  "#313031",
  "#78736e",
  "#887b6c",
  "#dfdeed",
  "#62615c",
  "#575b67",
  "#313031",
  "#78736e",
  "#887b6c",
  "#dfdeed",
  "#5c8797",
  "#2e292f",
  "#575853",
  "#e7e2da",
  "#e3e5e3",
  "#efefef",
  "#e9e2d0",
  "#9a8b79",
  "#78736e",
  "#727c7f",
  "#74685a",
  "#4f4e4a",
  "#edece6",
  "#867a6f",
  "#6b645b",
  "#7f817e",
  "#e4e5df",
  "#c1ae92",
  "#94908c",
  "#727c7f",
  "#596368",
  "#e7e2da",
  "#edece6",
  "#e4e5df",
  "#ebe8d8",
  "#beb5a9",
  "#988f7b",
  "#ada8a5",
  "#edece6",
  "#c0b2a2",
  "#636562",
  "#bcbfbf",
  "#d8d4bf",
  "#585654",
  "#e8e5da",
  "#444c57",
  "#edeae5",
  "#e0e0d9",
  "#939591",
  "#f1efe2",
  "#b4b296",
  "#78736e",
  "#74685a",
  "#e9eae7",
  "#867a6f",
  "#6b645b",
  "#7f817e",
  "#7e6f59",
  "#f1efe2",
  "#b4b296",
  "#c6bfb3",
  "#b2a9a4",
  "#edece6",
  "#373a3a",
  "#e7e2da",
  "#edece6",
  "#d1c7b8",
  "#b2ada4",
  "#2f2f30",
  "#c6bfad",
  "#e3e5e3",
  "#edeae5",
  "#b0b8b2",
  "#605a5d",
  "#798286",
  "#e2e0d6",
  "#596368",
  "#7f817e",
  "#484c49",
  "#9c8a79",
  "#b2b5af",
  "#5b6043",
  "#dbd0b9",
  "#616669",
  "#a39b7e",
  "#988977",
  "#cbbca5",
  "#c2bdb1",
  "#bebfb2",
  "#244653",
  "#e2ded8",
  "#bcb7ad",
  "#cec6bb",
  "#a8a093",
  "#7c7d75",
  "#bdbdb7",
  "#bbab95",
  "#e2ddd0",
  "#b2ac9c",
  "#b7b7b2",
  "#9b9893",
  "#585858",
  "#95978a",
  "#91999c",
  "#979083",
  "#4b3029",
  "#94766c",
  "#beac9f",
  "#c59f91",
  "#996c6e",
  "#6d595a",
  "#8b534e",
  "#ac7559",
  "#8d422f",
  "#c28e61",
  "#c19e80",
  "#cbb99b",
  "#c19f6e",
  "#aeb08f",
  "#8f8666",
  "#708672",
  "#45584d",
  "#8ca49c",
  "#627f7b",
  "#a0bbb8",
  "#739694",
  "#c0b6b4",
  "#7e696a",
  "#a39b90",
  "#cc8d84",
  "#e8b9ae",
  "#ecceb9",
  "#ecd0b1",
  "#cdcdb4",
  "#efc488",
  "#9aabab",
  "#546670",
  "#974f49",
  "#c08f80",
  "#eedac3",
  "#d9c3a6",
  "#ada193",
  "#7f7263",
  "#c4957a",
  "#a76251",
  "#3a4a3f",
  "#aca17d",
  "#ae905e",
  "#e9bf8c",
  "#946644",
  "#f3e5d1",
  "#6d817b",
  "#47626f",
  "#b8b2a2",
  "#f0eadc",
  "#f2e0c3",
  "#cbcec5",
  "#e9e0d5",
  "#d6bcaa",
  "#9e3e33",
  "#f1bfb1",
  "#cbd0c2",
  "#598c74",
  "#ab7878",
  "#c6b9b8",
  "#abd1c9",
  "#014e4c",
  "#4b5645",
  "#acb19f",
  "#f0cda0",
  "#c2ccc4",
  "#cd9c85",
  "#dec3b9",
  "#bc9c9e",
  "#623f45",
  "#e1d286",
  "#a489a0",
  "#8ac6bd",
  "#dab5b4",
  "#888782",
  "#f0d39d",
  "#c9aa98",
  "#cd717b",
  "#f6e3a1",
  "#f4e8b2",
  "#f2eac3",
  "#51323b",
  "#443735",
  "#3d4450",
  "#515763",
  "#4b2929",
  "#622f2d",
  "#975840",
  "#af8871",
  "#c3b09d",
  "#7f614a",
  "#6e5241",
  "#5f4d43",
  "#506a67",
  "#738478",
  "#979f7f",
  "#caab7d",
  "#a58258",
  "#97896a",
  "#565c4a",
  "#c08650",
  "#8b7d7b",
  "#777f86",
  "#887b67",
  "#a6a397",
  "#9a7e64",
  "#96724c",
  "#a39b7e",
  "#a7947c",
  "#d3b699",
  "#ece1cb",
  "#ebb875",
  "#b4b9b9",
  "#e8d9bd",
  "#e4c495",
  "#ae9278",
  "#85695b",
  "#6a4238",
  "#432722",
  "#7b3728",
  "#937f68",
  "#a79473",
  "#7a6a51",
  "#988f7b",
  "#575449",
  "#324038",
  "#616564",
  "#797978",
  "#b6b7b0",
  "#73705e",
  "#d9ad7f",
  "#be795e",
  "#9c8a79",
  "#61463a",
  "#eecf9e",
  "#d9a06a",
  "#dfc8b5",
  "#b3ae95",
  "#857c5d",
  "#89a4ad",
  "#f8d492",
  "#e0deda",
  "#bcb8b6",
  "#ada8a5",
  "#847b77",
  "#6d6562",
  "#e4dbd8",
  "#d4cdca",
  "#b1a3a1",
  "#867875",
  "#6e615f",
  "#4d3c3c",
  "#d1c5c4",
  "#c1b2b3",
  "#b3a3a5",
  "#8b7c7e",
  "#6f5c5f",
  "#4e3132",
  "#e3d9d5",
  "#d6c2be",
  "#c9b0ab",
  "#b89d9a",
  "#907676",
  "#76595d",
  "#5f3d3f",
  "#e5dcd6",
  "#d7c8c2",
  "#c3b1ac",
  "#b6a09a",
  "#8c706a",
  "#7a5f5a",
  "#5a3532",
  "#e3dbd4",
  "#d1c5be",
  "#bfb1aa",
  "#ac9e97",
  "#8c7e78",
  "#56433b",
  "#e5dad4",
  "#d6c8c0",
  "#c6b3a9",
  "#b8a196",
  "#947569",
  "#806257",
  "#5a382d",
  "#e7dbd3",
  "#dbc7bd",
  "#cfb4a8",
  "#c3a497",
  "#9c6e63",
  "#85594f",
  "#5d3831",
  "#e9ddd4",
  "#decabd",
  "#d1b7a8",
  "#c1a392",
  "#9d7868",
  "#896656",
  "#694336",
  "#e6ddd5",
  "#d9cdc3",
  "#cbb9ab",
  "#bba595",
  "#967a6a",
  "#715243",
  "#4f3426",
  "#e5e1d8",
  "#d4ccc3",
  "#c1b6ab",
  "#b7ab9f",
  "#8d7f75",
  "#756861",
  "#4d3930",
  "#e4dcd4",
  "#d3c8bd",
  "#c2b4a7",
  "#b5a597",
  "#907865",
  "#7a6455",
  "#5f4b3f",
  "#e6ddd4",
  "#d6c7b9",
  "#c5b1a2",
  "#b59f8f",
  "#8e725f",
  "#785b47",
  "#634533",
  "#e8ded3",
  "#dac8b8",
  "#cab3a0",
  "#bfa38d",
  "#957258",
  "#815d40",
  "#69482c",
  "#e5ddd0",
  "#d7c5b3",
  "#c9b29c",
  "#bca38b",
  "#947a62",
  "#7d644d",
  "#65503d",
  "#e6dccd",
  "#d7c5ae",
  "#c7b198",
  "#baa185",
  "#9e8163",
  "#8a6b4d",
  "#70573f",
  "#ebddcb",
  "#e4caad",
  "#d7b593",
  "#cca683",
  "#ba8c64",
  "#a57955",
  "#8d623d",
  "#e8dcc6",
  "#dbc7a8",
  "#cdb592",
  "#c5aa85",
  "#b39167",
  "#9c7a56",
  "#8a6645",
  "#e9dcc6",
  "#e4ceac",
  "#dcbd92",
  "#d2b084",
  "#c19763",
  "#ad8451",
  "#906a3a",
  "#eadfc9",
  "#e0cfb0",
  "#d0ba94",
  "#c6b08a",
  "#ac9571",
  "#9a815e",
  "#7f6743",
  "#e9decf",
  "#dacab2",
  "#ccb79b",
  "#c0a98b",
  "#947f65",
  "#867057",
  "#6e543c",
  "#eae2d4",
  "#d9cfba",
  "#c8bba3",
  "#b8a992",
  "#8e7f6a",
  "#786957",
  "#66543e",
  "#e8e2d4",
  "#dbd0b9",
  "#cdbda2",
  "#c1ae91",
  "#998970",
  "#7e6f59",
  "#5d513e",
  "#deddd1",
  "#d1ccb9",
  "#c1bca7",
  "#b2ac96",
  "#898473",
  "#6b6757",
  "#5e5949",
  "#e2e0d7",
  "#d1cdbf",
  "#bfb9aa",
  "#b0ab9c",
  "#8b8372",
  "#726b5b",
  "#424036",
  "#e2e2d1",
  "#cecebd",
  "#bbbca7",
  "#acad97",
  "#7f8266",
  "#65684c",
  "#4f523a",
  "#e3e2d9",
  "#d1d0c6",
  "#abac9f",
  "#7b8070",
  "#64695c",
  "#4e5147",
  "#dcdfd7",
  "#d1d3c7",
  "#bdc0b3",
  "#9fa694",
  "#7a8775",
  "#626e60",
  "#465448",
  "#ddddd6",
  "#c9c9c0",
  "#b6b5ab",
  "#a6a69b",
  "#7f7e72",
  "#6d6c62",
  "#64645a",
  "#e4e4dd",
  "#cdd2ca",
  "#bec3bb",
  "#aeb3a9",
  "#7a8076",
  "#44483d",
  "#d7dfd8",
  "#c2cdc5",
  "#adbbb2",
  "#9baaa2",
  "#7c8e87",
  "#5e706a",
  "#343b36",
  "#dae2e0",
  "#c2cfcf",
  "#abbebf",
  "#9bafb2",
  "#7a9192",
  "#5d7274",
  "#4a5d5f",
  "#bccbce",
  "#a4b7bd",
  "#96aab0",
  "#607d84",
  "#47626a",
  "#dee1df",
  "#cdd2d2",
  "#b8bebe",
  "#a9b0b1",
  "#23383f",
  "#dbdfe0",
  "#bfc9d0",
  "#aabac6",
  "#98a9b7",
  "#768b9a",
  "#5d6f7f",
  "#2f3d4c",
  "#dde2e0",
  "#cad0d2",
  "#b8c0c3",
  "#adb5b9",
  "#7a848d",
  "#606b75",
  "#586168",
  "#e3e4e1",
  "#d4d8d7",
  "#a8aeb1",
  "#7d848b",
  "#dddcdb",
  "#cbc9c9",
  "#b5b1b5",
  "#a6a3a9",
  "#736f78",
  "#5d5962",
  "#4a4653",
  "#cec9cc",
  "#bdb5b9",
  "#afa7ac",
  "#85777b",
  "#695c62",
  "#4e4247",
  "#cfc9c8",
  "#bdb8b8",
  "#aea9aa",
  "#7b787d",
  "#605e63",
  "#3a373e",
  "#dbcfd4",
  "#cbb8c0",
  "#aa8e9a",
  "#8b6878",
  "#7e5a6d",
  "#5f3f54",
  "#e0cdd1",
  "#d2b6be",
  "#b995a1",
  "#9e6d79",
  "#8d5869",
  "#6d344f",
  "#e8d4d5",
  "#dabdc1",
  "#c79ea2",
  "#9e6b75",
  "#895460",
  "#63333e",
  "#ebd1cf",
  "#dcb6b5",
  "#c39393",
  "#995d62",
  "#864c52",
  "#723941",
  "#edd3d2",
  "#e6bdbd",
  "#cf8a8d",
  "#ad5e65",
  "#974953",
  "#863a42",
  "#ebcecb",
  "#e3b7b1",
  "#cd8e89",
  "#b56966",
  "#a0524e",
  "#8e3738",
  "#f0e1d8",
  "#ebcfc3",
  "#e3b5a8",
  "#cd8e7f",
  "#b3675d",
  "#a0584f",
  "#7b3730",
  "#eeded5",
  "#eacdc1",
  "#e2b6a7",
  "#ce9382",
  "#a85e53",
  "#8f4438",
  "#83382a",
  "#efded1",
  "#edd2c0",
  "#e4b9a2",
  "#d9987c",
  "#c1785c",
  "#ad654c",
  "#994b35",
  "#efe1d2",
  "#eccfbb",
  "#e5b99b",
  "#db9c7b",
  "#c47b5b",
  "#b46848",
  "#a2583a",
  "#edddca",
  "#ebccb3",
  "#e0b392",
  "#d4966e",
  "#c38058",
  "#b46c42",
  "#a6613c",
  "#f0e1d0",
  "#edd0b6",
  "#e8be9b",
  "#d69969",
  "#cd8c5d",
  "#bb7748",
  "#b06c3e",
  "#f3e5d2",
  "#f3d9ba",
  "#f0cb97",
  "#e3ac72",
  "#d7995d",
  "#c6884a",
  "#b6743b",
  "#f2e3ca",
  "#f2d5b0",
  "#edc38e",
  "#e5ae6b",
  "#d59858",
  "#c78538",
  "#b67d3c",
  "#f3e6d4",
  "#f5debb",
  "#edc796",
  "#ddac6d",
  "#d69e59",
  "#cc9249",
  "#ba7f38",
  "#efddc1",
  "#e8c89e",
  "#d6ad78",
  "#cc9b5c",
  "#c09056",
  "#a4763c",
  "#ede0c5",
  "#e9d6b0",
  "#e1c28d",
  "#c99e53",
  "#bc934d",
  "#aa803a",
  "#996f32",
  "#e9e0c5",
  "#e4d0a5",
  "#d2ba83",
  "#c2a462",
  "#b89b59",
  "#9c7f41",
  "#95793d",
  "#e7dfc5",
  "#ddcda6",
  "#cbb584",
  "#b1975f",
  "#9d8344",
  "#8e773f",
  "#7a6841",
  "#e9e1ca",
  "#dfd4b0",
  "#cfc291",
  "#bba86a",
  "#9c9152",
  "#8d844d",
  "#655f2d",
  "#ecead5",
  "#e0ddbd",
  "#cbc99d",
  "#aeac7a",
  "#95945c",
  "#71713e",
  "#5f6033",
  "#e4e4ce",
  "#dbddbd",
  "#c7cda8",
  "#abb486",
  "#88915d",
  "#6d7645",
  "#576238",
  "#e4e8da",
  "#dae2cd",
  "#c5d1b2",
  "#a3b48c",
  "#788d60",
  "#60724f",
  "#475842",
  "#e0e7da",
  "#cfddc7",
  "#b3cbaa",
  "#8ba97f",
  "#5e7f57",
  "#42603c",
  "#405840",
  "#c8d8c4",
  "#acc2a8",
  "#98b092",
  "#6c8867",
  "#537150",
  "#205134",
  "#d8e2d8",
  "#c6d5c9",
  "#aac2b3",
  "#91af9d",
  "#61826c",
  "#4f6a56",
  "#3d5541",
  "#d7e4db",
  "#c4d9ce",
  "#accabc",
  "#94b5a6",
  "#6b927f",
  "#547867",
  "#2a4f43",
  "#bfd2c9",
  "#a8c1b7",
  "#7ea298",
  "#5f887d",
  "#476f65",
  "#124a42",
  "#e0e7e2",
  "#c3d7d3",
  "#b4ccc9",
  "#8caeab",
  "#518682",
  "#2e6864",
  "#01554f",
  "#bedbd8",
  "#9ec6c6",
  "#7bb1b2",
  "#5c9598",
  "#3c797d",
  "#016367",
  "#c7dfe0",
  "#b0d2d6",
  "#84b4be",
  "#5b96a2",
  "#217786",
  "#015a6b",
  "#d8e7e6",
  "#c5dce0",
  "#adccd3",
  "#83afbc",
  "#5b92a2",
  "#2f778b",
  "#015d75",
  "#dce7e8",
  "#c2dae0",
  "#a9c9d7",
  "#85b0c4",
  "#5389a1",
  "#22657f",
  "#01455e",
  "#e0e8e7",
  "#c5d8de",
  "#b3c9d3",
  "#97b4c3",
  "#6a8ea1",
  "#43718b",
  "#215772",
  "#ced9dd",
  "#b2c7d3",
  "#8ba7bb",
  "#6a8aa4",
  "#506b84",
  "#25476a",
  "#e1e6e6",
  "#cbd8e1",
  "#b2c8d8",
  "#8ea9c2",
  "#6b8ca9",
  "#4c6b8a",
  "#284a70",
  "#cbd5db",
  "#bbc7d2",
  "#99a7b8",
  "#6c7f9a",
  "#516582",
  "#3b496d",
  "#d6d9de",
  "#bdc3cd",
  "#99a0b2",
  "#757c91",
  "#5d657b",
  "#3b3c5a",
  "#dad6db",
  "#c5c0c9",
  "#a29baa",
  "#7e778e",
  "#645e77",
  "#3e385a",
  "#e0dadf",
  "#d1c6d2",
  "#b0a3b6",
  "#7a6b85",
  "#675a75",
  "#443757",
  "#ebd1db",
  "#e3c0cf",
  "#cb9aad",
  "#b87e93",
  "#92576f",
  "#7c3655",
  "#edd5dd",
  "#e8c0cf",
  "#d899b1",
  "#c47b95",
  "#a2566f",
  "#854158",
  "#f1d3da",
  "#efc0cb",
  "#e392a1",
  "#d47c8c",
  "#b04b63",
  "#99324e",
  "#f1d2d7",
  "#f0bcc9",
  "#eb92a3",
  "#dd7788",
  "#bd4c5f",
  "#a53a4e",
  "#f2d5d7",
  "#f0c1c6",
  "#ed939d",
  "#d66972",
  "#bb4b51",
  "#9d373c",
  "#f1c6c4",
  "#f0b3b2",
  "#ed9190",
  "#d76c6e",
  "#b74e4f",
  "#a43834",
  "#f2ccc5",
  "#f0afa8",
  "#ee9489",
  "#d9766c",
  "#b24743",
  "#a13b34",
  "#f2d1c3",
  "#f2b8a7",
  "#e79580",
  "#d87b6a",
  "#c76356",
  "#b85444",
  "#f0d1c3",
  "#f3c1ab",
  "#e49780",
  "#dd7861",
  "#c65f47",
  "#b44b34",
  "#f3d0bd",
  "#f2bda2",
  "#e2946f",
  "#d67c56",
  "#c4633e",
  "#b1533c",
  "#f3d3bf",
  "#f3c1a3",
  "#e89d6f",
  "#d57e52",
  "#c56639",
  "#bb613e",
  "#f4d3b3",
  "#f4c69f",
  "#f2ac78",
  "#e6955f",
  "#cb7841",
  "#c36f3e",
  "#f2e3ce",
  "#f4d4af",
  "#f5c894",
  "#efb57a",
  "#e69f5f",
  "#d88b4d",
  "#d28240",
  "#f3e3ca",
  "#f4d9b1",
  "#f5cf9b",
  "#efb97b",
  "#eaaa62",
  "#df984e",
  "#d28233",
  "#f3e2c9",
  "#f5d6a9",
  "#f6cd8e",
  "#f4bf77",
  "#ebad5e",
  "#df9938",
  "#d88f32",
  "#f3e6ce",
  "#f5deaf",
  "#f7d391",
  "#fbcb78",
  "#f7be5b",
  "#f2af46",
  "#e39a33",
  "#f4e3bc",
  "#f5e0b1",
  "#f6dda3",
  "#f6c973",
  "#f1ba55",
  "#eaae47",
  "#d69835",
  "#f5e5bc",
  "#f4e1ae",
  "#f5d68f",
  "#eec25f",
  "#e1b047",
  "#d6a02b",
  "#c48919",
  "#f3e8c2",
  "#f5e1ac",
  "#f7d78a",
  "#eac365",
  "#dbb04a",
  "#d1a436",
  "#c49832",
  "#f3eac6",
  "#eee3b2",
  "#e6d88e",
  "#d9c661",
  "#c4b146",
  "#ac9825",
  "#9c8b1f",
  "#e9e5b3",
  "#dad790",
  "#c4c476",
  "#b4b05a",
  "#989746",
  "#847e35",
  "#dce1b8",
  "#c5cd8f",
  "#afb96a",
  "#97a554",
  "#7a8833",
  "#6c7b30",
  "#d3dfc3",
  "#bdd0ab",
  "#9db682",
  "#85a16a",
  "#648149",
  "#58713f",
  "#d7e3ca",
  "#c0d2ad",
  "#99c285",
  "#7fac6e",
  "#4f854a",
  "#2f5f3a",
  "#cce2ca",
  "#aed2b0",
  "#8ec298",
  "#68a678",
  "#498555",
  "#245e36",
  "#d1e3d2",
  "#b7d7bf",
  "#8ac1a1",
  "#57aa80",
  "#348a5d",
  "#016844",
  "#d7ebe2",
  "#c0e3da",
  "#a1d4c8",
  "#70baa7",
  "#53a38f",
  "#368976",
  "#016c4f",
  "#c1e6df",
  "#a1d5cb",
  "#75b9ae",
  "#61a89d",
  "#3b8c80",
  "#016d60",
  "#c2e5e5",
  "#a7dcdc",
  "#6ec2c4",
  "#3aa9ae",
  "#01858b",
  "#017478",
  "#c2e0e3",
  "#a6d0d6",
  "#7dc1cb",
  "#4da6b2",
  "#08808e",
  "#01717e",
  "#c6e3e8",
  "#a6d4de",
  "#71b8c7",
  "#34a3b6",
  "#018498",
  "#016e85",
  "#d3e7e9",
  "#b4e0e7",
  "#8fd0dd",
  "#56b5ca",
  "#01a0b8",
  "#01819e",
  "#016081",
  "#b7dfe8",
  "#a2d5e7",
  "#5db3d4",
  "#289ec4",
  "#017ca7",
  "#015d87",
  "#d6e4e7",
  "#c3dfe8",
  "#b0d6e6",
  "#7db5d3",
  "#5a9ec0",
  "#2377a2",
  "#094c73",
  "#ccdbe5",
  "#b8cddd",
  "#97b3d0",
  "#7498be",
  "#4e739f",
  "#164576",
  "#d8dde6",
  "#c7d1e2",
  "#a7b2d4",
  "#8b98c4",
  "#6572a5",
  "#3e4371",
  "#dfd9e4",
  "#d1cbdf",
  "#bdb4d4",
  "#968db8",
  "#716998",
  "#4d426e",
  "#dfdce5",
  "#d2c8dd",
  "#c0afd0",
  "#a18ab7",
  "#7e6596",
  "#624977",
  "#e5dbe5",
  "#dac7da",
  "#c2a4c2",
  "#a785a7",
  "#7c5a7e",
  "#5d395f",
  "#b54d7f",
  "#953d68",
  "#92345b",
  "#ac4362",
  "#cc617f",
  "#c84f68",
  "#a42e41",
  "#ab3c51",
  "#a82e33",
  "#bf2d32",
  "#c33a36",
  "#ad2c34",
  "#f3d1c8",
  "#c04d35",
  "#c35530",
  "#d7552a",
  "#e16f3e",
  "#e47237",
  "#ec8430",
  "#f4a045",
  "#eb882c",
  "#f7dda1",
  "#fad97a",
  "#fdcc4e",
  "#ffc723",
  "#f8ac1d",
  "#fdb702",
  "#ffc801",
  "#f7e594",
  "#fed95d",
  "#fed340",
  "#fecb01",
  "#edd26f",
  "#ddb835",
  "#cba901",
  "#c6b836",
  "#b2c216",
  "#9aba25",
  "#3f8a24",
  "#358c3f",
  "#238652",
  "#017244",
  "#d4e7c3",
  "#87dcce",
  "#019187",
  "#019196",
  "#017680",
  "#01b0bb",
  "#7fc3e1",
  "#0192c6",
  "#016ea7",
  "#015f97",
  "#015086",
  "#225288",
  "#c2cbe0",
  "#3c4c80",
  "#cab2d2",
  "#795484",
  "#665385",
  "#514c7e",
  "#019d6e",
  "#3b373c",
  "#353337",
  "#323132",
  "#31363a",
  "#323639",
  "#f2ece6",
  "#eee9e0",
  "#efe8dd",
  "#e9ebe7",
  "#edeae0",
  "#e8e3d9",
  "#e5dfd2",
  "#efe8db",
  "#ece5d8",
  "#aca79e",
  "#908a83",
  "#dfd9d2",
  "#b9b2a9",
  "#aba39a",
  "#6f6459",
  "#564537",
  "#e3ded7",
  "#d1cbc1",
  "#bfb6aa",
  "#ada295",
  "#74685a",
  "#5c4d3c",
  "#e3ddd3",
  "#b1a290",
  "#8a7a6a",
  "#716354",
  "#564536",
  "#e6dfd3",
  "#817a6e",
  "#54504a",
  "#e2e0d6",
  "#cfcabd",
  "#bfb6a7",
  "#afa696",
  "#867e70",
  "#645a4b",
  "#554c3e",
  "#c8cbc4",
  "#b2b5af",
  "#a3a7a0",
  "#63655f",
  "#484c49",
  "#dedfdc",
  "#cbccc9",
  "#434341",
  "#dcdedc",
  "#c6caca",
  "#b0b5b5",
  "#a0a5a7",
  "#7f8486",
  "#616669",
  "#44484d",
  "#e2dedb",
  "#cfc9c8",
  "#bcb6b6",
  "#ada5a5",
  "#837d7f",
  "#676064",
  "#443e40",
  "#f3eee7",
  "#ede6db",
  "#f4efe5",
  "#f4efe4",
  "#f7efe3",
  "#f7efde",
  "#f8eedb",
  "#ac9a8a",
  "#a18d7d",
  "#a49689",
  "#9e9284",
  "#665d57",
  "#c4b7a5",
  "#b3a491",
  "#9c8a79",
  "#826f5e",
  "#5b4b44",
  "#cdbfb0",
  "#c5b6a4",
  "#a79582",
  "#827466",
  "#6e5f53",
  "#e0d6c8",
  "#dbcebd",
  "#c9b29c",
  "#af9781",
  "#6a5143",
  "#ad947c",
  "#9f8267",
  "#7c5c43",
  "#cabaa8",
  "#8a7362",
  "#dfd2bf",
  "#d0bfaa",
  "#c4b49c",
  "#d4c5ad",
  "#c4b39c",
  "#dcd1bf",
  "#cfc0ab",
  "#c0af97",
  "#b7a48b",
  "#a18e77",
  "#cbb49a",
  "#e3d2b8",
  "#c0a588",
  "#c1a98a",
  "#b09879",
  "#d8cfbe",
  "#cbc0ad",
  "#bcb099",
  "#ac9d83",
  "#63523d",
  "#b1a38e",
  "#cbbfad",
  "#ad9c85",
  "#907d66",
  "#f0ece2",
  "#e7dbcc",
  "#e7d7c6",
  "#ece1d1",
  "#e2d3bf",
  "#f4e8d2",
  "#f4e9d6",
  "#f3e9d7",
  "#f2e5cf",
  "#f4dec3",
  "#f5eacc",
  "#f6f0e2",
  "#eee8d7",
  "#e8dfca",
  "#dbd0bb",
  "#f3eee3",
  "#e2daca",
  "#dccfba",
  "#dfd9cf",
  "#ede1ce",
  "#e7d7c2",
  "#e9d9c0",
  "#e7d8be",
  "#e0d1b8",
  "#533640",
  "#72353d",
  "#81585b",
  "#573e3e",
  "#803532",
  "#7c3239",
  "#6e3637",
  "#692b2b",
  "#813235",
  "#9f4442",
  "#a42e37",
  "#b8473d",
  "#7c453d",
  "#753531",
  "#703229",
  "#6e423e",
  "#5d3736",
  "#e2d3c4",
  "#924e3c",
  "#93402f",
  "#903934",
  "#a0b3bc",
  "#3e5063",
  "#8095a0",
  "#596e79",
  "#35454e",
  "#6591a8",
  "#416d83",
  "#87aab9",
  "#5b8d9f",
  "#3e758a",
  "#7c9aa0",
  "#679199",
  "#9cb0b3",
  "#577c88",
  "#3e4b54",
  "#a0aeaf",
  "#376167",
  "#314d58",
  "#666d69",
  "#273e3e",
  "#606e74",
  "#3d484c",
  "#e6e1d9",
  "#e7e1d7",
  "#ded8cf",
  "#786e70",
  "#392b2d",
  "#dfdad1",
  "#d6cec3",
  "#ada090",
  "#aa9e95",
  "#e5e2da",
  "#c0b9a9",
  "#aea594",
  "#a7a094",
  "#c6c0b6",
  "#a0998f",
  "#57534c",
  "#dad9d4",
  "#d6d3cc",
  "#d0cec9",
  "#c2c0ba",
  "#aaa9a4",
  "#ccccc5",
  "#abb0ac",
  "#d1d2cb",
  "#cecec6",
  "#a0a09a",
  "#dee0de",
  "#c5c8c4",
  "#a5a9a8",
  "#969a96",
  "#d3d5d3",
  "#c9cccd",
  "#b8bcbb",
  "#90979b",
  "#656d73",
  "#dcddd8",
  "#cac9c6",
  "#959491",
  "#949392",
  "#d0cec8",
  "#c3c1bc",
  "#f2e0c4",
  "#eaba8a",
  "#eddbbd",
  "#d9ad7f",
  "#c09972",
  "#f8e4c2",
  "#eabf86",
  "#f1dfc1",
  "#edd6b1",
  "#e5c28b",
  "#f8ddb7",
  "#e7c7a0",
  "#e1cdae",
  "#d2bb9d",
  "#c3aa8c",
  "#e3c9a1",
  "#dcbc8e",
  "#cba97e",
  "#caad87",
  "#bd9c77",
  "#dcc6a6",
  "#ccb18b",
  "#dbc8a2",
  "#ba9a67",
  "#8f6c3e",
  "#ac6b53",
  "#b0785c",
  "#a85e39",
  "#d5b59b",
  "#976b53",
  "#c67b57",
  "#b16a37",
  "#a56c4a",
  "#e6d0bd",
  "#dfc8b5",
  "#ccb299",
  "#bfa287",
  "#aa866e",
  "#dbc5a7",
  "#d2b18f",
  "#bb8d6b",
  "#d8c4ae",
  "#c7a485",
  "#edd1b1",
  "#ecd3b3",
  "#ddc6ab",
  "#b7987b",
  "#ad896a",
  "#9d986f",
  "#b9b292",
  "#a29f80",
  "#827c5a",
  "#4d5346",
  "#a69474",
  "#c8bd98",
  "#b3a479",
  "#857c5d",
  "#635936",
  "#b1a584",
  "#8d8168",
  "#cdc4ae",
  "#a49b82",
  "#7d745e",
  "#aaad9c",
  "#8ea486",
  "#868578",
  "#99907e",
  "#5a5243",
  "#a19c8f",
  "#bdc0a0",
  "#9a9883",
  "#44493d",
  "#424c44",
  "#f7f7f1",
  "#f0ebe0",
  "#ae8087",
  "#a87376",
  "#ba7176",
  "#c37f7a",
  "#bf796e",
  "#b57466",
  "#f2b88c",
  "#f5c78e",
  "#cc896c",
  "#dba480",
  "#e3ab7b",
  "#e8b87f",
  "#eeb76b",
  "#fbd187",
  "#fbe4b3",
  "#fddfa0",
  "#fedf94",
  "#fbd682",
  "#fbd073",
  "#f4c454",
  "#f6d58f",
  "#f1cd7b",
  "#e1bd8e",
  "#cba576",
  "#ba9c75",
  "#d5b176",
  "#dcc797",
  "#bea775",
  "#c4b47d",
  "#cebc55",
  "#d2d083",
  "#9fac5c",
  "#abca99",
  "#a9c095",
  "#78b185",
  "#9fcdb1",
  "#bbb98a",
  "#9ba373",
  "#8fa277",
  "#75946b",
  "#7d9b89",
  "#81a595",
  "#89c6b7",
  "#8ac5ba",
  "#92d0d0",
  "#97cbd2",
  "#8bc4d1",
  "#73c0d2",
  "#89c6df",
  "#94b2a6",
  "#a3c0bd",
  "#90bdbd",
  "#9fc5cc",
  "#c7d8db",
  "#afc7cd",
  "#9fbbc3",
  "#88abb4",
  "#68909d",
  "#427584",
  "#175a6c",
  "#9bbfc9",
  "#6f9db3",
  "#9bc8de",
  "#7c9ab5",
  "#6487b0",
  "#bbc5de",
  "#afa5c7",
  "#b3a1c6",
  "#937496",
  "#83a2b4",
  "#7b99b0",
  "#8595aa",
  "#8990a3",
  "#908a9b",
  "#9a8ca2",
  "#9b7e8b",
  "#a38887",
  "#a08882",
  "#a2877d",
  "#a8857a",
  "#ae8e7e",
  "#a58c7b",
  "#9c8373",
  "#a08e7e",
  "#d5c7ba",
  "#c6b5a7",
  "#b9a796",
  "#a58f7b",
  "#917864",
  "#785f4c",
  "#604c3d",
  "#a3846c",
  "#a88e76",
  "#dcc7b3",
  "#d2b79e",
  "#c5a88d",
  "#b59778",
  "#89674a",
  "#725237",
  "#765138",
  "#dcc7ad",
  "#cfb597",
  "#c1a485",
  "#b99974",
  "#a78361",
  "#946e48",
  "#7b5838",
  "#a78c71",
  "#dfd3c3",
  "#c0ad96",
  "#af987f",
  "#a08568",
  "#8f7659",
  "#695239",
  "#ab9579",
  "#a4947e",
  "#b9a47e",
  "#ddd0b6",
  "#cdbb9c",
  "#c3b090",
  "#b19f80",
  "#9f8e71",
  "#877459",
  "#665439",
  "#9e9985",
  "#989a82",
  "#909886",
  "#969c92",
  "#8d9e97",
  "#8b9fa0",
  "#80969d",
  "#cbd4d4",
  "#b6c3c4",
  "#a6b2b5",
  "#90a0a6",
  "#6f848c",
  "#204652",
  "#c9d9e0",
  "#b7c9d1",
  "#9eb4c0",
  "#708d9e",
  "#4e7287",
  "#32586e",
  "#899caa",
  "#979fa5",
  "#949194",
  "#989192",
  "#8f8a91",
  "#9d9093",
  "#9d8d8e",
  "#9f9291",
  "#9e9089",
  "#959ba0",
  "#939899",
  "#92948d",
  "#d3cec4",
  "#dcd8d0",
  "#9e9793",
  "#a09287",
  "#9e9991",
  "#958d7f",
  "#c8bcab",
  "#a0907f",
  "#393437",
  "#2b4360",
  "#234058",
  "#283849",
  "#2b3441",
  "#e8decd",
  "#4b3029",
  "#4c3d31",
  "#454b40",
  "#2e5464",
  "#c29871",
  "#cec4b8",
  "#ebe0c3",
  "#3e3230",
  "#cec6b6",
  "#85867f",
  "#153b2f",
  "#b6aa9d",
  "#e5e5e5",
  "#f7f5e6",
  "#446964",
  "#faf6ed",
  "#412a1c",
  "#5a331c",
  "#cbc2b0",
  "#ada394",
  "#f2f7f7",
  "#dfdccb",
  "#4f4842",
  "#c1b899",
  "#30332d",
  "#46403d",
  "#ada297",
  "#fcfdff",
  "#4a4f52",
  "#a39785",
  "#6d6c65",
  "#ede7d2",
  "#82735e",
  "#abb4ab",
  "#444542",
  "#616258",
  "#6b7062",
  "#6d3e37",
  "#5f5349",
  "#ffffff",
  "#64747d",
  "#3f5e73",
  "#586162",
  "#c9c0ab",
  "#73796c",
  "#a89885",
  "#333d46",
  "#49453c",
  "#818582",
  "#928e82",
  "#252a2a",
  "#725e4d",
  "#5b5e61",
  "#c5c2ba",
  "#a4a490",
  "#a39f8c",
  "#b2b2ab",
  "#38556b",
  "#673e3c",
  "#cac5b9",
  "#c3c0ab",
  "#cfcece",
  "#727d82",
  "#9c907d",
  "#7a7362",
  "#79736e",
  "#f8f4e9",
  "#65182c",
  "#452a19",
  "#acb297",
  "#7d8284",
  "#13233a",
  "#151312",
  "#ba1f26",
  "#e6e9ee",
  "#19221f",
  "#e9ebee",
  "#b4b2a9",
  "#483c37",
  "#dcb6b5",
  "#d9987c",
  "#edd0b6",
  "#e4c495",
  "#a58258",
  "#eecf9e",
  "#bec3bb",
  "#6d6b58",
  "#405840",
  "#788b81",
  "#9ec6c6",
  "#b8cddd",
  "#4c6b8a",
  "#6e543c",
  "#c0a98b",
  "#e2e0d6",
  "#b2b5af",
  "#988f7b",
  "#74685a",
  "#727c7f",
  "#484c49",
  "#beb5a9",
  "#596368",
  "#7e6f59",
  "#e8d9bd",
  "#dbd0b9",
  "#c1ae91",
  "#6a4238",
  "#7b3728",
  "#deddd1",
  "#deddd1",
  "#e2e0d6",
  "#7b3728",
  "#6a4238",
  "#dcb6b5",
  "#d9987c",
  "#edd0b6",
  "#a58258",
  "#eecf9e",
  "#e4c495",
  "#e8d9bd",
  "#c1ae91",
  "#a39b7e",
  "#6d6b58",
  "#405840",
  "#9ec6c6",
  "#b8cddd",
  "#4c6b8a",
  "#74685a",
  "#c0a98b",
  "#9c8a79",
  "#7e6f59",
  "#beb5a9",
  "#dbd0b9",
  "#6e543c",
  "#988f7b",
  "#bec3bb",
  "#b2b5af",
  "#788b81",
  "#596368",
  "#727c7f",
  "#484c49",
  "#EECF9E",
  "#B8CDDD",
  "#E8D9BD",
  "#C0A98B",
  "#A58258",
  "#EDD0B6",
  "#D9987C",
  "#6A4238",
  "#DCB6B5",
  "#9EC6C6",
  "#788b81",
  "#405840",
  "#9C8A79",
  "#E2E0D6",
  "#6E543C",
  "#727C7F",
  "#596368",
  "#484C49",
  "#BEC3BB",
  "#DEDDD1",
  "#6a4238",
  "#4e3132",
  "#d9987c",
  "#e6ddd5",
  "#ba8c64",
  "#e4c495",
  "#e8d9bd",
  "#a58258",
  "#a57955",
  "#727c7f",
  "#596368",
  "#ada8a5",
  "#7f817e",
  "#616669",
  "#4e5147",
  "#788b81",
  "#deddd1",
  "#bec3bb",
  "#e2e0d6",
  "#b2b5af",
  "#7f817e",
  "#c1ae91",
  "#2f3d4c",
  "#78736e",
  "#4f4842",
  "#564536",
  "#4c6b8a",
  "#74685a",
  "#9c8a79",
  "#dbd0b9",
  "#7b3728",
  "#a39b7e",
  "#988f7b",
  "#6d6b58",
  "#eecf9e",
  "#b8cddd",
  "#dcb6b5",
  "#9ec6c6",
  "#eecf9e",
  "#d9987c",
  "#e8d9bd",
  "#c0a98b",
  "#ba8c64",
  "#edd0b6",
  "#c1ae91",
  "#7e6f59",
  "#9ec6c6",
  "#e6ddd5",
  "#b8cddd",
  "#deddd1",
  "#dcb6b5",
  "#bec3bb",
  "#405840",
  "#4e5147",
  "#4c6b8a",
  "#2f3d4c",
  "#e4c495",
  "#a58258",
  "#6e543c",
  "#4e3132",
  "#7b3728",
  "#6a4238",
  "#a57955",
  "#7f817e",
  "#564536",
  "#6e543c",
  "#d9987c",
  "#dcb6b5",
  "#6a4238",
  "#e2e0d6",
  "#bec3bb",
  "#beb5a9",
  "#b2b5af",
  "#484c49",
  "#7b3728",
  "#9ec6c6",
  "#eecf9e",
  "#727c7f",
  "#596368",
  "#a39b7e",
  "#e8d9bd",
  "#c0a98b",
  "#b8cddd",
  "#deddd1",
  "#405840",
  "#4c6b8a",
  "#c1ae91",
  "#74685a",
  "#9c8a79",
  "#e4c495",
  "#edd0b6",
  "#dbd0b9",
  "#646753",
  "#68887b",
  "#B7AB9F",
  "#674721",
  "#d5c3ad",
  "#5c5753",
  "#423f40",
  "#f0ece3",
  "#dfdcd5",
  "#cac7c0",
  "#acaa9d",
  "#76716d",
  "#666c68",
  "#b0a08d",
  "#d1caba",
  "#f2f3ee",
  "#a3a59f",
  "#2f374a",
  "#5f4c42",
  "#191815",
  "#948d7d",
  "#74766b",
  "#3e3a37",
  "#fffefa",
  "#5f5345",
  "#e1ddc0",
  "#e0d1b4",
  "#c4bea2",
  "#b0ae9a",
  "#514d41",
  "#525658",
  "#fffef9",
  "#c8bca6",
  "#b4a49f",
  "#c2b89c",
  "#f0f7fa",
  "#2d4647",
  "#DBDBDB",
  "#161513",
  "#E7E8E2",
  "#ACA298",
  "#C3C2BD",
  "#8E8E8C",
  "#29303A",
  "#19363D",
  "#7D8E98",
  "#EDEDED",
  "#817765",
  "#0C0006",
  "#0C0006",
  "#A1A1A1",
  "#5B8095",
  "#3f3e41",
  "#554541",
  "#5d5e5b",
  "#7f7e7a",
  "#6a6965",
  "#4a545c",
  "#f0ecdb",
  "#aba796",
  "#f9faf5",
  "#CCB9B1",
  "#C2B89C",
  "#040707",
  "#332A22",
  "#B4A49F",
  "#2E2822",
  "#A6AEAD",
  "#CEC8B4",
  "#524535",
  "#E4E8CF",
  "#0F3F67",
  "#3D6C80",
  "#857F69",
  "#452727",
  "#464A49",
  "#9AA3AA",
  "#6D2B2D",
  "#4B392B",
  "#3C382F",
  "#A12034",
  "#365C45",
  "#37624F",
  "#38483E",
  "#5C7C6D",
  "#282B30",
  "#5C4B39",
  "#FDFEF9",
  "#D4D0C7",
  "#629881",
  "#004961",
  "#DCE0DF",
  "#A79C7E",
  "#3F776E",
  "#A64F3B",
  "#778083",
  "#D1C8B7",
  "#000000",
  "#716E69",
  "#48382C",
  "#C7BFA7",
  "#08402E",
  "#646263",
  "#969897",
  "#978B7E",
  "#FFFFFF",
  "#F4E8D6",
  "#9FA6AA",
  "#DFDCD3",
  "#65615D",
  "#53524F",
  "#A39584",
  "#81837B",
  "#85514D",
  "#F2F1EC",
  "#e5d8bd",
  "#695e50",
  "#38211d",
  "#302f30",
  "#434f51",
  "#bec0c0",
  "#e7e8e9",
  "#a99d8a",
  "#4F5455",
  "#C9BFB0",
  "#788387",
  "#7c7463",
  "#A2A298",
  "#B2AFAD",
  "#B6AB9F",
  "#4b4b4d",
  "#06060a",
  "#66211c",
  "#373229",
  "#f0dfb7",
  "#a49f90",
  "#a49f90",
  "#faf8f4",
  "#2f2a22",
  "#6d6158",
  "#385546",
  "#c3b9a3",
  "#06060a",
  "#4c4036",
  "#f1edd6",
  "#4f2e26",
  "#c3b9a3",
  "#a4a7a6",
  "#b2b8b4",
  "#665c52",
  "#fff9f0",
  "#f5f4ee",
  "#eaebe7",
  "#DED6C6",
  "#E3D3C8",
  "#D4CBB4",
  "#C8AF99",
  "#B79E86",
  "#242424",
  "#8E7C6C",
  "#B09B8B",
  "#9FA193",
  "#F0E5DC",
  "#9E9286",
  "#9E9686",
  "#9F684F",
  "#F3E9D2",
  "#6E4B50",
  "#F7EBD4",
  "#4C443E",
  "#858281",
  "#D2CBBB",
  "#707377",
  "#192A21",
  "#EFEFEF",
  "#939698",
  "#49544A",
  "#A89D8D",
  "#DAD1C7",
  "#55413E",
  "#F1E5D1",
  "#5E6C68",
  "#686261",
  "#D9CAB7",
  "#E0D7CA",
  "#EBEBEB",
  "#3B393A",
  "#554A47",
  "#1B2A41",
  "#A69790",
  "#959288",
  "#59626E",
  "#A0A09D",
  "#B7B4B3",
  "#CACED2",
  "#AFA797",
  "#4D4442",
  "#5C5653",
  "#CBBFB8",
  "#F3ECDF",
  "#BAAA9E",
  "#764A4A",
  "#A8ADB3",
  "#E9E4DD",
  "#F0F0EE",
  "#E7DFC6",
  "#696561",
  "#605D59",
  "#515154",
  "#C8B9A8",
  "#BCADA0",
  "#5F2D2C",
  "#3B4B46",
  "#F7F7F7",
  "#F6F5E4",
  "#DAD3C5",
  "#F1EDEC",
  "#F8EDD8",
  "#C3C3BE",
  "#DFCEC6",
  "#B8B3AC",
  "#D8C7A2",
  "#CEAE90",
  "#C8B8A1",
  "#BBBCB2",
  "#DBDED6",
  "#737373",
  "#928C83",
  "#E0DDD4",
  "#ACACAC",
  "#BBB3AA",
  "#BBB8AD",
  "#998F86",
  "#D6DADD",
  "#E7F0F2",
  "#DFE1D5",
  "#CDC8BC",
  "#E1DFD4",
  "#CABA9F",
  "#ACA291",
  "#D4C298",
  "#9C8462",
  "#A18B72",
  "#C8CAC9",
  "#D4A97D",
  "#D7B588",
  "#ECE7BC",
  "#F3F3E3",
  "#A59C88",
  "#D7B385",
  "#A59A7C",
  "#C6AF97",
  "#F4F4EB",
  "#E3C59B",
  "#E5D3B5",
  "#E1C39C",
  "#CEC4AE",
  "#D4BEAA",
  "#514A46",
  "#edf5f4",
  "#941318",
  "#231f20",
  "#4c191c",
  "#4c4d4f",
  "#636466",
  "#a9a089",
  "#62443d",
  "#ad6c32",
  "#004829",
  "#003663",
  "#f7edc9",
  "#7f6757",
  "#dedbc4",
  "#5d9a8b",
  "#be1228",
  "#bdbdb8",
  "#376b7c",
  "#d6bd9e",
  "#eeeeec",
  "#A89D8E",
  "#aea89c",
  "#d0cbc5",
  "#ffffff",
  "#2f3437",
  "#3d3429",
  "#b0a282",
  "#586151",
  "#593b26",
  "#47393d",
  "#371516",
  "#3a4545",
  "#8b8041",
  "#d5d8d7",
  "#bfc4c5",
  "#a9afb2",
  "#999fa3",
  "#838b91",
  "#6d747a",
  "#575c62",
  "#d4d4cd",
  "#c9cbc6",
  "#bbbcb6",
  "#a8aaa4",
  "#9c9f99",
  "#92958f",
  "#717572",
  "#e0dfdc",
  "#d2d1cd",
  "#c7c6c2",
  "#b9b8b5",
  "#9f9f9d",
  "#7b7a78",
  "#3c3d3d",
  "#ddddd9",
  "#cdccc9",
  "#a8a7a3",
  "#92928f",
  "#81807e",
  "#6f6f6e",
  "#5e5e5d",
  "#d0cfc9",
  "#c4c3bd",
  "#bbbab5",
  "#abaca6",
  "#969794",
  "#7b7c7a",
  "#575957",
  "#f2f0e7",
  "#bfbab0",
  "#afaba1",
  "#a19e97",
  "#949089",
  "#7e7a74",
  "#5c5752",
  "#dedbd2",
  "#c7c2b7",
  "#b2ada2",
  "#9a9387",
  "#8b8376",
  "#746e64",
  "#635f59",
  "#d1c9bc",
  "#c2b9ac",
  "#b1a89c",
  "#a19689",
  "#8e8274",
  "#7d7265",
  "#64584a",
  "#f2f2ee",
  "#e3e4e2",
  "#dadbdb",
  "#acadae",
  "#848585",
  "#5c5d5d",
  "#414040",
  "#edeae7",
  "#e6e3df",
  "#d4cfca",
  "#b9b4b1",
  "#918e8c",
  "#6f6a68",
  "#4b4441",
  "#e1dedd",
  "#d8d3d4",
  "#b8b4b6",
  "#a6a1a3",
  "#908b8e",
  "#69656a",
  "#49454b",
  "#dddada",
  "#d2cecc",
  "#c5bebc",
  "#b3aaaa",
  "#8b8283",
  "#655d5e",
  "#50484a",
  "#e5e2e0",
  "#d4d0ce",
  "#c4bfbc",
  "#b5adaa",
  "#8d847f",
  "#665e59",
  "#4f443f",
  "#eeede5",
  "#e1ded9",
  "#ccc8c1",
  "#b8b1aa",
  "#8c857d",
  "#7c736c",
  "#61574f",
  "#e8e6e1",
  "#d0cbc3",
  "#beb8ae",
  "#afaaa1",
  "#99938d",
  "#827c77",
  "#564d4b",
  "#e6e0d4",
  "#d1c9bd",
  "#b4aca3",
  "#a2978b",
  "#8d8478",
  "#766f67",
  "#615c58",
  "#e1e1dc",
  "#d3d4d0",
  "#c6c8c5",
  "#b9b8b5",
  "#8e908d",
  "#6b6a65",
  "#4e4f48",
  "#eae8e4",
  "#d7d6d2",
  "#bdbeba",
  "#a7a9a5",
  "#8a8b87",
  "#6f716e",
  "#585a5c",
  "#eae9e7",
  "#d2d6d6",
  "#b1b6b8",
  "#9aa0a5",
  "#6f7477",
  "#5c5e61",
  "#454443",
  "#e1e5e3",
  "#dce2e2",
  "#d2d9db",
  "#b8bfc2",
  "#8e9598",
  "#6e7579",
  "#434b4f",
  "#e7e7e6",
  "#dadbdd",
  "#c0c2c4",
  "#adb0b5",
  "#828388",
  "#575960",
  "#404149",
  "#ebe9e7",
  "#e6e3e4",
  "#e1ddde",
  "#c0b2b2",
  "#9c8e8e",
  "#746665",
  "#554747",
  "#f2ebe2",
  "#ede4dc",
  "#e6d7ce",
  "#cdb8b3",
  "#a59491",
  "#826f6b",
  "#5f4a47",
  "#eaded9",
  "#e6d5cf",
  "#ddc8c1",
  "#d2bbb3",
  "#b59b94",
  "#8f746c",
  "#674a41",
  "#ecdfda",
  "#d9cac5",
  "#c9bcb7",
  "#b8a9a3",
  "#8e7d78",
  "#786560",
  "#60504b",
  "#ded6d0",
  "#d5cbc6",
  "#b9b0a8",
  "#aa9f97",
  "#a1928b",
  "#80726b",
  "#5b4c44",
  "#ebe2d8",
  "#d7cbc0",
  "#c8bab1",
  "#aca199",
  "#93857c",
  "#82746c",
  "#645851",
  "#f2eee5",
  "#e3d8cc",
  "#cfc1b5",
  "#b6a393",
  "#a7978a",
  "#857567",
  "#65574c",
  "#e9e3dc",
  "#d2c7b9",
  "#c0b1a2",
  "#ab9a8b",
  "#8d7b6c",
  "#766759",
  "#5f5248",
  "#e7e0d7",
  "#d2c8be",
  "#bdb6ae",
  "#a3968c",
  "#9a8e83",
  "#746a5e",
  "#5d5043",
  "#e8e3d6",
  "#dad0c2",
  "#cabfb2",
  "#b7ac9e",
  "#9f9484",
  "#827566",
  "#594e40",
  "#e9e3d6",
  "#e2daca",
  "#dacfbf",
  "#d1c9bb",
  "#a89d8e",
  "#8b7d6b",
  "#5f5241",
  "#e7e9e7",
  "#dcd7cf",
  "#d2ccc3",
  "#b2aa9c",
  "#8c8475",
  "#7a6c5e",
  "#615544",
  "#e3d6bc",
  "#d7c7a7",
  "#c1b295",
  "#b4a284",
  "#a59171",
  "#927f63",
  "#766851",
  "#dfdbcd",
  "#d3cbb7",
  "#c1b8a2",
  "#afa78d",
  "#8f876b",
  "#7b6b53",
  "#5f563f",
  "#e7e6d6",
  "#d3d0bc",
  "#bbb8a5",
  "#a1a190",
  "#827e6e",
  "#776e5d",
  "#5c5644",
  "#e7e5dc",
  "#dbd8c9",
  "#cac8b6",
  "#aead96",
  "#928c7a",
  "#777162",
  "#676357",
  "#d4d3c2",
  "#c6c6b3",
  "#b5b7a3",
  "#9e9f87",
  "#928e74",
  "#78725d",
  "#6a6758",
  "#d0ccbc",
  "#c2c1b2",
  "#a8a897",
  "#969481",
  "#87836f",
  "#676455",
  "#5c594c",
  "#ceccbf",
  "#bfbbae",
  "#b0ab9b",
  "#999382",
  "#878170",
  "#716c5e",
  "#5f5a4d",
  "#e0e3d9",
  "#dbdcd2",
  "#c5c8bf",
  "#aaafa8",
  "#89928a",
  "#646c64",
  "#474e44",
  "#e4ece9",
  "#dfebea",
  "#d5e1e1",
  "#b4c7c9",
  "#8b9fa1",
  "#6a7e81",
  "#334448",
  "#d2e0df",
  "#c8d7d8",
  "#a4babd",
  "#8ca2a8",
  "#6d868b",
  "#5d7076",
  "#455257",
  "#e1e5e5",
  "#ccd3d3",
  "#adb7b8",
  "#93a0a2",
  "#7c8787",
  "#707b7d",
  "#585f60",
  "#d7dddd",
  "#cbd3d4",
  "#a8b4b8",
  "#92a2a9",
  "#67787e",
  "#525e63",
  "#464b4f",
  "#e4e9e8",
  "#dde3e4",
  "#d4dcdb",
  "#adb6ba",
  "#858f94",
  "#5e686d",
  "#3a484f",
  "#ced3d2",
  "#bcc1c1",
  "#aab1b3",
  "#919a9f",
  "#7d868a",
  "#666f73",
  "#445056",
  "#d0dce0",
  "#c1d0d8",
  "#b2c0c8",
  "#a1b1ba",
  "#8f9fa9",
  "#667884",
  "#515e69",
  "#eceded",
  "#e1e5eb",
  "#dadde3",
  "#bcc5cf",
  "#939fa9",
  "#6a7680",
  "#3f4c5a",
  "#e6e9ed",
  "#dfdac8",
  "#212424",
  "#212424",
  "#42372a",
  "#7c7d7c",
  "#c2bcae",
  "#6d6c61",
  "#dfdac8",
  "#004327",
  "#f1f1f1",
  "#42372a",
  "#d6d0c1",
  "#c2bcae",
  "#6d6c61",
  "#f1f1f1",
  "#9cb1bf",
  "#aca38b",
  "#513b36",
  "#8b9d89",
  "#a2a298",
  "#595c53",
  "#8f8d85",
  "#ada69a",
  "#255d79",
  "#3d4445",
  "#f5efe4",
  "#2c3c55",
  "#475662",
  "#a39382",
  "#7b2c06",
  "#646c6f",
  "#868683",
  "#d3cdbc",
  "#576c58",
  "#87a2a7",
  "#e3d4bb",
  "#ced0cb",
  "#838a91",
  "#968a76",
  "#969784",
  "#58554f",
  "#fff1cd",
  "#937d68",
  "#595c53",
  "#253739",
  "#f2f3ee",
  "#c6b9a0",
  "#425b65",
  "#677f86",
  "#738a8b",
  "#a1aeac",
  "#f0eae0",
  "#7d8681",
  "#ced0c6",
  "#bec6bf",
  "#47545d",
  "#3b4550",
  "#64707c",
  "#9fa5b3",
  "#a3adb2",
  "#aebbc0",
  "#bcc0bf",
  "#6a828c",
  "#bcc5d9",
  "#ccd0dd",
  "#71787f",
  "#919ea7",
  "#8092a3",
  "#657687",
  "#d4dae2",
  "#9eadbb",
  "#d4dcdb",
  "#cedde7",
  "#cfdbe0",
  "#a1b2bb",
  "#848982",
  "#bcc5b6",
  "#c4d0c6",
  "#2a4a6f",
  "#e3e6eb",
  "#d4dce3",
  "#adb4c4",
  "#828b9c",
  "#5c6576",
  "#404d62",
  "#e9e9ea",
  "#e2e1e2",
  "#dedfe2",
  "#b1b2be",
  "#8b8d98",
  "#656874",
  "#484b5a",
  "#f2ebea",
  "#ebdde1",
  "#e3c8d2",
  "#d7b3c0",
  "#c58ba1",
  "#a8647e",
  "#86455c",
  "#f1edeb",
  "#eee0e3",
  "#e4d0d5",
  "#d0aebb",
  "#b28692",
  "#9a6a79",
  "#6f4052",
  "#eae1e0",
  "#eadbe1",
  "#dac2ca",
  "#cbb7c0",
  "#a48b93",
  "#866c76",
  "#5d4450",
  "#efe7e4",
  "#e5d8d6",
  "#d6c5c2",
  "#d1c1c3",
  "#ac9b9c",
  "#877578",
  "#5b484b",
  "#f0eae7",
  "#f0dddf",
  "#e4c9ce",
  "#d5b6ba",
  "#aa8a8d",
  "#8e6c6f",
  "#624046",
  "#f2eeeb",
  "#f0dadd",
  "#d7b8bd",
  "#c9a1a9",
  "#ad7982",
  "#905c67",
  "#73424a",
  "#f3e6e7",
  "#ecced4",
  "#e3b9c2",
  "#d494a0",
  "#c47281",
  "#ad586c",
  "#9a3c55",
  "#f3ddd8",
  "#eec9ca",
  "#ebb3b4",
  "#dc9294",
  "#c67276",
  "#af545d",
  "#943e45",
  "#f0e0d7",
  "#f5e2dd",
  "#dfbeba",
  "#c59191",
  "#af7271",
  "#95555a",
  "#853e44",
  "#f2ede5",
  "#edd4d2",
  "#e5c7c6",
  "#d9b1b2",
  "#b78e8b",
  "#976a66",
  "#6e403e",
  "#f2e4dd",
  "#f2dcd8",
  "#e7cdca",
  "#dbbebc",
  "#b49997",
  "#90716e",
  "#694848",
  "#f3ebe7",
  "#f5dbd9",
  "#ddb9b6",
  "#c99d9b",
  "#ab7673",
  "#905959",
  "#7a4041",
  "#e9dad7",
  "#e4d2ce",
  "#dabcb7",
  "#cf9f9a",
  "#b87770",
  "#9e5b55",
  "#89423e",
  "#efe3dd",
  "#edd1cd",
  "#e8c1bb",
  "#e0a79f",
  "#ce7c74",
  "#b4635e",
  "#a53f3e",
  "#f2e0db",
  "#edcfc9",
  "#e9cac3",
  "#dfb1a8",
  "#ca887f",
  "#ae6056",
  "#a0413f",
  "#efded9",
  "#ead2cd",
  "#dcc0ba",
  "#caa6a1",
  "#af7e76",
  "#95625b",
  "#7d453e",
  "#edd8d0",
  "#e5d1cc",
  "#dfcac5",
  "#cfaea5",
  "#ac8880",
  "#8c5e55",
  "#6f4741",
  "#f0e7df",
  "#ebddd7",
  "#e3cbc2",
  "#c4a297",
  "#b6897d",
  "#996c61",
  "#715045",
  "#f0e3da",
  "#ecd6ce",
  "#e4cec6",
  "#d8b1a5",
  "#bc8675",
  "#9e6757",
  "#884f3e",
  "#f5e5dd",
  "#f2ded3",
  "#f4d1c4",
  "#efbdb0",
  "#d5917c",
  "#b06e5b",
  "#a2543e",
  "#f3e4de",
  "#f5ded9",
  "#f3d2c9",
  "#efbcb2",
  "#e19789",
  "#ca7363",
  "#a8483d",
  "#f2e2df",
  "#eed8d3",
  "#eacfc8",
  "#e4bcb3",
  "#cc9487",
  "#b16456",
  "#94493e",
  "#f2e6e0",
  "#f2ddd8",
  "#f3d3cb",
  "#dfbaab",
  "#bd8675",
  "#ae6f60",
  "#8f4f42",
  "#eedbd3",
  "#ead3c9",
  "#e9cac0",
  "#e2b5a4",
  "#b4715a",
  "#9d6454",
  "#924c3a",
  "#f0e4db",
  "#eddfd6",
  "#e4c9be",
  "#dbb19f",
  "#c08973",
  "#ab715a",
  "#945b41",
  "#f0dbce",
  "#edccb9",
  "#e7bca5",
  "#d5a084",
  "#be886a",
  "#a26949",
  "#965f43",
  "#f0dacc",
  "#eed5c7",
  "#e9c3ac",
  "#d6a284",
  "#c78d6a",
  "#a86e49",
  "#986544",
  "#ebdfd2",
  "#ebd5c7",
  "#e2c7b8",
  "#dbbbaa",
  "#bc947d",
  "#9a6e5c",
  "#805a48",
  "#f1e8e0",
  "#eadad2",
  "#d7bfb5",
  "#c4a79a",
  "#a4816f",
  "#8a6757",
  "#6e483a",
  "#f1e7d9",
  "#e9d9ce",
  "#e4d1c8",
  "#d1bbb0",
  "#a68f85",
  "#8b7265",
  "#64493e",
  "#eee6dc",
  "#ebdfd5",
  "#dbcbbf",
  "#bfa999",
  "#977d6f",
  "#6e554b",
  "#604b43",
  "#f0ebe4",
  "#ebe2d8",
  "#dfd4c9",
  "#beada4",
  "#978379",
  "#736157",
  "#604a3f",
  "#ebe3dc",
  "#e5ded5",
  "#d1c2b5",
  "#b19e90",
  "#9a8172",
  "#7d675c",
  "#64544a",
  "#f1e0d0",
  "#ecdac9",
  "#c6ad97",
  "#b29a86",
  "#9b806a",
  "#826a56",
  "#6c5a4d",
  "#efe9dd",
  "#e8e1d6",
  "#e4cdb9",
  "#c3a98f",
  "#ab886b",
  "#8e705a",
  "#775f4f",
  "#ece3d8",
  "#e9e0d8",
  "#dcc8b7",
  "#c4ab98",
  "#ac8f7b",
  "#8d6e54",
  "#76563d",
  "#eddac7",
  "#e6c6aa",
  "#d9b391",
  "#cba282",
  "#bc8d68",
  "#a57b5b",
  "#8e684b",
  "#f2e6d6",
  "#e8cfb8",
  "#e3c5a9",
  "#d5b092",
  "#ba8b69",
  "#a06f50",
  "#946448",
  "#efe2d6",
  "#ebd9cc",
  "#e5d0bf",
  "#e1c0a7",
  "#ca9b75",
  "#b47e50",
  "#9a653c",
  "#f1e8dd",
  "#f3e8db",
  "#f0d8c2",
  "#e8ceb5",
  "#d4ad87",
  "#b28a61",
  "#936c43",
  "#f0e8dd",
  "#ede2d4",
  "#decfbc",
  "#ceb69c",
  "#b29577",
  "#987b5d",
  "#77593d",
  "#ece5d8",
  "#e5d9c6",
  "#deccb6",
  "#c6b199",
  "#ac9379",
  "#90775d",
  "#7b624d",
  "#eeeade",
  "#ebe1d2",
  "#e2cfb2",
  "#d3bc9b",
  "#b99e78",
  "#a88767",
  "#987659",
  "#efe6db",
  "#f0e5d9",
  "#ebd8c2",
  "#e2ceb8",
  "#d2b088",
  "#ad865a",
  "#987043",
  "#f0e8da",
  "#f0ddc9",
  "#edd4b8",
  "#dbb78e",
  "#c89e73",
  "#af8159",
  "#9d7149",
  "#f6e7d2",
  "#f7e6cc",
  "#f0d6b7",
  "#e4c39d",
  "#ca9d6d",
  "#be9064",
  "#a2784e",
  "#f5e6d0",
  "#edcda5",
  "#deb583",
  "#d7aa77",
  "#c69b6a",
  "#b4865a",
  "#9e7247",
  "#f3ebd4",
  "#f2e9d0",
  "#f2dbba",
  "#e4c093",
  "#d3a771",
  "#b88d5a",
  "#a87a4b",
  "#f3eddf",
  "#f2ebd7",
  "#e9d0ae",
  "#d4b288",
  "#c3996b",
  "#b2885c",
  "#99744e",
  "#f5edd9",
  "#f0e1c3",
  "#e2c8a2",
  "#ceb28a",
  "#c2a379",
  "#b49167",
  "#a68053",
  "#e8dcc8",
  "#e5d1b6",
  "#dcc2a2",
  "#d8ba95",
  "#bc976c",
  "#b29169",
  "#8e6e4b",
  "#f2e8d8",
  "#f0e3d2",
  "#e6d3b9",
  "#d9c39f",
  "#c3a377",
  "#a88759",
  "#896a3f",
  "#eee6d5",
  "#ece2cc",
  "#dfc8aa",
  "#ceb697",
  "#b6936c",
  "#a1855c",
  "#816640",
  "#eae5d8",
  "#e4dfd1",
  "#dbcfba",
  "#cabba3",
  "#ad9a7e",
  "#8b795f",
  "#766245",
  "#efe9d9",
  "#e9ddc6",
  "#dfcfb3",
  "#ceba9a",
  "#ae9774",
  "#947b56",
  "#725d3d",
  "#ece4d4",
  "#e6ddc9",
  "#dfcdae",
  "#d3bc96",
  "#b29774",
  "#9f8766",
  "#897052",
  "#eed39b",
  "#eccf94",
  "#dbbe74",
  "#d2bc88",
  "#b79e6a",
  "#a28651",
  "#947f4e",
  "#71684c",
  "#dcd2a9",
  "#cecaa1",
  "#e9e6b8",
  "#bca96f",
  "#b2ae7f",
  "#9a9764",
  "#8a8646",
  "#777d54",
  "#9e8f72",
  "#b2a282",
  "#c3b498",
  "#aea995",
  "#d6d7bd",
  "#c6bda0",
  "#9e9f87",
  "#828678",
  "#676357",
  "#878263",
  "#d0c6a1",
  "#8d856a",
  "#b0a582",
  "#b5aa85",
  "#b2a57b",
  "#9e8f68",
  "#f3efe2",
  "#f3ebd9",
  "#ddc9ab",
  "#bca27b",
  "#ac926b",
  "#9e835f",
  "#8b6f4d",
  "#eae6d9",
  "#e5ddc8",
  "#d1c1a7",
  "#c0ab8f",
  "#af9778",
  "#887154",
  "#695c4c",
  "#ece7dc",
  "#e4ddcd",
  "#c7b9a2",
  "#b9ab90",
  "#a0906e",
  "#847551",
  "#665c46",
  "#f0eada",
  "#e6dbc5",
  "#d9cbad",
  "#c6b28c",
  "#a68e61",
  "#927747",
  "#77633a",
  "#efe9da",
  "#ece5d0",
  "#e9dac2",
  "#d5be9a",
  "#b3976b",
  "#91774f",
  "#866e4d",
  "#f1e9d7",
  "#f1e9d2",
  "#ead3ad",
  "#e2caa1",
  "#d0b486",
  "#be9c6b",
  "#aa8650",
  "#f7e8cc",
  "#f3d5a8",
  "#e9bf84",
  "#d5a463",
  "#daa863",
  "#c39458",
  "#b28243",
  "#f6edce",
  "#f9eac2",
  "#efdaa4",
  "#eed39b",
  "#e1ba75",
  "#cfa357",
  "#c49e43",
  "#f6eed4",
  "#f7eac8",
  "#f3e1b5",
  "#e9ce98",
  "#d5b373",
  "#bf9e62",
  "#b39150",
  "#f0e3be",
  "#ebdab0",
  "#e6cf9e",
  "#cea36e",
  "#cdac67",
  "#ba9c56",
  "#a68734",
  "#f1e3b5",
  "#e9d59e",
  "#d8c482",
  "#cdb668",
  "#ad9555",
  "#a48d49",
  "#917c3b",
  "#e9e6da",
  "#e5ddc6",
  "#d0c6a1",
  "#bcac7d",
  "#9c8f60",
  "#897747",
  "#75693d",
  "#ede6d9",
  "#e2dac9",
  "#d7ccb6",
  "#c9ba9d",
  "#b1a582",
  "#9e9067",
  "#726647",
  "#dfdac6",
  "#d4cdb5",
  "#c6bda0",
  "#b0a582",
  "#9c946f",
  "#7a744d",
  "#5e573e",
  "#e9e7d7",
  "#dedbc4",
  "#d1ccaa",
  "#bcb58b",
  "#a39d70",
  "#8c8752",
  "#797547",
  "#eaebdd",
  "#e7e5d5",
  "#dfdcc7",
  "#c8c5a5",
  "#a19d77",
  "#918c66",
  "#756f4d",
  "#edebd5",
  "#e4e2ca",
  "#e5dfc1",
  "#dcd2a9",
  "#bfac78",
  "#ab955d",
  "#927f4a",
  "#eeebc2",
  "#e9e7b3",
  "#dcdb94",
  "#c3c67e",
  "#b5b364",
  "#a1a057",
  "#8e8849",
  "#e9e5c6",
  "#dfdbb6",
  "#d3d0a3",
  "#c0bc8a",
  "#a8a268",
  "#908a4f",
  "#7d7943",
  "#ece7d1",
  "#e7e1c5",
  "#dfdab9",
  "#cec99f",
  "#bab381",
  "#a59f6c",
  "#8d8753",
  "#edeee0",
  "#e3ead9",
  "#dce4cb",
  "#ccd1ac",
  "#b6be96",
  "#99a374",
  "#717a4e",
  "#e3e8da",
  "#dae1d0",
  "#cfdbc4",
  "#bac6a4",
  "#98a77d",
  "#7d8e61",
  "#5d6d3c",
  "#e9e8d8",
  "#dfe3d0",
  "#cfd2b5",
  "#b8bd97",
  "#9da073",
  "#7f8353",
  "#6c7344",
  "#eeece1",
  "#ebe9dd",
  "#e2e0d3",
  "#cecab6",
  "#a9a484",
  "#8f8a6b",
  "#6f6b4d",
  "#e1e5d8",
  "#d8decf",
  "#c7cebf",
  "#b2b9a5",
  "#92987e",
  "#6c765b",
  "#566049",
  "#e2e0d6",
  "#d2d4c3",
  "#c8cab6",
  "#acaf96",
  "#909374",
  "#6d704f",
  "#57593f",
  "#eaebe0",
  "#e7e6d8",
  "#dedccd",
  "#c3c2af",
  "#a1a187",
  "#7c7c64",
  "#6a6b58",
  "#dfe5d9",
  "#dbddcd",
  "#d1d2c1",
  "#afb29f",
  "#85866f",
  "#656552",
  "#5f5e4b",
  "#dcddd4",
  "#d1d2c8",
  "#c8cac0",
  "#bec4b8",
  "#929a8a",
  "#727b6c",
  "#515746",
  "#dfe5db",
  "#cad5c8",
  "#d0d5c8",
  "#b8bfb0",
  "#929b89",
  "#798372",
  "#52584e",
  "#e1e8dc",
  "#dbe5d8",
  "#cfddcd",
  "#b9d1b6",
  "#8faf88",
  "#709068",
  "#4c663e",
  "#e3ede3",
  "#d1e5d3",
  "#cdddc4",
  "#aac5a3",
  "#93b087",
  "#6e8b63",
  "#5c724c",
  "#dae9df",
  "#c5decf",
  "#a8d0ba",
  "#83bb9e",
  "#60a182",
  "#438866",
  "#20654a",
  "#dde7df",
  "#c7dace",
  "#bcd0c3",
  "#9cb7a6",
  "#789583",
  "#54745f",
  "#3d5948",
  "#e6eae0",
  "#e2e8df",
  "#deeae0",
  "#b2c5b9",
  "#899a8c",
  "#697b6c",
  "#405241",
  "#e6e9e3",
  "#e0e4dd",
  "#d9e0d7",
  "#b6c4bb",
  "#87988c",
  "#758478",
  "#57645c",
  "#e0e9e4",
  "#dee8e3",
  "#d5e2de",
  "#b9cac5",
  "#90a49d",
  "#70837d",
  "#495a51",
  "#ecf1ec",
  "#e6efea",
  "#dcece7",
  "#acc7c0",
  "#809f97",
  "#627d74",
  "#375549",
  "#d7e5dd",
  "#c3d7d0",
  "#aec7c0",
  "#8aaea4",
  "#6b9085",
  "#447266",
  "#3b564e",
  "#d3e5dc",
  "#bed5c8",
  "#a1c2b1",
  "#7eaa96",
  "#608f7b",
  "#3b6c55",
  "#2e594b",
  "#d7e7e0",
  "#badad1",
  "#9fcdc0",
  "#7cb5a5",
  "#559c8a",
  "#277a67",
  "#006852",
  "#d7e7e1",
  "#c2dcd6",
  "#acd0ca",
  "#87b9b2",
  "#5d9c92",
  "#42857c",
  "#106157",
  "#d5e7e4",
  "#cde2df",
  "#bbd6d5",
  "#99c1be",
  "#6fa39f",
  "#4a8582",
  "#0f5f5c",
  "#e1ebe5",
  "#c7d6d2",
  "#b6ccc8",
  "#92b1a9",
  "#73978f",
  "#4a726b",
  "#2d5951",
  "#d0dbd8",
  "#cad9d7",
  "#becfcd",
  "#a1b7b5",
  "#7b9793",
  "#547370",
  "#355856",
  "#e8eee8",
  "#d9e6e4",
  "#d6e5e3",
  "#a7bbba",
  "#7f9392",
  "#566b6b",
  "#3b4f4f",
  "#dce6e4",
  "#d3e0df",
  "#c7dada",
  "#9fbfbf",
  "#6b9a9b",
  "#467a7b",
  "#155d61",
  "#dbe6e5",
  "#cfe2e1",
  "#bbdbdb",
  "#8ac2c3",
  "#53a0a1",
  "#1f7d82",
  "#00666f",
  "#d4e3e3",
  "#d5e1e1",
  "#cad9db",
  "#a0bcc0",
  "#79989c",
  "#497279",
  "#2a535c",
  "#dbe4e5",
  "#cedee3",
  "#c2d3d7",
  "#95afb7",
  "#6f8d96",
  "#496772",
  "#2c5261",
  "#d2e4e6",
  "#cde0e4",
  "#b6d7de",
  "#8dbbc4",
  "#4b99a9",
  "#167b8f",
  "#00687d",
  "#d9e3e6",
  "#cbdee2",
  "#b3d0d9",
  "#86b5c4",
  "#5c96a9",
  "#31778c",
  "#02617b",
  "#dae3e6",
  "#d1dee4",
  "#a8c0ce",
  "#7e9daf",
  "#618396",
  "#355c74",
  "#2b516b",
  "#e9eeed",
  "#e3eaea",
  "#d7dfe2",
  "#acbfc9",
  "#7b8f99",
  "#516772",
  "#334a59",
  "#ecefeb",
  "#d4e2e6",
  "#cddce3",
  "#adc6d3",
  "#7f9daa",
  "#5c7a89",
  "#2c5268",
  "#e1e9ec",
  "#dfeaef",
  "#cedde7",
  "#bbcddc",
  "#8da7b9",
  "#5f7b8e",
  "#2d5069",
  "#dee6e8",
  "#c9d7de",
  "#a1b9cb",
  "#7494ac",
  "#52778f",
  "#2b5876",
  "#2c4c6a",
  "#d7e1e5",
  "#c5d8e3",
  "#aac8d8",
  "#81acc4",
  "#5491b2",
  "#32759a",
  "#005d89",
  "#d8e4e8",
  "#c3d8e4",
  "#a3c3d7",
  "#77a6c3",
  "#508aab",
  "#266c94",
  "#175788",
  "#dfe7e9",
  "#c4d2dd",
  "#a3bbce",
  "#779bb6",
  "#4f7b9a",
  "#1a5b84",
  "#255269",
  "#dae1e4",
  "#c1ceda",
  "#aabed0",
  "#8ca8bf",
  "#587f9e",
  "#395e7d",
  "#2a4a6f",
  "#dae3e8",
  "#bdd0e1",
  "#a1bed9",
  "#719cc3",
  "#4d83af",
  "#266393",
  "#224d88",
  "#d8e0e8",
  "#c7d3e0",
  "#adbfd6",
  "#7d9dc3",
  "#5b83b2",
  "#2f6295",
  "#304a77",
  "#dde3e8",
  "#c7d1dc",
  "#b6c3d2",
  "#9dafc2",
  "#6b8096",
  "#4b6077",
  "#2e5268",
  "#e9ecef",
  "#dae4ee",
  "#d6dfe8",
  "#adbad0",
  "#8290a6",
  "#627188",
  "#384966",
  "#e0e2e5",
  "#d1d6df",
  "#c0c6d4",
  "#a5afc4",
  "#7c8ba8",
  "#566682",
  "#3a3f5b",
  "#dee1e6",
  "#d4dae2",
  "#bcc5d9",
  "#9aa9c8",
  "#6c86b7",
  "#4e6897",
  "#364875",
  "#e3e5e8",
  "#dcdfe6",
  "#ccd0dd",
  "#a7b0cc",
  "#818db3",
  "#617099",
  "#455383",
  "#e6e6e8",
  "#dadbdf",
  "#c7ccd9",
  "#a4abbf",
  "#838ba4",
  "#606a88",
  "#3c486d",
  "#e4e3e5",
  "#dcdbe2",
  "#d1d2dc",
  "#afb2c4",
  "#898ca3",
  "#6b6d85",
  "#454b6a",
  "#e2e3ec",
  "#dee0ea",
  "#d1d3e1",
  "#b1b2cb",
  "#8f90b4",
  "#686b93",
  "#4c517f",
  "#e5e7e9",
  "#e5e6ea",
  "#dadde6",
  "#b8b9cb",
  "#9090a2",
  "#6e6f82",
  "#464960",
  "#efedeb",
  "#ebe8ec",
  "#d6d2d9",
  "#bab3bf",
  "#928a98",
  "#6b6472",
  "#4a4353",
  "#dfdee5",
  "#e0dde3",
  "#d4d1dc",
  "#bfbbc9",
  "#9c95a9",
  "#79738b",
  "#544f66",
  "#e5e1e5",
  "#dbd6df",
  "#cec8d2",
  "#bab3c2",
  "#9c8fa6",
  "#736a86",
  "#4e4360",
  "#e6e2e7",
  "#dfdbe5",
  "#d3d0dd",
  "#bfb8ce",
  "#998eb4",
  "#736993",
  "#534b77",
  "#e7dee6",
  "#e6dde7",
  "#d6cbdb",
  "#c3b1c8",
  "#a487ac",
  "#896792",
  "#6a4877",
  "#e7e3e7",
  "#e1d8e0",
  "#d7c7d6",
  "#c3aec3",
  "#a689a3",
  "#7f667f",
  "#604560",
  "#e8dfe4",
  "#e6d8e1",
  "#ddcad8",
  "#d0b7ca",
  "#b08ea5",
  "#88657e",
  "#674160",
  "#e8e1e3",
  "#e2d9dc",
  "#dbccd3",
  "#cfbac4",
  "#b695a4",
  "#906277",
  "#623f52",
  "#e6dae2",
  "#e7d8e3",
  "#e7cede",
  "#dab7cf",
  "#c291b2",
  "#a36c93",
  "#824874",
  "#f4dfe4",
  "#f5d8e0",
  "#f6c8d5",
  "#f2a8bf",
  "#ea85a4",
  "#e06c90",
  "#cb567c",
  "#f0e1e5",
  "#f1d6dd",
  "#f0c8d3",
  "#e6a4b8",
  "#da859f",
  "#cb6787",
  "#b0446a",
  "#f2dee1",
  "#f3d3d9",
  "#eebfc9",
  "#ea9dac",
  "#d5768b",
  "#cc607a",
  "#b13e5e",
  "#f5e4e5",
  "#f7cdd2",
  "#f8b3bc",
  "#f892a0",
  "#e76b81",
  "#da5770",
  "#d04a64",
  "#f5dbd9",
  "#f9cccd",
  "#f9b5b6",
  "#f8949b",
  "#eb6a76",
  "#e05164",
  "#cb384b",
  "#f3dbdb",
  "#f5cacb",
  "#f4b3b7",
  "#ea8e96",
  "#d56d76",
  "#c04f5b",
  "#ad3d4c",
  "#f4d9d7",
  "#f5d2cf",
  "#f4c1c0",
  "#f09b9d",
  "#dc7678",
  "#c8585c",
  "#b1393e",
  "#f5e3e0",
  "#f7d8d7",
  "#fac2bf",
  "#faa09d",
  "#f27777",
  "#e75f64",
  "#cb484c",
  "#f6e2de",
  "#f7dcd3",
  "#facac2",
  "#fbb1a6",
  "#f3867c",
  "#d7584c",
  "#b94940",
  "#f4e0db",
  "#f4dbd6",
  "#f6c8c3",
  "#eeaaa2",
  "#df8079",
  "#c76157",
  "#ae413a",
  "#f4ece7",
  "#f3e3dd",
  "#f1c5bb",
  "#e8a091",
  "#db8675",
  "#c06f60",
  "#b35941",
  "#f4e4dc",
  "#f5e0d8",
  "#f2d1c8",
  "#f2c2b6",
  "#e79c86",
  "#dc8267",
  "#c35b3c",
  "#f4e8e1",
  "#f7e2d8",
  "#f8dfd7",
  "#f4c8be",
  "#fda48d",
  "#e4745b",
  "#cf533a",
  "#f5e8e1",
  "#f6e4dc",
  "#f5ded4",
  "#eeb9ab",
  "#e68f75",
  "#e57757",
  "#c15339",
  "#f3eae2",
  "#f6e2d5",
  "#f3d4c5",
  "#f3b598",
  "#f6a37c",
  "#ec8a5b",
  "#dd6f3b",
  "#f4ddcd",
  "#f5d9c9",
  "#f7d5c2",
  "#f8be9d",
  "#fba270",
  "#f49056",
  "#ea874f",
  "#f3e9df",
  "#f3e1d2",
  "#f8d8be",
  "#fac6a0",
  "#feac71",
  "#fa9a54",
  "#f39349",
  "#f5decc",
  "#f5d4bf",
  "#f5c6a7",
  "#f0ab80",
  "#e08d59",
  "#d27638",
  "#c66b35",
  "#f5e2d6",
  "#f5dfd4",
  "#efc7b6",
  "#e7b095",
  "#d28d6c",
  "#c77c5a",
  "#b05f3a",
  "#d6bc8e",
  "#f2dabb",
  "#e8ba6c",
  "#d9b280",
  "#f6e4c0",
  "#e2bc8b",
  "#efd1a7",
  "#e9b072",
  "#f3e6cf",
  "#ceb9a5",
  "#c4a47f",
  "#dcbf98",
  "#eadbc6",
  "#d4b288",
  "#e2c8a2",
  "#c3aa87",
  "#f0d2a4",
  "#e1c193",
  "#c2a379",
  "#ccb38b",
  "#e2caa1",
  "#d0b486",
  "#efdaa4",
  "#ac8955",
  "#f6e2c8",
  "#e0ccaf",
  "#f0e1c3",
  "#e7d5b6",
  "#e1cba9",
  "#cfb695",
  "#ecd7ba",
  "#ebd6ba",
  "#f4e4d5",
  "#f6d9c6",
  "#f2c3a7",
  "#e9a580",
  "#d2885e",
  "#c47444",
  "#b96a3c",
  "#f2e4d7",
  "#f0dcca",
  "#f1cdb4",
  "#eab794",
  "#d89466",
  "#cf8149",
  "#bf7037",
  "#f2e9dd",
  "#f5e3d1",
  "#f4dcc6",
  "#f0c9aa",
  "#e4ac78",
  "#d29358",
  "#c58038",
  "#f3ecdd",
  "#f6e8d6",
  "#f5debf",
  "#fbd19f",
  "#fcbc7d",
  "#f5ae61",
  "#f09c43",
  "#f4eedd",
  "#f4ead3",
  "#fbe4c2",
  "#fdd9aa",
  "#fcc584",
  "#fabb72",
  "#fbb153",
  "#f4f0de",
  "#f7eed6",
  "#fae6c4",
  "#ffdba5",
  "#ffd892",
  "#ffc963",
  "#ffbd32",
  "#f6efda",
  "#f8eece",
  "#f8eccb",
  "#fce5af",
  "#ffda77",
  "#ffd25a",
  "#ffc72f",
  "#f2ede1",
  "#f5e7d2",
  "#f4e2c6",
  "#f0cea0",
  "#e3b270",
  "#ce974d",
  "#bb8132",
  "#f2eee2",
  "#f4e9cf",
  "#f4dfb7",
  "#edc482",
  "#e1ad59",
  "#cf9943",
  "#bd862e",
  "#f3edd9",
  "#f5e5c6",
  "#f6deaf",
  "#f4c775",
  "#eeb955",
  "#e2a94b",
  "#c99233",
  "#f6ead3",
  "#f8e2bb",
  "#f8dcab",
  "#f9cf8e",
  "#eeb865",
  "#e5ac4f",
  "#d8a431",
  "#f6eed7",
  "#f7edcf",
  "#fbe7b7",
  "#ffe19c",
  "#fed27d",
  "#ffc85e",
  "#ffc047",
  "#f2efd7",
  "#f5efc3",
  "#f5edb2",
  "#f7eca1",
  "#feeb83",
  "#ffdf37",
  "#ffcb3b",
  "#f0efe1",
  "#f3efcd",
  "#f5eeba",
  "#f6edae",
  "#f9eb97",
  "#fcd361",
  "#f6c545",
  "#f2ecdb",
  "#f2ead2",
  "#f9e5ba",
  "#f5e3a7",
  "#f8d86e",
  "#e5c14c",
  "#d9ad38",
  "#f3f0e6",
  "#f0edd2",
  "#f0e7a9",
  "#f0df75",
  "#e3c74e",
  "#cfb128",
  "#b8a029",
  "#efefd6",
  "#eaeece",
  "#e9edbd",
  "#ececa7",
  "#ede777",
  "#e6da42",
  "#e0be36",
  "#f1edd3",
  "#efe8bb",
  "#ebe3a9",
  "#e0e2a9",
  "#d8d68e",
  "#d6ce81",
  "#d4c44b",
  "#f0eac6",
  "#f1e7b5",
  "#e7d890",
  "#ddc76a",
  "#c6b156",
  "#ae9c3f",
  "#a3923e",
  "#eeeed7",
  "#e9e7af",
  "#e1e0a0",
  "#d5d17b",
  "#c9c664",
  "#bab242",
  "#99a32a",
  "#eeefdc",
  "#f0edcc",
  "#eae9b8",
  "#e4e5ab",
  "#d9e29a",
  "#cace66",
  "#b7c04e",
  "#ecf1e2",
  "#ebedd1",
  "#e2e9bf",
  "#dde7ad",
  "#ccd98a",
  "#b3c667",
  "#a7b53c",
  "#e6ebd7",
  "#e6eccc",
  "#dbe5ba",
  "#cddda2",
  "#adc571",
  "#95af54",
  "#78973b",
  "#e2ede1",
  "#ddead9",
  "#d2e3cd",
  "#b8d7ae",
  "#93bf84",
  "#73a55b",
  "#558c3b",
  "#ecf0e5",
  "#e8f0e2",
  "#e4efdf",
  "#d6eccd",
  "#bde4b1",
  "#9bd687",
  "#74be58",
  "#e3efe2",
  "#dbeedb",
  "#cceace",
  "#bce5be",
  "#8fd49a",
  "#65c171",
  "#37a84f",
  "#dae9dd",
  "#d0e6d6",
  "#b7dcc4",
  "#97cda9",
  "#64b082",
  "#4c9d6f",
  "#007845",
  "#daeee1",
  "#c2ead6",
  "#a4e0c3",
  "#74cfa8",
  "#3eb989",
  "#25a975",
  "#00935f",
  "#dceee2",
  "#bfe5d6",
  "#a0d4be",
  "#7cc4aa",
  "#4ca787",
  "#1f8f6e",
  "#007859",
  "#d4ede3",
  "#bbe7d9",
  "#95dcc6",
  "#57c9b0",
  "#04b296",
  "#00a285",
  "#00896f",
  "#d8eae5",
  "#bce1d9",
  "#a3d8ce",
  "#73c2b5",
  "#40a696",
  "#089080",
  "#007c6d",
  "#e2ebe5",
  "#c4e5e3",
  "#b3deda",
  "#8cccc8",
  "#5ab1ac",
  "#239692",
  "#007a77",
  "#e1ede6",
  "#d3ece7",
  "#a9e3df",
  "#7cd5d1",
  "#3abdb7",
  "#00a29d",
  "#00918d",
  "#deeeed",
  "#d1ebeb",
  "#c2e7e9",
  "#b3e3e5",
  "#6ccacf",
  "#38b8be",
  "#0099a0",
  "#e5f1ef",
  "#d3e7e6",
  "#bededf",
  "#8cced1",
  "#4ab2b4",
  "#0e9498",
  "#007681",
  "#e8efed",
  "#d2e5e9",
  "#c3dde3",
  "#92c7d3",
  "#52a5b7",
  "#168da2",
  "#007893",
  "#deeced",
  "#d3e8ec",
  "#c5e3eb",
  "#9ad4e2",
  "#56b8cd",
  "#1fa3bc",
  "#008ea9",
  "#e4edee",
  "#cee4ee",
  "#add6eb",
  "#7ec0e3",
  "#44a6d1",
  "#1091c0",
  "#007bae",
  "#dae6ea",
  "#d0e1e8",
  "#accfe0",
  "#7cb5d0",
  "#5096b7",
  "#1e80a9",
  "#006994",
  "#d6e1e4",
  "#ccdfe9",
  "#9ec8e5",
  "#63a8d3",
  "#3a8ebc",
  "#1877ac",
  "#00609e",
  "#d3e5ec",
  "#cbe3ef",
  "#a2d0ec",
  "#67b3e1",
  "#2e96d0",
  "#1389ca",
  "#0071b6",
  "#d9e6ee",
  "#c7ddee",
  "#9ac6eb",
  "#5fa4e0",
  "#388dd1",
  "#177fc8",
  "#0262af",
  "#dae3ea",
  "#c2d7ea",
  "#96bde2",
  "#71a3d0",
  "#3984be",
  "#166eae",
  "#175799",
  "#e1e8ed",
  "#d3e0ed",
  "#aac9ea",
  "#7bade2",
  "#4e8ed2",
  "#3879c2",
  "#2463ad",
  "#e0e6eb",
  "#d0dbe9",
  "#a2bcdb",
  "#7da2d2",
  "#5287c0",
  "#326ead",
  "#18569a",
  "#dde0e9",
  "#dadee9",
  "#cbd1e1",
  "#abb6d8",
  "#8293c5",
  "#6174ab",
  "#415397",
  "#dfe2ec",
  "#d7ddec",
  "#cad1ea",
  "#adb9e3",
  "#8496d2",
  "#7287c6",
  "#5668ae",
  "#e9e5e9",
  "#e5e1ea",
  "#dcd7e4",
  "#c7bedd",
  "#a698c7",
  "#8378ad",
  "#5a4e87",
  "#edeced",
  "#e9e5ed",
  "#e4dfed",
  "#d1c8e6",
  "#9898bc",
  "#7b7da7",
  "#5d5d88",
  "#eae1e9",
  "#e5d6e5",
  "#ddcae0",
  "#caafd0",
  "#aa85b5",
  "#9769a2",
  "#7a5188",
  "#ecdfea",
  "#e9ddea",
  "#e0cae5",
  "#d1b1d8",
  "#b68bc2",
  "#a675b1",
  "#855994",
  "#ece2e8",
  "#ebe0e8",
  "#ead2e3",
  "#e3bed9",
  "#cf94be",
  "#b06ea0",
  "#935284",
  "#eee5e8",
  "#efe1ec",
  "#efdae8",
  "#eac2de",
  "#dea3cd",
  "#c67cb2",
  "#a05a8e",
  "#8e575d",
  "#79413a",
  "#6e403e",
  "#753e45",
  "#8b585d",
  "#5f4345",
  "#614142",
  "#6a4f61",
  "#a04848",
  "#6d1d14",
  "#983d4d",
  "#8b4548",
  "#72271e",
  "#a84f5c",
  "#a04f45",
  "#a23d3f",
  "#575561",
  "#5f5358",
  "#7a6c74",
  "#715d79",
  "#4a4353",
  "#6b6472",
  "#9e9fa8",
  "#807d85",
  "#364875",
  "#2d5069",
  "#295167",
  "#196a76",
  "#1c3c2d",
  "#3b5a54",
  "#52634f",
  "#526a4d",
  "#8c817b",
  "#7b675a",
  "#e1ded9",
  "#b9b0a8",
  "#3d4646",
  "#7e756b",
  "#e1dacd",
  "#eeeade",
  "#c0ab8f",
  "#d8cab2",
  "#d5d1c0",
  "#cbc1be",
  "#a1917e",
  "#c8b8a4",
  "#ebe3d6",
  "#f0ece2",
  "#d7c5ae",
  "#d2b89c",
  "#e4d2b9",
  "#eee6d7",
  "#e0d4c4",
  "#cbbab0",
  "#efe7da",
  "#eae6de",
  "#d5d0bf",
  "#c8bea8",
  "#b9ac97",
  "#aaa190",
  "#d1c9bb",
  "#dbd1c6",
  "#e6e1d8",
  "#cec7b8",
  "#bb987b",
  "#9b6f45",
  "#b08661",
  "#c7a78b",
  "#efebde",
  "#e7dbca",
  "#bc9f85",
  "#a58056",
  "#baa286",
  "#ae9273",
  "#c8a987",
  "#c3a98f",
  "#705746",
  "#5e3f1e",
  "#b29577",
  "#c6b199",
  "#8d847f",
  "#6d5f53",
  "#a39080",
  "#87796c",
  "#766759",
  "#635141",
  "#462406",
  "#381b04",
  "#c9bcac",
  "#dbcfba",
  "#f7f0e2",
  "#cabfb2",
  "#b6a393",
  "#9c8a7a",
  "#a38e72",
  "#8d7868",
  "#d3ac9a",
  "#a38064",
  "#c88f68",
  "#b58365",
  "#ba8a74",
  "#a16f52",
  "#9f6f59",
  "#7a4d42",
  "#ccb9ad",
  "#ddba87",
  "#c5944f",
  "#af7800",
  "#ae814e",
  "#ce9859",
  "#ae7b44",
  "#aa7f5e",
  "#977652",
  "#cea886",
  "#c88b5a",
  "#b1703a",
  "#b27547",
  "#a96c3f",
  "#855842",
  "#574542",
  "#eacbb4",
  "#d6a284",
  "#bd8675",
  "#b06e5b",
  "#96534a",
  "#743618",
  "#772f0f",
  "#692300",
  "#92b3dc",
  "#4d7cb2",
  "#345578",
  "#6c86b7",
  "#5668ae",
  "#7a8ab7",
  "#826d95",
  "#b18aae",
  "#cc6e94",
  "#c65a87",
  "#aa4875",
  "#9e4749",
  "#cb484c",
  "#eb6a76",
  "#e4745b",
  "#de624e",
  "#ffce6a",
  "#f3c16d",
  "#edad57",
  "#e2ac71",
  "#fba971",
  "#ec8e3f",
  "#ce7b51",
  "#da7953",
  "#ddcb6b",
  "#a9ac31",
  "#aaa44c",
  "#7a8e68",
  "#94d3c1",
  "#bae6d2",
  "#8dc9c0",
  "#00948b",
  "#f3f0e7",
  "#d7cbc1",
  "#c9b6a9",
  "#c4bab9",
  "#b99d99",
  "#c69b9e",
  "#ad929f",
  "#9f898c",
  "#ece8de",
  "#f1e7d9",
  "#f3ebe4",
  "#f5e4da",
  "#efdacf",
  "#e1c4b9",
  "#e3b9ab",
  "#c59688",
  "#ede2e4",
  "#ebd7d9",
  "#dbb7bc",
  "#b98290",
  "#a67479",
  "#9d686c",
  "#9f6071",
  "#7f3f55",
  "#cfbeb7",
  "#e4caba",
  "#e5c0a9",
  "#dfbaab",
  "#ca7976",
  "#c1727c",
  "#b0676d",
  "#af5959",
  "#545049",
  "#c2b8ac",
  "#eddcc9",
  "#1a1917",
  "#000000",
  "#ffffff",
  "#eaeace",
  "#bfbfb6",
  "#e8e8e8",
  "#373025",
  "#a1a191",
  "#383838",
  "#354c3b",
  "#6b3d31",
  "#96683b",
  "#51524d",
  "#aa988a",
  "#757d82",
  "#8f9da8",
  "#3c4a53",
  "#4f4135",
  "#2b2b2b",
  "#524b3e",
  "#002e45",
  "#da2122",
  "#ebebeb",
  "#112e57",
  "#cccfbe",
  "#959595",
  "#4f6e7d",
  "#848484",
  "#9d4e2f",
  "#9aa1a3",
  "#BEB5A9",
  "#C8BCAB",
  "#EDECE6",
  "#bbb2a3",
  "#efece3",
  "#e3dbcd",
  "#2a3037",
  "#313233",
  "#433f34",
  "#E7e7e9",
  "#f6f5fa",
  "#6b5d50",
  "#d4d3ce",
  "#778375",
  "#afb2a3",
  "#b8bab2",
  "#31353a",
  "#323234",
  "#757257",
  "#5c5c4f",
  "#c5baa5",
  "#ccc8c0",
  "#90948b",
  "#c5c2b8",
  "#b3b0a6",
  "#54523b",
  "#8b8370",
  "#d8d5cf",
  "#1a181a",
  "#4d412f",
  "#e2ded4",
  "#b2ad98",
  "#f4f6f2",
  "#aaa69a",
  "#2f2f30",
  "#303d4d",
  "#4d3d30",
  "#797979",
  "#870000",
  "#edece7",
  "#d7d7d1",
  "#143d1e",
  "#040708",
  "#ffffff",
  "#4a3321",
  "#361721",
  "#35352d",
  "#4e4d48",
  "#6a7a55",
  "#8a5121",
  "#928e34",
  "#d7d7d2",
  "#bf2726",
  "#840a2d",
  "#4a3321",
  "#830b0d",
  "#8b8776",
  "#133f1f",
  "#053752",
  "#979292",
  "#4e4d48",
  "#999492",
  "#b7ac97",
  "#1e4922",
  "#d3ccab",
  "#bdb68f",
  "#bdb790",
  "#999492",
  "#4d4d47",
  "#315d74",
  "#221f1f",
  "#999492",
  "#edefeb",
  "#a22320",
  "#7a2a28",
  "#49331f",
  "#bdb68f",
  "#9f8777",
  "#221f1f",
  "#bc9369",
  "#9f8776",
  "#040708",
  "#23302c",
  "#63707c",
  "#4e413a",
  "#322c2d",
  "#304654",
  "#2a3d3a",
  "#6c6f6a",
  "#3b564b",
  "#e7e2cb",
  "#5c6461",
  "#a58966",
  "#726158",
  "#a09b9a",
  "#8d877c",
  "#dcc28f",
  "#4b504c",
  "#8b8e8c",
  "#9aa098",
  "#4f5f67",
  "#466279",
  "#5f767a",
  "#78484a",
  "#927564",
  "#475960",
  "#958b75",
  "#c3cbb8",
  "#e0d0b4",
  "#ccd0c7",
  "#986953",
  "#7b7162",
  "#bbc2aa",
  "#9e7960",
  "#c9bca7",
  "#aaa891",
  "#24211f",
  "#734136",
  "#f1edcf",
  "#606659",
  "#999b93",
  "#3a4650",
  "#46443c",
  "#5b3e2f",
  "#673440",
  "#7a7265",
  "#5d3e41",
  "#514e47",
  "#d3c6b4",
  "#f7f1cc",
  "#acaeb2",
  "#cbd0c9",
  "#fff7e3",
  "#a0aa9a",
  "#f0ead6",
  "#d2cab6",
  "#e0d0b4",
  "#a6c1c9",
  "#d8d4bf",
  "#a1ab8b",
  "#bbc2aa",
  "#8f5937",
  "#73645b",
  "#7a7474",
  "#3f4748",
  "#585c67",
  "#8c898c",
  "#dfd5c3",
  "#5f6a62",
  "#c9af8c",
  "#9d9ba1",
  "#908171",
  "#333932",
  "#999a92",
  "#ac9988",
  "#485061",
  "#5c5e63",
  "#6b6866",
  "#c9c0b8",
  "#867f7d",
  "#4d3b33",
  "#c0b19d",
  "#6e767f",
  "#614e42",
  "#a67c64",
  "#7f4642",
  "#9d8071",
  "#877563",
  "#cabbaa",
  "#9f9584",
  "#978b7e",
  "#55554f",
  "#f8f8f7",
  "#a8967c",
  "#84786d",
  "#eddcc9",
  "#1a1917",
  "#423124",
  "#a9a092",
  "#847362",
  "#ede0c9",
  "#224a4f",
  "#a5a6aa",
  "#fbf9f4",
  "#f0ebd1",
  "#f7f5f5",
  "#2f2e2e",
  "#756346",
  "#5c4d29",
  "#40311c",
  "#e0d8c5",
  "#6e6968",
  "#c4b591",
  "#928b7c",
  "#949594",
  "#8e988c",
  "#7c7463",
  "#59534c",
  "#79888e",
  "#988977",
  "#e8b9ae",
  "#946644",
  "#47626f",
  "#e9e0d5",
  "#598c74",
  "#c2ccc4",
  "#92576f",
  "#b87e93",
  "#cb9aad",
  "#e3c0cf",
  "#ebd1db",
  "#7c3655",
  "#854158",
  "#a2566f",
  "#c47b95",
  "#d899b1",
  "#99324e",
  "#b04b63",
  "#d47c8c",
  "#e392a1",
  "#efc0cb",
  "#f1d3da",
  "#f0bcc9",
  "#f1d2d7",
  "#a42e37",
  "#bb4b51",
  "#d66972",
  "#ed939d",
  "#f0c1c6",
  "#f2d5d7",
  "#813235",
  "#a43834",
  "#d76c6e",
  "#ed9190",
  "#f0b3b2",
  "#f1c6c4",
  "#903934",
  "#a13b34",
  "#d9766c",
  "#ee9489",
  "#f0afa8",
  "#f2ccc5",
  "#b8473d",
  "#b85444",
  "#d87b6a",
  "#e79580",
  "#f2b8a7",
  "#f2d1c3",
  "#b44b34",
  "#c65f47",
  "#dd7861",
  "#e49780",
  "#f3c1ab",
  "#f0d1c3",
  "#c4633e",
  "#d67c56",
  "#e2946f",
  "#c35530",
  "#f3c1a3",
  "#f3d3bf",
  "#c36f3e",
  "#cb7841",
  "#e6955f",
  "#f2b88c",
  "#f4c69f",
  "#f4d3b3",
  "#e69f5f",
  "#efb57a",
  "#f5c894",
  "#f4d4af",
  "#df9938",
  "#ebad5e",
  "#eeb76b",
  "#f4bf77",
  "#f5d6a9",
  "#e39a33",
  "#f2af46",
  "#f7be5b",
  "#fbcb78",
  "#fbd187",
  "#f5deaf",
  "#ffc723",
  "#f4c454",
  "#fbd073",
  "#fbd682",
  "#fedf94",
  "#f5e5bc",
  "#fecb01",
  "#fed340",
  "#ffd566",
  "#fad97a",
  "#f5e1a6",
  "#f3e8c2",
  "#f1ead8",
  "#f6dda3",
  "#f5e0b1",
  "#c48919",
  "#d6a02b",
  "#eec25f",
  "#f5d68f",
  "#c49832",
  "#d1a436",
  "#dbb04a",
  "#eac365",
  "#f7d78a",
  "#f5e1ac",
  "#cba901",
  "#ddb835",
  "#edd26f",
  "#f7e594",
  "#f2eac3",
  "#9c8b1f",
  "#ac9825",
  "#c4b146",
  "#d9c661",
  "#e6d88e",
  "#eee3b2",
  "#847e35",
  "#b4b05a",
  "#c4c476",
  "#d2d083",
  "#dad790",
  "#e9e5b3",
  "#2f5f3a",
  "#4f854a",
  "#7fac6e",
  "#99c285",
  "#abca99",
  "#c0d2ad",
  "#245e36",
  "#68a678",
  "#78b185",
  "#8ec298",
  "#aed2b0",
  "#cce2ca",
  "#016844",
  "#57aa80",
  "#8ac1a1",
  "#9fcdb1",
  "#b7d7bf",
  "#d1e3d2",
  "#368976",
  "#53a38f",
  "#70baa7",
  "#89c6b7",
  "#a1d4c8",
  "#c0e3da",
  "#3b8c80",
  "#75b9ae",
  "#8ac5ba",
  "#a1d5cb",
  "#c1e6df",
  "#017478",
  "#01858b",
  "#3aa9ae",
  "#6ec2c4",
  "#92d0d0",
  "#a7dcdc",
  "#c2e5e5",
  "#01717e",
  "#08808e",
  "#4da6b2",
  "#7dc1cb",
  "#97cbd2",
  "#a6d0d6",
  "#016e85",
  "#34a3b6",
  "#71b8c7",
  "#8bc4d1",
  "#a6d4de",
  "#c6e3e8",
  "#016081",
  "#01819e",
  "#01a0b8",
  "#56b5ca",
  "#8fd0dd",
  "#b4e0e7",
  "#015d87",
  "#017ca7",
  "#289ec4",
  "#5db3d4",
  "#89c6df",
  "#a2d5e7",
  "#b7dfe8",
  "#2377a2",
  "#5a9ec0",
  "#7db5d3",
  "#b0d6e6",
  "#c3dfe8",
  "#4c6b8a",
  "#6b8ca9",
  "#8ea9c2",
  "#b2c8d8",
  "#cbd8e1",
  "#164576",
  "#4e739f",
  "#7498be",
  "#97b3d0",
  "#b8cddd",
  "#ccdbe5",
  "#3e4371",
  "#6572a5",
  "#8b98c4",
  "#a7b2d4",
  "#bbc5de",
  "#d8dde6",
  "#4d426e",
  "#716998",
  "#968db8",
  "#bdb4d4",
  "#d1cbdf",
  "#dfd9e4",
  "#624977",
  "#7e6596",
  "#a18ab7",
  "#c0afd0",
  "#d2c8dd",
  "#dfdce5",
  "#5d395f",
  "#7c5a7e",
  "#a785a7",
  "#c2a4c2",
  "#dac7da",
  "#e5dbe5",
  "#2f2f30",
  "#7d848b",
  "#a8aeb1",
  "#bec1c3",
  "#d4d8d7",
  "#656d73",
  "#90979b",
  "#b8bcbb",
  "#d3d5d3",
  "#dbdfe0",
  "#44484d",
  "#616669",
  "#7f8486",
  "#939899",
  "#a0a5a7",
  "#b0b5b5",
  "#c6caca",
  "#606e74",
  "#969a96",
  "#abb0ac",
  "#a5a9a8",
  "#c5c8c4",
  "#dad9d4",
  "#434341",
  "#636562",
  "#7f817e",
  "#939591",
  "#a7a8a2",
  "#bdbdb7",
  "#cbccc9",
  "#585858",
  "#7f7b73",
  "#b2ada4",
  "#beb9b0",
  "#cbc7bf",
  "#484c49",
  "#63655f",
  "#7c7d75",
  "#92948d",
  "#a3a7a0",
  "#b2b5af",
  "#c8cbc4",
  "#f2eac3",
  "#9e6b75",
  "#ae8087",
  "#c79ea2",
  "#dabdc1",
  "#e8d4d5",
  "#864c52",
  "#995d62",
  "#a87376",
  "#c39393",
  "#dcb6b5",
  "#ebd1cf",
  "#974953",
  "#ad5e65",
  "#ba7176",
  "#cf8a8d",
  "#e6bdbd",
  "#edd3d2",
  "#8e3738",
  "#b56966",
  "#c37f7a",
  "#cd8e89",
  "#ebcecb",
  "#7b3730",
  "#a0584f",
  "#bf796e",
  "#cd8e7f",
  "#e3b5a8",
  "#ebcfc3",
  "#83382a",
  "#a85e53",
  "#b57466",
  "#ce9382",
  "#e2b6a7",
  "#eacdc1",
  "#994b35",
  "#c1785c",
  "#d9987c",
  "#e4b9a2",
  "#edd2c0",
  "#a2583a",
  "#b46848",
  "#c47b5b",
  "#db9c7b",
  "#e5b99b",
  "#eccfbb",
  "#a6613c",
  "#c38058",
  "#d4966e",
  "#dba480",
  "#e0b392",
  "#ebccb3",
  "#cd8c5d",
  "#d69969",
  "#e3ab7b",
  "#e8be9b",
  "#edd0b6",
  "#b16a37",
  "#f0cb97",
  "#f3d9ba",
  "#b67d3c",
  "#c78538",
  "#d59858",
  "#e8b87f",
  "#edc38e",
  "#f2d5b0",
  "#ba7f38",
  "#cc9249",
  "#d69e59",
  "#ddac6d",
  "#edc796",
  "#a57955",
  "#ba8c64",
  "#cca683",
  "#e4caad",
  "#a4763c",
  "#c09056",
  "#efddc1",
  "#906a3a",
  "#ad8451",
  "#c19763",
  "#cba576",
  "#d2b084",
  "#dcbd92",
  "#e4ceac",
  "#9c7a56",
  "#b39167",
  "#ba9c75",
  "#c5aa85",
  "#cdb592",
  "#dbc7a8",
  "#996f32",
  "#aa803a",
  "#c99e53",
  "#d5b176",
  "#e1c28d",
  "#e9d6b0",
  "#9c7f41",
  "#b89b59",
  "#c2a462",
  "#d2ba83",
  "#dcc797",
  "#e4d0a5",
  "#7a6841",
  "#9d8344",
  "#b1975f",
  "#bea775",
  "#cbb584",
  "#ddcda6",
  "#655f2d",
  "#8d844d",
  "#9c9152",
  "#c4b47d",
  "#cfc291",
  "#dfd4b0",
  "#71713e",
  "#95945c",
  "#aeac7a",
  "#bbb98a",
  "#cbc99d",
  "#e0ddbd",
  "#576238",
  "#6d7645",
  "#88915d",
  "#9ba373",
  "#dbddbd",
  "#475842",
  "#60724f",
  "#8fa277",
  "#a3b48c",
  "#c5d1b2",
  "#dae2cd",
  "#42603c",
  "#5e7f57",
  "#75946b",
  "#8ba97f",
  "#b3cbaa",
  "#cfddc7",
  "#205134",
  "#537150",
  "#6c8867",
  "#98b092",
  "#acc2a8",
  "#c8d8c4",
  "#3d5541",
  "#61826c",
  "#7d9b89",
  "#91af9d",
  "#aac2b3",
  "#c6d5c9",
  "#2a4f43",
  "#547867",
  "#94b5a6",
  "#accabc",
  "#c4d9ce",
  "#124a42",
  "#476f65",
  "#7ea298",
  "#94b2a6",
  "#a8c1b7",
  "#bfd2c9",
  "#01554f",
  "#2e6864",
  "#518682",
  "#8caeab",
  "#a3c0bd",
  "#b4ccc9",
  "#c3d7d3",
  "#016367",
  "#3c797d",
  "#5c9598",
  "#7bb1b2",
  "#bedbd8",
  "#015a6b",
  "#217786",
  "#5b96a2",
  "#84b4be",
  "#b0d2d6",
  "#c7dfe0",
  "#175a6c",
  "#427584",
  "#68909d",
  "#88abb4",
  "#9fbbc3",
  "#c7d8db",
  "#015d75",
  "#2f778b",
  "#5b92a2",
  "#83afbc",
  "#9bbfc9",
  "#c5dce0",
  "#01455e",
  "#22657f",
  "#5389a1",
  "#85b0c4",
  "#a9c9d7",
  "#c2dae0",
  "#215772",
  "#43718b",
  "#6a8ea1",
  "#97b4c3",
  "#b3c9d3",
  "#506b84",
  "#6a8aa4",
  "#8ba7bb",
  "#b2c7d3",
  "#ced9dd",
  "#3b496d",
  "#6c7f9a",
  "#8595aa",
  "#99a7b8",
  "#cbd5db",
  "#3b3c5a",
  "#5d657b",
  "#757c91",
  "#99a0b2",
  "#bdc3cd",
  "#d6d9de",
  "#3e385a",
  "#645e77",
  "#7e778e",
  "#a29baa",
  "#c5c0c9",
  "#dad6db",
  "#7a6b85",
  "#9a8ca2",
  "#b0a3b6",
  "#d1c6d2",
  "#e0dadf",
  "#5f3f54",
  "#7e5a6d",
  "#8b6878",
  "#aa8e9a",
  "#cbb8c0",
  "#dbcfd4",
  "#665d57",
  "#6d6562",
  "#847b77",
  "#9e9793",
  "#ada8a5",
  "#cfcac7",
  "#48423c",
  "#dcd8d0",
  "#564537",
  "#6f6459",
  "#867a6f",
  "#aba39a",
  "#b9b2a9",
  "#ccc5bd",
  "#756861",
  "#a09287",
  "#b7ab9f",
  "#c1b6ab",
  "#d4ccc3",
  "#564536",
  "#716354",
  "#8a7a6a",
  "#a0907f",
  "#b1a290",
  "#c0b2a2",
  "#d1c7b8",
  "#4d3930",
  "#826f5e",
  "#917c6a",
  "#c5b6a4",
  "#cdbfb0",
  "#dbcebd",
  "#443735",
  "#755c48",
  "#a48d77",
  "#d8c4ae",
  "#443735",
  "#5f3d3f",
  "#76595d",
  "#907676",
  "#b89d9a",
  "#c9b0ab",
  "#d6c2be",
  "#5a3532",
  "#7a5f5a",
  "#a08882",
  "#b6a09a",
  "#c3b1ac",
  "#d7c8c2",
  "#5a382d",
  "#806257",
  "#a2877d",
  "#b8a196",
  "#c6b3a9",
  "#d6c8c0",
  "#5d3831",
  "#9c6e63",
  "#a8857a",
  "#cfb4a8",
  "#dbc7bd",
  "#694336",
  "#896656",
  "#ae8e7e",
  "#c1a392",
  "#d1b7a8",
  "#decabd",
  "#4f3426",
  "#715243",
  "#967a6a",
  "#a58c7b",
  "#bba595",
  "#cbb9ab",
  "#634533",
  "#785b47",
  "#8e725f",
  "#9c8373",
  "#b59f8f",
  "#d6c7b9",
  "#403330",
  "#7a6455",
  "#907865",
  "#a08e7e",
  "#b5a597",
  "#c2b4a7",
  "#d3c8bd",
  "#604c3d",
  "#785f4c",
  "#917864",
  "#a58f7b",
  "#b9a796",
  "#c6b5a7",
  "#d5c7ba",
  "#69482c",
  "#815d40",
  "#a3846c",
  "#bfa38d",
  "#cab3a0",
  "#dac8b8",
  "#65503d",
  "#947a62",
  "#bca38b",
  "#c9b29c",
  "#d7c5b3",
  "#765138",
  "#c5a88d",
  "#dcc7b3",
  "#b99974",
  "#cfb597",
  "#dcc7ad",
  "#70573f",
  "#9e8163",
  "#a78c71",
  "#baa185",
  "#c7b198",
  "#d7c5ae",
  "#695239",
  "#8f7659",
  "#a08568",
  "#c0ad96",
  "#cfbea9",
  "#dfd3c3",
  "#855d42",
  "#ab8b6e",
  "#caad87",
  "#dabe9e",
  "#e1cdae",
  "#f1dbbd",
  "#6e543c",
  "#867057",
  "#947f65",
  "#ccb79b",
  "#dacab2",
  "#786957",
  "#8e7f6a",
  "#a4947e",
  "#b8a992",
  "#c8bba3",
  "#d9cfba",
  "#9a815e",
  "#ac9571",
  "#b9a47e",
  "#c6b08a",
  "#d0ba94",
  "#e0cfb0",
  "#665439",
  "#877459",
  "#9f8e71",
  "#b19f80",
  "#cdbb9c",
  "#ddd0b6",
  "#5d513e",
  "#7e6f59",
  "#998970",
  "#ac9d83",
  "#c1ae91",
  "#cdbda2",
  "#5a5243",
  "#726b5b",
  "#b0ab9c",
  "#bfb9aa",
  "#d1cdbf",
  "#5e5949",
  "#898473",
  "#b2ac96",
  "#d1ccb9",
  "#4f523a",
  "#65684c",
  "#7f8266",
  "#acad97",
  "#bbbca7",
  "#cecebd",
  "#465448",
  "#626e60",
  "#7a8775",
  "#9fa694",
  "#bdc0b3",
  "#d1d3c7",
  "#4e5147",
  "#7b8070",
  "#95978a",
  "#abac9f",
  "#bebfb2",
  "#d1d0c6",
  "#64645a",
  "#7f7e72",
  "#949488",
  "#a6a69b",
  "#b6b5ab",
  "#c9c9c0",
  "#5e6259",
  "#7a8076",
  "#969c92",
  "#bec3bb",
  "#cdd2ca",
  "#343b36",
  "#5e706a",
  "#7c8e87",
  "#8d9e97",
  "#9baaa2",
  "#adbbb2",
  "#4a5d5f",
  "#5d7274",
  "#7a9192",
  "#8b9fa0",
  "#9bafb2",
  "#abbebf",
  "#c2cfcf",
  "#244653",
  "#607d84",
  "#80969d",
  "#96aab0",
  "#a4b7bd",
  "#bccbce",
  "#204652",
  "#536872",
  "#6f848c",
  "#90a0a6",
  "#a6b2b5",
  "#b6c3c4",
  "#cbd4d4",
  "#23383f",
  "#596368",
  "#91999c",
  "#a9b0b1",
  "#b8bebe",
  "#cdd2d2",
  "#32586e",
  "#4e7287",
  "#708d9e",
  "#8aa3b1",
  "#9eb4c0",
  "#b7c9d1",
  "#c9d9e0",
  "#2f3d4c",
  "#5d6f7f",
  "#768b9a",
  "#98a9b7",
  "#aabac6",
  "#bfc9d0",
  "#606b75",
  "#7a848d",
  "#979fa5",
  "#adb5b9",
  "#b8c0c3",
  "#cad0d2",
  "#605e63",
  "#7b787d",
  "#949194",
  "#bdb8b8",
  "#cfc9c8",
  "#443e40",
  "#676064",
  "#837d7f",
  "#989192",
  "#ada5a5",
  "#4a4653",
  "#5d5962",
  "#736f78",
  "#8f8a91",
  "#a6a3a9",
  "#b5b1b5",
  "#cbc9c9",
  "#4e4247",
  "#695c62",
  "#9d9093",
  "#afa7ac",
  "#bdb5b9",
  "#cec9cc",
  "#4e3132",
  "#6f5c5f",
  "#8b7c7e",
  "#b3a3a5",
  "#c1b2b3",
  "#d1c5c4",
  "#4d3c3c",
  "#6e615f",
  "#867875",
  "#9f9291",
  "#b1a3a1",
  "#c2b6b6",
  "#56433b",
  "#756761",
  "#8c7e78",
  "#ac9e97",
  "#bfb1aa",
  "#d1c5be",
  "#827466",
  "#9c8a79",
  "#a79582",
  "#b3a491",
  "#c4b7a5",
  "#5f4b3f",
  "#907d66",
  "#b7a48b",
  "#c0af97",
  "#dfd2bf",
  "#74685a",
  "#9e9284",
  "#ada295",
  "#bfb6aa",
  "#d1cbc1",
  "#4f4842",
  "#78736e",
  "#908a83",
  "#aca79e",
  "#bcb7ad",
  "#ccc9c0",
  "#54504a",
  "#6b645b",
  "#817a6e",
  "#979083",
  "#a8a093",
  "#cec6bb",
  "#645a4b",
  "#867e70",
  "#958d7f",
  "#cfcabd",
  "#7d745e",
  "#bcb099",
  "#cbc0ad",
  "#dbd0bb",
  "#f7f7f1",
  "#f5f2e9",
  "#f3eee3",
  "#eeece3",
  "#eeefea",
  "#edece6",
  "#e5e2da",
  "#e3ddd3",
  "#e3ded0",
  "#e5dfd2",
  "#e6dfd3",
  "#e2daca",
  "#dcd1bf",
  "#dcd2c3",
  "#dfd9cf",
  "#e3ded7",
  "#e2ded8",
  "#e7e2da",
  "#eeefeb",
  "#ecece7",
  "#f6f0e2",
  "#f0ece2",
  "#edeae0",
  "#f0eadc",
  "#efe8db",
  "#e8e2d4",
  "#e8dfca",
  "#f4e8d2",
  "#f2e3ca",
  "#f2e5cf",
  "#ede1ce",
  "#dccfba",
  "#e6dccd",
  "#e9decf",
  "#e9dcc6",
  "#e8dcc6",
  "#eadfc9",
  "#e2d3bf",
  "#e7d7c2",
  "#e9ebe7",
  "#f1eee6",
  "#f4efe5",
  "#f7efe3",
  "#f0ebe0",
  "#e3e4e1",
  "#dedfdc",
  "#d8e0df",
  "#e3e2d9",
  "#e2e0d6",
  "#e8e3d9",
  "#edeae5",
  "#eee9e0",
  "#e6ddd5",
  "#f2ece6",
  "#e7dbd3",
  "#edddca",
  "#f0e1d0",
  "#f3e9d7",
  "#efe8dd",
  "#cfcac7",
  "#ada8a5",
  "#847b77",
  "#6d6562",
  "#403330",
  "#c2b6b6",
  "#b1a3a1",
  "#867875",
  "#6e615f",
  "#4d3c3c",
  "#d1c5c4",
  "#c1b2b3",
  "#b3a3a5",
  "#8b7c7e",
  "#6f5c5f",
  "#4e3132",
  "#d6c2be",
  "#c9b0ab",
  "#b89d9a",
  "#907676",
  "#76595d",
  "#5f3d3f",
  "#d7c8c2",
  "#c3b1ac",
  "#b6a09a",
  "#7a5f5a",
  "#5a3532",
  "#d1c5be",
  "#bfb1aa",
  "#ac9e97",
  "#8c7e78",
  "#756761",
  "#56433b",
  "#d6c8c0",
  "#c6b3a9",
  "#b8a196",
  "#806257",
  "#5a382d",
  "#e7dbd3",
  "#dbc7bd",
  "#cfb4a8",
  "#9c6e63",
  "#5d3831",
  "#decabd",
  "#d1b7a8",
  "#c1a392",
  "#896656",
  "#694336",
  "#e6ddd5",
  "#cbb9ab",
  "#bba595",
  "#967a6a",
  "#715243",
  "#4f3426",
  "#d4ccc3",
  "#c1b6ab",
  "#b7ab9f",
  "#756861",
  "#4d3930",
  "#d3c8bd",
  "#c2b4a7",
  "#b5a597",
  "#907865",
  "#7a6455",
  "#5f4b3f",
  "#d6c7b9",
  "#b59f8f",
  "#8e725f",
  "#785b47",
  "#634533",
  "#dac8b8",
  "#cab3a0",
  "#bfa38d",
  "#815d40",
  "#69482c",
  "#d7c5b3",
  "#c9b29c",
  "#bca38b",
  "#947a62",
  "#65503d",
  "#e6dccd",
  "#d7c5ae",
  "#c7b198",
  "#baa185",
  "#9e8163",
  "#70573f",
  "#e4caad",
  "#cca683",
  "#ba8c64",
  "#a57955",
  "#e8dcc6",
  "#dbc7a8",
  "#cdb592",
  "#c5aa85",
  "#b39167",
  "#9c7a56",
  "#e9dcc6",
  "#e4ceac",
  "#dcbd92",
  "#d2b084",
  "#c19763",
  "#ad8451",
  "#906a3a",
  "#eadfc9",
  "#e0cfb0",
  "#d0ba94",
  "#c6b08a",
  "#ac9571",
  "#9a815e",
  "#e9decf",
  "#dacab2",
  "#ccb79b",
  "#947f65",
  "#867057",
  "#6e543c",
  "#d9cfba",
  "#c8bba3",
  "#b8a992",
  "#8e7f6a",
  "#786957",
  "#e8e2d4",
  "#cdbda2",
  "#c1ae91",
  "#998970",
  "#7e6f59",
  "#5d513e",
  "#d1ccb9",
  "#b2ac96",
  "#898473",
  "#5e5949",
  "#d1cdbf",
  "#bfb9aa",
  "#b0ab9c",
  "#726b5b",
  "#cecebd",
  "#bbbca7",
  "#acad97",
  "#7f8266",
  "#65684c",
  "#4f523a",
  "#e3e2d9",
  "#d1d0c6",
  "#bebfb2",
  "#abac9f",
  "#7b8070",
  "#4e5147",
  "#d1d3c7",
  "#bdc0b3",
  "#9fa694",
  "#7a8775",
  "#626e60",
  "#465448",
  "#c9c9c0",
  "#b6b5ab",
  "#a6a69b",
  "#7f7e72",
  "#64645a",
  "#cdd2ca",
  "#bec3bb",
  "#7a8076",
  "#5e6259",
  "#adbbb2",
  "#9baaa2",
  "#7c8e87",
  "#5e706a",
  "#343b36",
  "#c2cfcf",
  "#abbebf",
  "#9bafb2",
  "#7a9192",
  "#5d7274",
  "#4a5d5f",
  "#d8e0df",
  "#bccbce",
  "#a4b7bd",
  "#96aab0",
  "#607d84",
  "#244653",
  "#cdd2d2",
  "#b8bebe",
  "#a9b0b1",
  "#596368",
  "#23383f",
  "#dbdfe0",
  "#bfc9d0",
  "#aabac6",
  "#98a9b7",
  "#768b9a",
  "#5d6f7f",
  "#2f3d4c",
  "#cad0d2",
  "#b8c0c3",
  "#adb5b9",
  "#7a848d",
  "#606b75",
  "#e3e4e1",
  "#d4d8d7",
  "#bec1c3",
  "#a8aeb1",
  "#7d848b",
  "#2f2f30",
  "#cbc9c9",
  "#b5b1b5",
  "#a6a3a9",
  "#736f78",
  "#5d5962",
  "#4a4653",
  "#cec9cc",
  "#bdb5b9",
  "#afa7ac",
  "#695c62",
  "#4e4247",
  "#cfc9c8",
  "#bdb8b8",
  "#7b787d",
  "#605e63",
  "#dbcfd4",
  "#cbb8c0",
  "#aa8e9a",
  "#8b6878",
  "#7e5a6d",
  "#5f3f54",
  "#e8d4d5",
  "#dabdc1",
  "#c79ea2",
  "#9e6b75",
  "#ebd1cf",
  "#dcb6b5",
  "#c39393",
  "#995d62",
  "#864c52",
  "#edd3d2",
  "#e6bdbd",
  "#cf8a8d",
  "#ad5e65",
  "#974953",
  "#ebcecb",
  "#cd8e89",
  "#b56966",
  "#8e3738",
  "#ebcfc3",
  "#e3b5a8",
  "#cd8e7f",
  "#a0584f",
  "#7b3730",
  "#eacdc1",
  "#e2b6a7",
  "#ce9382",
  "#a85e53",
  "#83382a",
  "#edd2c0",
  "#e4b9a2",
  "#d9987c",
  "#c1785c",
  "#994b35",
  "#eccfbb",
  "#e5b99b",
  "#db9c7b",
  "#c47b5b",
  "#b46848",
  "#a2583a",
  "#edddca",
  "#ebccb3",
  "#e0b392",
  "#d4966e",
  "#c38058",
  "#a6613c",
  "#f0e1d0",
  "#edd0b6",
  "#e8be9b",
  "#d69969",
  "#cd8c5d",
  "#f3d9ba",
  "#f0cb97",
  "#f2e3ca",
  "#f2d5b0",
  "#edc38e",
  "#d59858",
  "#c78538",
  "#b67d3c",
  "#edc796",
  "#ddac6d",
  "#d69e59",
  "#cc9249",
  "#ba7f38",
  "#f0eadc",
  "#efddc1",
  "#c09056",
  "#a4763c",
  "#e9d6b0",
  "#e1c28d",
  "#c99e53",
  "#aa803a",
  "#996f32",
  "#e4d0a5",
  "#d2ba83",
  "#c2a462",
  "#b89b59",
  "#9c7f41",
  "#ddcda6",
  "#cbb584",
  "#b1975f",
  "#9d8344",
  "#7a6841",
  "#dfd4b0",
  "#cfc291",
  "#9c9152",
  "#8d844d",
  "#655f2d",
  "#e0ddbd",
  "#cbc99d",
  "#aeac7a",
  "#95945c",
  "#71713e",
  "#dbddbd",
  "#88915d",
  "#6d7645",
  "#576238",
  "#dae2cd",
  "#c5d1b2",
  "#a3b48c",
  "#60724f",
  "#475842",
  "#cfddc7",
  "#b3cbaa",
  "#8ba97f",
  "#5e7f57",
  "#42603c",
  "#c8d8c4",
  "#acc2a8",
  "#98b092",
  "#6c8867",
  "#537150",
  "#205134",
  "#c6d5c9",
  "#aac2b3",
  "#91af9d",
  "#61826c",
  "#3d5541",
  "#c4d9ce",
  "#accabc",
  "#94b5a6",
  "#547867",
  "#2a4f43",
  "#bfd2c9",
  "#a8c1b7",
  "#7ea298",
  "#476f65",
  "#124a42",
  "#c3d7d3",
  "#b4ccc9",
  "#8caeab",
  "#518682",
  "#2e6864",
  "#01554f",
  "#bedbd8",
  "#7bb1b2",
  "#5c9598",
  "#3c797d",
  "#016367",
  "#c7dfe0",
  "#b0d2d6",
  "#84b4be",
  "#5b96a2",
  "#217786",
  "#015a6b",
  "#c5dce0",
  "#83afbc",
  "#5b92a2",
  "#2f778b",
  "#015d75",
  "#c2dae0",
  "#a9c9d7",
  "#85b0c4",
  "#5389a1",
  "#22657f",
  "#01455e",
  "#b3c9d3",
  "#97b4c3",
  "#6a8ea1",
  "#43718b",
  "#215772",
  "#ced9dd",
  "#b2c7d3",
  "#8ba7bb",
  "#6a8aa4",
  "#506b84",
  "#cbd8e1",
  "#b2c8d8",
  "#8ea9c2",
  "#6b8ca9",
  "#4c6b8a",
  "#cbd5db",
  "#99a7b8",
  "#6c7f9a",
  "#3b496d",
  "#d6d9de",
  "#bdc3cd",
  "#99a0b2",
  "#757c91",
  "#5d657b",
  "#3b3c5a",
  "#dad6db",
  "#c5c0c9",
  "#a29baa",
  "#7e778e",
  "#645e77",
  "#3e385a",
  "#e0dadf",
  "#d1c6d2",
  "#b0a3b6",
  "#7a6b85",
  "#ebd1db",
  "#e3c0cf",
  "#cb9aad",
  "#b87e93",
  "#92576f",
  "#7c3655",
  "#d899b1",
  "#c47b95",
  "#a2566f",
  "#854158",
  "#f1d3da",
  "#efc0cb",
  "#e392a1",
  "#d47c8c",
  "#b04b63",
  "#99324e",
  "#f1d2d7",
  "#f0bcc9",
  "#f2d5d7",
  "#f0c1c6",
  "#ed939d",
  "#d66972",
  "#bb4b51",
  "#f1c6c4",
  "#f0b3b2",
  "#ed9190",
  "#d76c6e",
  "#a43834",
  "#f2ccc5",
  "#f0afa8",
  "#ee9489",
  "#d9766c",
  "#a13b34",
  "#f2d1c3",
  "#f2b8a7",
  "#e79580",
  "#d87b6a",
  "#b85444",
  "#f0d1c3",
  "#f3c1ab",
  "#e49780",
  "#dd7861",
  "#c65f47",
  "#b44b34",
  "#e2946f",
  "#d67c56",
  "#c4633e",
  "#f3d3bf",
  "#f3c1a3",
  "#f4d3b3",
  "#f4c69f",
  "#e6955f",
  "#cb7841",
  "#c36f3e",
  "#f4d4af",
  "#f5c894",
  "#efb57a",
  "#e69f5f",
  "#f5d6a9",
  "#f4bf77",
  "#ebad5e",
  "#df9938",
  "#f5deaf",
  "#fbcb78",
  "#f7be5b",
  "#f2af46",
  "#e39a33",
  "#f5e0b1",
  "#f6dda3",
  "#f5e5bc",
  "#f5d68f",
  "#eec25f",
  "#d6a02b",
  "#c48919",
  "#f3e8c2",
  "#f5e1ac",
  "#f7d78a",
  "#eac365",
  "#dbb04a",
  "#d1a436",
  "#c49832",
  "#eee3b2",
  "#e6d88e",
  "#d9c661",
  "#c4b146",
  "#ac9825",
  "#9c8b1f",
  "#e9e5b3",
  "#dad790",
  "#c4c476",
  "#b4b05a",
  "#847e35",
  "#c0d2ad",
  "#99c285",
  "#7fac6e",
  "#4f854a",
  "#2f5f3a",
  "#cce2ca",
  "#aed2b0",
  "#8ec298",
  "#68a678",
  "#245e36",
  "#d1e3d2",
  "#b7d7bf",
  "#8ac1a1",
  "#57aa80",
  "#016844",
  "#c0e3da",
  "#a1d4c8",
  "#70baa7",
  "#53a38f",
  "#368976",
  "#c1e6df",
  "#a1d5cb",
  "#75b9ae",
  "#3b8c80",
  "#c2e5e5",
  "#a7dcdc",
  "#6ec2c4",
  "#3aa9ae",
  "#01858b",
  "#017478",
  "#a6d0d6",
  "#7dc1cb",
  "#4da6b2",
  "#08808e",
  "#01717e",
  "#c6e3e8",
  "#a6d4de",
  "#71b8c7",
  "#34a3b6",
  "#016e85",
  "#b4e0e7",
  "#8fd0dd",
  "#56b5ca",
  "#01a0b8",
  "#01819e",
  "#016081",
  "#b7dfe8",
  "#a2d5e7",
  "#5db3d4",
  "#289ec4",
  "#017ca7",
  "#015d87",
  "#c3dfe8",
  "#b0d6e6",
  "#7db5d3",
  "#5a9ec0",
  "#2377a2",
  "#ccdbe5",
  "#b8cddd",
  "#97b3d0",
  "#7498be",
  "#4e739f",
  "#164576",
  "#d8dde6",
  "#a7b2d4",
  "#8b98c4",
  "#6572a5",
  "#3e4371",
  "#dfd9e4",
  "#d1cbdf",
  "#bdb4d4",
  "#968db8",
  "#716998",
  "#4d426e",
  "#dfdce5",
  "#d2c8dd",
  "#c0afd0",
  "#a18ab7",
  "#7e6596",
  "#624977",
  "#e5dbe5",
  "#dac7da",
  "#c2a4c2",
  "#a785a7",
  "#7c5a7e",
  "#5d395f",
  "#c35530",
  "#f5e1a6",
  "#fad97a",
  "#ffc723",
  "#f7e594",
  "#fed340",
  "#fecb01",
  "#edd26f",
  "#ddb835",
  "#cba901",
  "#3b373c",
  "#313031",
  "#f2ece6",
  "#eee9e0",
  "#efe8dd",
  "#e7e2da",
  "#edeae5",
  "#edece6",
  "#eeefea",
  "#e9ebe7",
  "#edeae0",
  "#e8e3d9",
  "#e5dfd2",
  "#e3ded0",
  "#efe8db",
  "#e2ded8",
  "#ccc9c0",
  "#bcb7ad",
  "#aca79e",
  "#908a83",
  "#78736e",
  "#4f4842",
  "#ccc5bd",
  "#b9b2a9",
  "#aba39a",
  "#867a6f",
  "#6f6459",
  "#564537",
  "#e3ded7",
  "#d1cbc1",
  "#bfb6aa",
  "#ada295",
  "#74685a",
  "#e3ddd3",
  "#d1c7b8",
  "#c0b2a2",
  "#b1a290",
  "#8a7a6a",
  "#716354",
  "#564536",
  "#e6dfd3",
  "#cec6bb",
  "#a8a093",
  "#817a6e",
  "#6b645b",
  "#54504a",
  "#e2e0d6",
  "#cfcabd",
  "#867e70",
  "#645a4b",
  "#c8cbc4",
  "#b2b5af",
  "#a3a7a0",
  "#7c7d75",
  "#63655f",
  "#484c49",
  "#dedfdc",
  "#cbccc9",
  "#bdbdb7",
  "#a7a8a2",
  "#7f817e",
  "#636562",
  "#434341",
  "#c6caca",
  "#b0b5b5",
  "#a0a5a7",
  "#7f8486",
  "#616669",
  "#44484d",
  "#ada5a5",
  "#837d7f",
  "#676064",
  "#443e40",
  "#f4efe5",
  "#f7efe3",
  "#9e9284",
  "#665d57",
  "#c4b7a5",
  "#b3a491",
  "#9c8a79",
  "#826f5e",
  "#cdbfb0",
  "#c5b6a4",
  "#a79582",
  "#827466",
  "#6e5f53",
  "#dbcebd",
  "#dfd2bf",
  "#d4c5ad",
  "#dcd1bf",
  "#c0af97",
  "#b7a48b",
  "#cbc0ad",
  "#bcb099",
  "#ac9d83",
  "#63523d",
  "#907d66",
  "#f0ece2",
  "#e2d3bf",
  "#f4e8d2",
  "#f3e9d7",
  "#f2e5cf",
  "#f6f0e2",
  "#e8dfca",
  "#dbd0bb",
  "#f3eee3",
  "#dcd2c3",
  "#e2daca",
  "#dccfba",
  "#dfd9cf",
  "#ede1ce",
  "#e7d7c2",
  "#72353d",
  "#813235",
  "#a42e37",
  "#b8473d",
  "#7c453d",
  "#903934",
  "#3e5063",
  "#b0b8b2",
  "#606e74",
  "#e5e2da",
  "#c0b9a9",
  "#aea594",
  "#c6c0b6",
  "#b2ada4",
  "#dad9d4",
  "#abb0ac",
  "#c5c8c4",
  "#a5a9a8",
  "#969a96",
  "#d3d5d3",
  "#b8bcbb",
  "#90979b",
  "#656d73",
  "#585858",
  "#48423c",
  "#e1cdae",
  "#cba97e",
  "#caad87",
  "#ac6b53",
  "#b0785c",
  "#b16a37",
  "#d8c4ae",
  "#b9b292",
  "#857c5d",
  "#7d745e",
  "#5a5243",
  "#bdc0a0",
  "#f7f7f1",
  "#ae8087",
  "#a87376",
  "#ba7176",
  "#c37f7a",
  "#bf796e",
  "#b57466",
  "#f2b88c",
  "#dba480",
  "#e3ab7b",
  "#e8b87f",
  "#eeb76b",
  "#fbd187",
  "#fedf94",
  "#fbd682",
  "#fbd073",
  "#f4c454",
  "#cba576",
  "#ba9c75",
  "#d5b176",
  "#dcc797",
  "#bea775",
  "#c4b47d",
  "#d2d083",
  "#abca99",
  "#78b185",
  "#9fcdb1",
  "#bbb98a",
  "#9ba373",
  "#8fa277",
  "#75946b",
  "#7d9b89",
  "#89c6b7",
  "#8ac5ba",
  "#92d0d0",
  "#97cbd2",
  "#8bc4d1",
  "#89c6df",
  "#94b2a6",
  "#a3c0bd",
  "#c7d8db",
  "#9fbbc3",
  "#88abb4",
  "#68909d",
  "#427584",
  "#175a6c",
  "#9bbfc9",
  "#bbc5de",
  "#8595aa",
  "#9a8ca2",
  "#a08882",
  "#a2877d",
  "#a8857a",
  "#ae8e7e",
  "#a58c7b",
  "#9c8373",
  "#a08e7e",
  "#d5c7ba",
  "#c6b5a7",
  "#b9a796",
  "#a58f7b",
  "#917864",
  "#785f4c",
  "#604c3d",
  "#a3846c",
  "#dcc7b3",
  "#c5a88d",
  "#765138",
  "#dcc7ad",
  "#cfb597",
  "#b99974",
  "#a78c71",
  "#dfd3c3",
  "#cfbea9",
  "#c0ad96",
  "#a08568",
  "#8f7659",
  "#695239",
  "#a4947e",
  "#b9a47e",
  "#ddd0b6",
  "#cdbb9c",
  "#b19f80",
  "#9f8e71",
  "#877459",
  "#665439",
  "#95978a",
  "#949488",
  "#969c92",
  "#8d9e97",
  "#8b9fa0",
  "#80969d",
  "#cbd4d4",
  "#b6c3c4",
  "#a6b2b5",
  "#90a0a6",
  "#6f848c",
  "#536872",
  "#204652",
  "#91999c",
  "#c9d9e0",
  "#b7c9d1",
  "#9eb4c0",
  "#8aa3b1",
  "#708d9e",
  "#4e7287",
  "#32586e",
  "#979fa5",
  "#949194",
  "#989192",
  "#8f8a91",
  "#9d9093",
  "#9f9291",
  "#939899",
  "#939591",
  "#92948d",
  "#dcd8d0",
  "#9e9793",
  "#a09287",
  "#979083",
  "#958d7f",
  "#a0907f",
  "#2b4360",
  "#234058",
  "#cbc6b7",
  "#aaa28b",
  "#dbd6b9",
  "#ffffff",
  "#292929",
  "#46423a",
  "#c6c2be",
  "#c4b499",
  "#f3f3f3",
  "#dccebe",
  "#3e3d40",
  "#5f251f",
  "#514432",
  "#eeece8",
  "#b1a698",
  "#00412d",
  "#454b4d",
  "#7b685a",
  "#9c8e7e",
  "#ededec",
  "#a8a6a2",
  "#c2b4a0",
  "#c2b4a0",
  "#554f49",
  "#030303",
  "#a59989",
  "#fefffc",
  "#3e2d0f",
  "#776154",
  "#7e8285",
  "#ffffff",
  "#40190a",
  "#a09174",
  "#c9c6b5",
  "#fcecd2",
  "#e8dccd",
  "#d5c8b0",
  "#2c2b2a",
  "#593033",
  "#f4f6f7",
  "#743d36",
  "#d3cdbd",
  "#2c4452",
  "#9d9388",
  "#beae99",
  "#a1917f",
  "#a49789",
  "#fdf1d4",
  "#e2cca9",
  "#513c35",
  "#3c574b",
  "#cabb9f",
  "#bdbebf",
  "#e5e3d2",
  "#16363f",
  "#254035",
  "#3b3837",
  "#d1d2d4",
  "#f7f3e4",
  "#d3c5ad",
  "#fff6e4",
  "#e0c5a1",
  "#c6b09a",
  "#4c4846",
  "#587278",
  "#f5f5f4",
  "#f5faf2",
  "#c1ae9a",
  "#602c30",
  "#f5eace",
  "#212121",
  "#4b392f",
  "#e0d6bd",
  "#2d4e43",
  "#bbac97",
  "#656158",
  "#f8fcff",
  "#63574c",
  "#8d9093",
  "#5e6567",
  "#925f42",
  "#cccec8",
  "#a5a8a3",
  "#f6f1e6",
  "#c0c7bc",
  "#efe9e0",
  "#fff3d1",
  "#a7aa9e",
  "#a4aaad",
  "#5a5850",
  "#a59c87",
  "#63554f",
  "#b5a091",
  "#8d9484",
  "#948671",
  "#798689",
  "#e2e3e4",
  "#9aa29b",
  "#567d96",
  "#c2b59b",
  "#9ab5c6",
  "#4f5736",
  "#a99573",
  "#343c44",
  "#baaf9b",
  "#534f4e",
  "#98afc1",
  "#c06050",
  "#edeee6",
  "#51605b",
  "#c6b89e",
  "#74676e",
  "#747c65",
  "#616161",
  "#e98b43",
  "#a1965c",
  "#dccaa2",
  "#736f66",
  "#7e6958",
  "#3d5847",
  "#f5cf46",
  "#9f978c",
  "#c3914c",
  "#8d473d",
  "#aca39c",
  "#a1a29d",
  "#41504d",
  "#8f6b51",
  "#6a7780",
  "#ebe2d3",
  "#675e59",
  "#4a494e",
  "#544645",
  "#e5e5e3",
  "#9c8a74",
  "#98887b",
  "#6f4b4b",
  "#e1dbcb",
  "#a79b8d",
  "#ac393e",
  "#70403e",
  "#e6e6de",
  "#00639c",
  "#e9c66c",
  "#3e3e3e",
  "#455f6e",
  "#c6bdac",
  "#0b8a93",
  "#414f69",
  "#f3dfc6",
  "#12221d",
  "#60605e",
  "#422b19",
  "#a29788",
  "#66685e",
  "#f0efee",
  "#ada590",
  "#52504d",
  "#567d96",
  "#934f45",
  "#6b7669",
  "#616c64",
  "#36393a",
  "#e6e7d8",
  "#832930",
  "#b23643",
  "#aa5154",
  "#c23f4b",
  "#d86165",
  "#4d3f33",
  "#52463b",
  "#6a4e36",
  "#70563e",
  "#7f5832",
  "#956133",
  "#986735",
  "#906a46",
  "#a96b2b",
  "#c07722",
  "#c27b2e",
  "#ce8121",
  "#d88a30",
  "#e09851",
  "#e6a96f",
  "#c5b5a7",
  "#dfc6b0",
  "#d8cbc0",
  "#ecdbcd",
  "#f0e8df",
  "#efe5dc",
  "#efe4da",
  "#f1e4d7",
  "#f4e5d7",
  "#b4cbd9",
  "#005e63",
  "#2d3d33",
  "#97d5b1",
  "#9d4f84",
  "#603231",
  "#86252b",
  "#eb8621",
  "#f2ece5",
  "#e1e7ea",
  "#008c5d",
  "#bdbbda",
  "#d185b7",
  "#862a2e",
  "#dca29e",
  "#7c2829",
  "#d4c5b6",
  "#dfd0c2",
  "#e1cfbe",
  "#f2e6db",
  "#67a0c1",
  "#a1c9e3",
  "#bee1e2",
  "#eeefe8",
  "#dbd8e7",
  "#867e7d",
  "#b97a77",
  "#eae8e5",
  "#d9974c",
  "#e3901a",
  "#aacce3",
  "#9390be",
  "#722f2e",
  "#b83944",
  "#f3951b",
  "#fea93a",
  "#f9d1aa",
  "#83a8c1",
  "#c7d9e3",
  "#e2e5e6",
  "#086845",
  "#008356",
  "#a6272f",
  "#8a7662",
  "#ffa405",
  "#b2d1e7",
  "#19563e",
  "#3c3a48",
  "#bf7aa4",
  "#99282c",
  "#be5b59",
  "#98b6cb",
  "#d9dad8",
  "#717366",
  "#838a65",
  "#94968a",
  "#9aa07d",
  "#dbd7d5",
  "#d4bea8",
  "#e6d9cc",
  "#ede1d5",
  "#f6e5d4",
  "#fae7d3",
  "#585568",
  "#84747c",
  "#6b3136",
  "#a1876a",
  "#dda667",
  "#ffaf3e",
  "#eebf8b",
  "#25485c",
  "#005476",
  "#006392",
  "#006b9b",
  "#6c97b3",
  "#95a7b4",
  "#b8c4cc",
  "#a9cce6",
  "#d7dde1",
  "#e8eae9",
  "#e8eae9",
  "#386a6d",
  "#308a91",
  "#699093",
  "#88abad",
  "#6ab1b6",
  "#63b3b9",
  "#98b9bb",
  "#90ccd0",
  "#89ced2",
  "#acd6d8",
  "#9fd8db",
  "#c6e1e1",
  "#dcedec",
  "#207856",
  "#41795f",
  "#757e78",
  "#009461",
  "#41aa7d",
  "#1cad78",
  "#9da5a0",
  "#8cac9b",
  "#5fc094",
  "#83c7a5",
  "#a5c1b2",
  "#8ad3af",
  "#c0d7c8",
  "#d5dad5",
  "#b4e5ca",
  "#c7e8d4",
  "#e6eae4",
  "#ddebdf",
  "#d2eddb",
  "#63664f",
  "#72813a",
  "#8d9275",
  "#a3ac74",
  "#98b33e",
  "#afc657",
  "#b7c292",
  "#d9dcb8",
  "#d6e0a0",
  "#dfe6b7",
  "#e8e9dc",
  "#e7e7d1",
  "#eaf0d3",
  "#444258",
  "#534f74",
  "#66656d",
  "#6f6c81",
  "#6c698d",
  "#81808b",
  "#8c8b95",
  "#9c98b6",
  "#bebacf",
  "#d1d1d6",
  "#d4d1df",
  "#dddbdc",
  "#e9e8e8",
  "#54414c",
  "#82516f",
  "#7d596e",
  "#a25a85",
  "#a8658c",
  "#977287",
  "#c1669d",
  "#b195a4",
  "#c29aaf",
  "#cb94b3",
  "#cdb9c3",
  "#c8c1c4",
  "#d6bbc9",
  "#d5cecf",
  "#ded1d5",
  "#e1d1d7",
  "#dfdbda",
  "#e2dcdc",
  "#eae8e5",
  "#eee8e8",
  "#783c3a",
  "#8f6360",
  "#de8e89",
  "#d59b96",
  "#ceb2af",
  "#c9bfbd",
  "#ecccc8",
  "#ece7e3",
  "#54473b",
  "#6b5137",
  "#6d5539",
  "#825e39",
  "#6e6256",
  "#7c6a55",
  "#b0752d",
  "#9c7851",
  "#ab804f",
  "#c88326",
  "#c88626",
  "#ab9279",
  "#d19038",
  "#c59967",
  "#e39931",
  "#c9a887",
  "#bab3ac",
  "#e8a553",
  "#c2b6a9",
  "#ebae62",
  "#ccb9a4",
  "#c5bfb9",
  "#d7bea3",
  "#e9bd8e",
  "#f2c89b",
  "#e3d1bf",
  "#e8d3bd",
  "#f1d6ba",
  "#f5d6b5",
  "#e7dbd0",
  "#f6d8b8",
  "#ebdccc",
  "#f3dec8",
  "#f9dbbd",
  "#efe9e1",
  "#f4e8da",
  "#006b9f",
  "#57a3d1",
  "#64907a",
  "#575a4c",
  "#ecede7",
  "#9a8b92",
  "#b4aaae",
  "#ba9a77",
  "#e19000",
  "#f6cea2",
  "#ffcf95",
  "#f6e0c9",
  "#fae0c3",
  "#f2ebe3",
  "#9a9ea0",
  "#e0eaef",
  "#d6e8e8",
  "#025e42",
  "#4f5342",
  "#a3a793",
  "#6f68a4",
  "#bcb7d5",
  "#603250",
  "#c1aca9",
  "#c9ae91",
  "#fdba61",
  "#b9e3e5",
  "#b9bfa7",
  "#e1e2dd",
  "#9693a1",
  "#5e354c",
  "#744962",
  "#edd3df",
  "#ede4e2",
  "#fbbd71",
  "#6cabd6",
  "#b0c4d3",
  "#a8dee2",
  "#565c43",
  "#dde3cb",
  "#b2afbb",
  "#7d3761",
  "#863b67",
  "#e1a5c3",
  "#91302c",
  "#fbb758",
  "#efc89b",
  "#f5eee5",
  "#106086",
  "#457697",
  "#afc3b9",
  "#8b81ba",
  "#d4cfe3",
  "#ae7995",
  "#bf9b6e",
  "#d8b081",
  "#d7c1a8",
  "#e1d4c6",
  "#007cb6",
  "#858585",
  "#7e8d99",
  "#0096a2",
  "#0098a4",
  "#809158",
  "#a2ca48",
  "#d0d4c3",
  "#625894",
  "#a79dc8",
  "#d8d5e0",
  "#dddae4",
  "#5f5654",
  "#b02826",
  "#c33a38",
  "#f5dfdb",
  "#f8dcbb",
  "#eae4db",
  "#314655",
  "#9ac2e2",
  "#cfdbe5",
  "#e0e4e8",
  "#004c52",
  "#20adb8",
  "#8cd5dc",
  "#94aca0",
  "#858a77",
  "#d4d4d2",
  "#915d79",
  "#a23530",
  "#d8c5c1",
  "#6c6965",
  "#edd0ae",
  "#f1e1cf",
  "#63707b",
  "#58748b",
  "#b3cade",
  "#687152",
  "#95a969",
  "#493f6c",
  "#453432",
  "#e18479",
  "#f7aca1",
  "#f3deda",
  "#f3e7e4",
  "#53bfcb",
  "#96d6dd",
  "#ced4be",
  "#f1dee6",
  "#af332e",
  "#bd2f2c",
  "#dfcfcc",
  "#6f614f",
  "#feab13",
  "#d2cabf",
  "#fdd29b",
  "#3d454d",
  "#86ad3d",
  "#8eaf54",
  "#634f35",
  "#765935",
  "#8b7a66",
  "#987b54",
  "#b37f28",
  "#978064",
  "#b5812e",
  "#af8136",
  "#c88a28",
  "#998c7c",
  "#a09180",
  "#aa906f",
  "#c38d38",
  "#d79413",
  "#ab9e8e",
  "#bd9f7b",
  "#b3a18c",
  "#dd9c2c",
  "#c5aa88",
  "#bcad9a",
  "#e5aa53",
  "#dcb481",
  "#cdbba6",
  "#d9c1a2",
  "#d1c5b7",
  "#d6c7b5",
  "#dac8b2",
  "#e5cdaf",
  "#efc898",
  "#dbcfc0",
  "#eed0ac",
  "#e0d1bf",
  "#e4d2bc",
  "#e8d4bc",
  "#e4dbd0",
  "#efdfcb",
  "#f5dfc4",
  "#efe8df",
  "#f1e8dc",
  "#4e5b66",
  "#a1c0dc",
  "#b0b0af",
  "#269d78",
  "#728c42",
  "#749639",
  "#b34f83",
  "#d486ac",
  "#973e34",
  "#e3cfcb",
  "#f6d6cf",
  "#786d60",
  "#b0a290",
  "#d7a762",
  "#fcbb58",
  "#efe7dc",
  "#fae8d1",
  "#234760",
  "#d2dcbf",
  "#b9483c",
  "#eea197",
  "#a79278",
  "#ffba35",
  "#fee1bc",
  "#c7d8e6",
  "#83c5ce",
  "#605088",
  "#e1dfe4",
  "#6f3b33",
  "#7e3c33",
  "#dca440",
  "#eab45d",
  "#ffba1f",
  "#f7ebdc",
  "#87b1d5",
  "#e9eed7",
  "#d3d0d6",
  "#ac833f",
  "#c39e67",
  "#f6e5d0",
  "#37919d",
  "#164b3c",
  "#cb983b",
  "#c5af92",
  "#f8af1c",
  "#f1aa4a",
  "#cebea8",
  "#f3ba6f",
  "#f1c184",
  "#ffd090",
  "#ede1d0",
  "#fbdcae",
  "#f5e1be",
  "#f5e6d1",
  "#f4e7ce",
  "#4f5050",
  "#59796c",
  "#c5de9e",
  "#92486c",
  "#e3dbdc",
  "#b05446",
  "#e16f5f",
  "#dfb778",
  "#e5dfd7",
  "#fadbaf",
  "#105444",
  "#7d7d7c",
  "#deebe5",
  "#cc6552",
  "#e16553",
  "#f5cac1",
  "#e8e3dc",
  "#274c68",
  "#184c6e",
  "#004e76",
  "#005b8e",
  "#1d567c",
  "#3a698d",
  "#57718a",
  "#4883b0",
  "#6790b3",
  "#90969c",
  "#769dc2",
  "#9bb6d1",
  "#bdbfc0",
  "#b2c2d5",
  "#cbcdcc",
  "#c3cfda",
  "#c2d0df",
  "#d6dde5",
  "#e9e9e9",
  "#e8eaeb",
  "#00565f",
  "#39595f",
  "#006e7b",
  "#007585",
  "#4b7278",
  "#008897",
  "#62868b",
  "#49a7b5",
  "#85a6ab",
  "#adc9cc",
  "#bdd1d3",
  "#b3d7db",
  "#d6dad7",
  "#d1dedf",
  "#c9dddd",
  "#c4e1e4",
  "#c8e6e9",
  "#47524d",
  "#1c5c4a",
  "#517367",
  "#007c5c",
  "#008763",
  "#008466",
  "#008e6b",
  "#669887",
  "#5da78f",
  "#31b592",
  "#65b59a",
  "#8cbcab",
  "#8bc2ae",
  "#b8bbb9",
  "#80d2b6",
  "#95cfba",
  "#a9d0c1",
  "#abd5c5",
  "#d7d9d6",
  "#ace3cd",
  "#c9e1d5",
  "#c4e3d6",
  "#c4e6d7",
  "#e5eae5",
  "#dbeee5",
  "#d9ede3",
  "#d2ebde",
  "#465439",
  "#53594c",
  "#506436",
  "#5b6c42",
  "#5b7638",
  "#647d43",
  "#648637",
  "#75845d",
  "#8b9973",
  "#919f72",
  "#a4a7a1",
  "#86b34f",
  "#a2ae8e",
  "#afbe9b",
  "#aac089",
  "#c1c2bd",
  "#b2cf89",
  "#bfd1a3",
  "#c4cfb0",
  "#b9d594",
  "#d2e0bb",
  "#dbddd2",
  "#d9e1cc",
  "#d4e6b6",
  "#e0e1dc",
  "#e6eadd",
  "#e5ebd5",
  "#e3ecce",
  "#5a4d70",
  "#5f507a",
  "#655a7b",
  "#70677f",
  "#7d6d99",
  "#83769b",
  "#8a8692",
  "#9a95a6",
  "#a398b4",
  "#a09da7",
  "#b8b5bc",
  "#beb9c5",
  "#c3bace",
  "#c4c1c6",
  "#d1cfd3",
  "#d8d2e0",
  "#dcdbdb",
  "#dedbde",
  "#e0dde1",
  "#6a4253",
  "#7d395a",
  "#834662",
  "#a14c72",
  "#856772",
  "#a86d86",
  "#bb7191",
  "#a48c95",
  "#b88599",
  "#cb9db0",
  "#d8b6c3",
  "#e9b9ca",
  "#e5ced4",
  "#e8dadd",
  "#ebe5e5",
  "#5e3b34",
  "#7c3b31",
  "#713e34",
  "#823f33",
  "#79493f",
  "#71554e",
  "#8b4c3f",
  "#7c625c",
  "#b54131",
  "#88625a",
  "#93645b",
  "#cf4d3d",
  "#ca5b4a",
  "#a78a84",
  "#b18b83",
  "#de8f7f",
  "#b4a4a0",
  "#e19b8d",
  "#c4b1ac",
  "#e3b3a8",
  "#d4ccc9",
  "#d8ccc8",
  "#e9ccc5",
  "#eeccc4",
  "#e6dad6",
  "#ede6e2",
  "#efe7e2",
  "#f2e6e2",
  "#3f3934",
  "#52483b",
  "#645239",
  "#745d36",
  "#7f6948",
  "#7d7974",
  "#8a7455",
  "#9e782e",
  "#967d54",
  "#948062",
  "#9f8662",
  "#9d8b70",
  "#c89319",
  "#b4986d",
  "#b29c7d",
  "#bba17b",
  "#dba000",
  "#bcae9a",
  "#b7b3ac",
  "#e2ac39",
  "#c3b198",
  "#c6baa8",
  "#ccbda6",
  "#cec5b6",
  "#d9c3a4",
  "#d3c6b4",
  "#dacab3",
  "#e6caa1",
  "#dfccb1",
  "#f0cb90",
  "#e4cfb1",
  "#ddd7cd",
  "#efd5ae",
  "#ffce7d",
  "#e2d8c9",
  "#e9d8be",
  "#dedcd7",
  "#f0dec2",
  "#f4ddbe",
  "#e6e1d8",
  "#ede3d5",
  "#f0e3d2",
  "#f3e5ce",
  "#ede8df",
  "#ece9e2",
  "#446a8b",
  "#005765",
  "#878888",
  "#be5385",
  "#eda798",
  "#f7e7e3",
  "#005482",
  "#8699ad",
  "#bee2e7",
  "#a1c777",
  "#e6a7be",
  "#e58a77",
  "#b4ceeb",
  "#6bb7c4",
  "#f1d5dd",
  "#beb4b1",
  "#ffcf6e",
  "#ffd997",
  "#d8e7e9",
  "#d7ebe3",
  "#a19b98",
  "#b68d2c",
  "#f5b700",
  "#f9c13b",
  "#fbd388",
  "#f2debe",
  "#fbe3bd",
  "#38b9cd",
  "#f1bc59",
  "#efc076",
  "#ecdfca",
  "#fadeaa",
  "#f5efe5",
  "#91b5d8",
  "#e7f1ec",
  "#616160",
  "#f5d8e1",
  "#dbc399",
  "#0095ac",
  "#c99c1d",
  "#c39e4b",
  "#ffc100",
  "#fadaa1",
  "#ece2d1",
  "#cbd8e6",
  "#00a1b8",
  "#61933a",
  "#675f6d",
  "#676162",
  "#ae5138",
  "#d89683",
  "#e9dbc5",
  "#fadeae",
  "#f6ebd8",
  "#e4e8ec",
  "#00879e",
  "#d6e8c6",
  "#41393b",
  "#874531",
  "#e7b523",
  "#c4bdb0",
  "#fad587",
  "#eddab9",
  "#eae0cd",
  "#f4e9d6",
  "#ede8dd",
  "#f5e5c7",
  "#e7e9eb",
  "#517933",
  "#ad94c2",
  "#bca5cc",
  "#cdc2c4",
  "#f4d9d0",
  "#afa490",
  "#b7a78c",
  "#cea127",
  "#daa937",
  "#deb349",
  "#ebbd51",
  "#ffc700",
  "#ddd3c2",
  "#e4d0ab",
  "#e2d5c0",
  "#ffd04a",
  "#e6d7bd",
  "#e3ddd2",
  "#f3dcb4",
  "#f9dfad",
  "#ebe8e1",
  "#efe9df",
  "#f4e9d7",
  "#f5e8d2",
  "#f6e7cd",
  "#f7e6ca",
  "#b1dccf",
  "#85689e",
  "#9477ac",
  "#a185b7",
  "#e7e0d3",
  "#efe8d9",
  "#4181ba",
  "#005345",
  "#435736",
  "#74568c",
  "#7f7685",
  "#c8b7d6",
  "#d6c8de",
  "#a77987",
  "#f39578",
  "#f7c631",
  "#f4e9d4",
  "#f5ebd9",
  "#d5e1e2",
  "#569532",
  "#523b64",
  "#4e4653",
  "#b8537b",
  "#fbcb3b",
  "#f8cd6a",
  "#fed56a",
  "#f7da99",
  "#ebe6da",
  "#b2c1d7",
  "#bbcee3",
  "#384340",
  "#006755",
  "#937b3c",
  "#ceccc3",
  "#ddd6c9",
  "#e3d5bb",
  "#f5e9d4",
  "#eee9de",
  "#f6ebd3",
  "#3573ab",
  "#7ca4d3",
  "#e0e6e1",
  "#e7eae4",
  "#ddeed2",
  "#794532",
  "#f6e3db",
  "#847558",
  "#e6c780",
  "#f7c500",
  "#e8cc8d",
  "#faca35",
  "#f6cf6c",
  "#f8d483",
  "#ffd571",
  "#ffdc8c",
  "#f1e7d3",
  "#f3e8d4",
  "#f6e8cf",
  "#f8e8c9",
  "#fce5b4",
  "#9fd5e2",
  "#00aa8f",
  "#518439",
  "#864833",
  "#f8cec0",
  "#c3bdb0",
  "#daccb0",
  "#d4deee",
  "#a0d6e3",
  "#8ed3c2",
  "#54494b",
  "#d97a99",
  "#e3b6c2",
  "#806c65",
  "#d6c9ad",
  "#f2ede3",
  "#8599b4",
  "#b2c5df",
  "#7fcadb",
  "#007f6e",
  "#4e3a34",
  "#57453e",
  "#d06740",
  "#625841",
  "#665936",
  "#ffd967",
  "#fee39f",
  "#60666c",
  "#5c7291",
  "#a3bada",
  "#c9cfd8",
  "#bcbdbb",
  "#dee2e0",
  "#ae486d",
  "#c199a3",
  "#e7a8ba",
  "#e16233",
  "#f1bca9",
  "#c4ae73",
  "#d1be8e",
  "#f2d486",
  "#e9ddc4",
  "#1c3753",
  "#1c4b75",
  "#626f83",
  "#4d73a1",
  "#718eb4",
  "#8fa6c6",
  "#9db1d0",
  "#b9c1cd",
  "#d7dbe1",
  "#e9e9e7",
  "#245d6a",
  "#3a5e67",
  "#00839d",
  "#547c87",
  "#338193",
  "#519bad",
  "#009fbe",
  "#7f9da5",
  "#49b6ce",
  "#9ab4ba",
  "#83b8c5",
  "#b0d3db",
  "#c9d1d2",
  "#d9dedf",
  "#c1e3ea",
  "#dbe1e1",
  "#d0e4e8",
  "#2d3d39",
  "#1f564c",
  "#4b9c8c",
  "#aad4c8",
  "#c6d1cd",
  "#b9ded3",
  "#b2e5d8",
  "#d5ddd8",
  "#cae3db",
  "#cfede3",
  "#e7eae6",
  "#e5e9e4",
  "#e2ece6",
  "#3e4e39",
  "#527143",
  "#497839",
  "#65775b",
  "#6c895b",
  "#7c8d74",
  "#87ac72",
  "#74b559",
  "#a5b29c",
  "#9bb68c",
  "#93c87b",
  "#a5c295",
  "#b3caa6",
  "#c9d3c3",
  "#c8d6c1",
  "#c6debb",
  "#c1e1b2",
  "#dadbd6",
  "#d7dfd1",
  "#d5e2cb",
  "#d2e7c3",
  "#e5e9df",
  "#e3ebdd",
  "#55455e",
  "#624b6e",
  "#675c6d",
  "#867091",
  "#a493ac",
  "#a29ba6",
  "#bcb6bd",
  "#c6b9ca",
  "#d8d0d9",
  "#ddd2df",
  "#dfdbdd",
  "#e0dde0",
  "#e9e7e6",
  "#734150",
  "#8a3f59",
  "#aa516f",
  "#976876",
  "#cc6487",
  "#9f9899",
  "#c68597",
  "#dba9b6",
  "#d0b5bb",
  "#c4c0c0",
  "#e3c1c9",
  "#decdd0",
  "#dddad8",
  "#e7dadb",
  "#ece9e7",
  "#efe6e5",
  "#f0e7e7",
  "#5e3e32",
  "#724232",
  "#994c33",
  "#9a5238",
  "#7f6359",
  "#857873",
  "#b86c51",
  "#dd7b59",
  "#beb1ab",
  "#e5b4a3",
  "#cdcbc9",
  "#dbccc6",
  "#e3ccc3",
  "#eacdc2",
  "#ded9d5",
  "#e5d9d4",
  "#f4d8ce",
  "#efd8cf",
  "#f0e0d9",
  "#eae8e5",
  "#ede8e4",
  "#eee6e2",
  "#efe7e3",
  "#f0e5de",
  "#bc9e36",
  "#e0ba25",
  "#ebc65d",
  "#e2cb8f",
  "#efd077",
  "#f2dcaa",
  "#f0e1bf",
  "#f8e1b2",
  "#ebe7de",
  "#f3e7ce",
  "#f6e5c3",
  "#1c5789",
  "#628cc0",
  "#3c6158",
  "#c9b1a8",
  "#f3e3da",
  "#efc900",
  "#e3ddcf",
  "#fee089",
  "#ede6d8",
  "#f4ead1",
  "#37465c",
  "#39afc9",
  "#a55e43",
  "#ca5322",
  "#cbc0a7",
  "#fdd84f",
  "#f9e8bc",
  "#f7ecd5",
  "#9e9f9e",
  "#50c7b3",
  "#efe7e7",
  "#b25431",
  "#968550",
  "#e7e1d4",
  "#f2e7cc",
  "#fde39f",
  "#9ca5b6",
  "#cbd3e2",
  "#87cee2",
  "#646967",
  "#a9b7b3",
  "#e6e2e6",
  "#743347",
  "#eca8b9",
  "#675750",
  "#ae684a",
  "#7f7b73",
  "#b7b2a4",
  "#d3cdbe",
  "#f8d02e",
  "#c3e1e9",
  "#78beb1",
  "#942d52",
  "#f2d6da",
  "#f37c4b",
  "#ede4de",
  "#233f61",
  "#008dac",
  "#e2e7e7",
  "#90ddcd",
  "#bee9de",
  "#63406e",
  "#f0ede4",
  "#6d9464",
  "#efbfc9",
  "#af7f6b",
  "#b48d7c",
  "#f3eddd",
  "#165f9c",
  "#f4a481",
  "#e1dac7",
  "#f7e9c5",
  "#368631",
  "#dbb6a6",
  "#f4d1c1",
  "#007c9a",
  "#48877d",
  "#d8e8e3",
  "#3f3e3e",
  "#dec7cb",
  "#503e37",
  "#674332",
  "#ae562d",
  "#be6b44",
  "#a18c82",
  "#a09591",
  "#d8967b",
  "#e5906a",
  "#b5a49d",
  "#efb499",
  "#f2cebe",
  "#eddad1",
  "#edeae6",
  "#ede8e3",
  "#efe8e2",
  "#f0e7e1",
  "#f2e2d9",
  "#9f8b33",
  "#9e967e",
  "#b0993f",
  "#c4a91b",
  "#cbb132",
  "#d9b500",
  "#ecc722",
  "#f3d15b",
  "#efd886",
  "#e8d8ac",
  "#f3de9c",
  "#f7df96",
  "#f6e2a9",
  "#f4e7c8",
  "#f4e6c0",
  "#6d8dbe",
  "#cbd7da",
  "#1c4741",
  "#4f514d",
  "#496343",
  "#f6b99d",
  "#f3c0a9",
  "#b7a44b",
  "#f6eccc",
  "#f4f0e4",
  "#f6edd1",
  "#52774d",
  "#4d4a4a",
  "#7c503a",
  "#a75b34",
  "#857a74",
  "#978953",
  "#fce99c",
  "#e6e9e3",
  "#b5506b",
  "#e0899c",
  "#d4692e",
  "#eea986",
  "#d5bf19",
  "#f1e4b8",
  "#e7e4d9",
  "#9cb2df",
  "#d7e5ea",
  "#bc93c1",
  "#d5bad8",
  "#9d3352",
  "#4f4e49",
  "#b3a236",
  "#aaa48f",
  "#d5d1c2",
  "#ece9dc",
  "#f4eac6",
  "#00779b",
  "#dcc5dd",
  "#6c4e3e",
  "#f17831",
  "#9a8b30",
  "#ecd461",
  "#ecd96a",
  "#ecdb8b",
  "#ebe4cc",
  "#efead6",
  "#f0eee5",
  "#f6f1de",
  "#f6f2e5",
  "#b4dcea",
  "#e6ced0",
  "#c2886b",
  "#f7eab3",
  "#f7ebbd",
  "#f5efd7",
  "#4e6185",
  "#e3dee2",
  "#cdc0b9",
  "#efdcd2",
  "#ccbc37",
  "#f2efe5",
  "#f7eed4",
  "#a9c4bf",
  "#e56e27",
  "#6f6845",
  "#f7eaa5",
  "#677dad",
  "#d3e5e9",
  "#83c385",
  "#e68d5a",
  "#354e76",
  "#707992",
  "#898d9b",
  "#8998bc",
  "#979fb2",
  "#a3a7b1",
  "#a6afc8",
  "#b1b6c4",
  "#bec2c9",
  "#ccced3",
  "#ced1d9",
  "#ced3e3",
  "#dadbdc",
  "#dbdde0",
  "#dbdce1",
  "#e8e8eb",
  "#2f454d",
  "#0c5c70",
  "#006b88",
  "#0a6c84",
  "#008fb5",
  "#829096",
  "#20a1c3",
  "#599fb7",
  "#9daaae",
  "#5db2cf",
  "#94b5c2",
  "#8dbdcf",
  "#9ac5d5",
  "#b0ced9",
  "#b5d7e2",
  "#c1dde7",
  "#bbdde9",
  "#005d56",
  "#90a8a4",
  "#55b7ac",
  "#8bd6cc",
  "#d1ddd9",
  "#e4ebe7",
  "#495a47",
  "#346437",
  "#266a34",
  "#3c6e3e",
  "#536c51",
  "#7c927a",
  "#779b74",
  "#7eb17e",
  "#a1c09f",
  "#c4d2c0",
  "#bdd7bb",
  "#bad9b8",
  "#d7dad5",
  "#d3decf",
  "#cfe2cd",
  "#cce3c9",
  "#c8e3c6",
  "#e2ece0",
  "#e0ecdd",
  "#deedd9",
  "#7d5f7f",
  "#7d6d7e",
  "#9a729c",
  "#9e919f",
  "#bfb6bf",
  "#d5cfd4",
  "#dcd1d9",
  "#ebe8e9",
  "#ede8ea",
  "#6b4a50",
  "#7e434e",
  "#864f5a",
  "#984356",
  "#816469",
  "#966870",
  "#977f82",
  "#c16d7e",
  "#b18e93",
  "#d0929c",
  "#c1a4a9",
  "#d6b5b8",
  "#d3bfc1",
  "#e2cecf",
  "#e3dad8",
  "#e9dad9",
  "#f1e5e4",
  "#4e3d34",
  "#654330",
  "#5b4a41",
  "#66554d",
  "#765b4d",
  "#8f6c58",
  "#ae6335",
  "#aa8e7f",
  "#d9a387",
  "#beafa6",
  "#e1b7a3",
  "#dbcec6",
  "#eacec0",
  "#ede7e1",
  "#f0e8e2",
  "#5a5335",
  "#787256",
  "#867b3d",
  "#918a70",
  "#a49b7a",
  "#aea26b",
  "#b8b192",
  "#c9b96d",
  "#cfbf3b",
  "#cdc387",
  "#d4cfbc",
  "#d9d2b8",
  "#ded29c",
  "#e8d36d",
  "#e2d8ae",
  "#eddda2",
  "#e6dec4",
  "#f4e291",
  "#ece9e0",
  "#f2e8c9",
  "#3f4f72",
  "#004641",
  "#a1d3a2",
  "#abddac",
  "#ecb8be",
  "#f3eedc",
  "#224373",
  "#5f373d",
  "#8a4b56",
  "#efdfdf",
  "#546894",
  "#b6d4e0",
  "#a5cea7",
  "#603960",
  "#a1948c",
  "#c2c7d6",
  "#9fd3e7",
  "#d4dee1",
  "#bcccc9",
  "#616760",
  "#442529",
  "#d86c80",
  "#e5dfde",
  "#e1d2ca",
  "#f2d4c2",
  "#76908d",
  "#d2e6e2",
  "#e6e7e4",
  "#a25d2c",
  "#c77338",
  "#e1cbbe",
  "#ccc45a",
  "#f5edcf",
  "#c4e0eb",
  "#dd939c",
  "#cd6f27",
  "#908b2c",
  "#aca90c",
  "#448ca7",
  "#8dcce7",
  "#90b9b5",
  "#deebe8",
  "#8f988f",
  "#46ac5f",
  "#cdd8cd",
  "#ab4357",
  "#f3c4c9",
  "#8a5631",
  "#bb7546",
  "#787336",
  "#bcb928",
  "#c6c13b",
  "#eeede5",
  "#555c5e",
  "#4e6c69",
  "#4b7b78",
  "#00837d",
  "#008c86",
  "#bae3df",
  "#cbebe6",
  "#573b55",
  "#f0a9b1",
  "#f5ced1",
  "#ed8b45",
  "#f8d7c3",
  "#eceadf",
  "#0097c4",
  "#bdd7e3",
  "#009b96",
  "#a0c6c2",
  "#c1e6e2",
  "#91a392",
  "#b5cab6",
  "#c5c7c3",
  "#ebdee8",
  "#826f63",
  "#ebded4",
  "#8d8964",
  "#324169",
  "#38b1db",
  "#154946",
  "#10514e",
  "#22625f",
  "#2a7c79",
  "#6db0ac",
  "#a1d8d4",
  "#cbd5d3",
  "#3a5f42",
  "#33643e",
  "#b5bbb5",
  "#68303a",
  "#853643",
  "#f2dcdc",
  "#6c5141",
  "#8f5833",
  "#826a5c",
  "#a4673c",
  "#b4662f",
  "#8c7567",
  "#a08573",
  "#d77e44",
  "#d38043",
  "#da8953",
  "#d08e61",
  "#ec9f6c",
  "#d6a78a",
  "#eab696",
  "#e1bca7",
  "#f0c8b0",
  "#e1cfc3",
  "#e5dad3",
  "#e9dcd3",
  "#efddd1",
  "#eee7e1",
  "#e8e38c",
  "#6c7aab",
  "#848db5",
  "#00546e",
  "#1b7694",
  "#b0cfdd",
  "#bdd9d6",
  "#496e51",
  "#e8dae5",
  "#ed9aa3",
  "#c9b7b7",
  "#343333",
  "#b59f91",
  "#e5e0dc",
  "#ebeae8",
  "#deddd3",
  "#e8e7e3",
  "#d6e5eb",
  "#006663",
  "#5d7861",
  "#d0e4d2",
  "#d2b6cc",
  "#5f4546",
  "#85686a",
  "#f6d8da",
  "#d8bcaa",
  "#f7e2d3",
  "#d6d5cb",
  "#e4e184",
  "#343e61",
  "#7586c6",
  "#afc5d0",
  "#7e9e84",
  "#7c4e75",
  "#963747",
  "#f19754",
  "#f6b180",
  "#eec4a9",
  "#b2b1a5",
  "#f1f0e8",
  "#f2f1e5",
  "#b8bcd4",
  "#537686",
  "#cdd3d5",
  "#e0c0da",
  "#e5d1e0",
  "#482e32",
  "#e8a06c",
  "#ccb19f",
  "#bbc9d0",
  "#d7e3e0",
  "#32583d",
  "#ddb1d4",
  "#e5dcdc",
  "#af907b",
  "#f18517",
  "#fabc90",
  "#dededa",
  "#f1efcc",
  "#f3f2da",
  "#5a638d",
  "#57b7dd",
  "#d6a4cc",
  "#f5a265",
  "#eed3c1",
  "#e8e3a8",
  "#e4e5ea",
  "#6b5253",
  "#5b5a58",
  "#f3ccb0",
  "#5d5d32",
  "#eeedd5",
  "#0c4c62",
  "#00a4a6",
  "#c98ebd",
  "#b94657",
  "#d8d87c",
  "#e0dd90",
  "#c1dae6",
  "#d0dde3",
  "#ebd3e2",
  "#eae2e6",
  "#d2d36f",
  "#e8e5ae",
  "#e7e6dd",
  "#454c6c",
  "#6e718e",
  "#68709f",
  "#71779e",
  "#8085ae",
  "#9194ab",
  "#9799b8",
  "#aeb0c8",
  "#bcbed5",
  "#c8cae4",
  "#dbdbdd",
  "#e9e8e8",
  "#eceaed",
  "#394a53",
  "#005f7d",
  "#007096",
  "#587381",
  "#1883a7",
  "#5e93ad",
  "#84939c",
  "#7d98a6",
  "#8f9ea5",
  "#99afbc",
  "#a7b1b6",
  "#adc8d7",
  "#c7d0d4",
  "#cbdee8",
  "#c9dee9",
  "#007a7a",
  "#6c9393",
  "#609c9b",
  "#64b1af",
  "#8cadac",
  "#44bfbe",
  "#88c8c6",
  "#a1ccca",
  "#c8e2df",
  "#c3e3df",
  "#e6e9e6",
  "#ddedea",
  "#d9edea",
  "#32523d",
  "#57725e",
  "#34794d",
  "#238e52",
  "#5b9a70",
  "#7f9584",
  "#57a972",
  "#7aa888",
  "#51b074",
  "#a9b4ab",
  "#80c194",
  "#93c1a1",
  "#8bcea0",
  "#c5d4c8",
  "#a6deb7",
  "#bedac4",
  "#b7e2c3",
  "#d5ded6",
  "#d2ded4",
  "#c8e6ce",
  "#e3e9e1",
  "#e5ebe4",
  "#daeddc",
  "#d8efdc",
  "#533f4f",
  "#734d6c",
  "#9e7594",
  "#b897af",
  "#e1d1dc",
  "#e5dbe0",
  "#edeaeb",
  "#eee9eb",
  "#eee9eb",
  "#eee8ea",
  "#84474b",
  "#9e555c",
  "#ac4b57",
  "#b87c7e",
  "#a78e8e",
  "#db7680",
  "#a99898",
  "#db9599",
  "#eab0b2",
  "#ddb8b8",
  "#ebbabb",
  "#e6c4c5",
  "#d5cecd",
  "#ecd0cf",
  "#e3dbd8",
  "#eedcda",
  "#ece8e5",
  "#ece7e4",
  "#eee7e5",
  "#f0e7e5",
  "#363635",
  "#664d3b",
  "#ae6830",
  "#9e8472",
  "#d77e29",
  "#b1937d",
  "#a8998e",
  "#d48b4c",
  "#dd883a",
  "#c1a28b",
  "#e29859",
  "#baa79a",
  "#e0a678",
  "#ccb7a8",
  "#d3baa7",
  "#f4ac71",
  "#e7b794",
  "#f0bc94",
  "#d9c4b6",
  "#d6cec7",
  "#e9c9b2",
  "#e1d0c3",
  "#f3d4bd",
  "#e8dcd2",
  "#f4ddcc",
  "#f0e4db",
  "#f0e8e0",
  "#f4e5d9",
  "#484737",
  "#6c6b3e",
  "#747264",
  "#7e7f3a",
  "#a09e64",
  "#bbb786",
  "#b9bb58",
  "#c2c28f",
  "#c9cc75",
  "#d7d4bb",
  "#ddda87",
  "#e1dbae",
  "#ede9d3",
  "#edeccd",
  "#ede9c5",
  "#333d6b",
  "#f4a6a8",
  "#5a4a3d",
  "#7d8234",
  "#a2af1d",
  "#eaebba",
  "#f0f0e0",
  "#3d4448",
  "#89d6d5",
  "#afbb34",
  "#bac348",
  "#c5cf5a",
  "#d7dc88",
  "#64727a",
  "#7f847f",
  "#b973a8",
  "#f9cecd",
  "#a17247",
  "#ece5df",
  "#f2ece6",
  "#b9c546",
  "#f1f1ed",
  "#e6bdd9",
  "#dd646d",
  "#c49f80",
  "#e9ead9",
  "#767f84",
  "#b2b8ba",
  "#d4e4e1",
  "#e4b6d6",
  "#ebd2e2",
  "#6b2c31",
  "#e48286",
  "#a4a967",
  "#ae639a",
  "#514c47",
  "#bdb1a6",
  "#f79a38",
  "#bec198",
  "#d3d3cb",
  "#385142",
  "#eedbe5",
  "#b5a08f",
  "#fcae63",
  "#e9ead7",
  "#7fb7d6",
  "#aa7e54",
  "#ddb694",
  "#e8e0d8",
  "#0087bd",
  "#b1d2e6",
  "#af7026",
  "#e7c4a6",
  "#f3c49b",
  "#f3e6d9",
  "#f4e6da",
  "#e2e3d2",
  "#e8ead0",
  "#f0dcc9",
  "#f7f5ee",
  "#705f68",
  "#8d6e5a",
  "#dc7525",
  "#645636",
  "#dfd3c5",
  "#f0ecdf",
  "#9a5c38",
  "#e2cd9e",
  "#efe7da",
  "#3c3e3e",
  "#e7dcd5",
  "#d8e5d4",
  "#eae7c1",
  "#d6eae2",
  "#b9c9e1",
  "#83a89a",
  "#f8ede1",
  "#b6ab9d",
  "#ccbda6",
  "#f0eddf",
  "#b6ab9d",
  "#f0e8e1",
  "#a29182",
  "#f3e7cd",
  "#e9ead9",
  "#feb572",
  "#f9d1b5",
  "#f2e3d2",
  "#f1d4d5",
  "#5d3f36",
  "#a0c6c2",
  "#cac0b8",
  "#bdbfc0",
  "#a6908b",
  "#d8cbc0",
  "#d49c9b",
  "#e4e1db",
  "#b5d3d2",
  "#cddbe0",
  "#5f5569",
  "#a85958",
  "#c16130",
  "#c3cacd",
  "#e56f5c",
  "#f0bd00",
  "#514961",
  "#e1daca",
  "#e7cbc7",
  "#e8d3b7",
  "#d2a36c",
  "#a2ae8e",
  "#ffcf73",
  "#ede3cd",
  "#32628c",
  "#494d52",
  "#e9d8be",
  "#8e5637",
  "#28a2b7",
  "#06a5ae",
  "#c9cbc9",
  "#dedcc1",
  "#d4bfa5",
  "#658185",
  "#746357",
  "#991b25",
  "#c16d7e",
  "#ae5367",
  "#d37998",
  "#f4d3cb",
  "#d2dde1",
  "#9f9899",
  "#d5c4b7",
  "#6a4d33",
  "#2d2d2d",
  "#282829",
  "#3b343f",
  "#524f63",
  "#2c3241",
  "#2e4a58",
  "#6a4a3e",
  "#bfd1e4",
  "#c57463",
  "#e5dbd7",
  "#eee2df",
  "#5e7c86",
  "#92b8dc",
  "#005b8e",
  "#1c3c43",
  "#567ebe",
  "#413048",
  "#d8e0e9",
  "#99bdd0",
  "#d1dde3",
  "#005476",
  "#7f8a9c",
  "#b5cbda",
  "#154367",
  "#737b84",
  "#457697",
  "#88b7bf",
  "#e1dbd2",
  "#e6d8d1",
  "#7093ab",
  "#f3a9a4",
  "#d5e9e9",
  "#d1dde3",
  "#9e713e",
  "#9db19e",
  "#6d5e4d",
  "#735237",
  "#a48561",
  "#9d8e7e",
  "#b0c4d3",
  "#a96e4d",
  "#cccccb",
  "#c19659",
  "#e1c09d",
  "#f7b260",
  "#7d623b",
  "#9a5238",
  "#f7da99",
  "#ffd17d",
  "#fedfa1",
  "#f0dfbc",
  "#ebc68e",
  "#594b3f",
  "#f58b52",
  "#ffd17d",
  "#f4c272",
  "#e8e8e5",
  "#a49b7a",
  "#e4be9b",
  "#e0a767",
  "#ede3d5",
  "#f8e8dc",
  "#ecd9ca",
  "#505354",
  "#87846e",
  "#c498ac",
  "#c9a02e",
  "#d7a762",
  "#c5aa9b",
  "#d7c6b4",
  "#c4b591",
  "#dbcaa4",
  "#cbc890",
  "#c26430",
  "#e6e7a3",
  "#8fa6c6",
  "#e6e9e9",
  "#e6e9e9",
  "#f2d7b4",
  "#f9e3c1",
  "#c19659",
  "#d3baa7",
  "#5d3e3f",
  "#ddb5ba",
  "#453432",
  "#babab9",
  "#dfe2e7",
  "#9b3d3f",
  "#dfdcd5",
  "#eeefea",
  "#c6d6b2",
  "#452b33",
  "#646350",
  "#8a7662",
  "#7a4d3a",
  "#c87f3c",
  "#ad6c55",
  "#724232",
  "#a8d4d7",
  "#d0c738",
  "#ffb54f",
  "#fbedba",
  "#dab955",
  "#63655d",
  "#d5e1e2",
  "#f3f2ec",
  "#ebeae4",
  "#9daaae",
  "#a8dae5",
  "#ecede7",
  "#b3d6dc",
  "#f8ead5",
  "#b8c7cc",
  "#afc3cc",
  "#005184",
  "#343639",
  "#e6d9b7",
  "#fbdcb1",
  "#b28d80",
  "#676162",
  "#908874",
  "#bcc7b5",
  "#9d9e9d",
  "#f3e7de",
  "#37423b",
  "#bea18e",
  "#afb1b3",
  "#c4dbe4",
  "#79433d",
  "#cc907b",
  "#7d362a",
  "#c2886b",
  "#ecded4",
  "#c27470",
  "#d16965",
  "#f7e6e4",
  "#c27470",
  "#d66b76",
  "#e19b8d",
  "#59a4d1",
  "#7ca8bf",
  "#dce1df",
  "#e2ddcb",
  "#c9b9c9",
  "#ece9d9",
  "#dfe5f0",
  "#f0e8e1",
  "#f7f0df",
  "#63584c",
  "#e2ccab",
  "#b8c7cc",
  "#896a46",
  "#e8cda5",
  "#efebd1",
  "#c7bdb6",
  "#a32e39",
  "#efdab9",
  "#f8efd8",
  "#faebd1",
  "#899596",
  "#c1bea2",
  "#bf7567",
  "#bde0a9",
  "#fad9af",
  "#b7afa4",
  "#00533f",
  "#f6ebcd",
  "#6e6867",
  "#a05155",
  "#cbd7e3",
  "#5a3732",
  "#3b343f",
  "#5d3944",
  "#503e37",
  "#3e2a27",
  "#674332",
  "#c3ad94",
  "#f6f5d9",
  "#ecd461",
  "#46383e",
  "#4a5a88",
  "#8f908f",
  "#833733",
  "#7f4c3c",
  "#295078",
  "#82c8e3",
  "#5c9bcc",
  "#eae6e1",
  "#7c8d95",
  "#938564",
  "#f9f1e4",
  "#a7b9a5",
  "#c79e9c",
  "#87846e",
  "#728d73",
  "#5f708a",
  "#f5ebd7",
  "#3a4357",
  "#d0d7c7",
  "#68695b",
  "#ecd1ad",
  "#f2e8ce",
  "#4a423a",
  "#c3dee7",
  "#2c5663",
  "#e8ccbd",
  "#c3c4c8",
  "#e3e2d9",
  "#388597",
  "#d3d9d9",
  "#915165",
  "#a29f7f",
  "#dbe0e0",
  "#cdb288",
  "#b2ccc5",
  "#8d3926",
  "#4d2f27",
  "#a3652d",
  "#3d2923",
  "#553f2f",
  "#372b27",
  "#833622",
  "#39332f",
  "#7f4f27",
  "#9c6d39",
  "#6a2b24",
  "#cb8c39",
  "#62372a",
  "#c98122",
  "#6a2b24",
  "#59382a",
  "#5f3828",
  "#7d3d23",
  "#502c26",
  "#a94c1c",
  "#5a3423",
  "#cabb9e",
  "#90969c",
  "#c3b3b8",
  "#a99898",
  "#6e8799",
  "#cd4a38",
  "#a0a9ae",
  "#c33f28",
  "#ad588f",
  "#2d2d2d",
  "#e8e8e4",
  "#d8d1c5",
  "#642a33",
  "#fadeae",
  "#e8dcc6",
  "#0081b8",
  "#706d74",
  "#2f7769",
  "#6e8a7f",
  "#4b9c8c",
  "#a57b76",
  "#7a655d",
  "#bea488",
  "#b66e59",
  "#304b38",
  "#932f55",
  "#cbb3ad",
  "#d8cfcd",
  "#5e717b",
  "#e0d9af",
  "#dbcfd0",
  "#b0c4d3",
  "#ddedd3",
  "#c6b3aa",
  "#819bb4",
  "#f8a476",
  "#97a1cf",
  "#e5e9df",
  "#336c72",
  "#f6f2e5",
  "#503137",
  "#009e82",
  "#ae684a",
  "#9a7259",
  "#3e4334",
  "#afd2e5",
  "#cfd0c2",
  "#a45d6a",
  "#7b90a0",
  "#c8c6bd",
  "#e18d93",
  "#e3d7c4",
  "#e3ddd2",
  "#7d7f80",
  "#949488",
  "#d6c0be",
  "#6b2230",
  "#987623",
  "#976856",
  "#a16c79",
  "#d4dadd",
  "#03664f",
  "#646967",
  "#a09591",
  "#878a83",
  "#57624d",
  "#6289a3",
  "#f6ce62",
  "#007067",
  "#dedacb",
  "#b6b4a9",
  "#eee7df",
  "#c7c9d5",
  "#a3a78d",
  "#d6d9e7",
  "#e0b7a4",
  "#1b80b8",
  "#915b24",
  "#847b72",
  "#e3f0dd",
  "#c1bea2",
  "#e5eade",
  "#ebe9ba",
  "#f5ebd9",
  "#98a9a4",
  "#d0cd98",
  "#23693b",
  "#dab6ab",
  "#bcc7b5",
  "#dcce8d",
  "#d3edef",
  "#f7f6ee",
  "#cccccb",
  "#af98b0",
  "#cd8161",
  "#d6dce0",
  "#b8bfba",
  "#f1e8d4",
  "#5dab70",
  "#4d7a79",
  "#d9cec4",
  "#cdcce1",
  "#d8d4ce",
  "#d09d6e",
  "#d4d4d2",
  "#cadee1",
  "#f29f00",
  "#cf966e",
  "#d1be8e",
  "#fdc582",
  "#ebca9c",
  "#ddc9b0",
  "#d7b468",
  "#c9cbc9",
  "#aeaeab",
  "#95c268",
  "#eee9de",
  "#eae2cc",
  "#d4cfbc",
  "#e1d5bb",
  "#aac089",
  "#c7d2ce",
  "#c8cdc7",
  "#525353",
  "#737b84",
  "#9c968b",
  "#dadad9",
  "#aa8e7f",
  "#777b5b",
  "#e7dfd3",
  "#f9e4ae",
  "#d4b773",
  "#d7b468",
  "#b4b3b9",
  "#b68d2c",
  "#9b8987",
  "#777899",
  "#b6a5a6",
  "#b6a379",
  "#c4ccc9",
  "#a2ae8e",
  "#9da298",
  "#dab955",
  "#b0cfde",
  "#28373a",
  "#3c5949",
  "#17407d",
  "#fbead6",
  "#8b7267",
  "#c7582e",
  "#f4eedb",
  "#e6af47",
  "#d6bb82",
  "#f2dec2",
  "#d2c6a8",
  "#d7dde1",
  "#f8b8a1",
  "#a99a8c",
  "#f2dcdc",
  "#f3f2ec",
  "#eee0e2",
  "#cd8161",
  "#d8c7b2",
  "#e8e8e5",
  "#315368",
  "#567195",
  "#364a55",
  "#617482",
  "#34435c",
  "#5270a7",
  "#444038",
  "#e8d6bb",
  "#f7edda",
  "#384a33",
  "#dfebe6",
  "#d1d4e6",
  "#e8e4e0",
  "#f8ece6",
  "#f2efe5",
  "#575253",
  "#a09180",
  "#ecdfa3",
  "#a3ac74",
  "#d5d6b5",
  "#c1bea2",
  "#3e6256",
  "#3e3e34",
  "#e0dad5",
  "#d7c2b6",
  "#bdd176",
  "#475538",
  "#cbc4b8",
  "#594b3f",
  "#edc9cc",
  "#cbf0e8",
  "#f5e4da",
  "#ede1d0",
  "#32a5bb",
  "#5e555f",
  "#cfd7e3",
  "#e5e2e5",
  "#ebe5f0",
  "#c6cedb",
  "#b8b9c8",
  "#c9cbe5",
  "#7d7d7c",
  "#d9dcdd",
  "#97cd87",
  "#9b6d54",
  "#ecd96a",
  "#ffc032",
  "#ffe087",
  "#eecd40",
  "#f8d483",
  "#f8f3c2",
  "#f4e6c0",
  "#f9e09c",
  "#ffd562",
  "#e1e2dd",
  "#00918b",
  "#9eb4cb",
  "#d6dce0",
  "#a3c0cb",
  "#efeff1",
  "#bcb6bd",
  "#d1b098",
  "#a79dc8",
  "#c8aec0",
  "#dcdfe4",
  "#bcb6bd",
  "#e6ebb9",
  "#deecaa",
  "#eaecd4",
  "#30673f",
  "#f3f2da",
  "#fce2af",
  "#9fae36",
  "#ede8e2",
  "#ebe9e0",
  "#a2967f",
  "#4f3841",
  "#c15a57",
  "#7badab",
  "#e4e1db",
  "#7c6655",
  "#fcde93",
  "#f9f4da",
  "#c0c1b5",
  "#c7ca56",
  "#2e8f3d",
  "#905636",
  "#f4e7d4",
  "#006872",
  "#2d3d39",
  "#cfc1cb",
  "#eae8e5",
  "#d1c2b9",
  "#d2cfc6",
  "#ba977c",
  "#c2794f",
  "#d08e61",
  "#eae9ea",
  "#ffbe7a",
  "#8bd6d3",
  "#699093",
  "#ffae62",
  "#bb565c",
  "#9c7851",
  "#b6b4a9",
  "#423b64",
  "#d1d2dc",
  "#807a7c",
  "#ece8c6",
  "#55b7ac",
  "#29524d",
  "#d7ccc7",
  "#d9dcb8",
  "#d0cd98",
  "#60696c",
  "#29394c",
  "#6d837d",
  "#373635",
  "#223a53",
  "#445a66",
  "#b69f90",
  "#4e5b66",
  "#e4dabf",
  "#c3d8e3",
  "#999997",
  "#646967",
  "#b9d3d1",
  "#f2f3e2",
  "#facaab",
  "#84939c",
  "#a29f7f",
  "#c8ced4",
  "#b7c3c5",
  "#e5b600",
  "#833532",
  "#d7dde1",
  "#f6f7ee",
  "#98977b",
  "#d1dfdd",
  "#f8f2e4",
  "#ceccc3",
  "#e36811",
  "#cbc5b1",
  "#f5e3cd",
  "#ecf1e2",
  "#968a3b",
  "#7b8178",
  "#bea99d",
  "#817b73",
  "#654657",
  "#b89441",
  "#e3b383",
  "#d5cbc6",
  "#b0a498",
  "#bfbfa8",
  "#445a66",
  "#3b4966",
  "#768299",
  "#b0aaa0",
  "#202c3a",
  "#ece2d2",
  "#e1d5c6",
  "#909396",
  "#c5bbab",
  "#ede0d1",
  "#dc9c86",
  "#b8632a",
  "#627775",
  "#f0ecdf",
  "#d6d3e0",
  "#3a5267",
  "#4d4f52",
  "#6c6b3e",
  "#b8c4cc",
  "#7db0c2",
  "#ebf5e4",
  "#c2794f",
  "#bcae9a",
  "#e3dcd4",
  "#decebe",
  "#dcf3ee",
  "#32759a",
  "#99afbc",
  "#cf7b1c",
  "#ca9a51",
  "#c39e4b",
  "#ece6d8",
  "#5c5a47",
  "#9e967e",
  "#615b3c",
  "#9e967e",
  "#9f9288",
  "#aaa48f",
  "#edc687",
  "#e2712b",
  "#525234",
  "#f4e9d4",
  "#528580",
  "#b1ac96",
  "#b9a99f",
  "#4f4c80",
  "#e5c586",
  "#e9e6da",
  "#e3dcd4",
  "#cfcfac",
  "#e5eee4",
  "#e7ddde",
  "#d2cdc6",
  "#d8d0d9",
  "#d4cabd",
  "#384137",
  "#e8eae4",
  "#dfdad5",
  "#ccbda5",
  "#71a63f",
  "#d699b9",
  "#865c7d",
  "#dae2e8",
  "#e6dde6",
  "#f1dad2",
  "#fed6ab",
  "#f4e8da",
  "#bf8e63",
  "#dfccb1",
  "#e0d2cd",
  "#a2ae8e",
  "#bab3ac",
  "#d2cfc6",
  "#afb4ac",
  "#024a7f",
  "#cedfdd",
  "#bde8da",
  "#b33e3f",
  "#c5beba",
  "#f5dad0",
  "#dad2d8",
  "#aeb5d4",
  "#9d9e9d",
  "#f1ede0",
  "#96b0b7",
  "#efd886",
  "#4a413e",
  "#d2e5e0",
  "#2a493f",
  "#e2d4cb",
  "#d48594",
  "#cea9aa",
  "#cbb3ad",
  "#c79ca3",
  "#c49f9a",
  "#efe7e0",
  "#e2bec0",
  "#d5d6b5",
  "#72404f",
  "#484253",
  "#8d84b5",
  "#877678",
  "#e6b580",
  "#d4c9b5",
  "#9e3147",
  "#72b671",
  "#d8d8d7",
  "#e7d098",
  "#cfad78",
  "#b6ccd8",
  "#be3b30",
  "#d6ccca",
  "#f4dccf",
  "#d4d2cb",
  "#dfcecb",
  "#a09591",
  "#d9b7af",
  "#e9dcd3",
  "#d9dcc0",
  "#847b72",
  "#5b4a41",
  "#546386",
  "#bc9795",
  "#c0b4ab",
  "#e4d2e2",
  "#f3ecd1",
  "#c6c0d9",
  "#3f8685",
  "#93383f",
  "#c9bdb7",
  "#d4cbc8",
  "#867091",
  "#594786",
  "#8c8b95",
  "#bf7567",
  "#d5d0c7",
  "#e4e7e9",
  "#888c29",
  "#b9cace",
  "#482e32",
  "#53504d",
  "#ccba87",
  "#cfb084",
  "#d1aa6d",
  "#f7a800",
  "#e29e00",
  "#ca8f00",
  "#e09000",
  "#e78c00",
  "#af8152",
  "#dcaf2f",
  "#e1d8c4",
  "#dbc399",
  "#e4d1b4",
  "#efdc3b",
  "#f3a852",
  "#f8ca3a",
  "#a48f79",
  "#a18f65",
  "#f4b600",
  "#f5b500",
  "#b98f4e",
  "#a78020",
  "#ff9c00",
  "#e0a312",
  "#f69824",
  "#e99c54",
  "#ee920a",
  "#d96f0b",
  "#b94a24",
  "#be3c28",
  "#f3782e",
  "#e05313",
  "#eb6c2a",
  "#db5417",
  "#ce5d2a",
  "#e17021",
  "#d3654d",
  "#a52f28",
  "#9b2a2a",
  "#9a2928",
  "#852227",
  "#6e252b",
  "#5c252a",
  "#43292a",
  "#6f3a33",
  "#7a2d2c",
  "#c5866e",
  "#97332b",
  "#ca7475",
  "#d6a0a5",
  "#a74236",
  "#ca565d",
  "#c5424d",
  "#b9271f",
  "#ce6a55",
  "#aa2c40",
  "#a6393d",
  "#836384",
  "#8d414e",
  "#c3638c",
  "#67263d",
  "#786a9a",
  "#913a75",
  "#4d2d41",
  "#864f82",
  "#9e8691",
  "#bc4579",
  "#33516f",
  "#194e65",
  "#0c3e7d",
  "#1c3753",
  "#232830",
  "#005688",
  "#3b6c8c",
  "#303e47",
  "#225e77",
  "#00527d",
  "#223241",
  "#0789b4",
  "#223656",
  "#637c94",
  "#007daf",
  "#005d8c",
  "#158c8b",
  "#006083",
  "#00474f",
  "#007777",
  "#2f355e",
  "#466b8d",
  "#6193ab",
  "#407561",
  "#3a6939",
  "#385d31",
  "#535640",
  "#174947",
  "#194536",
  "#413f36",
  "#33392b",
  "#3b392f",
  "#2c3a2f",
  "#50703c",
  "#6e7e5c",
  "#313f3c",
  "#7d775c",
  "#4c4539",
  "#41413a",
  "#006b4e",
  "#5b8041",
  "#62993d",
  "#b8ccaa",
  "#3d4736",
  "#8b9a78",
  "#423c31",
  "#058554",
  "#607041",
  "#006150",
  "#7cb8b2",
  "#365746",
  "#007141",
  "#2a8054",
  "#498880",
  "#7badab",
  "#7b898e",
  "#8c969b",
  "#837a66",
  "#7b786a",
  "#9a9b9b",
  "#6e706d",
  "#786c5f",
  "#766141",
  "#5e6158",
  "#5b5e58",
  "#555c5e",
  "#5b6162",
  "#5a5347",
  "#53575c",
  "#3d4448",
  "#36393a",
  "#504e49",
  "#818177",
  "#494d52",
  "#3d484a",
  "#928f85",
  "#5f6b6f",
  "#b5b0a0",
  "#808374",
  "#938870",
  "#c5c7c3",
  "#989492",
  "#7d7e7c",
  "#afb1a8",
  "#6d6961",
  "#989fa1",
  "#8f9391",
  "#525654",
  "#b7b3a8",
  "#8e9495",
  "#7e8589",
  "#c7c7c5",
  "#8b6c44",
  "#9d6432",
  "#7b5142",
  "#804f2f",
  "#8e4e38",
  "#724a32",
  "#744f2f",
  "#5d3d2e",
  "#693a33",
  "#4e3c30",
  "#61362e",
  "#51332b",
  "#483530",
  "#433c3b",
  "#2a2524",
  "#a55b33",
  "#7a543d",
  "#765b4b",
  "#544033",
  "#e7e0d1",
  "#d6d5ca",
  "#eaeae6",
  "#323233",
  "#202021",
  "#eeebe1",
  "#2d2f31",
  "#eeeee7",
  "#2c2a29",
  "#c8cbc4",
  "#8f353a",
  "#bf4f5c",
  "#b27782",
  "#c95d73",
  "#a86d86",
  "#333a3e",
  "#343639",
  "#d4c9b5",
  "#cc9089",
  "#672529",
  "#974951",
  "#97534d",
  "#b84b1b",
  "#89242b",
  "#b47761",
  "#614466",
  "#423b64",
  "#006aa8",
  "#007499",
  "#aab2b9",
  "#65635e",
  "#d57471",
  "#693838",
  "#2c2b2b",
  "#25313d",
  "#7f6948",
  "#54494b",
  "#605f5e",
  "#c1b8a8",
  "#5d4c30",
  "#e0cdd1",
  "#7c7c7a",
  "#9ab4ba",
  "#7c625c",
  "#ab4c4c",
  "#d35338",
  "#906a46",
  "#b7b3ac",
  "#e9eae9",
  "#b87c7e",
  "#dbcfbb",
  "#cdc2c4",
  "#ede8e2",
  "#dedcd7",
  "#e4caa7",
  "#cbc0a7",
  "#7b6364",
  "#d6c0be",
  "#98a9a4",
  "#eaddd4",
  "#d9a397",
  "#a56a61",
  "#f2e7db",
  "#492d35",
  "#4d73a1",
  "#6c645f",
  "#782e34",
  "#8f969b",
  "#a4726d",
  "#70482f",
  "#5b4941",
  "#b3a897",
  "#e2ad72",
  "#e48320",
  "#375754",
  "#9ead9e",
  "#cd6555",
  "#d8c7b2",
  "#bba17b",
  "#ddcec4",
  "#324965",
  "#3b424c",
  "#b6d1e2",
  "#8b5545",
  "#de6546",
  "#b9a08b",
  "#c5a762",
  "#005a56",
  "#4c4e48",
  "#e5e2cd",
  "#829e96",
  "#39595f",
  "#8a8b54",
  "#c2d0df",
  "#4d3f38",
  "#b0c7d4",
  "#b7c3c5",
  "#afa490",
  "#817b72",
  "#e7bbb0",
  "#e7eae0",
  "#69662f",
  "#dcd1c0",
  "#c9cbc9",
  "#d7cfbc",
  "#dfcd45",
  "#a68e86",
  "#aba18d",
  "#bec2c2",
  "#717376",
  "#d2d0c6",
  "#dcdfd8",
  "#afb3a5",
  "#bab9b5",
  "#dcdfd8",
  "#bebcba",
  "#dfdbda",
  "#93bec0",
  "#599fb7",
  "#83a8c1",
  "#32523d",
  "#e9e9e7",
  "#ccb7a8",
  "#c6bdbd",
  "#626976",
  "#ceaf96",
  "#807a7c",
  "#dae0e2",
  "#e2e5e4",
  "#e9e8e9",
  "#edf2e9",
  "#a3c0da",
  "#e3dad6",
  "#e6eacb",
  "#fbecde",
  "#e4e1db",
  "#f6d9be",
  "#97b1da",
  "#d6c2b7",
  "#b9a99f",
  "#44483d",
  "#f2eac0",
  "#a38061",
  "#a43e2d",
  "#dddcd3",
  "#e3e7de",
  "#4e4a45",
  "#f7f1ef",
  "#7c8bae",
  "#dfebc1",
  "#c3cde1",
  "#949235",
  "#f3e7ef",
  "#d6c387",
  "#d6d5cb",
  "#48433f",
  "#c5e4e9",
  "#ad6368",
  "#b6b4a9",
  "#6794a5",
  "#8f9391",
  "#838c86",
  "#9cbfd7",
  "#ecd5af",
  "#10a1cf",
  "#e8e8e8",
  "#fce462",
  "#ddc9b0",
  "#57363f",
  "#bec1d6",
  "#e88683",
  "#eae3d7",
  "#983660",
  "#e0b595",
  "#ffbb93",
  "#fbb847",
  "#b0b655",
  "#dc9c86",
  "#fbcaaa",
  "#cbcccb",
  "#e2e2db",
  "#e7eaeb",
  "#626f83",
  "#88625a",
  "#d9c15b",
  "#d6ccca",
  "#e8bdd3",
  "#e4c5c1",
  "#e1c5cb",
  "#e8c4db",
  "#d9d8da",
  "#c76090",
  "#e8e1cb",
  "#f08948",
  "#a14a45",
  "#5f5a4c",
  "#136777",
  "#00939f",
  "#0f4c4b",
  "#5a8487",
  "#d7c3b9",
  "#eaebba",
  "#5a3732",
  "#873a2b",
  "#9a4c3c",
  "#a09591",
  "#e1dadf",
  "#676a6b",
  "#909998",
  "#f0ede4",
  "#b8c2c3",
  "#e4d8ce",
  "#e7d4bc",
  "#c6baa8",
  "#1d577e",
  "#5c615a",
  "#bdc3b9",
  "#62a3ad",
  "#e8e7e3",
  "#9e7043",
  "#cd8161",
  "#dddad8",
  "#3f3934",
  "#c6d0c8",
  "#9ba99a",
  "#00836e",
  "#6f6550",
  "#d7d9d6",
  "#efbfa1",
  "#808080",
  "#41464b",
  "#8a8376",
  "#4c413a",
  "#f4ecd6",
  "#fbe5ad",
  "#f0e8da",
  "#f6f2de",
  "#606573",
  "#6e3936",
  "#6b3c50",
  "#a4a93a",
  "#b8b192",
  "#229064",
  "#7a6b81",
  "#f3eed9",
  "#62859d",
  "#7ea28f",
  "#d59883",
  "#3b6035",
  "#796c61",
  "#c49f9a",
  "#66605c",
  "#a493ac",
  "#bfb6bf",
  "#dfdde2",
  "#7090c9",
  "#d3d0d6",
  "#898d9b",
  "#b4b3b9",
  "#dedce6",
  "#ecdfca",
  "#9b8987",
  "#bda68a",
  "#afa490",
  "#817b73",
  "#a2a5a5",
  "#d6c9ad",
  "#d7dddd",
  "#25313d",
  "#7b8178",
  "#d5ccc4",
  "#57b5a2",
  "#cdd4ce",
  "#818278",
  "#dbedcf",
  "#e4ddce",
  "#aaa8ae",
  "#f1f1e8",
  "#eeefea",
  "#eeefeb",
  "#e3e7de",
  "#e8e8e4",
  "#edece7",
  "#c4b591",
  "#4e4653",
  "#636040",
  "#8d9275",
  "#68655d",
  "#c9464f",
  "#f4e3b8",
  "#6f7a70",
  "#c4b591",
  "#cac8a8",
  "#c9d7c4",
  "#6c645f",
  "#eae9e7",
  "#eee9e4",
  "#dfdbd8",
  "#b3c5d1",
  "#d06740",
  "#e1e7ea",
  "#7d98a6",
  "#4e5a60",
  "#85a6ab",
  "#afb1b3",
  "#e8e7e3",
  "#abbcdc",
  "#3a7d9a",
  "#98958d",
  "#807a7c",
  "#6c645f",
  "#a09591",
  "#bbc3bb",
  "#9d948b",
  "#beb1ab",
  "#9e9890",
  "#8b7267",
  "#494538",
  "#ccd9ca",
  "#e7d9c7",
  "#f5bc5d",
  "#ced06a",
  "#64533d",
  "#716d65",
  "#292a27",
  "#5d2d1e",
  "#babbbb",
  "#b04923",
  "#dce1d6",
  "#171b1c",
  "#e3dbce",
  "#c7c2bc",
  "#DACBAF",
  "#756048",
  "#655E49",
  "#655e49",
  "#B2B4AC",
  "#CBCFCA",
  "#404B4E",
  "#A19E93",
  "#B1B6B2",
  "#B1B6B2",
  "#ACB2AF",
  "#AEB1AB",
  "#494A44",
  "#F0EDDD",
  "#303533",
  "#5D5748",
  "#BAC0C0",
  "#898887",
  "#898887",
  "#4F4B47",
  "#3A4145",
  "#3A4145",
  "#423933",
  "#E1DAC7",
  "#AFB0B0",
  "#4D5352",
  "#2B2B2C",
  "#ACADAC",
  "#ACADAC",
  "#B9BEBC",
  "#ACADAC",
  "#A9A092",
  "#F0F4EF",
  "#E0E7EB",
  "#E0E8ED",
  "#5B5C54",
  "#575851",
  "#5B5C54",
  "#586D90",
  "#2D3231",
  "#525659",
  "#4D5153",
  "#ACA598",
  "#0B1574",
  "#D7C8B3",
  "#E5DBC4",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#666D6B",
  "#F2C137",
  "#E5ECE7",
  "#C9BCA3",
  "#4F5257",
  "#4F5257",
  "#D16C37",
  "#2D2E2E",
  "#2D2E2E",
  "#2A2A2B",
  "#2C2D2D",
  "#333937",
  "#3B3C3C",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2C2D2E",
  "#404645",
  "#404645",
  "#323334",
  "#303031",
  "#006AB2",
  "#006AB2",
  "#0083BE",
  "#162159",
  "#294A62",
  "#4F606B",
  "#4B5D69",
  "#566C76",
  "#566C76",
  "#67767D",
  "#bb9b82",
  "#968D72",
  "#3083C1",
  "#3083C1",
  "#57453C",
  "#4B2B48",
  "#491217",
  "#60595B",
  "#B6BCBB",
  "#A1A3A4",
  "#E1E9F0",
  "#E1E9F0",
  "#EFFBFF",
  "#F5DF3D",
  "#F5DF3D",
  "#4C433D",
  "#7A163C",
  "#564D39",
  "#4D4738",
  "#976E61",
  "#8A8680",
  "#7C7873",
  "#5D4B47",
  "#EAC066",
  "#48403C",
  "#8B8D7E",
  "#8B8D7E",
  "#756048",
  "#7c453e",
  "#F3E7C8",
  "#452430",
  "#CBC8BD",
  "#CBC8BD",
  "#838469",
  "#EFEAD9",
  "#EFEAD9",
  "#A19E99",
  "#9D978E",
  "#9D978E",
  "#8C8478",
  "#B2B4AC",
  "#B2B4AC",
  "#BDB8A7",
  "#373B3E",
  "#373B3E",
  "#373B3E",
  "#3A3D40",
  "#232725",
  "#3D4546",
  "#3C4143",
  "#3D4546",
  "#404041",
  "#444743",
  "#3F423F",
  "#3F3F3D",
  "#A6ABAE",
  "#B4BCBD",
  "#B4B8B4",
  "#D6CF72",
  "#533939",
  "#E3D2B0",
  "#E3D2B0",
  "#E3D2B0",
  "#EFE2C0",
  "#EFE2C0",
  "#2D4338",
  "#F2F5F1",
  "#F2F5F1",
  "#A3A7A9",
  "#936548",
  "#b17861",
  "#936548",
  "#888075",
  "#92867C",
  "#92867C",
  "#29382F",
  "#926346",
  "#8F6244",
  "#2F3433",
  "#323735",
  "#4E6263",
  "#365045",
  "#365045",
  "#365045",
  "#455E50",
  "#455E50",
  "#90886F",
  "#90886F",
  "#9E987E",
  "#4AA590",
  "#313634",
  "#2C312F",
  "#524C40",
  "#4D453F",
  "#513A70",
  "#4A4846",
  "#2F3D36",
  "#2F3D36",
  "#32443C",
  "#3D4954",
  "#3D4954",
  "#3D4954",
  "#45565F",
  "#45565F",
  "#4A5862",
  "#009390",
  "#C6905A",
  "#aa8578",
  "#E5E7E5",
  "#C3AA80",
  "#CEB78E",
  "#DED0AF",
  "#D0D5D2",
  "#AAA398",
  "#AAA398",
  "#AAA398",
  "#B8B4A8",
  "#B8B4A8",
  "#3D3D3D",
  "#313433",
  "#325053",
  "#64635C",
  "#2F487C",
  "#A1A29E",
  "#595449",
  "#959C99",
  "#524A3E",
  "#524A3E",
  "#A8ABA8",
  "#A8ABA8",
  "#373637",
  "#373637",
  "#ACB0B3",
  "#ACB0B3",
  "#DEDBCF",
  "#DEDBCF",
  "#A59E92",
  "#A59E92",
  "#7C8181",
  "#7C8181",
  "#979A9C",
  "#979A9C",
  "#9C9F9F",
  "#595B58",
  "#595B58",
  "#BCB7A3",
  "#BDB7A3",
  "#BCB7A3",
  "#CDC9B5",
  "#CDC9B5",
  "#98292C",
  "#A33733",
  "#BA4432",
  "#ECF0ED",
  "#2E53A1",
  "#3665AD",
  "#A4A9AB",
  "#8A795E",
  "#DFB465",
  "#AB8F5F",
  "#A78B5D",
  "#998053",
  "#9B7F51",
  "#545454",
  "#6EA743",
  "#606964",
  "#6E7173",
  "#BEB9A5",
  "#756F64",
  "#756F64",
  "#837F71",
  "#3D3C3C",
  "#565551",
  "#514842",
  "#483C39",
  "#3B7AAB",
  "#BFA981",
  "#324B3C",
  "#915241",
  "#915241",
  "#34453C",
  "#EAD590",
  "#EFEEE5",
  "#2B302F",
  "#424A4B",
  "#B3BCBD",
  "#FBFFFC",
  "#0D5E86",
  "#0D5E86",
  "#8B392E",
  "#8B392E",
  "#26603E",
  "#26603E",
  "#B42C29",
  "#B42C29",
  "#4B8941",
  "#4B8941",
  "#EECF41",
  "#EECF41",
  "#2769B8",
  "#2769B8",
  "#2A334F",
  "#2A334F",
  "#E65A23",
  "#E7AB36",
  "#E7AB36",
  "#576D69",
  "#4A4E55",
  "#4A4E55",
  "#4A4E55",
  "#525A5E",
  "#525A5E",
  "#F0EDDD",
  "#60503F",
  "#675C51",
  "#675C51",
  "#675C51",
  "#736C5F",
  "#736C5F",
  "#736C5F",
  "#1B6193",
  "#1B6193",
  "#3C3E41",
  "#9e7269",
  "#C5C0B2",
  "#416947",
  "#F1D650",
  "#FEDF47",
  "#C5BEAD",
  "#C1BAA5",
  "#C8DED1",
  "#A5382D",
  "#A6392D",
  "#A5382D",
  "#544F4C",
  "#544F4C",
  "#ADA899",
  "#ADA490",
  "#C8D954",
  "#C8D954",
  "#5E5548",
  "#2F2925",
  "#DBCEB2",
  "#E4DCC0",
  "#676756",
  "#646554",
  "#717662",
  "#2D2E2F",
  "#9C9E9A",
  "#C4BFB5",
  "#F0F2ED",
  "#693832",
  "#693832",
  "#693832",
  "#676D60",
  "#676D60",
  "#764841",
  "#303634",
  "#DFB465",
  "#7E6B52",
  "#675D50",
  "#C1C8C7",
  "#7b4844",
  "#3C3F3E",
  "#4A4745",
  "#A5ABAE",
  "#5D5F5D",
  "#546069",
  "#0D6938",
  "#0D6938",
  "#A6987E",
  "#424343",
  "#424343",
  "#424343",
  "#2A2B2B",
  "#3E3B38",
  "#424343",
  "#424343",
  "#424343",
  "#424343",
  "#424343",
  "#3E3B38",
  "#3E3B38",
  "#3E3B38",
  "#3E3B38",
  "#BDB6AB",
  "#E4DFD6",
  "#514F4D",
  "#A1A29E",
  "#58462C",
  "#A6A9A7",
  "#2D3B50",
  "#354B5E",
  "#A9A092",
  "#303533",
  "#303533",
  "#9AA09C",
  "#959593",
  "#9AA09C",
  "#5E6265",
  "#5E6265",
  "#6A7273",
  "#5C6063",
  "#959C9C",
  "#D9D9CD",
  "#D9D9CD",
  "#E7E9DF",
  "#6A6D70",
  "#6A6D70",
  "#787F80",
  "#7A7D80",
  "#3D3E40",
  "#E2672A",
  "#E2672A",
  "#88473C",
  "#BEC0B9",
  "#BEC0B9",
  "#D4DAD4",
  "#A8BFC8",
  "#78816A",
  "#78816A",
  "#868F78",
  "#868F78",
  "#DADAD7",
  "#939894",
  "#C7E2E3",
  "#9CA0A1",
  "#12273A",
  "#C2B198",
  "#C2B198",
  "#C2B198",
  "#D1C5AD",
  "#D1C5AD",
  "#727C6F",
  "#836F4A",
  "#EFF3F2",
  "#EFF3F2",
  "#F9FFFF",
  "#F9FFFF",
  "#F4F7F5",
  "#F7F8F4",
  "#F9FFFF",
  "#797D7D",
  "#898F8D",
  "#AAB269",
  "#D9DBD8",
  "#A19E98",
  "#1F4E81",
  "#9C8B70",
  "#B9AD97",
  "#877F72",
  "#434138",
  "#85775C",
  "#575042",
  "#BABEBD",
  "#303533",
  "#434138",
  "#BABEBD",
  "#708185",
  "#A98D5F",
  "#7A7363",
  "#696D6E",
  "#EDDBB5",
  "#EDDBB5",
  "#F8E9C2",
  "#F8E9C2",
  "#ECD8B0",
  "#554737",
  "#b9a499",
  "#E6E7DF",
  "#D4A892",
  "#E5BE01",
  "#E98C1A",
  "#E3D9C6",
  "#E3BBA6",
  "#ECC6C1",
  "#FBC651",
  "#AF8C88",
  "#F3B300",
  "#FAD201",
  "#6A5D4D",
  "#DC6F32",
  "#C53940",
  "#F97748",
  "#ED6A40",
  "#B12D42",
  "#A52019",
  "#A72842",
  "#952842",
  "#6F3545",
  "#7B4248",
  "#781F19",
  "#C1876B",
  "#CC0605",
  "#D72D6D",
  "#8673A1",
  "#40428B",
  "#434569",
  "#1E2D6E",
  "#32508D",
  "#4D80C1",
  "#434267",
  "#3A73BA",
  "#063971",
  "#3A5D92",
  "#1D334A",
  "#29748B",
  "#4D644A",
  "#424632",
  "#3D504F",
  "#464748",
  "#35682D",
  "#7B7F6C",
  "#5D4E4C",
  "#709A57",
  "#308446",
  "#9E91A9",
  "#969992",
  "#80737E",
  "#6D6552",
  "#696170",
  "#6E6472",
  "#665C6D",
  "#534E5A",
  "#4F4751",
  "#62565C",
  "#5E5463",
  "#9F8A92",
  "#726C7E",
  "#C2AAAE",
  "#C2AAAE",
  "#D1BBCE",
  "#D1BBCE",
  "#A58F9F",
  "#8E7E8C",
  "#BBA7B3",
  "#7D6C72",
  "#9DA1AA",
  "#8D948D",
  "#4E5452",
  "#CAC4B0",
  "#909090",
  "#82898F",
  "#D0D0D0",
  "#898176",
  "#99524C",
  "#5E4748",
  "#5D4248",
  "#57474F",
  "#4E3B31",
  "#FAF4E3",
  "#E0C6D5",
  "#F4F4F4",
  "#282828",
  "#433C42",
  "#A5A5A5",
  "#A1A1A0",
  "#8F8F8F",
  "#F7D9ED",
  "#463C45",
  "#F6F6F6",
  "#F6F6F6",
  "#D7D7D7",
  "#828282",
  "#493D3B",
  "#634037",
  "#583838",
  "#B3B8B5",
  "#313735",
  "#323735",
  "#595D5A",
  "#C0C5BF",
  "#D0C9B1",
  "#8F9990",
  "#636C6D",
  "#CED5D2",
  "#E7EBDA",
  "#FBFFFF",
  "#E97237",
  "#E5DFCE",
  "#D9CEBE",
  "#9F8E7D",
  "#9F8E7D",
  "#9C9282",
  "#8E573D",
  "#8E573D",
  "#586063",
  "#6C5853",
  "#B9BEBC",
  "#565750",
  "#565750",
  "#4D5453",
  "#4D5453",
  "#353A38",
  "#626663",
  "#626663",
  "#5F483A",
  "#5F483A",
  "#8D9450",
  "#D5D5CA",
  "#D5D5CA",
  "#545040",
  "#545040",
  "#40554C",
  "#AAB1AC",
  "#AAB1AC",
  "#F1A121",
  "#F1A121",
  "#F8AC32",
  "#6C8472",
  "#768A81",
  "#C3B18C",
  "#C3B18C",
  "#E6EAEA",
  "#898C87",
  "#DB9A5D",
  "#4F5C62",
  "#766E63",
  "#B9AD9C",
  "#FFDBD4",
  "#48544F",
  "#DE6A31",
  "#DE6A31",
  "#B3B5AF",
  "#B3B5AF",
  "#B3B5AF",
  "#C2C5BF",
  "#C2C5BF",
  "#476E40",
  "#476E40",
  "#9FA2A2",
  "#91887D",
  "#E2DDD4",
  "#E2DDD4",
  "#F4F4E9",
  "#AE372C",
  "#AE372C",
  "#A94035",
  "#B7B6B2",
  "#919597",
  "#B6BCBB",
  "#969A99",
  "#B1B6B2",
  "#A5ACA8",
  "#ABB2B0",
  "#909190",
  "#E1A98C",
  "#91B0B6",
  "#1B2228",
  "#A48D6A",
  "#3C3B3B",
  "#F5F5EB",
  "#363B4E",
  "#DAC18B",
  "#2C3972",
  "#2C4674",
  "#593435",
  "#F4F4F8",
  "#EAF2F3",
  "#B1ACA3",
  "#454647",
  "#575C5D",
  "#4E5052",
  "#C4BFB9",
  "#909293",
  "#946B3A",
  "#C2AA8D",
  "#CCBCA0",
  "#C5B29B",
  "#908E8A",
  "#908E8A",
  "#616660",
  "#94A19A",
  "#7C8983",
  "#A0A5A7",
  "#618682",
  "#ADC0CA",
  "#DAC9A0",
  "#85898A",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D6D4C9",
  "#E6E9E0",
  "#E6E9E0",
  "#D6DAD4",
  "#91A79A",
  "#55585B",
  "#E5E2D8",
  "#E5E2D8",
  "#504139",
  "#644133",
  "#644133",
  "#6A4C3B",
  "#45565F",
  "#B8B4A8",
  "#525A5E",
  "#736C5F",
  "#3E3B38",
  "#D1C5AD",
  "#F8E9C2",
  "#2E3332",
  "#9EA09E",
  "#E6E9E0",
  "#5C6059",
  "#616560",
  "#616560",
  "#DADAD6",
  "#E1E4E3",
  "#7D8A85",
  "#909D95",
  "#999F9E",
  "#999F9E",
  "#7C8083",
  "#44767C",
  "#9d6355",
  "#595A57",
  "#303535",
  "#AEB7B9",
  "#A5A9AB",
  "#2F4239",
  "#7B7D7E",
  "#68A842",
  "#68A842",
  "#6D6B67",
  "#6D6B67",
  "#767872",
  "#51493F",
  "#56331E",
  "#5A7990",
  "#6386A0",
  "#43553B",
  "#F3F5F1",
  "#F3F5F1",
  "#E7E8DF",
  "#F3F2EA",
  "#F6F8F5",
  "#F4F4EE",
  "#A1A8A7",
  "#FAFFFD",
  "#F9ECD6",
  "#F5ECD8",
  "#FFFDE7",
  "#F8EED8",
  "#FBF5E0",
  "#53595F",
  "#F5F8F3",
  "#627062",
  "#6E7E6E",
  "#DFB465",
  "#6E7E6E",
  "#7E8481",
  "#7E8481",
  "#7E8481",
  "#8D9592",
  "#8D9592",
  "#6E555A",
  "#516A71",
  "#52524D",
  "#52524D",
  "#52524D",
  "#52524E",
  "#5C6059",
  "#5C6059",
  "#E47433",
  "#2A2A2B",
  "#A19E99",
  "#3A3D40",
  "#A3A7A9",
  "#919597",
  "#E7E8DF",
  "#F6A713",
  "#F6A713",
  "#FFB51C",
  "#2C2C2D",
  "#2C2C2D",
  "#3C3F43",
  "#3C3F43",
  "#3B4044",
  "#3B4044",
  "#6C6F72",
  "#6C6F72",
  "#2D2D2E",
  "#2D2D2E",
  "#E3E1D8",
  "#E3E1D8",
  "#ADB1B2",
  "#ABAFB1",
  "#545450",
  "#545450",
  "#F0F4F2",
  "#F0F4F2",
  "#9d958c",
  "#d1cdca",
  "#dfded3",
  "#d4d0ca",
  "#9e968b",
  "#4d423d",
  "#484343",
  "#fcecc5",
  "#6d6c65",
  "#ede8d1",
  "#000000",
  "#c3b9a8",
  "#81725e",
  "#aab4ab",
  "#434542",
  "#616158",
  "#8f9489",
  "#594d3e",
  "#6b6f62",
  "#6d3e36",
  "#5e5348",
  "#ffffff",
  "#63737d",
  "#9ea08a",
  "#3e5d73",
  "#dcceb0",
  "#576161",
  "#c9bfaa",
  "#73796b",
  "#514138",
  "#8299a3",
  "#e7e5d5",
  "#d1cec3",
  "#333c45",
  "#48453c",
  "#808481",
  "#928e82",
  "#a39685",
  "#c3b7a0",
  "#d0c6b4",
  "#aca0a0",
  "#dedfd8",
  "#e0dde8",
  "#891a20",
  "#a3927d",
  "#504541",
  "#605b5d",
  "#2f483b",
  "#25446a",
  "#4f3936",
  "#6b3933",
  "#aa7350",
  "#494d55",
  "#9f9181",
  "#314a40",
  "#abbcc3",
  "#1c4b60",
  "#486c83",
  "#eae3ed",
  "#1a4339",
  "#c8b6aa",
  "#534940",
  "#1f2021",
  "#3e3a38",
  "#385a6b",
  "#cfcfdc",
  "#863e39",
  "#b59380",
  "#a02223",
  "#777570",
  "#cdd0d2",
  "#505255",
  "#100f0f",
  "#979695",
  "#d0c9cc",
  "#4e2c2f",
  "#010005",
  "#393335",
  "#583b35",
  "#948d87",
  "#eae6cd",
  "#4c2f27",
  "#33362d",
  "#c3c3c1",
  "#2e453f",
  "#463f39",
  "#a52a23",
  "#9a9a98",
  "#bbb1a7",
  "#fbfaf8",
  "#876a4f",
  "#51514f",
  "#968e83",
  "#95928e",
  "#696a67",
  "#4c535b",
  "#a3816d",
  "#8d5937",
  "#7d6e5d",
  "#403c39",
  "#925437",
  "#bf9e75",
  "#5b6d76",
  "#a37c59",
  "#564033",
  "#ccc5b7",
  "#d9d9d9",
  "#83654f",
  "#ffffff",
  "#e4e2d8",
  "#aa9a88",
  "#dcd0b5",
  "#cdc8c2",
  "#9a948c",
  "#cbbeb3",
  "#93999c",
  "#f0e9d1",
  "#8397a5",
  "#c1b49e",
  "#e0cbae",
  "#fff1cf",
  "#d2cdbb",
  "#e1e1dd",
  "#5f474b",
  "#686057",
  "#575a5c",
  "#a6a9a8",
  "#4e4c49",
  "#754944",
  "#514b46",
  "#6e6d6d",
  "#4e6157",
  "#4c677b",
  "#4f5c58",
  "#574b47",
  "#424344",
  "#a2a29c",
  "#8f6a45",
  "#afbec3",
  "#818c77",
  "#9a3e43",
  "#c1c2b4",
  "#a99a88",
  "#638391",
  "#84817f",
  "#d2d8d6",
  "#9c5b4f",
  "#595954",
  "#e5dccb",
  "#040707",
  "#751b16",
  "#332c28",
  "#9b8c78",
  "#afb6b5",
  "#183f2e",
  "#726659",
  "#ffffff",
  "#393b3a",
  "#4c3e2f",
  "#997d62",
  "#8b694c",
  "#69493a",
  "#8a4f3c",
  "#242f2d",
  "#4a4739",
  "#d0d0c3",
  "#979a9b",
  "#FFFFFF",
  "#f9ead3",
  "#decfb0",
  "#100c0b",
  "#695e58",
  "#49281f",
  "#64142d",
  "#3e2c14",
  "#7f6661",
  "#c8ba9f",
  "#b5b9bc",
  "#0c452f",
  "#153149",
  "#5d7486",
  "#6b1d11",
  "#afa292",
  "#8f6d4a",
  "#fbf6f2",
  "#eeeef0",
  "#968a76",
  "#868683",
  "#838a91",
  "#857e75",
  "#3d4445",
  "#655541",
  "#585747",
  "#2c3c55",
  "#804039",
  "#58554f",
  "#5a6c7c",
  "#5c6468",
  "#5f6860",
  "#797979",
  "#e5ddcd",
  "#edeadf",
  "#c0cecd",
  "#cfd2c3",
  "#39311e",
  "#e8e5d1",
  "#363332",
  "#000000",
  "#f5f4ed",
  "#7b7562",
  "#5b3738",
  "#4b4940",
  "#485b65",
  "#99a6a7",
  "#863826",
  "#3f351a",
  "#2a4b37",
  "#2f5b48",
  "#474742",
  "#1d584d",
  "#51736f",
  "#004677",
  "#3f4442",
  "#4b2d02",
  "#675b43",
  "#373432",
  "#3f7898",
  "#737577",
  "#282c2d",
  "#3f7897",
  "#398c73",
  "#eef7f5",
  "#e1dbca",
  "#e7e4d1",
  "#99a6a7",
  "#e7e6de",
  "#00676c",
  "#b45414",
  "#ae9076",
  "#54372f",
  "#98887c",
  "#313132",
  "#313132",
  "#313132",
  "#d3cab7",
  "#010101",
  "#a2978a",
  "#ffffff",
  "#90623d",
  "#6e786f",
  "#000000",
  "#f3f3eb",
  "#475b65",
  "#3f351a",
  "#dbdee1",
  "#e7e6dd",
  "#ada18e",
  "#ebe8dc",
  "#949587",
  "#d4d1c7",
  "#fdfdf8",
  "#555551",
  "#4f4535",
  "#253d37",
  "#292817",
  "#6d503d",
  "#514a3d",
  "#454543",
  "#1a1b1c",
  "#3c4233",
  "#6f695d",
  "#5d6060",
  "#76332d",
  "#2b322e",
  "#38484f",
  "#565656",
  "#3a423f",
  "#60757a",
  "#adb8c0",
  "#1a363f",
  "#8f8f7e",
  "#924a36",
  "#633d30",
  "#928b82",
  "#7f5944",
  "#7f807d",
  "#f5f4f0",
  "#a3a284",
  "#4d555e",
  "#dfd5ba",
  "#8b857f",
  "#5f5248",
  "#727f83",
  "#596356",
  "#998475",
  "#9e998f",
  "#b1aea6",
  "#fbefd5",
  "#dfdbce",
  "#77382f",
  "#4d5765",
  "#c9a983",
  "#b3a798",
  "#697453",
  "#a8b4bb",
  "#5e6972",
  "#6e5e54",
  "#6e5e50",
  "#ece9de",
  "#ccbea2",
  "#9fa095",
  "#504f4d",
  "#636058",
  "#7a766c",
  "#757c5f",
  "#c0bfbb",
  "#2f2b2a",
  "#9c908c",
  "#887771",
  "#6a858c",
  "#efefef",
  "#2a2625",
  "#05030b",
  "#39342a",
  "#a59e90",
  "#c1b7a2",
  "#fff6ee",
  "#a18062",
  "#424e53",
  "#615b5d",
  "#26262a",
  "#d0d3dc",
  "#F7F6EF",
  "#e2ddd3",
  "#b8b4a8",
  "#2f2e31",
  "#443a35",
  "#a1a09b",
  "#737373",
  "#625852",
  "#737373",
  "#66676a",
  "#cdc5a5",
  "#262325",
  "#39312c",
  "#b9b09b",
  "#f8f8f8",
  "#000000",
  "#aea590",
  "#dcd1ba",
  "#ffffff",
  "#9d6844",
  "#d9c9af",
  "#f5faf4",
  "#e7d7b3",
  "#1e1e1e",
  "#45403c",
  "#c0b6a5",
  "#384e47",
  "#928986",
  "#9b927f",
  "#858078",
  "#e6e0de",
  "#000000",
  "#6e634d",
  "#602a2a",
  "#36251b",
  "#154535",
  "#f2e8cd",
  "#000000",
  "#65838e",
  "#436585",
  "#9d836b",
  "#4e4a48",
  "#521c01",
  "#403929",
  "#0f3c2b",
  "#2f4e38",
  "#000000",
  "#373530",
  "#717c7b",
  "#a9a897",
  "#9b8d6e",
  "#2b4164",
  "#f1f5f8",
  "#797f65",
  "#b39c85",
  "#444c4d",
  "#235272",
  "#7c402e",
  "#746f66",
  "#695c49",
  "#423e22",
  "#666662",
  "#dcd4bf",
  "#0c0c0e",
  "#19221f",
  "#c6bfad",
  "#f1faf7",
  "#242424",
  "#29231b",
  "#f4f4f2",
  "#736d63",
  "#d7cdb9",
  "#646561",
  "#682e2a",
  "#61544c",
  "#683418",
  "#545e67",
  "#864f29",
  "#a09b8f",
  "#53514e",
  "#725147",
  "#6f6154",
  "#746349",
  "#595755",
  "#4b3828",
  "#555b57",
  "#9a8771",
  "#b6afa7",
  "#a28a75",
  "#555554",
  "#976824",
  "#8d847a",
  "#bbbab3",
  "#434c57",
  "#6d7b82",
  "#80806a",
  "#434446",
  "#a99d8d",
  "#888986",
  "#b9aa92",
  "#796e5f",
  "#626564",
  "#736f66",
  "#574841",
  "#e1e1da",
  "#a6a39a",
  "#543546",
  "#000000",
  "#982721",
  "#3f3928",
  "#5f5e5b",
  "#9c927c",
  "#344f41",
  "#1f4963",
  "#4a6e7d",
  "#1a4535",
  "#ded0b3",
  "#5f453a",
  "#c3bba3",
  "#8c5d2c",
  "#f1f2f0",
  "#7f2f13",
  "#af9778",
  "#5a6265",
  "#fff5c9",
  "#717f65",
  "#accccb",
  "#bd6e50",
  "#3f382e",
  "#5e7270",
  "#e7b26e",
  "#060503",
  "#434746",
  "#212526",
  "#9d9483",
  "#323433",
  "#f9eed8",
  "#493f3d",
  "#274b41",
  "#afa397",
  "#776a61",
  "#ebebe9",
  "#c8c3af",
  "#7e745b",
  "#5f4736",
  "#352b21",
  "#6e3623",
  "#8b8e8c",
  "#6c748c",
  "#141211",
  "#ad9b7a",
  "#55534b",
  "#083931",
  "#5b5d5d",
  "#e6ddcb",
  "#4e2f21",
  "#e1d3b6",
  "#675d43",
  "#ffffff",
  "#54473b",
  "#242021",
  "#2b312f",
  "#b6b3a5",
  "#e8dcc7",
  "#f2f1f7",
  "#0a0203",
  "#837b68",
  "#ede7db",
  "#140b01",
  "#f8f0df",
  "#000000",
  "#48473a",
  "#d7d3cb",
  "#7e8083",
  "#28291f",
  "#b7b09b",
  "#433b35",
  "#0a3210",
  "#9a948c",
  "#3d4445",
  "#f5efe4",
  "#f5efe4",
  "#7f5432",
  "#757561",
  "#a39382",
  "#d3cdbc",
  "#9e8e76",
  "#766340",
  "#572700",
  "#ffffff",
  "#c6b9a0",
  "#dad6d8",
  "#ddbf9c",
  "#7d695d",
  "#9d805f",
  "#633c28",
  "#d2ab7b",
  "#3c434b",
  "#bd8b68",
  "#aa7a47",
  "#774820",
  "#83715b",
  "#93663b",
  "#23211f",
  "#5a4b44",
  "#e8e8e8",
  "#98896f",
  "#9b7c4a",
  "#633b29",
  "#9d8d82",
  "#1e1a15",
  "#8e5c2f",
  "#67402e",
  "#cca778",
  "#97673a",
  "#40392e",
  "#b37f45",
  "#b6aa9c",
  "#8f837b",
  "#232323",
  "#5d5956",
  "#c46623",
  "#66331a",
  "#443730",
  "#1c2317",
  "#000000",
  "#a9a18f",
  "#181717",
  "#e1dbc4",
  "#f9f7f7",
  "#463829",
  "#e1d4c2",
  "#030505",
  "#bebebe",
  "#f5f5f5",
  "#000000",
  "#eef0f0",
  "#7e7f84",
  "#5e4330",
  "#e4d4c1",
  "#ffffff",
  "#4a1711",
  "#4d4b40",
  "#694414",
  "#C97F31",
  "#B1871C",
  "#8A4C11",
  "#9C5634",
  "#2E2927",
  "#786256",
  "#5A5652",
  "#A56F4B",
  "#693424",
  "#5C3B28",
  "#BB8342",
  "#5D3D2E",
  "#242223",
  "#442E26",
  "#593328",
  "#3A3C47",
  "#7A7777",
  "#CDB9B2",
  "#1A1617",
  "#841000",
  "#534B40",
  "#8E867B",
  "#562D01",
  "#B3BAC0",
  "#004833",
  "#D2C9B6",
  "#70665A",
  "#FFFFFF",
  "#55514a",
  "#c4baaa",
  "#efeee5",
  "#ddd9ce",
  "#eeece1",
  "#504A46",
  "#A59484",
  "#888782",
  "#8A5A4C",
  "#E6E0DB",
  "#684f46",
  "#aeaa9d",
  "#313132",
  "#41433C",
  "#ACA7A1",
  "#563638",
  "#554C46",
  "#575C60",
  "#743733",
  "#413D3E",
  "#A7A9A9",
  "#40574C",
  "#394542",
  "#6B7972",
  "#4C3C38",
  "#27292D",
  "#5F544B",
  "#828A75",
  "#1F5371",
  "#A23032",
  "#E8ECEE",
  "#D1CABC",
  "#AD9883",
  "#537C8D",
  "#7E7B77",
  "#E8E7DC",
  "#D8DBDA",
  "#B8A28D",
  "#A34C38",
  "#3B3833",
  "#CABAA0",
  "#010005",
  "#454A4D",
  "#9B8E7E",
  "#F4F1E8",
  "#D9C8AD",
  "#1D181D",
  "#D5D1C9",
  "#BCAE9F",
  "#736242",
  "#423B28",
  "#4C4139",
  "#BAAB96",
  "#424244",
  "#4A443A",
  "#36393B",
  "#DDD9D3",
  "#E7E0CC",
  "#1A1517",
  "#524B3E",
  "#752716",
  "#094536",
  "#C5CDD7",
  "#F7F8F8",
  "#987856",
  "#704F46",
  "#c1bfba",
  "#494a4b",
  "#a59a8d",
  "#695B52",
  "#514946",
  "#B0A89C",
  "#2B2726",
  "#87898C",
  "#494542",
  "#363621",
  "#757a6c",
  "#425966",
  "#e8e4d9",
  "#473933",
  "#6e5a49",
  "#60554c",
  "#5b4f41",
  "#c0b5a0",
  "#c5baa6",
  "#6b6a5b",
  "#acb4ac",
  "#99a098",
  "#67716e",
  "#4e5856",
  "#435454",
  "#3c4d51",
  "#2a2b2c",
  "#7f878a",
  "#626869",
  "#423f3b",
  "#463e3b",
  "#81796f",
  "#72695e",
  "#c0bbae",
  "#4d483d",
  "#d9d9d1",
  "#3d5463",
  "#f2f2eb",
  "#797979",
  "#867d6e",
  "#6e726a",
  "#f2f4f1",
  "#676662",
  "#e3e2da",
  "#f4f6f1",
  "#030303",
  "#f8f0ca",
  "#4c4e4a",
  "#cecece",
  "#ffffff",
  "#3b3020",
  "#98a0ac",
  "#a0917e",
  "#6e3831",
  "#365f76",
  "#8f8c78",
  "#403f41",
  "#a2a298",
  "#695b52",
  "#595c53",
  "#8f8780",
  "#a6998f",
  "#265d79",
  "#2c3c55",
  "#203c51",
  "#475662",
  "#514946",
  "#cecccb",
  "#fafafa",
  "#7b2c06",
  "#636a6d",
  "#777a74",
  "#576c58",
  "#919599",
  "#d5c1a7",
  "#cfd0cc",
  "#6c7275",
  "#5b6163",
  "#746759",
  "#8f5a40",
  "#979784",
  "#494542",
  "#58554f",
  "#f8e4c4",
  "#907460",
  "#595c53",
  "#253739",
  "#79343c",
  "#b57c45",
  "#976645",
  "#a67c4b",
  "#debe98",
  "#6f5241",
  "#ebdfce",
  "#ebe9e0",
  "#eae9e0",
  "#e8e7df",
  "#ad9785",
  "#e5dfd4",
  "#837363",
  "#615447",
  "#bfb5a9",
  "#60544b",
  "#dbd3c6",
  "#d6c3a8",
  "#f3f1e7",
  "#c0beaf",
  "#9ca18d",
  "#868b81",
  "#c2c9bd",
  "#92a098",
  "#7c9392",
  "#596e6b",
  "#617475",
  "#455454",
  "#9dabab",
  "#4b4042",
  "#3f4445",
  "#dae5df",
  "#b3c7c8",
  "#7f9a9f",
  "#5d6d76",
  "#c7cbce",
  "#aab1b6",
  "#555c64",
  "#2a2b2c",
  "#e5e4de",
  "#b7bbba",
  "#7f878a",
  "#3a3b3b",
  "#d5d4d0",
  "#c6c3c0",
  "#b3b1ae",
  "#828080",
  "#c6c7c5",
  "#efece1",
  "#d5cabd",
  "#948c83",
  "#eae5dc",
  "#d5d1c6",
  "#a6a39a",
  "#d9d8d1",
  "#b7b7af",
  "#838682",
  "#61635e",
  "#4b4b45",
  "#235083",
  "#ecefec",
  "#557280",
  "#6b877a",
  "#fedc98",
  "#de9777",
  "#a55b3f",
  "#3f373e",
  "#c3b39a",
  "#13171c",
  "#e9e4da",
  "#bdc4c5",
  "#eadfc8",
  "#f3f3f0",
  "#efedea",
  "#efefec",
  "#e6e3da",
  "#eeeee7",
  "#e7e4dd",
  "#424242",
  "#84837d",
  "#5e5b56",
  "#6f645c",
  "#5d5651",
  "#938c7c",
  "#dac988",
  "#bbc0a9",
  "#c8cbc5",
  "#9ca19a",
  "#979f9b",
  "#767a72",
  "#4e5351",
  "#cccfcd",
  "#8da09f",
  "#698587",
  "#42676f",
  "#425862",
  "#b5c2c5",
  "#81959d",
  "#64737a",
  "#424547",
  "#a7aeb0",
  "#5c6568",
  "#565f6b",
  "#515b63",
  "#4e535c",
  "#5e5b5d",
  "#4b4042",
  "#5f444a",
  "#624c4d",
  "#9fa8ac",
  "#a6a19a",
  "#dedede",
  "#e2dcc0",
  "#aeae9a",
  "#f7f1cc",
  "#cbd0c9",
  "#d8d4bf",
  "#bbc2aa",
  "#f0ead6",
  "#c5bea2",
  "#fbf9f9",
  "#343032",
  "#5b433b",
  "#584d45",
  "#a29d8a",
  "#ffffff",
  "#bcb6a1",
  "#4a494a",
  "#ffffff",
  "#cec6ba",
  "#74655a",
  "#46413c",
  "#c4b6a2",
  "#bcb6b1",
  "#615347",
  "#605951",
  "#8b8882",
  "#222944",
  "#7d4037",
  "#777a74",
  "#c0b6a7",
  "#8a8f92",
  "#838a92",
  "#e4d7c6",
  "#778d99",
  "#4e606d",
  "#b1a693",
  "#d3bea1",
  "#515557",
  "#857e75",
  "#5f6860",
  "#79797a",
  "#efdab3",
  "#000000",
  "#4e4539",
  "#9b917f",
  "#d1bf9f",
  "#ffffff",
  "#141414",
  "#39311d",
  "#69735a",
  "#e9e8d3",
  "#363432",
  "#004583",
  "#231f20",
  "#f6f5f1",
  "#7c7562",
  "#5b3838",
  "#b93232",
  "#ccc4af",
  "#485b65",
  "#9aa7a9",
  "#943c29",
  "#c6701b",
  "#3f351a",
  "#2e5c48",
  "#6b7b84",
  "#b3ada5",
  "#1b584e",
  "#537878",
  "#004678",
  "#404543",
  "#4b2d05",
  "#675b44",
  "#1d1c0f",
  "#3f7998",
  "#747577",
  "#366889",
  "#378c73",
  "#e2dccb",
  "#c6b291",
  "#8e8f92",
  "#919392",
  "#e8e8e1",
  "#00686d",
  "#b55513",
  "#7b868e",
  "#000000",
  "#414141",
  "#314d43",
  "#f9feff",
  "#483c22",
  "#e5dbc7",
  "#d5c4b6",
  "#aba79f",
  "#efede9",
  "#f4f4f7",
  "#48292f",
  "#463f32",
  "#545657",
  "#a1a4a2",
  "#2e4f39",
  "#692a2c",
  "#524f4e",
  "#474647",
  "#273d1e",
  "#6e7e77",
  "#422c1f",
  "#544b3a",
  "#6c6d6d",
  "#9a9990",
  "#921a2c",
  "#335369",
  "#c8c4b6",
  "#c9b9a2",
  "#6a8f9e",
  "#84817d",
  "#dfddd5",
  "#3e6a62",
  "#a6592c",
  "#83a684",
  "#dad6b4",
  "#9e9687",
  "#a72225",
  "#030203",
  "#eaecda",
  "#194726",
  "#6c2b11",
  "#181b15",
  "#969b93",
  "#0e291b",
  "#3d241c",
  "#5b4f30",
  "#4e463a",
  "#6b7f56",
  "#e1e8e3",
  "#15335f",
  "#cdcdb5",
  "#a99474",
  "#4f7483",
  "#686355",
  "#f4f4e6",
  "#dae1da",
  "#a84729",
  "#928d8a",
  "#828486",
  "#79563f",
  "#8d8581",
  "#956e4f",
  "#bbb3af",
  "#906d4b",
  "#978b81",
  "#514946",
  "#6e3831",
  "#375348",
  "#cecccb",
  "#365f76",
  "#79343c",
  "#203c51",
  "#695b52",
  "#8f5a40",
  "#87898c",
  "#664f40",
  "#626869",
  "#71706d",
  "#3f3a34",
  "#ffffff",
  "#ded9c9",
  "#dfe1de",
  "#aeafac",
  "#5e6367",
  "#1d4933",
  "#30291f",
  "#a9abac",
  "#000013",
  "#5e4f2a",
  "#dfe1de",
  "#ded9ca",
  "#827870",
  "#a5978b",
  "#130600",
  "#831002",
  "#524c3f",
  "#b1a89c",
  "#562e04",
  "#b5bbc0",
  "#004833",
  "#d3ccb9",
  "#71675b",
  "#57493e",
  "#d8b689",
  "#50433b",
  "#e8e8e8",
  "#e8d5b7",
  "#d2d9d5",
  "#000000",
  "#babcb4",
  "#c9a585",
  "#ca2c38",
  "#d3dedc",
  "#9a7c61",
  "#4c1b1b",
  "#d4d5cf",
  "#ded2c3",
  "#665f5a",
  "#574139",
  "#3b3533",
  "#282a2a",
  "#233835",
  "#a9242f",
  "#007a6e",
  "#007864",
  "#cfa269",
  "#004e62",
  "#3a4040",
  "#004063",
  "#004b34",
  "#5f4d47",
  "#93ac92",
  "#2f8777",
  "#a99b8c",
  "#e3dfd8",
  "#919898",
  "#0078a5",
  "#6a7960",
  "#00a7b8",
  "#1b797f",
  "#006c4a",
  "#a9a29a",
  "#bfbcb7",
  "#ad9b7c",
  "#b2352b",
  "#009484",
  "#cac8c4",
  "#c8b79f",
  "#6e4729",
  "#73392f",
  "#4e2b1b",
  "#362218",
  "#b07540",
  "#d09041",
  "#d39c57",
  "#b96e3a",
  "#892c23",
  "#9d6134",
  "#9b3b26",
  "#000000",
  "#351900",
  "#aea295",
  "#bcaf9f",
  "#5b5b59",
  "#8d3428",
  "#000000",
  "#ffffff",
  "#573d2b",
  "#4f2a30",
  "#383a2c",
  "#565656",
  "#ada48a",
  "#a87548",
  "#851c23",
  "#215134",
  "#1a4766",
  "#a1a8a5",
  "#2a6e88",
  "#e2ebe6",
  "#d8d3b6",
  "#c3a67f",
  "#6b7289",
  "#231f20",
  "#aa9977",
  "#545149",
  "#003830",
  "#595b5b",
  "#e5dbc9",
  "#4c2d21",
  "#e0d1b5",
  "#665b42",
  "#ffffff",
  "#b58c6a",
  "#57341e",
  "#666955",
  "#d1c8b6",
  "#9b2026",
  "#dcded8",
  "#523136",
  "#9f673d",
  "#a7a6a5",
  "#8f8176",
  "#5d5a59",
  "#3b5040",
  "#6d3832",
  "#3e3937",
  "#9ea09f",
  "#2f2c2e",
  "#2e3f39",
  "#443632",
  "#2e3132",
  "#5c5246",
  "#7e846f",
  "#747270",
  "#124c64",
  "#dcdedb",
  "#c6bfae",
  "#a18d7b",
  "#aba6a6",
  "#466f81",
  "#7a7675",
  "#d2d4d1",
  "#0c645d",
  "#9b4d3c",
  "#202225",
  "#171d1b",
  "#eeeee9",
  "#5a5c5d",
  "#584c42",
  "#979da9",
  "#a0917e",
  "#7e7e80",
  "#8e8c76",
  "#3e403f",
  "#98948b",
  "#645b52",
  "#6f6151",
  "#8f867f",
  "#a79990",
  "#46606f",
  "#484540",
  "#e5ddd2",
  "#40444d",
  "#585d60",
  "#53504d",
  "#9b8975",
  "#7d473b",
  "#646c6f",
  "#787a75",
  "#f7f7f7",
  "#7e7979",
  "#c1b4a2",
  "#443c3c",
  "#616557",
  "#92959a",
  "#e0d3b3",
  "#d6e3d9",
  "#73726e",
  "#6e7376",
  "#746757",
  "#78786c",
  "#524a3f",
  "#f8e0c2",
  "#8c7766",
  "#65655d",
  "#3f4749",
  "#b2a690",
  "#ffd5cb",
  "#fbbeb2",
  "#f1d4c0",
  "#6f6151",
  "#65594a",
  "#e2d8cf",
  "#dcd3ca",
  "#d2c8bd",
  "#c3b8ae",
  "#a99a8d",
  "#968777",
  "#806d60",
  "#e8dcd1",
  "#f0ceb6",
  "#d3c4ba",
  "#ccb9ad",
  "#b49c8d",
  "#977d6c",
  "#8c6d5e",
  "#7e6355",
  "#e7ddcf",
  "#ded0c0",
  "#cab9a8",
  "#b49f8b",
  "#dcaa86",
  "#9d8774",
  "#887361",
  "#836f5d",
  "#e5dbce",
  "#dfd2c4",
  "#d1c0af",
  "#b8a18c",
  "#9c806d",
  "#8f7662",
  "#775e4b",
  "#da9b72",
  "#e2d4c2",
  "#dccebb",
  "#cfbca4",
  "#bca68c",
  "#a58d72",
  "#8a735b",
  "#826c54",
  "#e1d6c1",
  "#dcccb3",
  "#cfba9c",
  "#bd7750",
  "#bca47e",
  "#a98e69",
  "#997c57",
  "#826849",
  "#e7d9be",
  "#dfceae",
  "#d3c09d",
  "#c1a77d",
  "#a7885b",
  "#8d6e43",
  "#9c6040",
  "#856846",
  "#e8dcc8",
  "#e1cfb5",
  "#cdb99f",
  "#b8a183",
  "#a68c6c",
  "#987c5d",
  "#8b7355",
  "#e6d6bc",
  "#dfceb3",
  "#f6e0c8",
  "#d3be9e",
  "#c2a680",
  "#b6976c",
  "#aa855b",
  "#987248",
  "#eee4d0",
  "#e9ddc5",
  "#e2ceaf",
  "#dac4a3",
  "#c9ac86",
  "#f1d5b7",
  "#c19d73",
  "#a77f57",
  "#eadac2",
  "#e7d8be",
  "#ddc9ac",
  "#c9b394",
  "#c0a787",
  "#b0987a",
  "#a08461",
  "#e5d5c3",
  "#f1caa7",
  "#dfcdbb",
  "#d7c2ad",
  "#c9af98",
  "#b4967a",
  "#957459",
  "#8e7056",
  "#f1e2ce",
  "#ead6bd",
  "#e5caac",
  "#d3b28e",
  "#e7b388",
  "#c39b74",
  "#ae8157",
  "#a97b54",
  "#eadfc9",
  "#e8dac1",
  "#dacaac",
  "#c9ae84",
  "#c2a579",
  "#b39666",
  "#a8875b",
  "#f7a292",
  "#dea173",
  "#ead4b0",
  "#e3c79d",
  "#d5b387",
  "#cda674",
  "#bf9364",
  "#b88d60",
  "#ac8255",
  "#ead6b6",
  "#ead2b1",
  "#e6c8a3",
  "#d49262",
  "#d4b385",
  "#caa472",
  "#bf9765",
  "#a47c4f",
  "#eedcbe",
  "#e8d0ae",
  "#dabd98",
  "#caa77a",
  "#b79163",
  "#9b7149",
  "#ca8354",
  "#8f6541",
  "#dfccb6",
  "#dac5ac",
  "#c8ac8e",
  "#b99978",
  "#977555",
  "#927254",
  "#d8c4ab",
  "#c8ab8b",
  "#f7e8ce",
  "#c5a485",
  "#b6906b",
  "#a3795a",
  "#956e56",
  "#825e46",
  "#f2e3d0",
  "#ead3bb",
  "#e3c3a6",
  "#d2ab88",
  "#ba8d65",
  "#f6debf",
  "#9c6e49",
  "#8f6748",
  "#ebd7bf",
  "#e4ccb1",
  "#e2c19c",
  "#d5ae83",
  "#cc9764",
  "#be8759",
  "#b68253",
  "#efdfcc",
  "#f7d6b1",
  "#e9d4c0",
  "#e0c3ad",
  "#d9bca5",
  "#cda688",
  "#c49676",
  "#a87857",
  "#f0e2d2",
  "#e8d7c6",
  "#e0c8b6",
  "#d0b19b",
  "#f0c9a1",
  "#b59077",
  "#a47b64",
  "#99745d",
  "#eddbcd",
  "#e7d1c2",
  "#dcc0af",
  "#d8baa5",
  "#c4a289",
  "#bd9174",
  "#9c7059",
  "#e6b789",
  "#f0e2d4",
  "#ebdacc",
  "#e2c8ba",
  "#d6b3a3",
  "#d0ae9f",
  "#bc917f",
  "#9c725f",
  "#e6cfc5",
  "#e0c4b8",
  "#cfaea0",
  "#dd9d65",
  "#bf9789",
  "#b98d7d",
  "#a67768",
  "#8d5d50",
  "#f2e3d7",
  "#f0dbd2",
  "#e5c8bf",
  "#d9b3a6",
  "#ca9c8e",
  "#bb8877",
  "#d0864e",
  "#985949",
  "#f2d9cc",
  "#e8c5b8",
  "#d2a08e",
  "#c18872",
  "#b67861",
  "#9e624d",
  "#905b47",
  "#f2c8b5",
  "#e4b5a6",
  "#ef8c7d",
  "#fae0c1",
  "#d49b8a",
  "#c1796a",
  "#b36957",
  "#a5594e",
  "#8e5049",
  "#e2c1ab",
  "#dcb79f",
  "#cfa68d",
  "#bc8b6e",
  "#a26e57",
  "#fbd8ae",
  "#9b6752",
  "#875e4c",
  "#f6e4d6",
  "#f1d9c6",
  "#e8c6b0",
  "#deb59d",
  "#b67d5e",
  "#9c664b",
  "#dab8a1",
  "#fed1a5",
  "#caa286",
  "#b98766",
  "#b17d60",
  "#a07259",
  "#8e6552",
  "#825a49",
  "#d8bdad",
  "#c39d87",
  "#b78c75",
  "#a77964",
  "#f4c08b",
  "#86604f",
  "#7c5b4e",
  "#cdb5aa",
  "#b5988a",
  "#997968",
  "#8e6e5f",
  "#725748",
  "#645145",
  "#5f5047",
  "#eda768",
  "#e8d9d4",
  "#e0cec9",
  "#cfb7b1",
  "#bfa4a0",
  "#a58785",
  "#866963",
  "#6a544c",
  "#eae1de",
  "#dfd1d0",
  "#cdb9bb",
  "#efa361",
  "#bda7a8",
  "#a2898b",
  "#7f6868",
  "#5f4e4b",
  "#e1c6c5",
  "#d8b4b5",
  "#c89896",
  "#9a6d6b",
  "#8c5956",
  "#774d4a",
  "#d78a4b",
  "#634543",
  "#e8d7d5",
  "#e0cacb",
  "#d2b4b3",
  "#be999a",
  "#996e6f",
  "#85595d",
  "#6d4243",
  "#f6dfe0",
  "#f2cccf",
  "#f8ebd2",
  "#e5b6bf",
  "#d89fa8",
  "#c68691",
  "#ae6c75",
  "#914d4e",
  "#f4d7d5",
  "#ebc7c9",
  "#e4b2b5",
  "#d29a9c",
  "#c7868c",
  "#f9e3c6",
  "#b17376",
  "#905455",
  "#f3d3d1",
  "#e9b2b4",
  "#df979c",
  "#dd9091",
  "#c36b6e",
  "#ab5f5e",
  "#9b4b49",
  "#f2d7d0",
  "#fed9af",
  "#efc8c5",
  "#e4b2ae",
  "#d99a94",
  "#bc746b",
  "#ae675e",
  "#89504e",
  "#e69a95",
  "#cc7469",
  "#b66156",
  "#ed7b6c",
  "#fdce9e",
  "#a64c43",
  "#984841",
  "#fec1bf",
  "#ef8b84",
  "#e66f68",
  "#d2564a",
  "#c14c45",
  "#b84945",
  "#a84342",
  "#f9bb80",
  "#f9c6cc",
  "#f7b4be",
  "#e7838d",
  "#d85c66",
  "#cb4746",
  "#bd3a42",
  "#a54048",
  "#f5dcd9",
  "#f6c1c6",
  "#ee989e",
  "#fdb06d",
  "#e76f75",
  "#c24c4d",
  "#b03e43",
  "#a03d41",
  "#fac6d1",
  "#fab6c5",
  "#f7a2b4",
  "#eb8496",
  "#dd6779",
  "#bb4254",
  "#f79547",
  "#a5414d",
  "#f7d9d7",
  "#f9d0d1",
  "#f5b1bb",
  "#ef949d",
  "#e86674",
  "#bc4550",
  "#b04253",
  "#f6d6d6",
  "#f0b4c1",
  "#fae6ce",
  "#e59aa8",
  "#d5788b",
  "#b9596a",
  "#ad364e",
  "#963f50",
  "#f5c5dc",
  "#e898bf",
  "#dd7aa5",
  "#c9527f",
  "#b24668",
  "#f8ddc0",
  "#af405b",
  "#9d3c53",
  "#f3d6da",
  "#f3d1db",
  "#e3afc5",
  "#c77a9a",
  "#9e5774",
  "#7d485a",
  "#674a4e",
  "#f2dcde",
  "#fcd2ab",
  "#e9cdd6",
  "#ddb2c6",
  "#c997af",
  "#ba7699",
  "#924e6a",
  "#6c4551",
  "#eee0e2",
  "#eed5df",
  "#e2c4d5",
  "#d8b2ca",
  "#fec79b",
  "#bd90ae",
  "#8f6483",
  "#755172",
  "#eee2de",
  "#e4d3d6",
  "#d6bfce",
  "#ccaec5",
  "#bb95ae",
  "#8d6782",
  "#6d4a61",
  "#fdb580",
  "#e1d4dd",
  "#d4c7d6",
  "#cdbfd1",
  "#aa98ad",
  "#9a83a0",
  "#7d6685",
  "#5b435d",
  "#e3dddd",
  "#dccddd",
  "#cbb7d0",
  "#fca367",
  "#b498bd",
  "#9f7ca5",
  "#76597f",
  "#544556",
  "#e3dce8",
  "#d4c7e2",
  "#bdadd5",
  "#ab97c8",
  "#9379b0",
  "#6c598d",
  "#dc624d",
  "#f58c40",
  "#635083",
  "#e0e1e8",
  "#d3d1e0",
  "#c7c3d9",
  "#b2aac8",
  "#9c94bb",
  "#897eaa",
  "#5e5384",
  "#e9ebe6",
  "#d9dbe2",
  "#f9e8c4",
  "#d2d2dc",
  "#c3c2d0",
  "#a6a6bd",
  "#827f92",
  "#514c5a",
  "#daddea",
  "#d5dae6",
  "#c8d0e3",
  "#b4bdd9",
  "#929bc2",
  "#fae0b2",
  "#8085b4",
  "#53588a",
  "#d6d8df",
  "#c5c8d4",
  "#acb3ca",
  "#9aa1b9",
  "#7c819d",
  "#696d86",
  "#504c5b",
  "#d0d5e3",
  "#fddca8",
  "#c5ccdf",
  "#bdc5dc",
  "#a7b1cc",
  "#93a0bd",
  "#747d92",
  "#5c6274",
  "#dee2e3",
  "#c9d0d8",
  "#b3b9c7",
  "#a0a6b6",
  "#fccf8e",
  "#84899a",
  "#6e7182",
  "#49484c",
  "#e4ddde",
  "#d6ced1",
  "#c4bcc0",
  "#b4a9af",
  "#a39499",
  "#928187",
  "#765f61",
  "#fbbc6b",
  "#e5e0dd",
  "#d3cfd0",
  "#c1b9bd",
  "#afa8ae",
  "#988b90",
  "#7a6f74",
  "#675c5f",
  "#e5e0db",
  "#dcd9d5",
  "#cacac8",
  "#f8ac57",
  "#b3b1b0",
  "#a09e9d",
  "#797271",
  "#60544f",
  "#dbd8ce",
  "#cfccc4",
  "#b4b2ae",
  "#a29d96",
  "#8b847c",
  "#f99d48",
  "#726a62",
  "#c7c7c2",
  "#b6b4ac",
  "#adaba2",
  "#99958c",
  "#8d887a",
  "#6b655b",
  "#dfe1db",
  "#d4d7d2",
  "#fcebc8",
  "#cbcfc9",
  "#bbbeb8",
  "#a4a79e",
  "#898c83",
  "#565851",
  "#c8c6b9",
  "#c1bfb1",
  "#aeaa9a",
  "#95917f",
  "#7b7665",
  "#fee3b1",
  "#6e6958",
  "#5d594c",
  "#e7e7dd",
  "#dddccd",
  "#c7c8b7",
  "#9a9c87",
  "#878872",
  "#626451",
  "#e3e2d5",
  "#f7dbcf",
  "#fde0af",
  "#d4d3c3",
  "#c4c2b0",
  "#afab93",
  "#a39f87",
  "#87846b",
  "#696753",
  "#e1dfcf",
  "#dad9c9",
  "#d2d1bf",
  "#c5c3ae",
  "#ffd99f",
  "#aea98f",
  "#999275",
  "#81795e",
  "#edebdd",
  "#e5e3d4",
  "#dedbc7",
  "#cdcab2",
  "#b9b396",
  "#a29675",
  "#877c5e",
  "#fdc983",
  "#e2decf",
  "#dad5c6",
  "#cdc7b3",
  "#b8ae95",
  "#aca182",
  "#8e8163",
  "#6f664e",
  "#e0ded1",
  "#dbd8c9",
  "#cecbba",
  "#fec478",
  "#c0bba9",
  "#a8a189",
  "#8f866b",
  "#7d735d",
  "#d0cdc2",
  "#bab5a7",
  "#a09a89",
  "#918a78",
  "#7f7766",
  "#ffa84e",
  "#6c6453",
  "#ccc7bd",
  "#beb8ae",
  "#b6afa3",
  "#a59a8d",
  "#8b8274",
  "#7c7567",
  "#e3e0d7",
  "#dad6cc",
  "#f5e8ce",
  "#c5c1b8",
  "#b8b4ac",
  "#a69f93",
  "#908878",
  "#726859",
  "#ddddd3",
  "#cfd0c5",
  "#c2c3b9",
  "#b0b0a5",
  "#9a9a8e",
  "#fde0b5",
  "#8b8a7b",
  "#696757",
  "#d5dbd2",
  "#c7cfc8",
  "#b3beb9",
  "#a3b0ae",
  "#8b9490",
  "#7a847f",
  "#616964",
  "#cfd3c8",
  "#fedbae",
  "#bfc6bb",
  "#b0b9b2",
  "#a7b3aa",
  "#a2ada5",
  "#8b978e",
  "#646b61",
  "#d3d9d2",
  "#c9cfc9",
  "#9da8a1",
  "#fad4a4",
  "#818981",
  "#6a716a",
  "#d6ddd5",
  "#c9d3d0",
  "#b9c5c3",
  "#a7b2b0",
  "#8f9999",
  "#788181",
  "#646b68",
  "#f5c382",
  "#e0e2dc",
  "#ced2ce",
  "#b4bbbc",
  "#a0a8a8",
  "#83898a",
  "#6c7171",
  "#4b4e4e",
  "#c8cdcd",
  "#c0c6c5",
  "#adb3b3",
  "#fed6ca",
  "#f0ba77",
  "#9a9f9e",
  "#888d8f",
  "#6a6f70",
  "#444647",
  "#cfd4d1",
  "#b9bfbe",
  "#9ea5a5",
  "#7f8487",
  "#696d72",
  "#54585c",
  "#e39a50",
  "#4c4f52",
  "#d8d9d8",
  "#c6cbcc",
  "#b0b4b7",
  "#9a9fa2",
  "#7f8386",
  "#626568",
  "#4b4d4f",
  "#dae0e3",
  "#c8d2d6",
  "#f6eaca",
  "#b1bfc7",
  "#9eadb7",
  "#81909b",
  "#67737c",
  "#4e5357",
  "#d0d8d9",
  "#c0cacd",
  "#acb7c0",
  "#97a2ae",
  "#758391",
  "#f7e3bf",
  "#5f666c",
  "#464748",
  "#d4dedd",
  "#c3d0d2",
  "#a2b4ba",
  "#86989e",
  "#66797f",
  "#607077",
  "#494e52",
  "#c8d8d9",
  "#f5dbb0",
  "#bdd1d4",
  "#b1c7cb",
  "#a1bac0",
  "#84a0ab",
  "#6e8791",
  "#5e7480",
  "#dae3e2",
  "#bfd0d4",
  "#9bb1bb",
  "#7c939e",
  "#f3cf9c",
  "#627885",
  "#445962",
  "#435155",
  "#c8dee2",
  "#b9d3da",
  "#aecbd4",
  "#95b9c6",
  "#769eb0",
  "#618697",
  "#4e646f",
  "#ebbc7f",
  "#d4e2e4",
  "#c3d7dd",
  "#a4c1cd",
  "#8fafbf",
  "#7092a3",
  "#537284",
  "#415663",
  "#cbdcdf",
  "#b0c9d0",
  "#93b1bc",
  "#e1a863",
  "#7f9dac",
  "#6b8895",
  "#67818f",
  "#4c636e",
  "#cbdde2",
  "#bcd4dd",
  "#a0bece",
  "#81a2b6",
  "#63879f",
  "#4e738c",
  "#c58240",
  "#3f5266",
  "#f7e7c5",
  "#f9c4b3",
  "#f6e1aa",
  "#fcdb94",
  "#fcce73",
  "#ffc963",
  "#f5b54f",
  "#dfa34a",
  "#f6e9c4",
  "#f4e2b5",
  "#f1dbaa",
  "#f6d797",
  "#f5a48c",
  "#f1ca7f",
  "#ecb35d",
  "#d59d4e",
  "#f6ecd3",
  "#f2e6c8",
  "#f1dcb5",
  "#eacfa0",
  "#e5c48b",
  "#e3b26f",
  "#d0a05b",
  "#f19378",
  "#f7edd5",
  "#f4e2c0",
  "#edd5ac",
  "#e1c28b",
  "#d5af70",
  "#bf9652",
  "#b08749",
  "#f5e9c2",
  "#f2e1b4",
  "#edd7a4",
  "#ffc1b6",
  "#ef7a5f",
  "#e7cd8d",
  "#c92e2e",
  "#d33a41",
  "#e04c5b",
  "#f57f94",
  "#fdacbd",
  "#ffcdd8",
  "#fce2e6",
  "#ca2c2c",
  "#d5393f",
  "#e14b5a",
  "#f57e92",
  "#feacbd",
  "#ffcdd8",
  "#fee2e7",
  "#cf312b",
  "#d93e3c",
  "#e65458",
  "#f88791",
  "#ffb3bd",
  "#ffd3d8",
  "#fde7e8",
  "#b5332c",
  "#c33d3d",
  "#d44c57",
  "#ed7e8e",
  "#f9abba",
  "#fecdd6",
  "#fde2e6",
  "#a0372f",
  "#b14040",
  "#ca4f5a",
  "#e47f90",
  "#f5acbc",
  "#fcccd6",
  "#fce3e7",
  "#8a453e",
  "#9c5251",
  "#c78086",
  "#e1adb3",
  "#f0cdd1",
  "#f7e4e4",
  "#9d3d2d",
  "#a54337",
  "#b14c45",
  "#d37878",
  "#eaa6a9",
  "#f6c8ca",
  "#fae0e0",
  "#a33a2d",
  "#ae4138",
  "#be4e4e",
  "#de7c83",
  "#f2aab3",
  "#facbd0",
  "#fce1e3",
  "#bd4638",
  "#c94f43",
  "#d75f56",
  "#f0908d",
  "#fbb9b9",
  "#fed6d5",
  "#fde8e6",
  "#d33b2b",
  "#dc4739",
  "#e75a50",
  "#f88a87",
  "#ffb6b6",
  "#ffd4d3",
  "#fde7e4",
  "#e1c478",
  "#d7402b",
  "#df4c37",
  "#e95f4d",
  "#f98f83",
  "#ffb9b3",
  "#ffd7d1",
  "#fde9e3",
  "#e0412b",
  "#e7513b",
  "#f06450",
  "#fd988e",
  "#ffbeb8",
  "#ffd9d4",
  "#fdeae6",
  "#e04227",
  "#e75136",
  "#f16750",
  "#fe9989",
  "#ffc0b7",
  "#ffdbd4",
  "#fdebe5",
  "#e34c28",
  "#ea5933",
  "#f46f4b",
  "#ff9e84",
  "#ffc5b5",
  "#ffded3",
  "#fdede5",
  "#e95823",
  "#ef6530",
  "#f77946",
  "#ffa67e",
  "#ffcab0",
  "#ffe1cf",
  "#fdefe2",
  "#f0701a",
  "#f57c28",
  "#fb8b3c",
  "#ffb577",
  "#ffd4aa",
  "#ffe7cb",
  "#fcf2e1",
  "#f47c1b",
  "#f78523",
  "#fc9537",
  "#ffba71",
  "#ffd8a6",
  "#ffeac9",
  "#fcf3de",
  "#f98a0c",
  "#fc931e",
  "#ffa134",
  "#ffc36f",
  "#ffdda6",
  "#ffecc7",
  "#fcf4de",
  "#ff9f00",
  "#ffa706",
  "#ffb229",
  "#ffcf6b",
  "#ffe4a1",
  "#fef0c6",
  "#fbf6dd",
  "#ffaf00",
  "#ffb700",
  "#ffc21b",
  "#ffd766",
  "#ffe89f",
  "#fef2c3",
  "#fbf6db",
  "#deb866",
  "#ffb000",
  "#ffb600",
  "#ffc31e",
  "#ffd867",
  "#ffe99f",
  "#fff3c4",
  "#fbf7dd",
  "#ffbd00",
  "#ffc400",
  "#ffce0b",
  "#ffde64",
  "#ffec9e",
  "#fef4c3",
  "#fbf7db",
  "#ffd400",
  "#ffd600",
  "#ffdb00",
  "#ffe765",
  "#fff19f",
  "#fdf5c4",
  "#faf7dc",
  "#ecc900",
  "#f0cd00",
  "#f8d60a",
  "#fae466",
  "#fef0a1",
  "#fcf5c4",
  "#fbf8dd",
  "#c1b400",
  "#ccbb0e",
  "#d7c52e",
  "#ecdc71",
  "#f6eca9",
  "#faf4c8",
  "#faf8e0",
  "#b4ca00",
  "#c3cf00",
  "#d2d612",
  "#e1e465",
  "#f0f09f",
  "#f7f6c3",
  "#f7f8db",
  "#97c100",
  "#a4c700",
  "#bdd120",
  "#d2e169",
  "#e7efa0",
  "#f3f5c5",
  "#f7f8dc",
  "#99b009",
  "#abb915",
  "#bfc428",
  "#d5d869",
  "#e8e99f",
  "#f2f2c3",
  "#f5f6db",
  "#79a21e",
  "#88aa27",
  "#a6ba32",
  "#c3d16f",
  "#dde5a3",
  "#edf1c7",
  "#f4f6dd",
  "#569128",
  "#669a30",
  "#7ba640",
  "#acc774",
  "#cddfa7",
  "#e4eec8",
  "#f0f5de",
  "#c99b42",
  "#33a122",
  "#48ab2c",
  "#61b83e",
  "#97d477",
  "#bfe8aa",
  "#dbf3cb",
  "#ecf7e0",
  "#50ab18",
  "#62b424",
  "#78bf38",
  "#a7d873",
  "#cbeaa7",
  "#e1f3c9",
  "#eff8df",
  "#169928",
  "#32a431",
  "#4eb245",
  "#88d17e",
  "#b6e6af",
  "#d5f2ce",
  "#e7f6e1",
  "#008a31",
  "#00983c",
  "#31aa50",
  "#72cc88",
  "#a6e3b5",
  "#cbf0d2",
  "#e3f6e5",
  "#207337",
  "#2f7d3f",
  "#448c4e",
  "#7fb37f",
  "#aed2b0",
  "#cfe6ce",
  "#e5f1e2",
  "#136938",
  "#227442",
  "#348354",
  "#71ad87",
  "#a3cdb5",
  "#c8e3d2",
  "#e1f0e4",
  "#2f6f46",
  "#347e50",
  "#429565",
  "#75c099",
  "#a4dcc1",
  "#c9ecda",
  "#e2f5e9",
  "#00703a",
  "#00874a",
  "#00a162",
  "#53c799",
  "#94e1c2",
  "#c0efdb",
  "#dcf6e9",
  "#0c6546",
  "#007c56",
  "#0a976d",
  "#5bc2a2",
  "#95ddc7",
  "#bfedde",
  "#dcf6eb",
  "#006242",
  "#008158",
  "#009e75",
  "#35c6a8",
  "#85dfcb",
  "#b8eee0",
  "#d8f6ec",
  "#f3ebd4",
  "#105a3c",
  "#0a6548",
  "#17775c",
  "#5ca492",
  "#bfe0d7",
  "#d9ede7",
  "#2a453d",
  "#296253",
  "#34816f",
  "#65b4a5",
  "#9ad5cb",
  "#c2e8e0",
  "#def4ed",
  "#006047",
  "#007e5d",
  "#009d7b",
  "#3dc6ab",
  "#86decd",
  "#b8eee1",
  "#d8f5ec",
  "#055143",
  "#00745d",
  "#00967a",
  "#45c1ac",
  "#89dccd",
  "#b8ebe1",
  "#d7f4ec",
  "#006149",
  "#008363",
  "#009f7e",
  "#25c7af",
  "#7edecd",
  "#b3ede1",
  "#d3f4eb",
  "#005949",
  "#007c61",
  "#009c7d",
  "#24c5ae",
  "#7fddcf",
  "#b3ede2",
  "#d4f4ed",
  "#005a48",
  "#007a63",
  "#009a7f",
  "#22c3af",
  "#81ddd0",
  "#b4ece3",
  "#d5f4ed",
  "#174a43",
  "#006b5b",
  "#00907a",
  "#4bbcab",
  "#8bd8cd",
  "#baeae2",
  "#d8f3ec",
  "#004e4a",
  "#006d66",
  "#008b84",
  "#1fb9b4",
  "#7ed5d4",
  "#b3e8e6",
  "#d3f1ee",
  "#274043",
  "#225a5d",
  "#29777b",
  "#61acae",
  "#98ced0",
  "#c0e3e3",
  "#dcf0ed",
  "#f1e6cb",
  "#2f3e3e",
  "#325654",
  "#3e7371",
  "#6da9a7",
  "#9dcdcb",
  "#c4e3e1",
  "#ddf0ec",
  "#2f534f",
  "#2d5d5a",
  "#306e6d",
  "#629fa0",
  "#94c2c5",
  "#bedcdd",
  "#d8ebe9",
  "#1c4e42",
  "#0a5a52",
  "#00706c",
  "#499ea1",
  "#85c1c8",
  "#b3dbde",
  "#d5ebea",
  "#294e4f",
  "#255a5e",
  "#236d73",
  "#569ca5",
  "#8dc1ca",
  "#b8dae0",
  "#d6eaec",
  "#1d4543",
  "#0a565a",
  "#006b76",
  "#409cac",
  "#80c0cf",
  "#b0dae3",
  "#d2eaec",
  "#144552",
  "#005f6f",
  "#007b8e",
  "#12abbe",
  "#78cbda",
  "#aee1ea",
  "#d1eff1",
  "#0b464e",
  "#00636c",
  "#00808b",
  "#18afbb",
  "#7acfd9",
  "#afe3e9",
  "#d3f0f0",
  "#254952",
  "#1f5763",
  "#136b7b",
  "#4d9cae",
  "#87c0d1",
  "#b5dae4",
  "#d5ebee",
  "#254455",
  "#18546a",
  "#006985",
  "#419ab7",
  "#80bfd7",
  "#b0d9e8",
  "#d2eaf0",
  "#1d3e59",
  "#00567c",
  "#00719c",
  "#17a1c8",
  "#76c4e2",
  "#aadcee",
  "#cfecf2",
  "#eedfb7",
  "#203b5d",
  "#005381",
  "#006ea1",
  "#199fcc",
  "#73c1e4",
  "#a9dbef",
  "#ceebf3",
  "#2f394b",
  "#264864",
  "#185d82",
  "#3e90b8",
  "#7cb7d6",
  "#acd5e9",
  "#cde7f1",
  "#323a43",
  "#304656",
  "#2d5970",
  "#548da7",
  "#87b5cb",
  "#b3d3e1",
  "#d3e7ed",
  "#2e3549",
  "#254669",
  "#1a5e89",
  "#4a93be",
  "#84bbdc",
  "#b1d6ea",
  "#d3e8f1",
  "#2b3558",
  "#184a7c",
  "#0062a0",
  "#3195ca",
  "#74bae3",
  "#a8d5ef",
  "#cce8f3",
  "#2b3762",
  "#144b86",
  "#0063a6",
  "#1c94d0",
  "#6eb8e5",
  "#a3d4f0",
  "#c8e6f3",
  "#233872",
  "#004e93",
  "#0066b1",
  "#0f97d8",
  "#6cbaea",
  "#a3d6f2",
  "#cae8f3",
  "#333356",
  "#334076",
  "#365496",
  "#6289c6",
  "#92b3e0",
  "#bcd2ed",
  "#d7e5f2",
  "#3a3450",
  "#413d6d",
  "#4e4e8c",
  "#7f84be",
  "#aab0db",
  "#cbcfea",
  "#e2e5f1",
  "#3c3845",
  "#48445e",
  "#5c5a7c",
  "#8e8fb0",
  "#b8b9d2",
  "#d6d5e5",
  "#e8e8ef",
  "#e8d3a1",
  "#3b3339",
  "#453c50",
  "#544d6d",
  "#8782a6",
  "#afafcb",
  "#cfcfe0",
  "#e5e5ed",
  "#43334d",
  "#523c68",
  "#664b86",
  "#9a80b9",
  "#bfadd7",
  "#dbcee8",
  "#eae3f0",
  "#40363c",
  "#4d3d4b",
  "#604b62",
  "#957e99",
  "#bdabc2",
  "#d9ccdb",
  "#ebe3ea",
  "#4b3540",
  "#5d3d54",
  "#764b6e",
  "#aa7fa5",
  "#ccacca",
  "#e3cce0",
  "#f0e3ec",
  "#62334a",
  "#7b3c63",
  "#9b4a80",
  "#c280b4",
  "#dcacd3",
  "#edcde6",
  "#f5e3ef",
  "#663347",
  "#7f3b5f",
  "#9f487d",
  "#c67daf",
  "#dfaad1",
  "#edcce4",
  "#f6e3ef",
  "#8d2d48",
  "#a0365f",
  "#b4447b",
  "#d67cb0",
  "#e8a9d0",
  "#f3cae3",
  "#f7e2ed",
  "#9c284b",
  "#ab3162",
  "#bc427f",
  "#db7bb4",
  "#eba8d3",
  "#f4cbe5",
  "#f8e2ee",
  "#9d3448",
  "#ac3d58",
  "#bd5070",
  "#dc85a6",
  "#ecb0ca",
  "#f5d0e1",
  "#f8e5ec",
  "#aa253c",
  "#b83153",
  "#c84470",
  "#e47da7",
  "#f2abcb",
  "#f8cde1",
  "#fae2ec",
  "#e0c787",
  "#923538",
  "#9e3b45",
  "#ad485b",
  "#d07991",
  "#e6a7bc",
  "#f3c9d7",
  "#f8e1e7",
  "#a14048",
  "#ae4853",
  "#be5a67",
  "#dc8c9b",
  "#edb6c3",
  "#f5d4dc",
  "#f8e7ea",
  "#703e3c",
  "#7c4547",
  "#8c5059",
  "#b77f8c",
  "#d6acb8",
  "#e9ccd4",
  "#f3e2e6",
  "#73383f",
  "#833f4d",
  "#974c64",
  "#c27e9a",
  "#dcaac1",
  "#eccbda",
  "#f5e3ea",
  "#793b31",
  "#914443",
  "#b2525d",
  "#d48295",
  "#eaaebe",
  "#f6cfd9",
  "#fae4e8",
  "#6e3731",
  "#853f44",
  "#a64e5d",
  "#cb7e95",
  "#e4acc0",
  "#efcdd9",
  "#f8e3e8",
  "#b32735",
  "#c0324a",
  "#cf4566",
  "#e97b9d",
  "#f5abc5",
  "#facddd",
  "#fbe3ea",
  "#b82d33",
  "#c53d46",
  "#d35361",
  "#eb8a99",
  "#f6b6c3",
  "#fad4db",
  "#fae7e9",
  "#964333",
  "#9a4637",
  "#9f4b3d",
  "#bd6d64",
  "#d99992",
  "#ecbdb7",
  "#f6d9d4",
  "#a95445",
  "#b55e4f",
  "#c26c60",
  "#df9b91",
  "#eec0ba",
  "#f6dbd6",
  "#f9ece7",
  "#d6bb74",
  "#974434",
  "#9b4837",
  "#a14c3e",
  "#bf7065",
  "#da9b94",
  "#edc0b9",
  "#f7dad5",
  "#894334",
  "#8e4738",
  "#974c3e",
  "#b36f67",
  "#d19a95",
  "#e7bfba",
  "#f3dad5",
  "#7b4233",
  "#804638",
  "#864b40",
  "#a97169",
  "#cb9e99",
  "#e3c1bd",
  "#f0dbd7",
  "#754331",
  "#8b5042",
  "#ae6557",
  "#ce958e",
  "#e5bebb",
  "#f2dad7",
  "#f5eae7",
  "#7b4532",
  "#864d3b",
  "#975c4b",
  "#c18c80",
  "#ddb6ae",
  "#eed4ce",
  "#f6e8e2",
  "#6f4b3b",
  "#754f3f",
  "#7e5849",
  "#a48073",
  "#c6aaa0",
  "#dfcbc2",
  "#eee2db",
  "#714d39",
  "#78523f",
  "#825b48",
  "#a98573",
  "#caafa1",
  "#e2cfc4",
  "#f0e4dc",
  "#6b4a3c",
  "#704e40",
  "#7a5749",
  "#9f7f73",
  "#c3aaa1",
  "#ddcbc3",
  "#ede2dc",
  "#67473a",
  "#6d4c3f",
  "#785548",
  "#9b7d73",
  "#c0a9a1",
  "#dbcac3",
  "#ece2dc",
  "#6e493a",
  "#734d3e",
  "#7c5547",
  "#a17d71",
  "#c5a99f",
  "#decac2",
  "#ede1da",
  "#e26d4a",
  "#c29e54",
  "#6e4939",
  "#754e3f",
  "#7d5648",
  "#a47f73",
  "#c6aaa0",
  "#e0cbc3",
  "#eee1db",
  "#6f483b",
  "#744d40",
  "#7e554a",
  "#a57f75",
  "#c8aaa3",
  "#e0cbc5",
  "#efe2dd",
  "#6f473b",
  "#754c40",
  "#7f554b",
  "#a77f78",
  "#caaba6",
  "#e1cbc7",
  "#efe2de",
  "#684034",
  "#6d4338",
  "#754b41",
  "#9a726d",
  "#bf9f9c",
  "#dbc3c0",
  "#ecddda",
  "#714235",
  "#744539",
  "#7c4b42",
  "#9e726d",
  "#c19e9b",
  "#ddc3c0",
  "#ecdcd9",
  "#6c493a",
  "#724e3f",
  "#7a5648",
  "#a07e71",
  "#c3a99f",
  "#ddc9c1",
  "#ece1da",
  "#67493a",
  "#6d4e3f",
  "#755749",
  "#9c8174",
  "#c1aca2",
  "#dccdc5",
  "#ece3dc",
  "#614a3b",
  "#664f40",
  "#6f594b",
  "#978477",
  "#bdafa6",
  "#d8cfc7",
  "#eae4de",
  "#5d4b3d",
  "#604e40",
  "#695a4c",
  "#918578",
  "#b8b1a7",
  "#d3cfc7",
  "#e8e5df",
  "#58453b",
  "#604d44",
  "#68554d",
  "#8e7f79",
  "#b5aba7",
  "#d3ccc7",
  "#e6e2de",
  "#f5edd0",
  "#5a4430",
  "#6e5440",
  "#886a59",
  "#b59d94",
  "#d3c3bd",
  "#e8ddd8",
  "#f2ede8",
  "#594334",
  "#5f4b3c",
  "#68574a",
  "#8c847a",
  "#b4afa8",
  "#d3d0c9",
  "#e6e4df",
  "#52443c",
  "#564942",
  "#5f544e",
  "#86807e",
  "#aeabaa",
  "#cdccca",
  "#e4e3e0",
  "#5b3f36",
  "#5f433c",
  "#664b47",
  "#897475",
  "#b1a2a4",
  "#d0c5c5",
  "#e4dedd",
  "#433731",
  "#52433e",
  "#685553",
  "#9c8989",
  "#c2b5b7",
  "#dcd4d3",
  "#ece7e5",
  "#493a33",
  "#584744",
  "#6f5b5c",
  "#a19195",
  "#c4bbc0",
  "#ded8da",
  "#ece9e8",
  "#443a36",
  "#544649",
  "#6b5a64",
  "#9b8e9c",
  "#c1b9c4",
  "#dcd6dd",
  "#ebe9ea",
  "#383537",
  "#413d44",
  "#514a58",
  "#857d8f",
  "#b0acbb",
  "#d0cdd6",
  "#e5e3e7",
  "#353435",
  "#3c3b40",
  "#4a4a53",
  "#7b7c88",
  "#a9abb6",
  "#caccd3",
  "#e1e2e5",
  "#333334",
  "#3a3b3f",
  "#464a50",
  "#757b83",
  "#a2a9b1",
  "#c6cbcf",
  "#dfe2e3",
  "#f4e8c4",
  "#333334",
  "#3a3c3e",
  "#46494f",
  "#757b82",
  "#a3aab0",
  "#c6cbcf",
  "#dfe3e3",
  "#585858",
  "#787b7d",
  "#979c9f",
  "#c3c8cb",
  "#dce1e1",
  "#ecefec",
  "#f4f6f1",
  "#4b5756",
  "#6e7c7d",
  "#8f9d9e",
  "#bac8c9",
  "#d6e0e0",
  "#e9efed",
  "#f1f5f1",
  "#465956",
  "#627c7a",
  "#889e9e",
  "#b3c8c8",
  "#d3e1e1",
  "#e7efec",
  "#f1f4f1",
  "#696d70",
  "#8b9094",
  "#b8bdc0",
  "#d6dbdc",
  "#e8ebea",
  "#3d3f40",
  "#52565a",
  "#6d7378",
  "#a2a9ae",
  "#c7cdd1",
  "#e0e4e4",
  "#eef0ee",
  "#38393a",
  "#464a4d",
  "#5c6167",
  "#92999e",
  "#bac1c6",
  "#d7dcde",
  "#eaedeb",
  "#343435",
  "#373a3d",
  "#444a50",
  "#727c83",
  "#a0aab1",
  "#c4cbd0",
  "#dde2e3",
  "#393736",
  "#42444b",
  "#515a67",
  "#8290a0",
  "#acbac8",
  "#cdd7de",
  "#e3e9eb",
  "#323436",
  "#373c41",
  "#404b54",
  "#6d7e89",
  "#9cadb7",
  "#c1cdd3",
  "#dbe3e5",
  "#453c39",
  "#494242",
  "#4f4e53",
  "#717c86",
  "#9ca8b3",
  "#c1cad1",
  "#dce1e4",
  "#313435",
  "#373d3f",
  "#434e52",
  "#a1b0b4",
  "#c4cfd2",
  "#dde5e5",
  "#383a3c",
  "#44484d",
  "#717980",
  "#9ea7ad",
  "#c3c9cd",
  "#dde1e1",
  "#3d3d3e",
  "#4b4b4f",
  "#7c7f84",
  "#aaaeb3",
  "#cbced0",
  "#e2e4e3",
  "#4b433d",
  "#504a45",
  "#7e8283",
  "#a7aeb0",
  "#c9cece",
  "#e1e4e3",
  "#393d3c",
  "#434c4f",
  "#829ba1",
  "#adc3c8",
  "#cedddf",
  "#e4edeb",
  "#303536",
  "#364042",
  "#415457",
  "#6f898b",
  "#9eb5b8",
  "#c3d4d4",
  "#dce7e6",
  "#544839",
  "#5a4f40",
  "#645d4e",
  "#8d8c7f",
  "#b3b5ab",
  "#d3d4cc",
  "#e6e8e1",
  "#4f493b",
  "#555042",
  "#5f5e50",
  "#858d81",
  "#b0b8ae",
  "#cfd5cd",
  "#e4e8e2",
  "#464233",
  "#565344",
  "#6d6c5e",
  "#99a196",
  "#c0c8c1",
  "#dae0da",
  "#eaeee9",
  "#ead99d",
  "#4b4b3f",
  "#545447",
  "#616253",
  "#919284",
  "#b9bbb1",
  "#d6d8cf",
  "#e7e9e2",
  "#535140",
  "#5c5a47",
  "#6a6855",
  "#9a9885",
  "#bfc0b1",
  "#dadbcf",
  "#ecece3",
  "#5e5a42",
  "#696449",
  "#757055",
  "#a39f84",
  "#c8c5b2",
  "#e0ded0",
  "#edede3",
  "#766c4b",
  "#8d835e",
  "#a59c79",
  "#cbc7b0",
  "#e2e0d1",
  "#efeee3",
  "#f6f6ed",
  "#646742",
  "#83855e",
  "#c8cab2",
  "#e0e3d4",
  "#eeefe5",
  "#f6f7ee",
  "#6e743a",
  "#8b8c50",
  "#a6a56c",
  "#cccca3",
  "#e3e4ca",
  "#f0f0df",
  "#f5f6eb",
  "#83872e",
  "#9a983d",
  "#b1ad55",
  "#d3cf8f",
  "#e7e5bd",
  "#f2f1d7",
  "#f7f7e7",
  "#8c883f",
  "#949146",
  "#a19d52",
  "#c4c184",
  "#dddcb1",
  "#ececcf",
  "#f4f4e3",
  "#8b7744",
  "#9d8752",
  "#b19c68",
  "#d3c59d",
  "#f2eedd",
  "#f7f5eb",
  "#8b7d43",
  "#958649",
  "#ab9554",
  "#c6b984",
  "#ded6af",
  "#ede8cf",
  "#f5f3e3",
  "#e1ca84",
  "#9f8c3f",
  "#a89343",
  "#baa04f",
  "#d3c281",
  "#e7dcae",
  "#f2ebcd",
  "#f7f4e2",
  "#a08542",
  "#ac8d46",
  "#bb9951",
  "#d2ba7f",
  "#e8d8ad",
  "#f0e8cb",
  "#f5f2e1",
  "#ad863e",
  "#b89045",
  "#c59e55",
  "#e0c389",
  "#efddb5",
  "#f7ecd2",
  "#f9f5e5",
  "#96722e",
  "#a07a35",
  "#af8840",
  "#d1b071",
  "#e6cfa1",
  "#f2e4c5",
  "#f8f1dd",
  "#c58e38",
  "#cc953d",
  "#d5a14b",
  "#eac17c",
  "#f5daa9",
  "#faebcc",
  "#faf3e0",
  "#d68a1a",
  "#dc9222",
  "#eaa731",
  "#f4c36b",
  "#fbdc9f",
  "#fcebc3",
  "#fbf4dc",
  "#c57626",
  "#cc7f2d",
  "#d78c3b",
  "#ecb36d",
  "#f8d3a1",
  "#fbe7c5",
  "#fbf2dc",
  "#c57b3a",
  "#cd8341",
  "#d89050",
  "#eeb783",
  "#f9d5b0",
  "#fce7cf",
  "#fbf2e4",
  "#be7f3e",
  "#c68745",
  "#d19750",
  "#e8b981",
  "#f4d6ae",
  "#fae8ce",
  "#faf3e3",
  "#c4893a",
  "#cc9040",
  "#d69d4d",
  "#ecbf7f",
  "#f7daad",
  "#fbeacd",
  "#faf3e2",
  "#d9bf71",
  "#b2803d",
  "#ba8744",
  "#c9974f",
  "#e0b97f",
  "#f0d5ac",
  "#f8e8cc",
  "#f9f2e0",
  "#966b41",
  "#9f7247",
  "#ab7e51",
  "#cda87f",
  "#e3c9aa",
  "#f1e1cc",
  "#f7efe1",
  "#835e34",
  "#8c663b",
  "#997245",
  "#c09d73",
  "#dbc3a4",
  "#ecdcc5",
  "#f5ecdc",
  "#855c3f",
  "#8d6345",
  "#986e4f",
  "#be997c",
  "#dac0aa",
  "#ebdbca",
  "#f4ebdf",
  "#765138",
  "#7e583d",
  "#8a6348",
  "#b18e74",
  "#d1b7a3",
  "#e6d4c4",
  "#f2e8dd",
  "#a5763e",
  "#ae7e46",
  "#ba8b52",
  "#d8b281",
  "#ebd2ad",
  "#f5e5cc",
  "#f8f1e1",
  "#b5632c",
  "#bc6b32",
  "#c7773e",
  "#e1a16d",
  "#f1c5a0",
  "#f9dec3",
  "#faeddb",
  "#c76c37",
  "#d07640",
  "#db8450",
  "#f1ae84",
  "#fbcfb3",
  "#fde4d1",
  "#fcf1e4",
  "#c86638",
  "#d17042",
  "#dc8052",
  "#f2ab85",
  "#fbccb3",
  "#fde3d1",
  "#fcefe4",
  "#cc5a32",
  "#d4653e",
  "#e17751",
  "#f5a386",
  "#fdc8b6",
  "#ffe0d3",
  "#fdeee5",
  "#c29a4d",
  "#c35232",
  "#cb5e3d",
  "#d56e4e",
  "#ea9e82",
  "#f4c3b2",
  "#f9ddcf",
  "#faede3",
  "#ab4830",
  "#bd543d",
  "#d36651",
  "#ea9589",
  "#f8beb8",
  "#fddad5",
  "#fceae6",
  "#8e4332",
  "#924737",
  "#9a4b3d",
  "#b77067",
  "#d59a94",
  "#eabfb9",
  "#f4d9d5",
  "#804531",
  "#8d4e3a",
  "#9e5d4b",
  "#c88d81",
  "#e2b8b0",
  "#f0d5ce",
  "#f7e8e2",
  "#88442e",
  "#984f3b",
  "#ab604e",
  "#d29185",
  "#e8bbb4",
  "#f4d7d1",
  "#f9e9e4",
  "#a65330",
  "#ad5935",
  "#b66340",
  "#d48d6c",
  "#eab59d",
  "#f6d4c1",
  "#f9e7da",
  "#f2e7cb",
  "#edddb7",
  "#f7e4d4",
  "#e8d6ab",
  "#ddca9a",
  "#cdb379",
  "#b9995b",
  "#9e8249",
  "#ede5ce",
  "#e3d9bb",
  "#d5c8a6",
  "#cab88c",
  "#bca474",
  "#f5d8c7",
  "#a08b5f",
  "#7f6c46",
  "#ebe3cf",
  "#ded3bb",
  "#d1c5a8",
  "#a28d66",
  "#816f4e",
  "#7b6b4e",
  "#e4dcc4",
  "#f7c8b7",
  "#ddd3b7",
  "#d2c7a9",
  "#cec3a4",
  "#c1b697",
  "#ac9c7c",
  "#978466",
  "#f1e8cc",
  "#e8dcba",
  "#decea6",
  "#ceb985",
  "#f1b7a4",
  "#b99e64",
  "#a58b54",
  "#967e4e",
  "#eee5c7",
  "#e5d9b2",
  "#daca9c",
  "#c9b37a",
  "#c5b077",
  "#b19557",
  "#9d8246",
  "#e79e83",
  "#f4eaca",
  "#ece3c1",
  "#e1d5aa",
  "#dacea1",
  "#d1bb81",
  "#cab275",
  "#b09755",
  "#f3ebd6",
  "#ece3ca",
  "#e7dbbb",
  "#d88467",
  "#d9c9a1",
  "#c8b180",
  "#c1a977",
  "#b19b67",
  "#f3e4b6",
  "#eadba1",
  "#eada99",
  "#e1cc81",
  "#d2bd65",
  "#caab55",
  "#ce6c52",
  "#ab8f4e",
  "#f3edd1",
  "#f7f0ce",
  "#f7ecba",
  "#f3e4a0",
  "#e6d281",
  "#d6bd68",
  "#c6a447",
  "#f4edcc",
  "#f3e7be",
  "#f7dbd1",
  "#f1df9f",
  "#ebd689",
  "#ead180",
  "#e4c368",
  "#d0a647",
  "#faeec5",
  "#fde9b5",
  "#fae1a0",
  "#f3d27f",
  "#eec463",
  "#fcb0a3",
  "#eec2b7",
  "#efbc50",
  "#e2ad4a",
  "#faefce",
  "#fbebc1",
  "#fce6b0",
  "#f9d795",
  "#f5ca79",
  "#f7bc57",
  "#e4a039",
  "#f8eecc",
  "#e9a99a",
  "#fce9b6",
  "#fde7a5",
  "#fbdb90",
  "#facf70",
  "#fcc550",
  "#ffbd46",
  "#faf1c6",
  "#fdeeb2",
  "#ffeba2",
  "#fee181",
  "#e0907c",
  "#fdda66",
  "#ffcf30",
  "#feca25",
  "#faf1c5",
  "#fcf0b6",
  "#fceba2",
  "#f9e584",
  "#fde269",
  "#fbde61",
  "#ffd851",
  "#d37864",
  "#f8f3d5",
  "#f8f0c4",
  "#faf1b8",
  "#faea9e",
  "#f7e481",
  "#f8e165",
  "#ffdd39",
  "#f9f2ca",
  "#faf1bb",
  "#fceb9d",
  "#b6604f",
  "#f7e27d",
  "#fade60",
  "#f7d64f",
  "#f0c933",
  "#f7efd1",
  "#f9efc5",
  "#f4e8ae",
  "#f3e49c",
  "#f1da76",
  "#f1cc54",
  "#9e5545",
  "#e4bc3b",
  "#f8f3c5",
  "#f8eca9",
  "#f6e485",
  "#f3dd64",
  "#ecd559",
  "#edd24f",
  "#e2c839",
  "#f9f1b8",
  "#f8eda8",
  "#f0d3c9",
  "#f7e78f",
  "#f8e47b",
  "#f1da57",
  "#e8d24a",
  "#d2c13d",
  "#f7f0c5",
  "#f4ebb6",
  "#eee3a4",
  "#ecdf9b",
  "#e7d887",
  "#e9c9c1",
  "#e2d06d",
  "#cdbc47",
  "#f6efd1",
  "#f2e9c1",
  "#eae0b1",
  "#e6d89e",
  "#dbc988",
  "#d0bc68",
  "#bfa653",
  "#ece6c6",
  "#deb4aa",
  "#e6e0b9",
  "#dbd6a7",
  "#d5c589",
  "#c4b473",
  "#b3a358",
  "#ad9b4a",
  "#f5f0cd",
  "#f3edc1",
  "#eee7b0",
  "#e3da9b",
  "#d69b8e",
  "#d9cd7a",
  "#c7bc60",
  "#aea44a",
  "#f1f3ca",
  "#ecf0ba",
  "#e0e89b",
  "#d8de7b",
  "#d3d95d",
  "#cece4a",
  "#caca35",
  "#f89585",
  "#cb8574",
  "#e8f0c3",
  "#e2ecb4",
  "#d9e8a1",
  "#ccdb79",
  "#c5d25b",
  "#a7b554",
  "#95a54e",
  "#e5f1cf",
  "#e1efc2",
  "#dcedbb",
  "#b26b58",
  "#d1e8a5",
  "#cae392",
  "#a5c667",
  "#9bb95b",
  "#ebf3cb",
  "#e1f0ba",
  "#d4e898",
  "#bedd78",
  "#aad76a",
  "#95cb54",
  "#884d45",
  "#78b942",
  "#e2f1d1",
  "#d8edc4",
  "#cfe8b9",
  "#c4e0ac",
  "#add18a",
  "#9ec479",
  "#83ac58",
  "#dce8cf",
  "#d2dfbf",
  "#f1d5cb",
  "#bfcea8",
  "#a7b989",
  "#9baf7b",
  "#839462",
  "#627649",
  "#dce3d0",
  "#d4decb",
  "#cfdac4",
  "#c0cbb1",
  "#a9b595",
  "#ecc8be",
  "#889672",
  "#626d51",
  "#cbd8c6",
  "#bac9b4",
  "#aabba5",
  "#93a58c",
  "#70816b",
  "#5b6a5b",
  "#515d51",
  "#cdded3",
  "#e7b9ac",
  "#bfd1bf",
  "#aec1ad",
  "#9bad97",
  "#88977e",
  "#75866e",
  "#56664e",
  "#d5e0d5",
  "#ced9cc",
  "#bfcdc2",
  "#b3c2b5",
  "#daa492",
  "#97a493",
  "#737e6b",
  "#565d4f",
  "#e2e7dc",
  "#d2d9ca",
  "#bbc6b7",
  "#a7b4a2",
  "#8c9985",
  "#737f6a",
  "#586251",
  "#c18573",
  "#d1d7c7",
  "#c9d0bf",
  "#b9c0ad",
  "#a5aa92",
  "#939880",
  "#7b8068",
  "#dfe2c6",
  "#d5dbb9",
  "#cad2ad",
  "#975f57",
  "#b9c2a2",
  "#abb18e",
  "#969a72",
  "#80835c",
  "#e4e7d2",
  "#d4dabf",
  "#c7cdad",
  "#aeb68e",
  "#959d6e",
  "#777e55",
  "#87544b",
  "#6e7450",
  "#e2e3cc",
  "#dad9be",
  "#cbcbad",
  "#b9b790",
  "#a2a175",
  "#827f57",
  "#76754d",
  "#dde1ca",
  "#d6dabf",
  "#f37f6b",
  "#f2dacc",
  "#cccfae",
  "#c3c6a4",
  "#afb288",
  "#9d9e6f",
  "#8a885d",
  "#d2d4c4",
  "#c3c7b1",
  "#b8b8a1",
  "#a3a187",
  "#eecec1",
  "#858367",
  "#7d765a",
  "#e6e1cb",
  "#ded7be",
  "#cec7aa",
  "#b4a985",
  "#988b65",
  "#7b7251",
  "#6d684e",
  "#ebead6",
  "#e6bdac",
  "#e1e2cb",
  "#dbd8bc",
  "#cbc8a3",
  "#b4b085",
  "#9e9668",
  "#918659",
  "#e0e2be",
  "#d7daad",
  "#d1d2a1",
  "#c0c286",
  "#e2b5a5",
  "#a1a464",
  "#9c9a62",
  "#908d55",
  "#e8ecd2",
  "#e0e9ca",
  "#d3deba",
  "#cbd6a9",
  "#bcc58d",
  "#a6b376",
  "#8c965a",
  "#d89e87",
  "#d7e4c1",
  "#cfdeb5",
  "#bacda0",
  "#a6ba80",
  "#95ad6d",
  "#89a068",
  "#6e8454",
  "#e0efd2",
  "#c9e6c0",
  "#bfe0b8",
  "#d18c6c",
  "#a2d292",
  "#95c884",
  "#72a556",
  "#5f9253",
  "#ddf0cb",
  "#ceebb9",
  "#b7e3a0",
  "#a3d984",
  "#84cb6b",
  "#67b458",
  "#b86d52",
  "#51a448",
  "#c9e2c5",
  "#c0debf",
  "#aad0ac",
  "#8dba8e",
  "#7aac7a",
  "#5a8e5e",
  "#4d7256",
  "#d3edd1",
  "#c5e9c8",
  "#f6e3cf",
  "#b2e1b9",
  "#a9deb3",
  "#88c58e",
  "#67b273",
  "#288f50",
  "#bbecd6",
  "#abe6cd",
  "#a1dfc5",
  "#86d2b2",
  "#75c8a2",
  "#f7d5c1",
  "#5ab990",
  "#31976b",
  "#d7efe2",
  "#c7e9d8",
  "#b5e2ce",
  "#95d1b6",
  "#78be9c",
  "#51a07a",
  "#46926d",
  "#b1e7d4",
  "#f4cbb3",
  "#a1dfcb",
  "#89d6bd",
  "#66bfa0",
  "#3ba681",
  "#238966",
  "#306a57",
  "#d4ecde",
  "#cbe9de",
  "#b1decf",
  "#86c6b2",
  "#ea6d5a",
  "#f0c0a4",
  "#63a791",
  "#458a74",
  "#375c4f",
  "#c8ecdf",
  "#afe4d4",
  "#8ad7c5",
  "#5bc1a9",
  "#21a68c",
  "#00917a",
  "#2a806c",
  "#e5a883",
  "#c7ecdd",
  "#afe9d5",
  "#9fe3ce",
  "#83ddc5",
  "#50c9ac",
  "#00b998",
  "#009a7b",
  "#d3e9dc",
  "#c0e0d5",
  "#afd7cb",
  "#d8916d",
  "#97cbbb",
  "#7ebba6",
  "#599e84",
  "#367262",
  "#daeadd",
  "#c7ddcd",
  "#b1cfba",
  "#9cbea6",
  "#81a488",
  "#638469",
  "#c47752",
  "#c3d8cc",
  "#afcbbd",
  "#a1beaf",
  "#8aab98",
  "#75957d",
  "#64806c",
  "#56705f",
  "#c4ddcb",
  "#b4d1c1",
  "#f7dfcd",
  "#9cc1b2",
  "#83ac9d",
  "#588977",
  "#407465",
  "#3e5c53",
  "#cae9db",
  "#bce3d7",
  "#96cec0",
  "#6ab7a7",
  "#56a392",
  "#f6d8c4",
  "#3b7e6f",
  "#336155",
  "#cdf0e4",
  "#b7eae1",
  "#a2e4d8",
  "#79d5ca",
  "#4fc2b1",
  "#1db6a4",
  "#009181",
  "#c2e7dd",
  "#f6d0b7",
  "#ade1da",
  "#87d5d1",
  "#78cecc",
  "#43bbb6",
  "#00a6a1",
  "#008c87",
  "#c4e3db",
  "#b2ddd6",
  "#9cd1cd",
  "#87c5c2",
  "#f2c0a6",
  "#68b1ad",
  "#3f9793",
  "#2e7572",
  "#c6deda",
  "#b7d6d3",
  "#a6cbc9",
  "#8fbcba",
  "#689b99",
  "#517b77",
  "#3d585b",
  "#e8a481",
  "#d8e7de",
  "#c2dad3",
  "#abc8c0",
  "#94b8af",
  "#6c9187",
  "#55756c",
  "#445851",
  "#c1d2ce",
  "#bacdc8",
  "#a4bbb6",
  "#dd8963",
  "#8aa39c",
  "#748e88",
  "#5a7169",
  "#486055",
  "#ccd9cf",
  "#c2d1c6",
  "#b1c1b5",
  "#9cac9e",
  "#90a393",
  "#7d8d81",
  "#e1503c",
  "#606e63",
  "#c7d6cd",
  "#bdcec5",
  "#aabeb4",
  "#93a9a0",
  "#7f958e",
  "#4a5950",
  "#c8d8d1",
  "#b7ccc7",
  "#f6d8c4",
  "#9ab9b5",
  "#82a3a3",
  "#6f8f8e",
  "#4e6c6b",
  "#415451",
  "#dae5e2",
  "#c2d5d6",
  "#a9c3c6",
  "#97b2b7",
  "#75959a",
  "#f9c5ac",
  "#54747c",
  "#465a5d",
  "#bcdddd",
  "#acd3d7",
  "#88bdc8",
  "#6faab4",
  "#50939d",
  "#397a85",
  "#285e6b",
  "#c1e7e5",
  "#f5bba1",
  "#aae0df",
  "#87d1d2",
  "#68c1c3",
  "#3aa9a9",
  "#00898a",
  "#255456",
  "#b6e2e1",
  "#a1d9db",
  "#88cdd1",
  "#7bc7cb",
  "#f2a685",
  "#5cb5b9",
  "#2c9ba1",
  "#23777b",
  "#b9dce1",
  "#a1cfd7",
  "#95c8d2",
  "#86becb",
  "#71aebb",
  "#5598a9",
  "#33677b",
  "#e38e69",
  "#b7dfe2",
  "#a5d7dc",
  "#84c5ce",
  "#57abb7",
  "#3292a1",
  "#2c8392",
  "#226977",
  "#9ed9e2",
  "#8ad0db",
  "#6bc0ce",
  "#d0714a",
  "#45adbe",
  "#0493a7",
  "#008299",
  "#3c6c7a",
  "#c8e6ea",
  "#b7dfe5",
  "#a0d6e2",
  "#76c2d7",
  "#54b1c9",
  "#1fa0c1",
  "#b2573f",
  "#007594",
  "#c0dfe7",
  "#abd3e2",
  "#83b8d0",
  "#6aa4be",
  "#5394b4",
  "#3a6e8c",
  "#34586c",
  "#b4dbea",
  "#a9d4e7",
  "#f8e3d1",
  "#9bcee5",
  "#7dbcdb",
  "#5eabd1",
  "#4298c4",
  "#2474a3",
  "#b7ddeb",
  "#a4d4ec",
  "#94cce7",
  "#7bbde1",
  "#6db4dc",
  "#fcdcc7",
  "#3f9dd1",
  "#1369a7",
  "#cce3eb",
  "#b9d9e7",
  "#aed3e5",
  "#97c3df",
  "#6ba3d0",
  "#3d74ac",
  "#2f5688",
  "#b7d4e2",
  "#f7d7cc",
  "#fccfb9",
  "#a5c8dd",
  "#92bad4",
  "#79a7c5",
  "#5e8fb6",
  "#40729c",
  "#355473",
  "#c9dde5",
  "#c1d7e4",
  "#a1bfd5",
  "#81a5c0",
  "#f8ac89",
  "#6b8db3",
  "#396998",
  "#335183",
  "#d7e5eb",
  "#c0d7e8",
  "#a3c1e3",
  "#8dadd9",
  "#6e94cc",
  "#5b7eb7",
  "#41548c",
  "#f7946b",
  "#bacbdf",
  "#9db2d0",
  "#879ebf",
  "#6a82a8",
  "#414a62",
  "#c5d3df",
  "#b4c5d7",
  "#a5b7cd",
  "#f5855b",
  "#93a6be",
  "#7685a1",
  "#5c6a85",
  "#464956",
  "#c3d8e1",
  "#adc6d4",
  "#9ab4c7",
  "#85a0b6",
  "#6b89a3",
  "#f0764b",
  "#4b5a71",
  "#eaf0e9",
  "#d9e7df",
  "#d3e6dd",
  "#eef2eb",
  "#e3eee8",
  "#ddeae4",
  "#d6e7e2",
  "#d8ebe1",
  "#d9ede1",
  "#f7e6d3",
  "#d4ebda",
  "#eaefdf",
  "#e7edd9",
  "#e3ecd9",
  "#e1ebd5",
  "#e9e8e0",
  "#e3e2da",
  "#e0dfd7",
  "#ddd9ce",
  "#d3cec4",
  "#f9e1cb",
  "#ccc8be",
  "#c3bdb1",
  "#e5e6dc",
  "#dde1d8",
  "#d4d8d2",
  "#e4ebe4",
  "#dae4e2",
  "#d3dedc",
  "#d4dddc",
  "#f0f1ea",
  "#fad9bf",
  "#e5e7e4",
  "#dcdfde",
  "#eceeea",
  "#eaece8",
  "#e1e6e5",
  "#d9e0e1",
  "#f2efe8",
  "#f0ebe4",
  "#eee3de",
  "#f5f2ed",
  "#fecaa8",
  "#f4efea",
  "#f1ebe8",
  "#e9e7e8",
  "#f8eae3",
  "#f7e8e2",
  "#f5e4df",
  "#f8e9e0",
  "#f8e5dd",
  "#f8ddd8",
  "#f9dad3",
  "#fab689",
  "#f6f0e7",
  "#f6ecdf",
  "#f8e7da",
  "#f7e9dc",
  "#f5e2d5",
  "#f3deca",
  "#efd8c6",
  "#f8f0dc",
  "#f9e9d1",
  "#f7e1bf",
  "#f8c9c0",
  "#fca574",
  "#f7ebda",
  "#f7e7d4",
  "#f5e3cc",
  "#f5e0c8",
  "#f6f0e1",
  "#f7efdc",
  "#f4ead5",
  "#f3e6d3",
  "#f5ead6",
  "#f2e5d3",
  "#f78345",
  "#f0e0c9",
  "#f7eedb",
  "#f2ebda",
  "#f6ead2",
  "#f9ebd2",
  "#f2e7cf",
  "#f6e3c3",
  "#f2debc",
  "#f5eed8",
  "#f3ead0",
  "#f7e6d0",
  "#f1e4c4",
  "#f7ecd3",
  "#f6e8c9",
  "#f3e5c3",
  "#f4e3be",
  "#f2efdf",
  "#ece9d8",
  "#e9e5d0",
  "#f6efd6",
  "#f5edcd",
  "#fae2c8",
  "#f5ecc6",
  "#f4e9c0",
  "#f6f3dd",
  "#f4f1d8",
  "#f3eed0",
  "#eeecdb",
  "#e5e5d2",
  "#e6e4cf",
  "#ede8d5",
  "#fad9bc",
  "#e6e1cb",
  "#e2dbc2",
  "#f0ebd7",
  "#ebe6d2",
  "#eae4cd",
  "#e3dec7",
  "#f3e8d4",
  "#eee7d5",
  "#efe5d0",
  "#ede4d0",
  "#f8d0b2",
  "#e7deca",
  "#e7dbc3",
  "#e2d4bd",
  "#e6e0cf",
  "#e3dcc8",
  "#dbd2bc",
  "#eae0c8",
  "#e5d7b9",
  "#e2d2b3",
  "#dac9ab",
  "#f4c5a0",
  "#e9e6db",
  "#e3dfd2",
  "#e5dece",
  "#e0d8c6",
  "#d9cfbb",
  "#d7cdb7",
  "#f2f1e6",
  "#eceae0",
  "#e8e5d8",
  "#eeaf84",
  "#ebe6d7",
  "#e2ddd0",
  "#d9d3c4",
  "#cbc6b8",
  "#e5e0d0",
  "#dbd7c5",
  "#afa58f",
  "#9d917d",
  "#d07b51",
  "#dfdbcd",
  "#d7cebf",
  "#cdc4b5",
  "#ada290",
  "#998b75",
  "#84735e",
  "#ded3c6",
  "#cfc4b7",
  "#f6e0cc",
  "#cabdaf",
  "#b7a99c",
  "#9e8c7c",
  "#857466",
  "#7b6c5d",
  "#d3c9bd",
  "#c9beaf",
  "#b7aa9a",
  "#847562",
  "#f3f0e9",
  "#bbb2a1",
  "#978568",
  "#948065",
  "#7d664d",
  "#736046",
  "#b29678",
  "#c6b097",
  "#b8a28a",
  "#bdaa95",
  "#bfb198",
  "#f0efe6",
  "#b5a695",
  "#9f9282",
  "#8c6f5d",
  "#725641",
  "#5f4d43",
  "#58423a",
  "#3c2d2b",
  "#c4a996",
  "#dac2ae",
  "#ddbe9f",
  "#f8f7e8",
  "#d4b595",
  "#d9b091",
  "#d3a482",
  "#cb9976",
  "#a3673e",
  "#b87450",
  "#c37540",
  "#965a3a",
  "#804f31",
  "#c5a38c",
  "#efded2",
  "#f8ede3",
  "#e8d9d4",
  "#dbccc2",
  "#a06e68",
  "#7c3e2e",
  "#ab543f",
  "#b25c50",
  "#8a2728",
  "#8b383e",
  "#eeecdb",
  "#763637",
  "#f4e9ce",
  "#f2e7cf",
  "#f2debc",
  "#eddbbd",
  "#eed7b2",
  "#fce9bd",
  "#ead2a8",
  "#cfba92",
  "#d8ba87",
  "#efecdf",
  "#b99257",
  "#af8255",
  "#c49f78",
  "#d9c79a",
  "#c8ab6e",
  "#bba577",
  "#c2b393",
  "#cdbd95",
  "#c3b79d",
  "#aba38c",
  "#f5ecdc",
  "#b1ac8d",
  "#a1a07e",
  "#b4ae8e",
  "#c5c397",
  "#aca96e",
  "#c7b679",
  "#b4a85c",
  "#d5d3b8",
  "#979c78",
  "#f1eadc",
  "#a3b692",
  "#b2b69f",
  "#858a74",
  "#c7cab6",
  "#a3ac9e",
  "#738071",
  "#535f4e",
  "#c9d4c8",
  "#bbc3bb",
  "#89a098",
  "#eef1eb",
  "#e5e0d5",
  "#889d9a",
  "#6e888d",
  "#3d615e",
  "#9fb8c1",
  "#527687",
  "#4e7f92",
  "#3a647d",
  "#abc1cc",
  "#d5e1e3",
  "#a3aeb4",
  "#81949d",
  "#718087",
  "#565c5e",
  "#454b54",
  "#919da8",
  "#bac5d0",
  "#747d92",
  "#9c9ca6",
  "#7a767e",
  "#ac9eaa",
  "#e5dbce",
  "#958896",
  "#d6d2d5",
  "#ccb9b5",
  "#c4b7bb",
  "#b4a9af",
  "#94717d",
  "#6f505f",
  "#7c6a73",
  "#796c6f",
  "#56464e",
  "#e3ddce",
  "#453133",
  "#57504c",
  "#827d7b",
  "#d4cecb",
  "#b6b4b2",
  "#a5a2a0",
  "#cfcac2",
  "#bdb8ad",
  "#babdb8",
  "#bec2c2",
  "#e9e5d0",
  "#868583",
  "#888983",
  "#85837d",
  "#837c6e",
  "#dedfcd",
  "#d9d2be",
  "#e7dbc3",
  "#ddccb1",
  "#d4c9af",
  "#eceeec",
  "#f6f0e1",
  "#e1d6c1",
  "#cfba9c",
  "#8e5049",
  "#8e3f30",
  "#a5594e",
  "#b36957",
  "#f2efdf",
  "#e9ddc5",
  "#d3c09d",
  "#7e4a46",
  "#c18573",
  "#e6bdac",
  "#f2dacc",
  "#f5eed8",
  "#f1e4c4",
  "#edd7a4",
  "#bc8b6e",
  "#c18872",
  "#dcaa86",
  "#f0c9a1",
  "#eedfb7",
  "#583835",
  "#ebedea",
  "#e8d3a1",
  "#e1c28b",
  "#f9d795",
  "#fae1a0",
  "#fbebc1",
  "#fdeeb2",
  "#ede5ce",
  "#ddd3b7",
  "#cab88c",
  "#e5c48b",
  "#eacfa0",
  "#e3d9bb",
  "#e5d7b9",
  "#e2dbc2",
  "#d5c8a6",
  "#c1b697",
  "#9c6e49",
  "#caa472",
  "#dabd98",
  "#ead2b1",
  "#e7dbbb",
  "#d9c9a1",
  "#f0f1ea",
  "#ceb985",
  "#b99978",
  "#c9ac86",
  "#e2d2b3",
  "#dcccb3",
  "#ded0c0",
  "#693541",
  "#cfbca4",
  "#bca68c",
  "#a98e69",
  "#b0987a",
  "#b8a183",
  "#c9b394",
  "#5a3646",
  "#e8dcc8",
  "#e3c3a6",
  "#4f3b50",
  "#b98766",
  "#a58d72",
  "#b49f8b",
  "#c9af98",
  "#d7c2ad",
  "#e1cfb5",
  "#6f6578",
  "#d2ab88",
  "#9c6040",
  "#b49c8d",
  "#c3b8ae",
  "#cabdaf",
  "#cab9a8",
  "#5d4c54",
  "#f2f1e6",
  "#ead4b0",
  "#d5b387",
  "#b88d60",
  "#ccb9ad",
  "#d3c4ba",
  "#dcd3ca",
  "#e7ddcf",
  "#dfceb3",
  "#c0a787",
  "#997c57",
  "#9e8c7c",
  "#b7a99c",
  "#c9beaf",
  "#d3c9bd",
  "#cdc4b5",
  "#b7aa9a",
  "#9f8e7c",
  "#725748",
  "#86604f",
  "#b4967a",
  "#c8ac8e",
  "#c4baaa",
  "#ebe6d7",
  "#ada290",
  "#84735e",
  "#65594a",
  "#9d8774",
  "#968777",
  "#a29d96",
  "#cac4b0",
  "#afa58f",
  "#857a68",
  "#564e48",
  "#696867",
  "#8b847c",
  "#7f7d77",
  "#b6b8a5",
  "#9a9c87",
  "#626451",
  "#8b8274",
  "#8e816a",
  "#9e9079",
  "#d1c5a8",
  "#d6dabf",
  "#afb288",
  "#a2898b",
  "#e2d4c2",
  "#7b8068",
  "#a39f87",
  "#ab9e88",
  "#c5c3ae",
  "#e2e7dc",
  "#c9d0bf",
  "#783934",
  "#8c9985",
  "#586251",
  "#999275",
  "#aea98f",
  "#c4c2b0",
  "#dbd6a7",
  "#9f3e3e",
  "#c2d1c6",
  "#90a393",
  "#9c2e3b",
  "#5a7169",
  "#59523c",
  "#696753",
  "#606241",
  "#969a72",
  "#bfc6bb",
  "#a63841",
  "#a7b3aa",
  "#9da8a1",
  "#42483e",
  "#858367",
  "#95917f",
  "#b8b8a1",
  "#eceae0",
  "#c7cfc8",
  "#a3b0ae",
  "#7a847f",
  "#878872",
  "#939880",
  "#a5aa92",
  "#bbc6b7",
  "#b0c9d0",
  "#7f9dac",
  "#6b8895",
  "#30484a",
  "#4e6c6b",
  "#6f8f8e",
  "#9cac9e",
  "#a0bece",
  "#85a0b6",
  "#4b5a71",
  "#537284",
  "#83b8d0",
  "#97c3df",
  "#bcd4dd",
  "#cbdde2",
  "#bfa4a0",
  "#e3dfd2",
  "#63879f",
  "#3f5266",
  "#81a5c0",
  "#9ab4c7",
  "#b1bfc7",
  "#9bb1bb",
  "#b4c5d7",
  "#7685a1",
  "#5c6a85",
  "#10557d",
  "#40729c",
  "#5e8fb6",
  "#aed3e5",
  "#bacbdf",
  "#5b6d92",
  "#414a62",
  "#304c89",
  "#3862a3",
  "#6b8db3",
  "#a1bfd5",
  "#c9d0d8",
  "#93a0bd",
  "#d7cdb7",
  "#5c6274",
  "#5c79b3",
  "#8dadd9",
  "#9db2d0",
  "#a5b7cd",
  "#dee2e3",
  "#984841",
  "#a0a6b6",
  "#6e7182",
  "#2b3b4c",
  "#747d92",
  "#93a6be",
  "#c7d5e4",
  "#a64c43",
  "#acb3ca",
  "#7c819d",
  "#b86d52",
  "#696d86",
  "#3f4150",
  "#353963",
  "#40466d",
  "#3f457d",
  "#a6a6bd",
  "#bd6448",
  "#827f92",
  "#514c5a",
  "#999492",
  "#bbb6a9",
  "#c9bc96",
  "#bca87a",
  "#e2d0ac",
  "#cdbc96",
  "#b59f7c",
  "#efecd9",
  "#ded6bf",
  "#cac0a6",
  "#aa9d81",
  "#95836a",
  "#b1ada2",
  "#6c5d4a",
  "#f0e6d2",
  "#e3ceac",
  "#d6b28d",
  "#cc986b",
  "#ab7141",
  "#8b5c2b",
  "#e9caa6",
  "#daae85",
  "#bd8057",
  "#a09e97",
  "#bd713b",
  "#a55527",
  "#d17225",
  "#d1806d",
  "#b26b5d",
  "#905444",
  "#d69679",
  "#bd7a64",
  "#a95844",
  "#bf3f2d",
  "#827e78",
  "#ab3f30",
  "#a93434",
  "#be6f67",
  "#944544",
  "#773935",
  "#de8480",
  "#c86361",
  "#b0625c",
  "#b44d51",
  "#a02432",
  "#6a6967",
  "#9f233d",
  "#e1e0d1",
  "#cac7b4",
  "#968c76",
  "#aaa393",
  "#8e897c",
  "#6c6b6d",
  "#726e67",
  "#d5cfbf",
  "#bcb5a1",
  "#a39a88",
  "#c5bead",
  "#b2ab99",
  "#827b6d",
  "#e5e0d0",
  "#b1a591",
  "#867a6d",
  "#929392",
  "#aea497",
  "#938a7c",
  "#53473a",
  "#e8e0ce",
  "#d5cbb8",
  "#bfb5a3",
  "#b5a290",
  "#857567",
  "#4e433d",
  "#efeadb",
  "#848181",
  "#dfd3bd",
  "#b4a388",
  "#94836e",
  "#7f6c57",
  "#634f42",
  "#ded0b9",
  "#cbb79c",
  "#c6a883",
  "#a27f5d",
  "#886348",
  "#3b3230",
  "#6b4e3e",
  "#f9f6e7",
  "#e8decf",
  "#cec0ae",
  "#b99b82",
  "#906251",
  "#744634",
  "#eae1d0",
  "#ddccbd",
  "#d1b9a9",
  "#d4d0c3",
  "#b59c8d",
  "#8a6e62",
  "#5e3b2f",
  "#e3dfd5",
  "#d5d0c7",
  "#b5a99d",
  "#9f8e84",
  "#877e78",
  "#54423b",
  "#e3ded0",
  "#b0aca3",
  "#d5cbbe",
  "#c5b7ac",
  "#bba8a3",
  "#917876",
  "#6d5854",
  "#d6bbbb",
  "#ab696e",
  "#83434f",
  "#9e3f62",
  "#693a3c",
  "#848480",
  "#582f2f",
  "#8d8fa1",
  "#6f6177",
  "#4d3354",
  "#602e4e",
  "#6b5e6b",
  "#382930",
  "#e8e9e1",
  "#d6d2cd",
  "#c0bcbc",
  "#cbcdca",
  "#929591",
  "#d5d5d0",
  "#91898b",
  "#5f5960",
  "#cfd4d7",
  "#8ea3c5",
  "#53618f",
  "#8690a4",
  "#4b4a5c",
  "#403c3f",
  "#d0dde5",
  "#717571",
  "#9ab2c5",
  "#5f8ec2",
  "#4e719a",
  "#445772",
  "#404343",
  "#dcded8",
  "#c3c7c5",
  "#a8afb0",
  "#c9ced1",
  "#a2b0b7",
  "#626463",
  "#586471",
  "#8ca4ad",
  "#b7ced4",
  "#98c0cf",
  "#798e99",
  "#525a60",
  "#33383e",
  "#5ea3b1",
  "#3b98a2",
  "#26768e",
  "#c4baab",
  "#83a0ad",
  "#386b8c",
  "#004763",
  "#cbd3cc",
  "#9bafb1",
  "#82a1a7",
  "#56858c",
  "#44646d",
  "#023b4e",
  "#a7c7bc",
  "#afa79b",
  "#7eb6ac",
  "#759f9a",
  "#597d7d",
  "#496e73",
  "#1e4850",
  "#e8e6de",
  "#bbc3bb",
  "#919e97",
  "#b7c6be",
  "#8a9f9b",
  "#908980",
  "#707c79",
  "#cecec0",
  "#9fa194",
  "#767769",
  "#c2c8b8",
  "#a9b5a5",
  "#8a9e88",
  "#dbdfcc",
  "#c8d0b7",
  "#acae92",
  "#9d968c",
  "#87917a",
  "#697562",
  "#485241",
  "#dad9bc",
  "#c2be9f",
  "#949476",
  "#c8cb9f",
  "#b5b895",
  "#9ba375",
  "#e0dba9",
  "#878279",
  "#cfcb8c",
  "#bcb878",
  "#d1d256",
  "#b0bd4d",
  "#8dad61",
  "#ede9c9",
  "#d6d099",
  "#c9bf80",
  "#bab761",
  "#857d43",
  "#6a635d",
  "#5a5538",
  "#f2e7bd",
  "#f0dfa5",
  "#e1ca90",
  "#d6bd6f",
  "#bca346",
  "#957e37",
  "#efe8ca",
  "#f8e4b2",
  "#ecd093",
  "#d4cfc3",
  "#efd99a",
  "#e5c269",
  "#bb901e",
  "#efe6cb",
  "#dbc295",
  "#d5b781",
  "#bb9d61",
  "#987e55",
  "#866f4b",
  "#e9e0c0",
  "#f5f2e5",
  "#e8e1cc",
  "#eae0c4",
  "#f7ebcd",
  "#e2d3b3",
  "#d5c3a2",
  "#b8a387",
  "#b5a083",
  "#8e7559",
  "#d8cdb9",
  "#c8bca7",
  "#eeebd8",
  "#8a7a66",
  "#918578",
  "#695a4c",
  "#50382d",
  "#493830",
  "#4a403e",
  "#352d2b",
  "#ead6b8",
  "#ccaf92",
  "#a78668",
  "#e8e3cb",
  "#f1e7d4",
  "#e7ccb8",
  "#cea589",
  "#de9c8d",
  "#c58e79",
  "#c08e7f",
  "#c07060",
  "#a56559",
  "#906558",
  "#8f514c",
  "#d2c7a8",
  "#713128",
  "#783c36",
  "#6f4539",
  "#693d2d",
  "#64413d",
  "#f8e9c7",
  "#f2cd8f",
  "#e6b271",
  "#bd7d48",
  "#c87148",
  "#c5bca2",
  "#df745d",
  "#cc7469",
  "#af5c4a",
  "#bd4638",
  "#ab4830",
  "#985949",
  "#9e3f31",
  "#a6443d",
  "#ad433f",
  "#9f4552",
  "#9d9072",
  "#8c5059",
  "#734450",
  "#8e7f79",
  "#e4ca9f",
  "#e1c491",
  "#d6ae73",
  "#c79555",
  "#c29b63",
  "#b28a59",
  "#efd596",
  "#918a75",
  "#e8cd83",
  "#ddb558",
  "#efe5ba",
  "#dfce9d",
  "#d4bc7f",
  "#bb9951",
  "#b79f6d",
  "#ad9567",
  "#dad4b2",
  "#c1b88c",
  "#d2cbb9",
  "#a6a56c",
  "#e7e5bd",
  "#d3cf8f",
  "#b2b26a",
  "#6e743a",
  "#5f5d39",
  "#a7a787",
  "#babd99",
  "#c8ccad",
  "#a2ab87",
  "#edefe7",
  "#c5bead",
  "#75806a",
  "#484f32",
  "#363a32",
  "#a3b692",
  "#768c6e",
  "#597e5f",
  "#3e4f33",
  "#265d41",
  "#50996e",
  "#6e9486",
  "#b4ac99",
  "#2e8b7e",
  "#435851",
  "#bed6cd",
  "#96bfb8",
  "#558787",
  "#3d5459",
  "#6f8486",
  "#d0e2e0",
  "#7e9ea0",
  "#94c0c6",
  "#a29886",
  "#69a2ab",
  "#5d9fb6",
  "#6ca6c4",
  "#3c829f",
  "#4580a8",
  "#325a7d",
  "#304656",
  "#ced6d0",
  "#a7b0a9",
  "#768483",
  "#858374",
  "#c6d0d2",
  "#acc7d4",
  "#81929b",
  "#5a656c",
  "#517c8e",
  "#414f57",
  "#373839",
  "#57595a",
  "#5e6363",
  "#7e8181",
  "#847a67",
  "#a3a8a8",
  "#909698",
  "#d5d1c7",
  "#b9b8ae",
  "#7f807a",
  "#847d6f",
  "#827c6f",
  "#58584e",
  "#524f44",
  "#eae3d2",
  "#f2eddf",
  "#e2aa5f",
  "#82423a",
  "#674142",
  "#76403f",
  "#874b35",
  "#bd7d40",
  "#a9b5bc",
  "#e89b49",
  "#adb5a2",
  "#a27650",
  "#a2947f",
  "#5c463f",
  "#4a4442",
  "#9b6f40",
  "#4f423b",
  "#e5cba8",
  "#7f8786",
  "#d4cab9",
  "#dad3a1",
  "#deb866",
  "#7b7665",
  "#908972",
  "#b2a990",
  "#7f7766",
  "#918a78",
  "#a8a295",
  "#867f69",
  "#9a9684",
  "#aea897",
  "#807c64",
  "#e1c478",
  "#8f8d71",
  "#afab93",
  "#818066",
  "#9c9e87",
  "#b1b7a2",
  "#b9b790",
  "#cbcdae",
  "#d4dabf",
  "#a9b595",
  "#bfcbad",
  "#e7cd8d",
  "#cad7c0",
  "#586a54",
  "#798064",
  "#919d82",
  "#627067",
  "#687666",
  "#737f6a",
  "#638469",
  "#759a80",
  "#87ab93",
  "#b89c5b",
  "#64806c",
  "#75957d",
  "#8aab98",
  "#465a5d",
  "#415752",
  "#486055",
  "#6c9187",
  "#7da19a",
  "#93b5ac",
  "#b0baa4",
  "#c2aa6c",
  "#bec9b7",
  "#ccd4c4",
  "#93a9a0",
  "#aabeb4",
  "#c1d1c9",
  "#86989e",
  "#acbfbd",
  "#c1d0ca",
  "#82a0a6",
  "#9db6ba",
  "#cbba84",
  "#b5c8c9",
  "#618697",
  "#769eb0",
  "#95b9c6",
  "#465566",
  "#485b6e",
  "#435155",
  "#445962",
  "#627885",
  "#a08b5f",
  "#5e6c6c",
  "#778686",
  "#8a9696",
  "#7f867f",
  "#979f9b",
  "#aab2b0",
  "#757670",
  "#b8bab6",
  "#c1a873",
  "#cacbc5",
  "#d4d8d2",
  "#d9d3c4",
  "#e6e1cb",
  "#a09889",
  "#c9beaf",
  "#d9c6a6",
  "#646769",
  "#a8a9a3",
  "#daca9c",
  "#ccd0ca",
  "#990a14",
  "#69181a",
  "#762c23",
  "#662a25",
  "#4f3a30",
  "#745239",
  "#242e2c",
  "#27362e",
  "#0b412e",
  "#95805d",
  "#5f767f",
  "#e5dbab",
  "#a38f6a",
  "#baa887",
  "#bca470",
  "#c0b08c",
  "#ddcca7",
  "#bfae8c",
  "#dacaaa",
  "#e9e5d0",
  "#cbb58d",
  "#decea6",
  "#ece4c4",
  "#edddb7",
  "#ebdbb9",
  "#f4e2c0",
  "#ccb084",
  "#decca7",
  "#f3e5c3",
  "#a7885b",
  "#c1a77d",
  "#dac9ab",
  "#f5e1a4",
  "#9b7149",
  "#b79163",
  "#caa378",
  "#b1966f",
  "#c2ae8e",
  "#d1c2a7",
  "#aa896a",
  "#c0a689",
  "#d1bda4",
  "#9e624d",
  "#f2e5ba",
  "#985949",
  "#ae6b55",
  "#e7b388",
  "#f1caa7",
  "#f1d5b7",
  "#cda990",
  "#dfc1ab",
  "#d6b3a3",
  "#e2c8ba",
  "#f5e9c7",
  "#f1d9c6",
  "#754b4e",
  "#9a6d6b",
  "#d0ae9f",
  "#634543",
  "#774d4a",
  "#8c5956",
  "#65554a",
  "#69594d",
  "#7b6c5d",
  "#d5a65f",
  "#5f4f46",
  "#654c43",
  "#60514a",
  "#7f664e",
  "#927254",
  "#9d7756",
  "#8a7764",
  "#a3927c",
  "#d5cabb",
  "#bbab8e",
  "#ddb673",
  "#cdc0a8",
  "#dbd2bc",
  "#c2b59a",
  "#cec5b0",
  "#dbd3c3",
  "#7c7161",
  "#948674",
  "#978466",
  "#ac9c7c",
  "#ddbf86",
  "#cec3a4",
  "#bbab88",
  "#cebea0",
  "#a49a79",
  "#b8ae95",
  "#cec7aa",
  "#968d70",
  "#aca182",
  "#d6ceb1",
  "#e7deca",
  "#e0d8c6",
  "#eae0c8",
  "#f6ead2",
  "#f9ebd2",
  "#f7ecd3",
  "#f6e8c9",
  "#f5eed8",
  "#f5edcd",
  "#f8eecc",
  "#f3e7be",
  "#f6f3dd",
  "#d9cfbb",
  "#fbf6dd",
  "#f6eaca",
  "#f6e9c4",
  "#f5f2e1",
  "#faf8e0",
  "#f2f1d7",
  "#f2ebcd",
  "#f6f6ed",
  "#f6f7ee",
  "#eeefe5",
  "#e1d6c1",
  "#ece9d8",
  "#f7f5eb",
  "#f5f6eb",
  "#f7f7e7",
  "#f4f4e3",
  "#efeee3",
  "#f7f4e2",
  "#f5f3e3",
  "#f0f0df",
  "#f2efe8",
  "#e8e5d8",
  "#f2f1e6",
  "#ebe6d7",
  "#e9e5d0",
  "#eeecdb",
  "#eaead8",
  "#e5e5d2",
  "#e6e4cf",
  "#e7e7dd",
  "#e3e2d5",
  "#e1dfcf",
  "#dad5c6",
  "#dddccd",
  "#e7e4d9",
  "#e4dece",
  "#e7deca",
  "#e6e1cc",
  "#f2efe8",
  "#f2ebda",
  "#f2e7cf",
  "#f4e2c0",
  "#ebedea",
  "#d9d3c4",
  "#ebeee9",
  "#edeeeb",
  "#f1f2ee",
  "#d7cebf",
  "#e9e6db",
  "#e7e4d9",
  "#e7dbc3",
  "#e7e9e2",
  "#e6e4df",
  "#e3e0d7",
  "#dfdbcd",
  "#e9e8e0",
  "#dad6cc",
  "#d3cec4",
  "#edebdd",
  "#e8dcc8",
  "#e3dfd2",
  "#e2ddd0",
  "#dbd7c5",
  "#ede8d5",
  "#f0ebd7",
  "#ebe6d2",
  "#eae4cd",
  "#eceae0",
  "#f2efdf",
  "#f2eedd",
  "#e2d4c2",
  "#ebe3cf",
  "#e5e3d4",
  "#e2e0d1",
  "#dedbc7",
  "#e3dec7",
  "#e0ded1",
  "#dbd8c9",
  "#cecbba",
  "#dadbcf",
  "#e5dece",
  "#e0ded0",
  "#e0dfd7",
  "#d3d4cc",
  "#dfe1db",
  "#e6e8e1",
  "#e0e2dc",
  "#d6d8cf",
  "#f0f1ea",
  "#eaeee9",
  "#ecece3",
  "#e6e0cf",
  "#edede3",
  "#ecefec",
  "#eaece8",
  "#eceeea",
  "#e5e7e4",
  "#f1f5f1",
  "#f1f4f1",
  "#f2f4f1",
  "#f5f2ed",
  "#e3dcc8",
  "#f4efea",
  "#f0ebe4",
  "#f6f0e7",
  "#f6ecdf",
  "#f2e3d0",
  "#f0e2d2",
  "#e8d7c6",
  "#f7ebda",
  "#f7e7d4",
  "#f5e3cc",
  "#e4dcc4",
  "#f5e0c8",
  "#f3e6d3",
  "#f5ead6",
  "#f2e5d3",
  "#f0e0c9",
  "#f9f5e5",
  "#f6f0e1",
  "#f3e8d4",
  "#ede4d0",
  "#f8f1e1",
  "#e5e0d0",
  "#faf3e0",
  "#f8f1dd",
  "#f7ecd2",
  "#f9f2e0",
  "#f7efdc",
  "#eee7d5",
  "#e9ddc5",
  "#faf3e3",
  "#f7eedb",
  "#efe5d0",
  "#f1f2ee",
  "#27362e",
  "#27362e",
  "#242e2c",
  "#f2efe8",
  "#c9beaf",
  "#662a25",
  "#762c23",
  "#69181a",
  "#990a14",
  "#efeee5",
  "#edeeeb",
  "#e7e4d9",
  "#e4dece",
  "#f2e5d3",
  "#745239",
  "#4f3a30",
  "#f2e7cf",
  "#f4e2c0",
  "#d9c6a6",
  "#f2ebda",
  "#eee7d5",
  "#ebedea",
  "#e7deca",
  "#e6e1cc",
  "#a09889",
  "#ebeee9",
  "#ccd0ca",
  "#5f767f",
  "#a8a9a3",
  "#646769",
  "#2b2c2d",
  "#eee8dd",
  "#e9e5d8",
  "#f1ebe1",
  "#f0ebe1",
  "#f3ebdc",
  "#f4eedf",
  "#f3ecd9",
  "#f1ead8",
  "#eee4cf",
  "#f6f4ea",
  "#f4efe3",
  "#f1e7cc",
  "#efe7d3",
  "#f7f2e1",
  "#f7f0df",
  "#e3e0d7",
  "#e4e0d6",
  "#e1e2dd",
  "#dfdeda",
  "#ecf0e9",
  "#e9e7dd",
  "#dbd4c8",
  "#e7e3d9",
  "#e1e0d6",
  "#e5e2da",
  "#d7d7cd",
  "#e2dfd3",
  "#e8e9e1",
  "#f4e0cf",
  "#efd1bf",
  "#e8c4af",
  "#d9ac97",
  "#c99780",
  "#bc8069",
  "#a36952",
  "#f3e2d7",
  "#f1d8cd",
  "#e6c4b6",
  "#dcb2a2",
  "#c99d91",
  "#a57160",
  "#835246",
  "#f2d2c3",
  "#e6baa9",
  "#d7a697",
  "#cb9686",
  "#b47865",
  "#a76a58",
  "#8d5644",
  "#f7e8df",
  "#f7d7cd",
  "#f2beb4",
  "#d1867e",
  "#b86d64",
  "#8f584e",
  "#8c4944",
  "#eebebb",
  "#d79a99",
  "#c48281",
  "#b76d69",
  "#ae6660",
  "#924145",
  "#914849",
  "#f7dfd8",
  "#e6c6c3",
  "#dfbab7",
  "#d0a4a3",
  "#bb8a8a",
  "#9f6c69",
  "#7f534b",
  "#f7e7e4",
  "#e5c9c9",
  "#ddb9bd",
  "#caa1a6",
  "#bf8e92",
  "#99686b",
  "#784f4b",
  "#f2d6d6",
  "#ebcbce",
  "#e4bdc2",
  "#d7a5ad",
  "#c48a96",
  "#a76c76",
  "#824f52",
  "#eabcbf",
  "#d7a9b0",
  "#c89499",
  "#b07579",
  "#a66a6c",
  "#88585a",
  "#7c464a",
  "#f2e1de",
  "#e1c4c6",
  "#be9ca4",
  "#a68088",
  "#8e666a",
  "#7c484b",
  "#6d4643",
  "#dbbac1",
  "#d4b0b7",
  "#c49ea8",
  "#ae828d",
  "#93656b",
  "#7f4e59",
  "#67454a",
  "#ebc9ce",
  "#e3b9c0",
  "#cfa6b0",
  "#b78996",
  "#9f6f78",
  "#784552",
  "#7f444f",
  "#f0d7d2",
  "#e3c0bc",
  "#c99c99",
  "#aa756f",
  "#8b564f",
  "#865045",
  "#814d42",
  "#ede1d8",
  "#e1cbc3",
  "#d6bcb4",
  "#c1a199",
  "#ab8a82",
  "#926e64",
  "#76554a",
  "#eaddd4",
  "#dac4ba",
  "#baa198",
  "#a88f85",
  "#9a7e73",
  "#83675b",
  "#6b5145",
  "#d9c9c0",
  "#cdbcb4",
  "#b8a39a",
  "#a69086",
  "#7f6a60",
  "#6b584f",
  "#524641",
  "#eedfd5",
  "#e7d6cc",
  "#d2bbae",
  "#c8ab9b",
  "#b39383",
  "#977464",
  "#77584b",
  "#ecd9c6",
  "#e3cdb8",
  "#dcc2a9",
  "#cca88c",
  "#b58e73",
  "#a4785b",
  "#89644c",
  "#efe0d0",
  "#e8d0b9",
  "#dec0a8",
  "#cbae97",
  "#b0927a",
  "#a48268",
  "#98765b",
  "#f5e5d1",
  "#e5d0b8",
  "#dbc1a7",
  "#d0b092",
  "#bd9876",
  "#a17a5a",
  "#8a674c",
  "#e9ddcc",
  "#e1d1bc",
  "#c1ac92",
  "#b19a80",
  "#9f8468",
  "#8e755b",
  "#83684e",
  "#ebe0d3",
  "#dfd2c2",
  "#d8cab8",
  "#cabca9",
  "#baa893",
  "#8e7760",
  "#715f4e",
  "#ede2d4",
  "#ccbdad",
  "#bdad9a",
  "#907b68",
  "#776353",
  "#776350",
  "#dad3c8",
  "#cfc7b9",
  "#c1b8aa",
  "#aa9f8f",
  "#ebe8dc",
  "#ded6c9",
  "#d0c9bb",
  "#b9b0a3",
  "#a9a092",
  "#867c6c",
  "#675f53",
  "#ebe7dd",
  "#ddd6cd",
  "#cec8be",
  "#aa9f91",
  "#83796c",
  "#e6dfd3",
  "#ddd5c7",
  "#d0c7b7",
  "#aaa195",
  "#857b6d",
  "#746a5c",
  "#62584c",
  "#e4e0ce",
  "#e2dbc9",
  "#d8d0bc",
  "#c0b6a0",
  "#b1a793",
  "#8e826e",
  "#6e6352",
  "#e3ded3",
  "#d1cabc",
  "#c2bbac",
  "#aea391",
  "#8b7e6a",
  "#6c6150",
  "#e8d5bb",
  "#e1c9ac",
  "#d4b799",
  "#bea182",
  "#af8f6d",
  "#a07e5d",
  "#90704f",
  "#ead1ae",
  "#e3c59e",
  "#d3b188",
  "#caa577",
  "#bb9163",
  "#b68c63",
  "#aa815a",
  "#f4e7d0",
  "#efd8ba",
  "#e2c8a6",
  "#dec19c",
  "#d6b68b",
  "#c59e6f",
  "#a77c50",
  "#eadabf",
  "#e3cfb0",
  "#d2bc9f",
  "#bda281",
  "#b19671",
  "#a18560",
  "#90724e",
  "#e5d6bd",
  "#dfccad",
  "#d2bd9c",
  "#bfa57f",
  "#a98960",
  "#8f714a",
  "#856a4b",
  "#e9dfd0",
  "#ddd2be",
  "#d8ccb7",
  "#d1bea0",
  "#bba787",
  "#a58e6c",
  "#8a7454",
  "#e1d4bd",
  "#c6b698",
  "#bead8d",
  "#b6a17c",
  "#a28d69",
  "#7a6848",
  "#f0e6d4",
  "#e9dcc6",
  "#dfceb3",
  "#dcc9a5",
  "#c9b28d",
  "#a58d66",
  "#907855",
  "#f2ead7",
  "#e8d8bd",
  "#e1d0b2",
  "#d6c4a2",
  "#c9b38d",
  "#b29c75",
  "#8e764e",
  "#f2e9d6",
  "#eee3cb",
  "#e1d2b2",
  "#bba783",
  "#b29c73",
  "#a08a63",
  "#846f4b",
  "#f2ead6",
  "#f0e4ca",
  "#e0cfa8",
  "#cebc96",
  "#bba87e",
  "#af986b",
  "#907a50",
  "#ebe0c8",
  "#e4d8bd",
  "#dccdae",
  "#d6c7a3",
  "#c4b18a",
  "#ad976c",
  "#8c7952",
  "#ede5d1",
  "#e2d6b8",
  "#d9cca9",
  "#bbab82",
  "#ae9b6f",
  "#928159",
  "#82724e",
  "#ede3d0",
  "#dfd5ba",
  "#d6c9aa",
  "#cec19f",
  "#c1b58f",
  "#9f916b",
  "#7d704f",
  "#e6dfcf",
  "#e1d6c3",
  "#c5bba9",
  "#aea38e",
  "#a1937a",
  "#92856c",
  "#655a48",
  "#e6e1ce",
  "#d6ceba",
  "#cec6b1",
  "#c7bea5",
  "#b6ac91",
  "#978a6c",
  "#706750",
  "#dcd6c1",
  "#d0c8b1",
  "#c3baa2",
  "#a99d82",
  "#958c71",
  "#7e7254",
  "#786f51",
  "#edeade",
  "#dedccd",
  "#c8c2ac",
  "#a39a7a",
  "#8e8363",
  "#786f52",
  "#eee9da",
  "#e1dac5",
  "#cfc7ab",
  "#a3997b",
  "#938865",
  "#837a5b",
  "#7a7050",
  "#dcdacd",
  "#cac7b7",
  "#aea994",
  "#938f77",
  "#74705a",
  "#6a654b",
  "#e9e4d4",
  "#d3ceb8",
  "#c9c3ab",
  "#a29e87",
  "#918c72",
  "#847e64",
  "#756c4e",
  "#eee7cf",
  "#ece4ca",
  "#ddd2ac",
  "#d0c497",
  "#bcaf7a",
  "#afa16b",
  "#7c7147",
  "#eeead7",
  "#e7dfc2",
  "#ded6b3",
  "#cdc4a0",
  "#beb58c",
  "#b2a775",
  "#7e7546",
  "#edebd5",
  "#dfdab6",
  "#d3cda3",
  "#c4bd92",
  "#b2aa7c",
  "#99915f",
  "#877e4e",
  "#e4e5d0",
  "#dbddc4",
  "#d0d3b6",
  "#c2c5a4",
  "#b6b993",
  "#949569",
  "#6e6f4d",
  "#f3f2e9",
  "#eeede1",
  "#dfdfd1",
  "#c6c8b1",
  "#a1a282",
  "#858665",
  "#686b4b",
  "#ebe8dd",
  "#dad7c9",
  "#c4c0b0",
  "#aaab9e",
  "#97998b",
  "#707061",
  "#605e50",
  "#e1e2d2",
  "#d5d8c8",
  "#bbc3ad",
  "#959c81",
  "#7e856a",
  "#5f634f",
  "#4f5245",
  "#ededdf",
  "#d9decc",
  "#c2cbb3",
  "#878f77",
  "#767f67",
  "#616650",
  "#e2e5de",
  "#ced2cb",
  "#aeb5ad",
  "#666559",
  "#5d594d",
  "#575146",
  "#e9ece5",
  "#d9dcd6",
  "#bec4be",
  "#9ca299",
  "#737367",
  "#5e5c50",
  "#514d41",
  "#d6dcd1",
  "#ccd4c9",
  "#a9b6a8",
  "#97a697",
  "#758374",
  "#576256",
  "#dcdfd6",
  "#ced6cd",
  "#bec9bf",
  "#a8b5ac",
  "#6d7e75",
  "#525a53",
  "#e6eae3",
  "#d9e3dd",
  "#c1d3cd",
  "#afc3bf",
  "#3c5052",
  "#d6ddd5",
  "#cad2cd",
  "#bbc6bf",
  "#aeb8b3",
  "#929e9a",
  "#6e7673",
  "#59615e",
  "#dbe4dc",
  "#c9d6d1",
  "#b2c3c2",
  "#9eb1b0",
  "#899f9f",
  "#c5cecb",
  "#b9c5c2",
  "#707e7d",
  "#626f70",
  "#c1d2d1",
  "#96aeb2",
  "#60757a",
  "#485559",
  "#d7dcdd",
  "#bec9ce",
  "#a0b2bc",
  "#8e9ca7",
  "#768691",
  "#525356",
  "#e2e3e0",
  "#939ba4",
  "#6f767d",
  "#dddcdb",
  "#d1d0d1",
  "#b9b9be",
  "#a1a5ad",
  "#7f848f",
  "#71737c",
  "#48474b",
  "#cccecd",
  "#9da3a7",
  "#c9c8c4",
  "#b9b8b5",
  "#a2a3a2",
  "#848586",
  "#636463",
  "#4f4e4c",
  "#e1dfd9",
  "#d7d3ce",
  "#a0a09f",
  "#4c4946",
  "#e2dcd6",
  "#d9d6d3",
  "#b1aeae",
  "#9f9c9c",
  "#7a7473",
  "#655a56",
  "#cbc6c3",
  "#beb8b6",
  "#b5afab",
  "#9c9898",
  "#807c7d",
  "#67615f",
  "#524b48",
  "#ddd6cb",
  "#b0a89e",
  "#857e74",
  "#645b4e",
  "#cfc7bd",
  "#c6beb2",
  "#a7a198",
  "#867f73",
  "#756d63",
  "#5a554a",
  "#c2bcb0",
  "#8b8981",
  "#7a776c",
  "#737065",
  "#565148",
  "#c4c5bc",
  "#73766f",
  "#dde2e6",
  "#c4d1e0",
  "#aabbd3",
  "#8196b4",
  "#677b9b",
  "#617696",
  "#49536b",
  "#c6d3e5",
  "#b3c6e0",
  "#a7bcdc",
  "#99afd2",
  "#7c98c3",
  "#607cab",
  "#dbe3ec",
  "#c6d5ea",
  "#aac0e3",
  "#98aedb",
  "#5874b4",
  "#43487d",
  "#d5e1ed",
  "#bdd2ea",
  "#a0bde4",
  "#8faedc",
  "#7296cf",
  "#547dbd",
  "#41518e",
  "#c8d8e4",
  "#b6cbde",
  "#a1bdd7",
  "#87a4c0",
  "#7192b4",
  "#4f6e90",
  "#414b61",
  "#d3dddf",
  "#c7d3da",
  "#b7c8d3",
  "#9eb0c0",
  "#8b9eb3",
  "#64768b",
  "#4f5b6e",
  "#dee3e0",
  "#c8d4d8",
  "#b5c6cf",
  "#99afbc",
  "#859dad",
  "#4b5c6a",
  "#e1ebea",
  "#c6deec",
  "#aacfeb",
  "#8dbfe6",
  "#6ea7db",
  "#387ec2",
  "#335392",
  "#ccdce1",
  "#bcd2dd",
  "#adc6d6",
  "#91b3ce",
  "#7ba0c1",
  "#557ea2",
  "#425e79",
  "#d9e3e2",
  "#bfd7e1",
  "#adcedd",
  "#92bad1",
  "#73a3c2",
  "#4a7fa0",
  "#395e7a",
  "#dfeceb",
  "#c3e4eb",
  "#9ed6e7",
  "#7bc8e2",
  "#5bb4d5",
  "#37a5cb",
  "#0a5b7e",
  "#e8eeea",
  "#cfe3e4",
  "#bdd9de",
  "#92b9c4",
  "#6b9ca8",
  "#4e828d",
  "#3e5c64",
  "#dfeeeb",
  "#c3e7ea",
  "#9ad9e2",
  "#6cc4d3",
  "#2eadc2",
  "#0096ab",
  "#006381",
  "#cfeee8",
  "#bfe9e4",
  "#a5e3e0",
  "#7ed8d7",
  "#28b7b8",
  "#00a4a3",
  "#006d6e",
  "#e1eee7",
  "#d7e9e4",
  "#b8ddda",
  "#91c2c3",
  "#5f9e9d",
  "#488786",
  "#2d5c62",
  "#def1e9",
  "#bee9e0",
  "#90dacf",
  "#7bcbc1",
  "#50b5aa",
  "#289f90",
  "#206d63",
  "#e4ece1",
  "#c5d9d1",
  "#b8d1c7",
  "#a8c3b9",
  "#91afa4",
  "#546d61",
  "#d5ebe0",
  "#bae1d2",
  "#a8d7c6",
  "#96c6b6",
  "#72ac98",
  "#55927a",
  "#2d5c4f",
  "#daf1e2",
  "#c0e9d7",
  "#afe4cc",
  "#88cfaf",
  "#62b992",
  "#40a374",
  "#227654",
  "#e2efdf",
  "#d8ebd8",
  "#c8e5cd",
  "#abd6b4",
  "#7eb086",
  "#689b6c",
  "#578153",
  "#ebf1e3",
  "#daeed6",
  "#addeb3",
  "#9ecfa2",
  "#7fbb81",
  "#61a462",
  "#3d8145",
  "#dfecd9",
  "#c4dcc9",
  "#bed9c3",
  "#a3c6ac",
  "#8eb597",
  "#6e9675",
  "#4f6a4e",
  "#e1e6d3",
  "#cfd9c4",
  "#becdb6",
  "#b0c4a9",
  "#9baf91",
  "#809675",
  "#5d6c50",
  "#e9ebd8",
  "#d3dcc3",
  "#c7d1b5",
  "#bec8a6",
  "#aeba95",
  "#8c9a70",
  "#65704d",
  "#e9edd9",
  "#ceddbc",
  "#c3d6b2",
  "#bcd0a8",
  "#a5bd8e",
  "#8ba874",
  "#6d8553",
  "#e4efd8",
  "#d1e8c4",
  "#c0e0b3",
  "#b7d6a4",
  "#96c184",
  "#81ae66",
  "#639049",
  "#eff1dc",
  "#e4eec9",
  "#d6e8b5",
  "#c4db9c",
  "#afcd7f",
  "#99bd5f",
  "#7aa542",
  "#edeeca",
  "#e5eaba",
  "#e0e6af",
  "#d3da94",
  "#c5ce7f",
  "#aab85b",
  "#96a440",
  "#e8eace",
  "#d9ddb7",
  "#cfd4a6",
  "#bec48c",
  "#a7ab6b",
  "#949b59",
  "#7d8447",
  "#eae6c8",
  "#e0dfbb",
  "#d8d5a9",
  "#cac68c",
  "#bdb86c",
  "#aba857",
  "#8f9046",
  "#f4efd3",
  "#efe9c0",
  "#ede3af",
  "#e1d593",
  "#ccbd68",
  "#bcab51",
  "#a79a45",
  "#f8f2d3",
  "#f4e5b7",
  "#efdea4",
  "#e7d190",
  "#d8b966",
  "#ccad54",
  "#be9e43",
  "#f5eecf",
  "#f3e5b9",
  "#f2dfa8",
  "#ecd38b",
  "#ebcc76",
  "#e0be62",
  "#cfa541",
  "#f6f2da",
  "#f7f2d7",
  "#f9f0c7",
  "#f7d67a",
  "#f3c854",
  "#e8b229",
  "#f6f3d9",
  "#f8f2d2",
  "#faf0c2",
  "#faefbb",
  "#fce28e",
  "#f7cd58",
  "#f1b837",
  "#f8efcb",
  "#f8ecb0",
  "#f9e89e",
  "#fce589",
  "#f6d862",
  "#f3cd47",
  "#f0c32f",
  "#f8f4dc",
  "#fbf1c4",
  "#fdeea5",
  "#fae16a",
  "#f7d22d",
  "#f0ca14",
  "#edc80c",
  "#f7f4dd",
  "#f9f2c8",
  "#faf1b9",
  "#feee9a",
  "#ffea81",
  "#ffe04d",
  "#ffd328",
  "#f7f5e5",
  "#f8f2d6",
  "#fbefc5",
  "#ffe79d",
  "#ffdf7b",
  "#ffd046",
  "#ffc100",
  "#f8efd2",
  "#f9e8ba",
  "#f9e4a9",
  "#f7d98d",
  "#e9c062",
  "#dfb24f",
  "#d0a43f",
  "#f3ebd2",
  "#f1e4bf",
  "#eddaad",
  "#e0cb9b",
  "#c3a767",
  "#ba9d60",
  "#a88846",
  "#f8e7c9",
  "#f4e1be",
  "#f0ddba",
  "#dfc595",
  "#d0b179",
  "#c2a167",
  "#ac8950",
  "#f1e4c8",
  "#ead8b4",
  "#e8d4ab",
  "#dcc699",
  "#caae78",
  "#b5975d",
  "#9a804c",
  "#f0e4c9",
  "#e9dbc1",
  "#e8d6b0",
  "#d4b88b",
  "#c1a271",
  "#b39465",
  "#9a7c4d",
  "#f5ead1",
  "#f4e0bf",
  "#edd3ac",
  "#dfbe8b",
  "#d3ac73",
  "#bc9354",
  "#af864d",
  "#f6eeda",
  "#f5dfb9",
  "#f3d5a6",
  "#efd29d",
  "#e7c38a",
  "#d6aa64",
  "#b78944",
  "#f7f0dd",
  "#f9e6c1",
  "#f8dca9",
  "#efc689",
  "#e5b875",
  "#d7a458",
  "#c79244",
  "#f8ebd1",
  "#f8e7c9",
  "#f0d7ac",
  "#ebd2a8",
  "#e5c694",
  "#caa367",
  "#b5884d",
  "#f6eed8",
  "#fce4b6",
  "#f9daa3",
  "#f6d398",
  "#f0c985",
  "#e0b05d",
  "#c59442",
  "#f6f3e5",
  "#f6f0d9",
  "#faebc0",
  "#f8d898",
  "#eec377",
  "#e0b057",
  "#d09c3c",
  "#f9f2d9",
  "#fbf1d1",
  "#fee2a4",
  "#ffd98e",
  "#feca67",
  "#f9b945",
  "#eca72a",
  "#f9f0d0",
  "#fcedc2",
  "#fde9ae",
  "#ffe298",
  "#ffd269",
  "#ffc63c",
  "#ffb305",
  "#f7f2db",
  "#faefc2",
  "#fee59f",
  "#ffd368",
  "#ffc137",
  "#ffb428",
  "#fdab25",
  "#f8f2df",
  "#fbebc6",
  "#ffdea2",
  "#ffd185",
  "#ffc36a",
  "#ffb144",
  "#ff9a29",
  "#fbebcf",
  "#fce8c5",
  "#ffdbaa",
  "#ffd49f",
  "#ffb46e",
  "#ffa04f",
  "#f98433",
  "#f9e9d0",
  "#fcddb9",
  "#ffcfa1",
  "#febb83",
  "#faac6c",
  "#f99e59",
  "#ef8945",
  "#f8e5cb",
  "#fddfba",
  "#fdd4a9",
  "#f9c595",
  "#efaf78",
  "#e69c5a",
  "#d38643",
  "#f8f0e1",
  "#f8e5cc",
  "#f4d4ae",
  "#e8b984",
  "#d2985a",
  "#c4894f",
  "#bf8249",
  "#f5e3d0",
  "#f8ddc5",
  "#f4d3b7",
  "#e9c09a",
  "#d7a070",
  "#cf9561",
  "#b37c4a",
  "#f6e8d7",
  "#f4ddc4",
  "#f3d3b5",
  "#deb899",
  "#d6ab88",
  "#c08a64",
  "#aa724f",
  "#f2d8bf",
  "#f0ccaf",
  "#ecc6a6",
  "#dfb393",
  "#cd9875",
  "#b77c57",
  "#a06846",
  "#f7e6d3",
  "#f8dcc7",
  "#f5d4bd",
  "#eeb792",
  "#da966c",
  "#d08b60",
  "#b57248",
  "#f4f0e4",
  "#f9ebda",
  "#fcd9bd",
  "#fecfaf",
  "#f3a67d",
  "#e79060",
  "#cd6e44",
  "#f6f0e2",
  "#faead6",
  "#fde4cb",
  "#ffc299",
  "#ffa97a",
  "#fd9158",
  "#e77741",
  "#f7d1b7",
  "#f4c7ab",
  "#efb597",
  "#d17f58",
  "#9b5244",
  "#fbe8d8",
  "#ffdec9",
  "#ffd2ba",
  "#ffb99e",
  "#fca080",
  "#f88760",
  "#ed6641",
  "#f9e3d9",
  "#fad2c4",
  "#f7c7b6",
  "#efb3a0",
  "#dc8971",
  "#ac5844",
  "#a45849",
  "#f1e7de",
  "#f8e0d3",
  "#f2c8b6",
  "#e9ad99",
  "#db9b8a",
  "#c57f6d",
  "#8e4b3f",
  "#f9ebe2",
  "#fdd5c7",
  "#f6b4a5",
  "#ef9e8d",
  "#e2816a",
  "#c0594b",
  "#be5d4c",
  "#fae2d7",
  "#f9ddd5",
  "#f7cfc7",
  "#edb1a9",
  "#da8d80",
  "#cc796b",
  "#ac594b",
  "#f8ece6",
  "#fbe2de",
  "#ffcbc9",
  "#ffb1b0",
  "#f89596",
  "#de4f46",
  "#c24044",
  "#f8e8df",
  "#fbd7d3",
  "#fccbc9",
  "#f7a6a4",
  "#e9827f",
  "#df726d",
  "#bf4d47",
  "#f8dad6",
  "#f7cdcd",
  "#f2bcc0",
  "#eba3aa",
  "#da868c",
  "#b35250",
  "#a24e4d",
  "#f6c1c8",
  "#f3b0ba",
  "#e5848e",
  "#d56069",
  "#c74a4a",
  "#bc484e",
  "#a74c53",
  "#fbe4e6",
  "#ffd8e0",
  "#fec0ce",
  "#f891a9",
  "#f1758d",
  "#ce3a3e",
  "#b53f43",
  "#fae4e5",
  "#fcdce0",
  "#fccbd2",
  "#fcbbc5",
  "#ef91a0",
  "#c43944",
  "#a23d40",
  "#f7ebec",
  "#f7dbe3",
  "#f8d1e0",
  "#f5bdd4",
  "#f2adc9",
  "#dd6c96",
  "#9f3949",
  "#f7e2e6",
  "#f3ccd7",
  "#e5a4ba",
  "#d17c94",
  "#af5161",
  "#a8455e",
  "#aa446a",
  "#f5c6d2",
  "#f3bdcb",
  "#e8a1b5",
  "#ce798f",
  "#974851",
  "#9e4a52",
  "#984245",
  "#f6dde0",
  "#f5d2d7",
  "#f3c4cd",
  "#e2a0ae",
  "#d78c9b",
  "#be6471",
  "#a63b49",
  "#f5e8ea",
  "#f4dbe3",
  "#eeccdb",
  "#ecc1d5",
  "#dba9c4",
  "#b77494",
  "#894565",
  "#f5ecec",
  "#f4e1ea",
  "#f3cde5",
  "#f0bcdf",
  "#e59dcb",
  "#d772af",
  "#a33d65",
  "#f4e1eb",
  "#f2d8e8",
  "#edc7e1",
  "#d8a6ce",
  "#cc94c1",
  "#b471a5",
  "#70435a",
  "#eddce0",
  "#e0c6d6",
  "#dbb6cd",
  "#bd8cad",
  "#a8789c",
  "#966284",
  "#684b5b",
  "#f3ecea",
  "#f2dfe9",
  "#edcee5",
  "#e6bee0",
  "#c393c7",
  "#b078b1",
  "#6e496e",
  "#eedbe7",
  "#e7cfe4",
  "#debedd",
  "#cbaad0",
  "#b692be",
  "#a47dac",
  "#644466",
  "#eddcea",
  "#e6d0e7",
  "#ddc1e2",
  "#cbaed7",
  "#b493c8",
  "#9872af",
  "#694a73",
  "#ede3e7",
  "#e2cddc",
  "#d7bbd1",
  "#c3afc5",
  "#ae95b1",
  "#947795",
  "#614c5f",
  "#efdedf",
  "#e0c8d5",
  "#d8bbcd",
  "#b38fab",
  "#9f7b9b",
  "#8b6885",
  "#634e60",
  "#eadade",
  "#dec9d1",
  "#d3b9c5",
  "#bea5b5",
  "#a28698",
  "#846778",
  "#54454f",
  "#ede3df",
  "#e2d4d6",
  "#d6c7cc",
  "#c5afba",
  "#b69eab",
  "#8f7683",
  "#5e4a52",
  "#e9dfe5",
  "#d6c7d5",
  "#bca9c0",
  "#97819b",
  "#675569",
  "#564954",
  "#eee7e8",
  "#eae0e7",
  "#e2d6e4",
  "#d1c0dc",
  "#c0b0cf",
  "#a694bc",
  "#624d6c",
  "#ebe5eb",
  "#e4dbea",
  "#dacee7",
  "#cdbde2",
  "#b6a8d5",
  "#a797cb",
  "#604d7a",
  "#e2dfe7",
  "#d9d5e4",
  "#cac6df",
  "#a3a0c8",
  "#9593bd",
  "#78739f",
  "#574e70",
  "#d9d0e2",
  "#cfc3dc",
  "#b9b1ce",
  "#a49ec8",
  "#a098c5",
  "#8275ab",
  "#574c71",
  "#e3e3ea",
  "#dadaea",
  "#bfbfe4",
  "#a9aad7",
  "#9092ca",
  "#7173b3",
  "#555283",
  "#f1f0ed",
  "#e4e3eb",
  "#ccd0e6",
  "#bac0e4",
  "#8792cb",
  "#7179b8",
  "#4a4779",
  "#e9e8e5",
  "#ccd0e2",
  "#bec5de",
  "#abb2d7",
  "#98a0cc",
  "#717ab0",
  "#5b6196",
  "#e1dce3",
  "#d4cddb",
  "#bfb9cd",
  "#a6a4ba",
  "#9896ae",
  "#6d6983",
  "#514c5b",
  "#e8e2e5",
  "#cac2d0",
  "#b7b0c3",
  "#9e96ab",
  "#8e859b",
  "#81788d",
  "#5a505e",
  "#e1d9e3",
  "#dbd5df",
  "#d1c9d7",
  "#bcb4ca",
  "#aca2bd",
  "#857a9b",
  "#625165",
  "#ece3e2",
  "#e5dada",
  "#bdb1bc",
  "#a194a1",
  "#92838e",
  "#80717c",
  "#5b4a57",
  "#e6e1de",
  "#daced4",
  "#cdc0c9",
  "#bfb1bd",
  "#a89aaa",
  "#817180",
  "#594f58",
  "#d9d8da",
  "#cfced3",
  "#c0bfc7",
  "#b1b1bb",
  "#9b9daa",
  "#6f7280",
  "#5d5e6a",
  "#e4e3d9",
  "#e2ddcd",
  "#f5f4f1",
  "#eeebe1",
  "#f0ede3",
  "#e0dacf",
  "#c9c8cb",
  "#aeafb0",
  "#838487",
  "#747777",
  "#545554",
  "#c2c1bc",
  "#7c7974",
  "#50504f",
  "#d7d0c5",
  "#b9b2aa",
  "#aea89f",
  "#7e7467",
  "#534f4a",
  "#4b4745",
  "#e4dfd7",
  "#d1c7b9",
  "#bab0a5",
  "#62534d",
  "#e5dfd3",
  "#d6cdbc",
  "#a4927e",
  "#927d61",
  "#6f5d47",
  "#574c44",
  "#d0cac1",
  "#bcb8ae",
  "#908a76",
  "#787159",
  "#56523f",
  "#ddd9bb",
  "#bbac79",
  "#9d8b51",
  "#b89040",
  "#816e4b",
  "#b4b29d",
  "#a6a899",
  "#759171",
  "#788770",
  "#4d625a",
  "#babeaf",
  "#a2a690",
  "#8c896d",
  "#575c53",
  "#525850",
  "#bbc3b8",
  "#9fa398",
  "#3a596d",
  "#94a5ab",
  "#44535c",
  "#495b63",
  "#b8cbd4",
  "#9ec1cd",
  "#a0aeb8",
  "#5f7688",
  "#424b55",
  "#cad0d3",
  "#8e9a9f",
  "#91999c",
  "#525b61",
  "#b3bec5",
  "#77808a",
  "#626f7a",
  "#cbccd4",
  "#aaa7af",
  "#737379",
  "#49454b",
  "#4b4648",
  "#d4cbc6",
  "#b0a5a0",
  "#7e746c",
  "#766866",
  "#695b57",
  "#c1b4b8",
  "#9b8988",
  "#837272",
  "#7f686a",
  "#e7d1c4",
  "#cab2ac",
  "#7d4742",
  "#784042",
  "#6f4242",
  "#5b4846",
  "#f0e9d8",
  "#d9c9b3",
  "#bea996",
  "#9b775f",
  "#825945",
  "#5a4a43",
  "#3c3b3c",
  "#454444",
  "#515051",
  "#6c6b6c",
  "#79787a",
  "#868586",
  "#a3a2a3",
  "#c0bebf",
  "#cfced0",
  "#dddcdd",
  "#91353d",
  "#bd3c4b",
  "#54473d",
  "#6b543d",
  "#755d47",
  "#815f3c",
  "#886d52",
  "#95734f",
  "#9e7e5c",
  "#a78869",
  "#af9175",
  "#b89d83",
  "#c3a283",
  "#c2a891",
  "#c9ab8f",
  "#d2b69d",
  "#e3b687",
  "#d2bead",
  "#d9c0ab",
  "#dfc3a9",
  "#dac8ba",
  "#e4ccb7",
  "#f2caa2",
  "#d7d1ce",
  "#eed0b4",
  "#f3d2b2",
  "#f1d8c2",
  "#c9d9e9",
  "#c4badd",
  "#ffba6d",
  "#b3a7d3",
  "#d3cbe5",
  "#0081c2",
  "#aac9e8",
  "#dfd8ea",
  "#fbb158",
  "#c33e49",
  "#f4a027",
  "#fbd6af",
  "#e6e0ed",
  "#a9333d",
  "#fcbb69",
  "#9cbfe3",
  "#77393e",
  "#364c63",
  "#4d5e72",
  "#687788",
  "#768393",
  "#6a88a8",
  "#7796b8",
  "#909eaf",
  "#9fabba",
  "#97afc9",
  "#92b2d4",
  "#aeb7c5",
  "#a3bedc",
  "#bdc5d1",
  "#ccd1db",
  "#c5d5ea",
  "#dcdee3",
  "#dadee7",
  "#ecebee",
  "#eaebef",
  "#eaebf0",
  "#e8ebec",
  "#e1edef",
  "#bec4c1",
  "#ccd1cf",
  "#dadedc",
  "#9fa494",
  "#b9bcad",
  "#5e537a",
  "#6b637b",
  "#766f86",
  "#766b91",
  "#8478a0",
  "#8a8495",
  "#8c80a3",
  "#8d869a",
  "#9c90b7",
  "#a39dae",
  "#b0a5c6",
  "#b0abba",
  "#d0c7dc",
  "#9b587e",
  "#b16590",
  "#cb80a8",
  "#c688a9",
  "#d99fbe",
  "#deaac5",
  "#e7c0d4",
  "#d9c6d0",
  "#f0bfd8",
  "#e3d3da",
  "#eadee3",
  "#7f4644",
  "#8e4545",
  "#9c4745",
  "#a45351",
  "#b25352",
  "#a45e5b",
  "#c35352",
  "#bc605d",
  "#b86c68",
  "#cf6d6a",
  "#d96b6a",
  "#c87975",
  "#de7a76",
  "#d88682",
  "#e4928d",
  "#5b5044",
  "#665c50",
  "#725c42",
  "#73675d",
  "#866d4d",
  "#7f746a",
  "#9a8368",
  "#a29384",
  "#af9473",
  "#aea092",
  "#b99e80",
  "#baada0",
  "#c2aa8e",
  "#dca75c",
  "#e2af6b",
  "#cbb59e",
  "#c5b9ae",
  "#c9c2be",
  "#d9c1a8",
  "#cec4bb",
  "#f2c284",
  "#e6ceb4",
  "#e2d4c6",
  "#f2d4b2",
  "#ebd7c3",
  "#f8dcbe",
  "#eee0d3",
  "#f2e1d1",
  "#fadfc2",
  "#f6eae0",
  "#f8e9da",
  "#bdd1e8",
  "#6a3d58",
  "#7d4240",
  "#0071b4",
  "#883e67",
  "#eaa5c7",
  "#83addb",
  "#007d92",
  "#0090a6",
  "#089eb4",
  "#d14748",
  "#38acc0",
  "#94d3e1",
  "#a8dbe5",
  "#fdcd87",
  "#6ac1d2",
  "#9ad5e2",
  "#c9393b",
  "#fae8d1",
  "#847560",
  "#92784e",
  "#9c835b",
  "#9a866b",
  "#a39077",
  "#b29056",
  "#ae9265",
  "#a39686",
  "#ae9675",
  "#ac9b84",
  "#b7a183",
  "#c29e60",
  "#aea293",
  "#c0a171",
  "#b7a691",
  "#cea65d",
  "#c7ab80",
  "#b9aea2",
  "#c7af8e",
  "#cfae7b",
  "#ceb38b",
  "#dbb169",
  "#c8b79e",
  "#c5bbb0",
  "#cfba9d",
  "#d5b789",
  "#d0c0ac",
  "#dcc198",
  "#d6c3aa",
  "#dbc5a7",
  "#d9cbba",
  "#e1cfb6",
  "#eccea2",
  "#efd5b1",
  "#e7d7c4",
  "#f5e3ce",
  "#f8e4cc",
  "#f6eade",
  "#f7eada",
  "#de87b0",
  "#f8b7ae",
  "#6c9cd1",
  "#f5a69b",
  "#fdd79c",
  "#eceee8",
  "#f2988b",
  "#fac6bf",
  "#fad3ce",
  "#6394cb",
  "#ec7e6f",
  "#f3ca8c",
  "#fee2b8",
  "#fce0b4",
  "#e96d5a",
  "#f9ebda",
  "#fed372",
  "#fcdfaf",
  "#525966",
  "#62656b",
  "#606672",
  "#536784",
  "#6e7176",
  "#697283",
  "#62738f",
  "#797e89",
  "#718099",
  "#87898e",
  "#858c9a",
  "#7c8da9",
  "#768eb3",
  "#9399a6",
  "#8c9ab4",
  "#8a9bb8",
  "#869bbd",
  "#809cc6",
  "#9ba6bd",
  "#95a7c6",
  "#b0b4be",
  "#aab5cd",
  "#a3b5d7",
  "#bfc2cb",
  "#b4c3e0",
  "#cfced1",
  "#c9cfe0",
  "#c4d0e8",
  "#dedddf",
  "#ecebef",
  "#4d5a5e",
  "#425d65",
  "#626f74",
  "#6b797e",
  "#77858a",
  "#698891",
  "#4d8d9e",
  "#75939c",
  "#8f9b9f",
  "#68a2b2",
  "#99a5a9",
  "#8ba8b0",
  "#76adbc",
  "#a3afb3",
  "#b0bbbf",
  "#8fc1d0",
  "#bcc7cc",
  "#b3cbd3",
  "#a4ccd7",
  "#cbd4d7",
  "#c9d5d9",
  "#c4d5db",
  "#bbd6de",
  "#b7d7e0",
  "#dbdedf",
  "#d8dfe2",
  "#d0e0e5",
  "#c3e1eb",
  "#cce6ef",
  "#ecebeb",
  "#eaebec",
  "#e7ecea",
  "#4b4e47",
  "#636761",
  "#dde0d7",
  "#e3e2e1",
  "#ecebe8",
  "#f1f0ef",
  "#4b4551",
  "#52485a",
  "#5d5465",
  "#b6a5c1",
  "#cabcd2",
  "#dcd2e1",
  "#ded3e4",
  "#edeaed",
  "#59444c",
  "#724859",
  "#874161",
  "#7c5364",
  "#977783",
  "#c67295",
  "#aa8f9a",
  "#b59ca6",
  "#c0a9b2",
  "#bab4b7",
  "#c8b5bc",
  "#d3c2c9",
  "#d4cfd2",
  "#76463d",
  "#7f5248",
  "#905e54",
  "#ab6153",
  "#b26d5f",
  "#d75443",
  "#c5796b",
  "#e08576",
  "#d29185",
  "#4f4a45",
  "#585045",
  "#5b5752",
  "#655d52",
  "#6f675d",
  "#74706b",
  "#7b756b",
  "#817e7a",
  "#8d7b5d",
  "#878078",
  "#938d86",
  "#a18d68",
  "#9b9895",
  "#ab9876",
  "#a29c95",
  "#b69f73",
  "#b5a283",
  "#ada8a2",
  "#bea982",
  "#bead90",
  "#caad72",
  "#d6b053",
  "#bab6b1",
  "#d1b57f",
  "#c6b79e",
  "#ceb88e",
  "#c2b9ae",
  "#e4ba50",
  "#cebb9d",
  "#deba6f",
  "#d5c09c",
  "#e7be5f",
  "#cfc1ac",
  "#c7c3bf",
  "#ddc18a",
  "#e3c17c",
  "#e9c26d",
  "#dac8a9",
  "#d7cbba",
  "#e1cca8",
  "#d4d0cd",
  "#e7d0a7",
  "#f0d196",
  "#e6d4b6",
  "#e0d6c7",
  "#ebd6b4",
  "#e0d9d1",
  "#dfdddc",
  "#e1dedc",
  "#eddfcb",
  "#f1e2c8",
  "#f6e3c5",
  "#eae5df",
  "#f0e6db",
  "#f6e8d3",
  "#eeebea",
  "#5184bf",
  "#ad3439",
  "#faded9",
  "#719ace",
  "#f2c765",
  "#f0ca7f",
  "#fce6b2",
  "#9bb3dd",
  "#ffcf97",
  "#ebe4d2",
  "#f1ebe4",
  "#b895c7",
  "#c4a4cf",
  "#a33e66",
  "#9c917b",
  "#a69c88",
  "#b2a896",
  "#c6ac66",
  "#bbb2a2",
  "#d2ba7e",
  "#d8bc70",
  "#c6beb0",
  "#cdc3ae",
  "#eac550",
  "#e1c88a",
  "#edc95e",
  "#d6cdbb",
  "#efcd6b",
  "#e4ce97",
  "#dcd0b8",
  "#efd079",
  "#d6d2cc",
  "#e1d3b5",
  "#ecd394",
  "#f3d585",
  "#dfd6c7",
  "#e4d9c5",
  "#e8dbc2",
  "#f1ddae",
  "#f7dd9f",
  "#ecddbf",
  "#e2deda",
  "#eae1d3",
  "#eee3cf",
  "#f2e5cc",
  "#eeeae7",
  "#f3ebe0",
  "#f7ecd9",
  "#dce1e4",
  "#9068a2",
  "#9f77b0",
  "#ab85bb",
  "#d0b8da",
  "#fa9a7e",
  "#f7eddb",
  "#f9f0e1",
  "#5d426a",
  "#c6557f",
  "#f8d870",
  "#c4cde7",
  "#009986",
  "#f6ecd9",
  "#f8eed9",
  "#537db9",
  "#a89a75",
  "#b0a481",
  "#baae8d",
  "#ceb24c",
  "#bbb29e",
  "#c7beac",
  "#d1cab9",
  "#e7cf8a",
  "#e4d09a",
  "#ebd495",
  "#f9d646",
  "#e1d7c1",
  "#e9d7a7",
  "#f7db81",
  "#fedf6f",
  "#f0dfb4",
  "#f6de9d",
  "#ffe27c",
  "#e7e0d3",
  "#fae199",
  "#ffe387",
  "#ffe693",
  "#f4ebdb",
  "#fdebbc",
  "#fad0c3",
  "#faedce",
  "#3863a1",
  "#bac5e4",
  "#00b4a3",
  "#fcac91",
  "#b0bce0",
  "#e1e2e9",
  "#444d63",
  "#404d6b",
  "#52586d",
  "#4f5972",
  "#5f6478",
  "#5a6684",
  "#63729a",
  "#767e99",
  "#717ea4",
  "#858ca5",
  "#7e8bae",
  "#9399b0",
  "#8f99b9",
  "#9ca6c2",
  "#b0b4c7",
  "#acb2c8",
  "#acb3cd",
  "#bec1d2",
  "#bcc2d8",
  "#cdd0dd",
  "#cacfe5",
  "#dcdde6",
  "#dcdde7",
  "#ebeaef",
  "#ecebf0",
  "#45626e",
  "#7c8286",
  "#989da0",
  "#38a1c5",
  "#a4a9ac",
  "#59b3d4",
  "#b2b6b9",
  "#b1b9be",
  "#7bc2df",
  "#c0c4c6",
  "#a1ccde",
  "#ced0d3",
  "#ccd2d6",
  "#d5dce0",
  "#dcdde0",
  "#b8dff0",
  "#e0e3e6",
  "#dde4e7",
  "#d6e5ec",
  "#d1e5ef",
  "#ebebee",
  "#374442",
  "#3e5b56",
  "#58716d",
  "#5da79c",
  "#7dbab0",
  "#adbab9",
  "#8dc4bc",
  "#bbc8c6",
  "#abd6cf",
  "#c9d4d3",
  "#bbe0da",
  "#888e87",
  "#979c95",
  "#a3a8a3",
  "#76c26f",
  "#b3b7b2",
  "#b3bcb1",
  "#b2c4ae",
  "#8dce86",
  "#bfc3bf",
  "#c0c8be",
  "#97d590",
  "#a2db9c",
  "#cdd4cc",
  "#ccd6c9",
  "#cbd9c7",
  "#b9e6b2",
  "#dbe0d9",
  "#d9e2d7",
  "#c4ebbd",
  "#d1eccb",
  "#e9ece6",
  "#e6ede3",
  "#dcf1d6",
  "#6b5073",
  "#7b5d84",
  "#8f6b99",
  "#8f7395",
  "#957d9a",
  "#a493a9",
  "#afa0b3",
  "#b8a3bc",
  "#c1aec5",
  "#c4b7c7",
  "#cbbace",
  "#d5c6d8",
  "#e4dee4",
  "#efeaee",
  "#4f4245",
  "#594d50",
  "#65585c",
  "#8d4a5f",
  "#716569",
  "#955569",
  "#7d7275",
  "#968c90",
  "#a39a9d",
  "#aea6a9",
  "#c7c2c4",
  "#ecdce0",
  "#f1dce2",
  "#f3e9eb",
  "#f5e8eb",
  "#49413f",
  "#54443f",
  "#7a5e54",
  "#856a61",
  "#9e654f",
  "#90766e",
  "#be7459",
  "#e48262",
  "#ed7c56",
  "#e4a38d",
  "#ebbaab",
  "#f0bbaa",
  "#f0c7ba",
  "#5a5545",
  "#666050",
  "#726c5d",
  "#9b8d59",
  "#969085",
  "#a69766",
  "#a29d92",
  "#ada073",
  "#b6a97f",
  "#b8a870",
  "#afaaa0",
  "#c1b27d",
  "#bfb38c",
  "#bcb7af",
  "#cbb97b",
  "#c8bc99",
  "#d8c15d",
  "#c9c5bd",
  "#d2c6a6",
  "#e2c84d",
  "#e8cf66",
  "#dacfb3",
  "#dfd0a1",
  "#d5d1ca",
  "#dad3c7",
  "#efd77f",
  "#f4de98",
  "#e6e0d4",
  "#f4e3b3",
  "#f1e5c5",
  "#f8e6af",
  "#fee88f",
  "#f0ebe6",
  "#f2ece1",
  "#faecc7",
  "#f5bfce",
  "#f8e8e3",
  "#f0eadf",
  "#f08b64",
  "#56c9bc",
  "#d76a8c",
  "#feeca8",
  "#f6efe2",
  "#99a8d6",
  "#1a97be",
  "#7e3e52",
  "#f4acbe",
  "#fcecb4",
  "#f9d9e1",
  "#e16836",
  "#0089b2",
  "#91ded5",
  "#bfebe5",
  "#704775",
  "#f5a381",
  "#fcefc1",
  "#f8dfd6",
  "#8797cc",
  "#aae5de",
  "#ef9caf",
  "#f7af90",
  "#e7e6ec",
  "#0078a0",
  "#61514a",
  "#b56742",
  "#dc652f",
  "#c6744d",
  "#c48368",
  "#a69089",
  "#d28969",
  "#cc9077",
  "#e88557",
  "#df8b67",
  "#b09d96",
  "#dc9d83",
  "#ed9972",
  "#d8a692",
  "#f0bfab",
  "#f7cab8",
  "#f4d4c8",
  "#f8ded4",
  "#f5e9e6",
  "#979178",
  "#a29d86",
  "#ada892",
  "#b9b49f",
  "#c4bfac",
  "#d1c585",
  "#d8cb91",
  "#cfcab9",
  "#dfd28d",
  "#dad5c6",
  "#e4d799",
  "#e3d8a8",
  "#e2dabd",
  "#e6dcb8",
  "#eadfb4",
  "#e5e0d3",
  "#f2e49b",
  "#e8e2cd",
  "#f1e4ab",
  "#ebe3c8",
  "#f1e7bd",
  "#f7eab2",
  "#f0ebe0",
  "#f4ecd5",
  "#f8edc3",
  "#7a8bc3",
  "#f9bda1",
  "#f4efe6",
  "#f6f1e9",
  "#f9f2d9",
  "#cc5978",
  "#ea8ca1",
  "#6f7eb9",
  "#aa3b5b",
  "#f2ea98",
  "#f7efb9",
  "#f7f0c2",
  "#f9f2d2",
  "#f8f2da",
  "#f2efe6",
  "#d6e5f0",
  "#606e77",
  "#5c7482",
  "#6c7a83",
  "#517f97",
  "#79868f",
  "#778b98",
  "#6f95aa",
  "#809baa",
  "#649dbc",
  "#939fa6",
  "#8caabd",
  "#a1acb2",
  "#9fafba",
  "#84b1cb",
  "#9cb1bf",
  "#99b6c7",
  "#afb9c0",
  "#a8c0d0",
  "#a2c5da",
  "#bcc8d1",
  "#b6cbd9",
  "#b4cdde",
  "#afcfe2",
  "#c2d8e6",
  "#bdd8e8",
  "#d2d8de",
  "#b9dbf2",
  "#c9dbe8",
  "#c2ddef",
  "#d6dee4",
  "#cbdfec",
  "#297e7c",
  "#4e9593",
  "#5ea19e",
  "#8a9c9b",
  "#97a7a7",
  "#aab7b7",
  "#708973",
  "#66946f",
  "#7d9681",
  "#75a07c",
  "#8ba38f",
  "#83ac8a",
  "#91b897",
  "#a8bdab",
  "#a0c4a6",
  "#bddbc2",
  "#cfe4d2",
  "#cce6d0",
  "#e5ede5",
  "#e0f0e1",
  "#716170",
  "#847083",
  "#8f7c8d",
  "#735156",
  "#af4a61",
  "#946069",
  "#b6566b",
  "#9d6b74",
  "#a6787f",
  "#cf637b",
  "#c86f81",
  "#d37084",
  "#b8858e",
  "#b79097",
  "#df94a1",
  "#d59fa8",
  "#c7a8ae",
  "#e0adb5",
  "#d1b6bb",
  "#d9c2c6",
  "#ecc4cb",
  "#daced0",
  "#e0d0d3",
  "#f5e8ea",
  "#6c4d3c",
  "#895e44",
  "#976a50",
  "#da6d2b",
  "#9b857b",
  "#c89273",
  "#deaa8d",
  "#f0ae8b",
  "#e3b69d",
  "#7c7852",
  "#86825d",
  "#918d69",
  "#a5a066",
  "#afa971",
  "#aba9a0",
  "#b9b7ae",
  "#bbb799",
  "#beb97a",
  "#bfbca8",
  "#c8c73a",
  "#c7c4bc",
  "#cec88f",
  "#d0ce51",
  "#cdc9b6",
  "#d1cdb2",
  "#dad664",
  "#d4d1ca",
  "#d9d5c3",
  "#dcd7be",
  "#dfd9a5",
  "#e3dd77",
  "#e6e180",
  "#e1ded7",
  "#e5e0d1",
  "#eae3aa",
  "#ebe589",
  "#e7e2ca",
  "#ede6a5",
  "#eae4c4",
  "#ede6be",
  "#efebe5",
  "#f0ecde",
  "#f2edd7",
  "#f4eec9",
  "#f6efb4",
  "#f6f2e2",
  "#dee1e5",
  "#a5d2ed",
  "#e26e84",
  "#604245",
  "#f9bfc7",
  "#f7f2d6",
  "#97caec",
  "#edebdd",
  "#f6acb6",
  "#fad0d5",
  "#f4914e",
  "#8cc5e9",
  "#8a6a55",
  "#a7846c",
  "#b8835c",
  "#c4875b",
  "#ca9067",
  "#d59466",
  "#af9f95",
  "#d09a75",
  "#e39867",
  "#d99e74",
  "#bcaca4",
  "#dea681",
  "#e3b08e",
  "#c7b8b2",
  "#f2ad80",
  "#f4b58e",
  "#efbb9c",
  "#f6bd9b",
  "#f3ceb7",
  "#f7ceb7",
  "#f7e1d3",
  "#f39da8",
  "#f2f0e8",
  "#fadadd",
  "#f1efe7",
  "#f79f5d",
  "#efede2",
  "#b43a51",
  "#f1919b",
  "#f3f1d8",
  "#bde6e7",
  "#533c3e",
  "#69b4e3",
  "#e7eab0",
  "#8ed6d9",
  "#1fa4ae",
  "#aae0e3",
  "#d4e086",
  "#dee498",
  "#51a7dd",
  "#c7dbed",
  "#ed818b",
  "#f18e2e",
  "#62628e",
  "#7370a3",
  "#7b78a3",
  "#807bab",
  "#9490ba",
  "#aaa6c9",
  "#b0adbf",
  "#b7b2d1",
  "#c3bed9",
  "#cac6d6",
  "#cdc9e0",
  "#d6d3e2",
  "#e1dee7",
  "#45515b",
  "#4c5d6b",
  "#647481",
  "#5c778d",
  "#698297",
  "#7d8a96",
  "#8c959c",
  "#8995a1",
  "#8399ab",
  "#769dbb",
  "#96a1ac",
  "#84a8c3",
  "#a5abb3",
  "#a2acb6",
  "#92b2cc",
  "#b1bac3",
  "#a0bdd5",
  "#b6c8d8",
  "#afc9df",
  "#cbd2d9",
  "#c7d2de",
  "#c2d3e3",
  "#d9dee4",
  "#d5dee8",
  "#d0deec",
  "#39676b",
  "#617576",
  "#537d80",
  "#6e8283",
  "#47878b",
  "#628a8c",
  "#5c8e91",
  "#1b9299",
  "#7c8e90",
  "#6b9a9c",
  "#649ea1",
  "#7aa6a9",
  "#70aeb2",
  "#5fb3b8",
  "#8cb3b6",
  "#84b6b9",
  "#71bec3",
  "#9bc0c2",
  "#8bc8cb",
  "#aacdcf",
  "#a5cfd1",
  "#a0d1d3",
  "#9cd4d7",
  "#b5dbdc",
  "#b0dddf",
  "#a6e0e3",
  "#cae3e5",
  "#dceeef",
  "#6dbd91",
  "#7dc69c",
  "#87d2a7",
  "#a3e1bd",
  "#b7e6c9",
  "#d8dfdb",
  "#cbe8d6",
  "#c8ead5",
  "#e6ebe7",
  "#d9f1e2",
  "#53454f",
  "#5e4958",
  "#685462",
  "#eadce6",
  "#f2e9ef",
  "#6f5153",
  "#8b4e52",
  "#9f5057",
  "#866063",
  "#a65b61",
  "#b5515d",
  "#906c6e",
  "#c75361",
  "#b4676e",
  "#ca606b",
  "#9a797b",
  "#c36a72",
  "#de6e79",
  "#d77780",
  "#ce8187",
  "#ad9293",
  "#e37983",
  "#b69d9e",
  "#e99197",
  "#eb9aa1",
  "#dca3a7",
  "#e4a5a9",
  "#c9b7b8",
  "#eeb2b6",
  "#d2c4c5",
  "#f0bdbf",
  "#f1c8cb",
  "#dcd0d1",
  "#eed2d4",
  "#f2d3d4",
  "#e7ddde",
  "#ab9484",
  "#b79274",
  "#dc8833",
  "#be9d82",
  "#bfaca0",
  "#eca96e",
  "#e4ad7e",
  "#c9b9ae",
  "#eeb17c",
  "#f1ba8b",
  "#f9b277",
  "#cec3bd",
  "#ebbd99",
  "#f3c299",
  "#dad0cc",
  "#f6d1b5",
  "#e5ddda",
  "#5c5f42",
  "#828562",
  "#8d8f6e",
  "#8f9658",
  "#a2a385",
  "#acae91",
  "#b1b683",
  "#b6b89d",
  "#b6c462",
  "#c2c3a9",
  "#c0c68d",
  "#c5c5bc",
  "#c8d27e",
  "#cdceb6",
  "#d0d4a1",
  "#d3d2ca",
  "#d9d8c2",
  "#e1e2b6",
  "#dde698",
  "#e0ded7",
  "#e3e1d2",
  "#e9eeb7",
  "#eeecdf",
  "#efeed3",
  "#f2d3e7",
  "#853d42",
  "#f8a245",
  "#218fcd",
  "#693c3d",
  "#a93b46",
  "#f8e2e3",
  "#fbc898",
  "#efeeeb",
  "#b7d1eb",
  "#e56971",
  "#f9eae0",
  "#d5d8d9",
  "#bfc3c6",
  "#a9aeb4",
  "#999fa4",
  "#838b92",
  "#6d737a",
  "#575c62",
  "#d3d5cf",
  "#c8cbc8",
  "#bbbcb8",
  "#a7aaa5",
  "#9b9f9a",
  "#919591",
  "#707573",
  "#e0dfdd",
  "#d2d1ce",
  "#c7c6c3",
  "#b9b9b7",
  "#9e9f9e",
  "#7b7a79",
  "#3c3d3d",
  "#dddddb",
  "#cdccca",
  "#a7a7a4",
  "#929290",
  "#80807f",
  "#6f6f6f",
  "#5e5e5d",
  "#d0cfcb",
  "#c3c4be",
  "#babab6",
  "#abaca7",
  "#969795",
  "#7b7c7b",
  "#575958",
  "#f2f0e9",
  "#bebbb1",
  "#afaba3",
  "#a19e98",
  "#94918a",
  "#7d7a75",
  "#dedcd3",
  "#c7c3b9",
  "#b2aea3",
  "#999488",
  "#8a8478",
  "#746e65",
  "#635f5a",
  "#425a65",
  "#657d85",
  "#71898d",
  "#a0aead",
  "#e8e5db",
  "#7c8783",
  "#cdd2c9",
  "#bfc8c3",
  "#48545d",
  "#5c707e",
  "#8398a4",
  "#c3d0d8",
  "#a3aeb4",
  "#b0bcc3",
  "#bdc1c1",
  "#69808b",
  "#bbc6d9",
  "#70777e",
  "#939da9",
  "#808ea1",
  "#667486",
  "#d4dae2",
  "#9daab9",
  "#d4dddd",
  "#cedde7",
  "#cfdce0",
  "#a2b2bd",
  "#a2b5ab",
  "#bcc8ba",
  "#c4d1c6",
  "#2a4b6e",
  "#d1cabe",
  "#c2baad",
  "#b0a99d",
  "#a1978b",
  "#8e8475",
  "#7c7366",
  "#63594b",
  "#f1f2ee",
  "#e3e4e2",
  "#d9dcdb",
  "#acadad",
  "#848585",
  "#5c5d5d",
  "#edebe7",
  "#e6e3df",
  "#d0ccc5",
  "#b9b4b1",
  "#918e8c",
  "#6f6a68",
  "#4b4441",
  "#e1dddb",
  "#d7d2d1",
  "#b8b4b6",
  "#a49f9f",
  "#908b8e",
  "#69656a",
  "#49454b",
  "#dcd8d7",
  "#d1cdca",
  "#c4bdba",
  "#b2aaaa",
  "#8b8283",
  "#645d5e",
  "#50484a",
  "#e5e1de",
  "#d2cfcc",
  "#c2bdba",
  "#b4ada9",
  "#8d847f",
  "#665d59",
  "#4f443f",
  "#b6b0a9",
  "#8b847c",
  "#7b736b",
  "#61584f",
  "#e7e6e0",
  "#cecac1",
  "#bcb7ad",
  "#97928b",
  "#5f5854",
  "#e5e0d2",
  "#cfc9bc",
  "#b2aca2",
  "#a1988b",
  "#8c8578",
  "#746f67",
  "#605c58",
  "#e1e1db",
  "#d1d3cf",
  "#c4c7c4",
  "#b7b9b5",
  "#8e908d",
  "#6a6b65",
  "#4e4f48",
  "#e8e9e4",
  "#d6d7d2",
  "#babdb8",
  "#a4a7a4",
  "#898a86",
  "#595a5c",
  "#e8eae6",
  "#d0d3d3",
  "#afb4b6",
  "#989fa3",
  "#6e7376",
  "#5b5e61",
  "#464544",
  "#e0e5e2",
  "#dce3e2",
  "#d2d9db",
  "#b8bfc2",
  "#8e9598",
  "#6f7678",
  "#434b4f",
  "#e5e7e6",
  "#d9dcdd",
  "#bec0c2",
  "#adb0b4",
  "#828388",
  "#585960",
  "#404149",
  "#eae9e7",
  "#e6e4e4",
  "#c0b2b1",
  "#9b8e8e",
  "#736665",
  "#554747",
  "#f1ece2",
  "#ece4dc",
  "#e6d7cc",
  "#ccb8b3",
  "#a49491",
  "#816f6b",
  "#5e4a47",
  "#ebded7",
  "#e6d5ce",
  "#dcc7c0",
  "#d2bbb2",
  "#b39b94",
  "#8e746c",
  "#664942",
  "#ecdfd8",
  "#d9cac3",
  "#c8bcb7",
  "#b7a9a2",
  "#8d7d77",
  "#796660",
  "#60504b",
  "#ddd5ce",
  "#d4cbc4",
  "#a99f97",
  "#a0928b",
  "#7f726b",
  "#5b4c44",
  "#eae1d6",
  "#d6cbbf",
  "#c6baaf",
  "#a99f96",
  "#91857c",
  "#80736a",
  "#635951",
  "#f1eee4",
  "#e2d8cb",
  "#cec1b5",
  "#a6978a",
  "#847567",
  "#63584c",
  "#e8e3db",
  "#cfc5b6",
  "#bdb0a0",
  "#a99a89",
  "#8c7b6c",
  "#5e5349",
  "#e5e0d5",
  "#cfc6bc",
  "#bdb6ae",
  "#a1968c",
  "#998e83",
  "#746a5e",
  "#5c5042",
  "#e7e3d6",
  "#d9d0c1",
  "#c9bfb2",
  "#9f9484",
  "#827566",
  "#594e40",
  "#e8e4d6",
  "#e1daca",
  "#d8cfbe",
  "#a79d8d",
  "#8a7d6b",
  "#5e5241",
  "#dbd7ce",
  "#d1ccc2",
  "#b1aa9c",
  "#8c8475",
  "#786d5e",
  "#615544",
  "#e1d8bb",
  "#d4c9a6",
  "#beb394",
  "#b2a484",
  "#a29371",
  "#8e8062",
  "#746a51",
  "#dedbcc",
  "#d0cbb6",
  "#beb9a2",
  "#afa78d",
  "#8f876b",
  "#796e54",
  "#5f563f",
  "#e5e7d5",
  "#d1d1bb",
  "#b7b8a5",
  "#a1a18f",
  "#817f6e",
  "#746f5c",
  "#5c5644",
  "#e6e5dc",
  "#dad8c9",
  "#cac8b6",
  "#aead96",
  "#8f8c79",
  "#747261",
  "#656457",
  "#d1d3c0",
  "#c3c7b2",
  "#b1b7a1",
  "#9ca389",
  "#8e9074",
  "#76745d",
  "#686858",
  "#ccccba",
  "#bec0b0",
  "#a6a897",
  "#939581",
  "#84846f",
  "#666556",
  "#5b5a4d",
  "#cdccbe",
  "#bdbbad",
  "#aeab9a",
  "#979381",
  "#84816f",
  "#706d5e",
  "#5e5b4d",
  "#dde2d7",
  "#d9dcd1",
  "#c3c7bd",
  "#89928a",
  "#646c64",
  "#474f43",
  "#e4ece9",
  "#dfebe9",
  "#d5e1e0",
  "#b5c8c9",
  "#8c9fa0",
  "#6b7f81",
  "#3b5257",
  "#cfdfdd",
  "#c6d6d7",
  "#a0b7ba",
  "#89a0a6",
  "#6a8389",
  "#5b6e74",
  "#445055",
  "#e0e4e2",
  "#c9d2d1",
  "#aab5b7",
  "#919fa1",
  "#7a8687",
  "#6e797b",
  "#575e5f",
  "#d5dcdc",
  "#c9d3d3",
  "#a5b2b7",
  "#8fa0a7",
  "#66787e",
  "#535e63",
  "#474c50",
  "#e3e9e8",
  "#dde4e3",
  "#adb6b9",
  "#858f94",
  "#5e686d",
  "#3b484f",
  "#cbd1d0",
  "#b9c0c0",
  "#a8b0b2",
  "#8f989d",
  "#7b8588",
  "#656e72",
  "#445056",
  "#cfd9de",
  "#c0ced6",
  "#b0bec5",
  "#a0aeb8",
  "#8d9ca7",
  "#657682",
  "#525e68",
  "#eaeeec",
  "#dfe6ea",
  "#d8dee3",
  "#bcc5cf",
  "#939fa9",
  "#6b7680",
  "#e4eaed",
  "#e1e6eb",
  "#d4dde2",
  "#abb5c4",
  "#818b9c",
  "#5b6676",
  "#404e61",
  "#e8e9e9",
  "#e1e1e2",
  "#dedfe2",
  "#b1b3be",
  "#8b8d98",
  "#656874",
  "#484b5a",
  "#f1ebea",
  "#eadde1",
  "#e1c8d1",
  "#d6b3c0",
  "#c28ba1",
  "#a5647e",
  "#83455d",
  "#f0eeeb",
  "#ede0e3",
  "#e3d0d5",
  "#ceaebb",
  "#b08693",
  "#986a79",
  "#6d4052",
  "#e9e1df",
  "#e9dbe0",
  "#d8c2ca",
  "#cab7c0",
  "#a38b93",
  "#846c76",
  "#5c4450",
  "#efe6e1",
  "#e5d7d4",
  "#d6c4c1",
  "#d0c1c3",
  "#ab9b9c",
  "#867578",
  "#5a484b",
  "#efeae7",
  "#efdddf",
  "#e2c9ce",
  "#d3b6ba",
  "#a9898d",
  "#8c6c6f",
  "#604046",
  "#f1eeeb",
  "#eedadd",
  "#d6b8bd",
  "#c7a1a9",
  "#aa7982",
  "#8e5b68",
  "#71424a",
  "#f2e7e7",
  "#eaced4",
  "#e1b9c2",
  "#d194a1",
  "#c07281",
  "#a9586c",
  "#953d55",
  "#f2ddd8",
  "#ecc9ca",
  "#e9b3b4",
  "#d99294",
  "#c27277",
  "#ac545e",
  "#903f45",
  "#efe0d7",
  "#f3e2dc",
  "#ddbdba",
  "#c39191",
  "#ad7171",
  "#92555b",
  "#813e45",
  "#f1ede5",
  "#ecd4d2",
  "#e3c7c6",
  "#d7b1b2",
  "#b58e8b",
  "#956a66",
  "#6c403e",
  "#f1e4dc",
  "#f0dcd7",
  "#e6cdca",
  "#d9bebc",
  "#b39997",
  "#8f716e",
  "#674848",
  "#f2ebe6",
  "#f3dbd9",
  "#dbb9b6",
  "#c79d9b",
  "#a97673",
  "#8e5959",
  "#774041",
  "#e8dad6",
  "#e3d2ce",
  "#d9bcb7",
  "#cda09a",
  "#b57770",
  "#9b5b55",
  "#86423e",
  "#eee3dd",
  "#ebd1cd",
  "#e6c1bb",
  "#ca7c74",
  "#b1635e",
  "#a0403e",
  "#f1e0db",
  "#ebcfc9",
  "#e7cac3",
  "#ddb1a8",
  "#c7887f",
  "#ab6057",
  "#9b423f",
  "#eeded8",
  "#e9d2cc",
  "#dac0ba",
  "#c8a6a1",
  "#ad7d76",
  "#7b453e",
  "#ebd9d0",
  "#e3d1cc",
  "#decac5",
  "#cdaea5",
  "#aa8880",
  "#8a5d55",
  "#744034",
  "#efe7df",
  "#eaddd7",
  "#e3cbc0",
  "#c4a295",
  "#b4897d",
  "#976c60",
  "#715145",
  "#efe3d9",
  "#ead6ce",
  "#e3cec6",
  "#d7b1a5",
  "#b98675",
  "#9c6757",
  "#864f3e",
  "#f4e5dd",
  "#f0ded3",
  "#f2d1c4",
  "#d1907c",
  "#9f543e",
  "#f2e4dd",
  "#f4ded9",
  "#f1d2c9",
  "#ecbcb2",
  "#dd9789",
  "#c67363",
  "#a4493d",
  "#f1e2de",
  "#edd8d2",
  "#e9cfc8",
  "#e2bcb3",
  "#c99387",
  "#91493e",
  "#f1e6e0",
  "#f1ddd8",
  "#f1d3ca",
  "#ab6f60",
  "#8c4f42",
  "#ecdbd2",
  "#e8d3c9",
  "#e8cac0",
  "#e0b4a4",
  "#b1715a",
  "#9e6654",
  "#8f4c3a",
  "#efe4da",
  "#ecdfd6",
  "#e3c9be",
  "#d9b19f",
  "#be8973",
  "#a8715a",
  "#915b41",
  "#efdbcd",
  "#ebccb9",
  "#e5bca5",
  "#d3a083",
  "#bc886a",
  "#9f6949",
  "#935f43",
  "#eedacb",
  "#edd5c7",
  "#e7c3ac",
  "#d8a686",
  "#c48d69",
  "#a66e49",
  "#966544",
  "#eadfd2",
  "#ead4c4",
  "#e2c7b6",
  "#dbbba7",
  "#ba947b",
  "#996e5a",
  "#805b48",
  "#f0e8e0",
  "#e9dad2",
  "#d5bfb4",
  "#c3a79a",
  "#a2806f",
  "#896757",
  "#6c483a",
  "#e8d9ce",
  "#e3d1c8",
  "#d0bbb0",
  "#a58f85",
  "#8a7265",
  "#63493e",
  "#eee6db",
  "#eae0d4",
  "#dacbbf",
  "#bda998",
  "#957d6f",
  "#6e564a",
  "#efebe3",
  "#eae3d8",
  "#dfd5c8",
  "#bdada4",
  "#968379",
  "#736157",
  "#604a3f",
  "#eae3db",
  "#e4ded5",
  "#d0c2b4",
  "#b09f8f",
  "#988171",
  "#7d685b",
  "#63554b",
  "#f0e1cf",
  "#ebdac8",
  "#c4ae96",
  "#b19c86",
  "#998069",
  "#816b56",
  "#6c5b4d",
  "#eee9dc",
  "#e8e1d5",
  "#e3ceb8",
  "#a98a6b",
  "#8d725a",
  "#76604e",
  "#ebe3d8",
  "#e8e0d8",
  "#dbc8b6",
  "#c3ac98",
  "#aa8f7a",
  "#8c6e54",
  "#74563d",
  "#eadac6",
  "#e6c8a9",
  "#d8b691",
  "#c9a480",
  "#ba8f68",
  "#a37d5a",
  "#8d6a4a",
  "#f1e6d6",
  "#e6d0b6",
  "#e1c6a8",
  "#d3b191",
  "#b98d68",
  "#9f7250",
  "#936647",
  "#eee2d5",
  "#ead9cb",
  "#e3d0bf",
  "#dfc0a6",
  "#c89b75",
  "#b27d50",
  "#97653c",
  "#f0e8dd",
  "#f2e8db",
  "#eed8c2",
  "#e7ceb5",
  "#d2ad87",
  "#b08a61",
  "#926b43",
  "#efe8dc",
  "#ece2d4",
  "#ddcfbc",
  "#cdb69b",
  "#b19576",
  "#967b5d",
  "#75583d",
  "#eae4d6",
  "#e4d9c5",
  "#dcccb4",
  "#c6b49c",
  "#ab9378",
  "#8f775d",
  "#7a634d",
  "#eeeadd",
  "#eae2d1",
  "#e1cfb2",
  "#d2bc9b",
  "#b89e78",
  "#a68966",
  "#967859",
  "#eee6db",
  "#efe5d9",
  "#ead8c1",
  "#e0ceb7",
  "#d1b088",
  "#ab8659",
  "#977043",
  "#f0e8d9",
  "#eedec7",
  "#ebd5b7",
  "#d8b98c",
  "#c9a375",
  "#ad8458",
  "#9b7448",
  "#f5e7d2",
  "#f6e6cb",
  "#efd7b3",
  "#e2c59c",
  "#c7a06c",
  "#bc9263",
  "#a17b4d",
  "#f4e7ce",
  "#ebd0a4",
  "#dbb881",
  "#d4ae76",
  "#c49e69",
  "#b28959",
  "#9c7647",
  "#f2ebd3",
  "#f1e9cf",
  "#f0ddb8",
  "#e2c392",
  "#d0ab70",
  "#b5905a",
  "#a67e4b",
  "#f2eede",
  "#f2ebd6",
  "#e7d2ad",
  "#d3b78b",
  "#c09c6a",
  "#af8a5b",
  "#97774d",
  "#f2edd7",
  "#cbb489",
  "#b19466",
  "#a48454",
  "#e6ddc6",
  "#e3d3b5",
  "#d9c3a1",
  "#d4bc94",
  "#b8996b",
  "#af9468",
  "#8b714b",
  "#f1e8d8",
  "#efe3d2",
  "#e5d3b9",
  "#d8c39f",
  "#c2a377",
  "#a78658",
  "#886a3f",
  "#ede7d2",
  "#ece3cc",
  "#dccaa8",
  "#ccb896",
  "#b3956c",
  "#a0855c",
  "#7f6640",
  "#e9e5d7",
  "#e4dfd1",
  "#dacfba",
  "#c9bba3",
  "#ac9a7e",
  "#8b795f",
  "#756244",
  "#efe9d9",
  "#e8ddc6",
  "#decfb3",
  "#cdba99",
  "#ad9773",
  "#937b56",
  "#715d3d",
  "#ebe5d2",
  "#e6e0cc",
  "#dbceac",
  "#d0bd94",
  "#af9a73",
  "#9c8866",
  "#877252",
  "#ecda9e",
  "#ead795",
  "#d8c475",
  "#ccbf88",
  "#b1a26a",
  "#9d8a50",
  "#8e824e",
  "#6e6a4c",
  "#dad7ad",
  "#c8cda0",
  "#e4eab7",
  "#b7ad6e",
  "#acb17e",
  "#949b64",
  "#848947",
  "#708054",
  "#9c9273",
  "#b0a584",
  "#c2b79a",
  "#adaa96",
  "#d6dbc0",
  "#808677",
  "#838463",
  "#d0c6a1",
  "#89876a",
  "#afa984",
  "#b3ae87",
  "#afa97d",
  "#9c9369",
  "#f2efe1",
  "#f2ecd9",
  "#dacba9",
  "#b8a47a",
  "#a8946b",
  "#9a845e",
  "#88724d",
  "#eae6d9",
  "#e5ddc8",
  "#cec1a5",
  "#ac9877",
  "#867354",
  "#695f4f",
  "#ebe8db",
  "#e3ddcc",
  "#c4baa1",
  "#b9ab8f",
  "#9f906e",
  "#847451",
  "#665c46",
  "#f0eada",
  "#e5dbc5",
  "#c5b28b",
  "#a58e61",
  "#917747",
  "#77623a",
  "#eee9d9",
  "#ebe5d0",
  "#e7dbbf",
  "#d2c098",
  "#ae996b",
  "#8d794f",
  "#82714d",
  "#f0e9d6",
  "#f0e9d1",
  "#e7d5ad",
  "#bb9f6a",
  "#a78a50",
  "#f5e9ca",
  "#f1d9a5",
  "#e5c382",
  "#e6c26f",
  "#d7ad62",
  "#c09856",
  "#b08843",
  "#f3eecd",
  "#f6eec0",
  "#ede1a8",
  "#ddc073",
  "#cba956",
  "#c39e44",
  "#f4f0d2",
  "#f5eec6",
  "#f0e4b2",
  "#e5d295",
  "#d1b871",
  "#bba262",
  "#ae9550",
  "#ede5bc",
  "#e8ddae",
  "#e2d39b",
  "#d7c275",
  "#c8b165",
  "#b59f55",
  "#a28b36",
  "#ede6b3",
  "#e4d89a",
  "#d2c880",
  "#c6bb68",
  "#a79954",
  "#9f9049",
  "#8c7f3c",
  "#e8e6d9",
  "#e3dec6",
  "#d0c6a1",
  "#bbac7d",
  "#9c8f60",
  "#887647",
  "#75693d",
  "#eae6d7",
  "#e0dbc7",
  "#d4cdb5",
  "#c6bb9c",
  "#b0a582",
  "#9e8f66",
  "#726647",
  "#dddbc5",
  "#d1ceb4",
  "#c5c1a3",
  "#9c946e",
  "#7a744d",
  "#5d583e",
  "#e8e7d7",
  "#dedbc4",
  "#d0cca9",
  "#bcb58a",
  "#a49d70",
  "#8d8752",
  "#797447",
  "#e8ecdb",
  "#e4e5d2",
  "#dbdcc4",
  "#c3c6a4",
  "#9c9f75",
  "#8c8e65",
  "#71714e",
  "#eaecd3",
  "#e0e3c8",
  "#e1e1be",
  "#bab078",
  "#a69a5c",
  "#8c8449",
  "#e9edc0",
  "#e3ebb1",
  "#d4e092",
  "#bacb7c",
  "#adb864",
  "#99a456",
  "#898c4a",
  "#e6e8c5",
  "#dadeb5",
  "#cdd3a3",
  "#bac08a",
  "#a0a667",
  "#888f4f",
  "#757d43",
  "#e9e9d0",
  "#e4e4c5",
  "#dcddb8",
  "#c8cc9e",
  "#b4b780",
  "#9ea26b",
  "#868b53",
  "#eaeede",
  "#e0ead7",
  "#d8e6cb",
  "#c6d4ac",
  "#afc195",
  "#91a673",
  "#6a7d4e",
  "#e3e8d9",
  "#dae1cf",
  "#d0dbc4",
  "#bbc6a4",
  "#9aa77c",
  "#7e8d60",
  "#5f6c3c",
  "#e8e8d7",
  "#dfe3d0",
  "#cfd2b5",
  "#b9bd97",
  "#9da073",
  "#7f8353",
  "#6d7244",
  "#ececdf",
  "#eaeadb",
  "#e0e1d1",
  "#cbccb5",
  "#a4a582",
  "#8b8c6b",
  "#6b6d4e",
  "#e1e5d7",
  "#d8dece",
  "#c7cfbe",
  "#b2b9a5",
  "#92987d",
  "#6d765b",
  "#576049",
  "#e1e1d5",
  "#c8cab5",
  "#acaf95",
  "#909373",
  "#6d6f4f",
  "#57593f",
  "#e9ebde",
  "#e5e6d7",
  "#ddddcc",
  "#bfc3ae",
  "#9da286",
  "#797e65",
  "#676c58",
  "#dde6d7",
  "#d8ddcc",
  "#ced3c1",
  "#abb39e",
  "#81876f",
  "#636653",
  "#5c5f4b",
  "#dadcd3",
  "#cfd2c7",
  "#c5cabe",
  "#bec4b7",
  "#939a89",
  "#737b6c",
  "#525746",
  "#dfe6da",
  "#cad5c8",
  "#cdd4c6",
  "#b4c0af",
  "#8e9b88",
  "#768371",
  "#50594f",
  "#e1e8db",
  "#dce5d8",
  "#d0ddcc",
  "#bad1b5",
  "#91af88",
  "#729067",
  "#4d663e",
  "#e3eee3",
  "#d2e6d3",
  "#c8dfc3",
  "#a2c7a3",
  "#89b386",
  "#658e64",
  "#53734c",
  "#dbe9df",
  "#c6decf",
  "#aad0ba",
  "#86bb9d",
  "#64a281",
  "#478865",
  "#236649",
  "#dde7df",
  "#c8dbce",
  "#bdd0c3",
  "#9db7a5",
  "#7a9682",
  "#56745f",
  "#3f5948",
  "#e6eae0",
  "#e2e8df",
  "#deeae0",
  "#b3c6b9",
  "#899a8b",
  "#6a7b6b",
  "#415241",
  "#e4e8e1",
  "#dee4dc",
  "#d7dfd6",
  "#b3c4ba",
  "#83988c",
  "#728478",
  "#54645c",
  "#e0e9e4",
  "#dee8e3",
  "#d5e3de",
  "#bacbc4",
  "#91a49d",
  "#71847d",
  "#4a5b51",
  "#ecf1ec",
  "#e6f0ea",
  "#dcece7",
  "#adc8c0",
  "#829f96",
  "#637d74",
  "#395648",
  "#d8e5dd",
  "#c4d7cf",
  "#afc7bf",
  "#8caea3",
  "#6d9185",
  "#477266",
  "#3c574e",
  "#d3e5db",
  "#bfd6c8",
  "#a2c2b0",
  "#80aa95",
  "#638f7b",
  "#3d6c54",
  "#305a4a",
  "#d7e7e0",
  "#bbdbd0",
  "#a1cdbf",
  "#7fb6a4",
  "#599c89",
  "#2b7b66",
  "#006a50",
  "#d8e7e1",
  "#c3dcd5",
  "#aed0c9",
  "#89bab2",
  "#609d91",
  "#45867c",
  "#116356",
  "#d6e7e3",
  "#cde2de",
  "#bcd7d4",
  "#9bc2bd",
  "#72a49f",
  "#4d8681",
  "#10605a",
  "#e1ebe5",
  "#c8d7d2",
  "#b7ccc7",
  "#94b1a9",
  "#75978f",
  "#4c726b",
  "#2e5a50",
  "#cbd9d7",
  "#becfcd",
  "#a2b7b5",
  "#7c9793",
  "#56736f",
  "#365955",
  "#e7eee8",
  "#dae6e3",
  "#d6e5e2",
  "#a8bbba",
  "#809391",
  "#576b6b",
  "#3c504f",
  "#dce6e3",
  "#d3e0de",
  "#c7dbd9",
  "#a0c0bf",
  "#6d9a9b",
  "#487a7b",
  "#155e60",
  "#dce6e5",
  "#cfe2e0",
  "#bcdbdb",
  "#8cc3c3",
  "#57a1a0",
  "#247e81",
  "#00686d",
  "#d4e3e2",
  "#d5e2e1",
  "#cadada",
  "#a1bdbf",
  "#7a999c",
  "#4b7378",
  "#2a545c",
  "#dbe4e5",
  "#cedee2",
  "#c2d3d6",
  "#96afb7",
  "#708e95",
  "#4a6871",
  "#2d5360",
  "#d3e4e6",
  "#cee0e3",
  "#b7d7de",
  "#8fbcc4",
  "#4e9aa8",
  "#1b7d8d",
  "#00697c",
  "#d9e4e5",
  "#cbdee2",
  "#b4d0d9",
  "#88b5c4",
  "#5e97a9",
  "#34788c",
  "#04627a",
  "#d9e3e5",
  "#d1dee4",
  "#a8c0ce",
  "#7f9daf",
  "#638496",
  "#365d73",
  "#2b526a",
  "#e8efec",
  "#e3ebea",
  "#d7e0e2",
  "#adbfc8",
  "#7b8f99",
  "#526771",
  "#334b58",
  "#ecf0eb",
  "#d4e2e6",
  "#cddce3",
  "#adc6d3",
  "#819daa",
  "#5d7b89",
  "#2d5367",
  "#e1eaec",
  "#dfebee",
  "#bccedb",
  "#8ea7b9",
  "#607b8e",
  "#2e5169",
  "#dee6e7",
  "#cad7de",
  "#a2bacb",
  "#7595ab",
  "#53778f",
  "#2d5975",
  "#2c4d69",
  "#d7e2e5",
  "#c5d9e3",
  "#abc8d8",
  "#82acc4",
  "#5692b2",
  "#347699",
  "#005e88",
  "#d8e4e8",
  "#c3d9e4",
  "#a4c3d7",
  "#78a7c3",
  "#528bab",
  "#296d93",
  "#185887",
  "#dfe7e8",
  "#c4d3dc",
  "#a3bbcd",
  "#789bb6",
  "#507b9a",
  "#1d5c83",
  "#2b4d68",
  "#dae1e3",
  "#c1ceda",
  "#abbed0",
  "#8da8be",
  "#5a809e",
  "#3a5f7d",
  "#dae3e7",
  "#bed1e1",
  "#a1bed9",
  "#729cc2",
  "#4f84af",
  "#286492",
  "#234e86",
  "#d7e0e7",
  "#c7d3e0",
  "#adc0d6",
  "#7e9ec2",
  "#5d84b1",
  "#326395",
  "#314a76",
  "#dde4e8",
  "#c7d1db",
  "#b6c3d1",
  "#9eafc2",
  "#6c8096",
  "#4c6177",
  "#314d67",
  "#e8ecee",
  "#dae4ee",
  "#d6dfe7",
  "#aebbd0",
  "#8290a6",
  "#627188",
  "#384a66",
  "#dfe2e5",
  "#d0d7df",
  "#bfc7d4",
  "#a4b0c4",
  "#7b8ca8",
  "#556682",
  "#3a405a",
  "#dde2e6",
  "#99aac8",
  "#6d86b6",
  "#4f6997",
  "#374874",
  "#e3e5e8",
  "#dcdfe5",
  "#cbd0dd",
  "#a7b0cc",
  "#818db3",
  "#627099",
  "#465383",
  "#e6e6e7",
  "#dadbdf",
  "#c7ccd8",
  "#a4abbf",
  "#838ba4",
  "#606a88",
  "#3d496d",
  "#e3e4e5",
  "#dbdce2",
  "#d1d2dc",
  "#afb2c4",
  "#898ca3",
  "#6b6d85",
  "#464b6a",
  "#e2e3eb",
  "#dde0ea",
  "#d1d3e0",
  "#b1b3cb",
  "#8e90b4",
  "#686b93",
  "#4d517f",
  "#e5e7e8",
  "#e4e6ea",
  "#dadee6",
  "#b8b9cb",
  "#9090a2",
  "#6e6f82",
  "#464960",
  "#eeedea",
  "#eae8ec",
  "#d4cfd6",
  "#b9b3bf",
  "#928a98",
  "#6a6472",
  "#4a4354",
  "#dfdee5",
  "#e0dee3",
  "#d3d1dc",
  "#bebbc9",
  "#9b95a9",
  "#78738b",
  "#544f66",
  "#e4e1e4",
  "#dad6df",
  "#cdc8d2",
  "#b9b3c2",
  "#9b8fa6",
  "#736a86",
  "#4e4260",
  "#dedbe5",
  "#d3d0dd",
  "#beb8cd",
  "#988eb4",
  "#736993",
  "#534a77",
  "#e6dee6",
  "#e5dde7",
  "#d6cbda",
  "#c2b1c8",
  "#a387ac",
  "#886793",
  "#694878",
  "#e7e3e7",
  "#e0d8df",
  "#d6c7d6",
  "#c2aec3",
  "#a489a3",
  "#7e667f",
  "#5f4561",
  "#e7dfe3",
  "#e5d8e1",
  "#dccad8",
  "#cfb7c9",
  "#af8ea5",
  "#87657e",
  "#654161",
  "#e7e1e3",
  "#e1d9dc",
  "#dbccd3",
  "#ceb9c4",
  "#b495a4",
  "#8e6278",
  "#603e53",
  "#e5dae1",
  "#e6d9e2",
  "#e5cfde",
  "#d8b7cf",
  "#bf91b2",
  "#a16c94",
  "#7f4774",
  "#f3dfe3",
  "#f3d8e0",
  "#f4c8d5",
  "#efa7bf",
  "#e585a5",
  "#da6d91",
  "#c6577c",
  "#efe1e4",
  "#f0d6dd",
  "#eec8d3",
  "#e3a4b8",
  "#d6859f",
  "#c66787",
  "#ab446b",
  "#f0dee0",
  "#f1d3d9",
  "#ecbfc9",
  "#e69dad",
  "#d1768c",
  "#c7607b",
  "#ac3e5f",
  "#f4e4e5",
  "#f5cdd2",
  "#f5b3bc",
  "#f392a0",
  "#e26b81",
  "#d45871",
  "#ca4b65",
  "#f4dbd9",
  "#f7cccd",
  "#f6b5b6",
  "#f3949b",
  "#e66a77",
  "#da5265",
  "#c53a4b",
  "#f2dbdb",
  "#f3cacb",
  "#f1b3b6",
  "#e68e96",
  "#d16d76",
  "#bb4f5c",
  "#a83e4c",
  "#f3d9d6",
  "#f3d2cf",
  "#f2c1c0",
  "#ec9b9d",
  "#d87678",
  "#c3585c",
  "#ac3a3e",
  "#f4e4e0",
  "#f6d8d7",
  "#f7c2bf",
  "#f6a09d",
  "#ec7878",
  "#e15f65",
  "#c6494c",
  "#f5e2de",
  "#f6dbd3",
  "#f7cac1",
  "#f7b1a6",
  "#ee867d",
  "#d1584c",
  "#b44940",
  "#f3e0db",
  "#f2dbd6",
  "#f3c8c2",
  "#eaaaa2",
  "#db8079",
  "#c26157",
  "#aa423a",
  "#f3ece7",
  "#f2e3dc",
  "#efc4bb",
  "#e5a090",
  "#d78775",
  "#c3705f",
  "#af5941",
  "#f3e5dc",
  "#f3e0d8",
  "#f0d1c8",
  "#efc1b5",
  "#e49c86",
  "#d88167",
  "#bf5b3c",
  "#f3e9e0",
  "#f6e2d8",
  "#f7dfd7",
  "#f5c8bb",
  "#f9a48e",
  "#df745b",
  "#c9543a",
  "#f4e8e1",
  "#f5e5dc",
  "#f4ded3",
  "#f0b9a9",
  "#ea9073",
  "#e07757",
  "#bc5339",
  "#f2ebe1",
  "#f4e2d4",
  "#f1d4c4",
  "#f0b599",
  "#f2a37d",
  "#e88a5b",
  "#d86f3c",
  "#f3ddcd",
  "#f4d9c8",
  "#f5d5c2",
  "#f5be9d",
  "#f7a270",
  "#f09056",
  "#e68750",
  "#f2e9de",
  "#f2e1d2",
  "#f6d8be",
  "#f7c5a0",
  "#faac72",
  "#f69a54",
  "#ef924a",
  "#f4decb",
  "#f3d4bf",
  "#f2c6a7",
  "#edaa80",
  "#dc8c59",
  "#ce7639",
  "#c26a35",
  "#f4e2d6",
  "#f3dfd4",
  "#edc7b6",
  "#e4b095",
  "#cf8d6c",
  "#c37c59",
  "#ac5e3a",
  "#f9e4ae",
  "#f0ddbb",
  "#e7c26f",
  "#d4b57f",
  "#f5e4bf",
  "#e2c28d",
  "#efd7ab",
  "#e6b570",
  "#f1e7ce",
  "#f0debb",
  "#e5ca9e",
  "#dcc49b",
  "#e8dbc4",
  "#e1cca6",
  "#c2ae88",
  "#efd7a7",
  "#e0c796",
  "#c1a87c",
  "#ccb88d",
  "#e1cfa5",
  "#cfb989",
  "#ab8f55",
  "#f4e4c6",
  "#e1d0b2",
  "#f0e5c7",
  "#e7d9b9",
  "#e2d0ad",
  "#ceba97",
  "#dfcca6",
  "#e8d7b8",
  "#f3e4d5",
  "#f4d9c5",
  "#f0c3a7",
  "#e6a57f",
  "#cf875e",
  "#c17444",
  "#b66a3c",
  "#f1e4d7",
  "#efdcca",
  "#efcdb4",
  "#e8b793",
  "#d59466",
  "#cc8149",
  "#bc6f37",
  "#f1e9dd",
  "#f3e3d1",
  "#f3dcc6",
  "#eec9aa",
  "#e2ac78",
  "#d09258",
  "#c27f38",
  "#f3ecdc",
  "#f5e9d5",
  "#f4debf",
  "#f9d09f",
  "#fbc17b",
  "#f2ad62",
  "#ed9b44",
  "#f4eedc",
  "#f3ead2",
  "#f9e7bf",
  "#fbdca8",
  "#f9c982",
  "#f7c070",
  "#f7b74e",
  "#f4f0de",
  "#f5efd6",
  "#f8e9c2",
  "#fcdfa4",
  "#fdd792",
  "#ffc863",
  "#ffbc35",
  "#f4f0da",
  "#f6eecd",
  "#f7ecca",
  "#fbe4af",
  "#ffd978",
  "#ffd15c",
  "#ffc632",
  "#f1ede0",
  "#f4e8d1",
  "#f3e2c6",
  "#efcea0",
  "#e1b270",
  "#cc974d",
  "#b98033",
  "#f1eee2",
  "#f3e9cf",
  "#f3dfb6",
  "#ecc481",
  "#dfac59",
  "#ce9844",
  "#bb852f",
  "#f3edd9",
  "#f4e5c5",
  "#f5deae",
  "#f3c775",
  "#edb856",
  "#e1a84b",
  "#c89134",
  "#f4ebd0",
  "#f6e5b9",
  "#f6e0a9",
  "#f6d48d",
  "#ecbe63",
  "#e3b34c",
  "#d6a332",
  "#f3f0d6",
  "#f3efcd",
  "#f9ecb6",
  "#fce79a",
  "#f9d97b",
  "#fbd05c",
  "#ffc943",
  "#f1f0d6",
  "#f4efc3",
  "#f5edb2",
  "#f6eba1",
  "#fdea83",
  "#ffdf38",
  "#ffd637",
  "#f0f0e0",
  "#f2efcd",
  "#f4eeba",
  "#f5edae",
  "#f8eb97",
  "#f6db5d",
  "#efcc44",
  "#f0eddb",
  "#f0ead2",
  "#f7eab9",
  "#f3e4a7",
  "#f6d76e",
  "#e4c14d",
  "#d8ad39",
  "#f1f1e6",
  "#f0edd1",
  "#f0e7a9",
  "#efde75",
  "#e2c74f",
  "#ceb02a",
  "#b8a02a",
  "#eef0d6",
  "#eaefce",
  "#e9edbd",
  "#ebeca7",
  "#ece678",
  "#e6d943",
  "#d9c737",
  "#eff0d3",
  "#eaecb9",
  "#e4e8a7",
  "#d9e6a6",
  "#cfdb8d",
  "#cdd47f",
  "#c9cc4a",
  "#edeec5",
  "#edebb4",
  "#e1dd8e",
  "#d5ce69",
  "#beb755",
  "#a6a23f",
  "#9b983d",
  "#ebf0d6",
  "#e3ebae",
  "#d9e49e",
  "#ccd87a",
  "#bece61",
  "#afbb42",
  "#9aa22b",
  "#ecf0da",
  "#edefcb",
  "#e5ecb7",
  "#deeaaa",
  "#d0e798",
  "#bed565",
  "#a8c74d",
  "#ecf1e2",
  "#ddedbd",
  "#d5ebac",
  "#c1e089",
  "#a5cb66",
  "#98bd3c",
  "#e6ecd6",
  "#e6eccc",
  "#dbe5b9",
  "#cedda2",
  "#aec571",
  "#96af54",
  "#7a973b",
  "#e3ede0",
  "#deead8",
  "#d2e3cc",
  "#bad7ae",
  "#96bf83",
  "#76a55b",
  "#588c3a",
  "#ecf0e5",
  "#e8f0e2",
  "#e4efde",
  "#d7eccd",
  "#bfe5b1",
  "#9ed686",
  "#79be58",
  "#e3efe1",
  "#dceedb",
  "#cdeacd",
  "#bee5be",
  "#92d599",
  "#6bc271",
  "#41a94f",
  "#dae9dc",
  "#d1e6d5",
  "#b9dcc3",
  "#9acda9",
  "#68b082",
  "#529d6e",
  "#027944",
  "#dbeee0",
  "#c4ead5",
  "#a7e0c2",
  "#79d0a7",
  "#47ba87",
  "#31aa74",
  "#00955e",
  "#ddeee2",
  "#c1e5d5",
  "#a2d4bd",
  "#80c4a9",
  "#52a786",
  "#29906d",
  "#007958",
  "#d4ede3",
  "#bde8d8",
  "#98ddc5",
  "#5ecaae",
  "#1db394",
  "#00a483",
  "#008b6d",
  "#d9eae5",
  "#bde1d8",
  "#a5d8cd",
  "#46a795",
  "#007e6b",
  "#e2ebe5",
  "#c5e5e2",
  "#b5deda",
  "#8fcdc7",
  "#5eb2aa",
  "#2b9890",
  "#007c75",
  "#e1ede6",
  "#d4ede6",
  "#abe3de",
  "#80d7cf",
  "#41bfb5",
  "#00a49b",
  "#00938b",
  "#deeeed",
  "#d2ebea",
  "#c3e7e8",
  "#b5e4e4",
  "#70cbce",
  "#3fbabd",
  "#009a9e",
  "#e5f1ee",
  "#d3e7e5",
  "#bfdfdf",
  "#8ecfd0",
  "#4fb3b3",
  "#1a9597",
  "#00787f",
  "#e8efec",
  "#c4dde2",
  "#94c8d2",
  "#55a7b6",
  "#1e8ea1",
  "#007a91",
  "#deeced",
  "#d3e9ec",
  "#c6e4eb",
  "#9cd4e1",
  "#59b9cc",
  "#26a5ba",
  "#0090a8",
  "#e3eded",
  "#cfe4ee",
  "#aed7ea",
  "#80c1e2",
  "#48a8d0",
  "#1993be",
  "#007dac",
  "#dae6e9",
  "#d0e1e8",
  "#add0e0",
  "#7eb6d0",
  "#5397b7",
  "#2282a8",
  "#006a93",
  "#d6e1e4",
  "#ccdfe8",
  "#9fc9e4",
  "#66a9d3",
  "#3e8fbc",
  "#1d78ab",
  "#00619d",
  "#d3e5eb",
  "#cbe3ee",
  "#a3d1eb",
  "#6ab4e0",
  "#3398ce",
  "#1c8ac9",
  "#0072b5",
  "#d9e6ee",
  "#c8ddee",
  "#9bc7ea",
  "#62a5df",
  "#3d8ed0",
  "#1e80c7",
  "#0264ae",
  "#dae3e9",
  "#c2d7e9",
  "#97bee2",
  "#73a3d0",
  "#3c85be",
  "#1c70ad",
  "#1a5897",
  "#e0e8ec",
  "#d3e0ec",
  "#abcaea",
  "#7daee1",
  "#518fd1",
  "#3c7ac2",
  "#2863ad",
  "#dfe6ea",
  "#d0dce8",
  "#a3bcdb",
  "#7ea3d2",
  "#5488c0",
  "#356fad",
  "#1c5798",
  "#dde0e8",
  "#dadee9",
  "#cbd1e1",
  "#abb6d7",
  "#8394c5",
  "#6274ab",
  "#445397",
  "#dee2ec",
  "#d7ddec",
  "#c9d1e9",
  "#adbae3",
  "#8596d2",
  "#7487c6",
  "#5868ae",
  "#e8e6e8",
  "#e4e1ea",
  "#dbd7e4",
  "#c6bedd",
  "#a598c7",
  "#8278ad",
  "#5a4e88",
  "#edecec",
  "#e8e5ec",
  "#e3dfec",
  "#d0c8e6",
  "#ada2ce",
  "#9488be",
  "#76679e",
  "#e9e1e8",
  "#e3d7e5",
  "#dccae0",
  "#c9afd0",
  "#a885b5",
  "#9569a3",
  "#795088",
  "#ebdfea",
  "#e8deea",
  "#dfcae4",
  "#cfb1d8",
  "#b48ac2",
  "#a475b1",
  "#835995",
  "#ebe2e8",
  "#eae0e8",
  "#e8d2e3",
  "#e1bed9",
  "#cc94be",
  "#ad6ea0",
  "#905284",
  "#ede5e8",
  "#eee1eb",
  "#e7c2de",
  "#dba3ce",
  "#c37cb3",
  "#9d5a8f",
  "#91575d",
  "#824e4a",
  "#723f45",
  "#89585d",
  "#72494a",
  "#604344",
  "#6b4d5f",
  "#a34747",
  "#964647",
  "#943e4d",
  "#8f4347",
  "#9c4d52",
  "#a54f5d",
  "#a34a3e",
  "#9d3e3f",
  "#595461",
  "#605258",
  "#7c6b76",
  "#705c79",
  "#a0a0aa",
  "#817c85",
  "#295266",
  "#1c6b75",
  "#455c59",
  "#3a5a55",
  "#4f6450",
  "#4c6b4e",
  "#b4aaa0",
  "#9c8f83",
  "#e0ded8",
  "#bab2ab",
  "#3d4645",
  "#948e82",
  "#e0dbcd",
  "#c0af92",
  "#d9cdb5",
  "#d5d3c3",
  "#eeeada",
  "#a0917e",
  "#c7b8a4",
  "#eae3d6",
  "#efece2",
  "#d7c8b1",
  "#d3bc9e",
  "#e4d5bc",
  "#efe9da",
  "#dfd4c4",
  "#eee8d9",
  "#e9e6dd",
  "#d3d1be",
  "#c8c0aa",
  "#b8ae98",
  "#aaa492",
  "#dad1c6",
  "#e5e1d8",
  "#cec7b8",
  "#bb9b7d",
  "#996f45",
  "#ae8661",
  "#c7a98d",
  "#efebde",
  "#f5f0e2",
  "#e5caa2",
  "#cca571",
  "#baa589",
  "#ae9676",
  "#c8ac89",
  "#c4ad92",
  "#6f5746",
  "#98754e",
  "#6d6053",
  "#a39281",
  "#887b6e",
  "#766859",
  "#625141",
  "#624e45",
  "#544642",
  "#c8bcab",
  "#e5dac8",
  "#cbc1b4",
  "#b7a696",
  "#9d8c7c",
  "#c6b092",
  "#8b7867",
  "#d1ac99",
  "#c79c7c",
  "#c58f68",
  "#b78565",
  "#b88a74",
  "#a27253",
  "#9d6f59",
  "#784c42",
  "#f1e2c6",
  "#d9bc86",
  "#e2b46c",
  "#cd9647",
  "#ac854e",
  "#cc9859",
  "#ac7b44",
  "#a9805d",
  "#bc946d",
  "#cda885",
  "#c68b5a",
  "#ae703b",
  "#b07447",
  "#a76c40",
  "#835842",
  "#574642",
  "#e8cbb4",
  "#c18978",
  "#b7735e",
  "#9a5247",
  "#9b6046",
  "#a15c49",
  "#89483e",
  "#96addc",
  "#5072b1",
  "#314a76",
  "#7e84b5",
  "#816d95",
  "#b08aae",
  "#c86e94",
  "#c25a88",
  "#a54976",
  "#a24041",
  "#d9624e",
  "#fcd766",
  "#f1c96a",
  "#ebb454",
  "#dfb170",
  "#fdae6f",
  "#ef913e",
  "#d07d4d",
  "#d67953",
  "#d5d16b",
  "#aaac32",
  "#b6c876",
  "#729167",
  "#97d4c0",
  "#bce7d1",
  "#86c7bf",
  "#00908d",
  "#f2f0e6",
  "#d8cdc4",
  "#cab8ab",
  "#c3b8b7",
  "#bb9e9b",
  "#c49b9e",
  "#af8f9e",
  "#a18a8d",
  "#ece9dd",
  "#f2e9dc",
  "#f3eae3",
  "#f4e4d9",
  "#eedbce",
  "#dfc4b9",
  "#e3b8a9",
  "#c59687",
  "#ece2e3",
  "#ead7d9",
  "#dab7bb",
  "#b68190",
  "#a37379",
  "#a0666b",
  "#9c6071",
  "#7c3f55",
  "#f4e5d2",
  "#e5ccbd",
  "#e7c3ab",
  "#e3beb0",
  "#c67976",
  "#be727c",
  "#b2656c",
  "#ab5959",
  "#dcded4",
  "#876b61",
  "#dbded9",
  "#bfc4cc",
  "#5f696d",
  "#8c8071",
  "#6f6558",
  "#e8e4d9",
  "#78757c",
  "#47464a",
  "#7f9469",
  "#d6eae2",
  "#9daea5",
  "#a77f4f",
  "#454446",
  "#745e4c",
  "#bab2a9",
  "#cdcac0",
  "#ecddca",
  "#658289",
  "#43474a",
  "#c3d7d1",
  "#1f615b",
  "#8faeab",
  "#3a5d48",
  "#63554a",
  "#dacfb9",
  "#dbe5df",
  "#a8aeaf",
  "#a18569",
  "#af8a70",
  "#c4c8c7",
  "#d9d5d8",
  "#6a6d6f",
  "#637381",
  "#735245",
  "#c8d0cf",
  "#c7b3a3",
  "#7a5c4e",
  "#e1e5df",
  "#5f6a6e",
  "#9ca2b2",
  "#82b1b3",
  "#f1dfc7",
  "#abcad6",
  "#007783",
  "#dbc8a8",
  "#9e5f56",
  "#747f56",
  "#7d8991",
  "#4a7e83",
  "#697a5a",
  "#bdc8cd",
  "#beb09f",
  "#96abb0",
  "#536a71",
  "#6398a6",
  "#625557",
  "#d7c4b1",
  "#62524b",
  "#697178",
  "#bea58e",
  "#ccb8a9",
  "#b9c2c3",
  "#b0a9a7",
  "#137fa6",
  "#c7b098",
  "#584b4a",
  "#545552",
  "#54595d",
  "#514745",
  "#5b5256",
  "#404547",
  "#3d3e3e",
  "#dac7b6",
  "#f5dfcb",
  "#a2d5e5",
  "#d8e1d7",
  "#c9d4d9",
  "#bfe7dd",
  "#3e7da3",
  "#00918b",
  "#006985",
  "#4e778e",
  "#d2e8dd",
  "#5db7ca",
  "#96b3c1",
  "#007b86",
  "#a6adb0",
  "#6f8fa7",
  "#3f4d58",
  "#84b0bb",
  "#60676d",
  "#838a8f",
  "#677772",
  "#cfd9db",
  "#dfe5e2",
  "#a4d7e4",
  "#c7e6e6",
  "#c4dade",
  "#d7c4be",
  "#91d1dc",
  "#708ea8",
  "#4f6352",
  "#cccdb9",
  "#9d7469",
  "#356179",
  "#9aacb7",
  "#d8c7b9",
  "#6b7063",
  "#81704d",
  "#adccd1",
  "#5f5a55",
  "#8b6057",
  "#dac9b0",
  "#885149",
  "#7e6f5d",
  "#d7c6af",
  "#98806a",
  "#6e5344",
  "#8f7257",
  "#f1e0ca",
  "#b1d8e3",
  "#bfb9a6",
  "#a19a8b",
  "#d7e4d9",
  "#e1c18d",
  "#f1e4cf",
  "#95856f",
  "#92857b",
  "#dacfb8",
  "#89b0c3",
  "#ba8f69",
  "#4fc0af",
  "#bbc6cf",
  "#a59e84",
  "#4f4d52",
  "#c4ab87",
  "#abb3b6",
  "#98765c",
  "#95b19e",
  "#e0e9d4",
  "#7a8e9c",
  "#338592",
  "#e8e2ca",
  "#ebdcc6",
  "#88b7bf",
  "#ad8548",
  "#cba361",
  "#beb8b6",
  "#8d8979",
  "#dfe3cd",
  "#d9cdc1",
  "#4d4b50",
  "#687365",
  "#8c8270",
  "#8c7e7a",
  "#158a8f",
  "#8b8075",
  "#e5caad",
  "#63979b",
  "#755e49",
  "#57a9b3",
  "#aba69d",
  "#656269",
  "#916947",
  "#c3a598",
  "#a8bbbf",
  "#e3ddcd",
  "#e8d4ad",
  "#d0c191",
  "#c4b088",
  "#f1d4ae",
  "#edebe0",
  "#b4cdc8",
  "#bae1e5",
  "#e9dac0",
  "#d5a05d",
  "#cbc9ca",
  "#8c8476",
  "#d6ede8",
  "#cfcacc",
  "#6f92a5",
  "#bdbeb0",
  "#c4b3ad",
  "#836a64",
  "#e3cfa5",
  "#ecd1a6",
  "#d2d7d5",
  "#cc9451",
  "#bdc1c2",
  "#f3e5c9",
  "#dfb495",
  "#c1b093",
  "#ada296",
  "#a28058",
  "#d6e5e4",
  "#598a85",
  "#bdb8b8",
  "#afa8ad",
  "#ebcfba",
  "#90a9ba",
  "#b5b8ab",
  "#e0dcd9",
  "#7d6366",
  "#dfdfcc",
  "#714d47",
  "#686c48",
  "#8e7e81",
  "#e2c294",
  "#e9cfbd",
  "#917b48",
  "#c1bca7",
  "#d1bb97",
  "#978269",
  "#d6cec3",
  "#8dac84",
  "#646f4d",
  "#6a8773",
  "#335851",
  "#68737b",
  "#c7c2ca",
  "#eaccb4",
  "#e6e0d6",
  "#58738a",
  "#e7c79c",
  "#a8a89d",
  "#888785",
  "#a3a997",
  "#579aa3",
  "#dfd3ae",
  "#d3e1c7",
  "#dee8d3",
  "#b5d6bd",
  "#ddbd93",
  "#b9cddb",
  "#756d6a",
  "#eeddcf",
  "#b5e0e5",
  "#9bb295",
  "#b5cbd6",
  "#cfdde4",
  "#555f54",
  "#d7e9e3",
  "#92867f",
  "#7b7069",
  "#5e604b",
  "#7e706a",
  "#655a4e",
  "#f1d2b0",
  "#678561",
  "#dae7e2",
  "#a8beb2",
  "#8e6c5d",
  "#645647",
  "#5f785a",
  "#ebded2",
  "#e7dad0",
  "#b2b5ae",
  "#816554",
  "#c58c56",
  "#b79d5f",
  "#d3b187",
  "#bd8546",
  "#dcae6e",
  "#bf9759",
  "#d0ba85",
  "#c29a68",
  "#c0935c",
  "#e6ceac",
  "#e2e3dd",
  "#ccc7c5",
  "#a7a4a8",
  "#b4b2b5",
  "#e9d3d0",
  "#838277",
  "#c1b8ab",
  "#ede6d6",
  "#15715a",
  "#c0cdc3",
  "#96b6a7",
  "#476d50",
  "#acc3a9",
  "#d8e1ca",
  "#baa86d",
  "#d4c7ba",
  "#c2b4ab",
  "#006676",
  "#dbded9",
  "#dfd8cd",
  "#cec6bd",
  "#cfcac5",
  "#e2e6d5",
  "#67656a",
  "#aabdbd",
  "#ccbda2",
  "#cbb786",
  "#ad9775",
  "#a07b48",
  "#e0dcd5",
  "#817f82",
  "#a1d4c8",
  "#ca9c62",
  "#e7d9d6",
  "#8a755d",
  "#ceb5a2",
  "#918959",
  "#dfcabd",
  "#d2c6bd",
  "#b0875b",
  "#cbd1c6",
  "#b78247",
  "#2c5469",
  "#474c49",
  "#89807c",
  "#b9cedc",
  "#c7b5aa",
  "#405d53",
  "#3d4b50",
  "#9caeb0",
  "#a7d4db",
  "#71849a",
  "#d7c9c0",
  "#a1b0c7",
  "#82856b",
  "#d9d9db",
  "#5aa691",
  "#416f6c",
  "#424446",
  "#acbbb3",
  "#5b715e",
  "#80928c",
  "#adb68a",
  "#b0a898",
  "#a2d4ca",
  "#41a5b6",
  "#20879a",
  "#347b89",
  "#5b8da2",
  "#637677",
  "#3e5875",
  "#e2ded9",
  "#bbc0b5",
  "#515047",
  "#ece5e3",
  "#f3e2c7",
  "#aecbbd",
  "#dee6d8",
  "#adb3a7",
  "#b3c8cf",
  "#dadad8",
  "#a5aaa1",
  "#e3dbd3",
  "#d1c7c5",
  "#937a7c",
  "#e0d9d2",
  "#eac28e",
  "#796a6b",
  "#e6dbd2",
  "#c0a98d",
  "#cfcdbe",
  "#d9ced1",
  "#ede0da",
  "#49acb0",
  "#d4dcd3",
  "#70c0c2",
  "#9f955f",
  "#325b7d",
  "#e3dfd0",
  "#6c5d57",
  "#dfe4d3",
  "#cae0c7",
  "#cdc5b9",
  "#acc4b5",
  "#625a4e",
  "#b6bab5",
  "#e8cbb0",
  "#cce2d0",
  "#dfe7df",
  "#85a59a",
  "#dfbebd",
  "#56555f",
  "#d1b8a9",
  "#bbcbcc",
  "#5a6d86",
  "#e8e2d3",
  "#c5dbdc",
  "#cee7e4",
  "#70726b",
  "#645a49",
  "#9b8071",
  "#b99e9a",
  "#bfaa8c",
  "#8e8675",
  "#c1b3b2",
  "#b0b7b7",
  "#d6c8c0",
  "#d9d8ca",
  "#49545c",
  "#6f7159",
  "#778184",
  "#f0d7b6",
  "#bca48a",
  "#c4dace",
  "#c5b6a8",
  "#2e5d8a",
  "#706b6d",
  "#c7e3e7",
  "#cbd8cb",
  "#eeddcc",
  "#a18161",
  "#c7cac3",
  "#c2b7ab",
  "#80c1dd",
  "#efdcd4",
  "#836d4e",
  "#a28f7d",
  "#c0b5b2",
  "#8fa9bf",
  "#969867",
  "#4c5f4e",
  "#69574c",
  "#23677e",
  "#d8e3d6",
  "#489084",
  "#62a0bf",
  "#cdded3",
  "#e6ded0",
  "#3e6e85",
  "#e7e1d7",
  "#e2dbcd",
  "#e1d7d3",
  "#787a50",
  "#b2aea9",
  "#e0e0d8",
  "#f5d9b2",
  "#efdcd9",
  "#e6dcd2",
  "#d0cdb9",
  "#e2b99c",
  "#eaceb4",
  "#e5bc99",
  "#f0e0cf",
  "#dfb79f",
  "#75bba9",
  "#e3ded4",
  "#9a7f4c",
  "#ebdbc7",
  "#9e7b6b",
  "#f4e2d5",
  "#e0dadc",
  "#eee0e0",
  "#f0dcd7",
  "#f1dfd3",
  "#f1dcd7",
  "#ccb89b",
  "#dfdcd4",
  "#c4b69d",
  "#d2c6b5",
  "#dde1e1",
  "#d8dfdb",
  "#82b7d1",
  "#927765",
  "#f0e9d8",
  "#c2e4e3",
  "#d5ccc6",
  "#bfad84",
  "#ede1de",
  "#61665e",
  "#bfb7a6",
  "#e9ddc7",
  "#b2a2a2",
  "#55766d",
  "#635549",
  "#aea099",
  "#92684f",
  "#7a8b81",
  "#b59f8e",
  "#a67b59",
  "#b7bebf",
  "#15678c",
  "#a5d1d4",
  "#c6beb0",
  "#947d6b",
  "#898a87",
  "#cab39e",
  "#e5dcd1",
  "#e8cdc1",
  "#ebd1cd",
  "#eddad4",
  "#b9a398",
  "#efe1d9",
  "#cab1ac",
  "#e8ccc6",
  "#927770",
  "#674b49",
  "#a6dcda",
  "#9dc4c1",
  "#5d5650",
  "#b79071",
  "#925146",
  "#e3dad0",
  "#884d45",
  "#664941",
  "#b2ad97",
  "#417f91",
  "#b2a392",
  "#656a61",
  "#678b81",
  "#6bab9f",
  "#bea797",
  "#b7e7dd",
  "#c2e5e2",
  "#b3ccab",
  "#958f87",
  "#ddeadb",
  "#80c3ca",
  "#d3e9e8",
  "#007369",
  "#719784",
  "#a9bac3",
  "#dabab2",
  "#595c53",
  "#dedfd9",
  "#464949",
  "#ada496",
  "#bcb7b2",
  "#826a55",
  "#dfe4e0",
  "#c6cbc9",
  "#dfe1e3",
  "#e0ded5",
  "#deceb0",
  "#eed9d2",
  "#d5c9b2",
  "#e7dfc4",
  "#dbe6e3",
  "#51544b",
  "#b8bab5",
  "#dce7e3",
  "#6f5b4b",
  "#898384",
  "#b2c7d1",
  "#f3d4b1",
  "#e5e4da",
  "#eee7dd",
  "#e4e5e3",
  "#f1e0cb",
  "#736765",
  "#b29b65",
  "#7e685a",
  "#10a1a0",
  "#b5aa9e",
  "#a18a54",
  "#b3794b",
  "#bfd1c7",
  "#c6cfa8",
  "#c6d7bf",
  "#a4b690",
  "#e7e1de",
  "#516b4c",
  "#f5e8d3",
  "#d6af7d",
  "#939b9f",
  "#9a8462",
  "#9aa8b7",
  "#7d7974",
  "#e4e5de",
  "#7a6e60",
  "#706960",
  "#eec795",
  "#dadeda",
  "#abad96",
  "#d7b595",
  "#73696f",
  "#587188",
  "#706f5e",
  "#efefe5",
  "#694842",
  "#cabca4",
  "#b1d6e3",
  "#eee0c2",
  "#b0af80",
  "#c9c9c0",
  "#f1e1ce",
  "#eddbd1",
  "#c3d6da",
  "#51604d",
  "#c4a697",
  "#e4e3d8",
  "#cdb592",
  "#997c6f",
  "#ddcca5",
  "#7b6d60",
  "#438e7c",
  "#e2e3e1",
  "#c4927a",
  "#8e7e6e",
  "#d0b6aa",
  "#afac9c",
  "#78b9ae",
  "#b1d2d5",
  "#7b7064",
  "#9d8f77",
  "#676e70",
  "#5e4940",
  "#7f8b7b",
  "#718d6d",
  "#d0ccbc",
  "#edd4d0",
  "#9d834c",
  "#b1acac",
  "#c9d7dc",
  "#4d614c",
  "#5b7e6f",
  "#299f95",
  "#3c5575",
  "#e3dcbc",
  "#6f5f4c",
  "#276c6f",
  "#dae0e5",
  "#e7dcca",
  "#7f8475",
  "#d9dcd8",
  "#f2dbb8",
  "#e8dfd1",
  "#b59f99",
  "#534f51",
  "#575b59",
  "#aadee0",
  "#eddad0",
  "#e8cbbf",
  "#b4946d",
  "#eeded4",
  "#c5d0b1",
  "#bfb6a8",
  "#b2c7d4",
  "#d5e5e4",
  "#97754e",
  "#7e7872",
  "#bec1b2",
  "#b5a596",
  "#a1a8a8",
  "#f2e1c7",
  "#d1cac7",
  "#c9d8c3",
  "#eae6e3",
  "#e8dfd2",
  "#eeeadb",
  "#eedbbf",
  "#dac6bb",
  "#e8dcca",
  "#e7e4e1",
  "#e7e0d1",
  "#ebede5",
  "#eae7e3",
  "#e8dbc5",
  "#e0d6d0",
  "#f3ece3",
  "#deddcf",
  "#ddded5",
  "#e1dfd3",
  "#97765d",
  "#8c9668",
  "#e2ddd6",
  "#cad0ce",
  "#80d0d0",
  "#d9e1dc",
  "#dce0db",
  "#6d7378",
  "#7b7363",
  "#756a5f",
  "#727268",
  "#8e6f55",
  "#c0a58f",
  "#e2dbd3",
  "#aebea6",
  "#b1b695",
  "#94b1a0",
  "#528a9a",
  "#602234",
  "#7c243d",
  "#8d1d30",
  "#87141f",
  "#801522",
  "#711922",
  "#b5001a",
  "#9d101c",
  "#98010d",
  "#ac0000",
  "#940000",
  "#870000",
  "#911f21",
  "#7e191b",
  "#8e3928",
  "#9a4a33",
  "#b7813c",
  "#915f3d",
  "#503629",
  "#3d271d",
  "#3f352b",
  "#2c201a",
  "#424330",
  "#4c4527",
  "#1b5236",
  "#214b2d",
  "#054239",
  "#002f24",
  "#12221d",
  "#005553",
  "#006c7a",
  "#1e454d",
  "#004683",
  "#014e71",
  "#0e1531",
  "#e2d9d7",
  "#dfdcdb",
  "#e1dcda",
  "#e7e1e1",
  "#ebdfdd",
  "#e9dcdb",
  "#efe1dd",
  "#eededb",
  "#efded8",
  "#dfe4d5",
  "#d6e1d8",
  "#d8ebe6",
  "#dfe8e4",
  "#e1e5e3",
  "#dee2e4",
  "#e1e2e4",
  "#e6e4e4",
  "#ebe8e6",
  "#f0e5e5",
  "#f0e2e4",
  "#f0e3e4",
  "#f1dfdf",
  "#f1dede",
  "#f2dedc",
  "#f2dcd7",
  "#f4e1d7",
  "#f4e3d8",
  "#f1e1d7",
  "#f2e1d2",
  "#f2decc",
  "#f4d5b2",
  "#f5c99b",
  "#f0b07a",
  "#e89a61",
  "#dd894f",
  "#d2783a",
  "#f4e3cb",
  "#f2ecca",
  "#e8ecd1",
  "#e3ead6",
  "#e6ebd4",
  "#e0ead8",
  "#dfebdd",
  "#dcede7",
  "#d5eae8",
  "#cfe8e8",
  "#dce9e9",
  "#d5e5e7",
  "#e0e5e6",
  "#dfe2e7",
  "#e8e6e7",
  "#eae5e7",
  "#efe7e7",
  "#eac8da",
  "#e7bcd4",
  "#da9ec5",
  "#cf7ead",
  "#edc9d5",
  "#e3a9c4",
  "#dc89a8",
  "#ce6c91",
  "#eec5d2",
  "#e6a3b9",
  "#db7b97",
  "#f1cad3",
  "#ed9aab",
  "#e47486",
  "#cb3e50",
  "#b1383d",
  "#b13330",
  "#b6363b",
  "#d03e35",
  "#c04641",
  "#f1beb8",
  "#ef9a93",
  "#e5756a",
  "#d54f43",
  "#f1bdb2",
  "#ed9080",
  "#df644e",
  "#d85739",
  "#d34c2a",
  "#f5c795",
  "#f6b064",
  "#f08d2e",
  "#ed8732",
  "#f29312",
  "#f49807",
  "#fac76c",
  "#f9b952",
  "#f9ac34",
  "#ffc401",
  "#f5e6ac",
  "#e4d68c",
  "#d7c65b",
  "#b0ae26",
  "#8ab733",
  "#6ea43c",
  "#b1d99d",
  "#8cbf6f",
  "#61a53f",
  "#c9e7cc",
  "#a3d9ab",
  "#7ec083",
  "#52a550",
  "#b8e7de",
  "#48c2b0",
  "#01a192",
  "#019f9f",
  "#b5e3e2",
  "#7fd3d3",
  "#01a4a5",
  "#018c94",
  "#abdee3",
  "#73ccd8",
  "#017c85",
  "#a7d8e8",
  "#6cc3e0",
  "#01a2c6",
  "#0192b8",
  "#b0d8e7",
  "#bbd0e3",
  "#91b8d9",
  "#5287b9",
  "#4d78ac",
  "#01678d",
  "#9fabcf",
  "#7381b3",
  "#e4d4e2",
  "#a786b4",
  "#9975a5",
  "#e6ccdd",
  "#d3acce",
  "#b883b0",
  "#944f80",
  "#705284",
  "#bfe6d2",
  "#95dabd",
  "#6ccca5",
  "#e8eaea",
  "#f6e9e8",
  "#f6e6e5",
  "#f7e2e2",
  "#f6e7e2",
  "#f7e1dc",
  "#f5eae2",
  "#f7e5db",
  "#f7ece1",
  "#f8e6d7",
  "#f6ecde",
  "#f8e7d4",
  "#f9e9d1",
  "#f7edda",
  "#f8ebd4",
  "#f8ecd1",
  "#f8f0d9",
  "#f9eed0",
  "#f7f0d8",
  "#f9eecd",
  "#eeefe1",
  "#ebedda",
  "#eaf1e4",
  "#e5f1eb",
  "#e1f0ea",
  "#e6efec",
  "#d8ebea",
  "#e5eeee",
  "#dbeaed",
  "#e4e9ed",
  "#dee5ec",
  "#d8e0ea",
  "#e2e2ea",
  "#efeced",
  "#ece7ed",
  "#c69eae",
  "#d7a491",
  "#b63731",
  "#d1ae9a",
  "#e7b89a",
  "#d39a72",
  "#f6f7f2",
  "#dedacd",
  "#e4decf",
  "#f6f2e8",
  "#f6f0e5",
  "#e1d9c6",
  "#ddcfb9",
  "#d7c9ae",
  "#e0d4bd",
  "#c4b9a3",
  "#d8cfba",
  "#cec2aa",
  "#b5a78d",
  "#8c8373",
  "#584e41",
  "#d5cebf",
  "#bbb2a0",
  "#99917c",
  "#544e42",
  "#cdc7b7",
  "#b6ae99",
  "#969281",
  "#797869",
  "#5f5b4d",
  "#bfb397",
  "#a69c81",
  "#908468",
  "#7d6e52",
  "#5c4e2e",
  "#caba97",
  "#beae88",
  "#9e8e6c",
  "#94876e",
  "#665b44",
  "#cab598",
  "#b49d7b",
  "#a18a67",
  "#8d7553",
  "#796040",
  "#ecebe8",
  "#eaebe8",
  "#e2e0dc",
  "#e0ddd8",
  "#cdc8bf",
  "#ccccc5",
  "#d1cfca",
  "#d1ccc6",
  "#d1d0c9",
  "#c7c8c1",
  "#83807a",
  "#696863",
  "#e0e2e0",
  "#c6c7c5",
  "#a0a5a5",
  "#7b8285",
  "#656a6e",
  "#d2d1cb",
  "#c6c5c1",
  "#9e9d99",
  "#74777a",
  "#d6d2ca",
  "#c1bbb0",
  "#a8a298",
  "#8e8a81",
  "#615c55",
  "#dbd9d2",
  "#b4ada6",
  "#aca69f",
  "#726f6c",
  "#59504f",
  "#d8cfc6",
  "#d0c6b8",
  "#afa499",
  "#908379",
  "#eeebe1",
  "#edece7",
  "#e6e2d9",
  "#e3dfd5",
  "#e5e0d7",
  "#d0c7b7",
  "#c8c0b3",
  "#dbd5cb",
  "#dad2c6",
  "#b0a899",
  "#868172",
  "#7e7970",
  "#65635b",
  "#bab3a6",
  "#a8a294",
  "#80796d",
  "#6a655c",
  "#413d3c",
  "#d5cbbe",
  "#c1b2a1",
  "#978e7f",
  "#625346",
  "#453e39",
  "#cec5b6",
  "#9b8f7e",
  "#897d6d",
  "#766859",
  "#57534e",
  "#cabead",
  "#b2a492",
  "#8c8475",
  "#7c7466",
  "#62584b",
  "#d8d0c1",
  "#d0c1ac",
  "#9f8e7a",
  "#8d7e6d",
  "#5b564f",
  "#e0e3e2",
  "#ebebe7",
  "#eef1ec",
  "#e7e9e7",
  "#e4e1d6",
  "#e1e1db",
  "#dcdcd5",
  "#d8d5cc",
  "#cdccc3",
  "#cfd1ca",
  "#dce2df",
  "#ced7d5",
  "#b6c3c4",
  "#82979b",
  "#d5d8d7",
  "#b0b7b7",
  "#a2a8a6",
  "#536168",
  "#434a54",
  "#d4dcdc",
  "#bfc2bf",
  "#a3afac",
  "#768482",
  "#41494b",
  "#c9cabf",
  "#bcbcae",
  "#a7a796",
  "#85877b",
  "#c8cec6",
  "#b8bfb1",
  "#aab4a7",
  "#768078",
  "#5c6a6a",
  "#d0d5cb",
  "#c2cec5",
  "#adbcb4",
  "#94a69d",
  "#ebe0ce",
  "#f5e9cf",
  "#f6deb3",
  "#f5cf92",
  "#f7ce65",
  "#edebdb",
  "#efebd1",
  "#e3deb3",
  "#a4a571",
  "#4e6342",
  "#e9ede7",
  "#d3dccd",
  "#c2ccac",
  "#8b987b",
  "#2a4442",
  "#e7eae3",
  "#d4dcd3",
  "#bdcbbb",
  "#658375",
  "#303636",
  "#dde6e5",
  "#d7e1e5",
  "#dfe0e3",
  "#dcdee0",
  "#a8aab3",
  "#5c5666",
  "#383c49",
  "#e9e3de",
  "#f2e0df",
  "#eecacd",
  "#b85b57",
  "#833337",
  "#eee6de",
  "#f3dfd6",
  "#f0dfcd",
  "#f2a28c",
  "#d16f65",
  "#797a69",
  "#f5f1e6",
  "#221f20",
  "#c2c7bc",
  "#51504d",
  "#d8d0c0",
  "#beb6ab",
  "#fcf3d3",
  "#525f6c",
  "#aeb3a8",
  "#a8aa9f",
  "#844f45",
  "#73858e",
  "#a6aaad",
  "#615f55",
  "#acb1b3",
  "#68707c",
  "#a29c88",
  "#5f554f",
  "#877c69",
  "#3d2a1c",
  "#6e766a",
  "#8f9485",
  "#54331b",
  "#908672",
  "#6a543e",
  "#cac2b0",
  "#7d8689",
  "#aca394",
  "#e2e3e4",
  "#89847f",
  "#637d95",
  "#d2c7a8",
  "#beb59c",
  "#b8b7b0",
  "#848683",
  "#a2b5c5",
  "#e0d4c2",
  "#f3f7f7",
  "#fbf2c6",
  "#575451",
  "#767168",
  "#797b74",
  "#121112",
  "#f8f4e2",
  "#8a653e",
  "#e5e3d9",
  "#c6b9a0",
  "#d5c5c4",
  "#dfd7c4",
  "#cec0ae",
  "#b5b6b4",
  "#d0ceca",
  "#a2a59a",
  "#d0c4b6",
  "#8e857a",
  "#f2e8c4",
  "#3e5049",
  "#627c45",
  "#c9a669",
  "#42493c",
  "#dac8b2",
  "#766b5e",
  "#bbad96",
  "#7b7975",
  "#c0ab9a",
  "#d9d1bf",
  "#1c1b1c",
  "#4a352f",
  "#476158",
  "#57594c",
  "#413c37",
  "#554a46",
  "#736d63",
  "#9a9b86",
  "#432a1b",
  "#88382f",
  "#4e5d69",
  "#838889",
  "#b5b9b4",
  "#a19989",
  "#fcf7b3",
  "#838683",
  "#696f68",
  "#6d7169",
  "#906c54",
  "#4a4742",
  "#796657",
  "#1c4d1e",
  "#faf5d9",
  "#465669",
  "#48524c",
  "#7d604a",
  "#64514b",
  "#acaeb2",
  "#d8d4bf",
  "#c4b8a4",
  "#a39686",
  "#97938b",
  "#97939a",
  "#edddbe",
  "#53646c",
  "#a9a49d",
  "#fff6cf",
  "#ccbfa2",
  "#73685e",
  "#54322b",
  "#67696b",
  "#49515a",
  "#dac9b8",
  "#b7ab9b",
  "#adbcc1",
  "#9a9e8a",
  "#e4e0f1",
  "#c3af9f",
  "#e7e2cb",
  "#e0d0b4",
  "#afa497",
  "#5f6b71",
  "#e5dbde",
  "#b7ab9b",
  "#264c36",
  "#bcc7b8",
  "#cec0ae",
  "#f6f0e6",
  "#fff3d1",
  "#e3d4c1",
  "#c5c6c3",
  "#d0ceca",
  "#a29a8d",
  "#beaaa2",
  "#919489",
  "#dfd7c4",
  "#503731",
  "#c5c6c3",
  "#8a7c67",
  "#c7bdaf",
  "#9f8d7a",
  "#dfe1db",
  "#d4c9b3",
  "#5b6569",
  "#432a1b",
  "#97939a",
  "#737e82",
  "#525654",
  "#b2afac",
  "#d0c5b9",
  "#525654",
  "#dac8b2",
  "#6e685b",
  "#d7cdb9",
  "#554a46",
  "#726658",
  "#4a352f",
  "#d0c4b6",
  "#c7bdaf",
  "#c6b9a0",
  "#797860",
  "#c5b1a4",
  "#555f4f",
  "#aab6c0",
  "#c6c5c2",
  "#684018",
  "#7a7b7a",
  "#7c8d9c",
  "#933025",
  "#725837",
  "#e8e8e3",
  "#fbeed0",
  "#dfe3e0",
  "#e2d6b4",
  "#c4c2af",
  "#74756b",
  "#0d6290",
  "#cbb39a",
  "#c8c0b6",
  "#17151c",
  "#e0dbcc",
  "#41514e",
  "#99959a",
  "#8d98ab",
  "#edddbe",
  "#f3dcb0",
  "#73685e",
  "#53646c",
  "#dbcdcd",
  "#814847",
  "#aca38b",
  "#f0e0b8",
  "#efe9df",
  "#f0efe5",
  "#8e857a",
  "#737e82",
  "#9a9e8a",
  "#70413d",
  "#e8d3a5",
  "#afa497",
  "#f6f4ea",
  "#5f6b71",
  "#7b6e60",
  "#49515a",
  "#7a6c5f",
  "#b7ab9b",
  "#565550",
  "#a7aa9e",
  "#e3d6bd",
  "#473a32",
  "#bead9a",
  "#bd9164",
  "#696f68",
  "#72706a",
  "#f6f4e6",
  "#d5bda5",
  "#e4dadd",
  "#fff5c7",
  "#b2d6d1",
  "#713e36",
  "#f4dac5",
  "#9bb3c1",
  "#bfc9c9",
  "#f1ede0",
  "#f3e9d6",
  "#ebdec4",
  "#e8ddca",
  "#b79983",
  "#c9a27d",
  "#b59578",
  "#ecdcca",
  "#fcebd1",
  "#ebebe6",
  "#eff0ec",
  "#f7edd8",
  "#bca792",
  "#9f8870",
  "#ecdfc7",
  "#cdbba2",
  "#9ea49d",
  "#ded5c8",
  "#cdc4b7",
  "#8d8171",
  "#e7e2d2",
  "#aea492",
  "#a8b2b1",
  "#819094",
  "#f5f4ec",
  "#e6dfcf",
  "#d2c9b7",
  "#6a6d6d",
  "#eff0e9",
  "#b1b0af",
  "#949492",
  "#dddacf",
  "#cccac1",
  "#b1aea2",
  "#928c87",
  "#3f3f3e",
  "#dfe9e6",
  "#e1e6e5",
  "#dde7e8",
  "#e6f1f1",
  "#e7ece8",
  "#e3e6db",
  "#e4eae3",
  "#e7ebe6",
  "#f0f4f2",
  "#eef2f3",
  "#dce0dc",
  "#e3e5df",
  "#e2e2de",
  "#f2efde",
  "#f2f1df",
  "#f2f8ed",
  "#e0e1da",
  "#e9eade",
  "#edebe2",
  "#eeede0",
  "#f2f4e8",
  "#dddbd0",
  "#e4dfce",
  "#f0e8d7",
  "#f7f1e1",
  "#f4f0e5",
  "#d2c2b0",
  "#5d504a",
  "#e2ceb0",
  "#cbbeaa",
  "#f6e9d3",
  "#b7a083",
  "#cba578",
  "#93836f",
  "#6f6f6d",
  "#918f8a",
  "#747767",
  "#b6bbb2",
  "#8a9c99",
  "#728791",
  "#5a6365",
  "#4b4242",
  "#9a4149",
  "#7b4141",
  "#4c4845",
  "#f3e9d6",
  "#ddb582",
  "#3e554f",
  "#537175",
  "#435572",
  "#3b4354",
  "#347d8b",
  "#344d58",
  "#eed1a5",
  "#f7ead4",
  "#f7e4bf",
  "#e5dbca",
  "#d7c2a6",
  "#cbb0a8",
  "#d6dbdc",
  "#b5c9d3",
  "#cfdfe2",
  "#dbd3c6",
  "#9d9586",
  "#bdb6ab",
  "#d0d9c7",
  "#aebdbb",
  "#d0e6de",
  "#ecead9",
  "#acb397",
  "#c4aa27",
  "#3f4041",
  "#d16459",
  "#f2f0ea",
  "#f4f3ea",
  "#dd84a3",
  "#eee6d8",
  "#d3bda4",
  "#54463f",
  "#e8d3ba",
  "#f4a28c",
  "#d1ece3",
  "#d9d4cb",
  "#03a598",
  "#d4ebea",
  "#66537f",
  "#b7b7b1",
  "#ea7739",
  "#616665",
  "#a4a393",
  "#f1e7d6",
  "#d4b38f",
  "#a49588",
  "#7e7666",
  "#efeadc",
  "#c3b69f",
  "#9a9997",
  "#f2e6cf",
  "#b1a387",
  "#cfc1ae",
  "#aea494",
  "#dfd6c1",
  "#ede0c0",
  "#cfc5ae",
  "#d1ccc3",
  "#e6e3d9",
  "#89877f",
  "#e2e3d7",
  "#8c9595",
  "#8b7f76",
  "#dacbb9",
  "#d3c3d4",
  "#b8a3bb",
  "#a58ea9",
  "#907895",
  "#68546a",
  "#574958",
  "#e0cdda",
  "#d3b9cc",
  "#ba97b1",
  "#a7819d",
  "#956c87",
  "#7f576d",
  "#f1e0e8",
  "#e5c8d9",
  "#ddb8ce",
  "#d4a9c3",
  "#be89a8",
  "#a06582",
  "#875169",
  "#efdbe2",
  "#ebd0db",
  "#dfbbca",
  "#d0a1b4",
  "#b88096",
  "#9c6071",
  "#834253",
  "#f3d9dc",
  "#edc8ce",
  "#e6b6be",
  "#d08995",
  "#bd6973",
  "#843c41",
  "#f3d6d7",
  "#e8b9be",
  "#e0a7ad",
  "#d8979e",
  "#c67d84",
  "#a95657",
  "#f6d8d2",
  "#f1c3be",
  "#e39b96",
  "#f5d5cc",
  "#f2c8be",
  "#e8aa9d",
  "#d98a7d",
  "#ca6e5f",
  "#f6e3d6",
  "#f4d7c5",
  "#eec2ad",
  "#e5a68d",
  "#d88668",
  "#cc6f50",
  "#bf5c42",
  "#f6dacb",
  "#f0c8b6",
  "#e9b8a4",
  "#e3aa94",
  "#d08b73",
  "#bd6f56",
  "#aa5c43",
  "#f6d9c9",
  "#f1cab5",
  "#eabba2",
  "#e3ac92",
  "#d08f73",
  "#bf7657",
  "#af6649",
  "#faefe4",
  "#f7dbc7",
  "#d69875",
  "#c57e59",
  "#f9efe0",
  "#f7dac0",
  "#f0c39f",
  "#eab38a",
  "#e1a175",
  "#d78d5e",
  "#fbf1df",
  "#fce7cf",
  "#f6c79d",
  "#e8a773",
  "#c77b42",
  "#fbe6cd",
  "#f9debe",
  "#f7d3ad",
  "#f3c99d",
  "#e7b17c",
  "#f7e2c7",
  "#f4d9b9",
  "#e8c194",
  "#ca955c",
  "#c08950",
  "#ab7741",
  "#fbf1dd",
  "#fbe6c7",
  "#fadeb8",
  "#c1853b",
  "#feefd3",
  "#fae9ca",
  "#f2d7b0",
  "#ecca9a",
  "#e1b781",
  "#cd9956",
  "#b78545",
  "#f9f4e7",
  "#f7e7cd",
  "#efd4ae",
  "#e1bc8a",
  "#c99b5f",
  "#ab7f46",
  "#fcf3dd",
  "#feebc8",
  "#fcdba6",
  "#e2b66c",
  "#d6a550",
  "#c08f34",
  "#f6e8cc",
  "#f2debb",
  "#eacfa3",
  "#d7b57c",
  "#c6a05e",
  "#ae8845",
  "#9b7939",
  "#f6f3e1",
  "#ede5c7",
  "#d4c493",
  "#c0ab6e",
  "#aa9357",
  "#8a763d",
  "#f5e7c8",
  "#e4cb97",
  "#d1b375",
  "#bb9b52",
  "#957c35",
  "#eee8d2",
  "#e4dcbf",
  "#dad0ad",
  "#cabd94",
  "#b8aa7d",
  "#a49463",
  "#87784b",
  "#f5f3e1",
  "#edebce",
  "#e0deb2",
  "#d0cd94",
  "#b2b17c",
  "#949758",
  "#6e7042",
  "#ebeddb",
  "#dfe2c9",
  "#c6caa5",
  "#b2b68a",
  "#a4a97b",
  "#889551",
  "#6c7d42",
  "#ecf0df",
  "#cdd6b1",
  "#bfcba2",
  "#a2b07e",
  "#879550",
  "#6d7e42",
  "#f0f4e5",
  "#dfe8d0",
  "#c9d6b4",
  "#abbd90",
  "#718854",
  "#627948",
  "#dce2ce",
  "#d0d9c0",
  "#c3cdb0",
  "#b6c2a1",
  "#96a782",
  "#758a5f",
  "#546940",
  "#e6f0de",
  "#ddecd5",
  "#c4ddbb",
  "#a3c899",
  "#7fab70",
  "#558d4f",
  "#417b42",
  "#e2eddd",
  "#d9e7d4",
  "#bfd5b9",
  "#99b792",
  "#89a882",
  "#719166",
  "#506a48",
  "#d6e9d7",
  "#c8e2cc",
  "#b1d4b7",
  "#8cbd97",
  "#79b088",
  "#65926d",
  "#47694f",
  "#dceee3",
  "#d0e8db",
  "#bcdccd",
  "#97c3b0",
  "#74a690",
  "#54836b",
  "#446755",
  "#ddebe3",
  "#cbdfd6",
  "#b1cdc2",
  "#749e8f",
  "#537f6c",
  "#3f6253",
  "#abccc3",
  "#83ada3",
  "#6f968b",
  "#5d7f74",
  "#475f57",
  "#d7ede8",
  "#c2e3dd",
  "#afd9d3",
  "#89c1ba",
  "#63a39c",
  "#43817a",
  "#3a6b66",
  "#c9e9e7",
  "#acdbdb",
  "#96d0d1",
  "#7abec2",
  "#4a9fa3",
  "#2e8689",
  "#256d73",
  "#b9dee4",
  "#7bbbc8",
  "#57a3b3",
  "#e0f0f0",
  "#c9e5eb",
  "#a3d1df",
  "#78b8cc",
  "#55a0b7",
  "#2d7e96",
  "#2b677d",
  "#bad9e5",
  "#a6cdde",
  "#90bfd4",
  "#7bb1c9",
  "#5492af",
  "#37708c",
  "#355c74",
  "#bed8e4",
  "#adcddc",
  "#95bcd2",
  "#5285a4",
  "#416f8b",
  "#395a73",
  "#3a4859",
  "#c9dce7",
  "#afc9dc",
  "#6a92b1",
  "#40607c",
  "#3b5066",
  "#d0e3ed",
  "#c1dbea",
  "#9ac1dc",
  "#7aa8cb",
  "#3f6f98",
  "#3e5b7d",
  "#d2dfea",
  "#a4bbd3",
  "#819dbe",
  "#6a87ab",
  "#546e91",
  "#48516a",
  "#e1e9ef",
  "#ced9e9",
  "#b3c3dd",
  "#95a9cd",
  "#7e95be",
  "#465a7f",
  "#e1e2eb",
  "#d3d3e2",
  "#c1c2d7",
  "#aaabc8",
  "#8a8bae",
  "#75769b",
  "#5e5f7e",
  "#ede6ed",
  "#dfd3e4",
  "#d4c6dc",
  "#bba7c7",
  "#9d86ad",
  "#7b658a",
  "#5a4a64",
  "#864c58",
  "#8e4547",
  "#994341",
  "#bb6967",
  "#684344",
  "#744245",
  "#9f5440",
  "#a96f55",
  "#e3c6af",
  "#95878e",
  "#433f3d",
  "#60443f",
  "#b59a8d",
  "#897269",
  "#5c4945",
  "#bb9b7c",
  "#6b5446",
  "#956841",
  "#e1c8ab",
  "#a07d5e",
  "#d8be89",
  "#b7aa96",
  "#cab79c",
  "#cdba96",
  "#d8c6a8",
  "#bda88d",
  "#cabba1",
  "#d9ccb8",
  "#e5dbc1",
  "#c5b29f",
  "#a49085",
  "#5d4d47",
  "#d5bfad",
  "#b9a795",
  "#87786a",
  "#594c42",
  "#685951",
  "#e3c8aa",
  "#c9b196",
  "#b5a18a",
  "#9b856f",
  "#816d5a",
  "#d3c7b8",
  "#c3b7a4",
  "#ada493",
  "#857d72",
  "#bbb3a8",
  "#afa397",
  "#94897c",
  "#7b746b",
  "#c8c8c2",
  "#9d978d",
  "#71716e",
  "#5b5752",
  "#d7cec4",
  "#dccab7",
  "#d5c8b5",
  "#decfbb",
  "#e6deca",
  "#e7e1d3",
  "#dad0bb",
  "#e0d4b7",
  "#dddace",
  "#c5e4dc",
  "#ccd8cf",
  "#d3d8d2",
  "#e0dfd9",
  "#c7dae8",
  "#d6d9d8",
  "#d9dfe2",
  "#dde2e2",
  "#cecbcb",
  "#d9d9df",
  "#e4e5e7",
  "#ebe8e2",
  "#e2ded7",
  "#efdcd3",
  "#e5dad8",
  "#e1d8cc",
  "#d9c7b9",
  "#edc8b1",
  "#e5dccc",
  "#e9dbc4",
  "#e5d9b2",
  "#edd1ac",
  "#e1cdad",
  "#dfe1d9",
  "#e0e4d2",
  "#dbe0c4",
  "#cbd2c7",
  "#bbccbc",
  "#d9e0de",
  "#d9e6e2",
  "#cce7eb",
  "#cadade",
  "#b8cccd",
  "#dededc",
  "#d7e3e5",
  "#cfd9de",
  "#c2ced2",
  "#d7d8dd",
  "#ced2d7",
  "#e3a9a2",
  "#e8b9b2",
  "#bb9157",
  "#d29e68",
  "#d7a361",
  "#e4af65",
  "#e3bb65",
  "#e6c17a",
  "#26b7b5",
  "#81d8d3",
  "#b0ebdf",
  "#2b6baa",
  "#ad4e3c",
  "#d78e6b",
  "#bcaf65",
  "#d3e0b8",
  "#b2dd8e",
  "#50744a",
  "#64b5bf",
  "#afd3da",
  "#008bc4",
  "#c1abd4",
  "#bc86af",
  "#aeacad",
  "#3b3c3b",
  "#a1a2ab",
  "#4e4850",
  "#464e5a",
  "#3a4866",
  "#c6cbd1",
  "#808f98",
  "#8f979d",
  "#9ca4a9",
  "#a8b5bc",
  "#536770",
  "#879ca3",
  "#6d7273",
  "#8a9192",
  "#9fa5a5",
  "#bac1c3",
  "#b5acb7",
  "#35475b",
  "#36526a",
  "#9eb2b9",
  "#2a565b",
  "#a9bbbc",
  "#83a28f",
  "#76826c",
  "#b7c3b7",
  "#7d807b",
  "#a0a09c",
  "#bfbcb3",
  "#afad96",
  "#bdb593",
  "#d2cbbc",
  "#669699",
  "#006d73",
  "#78a696",
  "#45524f",
  "#48553f",
  "#99a787",
  "#6e7357",
  "#545b45",
  "#605f4b",
  "#bdb078",
  "#9f97a3",
  "#7e737d",
  "#67585f",
  "#584b4d",
  "#d3cacd",
  "#c6babe",
  "#a7989e",
  "#92838a",
  "#806f72",
  "#716264",
  "#4e4444",
  "#e9dfde",
  "#cdbbbc",
  "#b39c9e",
  "#917778",
  "#82696a",
  "#dcd0cb",
  "#d1c2bc",
  "#b6a19b",
  "#98817c",
  "#cac2bd",
  "#b3a9a5",
  "#9e938f",
  "#847975",
  "#71635e",
  "#605652",
  "#dfd2ca",
  "#cebdb4",
  "#b9a39a",
  "#9d8376",
  "#896d61",
  "#6e544b",
  "#5f4940",
  "#ebdfd8",
  "#dbc8c0",
  "#c7b0a7",
  "#b4978d",
  "#96786d",
  "#7f5f52",
  "#704e40",
  "#dfd4cc",
  "#cabab1",
  "#af9b91",
  "#8f786c",
  "#6d574d",
  "#5a4840",
  "#e8e2da",
  "#dad1c8",
  "#cbbeb5",
  "#b0a196",
  "#8f7d70",
  "#7f6b60",
  "#6c5a51",
  "#e9dfd5",
  "#dcccc0",
  "#cebcae",
  "#b8a292",
  "#9a8172",
  "#896e5d",
  "#6b5445",
  "#dad3cb",
  "#ccc3ba",
  "#baaea3",
  "#a69c91",
  "#8f847a",
  "#7a7068",
  "#665a51",
  "#e0d9cf",
  "#d1c7bb",
  "#bcafa2",
  "#aa9c8e",
  "#8a796a",
  "#6e5f53",
  "#554941",
  "#e3ded4",
  "#d3cabf",
  "#beb2a5",
  "#a5988a",
  "#938577",
  "#756657",
  "#655649",
  "#e0d5ca",
  "#d5c9bc",
  "#c8b9ab",
  "#aa9788",
  "#968374",
  "#85705f",
  "#6e5949",
  "#e7dbca",
  "#e1d0be",
  "#cfb8a1",
  "#bba088",
  "#a78b74",
  "#8f715c",
  "#7f6551",
  "#f0e3d4",
  "#ddc5af",
  "#caac91",
  "#b99779",
  "#a37d5e",
  "#8e6c51",
  "#775c47",
  "#ebdbc8",
  "#dec7ad",
  "#cab095",
  "#bda389",
  "#a68a71",
  "#8d745e",
  "#e4d7c3",
  "#dcc8b0",
  "#d1bba1",
  "#bda07f",
  "#ae8d6b",
  "#9c7c5b",
  "#8f7459",
  "#efe0cb",
  "#ddc3a4",
  "#cbac88",
  "#bb9973",
  "#a9855d",
  "#927149",
  "#f0e5d3",
  "#eaddc6",
  "#e3d2b6",
  "#c2a781",
  "#a7885f",
  "#91734c",
  "#ece5d7",
  "#e2d7c6",
  "#d3c5af",
  "#bba990",
  "#a59074",
  "#8e785c",
  "#7d6950",
  "#e5e0d3",
  "#dcd6c6",
  "#cfc7b5",
  "#b7ac97",
  "#988a72",
  "#85775f",
  "#6d624e",
  "#ddd9ce",
  "#d1ccc0",
  "#c4bdb0",
  "#b6afa0",
  "#989081",
  "#7d7363",
  "#ece8dc",
  "#ddd7c6",
  "#d2cab7",
  "#b6ac95",
  "#a39880",
  "#8b7e64",
  "#72664f",
  "#e2ddcf",
  "#cbc5b1",
  "#b8b19a",
  "#9b9279",
  "#887e64",
  "#68604a",
  "#dcdace",
  "#d1cfc0",
  "#c3c0b1",
  "#aaa794",
  "#93907e",
  "#767461",
  "#64634f",
  "#d9d9d2",
  "#c8c8c0",
  "#aba9a0",
  "#98968d",
  "#848178",
  "#6b655b",
  "#595147",
  "#e1e0d7",
  "#d4d3c9",
  "#bfbfb4",
  "#a7a699",
  "#8e8e82",
  "#6e6c5e",
  "#5e5c50",
  "#d6d7cf",
  "#c9cbc2",
  "#babbb3",
  "#a3a59b",
  "#8b8c83",
  "#6c6d62",
  "#5b5d53",
  "#dce1d5",
  "#ced5c7",
  "#b0b9a6",
  "#97a18d",
  "#88927e",
  "#68705c",
  "#5e6552",
  "#d4dcd1",
  "#c6d1c4",
  "#b3bfb0",
  "#93a190",
  "#7f8b79",
  "#5f6d5c",
  "#eaede5",
  "#d3d9d0",
  "#bec5ba",
  "#7e867c",
  "#63695f",
  "#555a51",
  "#d9e0d8",
  "#bdcac0",
  "#9dada3",
  "#87968b",
  "#717e73",
  "#5c685e",
  "#515a52",
  "#d9e4de",
  "#9fb1ab",
  "#889a95",
  "#687f7a",
  "#596d69",
  "#495d5a",
  "#d8e2df",
  "#bdcbca",
  "#afbfbe",
  "#8fa2a2",
  "#6d7e7d",
  "#586766",
  "#4e5a59",
  "#d1d5d3",
  "#c3c8c7",
  "#b1b8b8",
  "#8d9596",
  "#788082",
  "#616767",
  "#474b4a",
  "#d8dbd7",
  "#cccfcb",
  "#b6b9b6",
  "#9ea19f",
  "#868988",
  "#5f615f",
  "#505150",
  "#cbd5d6",
  "#bbc8c9",
  "#a9b8bb",
  "#78888e",
  "#59676b",
  "#4d585c",
  "#c9d3d7",
  "#b9c6cb",
  "#a6b5bd",
  "#90a1aa",
  "#74858f",
  "#5f6e77",
  "#4c565e",
  "#cbd3d5",
  "#bcc5c9",
  "#a9b4ba",
  "#8d99a1",
  "#6f7b84",
  "#59636a",
  "#45494d",
  "#dbdddb",
  "#cbcecd",
  "#acb0b0",
  "#999d9e",
  "#838789",
  "#5c5e5f",
  "#494b4e",
  "#cfd2d3",
  "#c0c4c6",
  "#aeb3b6",
  "#9fa4a8",
  "#757a80",
  "#535558",
  "#413f3e",
  "#d1d1cf",
  "#c5c5c3",
  "#aeadac",
  "#929291",
  "#757574",
  "#5e5e5d",
  "#3d3e3e",
  "#dbdcdb",
  "#d0d2d1",
  "#bdbebf",
  "#a2a4a6",
  "#818387",
  "#636365",
  "#4c4949",
  "#dbdddf",
  "#c2c4ca",
  "#b1b3bb",
  "#9698a2",
  "#777985",
  "#60616b",
  "#54555d",
  "#c8c7cb",
  "#b9b7bd",
  "#a29fa8",
  "#898790",
  "#69656d",
  "#4a4649",
  "#c7c4cd",
  "#b6b3bf",
  "#a8a3b1",
  "#938f9f",
  "#7d798a",
  "#66616f",
  "#d3cfd0",
  "#bfb9bd",
  "#a29aa0",
  "#887e82",
  "#70666a",
  "#5d5558",
  "#524c4f",
  "#fbecd8",
  "#f1e0cb",
  "#f6e5ce",
  "#faecd1",
  "#f9e9d3",
  "#ddd4c7",
  "#dcd0bd",
  "#e6dcc9",
  "#f5ede0",
  "#e7dccc",
  "#efe8d9",
  "#eae4d9",
  "#f7f1e3",
  "#faf6e9",
  "#e3cfe5",
  "#dbc1de",
  "#a97fb1",
  "#8b5e8f",
  "#674668",
  "#e4c1dd",
  "#dbb0d3",
  "#b576a7",
  "#a15d8c",
  "#91507b",
  "#edc2db",
  "#e7b2d0",
  "#d88cb5",
  "#cc76a3",
  "#be5c87",
  "#b24e76",
  "#944a63",
  "#f0cbd9",
  "#ecbcce",
  "#e6aac1",
  "#d37c99",
  "#c8647f",
  "#b74e64",
  "#f2d6da",
  "#f0c7cf",
  "#e5a5b1",
  "#d47f8d",
  "#c76a77",
  "#bc555e",
  "#a33f40",
  "#f6dee0",
  "#f3c6cc",
  "#eca2ad",
  "#e07c89",
  "#d86773",
  "#c74547",
  "#be3c37",
  "#f3cbcc",
  "#f0bcbe",
  "#e6999d",
  "#d9787c",
  "#cb5c5b",
  "#be4b47",
  "#b6453e",
  "#f5d1cf",
  "#f2b7b5",
  "#eda3a2",
  "#e58281",
  "#db615e",
  "#cf4944",
  "#c93f38",
  "#f9d5c9",
  "#f8c8bb",
  "#ee9685",
  "#e77b68",
  "#dc5d47",
  "#d04838",
  "#fbd9c4",
  "#fbd2bb",
  "#f8b797",
  "#f5a482",
  "#ee8962",
  "#e36940",
  "#da5736",
  "#fee2cc",
  "#fdb793",
  "#f79d72",
  "#eb7e4d",
  "#de6a41",
  "#fee8d1",
  "#ffdbbd",
  "#ffc69d",
  "#ffb587",
  "#fda471",
  "#e88951",
  "#db7842",
  "#fbecd3",
  "#fddcb7",
  "#fdd3a7",
  "#fdc592",
  "#fab47b",
  "#f59d59",
  "#ee8442",
  "#fcf0de",
  "#fee5c8",
  "#ffd3a7",
  "#fdc797",
  "#f7aa6f",
  "#f09650",
  "#eb8a44",
  "#ffe4be",
  "#ffdcac",
  "#ffd49d",
  "#ffc785",
  "#ffb96f",
  "#fd9d43",
  "#fa9335",
  "#ffeac5",
  "#ffe4b5",
  "#ffd89a",
  "#ffce84",
  "#ffc16c",
  "#ffb14e",
  "#ffa035",
  "#fcf3dd",
  "#ffecc3",
  "#ffe6b3",
  "#ffd98c",
  "#ffd379",
  "#ffc962",
  "#ffb729",
  "#feedca",
  "#ffe9bb",
  "#ffe3a9",
  "#ffd98c",
  "#ffb737",
  "#f9ab1d",
  "#fcf1cf",
  "#fee8b0",
  "#fde2a0",
  "#fcda89",
  "#f7c85f",
  "#f2bc48",
  "#eab034",
  "#ffedbe",
  "#ffe9ac",
  "#ffe39b",
  "#ffdc83",
  "#ffd467",
  "#ffca46",
  "#ffbd1b",
  "#fbf6e0",
  "#fff0c0",
  "#ffeba9",
  "#ffe99e",
  "#ffe487",
  "#ffd756",
  "#ffc819",
  "#fbf4d1",
  "#fdf3c4",
  "#fff1b4",
  "#f9e69c",
  "#f7da74",
  "#f0cc50",
  "#e1ba36",
  "#f9f2d1",
  "#f6ebb9",
  "#f3e4a7",
  "#edda8f",
  "#e5ce77",
  "#dbc058",
  "#c9aa37",
  "#f6eec9",
  "#f1e4b0",
  "#ebdc9c",
  "#e4d183",
  "#dcc772",
  "#ae9b33",
  "#f6f3d3",
  "#f1eab4",
  "#e8e097",
  "#d8d06b",
  "#ccc14d",
  "#b2ac31",
  "#a9a52a",
  "#f7f3dd",
  "#f2ebc7",
  "#e7dda7",
  "#d5cb7f",
  "#b5b04f",
  "#92942c",
  "#eef0d7",
  "#ecebc9",
  "#deddaa",
  "#c3c67e",
  "#b7bb6b",
  "#7a8c31",
  "#e3eacc",
  "#a6bc7b",
  "#89a457",
  "#698538",
  "#ebf2df",
  "#e1ecd1",
  "#d3e3bf",
  "#bad19e",
  "#9dbb7d",
  "#7ea15a",
  "#547839",
  "#dbf2d9",
  "#caecca",
  "#bbe6bb",
  "#97d499",
  "#7dc683",
  "#5eb56a",
  "#428f46",
  "#dff2dd",
  "#d2eed6",
  "#b2e1bc",
  "#86c994",
  "#73bd83",
  "#4a9d5b",
  "#398749",
  "#d7efde",
  "#bce3c9",
  "#aad9bb",
  "#84c299",
  "#6db083",
  "#539b6a",
  "#407548",
  "#d1f0e1",
  "#b2e4d0",
  "#89d1b5",
  "#73c4a4",
  "#4ea77d",
  "#338860",
  "#2e7451",
  "#c8efe2",
  "#a0e3d1",
  "#7bd5bf",
  "#5ac7ac",
  "#26ad8d",
  "#00886b",
  "#1f6c53",
  "#d2efe6",
  "#c4eae0",
  "#9dd9cc",
  "#6fc1af",
  "#54af9c",
  "#349581",
  "#297f6d",
  "#d7f2ed",
  "#b8e9e4",
  "#87d9d2",
  "#6fd1c9",
  "#2bb9af",
  "#009b8e",
  "#00877b",
  "#c7ecea",
  "#9fdfdf",
  "#75cfd0",
  "#00aaac",
  "#009494",
  "#006e6e",
  "#c6eaec",
  "#9ddce2",
  "#81d1da",
  "#66c6d0",
  "#1cadba",
  "#008e9a",
  "#007883",
  "#c5e8ee",
  "#b2e2ea",
  "#9bd9e5",
  "#65c3d6",
  "#1aa9c1",
  "#0089a0",
  "#00667b",
  "#b8e3ed",
  "#9ad6e8",
  "#7ecbe2",
  "#4db5d7",
  "#00a0c6",
  "#0087a8",
  "#007597",
  "#d5eaf2",
  "#b5dcef",
  "#9fd1eb",
  "#6fb7e0",
  "#47a0d2",
  "#0079b3",
  "#156a9b",
  "#bbdcf0",
  "#a1cfec",
  "#89c0e6",
  "#75b5e1",
  "#4596cf",
  "#267ebc",
  "#265c98",
  "#bdd8ec",
  "#aacde8",
  "#6aa0cf",
  "#4e89be",
  "#366fa6",
  "#2c538a",
  "#d2e1f0",
  "#afc7e8",
  "#9bb8e2",
  "#82a3d7",
  "#6389c6",
  "#4467a7",
  "#3c4b7e",
  "#dbe1ef",
  "#ccd4ec",
  "#b9c3e6",
  "#9facdb",
  "#7f8fca",
  "#6373b4",
  "#49548f",
  "#dfe0ee",
  "#d0d2e9",
  "#b6b8de",
  "#a0a3d2",
  "#8a8dc4",
  "#515386",
  "#ded2e8",
  "#ccbbdd",
  "#b7a1ce",
  "#a38bbf",
  "#9076ae",
  "#71588d",
  "#59476b",
  "#677559",
  "#80905f",
  "#92a461",
  "#c1c6a8",
  "#cbd1ba",
  "#cccfbf",
  "#dee0d2",
  "#f0efe3",
  "#eeeadc",
  "#a7a996",
  "#888b73",
  "#747767",
  "#583e3e",
  "#595f53",
  "#e1887f",
  "#8a4646",
  "#5f6d59",
  "#98a98b",
  "#9fa687",
  "#afb796",
  "#b1b5a0",
  "#bac4ad",
  "#bdc4b5",
  "#c9d1c2",
  "#c2d1c4",
  "#aabaaf",
  "#a0ac9e",
  "#8f9783",
  "#7b8370",
  "#4d6052",
  "#7a4248",
  "#70474b",
  "#72908d",
  "#879d99",
  "#93a79e",
  "#98beb2",
  "#9db9b2",
  "#bcc7c5",
  "#cfd4ce",
  "#eaebe4",
  "#d3dbd9",
  "#b0b8b0",
  "#899697",
  "#798884",
  "#60746d",
  "#69756c",
  "#616e6c",
  "#4d6162",
  "#147d87",
  "#547174",
  "#5c7884",
  "#719ca4",
  "#85a4a2",
  "#94b8c1",
  "#a4c8c8",
  "#a3bec4",
  "#9bb6b6",
  "#a6bdbe",
  "#afc0c4",
  "#b4cccb",
  "#cad8d8",
  "#dfe9e5",
  "#38515d",
  "#708189",
  "#58728a",
  "#587b9b",
  "#778590",
  "#adbbc4",
  "#5a7490",
  "#4e6173",
  "#3e4855",
  "#33578a",
  "#476386",
  "#496ead",
  "#5d83b3",
  "#8b9eb3",
  "#8ab1d6",
  "#b8bfd2",
  "#adbbc9",
  "#c3cfdc",
  "#485169",
  "#434555",
  "#4a4e54",
  "#533e4f",
  "#4f5152",
  "#595d61",
  "#6e7173",
  "#8d9396",
  "#b8bcbc",
  "#f0f1e7",
  "#d2ccc4",
  "#c4c0bb",
  "#b9b9b4",
  "#beb6ac",
  "#b6aca0",
  "#acaaa7",
  "#a29c94",
  "#97928b",
  "#857f7a",
  "#6c6b65",
  "#605c59",
  "#434442",
  "#683e3b",
  "#7a3f38",
  "#8c413d",
  "#e8dfd5",
  "#e3d6ca",
  "#ae7d6e",
  "#b06f60",
  "#ae5848",
  "#a45a4a",
  "#a04039",
  "#96453b",
  "#885247",
  "#784d40",
  "#75554e",
  "#4b4743",
  "#544f4c",
  "#6a6661",
  "#716a62",
  "#71706c",
  "#7b766c",
  "#87857e",
  "#908d86",
  "#a8a095",
  "#adaaa2",
  "#b7b4ac",
  "#cac9c0",
  "#e6e4db",
  "#ebeae2",
  "#e1dfd4",
  "#c7c6c0",
  "#bdbeb9",
  "#a5a6a1",
  "#969795",
  "#8f8f8b",
  "#807c77",
  "#585858",
  "#43484b",
  "#545554",
  "#646763",
  "#6b6d6a",
  "#a4a6a3",
  "#a8a89d",
  "#b0ada0",
  "#b6b4a9",
  "#b5b6ad",
  "#c3c2b8",
  "#d6d4ca",
  "#dee0d7",
  "#e9ece5",
  "#d5d9d3",
  "#c2c6c0",
  "#a7aba4",
  "#a4a6a4",
  "#858885",
  "#797f7d",
  "#727c7e",
  "#5e6869",
  "#525c61",
  "#4a5257",
  "#3e474c",
  "#4e5152",
  "#676a6a",
  "#7f8384",
  "#898887",
  "#8f9395",
  "#a0a09f",
  "#a7a5a3",
  "#b1b3b3",
  "#ccc9c5",
  "#cfccc5",
  "#d1d4d1",
  "#d3d8d8",
  "#e5e7e4",
  "#d9dcdb",
  "#d1d1ce",
  "#cbcece",
  "#c7cbc8",
  "#bec2c1",
  "#a0a6a9",
  "#9a9da2",
  "#858a8e",
  "#656d74",
  "#454749",
  "#45484a",
  "#bf7756",
  "#d2864e",
  "#f2e7d8",
  "#dcc4ac",
  "#dbba9d",
  "#d9a787",
  "#d2a888",
  "#c19a7d",
  "#c28c5f",
  "#a78876",
  "#ad7356",
  "#a76944",
  "#896754",
  "#8f5c45",
  "#6e5043",
  "#634d45",
  "#8f6a4f",
  "#9b7757",
  "#c38650",
  "#ad927b",
  "#bda286",
  "#be9b79",
  "#cab49b",
  "#dbc4aa",
  "#f9e8d3",
  "#ecd7bf",
  "#f5d8ba",
  "#ded2bb",
  "#ddc6a8",
  "#dabe9f",
  "#e7c89f",
  "#cca179",
  "#70553d",
  "#4c443e",
  "#6a5b4e",
  "#7e6c5f",
  "#82715f",
  "#8e7967",
  "#968777",
  "#a59789",
  "#ccc3b4",
  "#f3ece1",
  "#f5ebdc",
  "#f3e6d4",
  "#d6cab9",
  "#cabdae",
  "#b8a899",
  "#b39c8e",
  "#9d8675",
  "#837165",
  "#68574b",
  "#594d46",
  "#4b423f",
  "#d39952",
  "#edb36f",
  "#d9ad7a",
  "#ffc367",
  "#f7c680",
  "#f5d6aa",
  "#f8edd7",
  "#f4e4c6",
  "#eed8b2",
  "#f2dfb5",
  "#fdd773",
  "#e7c180",
  "#a79480",
  "#b5a28a",
  "#c0ae96",
  "#d2c1a8",
  "#d7cfc0",
  "#ddd2bf",
  "#e5dfd2",
  "#eeebe2",
  "#f0ebd9",
  "#f4eed8",
  "#ece2cc",
  "#e3dcca",
  "#e2d5bd",
  "#e7d4b6",
  "#e0c9a1",
  "#cbb08c",
  "#c1ac8b",
  "#b2a68f",
  "#a09482",
  "#887b69",
  "#695a47",
  "#cdbea1",
  "#eae1cb",
  "#ddd7c5",
  "#cec8b6",
  "#c5c0b0",
  "#afa791",
  "#9d9885",
  "#88857d",
  "#827e71",
  "#958d45",
  "#c7c176",
  "#b8b395",
  "#b1ae8b",
  "#a6a081",
  "#8d8764",
  "#686747",
  "#5e5d3d",
  "#eee8e8",
  "#f2ebea",
  "#eae1dd",
  "#e8e4e0",
  "#e7e7e6",
  "#e7e7e6",
  "#e6e9e9",
  "#e6ddd6",
  "#ede7e0",
  "#f8f4ed",
  "#f4f2ec",
  "#f3e6e4",
  "#f7e3df",
  "#f8e7df",
  "#f9f0e6",
  "#f4ede9",
  "#f8f1eb",
  "#f1ede7",
  "#f9e8d8",
  "#f7ebdd",
  "#bbafc1",
  "#9e90a7",
  "#84758c",
  "#6f5f70",
  "#62515b",
  "#d8c8d1",
  "#b9a1ae",
  "#9d8292",
  "#876c7a",
  "#705660",
  "#e9dbdf",
  "#e2d0d6",
  "#ceb3be",
  "#bfa1ad",
  "#ac8a98",
  "#916b77",
  "#744e5b",
  "#e9d3d4",
  "#dcbbbe",
  "#d3adb1",
  "#bd9095",
  "#a67577",
  "#905d5f",
  "#744543",
  "#eed5d4",
  "#e6c4c5",
  "#d6a9ab",
  "#c89697",
  "#b07473",
  "#8d504b",
  "#824942",
  "#e7c8c4",
  "#dcb5b0",
  "#d0a29e",
  "#bb8580",
  "#a26b66",
  "#8a5148",
  "#79483e",
  "#e8c7bf",
  "#dfb7ae",
  "#d3a49a",
  "#c48f85",
  "#995d50",
  "#834c3e",
  "#e2c8bf",
  "#d4b3aa",
  "#c49d93",
  "#ad8177",
  "#8b5e52",
  "#774d41",
  "#eacfc2",
  "#e3c1b3",
  "#d8b0a0",
  "#cea190",
  "#b58271",
  "#a06a56",
  "#8b5643",
  "#e9d5c9",
  "#e0c8b9",
  "#d6b8a7",
  "#bb9683",
  "#a8816f",
  "#926956",
  "#765143",
  "#e8d2c1",
  "#dec0ad",
  "#d0ae9a",
  "#c19c86",
  "#b08872",
  "#976d59",
  "#785240",
  "#ecd9ca",
  "#e2c7b3",
  "#d3b29a",
  "#c39c83",
  "#ae8167",
  "#9b6e57",
  "#855743",
  "#e4d1c0",
  "#dac2af",
  "#c8ab96",
  "#a9856b",
  "#9b775e",
  "#88654d",
  "#e8d0b9",
  "#e3c8b1",
  "#d7b59a",
  "#b99072",
  "#ab7e5e",
  "#986b4d",
  "#eadbc9",
  "#e0ccb6",
  "#d7bea5",
  "#c3a285",
  "#b49073",
  "#9e7454",
  "#8a6347",
  "#f3dfc9",
  "#e9c9a9",
  "#e0bb96",
  "#cc9f76",
  "#9e6e43",
  "#8f623b",
  "#e0c7aa",
  "#d7b999",
  "#c8a481",
  "#b89068",
  "#ad835c",
  "#936c48",
  "#f1dbbf",
  "#ebcfae",
  "#e3c19c",
  "#d3ae85",
  "#c79e73",
  "#b5865a",
  "#a77c57",
  "#efe2cf",
  "#e5d2b9",
  "#d2ba9d",
  "#c1a17f",
  "#b7926b",
  "#a47f59",
  "#96724f",
  "#f3e7d3",
  "#e8d0b2",
  "#d4b28b",
  "#c69c6a",
  "#b18655",
  "#a0764a",
  "#f2e6cf",
  "#e8d2b1",
  "#cbaa7d",
  "#b99563",
  "#ab8452",
  "#977447",
  "#f1e6cf",
  "#e6d3b2",
  "#dbc39b",
  "#caaf81",
  "#af915d",
  "#9d7f4c",
  "#896f40",
  "#efe8d7",
  "#e3d8bf",
  "#d0bf9e",
  "#b19d77",
  "#a18b62",
  "#86714a",
  "#e9e3ce",
  "#dfd5bb",
  "#cec2a1",
  "#b9ac87",
  "#a69872",
  "#928459",
  "#7d7248",
  "#efeeda",
  "#e2e1c6",
  "#d0cda9",
  "#bdb98f",
  "#a39e6c",
  "#8b8757",
  "#79774a",
  "#e5e1cd",
  "#d5d0b4",
  "#c5c0a3",
  "#a7a07e",
  "#8b8561",
  "#777250",
  "#e3e4d2",
  "#d1d2b8",
  "#c3c5a7",
  "#a7a987",
  "#72754f",
  "#e1e2cf",
  "#d7d9c2",
  "#bfc1a2",
  "#a4a783",
  "#898c66",
  "#7d7b55",
  "#6e6f4d",
  "#dfe1d2",
  "#cbcdb9",
  "#bcbfa8",
  "#aaad94",
  "#95987e",
  "#808367",
  "#696e51",
  "#dfe5d7",
  "#ced7c5",
  "#b2bfa6",
  "#9ead92",
  "#889779",
  "#5a6952",
  "#e7eee1",
  "#d5e0cf",
  "#b9cab3",
  "#aabfa5",
  "#88a385",
  "#658362",
  "#4b6443",
  "#d6e1d4",
  "#9db4a0",
  "#849e88",
  "#637c65",
  "#54654f",
  "#d8e5dd",
  "#bcd1c7",
  "#9ab6a9",
  "#84a194",
  "#6a8779",
  "#5c7669",
  "#495a52",
  "#d2e0d9",
  "#b2c7c0",
  "#8ea8a0",
  "#77928a",
  "#627b72",
  "#c8ddda",
  "#b8d1d0",
  "#a2c1c0",
  "#7ba0a0",
  "#658a8a",
  "#3f5052",
  "#cde0e1",
  "#bfd6d9",
  "#a9c6cb",
  "#648d95",
  "#4d7179",
  "#245b61",
  "#bcd9e0",
  "#a6ccd6",
  "#8dbbc9",
  "#74a9b9",
  "#508a9a",
  "#3b6a7a",
  "#395865",
  "#c2d5da",
  "#b0c8d0",
  "#9ab6c0",
  "#7d9da9",
  "#60818e",
  "#4e6975",
  "#4a585f",
  "#c3dae0",
  "#accad5",
  "#97bbc8",
  "#75a0b1",
  "#588496",
  "#466c7c",
  "#435964",
  "#d7e8ec",
  "#bcd8e2",
  "#93bdcf",
  "#679bb3",
  "#50859e",
  "#3d6d84",
  "#3a5e73",
  "#c2d8e3",
  "#9dbbcd",
  "#8aaec3",
  "#658faa",
  "#4f6f85",
  "#435a6f",
  "#afc2cf",
  "#99adbd",
  "#7b90a2",
  "#667b8e",
  "#566777",
  "#48505d",
  "#ced9e1",
  "#9eb2c3",
  "#70869d",
  "#5c7186",
  "#434d5c",
  "#a0b2c8",
  "#8397b1",
  "#6d829d",
  "#536078",
  "#40495b",
  "#d4d8e3",
  "#b7bdd1",
  "#a8afc7",
  "#9097b4",
  "#7e85a3",
  "#616b89",
  "#d1d4db",
  "#bfc2ce",
  "#aeb2c0",
  "#8c90a3",
  "#73788b",
  "#5c6070",
  "#dbd9e1",
  "#ccc9d7",
  "#b8b3c8",
  "#9c96af",
  "#87819b",
  "#6f697e",
  "#5e5967",
  "#5a4943",
  "#f8f9f3",
  "#f3ddbc",
  "#fce8ca",
  "#fcefd2",
  "#f6ead2",
  "#f2ead5",
  "#f7f2e3",
  "#f9f7ec",
  "#d4c5ac",
  "#e0d8c5",
  "#edebeb",
  "#c7c3b9",
  "#657d85",
  "#d4dddd",
  "#5c5d5d",
  "#cfc9bc",
  "#605c58",
  "#a99f97",
  "#5e5241",
  "#706d5e",
  "#d4dddd",
  "#efeae7",
  "#a9586c",
  "#f1ede5",
  "#f2eede",
  "#b8a47a",
  "#e6c26f",
  "#8c8449",
  "#b4d0d9",
  "#334b58",
  "#d8e4e8",
  "#bed1e1",
  "#4f84af",
  "#dde0ea",
  "#f3d8e0",
  "#ac3e5f",
  "#d45871",
  "#f2dbdb",
  "#e1b270",
  "#c1e089",
  "#ddeee2",
  "#c6e4eb",
  "#ccdfe8",
  "#6274ab",
  "#795088",
  "#a54f5d",
  "#d3d1be",
  "#f4e4d9",
  "#eee8dd",
  "#e9e5d8",
  "#f1ebe1",
  "#f0ebe1",
  "#f3ebdc",
  "#e9e0cf",
  "#f4eedf",
  "#f3ecd9",
  "#f1ead8",
  "#eee4cf",
  "#f6f4ea",
  "#f4efe3",
  "#f1e7cc",
  "#efe7d3",
  "#f7f2e1",
  "#f7f0df",
  "#eae9e3",
  "#e3e0d7",
  "#e9e7e0",
  "#e4e0d6",
  "#e1e2dd",
  "#dfdeda",
  "#ecf0e9",
  "#e7e7df",
  "#e9e7dd",
  "#dbd4c8",
  "#e7e3d9",
  "#e1e0d6",
  "#e5e2da",
  "#d7d7cd",
  "#e2dfd3",
  "#e8e9e1",
  "#f4e0cf",
  "#efd1bf",
  "#e8c4af",
  "#d9ac97",
  "#c99780",
  "#bc8069",
  "#a36952",
  "#f3e2d7",
  "#f1d8cd",
  "#e6c4b6",
  "#dcb2a2",
  "#c99d91",
  "#a57160",
  "#835246",
  "#f2d2c3",
  "#e6baa9",
  "#d7a697",
  "#cb9686",
  "#b47865",
  "#a76a58",
  "#8d5644",
  "#f7e8df",
  "#f7d7cd",
  "#f2beb4",
  "#d1867e",
  "#b86d64",
  "#8f584e",
  "#8c4944",
  "#eebebb",
  "#d79a99",
  "#c48281",
  "#b76d69",
  "#ae6660",
  "#924145",
  "#914849",
  "#f7dfd8",
  "#e6c6c3",
  "#dfbab7",
  "#d0a4a3",
  "#bb8a8a",
  "#9f6c69",
  "#7f534b",
  "#f7e7e4",
  "#e5c9c9",
  "#ddb9bd",
  "#caa1a6",
  "#bf8e92",
  "#99686b",
  "#784f4b",
  "#f2d6d6",
  "#ebcbce",
  "#e4bdc2",
  "#d7a5ad",
  "#c48a96",
  "#a76c76",
  "#824f52",
  "#eabcbf",
  "#d7a9b0",
  "#c89499",
  "#b07579",
  "#a66a6c",
  "#88585a",
  "#7c464a",
  "#f2e1de",
  "#e1c4c6",
  "#be9ca4",
  "#a68088",
  "#8e666a",
  "#7c484b",
  "#6d4643",
  "#dbbac1",
  "#d4b0b7",
  "#c49ea8",
  "#ae828d",
  "#93656b",
  "#7f4e59",
  "#67454a",
  "#ebc9ce",
  "#e3b9c0",
  "#cfa6b0",
  "#b78996",
  "#9f6f78",
  "#784552",
  "#7f444f",
  "#f0d7d2",
  "#e3c0bc",
  "#c99c99",
  "#aa756f",
  "#8b564f",
  "#865045",
  "#814d42",
  "#ede1d8",
  "#e1cbc3",
  "#d6bcb4",
  "#c1a199",
  "#ab8a82",
  "#926e64",
  "#76554a",
  "#eaddd4",
  "#dac4ba",
  "#baa198",
  "#a88f85",
  "#9a7e73",
  "#83675b",
  "#6b5145",
  "#d9c9c0",
  "#cdbcb4",
  "#b8a39a",
  "#a69086",
  "#7f6a60",
  "#6b584f",
  "#524641",
  "#eedfd5",
  "#e7d6cc",
  "#d2bbae",
  "#c8ab9b",
  "#b39383",
  "#977464",
  "#77584b",
  "#ecd9c6",
  "#e3cdb8",
  "#dcc2a9",
  "#cca88c",
  "#b58e73",
  "#a4785b",
  "#89644c",
  "#efe0d0",
  "#e8d0b9",
  "#dec0a8",
  "#cbae97",
  "#b0927a",
  "#a48268",
  "#98765b",
  "#f5e5d1",
  "#e5d0b8",
  "#dbc1a7",
  "#d0b092",
  "#bd9876",
  "#a17a5a",
  "#8a674c",
  "#e1d1bc",
  "#c1ac92",
  "#b19a80",
  "#9f8468",
  "#8e755b",
  "#83684e",
  "#ebe0d3",
  "#dfd2c2",
  "#d8cab8",
  "#cabca9",
  "#baa893",
  "#8e7760",
  "#715f4e",
  "#ede2d4",
  "#ccbdad",
  "#bdad9a",
  "#ae9b88",
  "#907b68",
  "#776353",
  "#776350",
  "#e5e0d5",
  "#dad3c8",
  "#cfc7b9",
  "#c1b8aa",
  "#aa9f8f",
  "#877a69",
  "#665c4f",
  "#ebe8dc",
  "#ded6c9",
  "#d0c9bb",
  "#b9b0a3",
  "#a9a092",
  "#867c6c",
  "#675f53",
  "#ebe7dd",
  "#ddd6cd",
  "#cec8be",
  "#c0b8ab",
  "#aa9f91",
  "#83796c",
  "#685e55",
  "#e6dfd3",
  "#ddd5c7",
  "#d0c7b7",
  "#aaa195",
  "#857b6d",
  "#746a5c",
  "#62584c",
  "#e4e0ce",
  "#e2dbc9",
  "#d8d0bc",
  "#c0b6a0",
  "#b1a793",
  "#8e826e",
  "#6e6352",
  "#e3ded3",
  "#dad4c7",
  "#d1cabc",
  "#c2bbac",
  "#aea391",
  "#8b7e6a",
  "#6c6150",
  "#e8d5bb",
  "#e1c9ac",
  "#d4b799",
  "#bea182",
  "#af8f6d",
  "#a07e5d",
  "#90704f",
  "#ead1ae",
  "#e3c59e",
  "#d3b188",
  "#caa577",
  "#bb9163",
  "#b68c63",
  "#aa815a",
  "#f4e7d0",
  "#efd8ba",
  "#e2c8a6",
  "#dec19c",
  "#d6b68b",
  "#c59e6f",
  "#a77c50",
  "#eadabf",
  "#e3cfb0",
  "#d2bc9f",
  "#bda281",
  "#b19671",
  "#a18560",
  "#90724e",
  "#e5d6bd",
  "#dfccad",
  "#d2bd9c",
  "#bfa57f",
  "#a98960",
  "#8f714a",
  "#856a4b",
  "#e9dfd0",
  "#ddd2be",
  "#d8ccb7",
  "#d1bea0",
  "#bba787",
  "#a58e6c",
  "#8a7454",
  "#e1d4bd",
  "#d5c6ab",
  "#c6b698",
  "#bead8d",
  "#b6a17c",
  "#a28d69",
  "#7a6848",
  "#f0e6d4",
  "#e9dcc6",
  "#dfceb3",
  "#dcc9a5",
  "#c9b28d",
  "#a58d66",
  "#907855",
  "#f2ead7",
  "#e8d8bd",
  "#e1d0b2",
  "#d6c4a2",
  "#c9b38d",
  "#b29c75",
  "#8e764e",
  "#f2e9d6",
  "#eee3cb",
  "#e1d2b2",
  "#bba783",
  "#b29c73",
  "#a08a63",
  "#846f4b",
  "#f2ead6",
  "#f0e4ca",
  "#e0cfa8",
  "#cebc96",
  "#bba87e",
  "#af986b",
  "#907a50",
  "#ebe0c8",
  "#e4d8bd",
  "#dccdae",
  "#d6c7a3",
  "#c4b18a",
  "#ad976c",
  "#8c7952",
  "#ede5d1",
  "#e2d6b8",
  "#d9cca9",
  "#bbab82",
  "#ae9b6f",
  "#928159",
  "#82724e",
  "#ede3d0",
  "#dfd5ba",
  "#d6c9aa",
  "#cec19f",
  "#c1b58f",
  "#9f916b",
  "#7d704f",
  "#e6dfcf",
  "#e1d6c3",
  "#c5bba9",
  "#aea38e",
  "#a1937a",
  "#92856c",
  "#655a48",
  "#e6e1ce",
  "#d6ceba",
  "#cec6b1",
  "#c7bea5",
  "#b6ac91",
  "#978a6c",
  "#706750",
  "#dcd6c1",
  "#d0c8b1",
  "#c3baa2",
  "#a99d82",
  "#958c71",
  "#7e7254",
  "#786f51",
  "#f4f2e9",
  "#edeade",
  "#dedccd",
  "#c8c2ac",
  "#a39a7a",
  "#8e8363",
  "#786f52",
  "#eee9da",
  "#e1dac5",
  "#cfc7ab",
  "#a3997b",
  "#938865",
  "#837a5b",
  "#7a7050",
  "#dcdacd",
  "#cac7b7",
  "#c1c1b1",
  "#aea994",
  "#938f77",
  "#74705a",
  "#6a654b",
  "#e9e4d4",
  "#d3ceb8",
  "#c9c3ab",
  "#a29e87",
  "#918c72",
  "#847e64",
  "#756c4e",
  "#eee7cf",
  "#ece4ca",
  "#ddd2ac",
  "#d0c497",
  "#bcaf7a",
  "#afa16b",
  "#7c7147",
  "#eeead7",
  "#e7dfc2",
  "#ded6b3",
  "#cdc4a0",
  "#beb58c",
  "#b2a775",
  "#7e7546",
  "#edebd5",
  "#dfdab6",
  "#d3cda3",
  "#c4bd92",
  "#b2aa7c",
  "#99915f",
  "#877e4e",
  "#e4e5d0",
  "#dbddc4",
  "#d0d3b6",
  "#c2c5a4",
  "#b6b993",
  "#949569",
  "#6e6f4d",
  "#f3f2e9",
  "#eeede1",
  "#dfdfd1",
  "#c6c8b1",
  "#a1a282",
  "#858665",
  "#686b4b",
  "#ebe8dd",
  "#dad7c9",
  "#c4c0b0",
  "#aaab9e",
  "#97998b",
  "#707061",
  "#605e50",
  "#e1e2d2",
  "#d5d8c8",
  "#bbc3ad",
  "#959c81",
  "#7e856a",
  "#5f634f",
  "#4f5245",
  "#ededdf",
  "#d9decc",
  "#c2cbb3",
  "#9da691",
  "#878f77",
  "#767f67",
  "#616650",
  "#e2e5de",
  "#ced2cb",
  "#aeb5ad",
  "#888f85",
  "#666559",
  "#5d594d",
  "#575146",
  "#e9ece5",
  "#d9dcd6",
  "#bec4be",
  "#9ca299",
  "#737367",
  "#5e5c50",
  "#514d41",
  "#d6dcd1",
  "#ccd4c9",
  "#c2ccbf",
  "#a9b6a8",
  "#97a697",
  "#758374",
  "#576256",
  "#dcdfd6",
  "#ced6cd",
  "#bec9bf",
  "#a8b5ac",
  "#93a39b",
  "#6d7e75",
  "#525a53",
  "#e6eae3",
  "#d9e3dd",
  "#c1d3cd",
  "#afc3bf",
  "#809696",
  "#5f7472",
  "#3c5052",
  "#d6ddd5",
  "#cad2cd",
  "#bbc6bf",
  "#aeb8b3",
  "#929e9a",
  "#6e7673",
  "#59615e",
  "#dbe4dc",
  "#c9d6d1",
  "#b2c3c2",
  "#9eb1b0",
  "#899f9f",
  "#667879",
  "#4f5d5d",
  "#c5cecb",
  "#b9c5c2",
  "#9facad",
  "#839294",
  "#707e7d",
  "#626f70",
  "#464b4b",
  "#d9e4df",
  "#c1d2d1",
  "#b3c7c8",
  "#96aeb2",
  "#839ca2",
  "#60757a",
  "#485559",
  "#d7dcdd",
  "#bec9ce",
  "#a0b2bc",
  "#8e9ca7",
  "#768691",
  "#67737c",
  "#525356",
  "#e2e3e0",
  "#c9ccce",
  "#acb2b7",
  "#939ba4",
  "#6f767d",
  "#5d636b",
  "#3e3f40",
  "#dddcdb",
  "#d1d0d1",
  "#b9b9be",
  "#a1a5ad",
  "#7f848f",
  "#71737c",
  "#48474b",
  "#e5e4df",
  "#cccecd",
  "#b8bcbc",
  "#9da3a7",
  "#848a8d",
  "#696d6f",
  "#474848",
  "#d5d4d0",
  "#c9c8c4",
  "#b9b8b5",
  "#a2a3a2",
  "#848586",
  "#636463",
  "#4f4e4c",
  "#e1dfd9",
  "#d7d3ce",
  "#c7c5c1",
  "#b5b3b0",
  "#a0a09f",
  "#868585",
  "#4c4946",
  "#e2dcd6",
  "#d9d6d3",
  "#c8c8c6",
  "#b1aeae",
  "#9f9c9c",
  "#7a7473",
  "#655a56",
  "#cbc6c3",
  "#beb8b6",
  "#b5afab",
  "#9c9898",
  "#807c7d",
  "#67615f",
  "#524b48",
  "#efebe1",
  "#ddd6cb",
  "#d4cabe",
  "#b0a89e",
  "#969088",
  "#857e74",
  "#645b4e",
  "#e9e3da",
  "#cfc7bd",
  "#c6beb2",
  "#a7a198",
  "#867f73",
  "#756d63",
  "#5a554a",
  "#d5d2c8",
  "#c2bcb0",
  "#a7a59d",
  "#8b8981",
  "#7a776c",
  "#737065",
  "#565148",
  "#d9d9d2",
  "#c4c5bc",
  "#b6b9b0",
  "#858984",
  "#73766f",
  "#666963",
  "#54544e",
  "#dde2e6",
  "#c4d1e0",
  "#aabbd3",
  "#8196b4",
  "#677b9b",
  "#617696",
  "#49536b",
  "#c6d3e5",
  "#b3c6e0",
  "#a7bcdc",
  "#99afd2",
  "#7c98c3",
  "#607cab",
  "#344c84",
  "#ebeceb",
  "#dbe3ec",
  "#c6d5ea",
  "#aac0e3",
  "#98aedb",
  "#5874b4",
  "#43487d",
  "#d5e1ed",
  "#bdd2ea",
  "#a0bde4",
  "#8faedc",
  "#7296cf",
  "#547dbd",
  "#41518e",
  "#c8d8e4",
  "#b6cbde",
  "#a1bdd7",
  "#87a4c0",
  "#7192b4",
  "#4f6e90",
  "#414b61",
  "#d3dddf",
  "#c7d3da",
  "#b7c8d3",
  "#9eb0c0",
  "#8b9eb3",
  "#64768b",
  "#4f5b6e",
  "#dee3e0",
  "#c8d4d8",
  "#b5c6cf",
  "#99afbc",
  "#859dad",
  "#5d7585",
  "#4b5c6a",
  "#e1ebea",
  "#c6deec",
  "#aacfeb",
  "#8dbfe6",
  "#6ea7db",
  "#387ec2",
  "#335392",
  "#ccdce1",
  "#bcd2dd",
  "#adc6d6",
  "#91b3ce",
  "#7ba0c1",
  "#557ea2",
  "#425e79",
  "#d9e3e2",
  "#bfd7e1",
  "#adcedd",
  "#92bad1",
  "#73a3c2",
  "#4a7fa0",
  "#395e7a",
  "#dfeceb",
  "#c3e4eb",
  "#9ed6e7",
  "#7bc8e2",
  "#5bb4d5",
  "#37a5cb",
  "#0a5b7e",
  "#e8eeea",
  "#cfe3e4",
  "#bdd9de",
  "#92b9c4",
  "#6b9ca8",
  "#4e828d",
  "#3e5c64",
  "#e2f0eb",
  "#c4e9e3",
  "#9ad9e2",
  "#6cc4d3",
  "#2eadc2",
  "#0096ab",
  "#006381",
  "#cfeee8",
  "#bfe9e4",
  "#a5e3e0",
  "#7ed8d7",
  "#28b7b8",
  "#00a4a3",
  "#006d6e",
  "#e1eee7",
  "#d7e9e4",
  "#b8ddda",
  "#91c2c3",
  "#5f9e9d",
  "#488786",
  "#2d5c62",
  "#def1e9",
  "#bee9e0",
  "#90dacf",
  "#7bcbc1",
  "#50b5aa",
  "#289f90",
  "#206d63",
  "#e4ece1",
  "#c5d9d1",
  "#b8d1c7",
  "#a8c3b9",
  "#91afa4",
  "#6d8c80",
  "#546d61",
  "#d5ebe0",
  "#bae1d2",
  "#a8d7c6",
  "#96c6b6",
  "#72ac98",
  "#55927a",
  "#2d5c4f",
  "#daf1e2",
  "#c0e9d7",
  "#afe4cc",
  "#88cfaf",
  "#62b992",
  "#40a374",
  "#227654",
  "#e2efdf",
  "#d8ebd8",
  "#c8e5cd",
  "#abd6b4",
  "#7eb086",
  "#689b6c",
  "#578153",
  "#ebf1e3",
  "#daeed6",
  "#addeb3",
  "#9ecfa2",
  "#7fbb81",
  "#61a462",
  "#3d8145",
  "#dfecd9",
  "#c4dcc9",
  "#bed9c3",
  "#a3c6ac",
  "#8eb597",
  "#6e9675",
  "#4f6a4e",
  "#e1e6d3",
  "#cfd9c4",
  "#becdb6",
  "#b0c4a9",
  "#9baf91",
  "#809675",
  "#5d6c50",
  "#e9ebd8",
  "#d3dcc3",
  "#c7d1b5",
  "#bec8a6",
  "#aeba95",
  "#8c9a70",
  "#65704d",
  "#e9edd9",
  "#ceddbc",
  "#c3d6b2",
  "#bcd0a8",
  "#a5bd8e",
  "#8ba874",
  "#6d8553",
  "#e4efd8",
  "#d1e8c4",
  "#c0e0b3",
  "#b7d6a4",
  "#96c184",
  "#81ae66",
  "#639049",
  "#eff1dc",
  "#e4eec9",
  "#d6e8b5",
  "#c4db9c",
  "#afcd7f",
  "#99bd5f",
  "#7aa542",
  "#edeeca",
  "#e5eaba",
  "#e0e6af",
  "#d2db94",
  "#c5ce7f",
  "#aab85b",
  "#96a440",
  "#e8eace",
  "#d9ddb7",
  "#cfd4a6",
  "#bec48c",
  "#a7ab6b",
  "#949b59",
  "#7d8447",
  "#eae6c8",
  "#e0dfbb",
  "#d8d5a9",
  "#cac68c",
  "#bdb86c",
  "#aba857",
  "#8f9046",
  "#f4efd3",
  "#efe9c0",
  "#ede3af",
  "#e1d593",
  "#ccbd68",
  "#bcab51",
  "#a79a45",
  "#f8f2d3",
  "#f4e5b7",
  "#efdea4",
  "#e7d190",
  "#d8b966",
  "#ccad54",
  "#be9e43",
  "#f5eecf",
  "#f3e5b9",
  "#f2dfa8",
  "#ecd38b",
  "#ebcc76",
  "#e0be62",
  "#cfa541",
  "#f6f2da",
  "#f7f2d7",
  "#f9f0c7",
  "#fbe29b",
  "#f7d67a",
  "#f3c854",
  "#e8b229",
  "#f6f3d9",
  "#f8f2d2",
  "#faf0c2",
  "#faefbb",
  "#fce28e",
  "#f7cd58",
  "#f1b837",
  "#f8efcb",
  "#f8ecb0",
  "#f9e89e",
  "#fce589",
  "#f6d862",
  "#f3cd47",
  "#f0c32f",
  "#f8f4dc",
  "#fbf1c4",
  "#fdeea5",
  "#fae16a",
  "#f7d22d",
  "#f0ca14",
  "#edc80c",
  "#f7f4dd",
  "#f9f2c8",
  "#faf1b9",
  "#fdee9b",
  "#ffea81",
  "#ffe04d",
  "#ffd328",
  "#f7f5e5",
  "#f7f1d5",
  "#fbefc5",
  "#ffe79d",
  "#ffdf7b",
  "#ffd046",
  "#ffc100",
  "#f8efd2",
  "#f9e8ba",
  "#f9e4a9",
  "#f7d98d",
  "#e9c062",
  "#dfb24f",
  "#d0a43f",
  "#f3ebd2",
  "#f1e4bf",
  "#eddaad",
  "#e0cb9b",
  "#c3a767",
  "#ba9d60",
  "#a88846",
  "#f8e7c9",
  "#f4e1be",
  "#f0ddba",
  "#dfc595",
  "#d0b179",
  "#c2a167",
  "#ac8950",
  "#f1e4c8",
  "#ead8b4",
  "#e8d4ab",
  "#dcc699",
  "#caae78",
  "#b5975d",
  "#9a804c",
  "#f0e4c9",
  "#e9dbc1",
  "#e8d6b0",
  "#d4b88b",
  "#c1a271",
  "#b39465",
  "#9a7c4d",
  "#f5ead1",
  "#f4e0bf",
  "#edd3ac",
  "#dfbe8b",
  "#d3ac73",
  "#bc9354",
  "#af864d",
  "#f6eeda",
  "#f5dfb9",
  "#f3d5a6",
  "#efd29d",
  "#e7c38a",
  "#d6aa64",
  "#b78944",
  "#f7f0dd",
  "#f9e6c1",
  "#f8dca9",
  "#efc689",
  "#e5b875",
  "#d7a458",
  "#c79244",
  "#f8ebd1",
  "#f8e7c9",
  "#f0d7ac",
  "#ebd2a8",
  "#e5c694",
  "#caa367",
  "#b5884d",
  "#f6eed8",
  "#fce4b6",
  "#f9daa3",
  "#f6d398",
  "#f0c985",
  "#e0b05d",
  "#c59442",
  "#f6f3e5",
  "#f6f0d9",
  "#faebc0",
  "#f8d898",
  "#eec377",
  "#e0b057",
  "#d09c3c",
  "#f9f2d9",
  "#fbf1d1",
  "#fee2a4",
  "#ffd98e",
  "#feca67",
  "#f9b945",
  "#eca72a",
  "#f9f0d0",
  "#fcedc2",
  "#fde9ae",
  "#ffe298",
  "#ffd269",
  "#ffc63c",
  "#ffb305",
  "#f7f2db",
  "#faefc2",
  "#fee59f",
  "#ffd368",
  "#ffc137",
  "#ffb428",
  "#fdab25",
  "#f8f2df",
  "#fbebc6",
  "#ffdea2",
  "#ffd185",
  "#ffc36a",
  "#ffb144",
  "#ff9a29",
  "#fbebcf",
  "#fce8c5",
  "#ffdbaa",
  "#ffd49f",
  "#ffb46e",
  "#f98433",
  "#f9e9d0",
  "#fcddb9",
  "#ffcfa1",
  "#febb83",
  "#faac6c",
  "#f99e59",
  "#ef8945",
  "#f8e5cb",
  "#fddfba",
  "#fdd4a9",
  "#f9c595",
  "#efaf78",
  "#e69c5a",
  "#d38643",
  "#f8f0e1",
  "#f8e5cc",
  "#f4d4ae",
  "#e8b984",
  "#d2985a",
  "#c4894f",
  "#bf8249",
  "#f5e3d0",
  "#f8ddc5",
  "#f4d3b7",
  "#e9c09a",
  "#d7a070",
  "#cf9561",
  "#b37c4a",
  "#f6e8d7",
  "#f4ddc4",
  "#f3d3b5",
  "#deb899",
  "#d6ab88",
  "#c08a64",
  "#aa724f",
  "#f2d8bf",
  "#f0ccaf",
  "#ecc6a6",
  "#dfb393",
  "#cd9875",
  "#b77c57",
  "#a06846",
  "#f7e6d3",
  "#f8dcc7",
  "#f5d4bd",
  "#eeb792",
  "#da966c",
  "#d08b60",
  "#b57248",
  "#f4f0e4",
  "#f9ebda",
  "#fcd9bd",
  "#fecfaf",
  "#f3a67d",
  "#e79060",
  "#cd6e44",
  "#f6f0e2",
  "#faead6",
  "#fde4cb",
  "#ffc299",
  "#ffa97a",
  "#fd9158",
  "#e77741",
  "#f7d1b7",
  "#f4c7ab",
  "#efb597",
  "#e29c7b",
  "#d17f58",
  "#ad674a",
  "#9b5244",
  "#fbe8d8",
  "#ffdec9",
  "#ffd2ba",
  "#ffb99e",
  "#fca080",
  "#f88760",
  "#ed6641",
  "#f9e3d9",
  "#fad2c4",
  "#f7c7b6",
  "#efb3a0",
  "#dc8971",
  "#ac5844",
  "#a45849",
  "#f1e7de",
  "#f8e0d3",
  "#f2c8b6",
  "#e9ad99",
  "#db9b8a",
  "#c57f6d",
  "#8e4b3f",
  "#f9ebe2",
  "#fdd5c7",
  "#f6b4a5",
  "#ef9e8d",
  "#e2816a",
  "#c0594b",
  "#be5d4c",
  "#fae2d7",
  "#f9ddd5",
  "#f7cfc7",
  "#edb1a9",
  "#da8d80",
  "#cc796b",
  "#ac594b",
  "#f8ece6",
  "#fbe2de",
  "#ffcbc9",
  "#ffb1b0",
  "#f89596",
  "#de4f46",
  "#c24044",
  "#f8e8df",
  "#fbd7d3",
  "#fccbc9",
  "#f7a6a4",
  "#e9827f",
  "#df726d",
  "#bf4d47",
  "#f8dad6",
  "#f7cdcd",
  "#f2bcc0",
  "#eba3aa",
  "#da868c",
  "#b35250",
  "#a24e4d",
  "#f6c1c8",
  "#f3b0ba",
  "#e5848e",
  "#d56069",
  "#c74a4a",
  "#bc484e",
  "#a74c53",
  "#fbe4e6",
  "#ffd8e0",
  "#fec0ce",
  "#f891a9",
  "#f1758d",
  "#ce3a3e",
  "#b53f43",
  "#fae4e5",
  "#fcdce0",
  "#fccbd2",
  "#fcbbc5",
  "#ef91a0",
  "#c43944",
  "#a23d40",
  "#f7ebec",
  "#f7dbe3",
  "#f8d1e0",
  "#f5bdd4",
  "#f2adc9",
  "#dd6c96",
  "#9f3949",
  "#f7e2e6",
  "#f3ccd7",
  "#e5a4ba",
  "#d17c94",
  "#af5161",
  "#a8455e",
  "#aa446a",
  "#f5c6d2",
  "#f3bdcb",
  "#e8a1b5",
  "#ce798f",
  "#974851",
  "#9e4a52",
  "#984245",
  "#f6dde0",
  "#f5d2d7",
  "#f3c4cd",
  "#e2a0ae",
  "#d78c9b",
  "#be6471",
  "#a63b49",
  "#f5e8ea",
  "#f4dbe3",
  "#eeccdb",
  "#ecc1d5",
  "#dba9c4",
  "#b77494",
  "#894565",
  "#f5ecec",
  "#f4e1ea",
  "#f3cde5",
  "#f0bcdf",
  "#e59dcb",
  "#d772af",
  "#a33d65",
  "#f4e1eb",
  "#f2d8e8",
  "#edc7e1",
  "#d8a6ce",
  "#cc94c1",
  "#b471a5",
  "#70435a",
  "#eddce0",
  "#e0c6d6",
  "#dbb6cd",
  "#bd8cad",
  "#a8789c",
  "#966284",
  "#684b5b",
  "#f3ecea",
  "#f2dfe9",
  "#edcee5",
  "#e6bee0",
  "#c393c7",
  "#b078b1",
  "#6e496e",
  "#eedbe7",
  "#e7cfe4",
  "#debedd",
  "#cbaad0",
  "#b692be",
  "#a47dac",
  "#644466",
  "#eddcea",
  "#e6d0e7",
  "#ddc1e2",
  "#cbaed7",
  "#b493c8",
  "#9872af",
  "#694a73",
  "#ede3e7",
  "#e2cddc",
  "#d7bbd1",
  "#c3afc5",
  "#ae95b1",
  "#947795",
  "#614c5f",
  "#efdedf",
  "#e0c8d5",
  "#d8bbcd",
  "#b38fab",
  "#9f7b9b",
  "#8b6885",
  "#634e60",
  "#eadade",
  "#dec9d1",
  "#d3b9c5",
  "#bea5b5",
  "#a28698",
  "#846778",
  "#54454f",
  "#ede3df",
  "#e2d4d6",
  "#d6c7cc",
  "#c5afba",
  "#b69eab",
  "#8f7683",
  "#5e4a52",
  "#e9dfe5",
  "#d6c7d5",
  "#bca9c0",
  "#97819b",
  "#675569",
  "#564954",
  "#4d4449",
  "#eee7e8",
  "#eae0e7",
  "#e2d6e4",
  "#d1c0dc",
  "#c0b0cf",
  "#a694bc",
  "#624d6c",
  "#ebe5eb",
  "#e4dbea",
  "#dacee7",
  "#cdbde2",
  "#b6a8d5",
  "#a797cb",
  "#604d7a",
  "#e2dfe7",
  "#d9d5e4",
  "#cac6df",
  "#a3a0c8",
  "#9593bd",
  "#78739f",
  "#574e70",
  "#d9d0e2",
  "#cfc3dc",
  "#b9b1ce",
  "#a49ec8",
  "#a098c5",
  "#8275ab",
  "#574c71",
  "#e3e3ea",
  "#dadaea",
  "#bfbfe4",
  "#a9aad7",
  "#9092ca",
  "#7173b3",
  "#555283",
  "#f1efeb",
  "#e4e3eb",
  "#ccd0e6",
  "#bac0e4",
  "#8792cb",
  "#7179b8",
  "#4a4779",
  "#e9e8e5",
  "#ccd0e2",
  "#bec5de",
  "#abb2d7",
  "#98a0cc",
  "#717ab0",
  "#5b6196",
  "#e1dce3",
  "#d4cddb",
  "#bfb9cd",
  "#a6a4ba",
  "#9896ae",
  "#6d6983",
  "#514c5b",
  "#e8e2e5",
  "#cac2d0",
  "#b7b0c3",
  "#9e96ab",
  "#8e859b",
  "#81788d",
  "#5a505e",
  "#e1d9e3",
  "#dbd5df",
  "#d1c9d7",
  "#bcb4ca",
  "#aca2bd",
  "#857a9b",
  "#625165",
  "#ece3e2",
  "#e5dada",
  "#bdb1bc",
  "#a194a1",
  "#92838e",
  "#80717c",
  "#5b4a57",
  "#e6e1de",
  "#daced4",
  "#cdc0c9",
  "#bfb1bd",
  "#a89aaa",
  "#817180",
  "#594f58",
  "#d9d8da",
  "#cfced3",
  "#c0bfc7",
  "#b1b1bb",
  "#9b9daa",
  "#6f7280",
  "#5d5e6a",
  "#e9ddcc",
  "#ffa04f",
  "#dec8ae",
  "#ffbe82",
  "#79e3b7",
  "#b8cecc",
  "#d6a65f",
  "#000000",
  "#dbbc87",
  "#f0dcb9",
  "#ffffff",
  "#ffdd5a",
  "#fff636",
  "#d5f47b",
  "#941928",
  "#fbe145",
  "#fdf882",
  "#fce271",
  "#fcfb86",
  "#9a8ac1",
  "#936baa",
  "#715f9e",
  "#f8ac2f",
  "#f09053",
  "#baca40",
  "#d6692b",
  "#8bb747",
  "#8ed564",
  "#1a88be",
  "#257ac5",
  "#1c4089",
  "#cb6b67",
  "#c22c38",
  "#7f969c",
  "#bdefd2",
  "#d3947a",
  "#f8ffd1",
  "#f2e9bd",
  "#b0c191",
  "#868681",
  "#969955",
  "#e08975",
  "#ede0bd",
  "#654449",
  "#765054",
  "#6c4140",
  "#7e504c",
  "#87585a",
  "#926668",
  "#78423f",
  "#8b4241",
  "#9b4744",
  "#844e4a",
  "#9a524b",
  "#8e564d",
  "#a65849",
  "#cb6955",
  "#dda262",
  "#ba7947",
  "#f7eed1",
  "#fbe7b7",
  "#f2e5b8",
  "#fce3a8",
  "#fad99f",
  "#e9cb99",
  "#d5b991",
  "#cb9850",
  "#d7b557",
  "#c69e39",
  "#b78340",
  "#a2774a",
  "#b49a50",
  "#b49769",
  "#a58d67",
  "#f0ceb1",
  "#eed4c2",
  "#e2c6b8",
  "#e4c7b3",
  "#dbc1a8",
  "#d0b096",
  "#cfa998",
  "#d0a994",
  "#bbc9ca",
  "#b0c4c5",
  "#a4b9b6",
  "#94afb5",
  "#a9cddd",
  "#9ca8ab",
  "#769cac",
  "#7d9193",
  "#839599",
  "#5f7276",
  "#597a8a",
  "#60747e",
  "#69acd9",
  "#005f97",
  "#484e62",
  "#366f8e",
  "#266576",
  "#0574b5",
  "#276ca6",
  "#4b5866",
  "#3b4167",
  "#495c61",
  "#485a62",
  "#67636f",
  "#55414c",
  "#4e4353",
  "#564247",
  "#bfccc2",
  "#c7d1bc",
  "#d4d4b7",
  "#a9c5b9",
  "#c8c8a3",
  "#adb7aa",
  "#91a69d",
  "#a6cdac",
  "#85a493",
  "#90b0a4",
  "#809f98",
  "#96ad89",
  "#8ab492",
  "#9c9e86",
  "#8f9b82",
  "#5e7866",
  "#69b3ae",
  "#618265",
  "#00827c",
  "#39836a",
  "#009081",
  "#757965",
  "#6c6954",
  "#5f6b63",
  "#636855",
  "#5a6c5b",
  "#416052",
  "#4e5749",
  "#455752",
  "#595e58",
  "#494b48",
  "#384d4d",
  "#504e48",
  "#3c3e3f",
  "#e2d9c5",
  "#d8cebf",
  "#e7d7c0",
  "#d8ccb4",
  "#c8c0af",
  "#b2a899",
  "#bdb9a8",
  "#bfbaac",
  "#b4aa8c",
  "#a99e87",
  "#b8a685",
  "#a2978a",
  "#87816d",
  "#8e7d65",
  "#7a756a",
  "#8b816d",
  "#7d7869",
  "#595752",
  "#b49c81",
  "#a99786",
  "#c7a985",
  "#9d8f75",
  "#a18461",
  "#9e8461",
  "#b58f73",
  "#8d7158",
  "#937a64",
  "#7e7162",
  "#7f7567",
  "#847262",
  "#695c49",
  "#785947",
  "#624541",
  "#896056",
  "#7f5f52",
  "#796451",
  "#736459",
  "#745d53",
  "#6b5851",
  "#645852",
  "#51443f",
  "#b3b4af",
  "#abb2ae",
  "#7b827d",
  "#7f7e78",
  "#64625f",
  "#656a6b",
  "#4c565d",
  "#ff9d00",
  "#87bd53",
  "#876248",
  "#c6ceed",
  "#cdf9d8",
  "#49caed",
  "#ffd467",
  "#eee2b9",
  "#ffbf96",
  "#f1c79a",
  "#ac3c40",
  "#cd8657",
  "#005ba5",
  "#4a3b3a",
  "#fff28c",
  "#fdfbce",
  "#84463b",
  "#518b68",
  "#ffffff",
  "#1a5a44",
  "#007c7f",
  "#b3a5a2",
  "#bfe2d7",
  "#c0dbd7",
  "#eee8dd",
  "#e9e5d8",
  "#f1ebe1",
  "#f0ebe1",
  "#f3ebdc",
  "#e9e0cf",
  "#f4eedf",
  "#f3ecd9",
  "#f1ead8",
  "#eee4cf",
  "#f6f4ea",
  "#f4efe3",
  "#f1e7cc",
  "#efe7d3",
  "#f7f2e1",
  "#f7f0df",
  "#ebe8e1",
  "#e3e0d7",
  "#e9e7e0",
  "#e4e0d6",
  "#e1e2dd",
  "#dfdeda",
  "#ecf0e9",
  "#e7e7df",
  "#e9e7dd",
  "#dbd4c8",
  "#e1e0d6",
  "#e5e2da",
  "#d7d7cd",
  "#e2dfd3",
  "#e8e9e1",
  "#f4e0cf",
  "#efd1bf",
  "#e8c4af",
  "#d9ac97",
  "#c99780",
  "#bc8069",
  "#a36952",
  "#f3e2d7",
  "#f1d8cd",
  "#e6c4b6",
  "#dcb2a2",
  "#c99d91",
  "#a57160",
  "#835246",
  "#f2d2c3",
  "#e6baa9",
  "#d7a697",
  "#cb9686",
  "#b47865",
  "#a76a58",
  "#8d5644",
  "#f7e8df",
  "#f7d7cd",
  "#f2beb4",
  "#d1867e",
  "#b86d64",
  "#8f584e",
  "#8c4944",
  "#eebebb",
  "#d79a99",
  "#c48281",
  "#b76d69",
  "#ae6660",
  "#924145",
  "#914849",
  "#f7dfd8",
  "#e6c6c3",
  "#dfbab7",
  "#d0a4a3",
  "#bb8a8a",
  "#9f6c69",
  "#7f534b",
  "#f7e7e4",
  "#e5c9c9",
  "#ddb9bd",
  "#caa1a6",
  "#bf8e92",
  "#99686b",
  "#784f4b",
  "#f2d6d6",
  "#ebcbce",
  "#e4bdc2",
  "#d7a5ad",
  "#c48a96",
  "#a76c76",
  "#824f52",
  "#eabcbf",
  "#d7a9b0",
  "#c89499",
  "#b07579",
  "#a66a6c",
  "#88585a",
  "#7c464a",
  "#f2e1de",
  "#e1c4c6",
  "#be9ca4",
  "#a68088",
  "#7c484b",
  "#6d4643",
  "#dbbac1",
  "#d4b0b7",
  "#c49ea8",
  "#ae828d",
  "#93656b",
  "#7f4e59",
  "#67454a",
  "#ebc9ce",
  "#e3b9c0",
  "#cfa6b0",
  "#b78996",
  "#9f6f78",
  "#784552",
  "#7f444f",
  "#f0d7d2",
  "#e3c0bc",
  "#c99c99",
  "#aa756f",
  "#8b564f",
  "#865045",
  "#814d42",
  "#ede1d8",
  "#e1cbc3",
  "#d6bcb4",
  "#c1a199",
  "#ab8a82",
  "#926e64",
  "#76554a",
  "#eaddd4",
  "#baa198",
  "#a88f85",
  "#9a7e73",
  "#83675b",
  "#6b5145",
  "#d9c9c0",
  "#cdbcb4",
  "#b8a39a",
  "#a69086",
  "#7f6a60",
  "#6b584f",
  "#eedfd5",
  "#e7d6cc",
  "#d2bbae",
  "#c8ab9b",
  "#b39383",
  "#977464",
  "#77584b",
  "#ecd9c6",
  "#e3cdb8",
  "#dcc2a9",
  "#cca88c",
  "#b58e73",
  "#a4785b",
  "#89644c",
  "#efe0d0",
  "#e8d0b9",
  "#dec0a8",
  "#cbae97",
  "#b0927a",
  "#a48268",
  "#98765b",
  "#f5e5d1",
  "#e5d0b8",
  "#dbc1a7",
  "#d0b092",
  "#bd9876",
  "#a17a5a",
  "#8a674c",
  "#e9ddcc",
  "#e1d1bc",
  "#c1ac92",
  "#b19a80",
  "#9f8468",
  "#8e755b",
  "#83684e",
  "#ebe0d3",
  "#dfd2c2",
  "#d8cab8",
  "#cabca9",
  "#baa893",
  "#8e7760",
  "#ede2d4",
  "#ccbdad",
  "#bdad9a",
  "#ae9b88",
  "#907b68",
  "#776353",
  "#776350",
  "#e5e0d5",
  "#dad3c8",
  "#cfc7b9",
  "#c1b8aa",
  "#aa9f8f",
  "#877a69",
  "#ebe8dc",
  "#d0c9bb",
  "#b9b0a3",
  "#a9a092",
  "#867c6c",
  "#675f53",
  "#ebe7dd",
  "#ddd6cd",
  "#cec8be",
  "#c0b8ab",
  "#aa9f91",
  "#83796c",
  "#aaa195",
  "#857b6d",
  "#e4e0ce",
  "#e2dbc9",
  "#d8d0bc",
  "#b1a793",
  "#6e6352",
  "#e3ded3",
  "#dad4c7",
  "#d1cabc",
  "#c2bbac",
  "#8b7e6a",
  "#6c6150",
  "#e8d5bb",
  "#e1c9ac",
  "#d4b799",
  "#bea182",
  "#af8f6d",
  "#a07e5d",
  "#90704f",
  "#ead1ae",
  "#e3c59e",
  "#d3b188",
  "#caa577",
  "#bb9163",
  "#b68c63",
  "#aa815a",
  "#f4e7d0",
  "#efd8ba",
  "#e2c8a6",
  "#dec19c",
  "#d6b68b",
  "#c59e6f",
  "#a77c50",
  "#eadabf",
  "#e3cfb0",
  "#d2bc9f",
  "#bda281",
  "#b19671",
  "#a18560",
  "#90724e",
  "#e5d6bd",
  "#dfccad",
  "#d2bd9c",
  "#bfa57f",
  "#a98960",
  "#8f714a",
  "#856a4b",
  "#e9dfd0",
  "#ddd2be",
  "#d8ccb7",
  "#d1bea0",
  "#bba787",
  "#a58e6c",
  "#8a7454",
  "#e1d4bd",
  "#d5c6ab",
  "#c6b698",
  "#bead8d",
  "#b6a17c",
  "#a28d69",
  "#7a6848",
  "#f0e6d4",
  "#e9dcc6",
  "#dfceb3",
  "#dcc9a5",
  "#c9b28d",
  "#a58d66",
  "#907855",
  "#f2ead7",
  "#e8d8bd",
  "#e1d0b2",
  "#d6c4a2",
  "#c9b38d",
  "#b29c75",
  "#8e764e",
  "#f2e9d6",
  "#eee3cb",
  "#e1d2b2",
  "#bba783",
  "#b29c73",
  "#a08a63",
  "#846f4b",
  "#f2ead6",
  "#f0e4ca",
  "#e0cfa8",
  "#cebc96",
  "#bba87e",
  "#af986b",
  "#907a50",
  "#ebe0c8",
  "#e4d8bd",
  "#dccdae",
  "#d6c7a3",
  "#c4b18a",
  "#ad976c",
  "#8c7952",
  "#ede5d1",
  "#e2d6b8",
  "#d9cca9",
  "#bbab82",
  "#ae9b6f",
  "#928159",
  "#82724e",
  "#ede3d0",
  "#dfd5ba",
  "#d6c9aa",
  "#cec19f",
  "#9f916b",
  "#7d704f",
  "#e6dfcf",
  "#e1d6c3",
  "#aea38e",
  "#a1937a",
  "#92856c",
  "#655a48",
  "#e6e1ce",
  "#d6ceba",
  "#cec6b1",
  "#c7bea5",
  "#b6ac91",
  "#978a6c",
  "#706750",
  "#dcd6c1",
  "#d0c8b1",
  "#c3baa2",
  "#a99d82",
  "#958c71",
  "#7e7254",
  "#786f51",
  "#f4f2e9",
  "#edeade",
  "#dedccd",
  "#c8c2ac",
  "#a39a7a",
  "#8e8363",
  "#786f52",
  "#eee9da",
  "#e1dac5",
  "#cfc7ab",
  "#a3997b",
  "#938865",
  "#837a5b",
  "#7a7050",
  "#dcdacd",
  "#cac7b7",
  "#c1c1b1",
  "#aea994",
  "#938f77",
  "#74705a",
  "#6a654b",
  "#e9e4d4",
  "#d3ceb8",
  "#c9c3ab",
  "#a29e87",
  "#918c72",
  "#847e64",
  "#756c4e",
  "#eee7cf",
  "#ece4ca",
  "#ddd2ac",
  "#d0c497",
  "#bcaf7a",
  "#afa16b",
  "#7c7147",
  "#eeead7",
  "#e7dfc2",
  "#ded6b3",
  "#cdc4a0",
  "#beb58c",
  "#b2a775",
  "#7e7546",
  "#edebd5",
  "#dfdab6",
  "#d3cda3",
  "#c4bd92",
  "#b2aa7c",
  "#99915f",
  "#877e4e",
  "#e4e5d0",
  "#dbddc4",
  "#d0d3b6",
  "#c2c5a4",
  "#b6b993",
  "#949569",
  "#6e6f4d",
  "#f3f2e9",
  "#eeede1",
  "#dfdfd1",
  "#c6c8b1",
  "#a1a282",
  "#858665",
  "#686b4b",
  "#dad7c9",
  "#c4c0b0",
  "#aaab9e",
  "#605e50",
  "#e1e2d2",
  "#d5d8c8",
  "#bbc3ad",
  "#959c81",
  "#7e856a",
  "#5f634f",
  "#4f5245",
  "#ededdf",
  "#d9decc",
  "#c2cbb3",
  "#9da691",
  "#878f77",
  "#767f67",
  "#616650",
  "#e2e5de",
  "#ced2cb",
  "#888f85",
  "#666559",
  "#5d594d",
  "#575146",
  "#e9ece5",
  "#d9dcd6",
  "#bec4be",
  "#737367",
  "#5e5c50",
  "#514d41",
  "#d6dcd1",
  "#ccd4c9",
  "#a9b6a8",
  "#97a697",
  "#758374",
  "#576256",
  "#dcdfd6",
  "#ced6cd",
  "#bec9bf",
  "#a8b5ac",
  "#93a39b",
  "#6d7e75",
  "#525a53",
  "#e6eae3",
  "#d9e3dd",
  "#c1d3cd",
  "#809696",
  "#5f7472",
  "#3c5052",
  "#d6ddd5",
  "#cad2cd",
  "#bbc6bf",
  "#aeb8b3",
  "#929e9a",
  "#dbe4dc",
  "#c9d6d1",
  "#b2c3c2",
  "#9eb1b0",
  "#899f9f",
  "#667879",
  "#b9c5c2",
  "#9facad",
  "#839294",
  "#707e7d",
  "#626f70",
  "#464b4b",
  "#d9e4df",
  "#c1d2d1",
  "#b3c7c8",
  "#96aeb2",
  "#839ca2",
  "#60757a",
  "#d7dcdd",
  "#bec9ce",
  "#a0b2bc",
  "#8e9ca7",
  "#768691",
  "#67737c",
  "#525356",
  "#e2e3e0",
  "#c9ccce",
  "#acb2b7",
  "#939ba4",
  "#6f767d",
  "#5d636b",
  "#dddcdb",
  "#d1d0d1",
  "#b9b9be",
  "#a1a5ad",
  "#7f848f",
  "#71737c",
  "#48474b",
  "#e5e4df",
  "#cccecd",
  "#b8bcbc",
  "#9da3a7",
  "#474848",
  "#d5d4d0",
  "#c9c8c4",
  "#b9b8b5",
  "#a2a3a2",
  "#848586",
  "#636463",
  "#4f4e4c",
  "#e1dfd9",
  "#d7d3ce",
  "#c7c5c1",
  "#b5b3b0",
  "#a0a09f",
  "#868585",
  "#e2dcd6",
  "#d9d6d3",
  "#c8c8c6",
  "#b1aeae",
  "#9f9c9c",
  "#7a7473",
  "#655a56",
  "#cbc6c3",
  "#beb8b6",
  "#b5afab",
  "#9c9898",
  "#807c7d",
  "#67615f",
  "#efebe1",
  "#ddd6cb",
  "#d4cabe",
  "#b0a89e",
  "#969088",
  "#645b4e",
  "#e9e3da",
  "#cfc7bd",
  "#c6beb2",
  "#a7a198",
  "#867f73",
  "#5a554a",
  "#d5d2c8",
  "#a7a59d",
  "#8b8981",
  "#7a776c",
  "#737065",
  "#c4c5bc",
  "#b6b9b0",
  "#858984",
  "#666963",
  "#54544e",
  "#dde2e6",
  "#c4d1e0",
  "#aabbd3",
  "#8196b4",
  "#677b9b",
  "#617696",
  "#49536b",
  "#c6d3e5",
  "#b3c6e0",
  "#a7bcdc",
  "#99afd2",
  "#7c98c3",
  "#607cab",
  "#344c84",
  "#ebeceb",
  "#dbe3ec",
  "#c6d5ea",
  "#aac0e3",
  "#98aedb",
  "#5874b4",
  "#43487d",
  "#d5e1ed",
  "#bdd2ea",
  "#a0bde4",
  "#8faedc",
  "#7296cf",
  "#547dbd",
  "#41518e",
  "#c8d8e4",
  "#b6cbde",
  "#a1bdd7",
  "#87a4c0",
  "#7192b4",
  "#4f6e90",
  "#414b61",
  "#d3dddf",
  "#c7d3da",
  "#b7c8d3",
  "#9eb0c0",
  "#8b9eb3",
  "#64768b",
  "#4f5b6e",
  "#dee3e0",
  "#c8d4d8",
  "#b5c6cf",
  "#99afbc",
  "#859dad",
  "#5d7585",
  "#e1ebea",
  "#c6deec",
  "#aacfeb",
  "#8dbfe6",
  "#6ea7db",
  "#387ec2",
  "#335392",
  "#ccdce1",
  "#bcd2dd",
  "#adc6d6",
  "#91b3ce",
  "#7ba0c1",
  "#557ea2",
  "#425e79",
  "#d9e3e2",
  "#bfd7e1",
  "#adcedd",
  "#92bad1",
  "#73a3c2",
  "#4a7fa0",
  "#395e7a",
  "#dfeceb",
  "#c3e4eb",
  "#9ed6e7",
  "#7bc8e2",
  "#5bb4d5",
  "#37a5cb",
  "#0a5b7e",
  "#e8eeea",
  "#cfe3e4",
  "#bdd9de",
  "#92b9c4",
  "#6b9ca8",
  "#4e828d",
  "#3e5c64",
  "#dfeeeb",
  "#c3e7ea",
  "#9ad9e2",
  "#6cc4d3",
  "#2eadc2",
  "#0096ab",
  "#006381",
  "#cfeee8",
  "#bfe9e4",
  "#a5e3e0",
  "#7ed8d7",
  "#28b7b8",
  "#00a4a3",
  "#006d6e",
  "#e1eee7",
  "#d7e9e4",
  "#b8ddda",
  "#91c2c3",
  "#5f9e9d",
  "#488786",
  "#2d5c62",
  "#def1e9",
  "#bee9e0",
  "#90dacf",
  "#7bcbc1",
  "#50b5aa",
  "#289f90",
  "#206d63",
  "#e4ece1",
  "#c5d9d1",
  "#b8d1c7",
  "#a8c3b9",
  "#91afa4",
  "#6d8c80",
  "#546d61",
  "#d5ebe0",
  "#bae1d2",
  "#a8d7c6",
  "#96c6b6",
  "#72ac98",
  "#55927a",
  "#2d5c4f",
  "#daf1e2",
  "#c0e9d7",
  "#afe4cc",
  "#88cfaf",
  "#62b992",
  "#40a374",
  "#227654",
  "#e2efdf",
  "#d8ebd8",
  "#c8e5cd",
  "#abd6b4",
  "#7eb086",
  "#689b6c",
  "#578153",
  "#ebf1e3",
  "#daeed6",
  "#addeb3",
  "#9ecfa2",
  "#7fbb81",
  "#61a462",
  "#3d8145",
  "#dfecd9",
  "#c4dcc9",
  "#bed9c3",
  "#a3c6ac",
  "#8eb597",
  "#6e9675",
  "#4f6a4e",
  "#e1e6d3",
  "#cfd9c4",
  "#becdb6",
  "#b0c4a9",
  "#9baf91",
  "#809675",
  "#5d6c50",
  "#e9ebd8",
  "#d3dcc3",
  "#c7d1b5",
  "#bec8a6",
  "#aeba95",
  "#8c9a70",
  "#65704d",
  "#e9edd9",
  "#ceddbc",
  "#c3d6b2",
  "#bcd0a8",
  "#a5bd8e",
  "#8ba874",
  "#6d8553",
  "#e4efd8",
  "#d1e8c4",
  "#c0e0b3",
  "#b7d6a4",
  "#96c184",
  "#81ae66",
  "#639049",
  "#eff1dc",
  "#e4eec9",
  "#d6e8b5",
  "#c4db9c",
  "#afcd7f",
  "#99bd5f",
  "#7aa542",
  "#edeeca",
  "#e5eaba",
  "#e0e6af",
  "#d3da94",
  "#c5ce7f",
  "#aab85b",
  "#96a440",
  "#e8eace",
  "#d9ddb7",
  "#cfd4a6",
  "#bec48c",
  "#a7ab6b",
  "#949b59",
  "#7d8447",
  "#eae6c8",
  "#e0dfbb",
  "#d8d5a9",
  "#cac68c",
  "#bdb86c",
  "#aba857",
  "#8f9046",
  "#f4efd3",
  "#efe9c0",
  "#ede3af",
  "#e1d593",
  "#ccbd68",
  "#bcab51",
  "#a79a45",
  "#f8f2d3",
  "#f4e5b7",
  "#efdea4",
  "#e7d190",
  "#d8b966",
  "#ccad54",
  "#be9e43",
  "#f5eecf",
  "#f3e5b9",
  "#f2dfa8",
  "#ecd38b",
  "#ebcc76",
  "#e0be62",
  "#cfa541",
  "#f6f2da",
  "#f7f2d7",
  "#f9f0c7",
  "#fbe29b",
  "#f7d67a",
  "#f3c854",
  "#e8b229",
  "#f6f3d9",
  "#f8f2d2",
  "#faf0c2",
  "#faefbb",
  "#fce28e",
  "#f7cd58",
  "#f1b837",
  "#f8efcb",
  "#f8ecb0",
  "#f9e89e",
  "#fce589",
  "#f6d862",
  "#f3cd47",
  "#f0c32f",
  "#f8f4dc",
  "#fbf1c4",
  "#fdeea5",
  "#fae16a",
  "#f7d22d",
  "#f0ca14",
  "#edc80c",
  "#f7f4dd",
  "#f9f2c8",
  "#faf1b9",
  "#feee9a",
  "#ffea81",
  "#ffe04d",
  "#ffd328",
  "#f7f5e5",
  "#f8f2d6",
  "#fbefc5",
  "#ffe79d",
  "#ffdf7b",
  "#ffd046",
  "#ffc100",
  "#f8efd2",
  "#f9e8ba",
  "#f9e4a9",
  "#f7d98d",
  "#e9c062",
  "#dfb24f",
  "#d0a43f",
  "#f3ebd2",
  "#f1e4bf",
  "#eddaad",
  "#e0cb9b",
  "#c3a767",
  "#ba9d60",
  "#a88846",
  "#f8e7c9",
  "#f4e1be",
  "#f0ddba",
  "#dfc595",
  "#d0b179",
  "#c2a167",
  "#ac8950",
  "#f1e4c8",
  "#ead8b4",
  "#e8d4ab",
  "#dcc699",
  "#caae78",
  "#b5975d",
  "#9a804c",
  "#f0e4c9",
  "#e9dbc1",
  "#e8d6b0",
  "#d4b88b",
  "#c1a271",
  "#b39465",
  "#9a7c4d",
  "#f5ead1",
  "#f4e0bf",
  "#edd3ac",
  "#dfbe8b",
  "#d3ac73",
  "#bc9354",
  "#af864d",
  "#f6eeda",
  "#f5dfb9",
  "#f3d5a6",
  "#efd29d",
  "#e7c38a",
  "#d6aa64",
  "#b78944",
  "#f7f0dd",
  "#f9e6c1",
  "#f8dca9",
  "#efc689",
  "#e5b875",
  "#d7a458",
  "#c79244",
  "#f8ebd1",
  "#f0d7ac",
  "#ebd2a8",
  "#e5c694",
  "#caa367",
  "#b5884d",
  "#f6eed8",
  "#fce4b6",
  "#f9daa3",
  "#f6d398",
  "#f0c985",
  "#e0b05d",
  "#c59442",
  "#f6f3e5",
  "#f6f0d9",
  "#faebc0",
  "#f8d898",
  "#eec377",
  "#e0b057",
  "#d09c3c",
  "#f9f2d9",
  "#fbf1d1",
  "#fee2a4",
  "#ffd98e",
  "#feca67",
  "#f9b945",
  "#eca72a",
  "#f9f0d0",
  "#fcedc2",
  "#fde9ae",
  "#ffe298",
  "#ffd269",
  "#ffc63c",
  "#ffb305",
  "#f7f2db",
  "#faefc2",
  "#fee59f",
  "#ffd368",
  "#ffc137",
  "#ffb428",
  "#fdab25",
  "#f8f2df",
  "#fbebc6",
  "#ffdea2",
  "#ffd185",
  "#ffc36a",
  "#ffb144",
  "#ff9a29",
  "#fbebcf",
  "#fce8c5",
  "#ffdbaa",
  "#ffd49f",
  "#ffb46e",
  "#ffa04f",
  "#f98433",
  "#f9e9d0",
  "#fcddb9",
  "#ffcfa1",
  "#febb83",
  "#faac6c",
  "#f99e59",
  "#ef8945",
  "#f8e5cb",
  "#fddfba",
  "#fdd4a9",
  "#f9c595",
  "#efaf78",
  "#e69c5a",
  "#d38643",
  "#f8f0e1",
  "#f8e5cc",
  "#f4d4ae",
  "#e8b984",
  "#d2985a",
  "#c4894f",
  "#bf8249",
  "#f5e3d0",
  "#f8ddc5",
  "#f4d3b7",
  "#e9c09a",
  "#d7a070",
  "#cf9561",
  "#b37c4a",
  "#f6e8d7",
  "#f4ddc4",
  "#f3d3b5",
  "#deb899",
  "#d6ab88",
  "#c08a64",
  "#aa724f",
  "#f2d8bf",
  "#f0ccaf",
  "#ecc6a6",
  "#dfb393",
  "#cd9875",
  "#b77c57",
  "#a06846",
  "#f7e6d3",
  "#f8dcc7",
  "#f5d4bd",
  "#eeb792",
  "#da966c",
  "#d08b60",
  "#b57248",
  "#f4f0e4",
  "#f9ebda",
  "#fcd9bd",
  "#fecfaf",
  "#f3a67d",
  "#e79060",
  "#cd6e44",
  "#f6f0e2",
  "#faead6",
  "#fde4cb",
  "#ffc299",
  "#ffa97a",
  "#fd9158",
  "#e77741",
  "#f7d1b7",
  "#f4c7ab",
  "#efb597",
  "#e29c7b",
  "#d17f58",
  "#ad674a",
  "#9b5244",
  "#fbe8d8",
  "#ffdec9",
  "#ffd2ba",
  "#ffb99e",
  "#fca080",
  "#f88760",
  "#ed6641",
  "#f9e3d9",
  "#fad2c4",
  "#f7c7b6",
  "#efb3a0",
  "#dc8971",
  "#ac5844",
  "#a45849",
  "#f1e7de",
  "#f8e0d3",
  "#f2c8b6",
  "#e9ad99",
  "#db9b8a",
  "#c57f6d",
  "#8e4b3f",
  "#f9ebe2",
  "#fdd5c7",
  "#f6b4a5",
  "#ef9e8d",
  "#e2816a",
  "#c0594b",
  "#be5d4c",
  "#fae2d7",
  "#f9ddd5",
  "#f7cfc7",
  "#edb1a9",
  "#da8d80",
  "#cc796b",
  "#ac594b",
  "#f8ece6",
  "#fbe2de",
  "#ffcbc9",
  "#ffb1b0",
  "#f89596",
  "#de4f46",
  "#c24044",
  "#f8e8df",
  "#fbd7d3",
  "#fccbc9",
  "#f7a6a4",
  "#e9827f",
  "#df726d",
  "#bf4d47",
  "#f8dad6",
  "#f7cdcd",
  "#f2bcc0",
  "#eba3aa",
  "#da868c",
  "#b35250",
  "#a24e4d",
  "#f6c1c8",
  "#f3b0ba",
  "#e5848e",
  "#d56069",
  "#c74a4a",
  "#bc484e",
  "#a74c53",
  "#fbe4e6",
  "#ffd8e0",
  "#fec0ce",
  "#f891a9",
  "#f1758d",
  "#ce3a3e",
  "#b53f43",
  "#fae4e5",
  "#fcdce0",
  "#fccbd2",
  "#fcbbc5",
  "#ef91a0",
  "#c43944",
  "#a23d40",
  "#f7ebec",
  "#f7dbe3",
  "#f8d1e0",
  "#f5bdd4",
  "#f2adc9",
  "#dd6c96",
  "#9f3949",
  "#f7e2e6",
  "#f3ccd7",
  "#e5a4ba",
  "#d17c94",
  "#af5161",
  "#a8455e",
  "#aa446a",
  "#f5c6d2",
  "#f3bdcb",
  "#e8a1b5",
  "#ce798f",
  "#974851",
  "#9e4a52",
  "#984245",
  "#f6dde0",
  "#f5d2d7",
  "#f3c4cd",
  "#e2a0ae",
  "#d78c9b",
  "#be6471",
  "#a63b49",
  "#f5e8ea",
  "#f4dbe3",
  "#eeccdb",
  "#ecc1d5",
  "#dba9c4",
  "#b77494",
  "#894565",
  "#f5ecec",
  "#f4e1ea",
  "#f3cde5",
  "#f0bcdf",
  "#e59dcb",
  "#d772af",
  "#a33d65",
  "#f4e1eb",
  "#f2d8e8",
  "#edc7e1",
  "#d8a6ce",
  "#cc94c1",
  "#b471a5",
  "#70435a",
  "#eddce0",
  "#e0c6d6",
  "#dbb6cd",
  "#bd8cad",
  "#a8789c",
  "#966284",
  "#684b5b",
  "#f3ecea",
  "#f2dfe9",
  "#edcee5",
  "#e6bee0",
  "#c393c7",
  "#b078b1",
  "#6e496e",
  "#eedbe7",
  "#e7cfe4",
  "#debedd",
  "#cbaad0",
  "#b692be",
  "#a47dac",
  "#644466",
  "#eddcea",
  "#e6d0e7",
  "#ddc1e2",
  "#cbaed7",
  "#b493c8",
  "#9872af",
  "#694a73",
  "#ede3e7",
  "#e2cddc",
  "#d7bbd1",
  "#c3afc5",
  "#ae95b1",
  "#947795",
  "#614c5f",
  "#efdedf",
  "#e0c8d5",
  "#d8bbcd",
  "#b38fab",
  "#9f7b9b",
  "#8b6885",
  "#634e60",
  "#eadade",
  "#dec9d1",
  "#d3b9c5",
  "#bea5b5",
  "#a28698",
  "#846778",
  "#54454f",
  "#ede3df",
  "#e2d4d6",
  "#d6c7cc",
  "#c5afba",
  "#b69eab",
  "#8f7683",
  "#5e4a52",
  "#e9dfe5",
  "#d6c7d5",
  "#bca9c0",
  "#97819b",
  "#675569",
  "#564954",
  "#4d4449",
  "#eee7e8",
  "#eae0e7",
  "#e2d6e4",
  "#d1c0dc",
  "#c0b0cf",
  "#a694bc",
  "#624d6c",
  "#ebe5eb",
  "#e4dbea",
  "#dacee7",
  "#cdbde2",
  "#b6a8d5",
  "#a797cb",
  "#604d7a",
  "#e2dfe7",
  "#d9d5e4",
  "#cac6df",
  "#a3a0c8",
  "#9593bd",
  "#78739f",
  "#574e70",
  "#d9d0e2",
  "#cfc3dc",
  "#b9b1ce",
  "#a49ec8",
  "#a098c5",
  "#8275ab",
  "#574c71",
  "#e3e3ea",
  "#dadaea",
  "#bfbfe4",
  "#a9aad7",
  "#9092ca",
  "#7173b3",
  "#555283",
  "#f1f0ed",
  "#e4e3eb",
  "#ccd0e6",
  "#bac0e4",
  "#8792cb",
  "#7179b8",
  "#4a4779",
  "#e9e8e5",
  "#ccd0e2",
  "#bec5de",
  "#abb2d7",
  "#98a0cc",
  "#717ab0",
  "#5b6196",
  "#e1dce3",
  "#d4cddb",
  "#bfb9cd",
  "#a6a4ba",
  "#9896ae",
  "#6d6983",
  "#514c5b",
  "#e8e2e5",
  "#cac2d0",
  "#b7b0c3",
  "#9e96ab",
  "#8e859b",
  "#81788d",
  "#5a505e",
  "#e1d9e3",
  "#dbd5df",
  "#d1c9d7",
  "#bcb4ca",
  "#aca2bd",
  "#857a9b",
  "#625165",
  "#ece3e2",
  "#e5dada",
  "#bdb1bc",
  "#a194a1",
  "#92838e",
  "#80717c",
  "#5b4a57",
  "#e6e1de",
  "#daced4",
  "#cdc0c9",
  "#bfb1bd",
  "#a89aaa",
  "#817180",
  "#594f58",
  "#d9d8da",
  "#cfced3",
  "#c0bfc7",
  "#b1b1bb",
  "#9b9daa",
  "#6f7280",
  "#5d5e6a",
  "#ece4d8",
  "#e4d9ca",
  "#d0c9be",
  "#dfddd7",
  "#e9e6de",
  "#e3ddd5",
  "#dcd2c2",
  "#d7d4cb",
  "#d6d4cf",
  "#faf7e7",
  "#e8d9c0",
  "#fbfaf5",
  "#fcf4db",
  "#e8ddc9",
  "#8c7b65",
  "#bfaf65",
  "#caae74",
  "#bfa45f",
  "#ffe9be",
  "#605f51",
  "#8a7c49",
  "#a18e5f",
  "#756a45",
  "#eee6d5",
  "#dfd9ca",
  "#cfc9a7",
  "#705641",
  "#9caaac",
  "#a7a89b",
  "#990219",
  "#541e20",
  "#b3975b",
  "#a49d93",
  "#bead7f",
  "#868a7e",
  "#3a5166",
  "#584925",
  "#554f29",
  "#332407",
  "#354649",
  "#bfc0bd",
  "#e3c699",
  "#aa9b84",
  "#b8be96",
  "#888479",
  "#242840",
  "#57686a",
  "#253c30",
  "#eaeeb8",
  "#bda07d",
  "#8b5045",
  "#5f7372",
  "#b59e75",
  "#3e343b",
  "#f4f8de",
  "#d4c9b3",
  "#bcb2a2",
  "#c4bca4",
  "#6d6762",
  "#c1c0b7",
  "#4a5d52",
  "#0d1c16",
  "#fff8ce",
  "#a3a7a7",
  "#8f8070",
  "#5e6260",
  "#7d8672",
  "#695e51",
  "#ecf0e9",
  "#e1e3dd",
  "#bfd3d2",
  "#acb4ac",
  "#9eb0bb",
  "#556e6b",
  "#557080",
  "#6d5e52",
  "#e8e8e0",
  "#e2dfda",
  "#d3c6b4",
  "#526e83",
  "#928b7c",
  "#867e6f",
  "#f7f1cc",
  "#afafab",
  "#3d4b4f",
  "#acaeb2",
  "#ad9a78",
  "#fff7e3",
  "#a0aa9a",
  "#f0ead6",
  "#717f65",
  "#5f5243",
  "#e2dcc0",
  "#6e786f",
  "#949594",
  "#d2cab6",
  "#8e988c",
  "#c5bea2",
  "#a6c1c9",
  "#8a544a",
  "#a1ab8b",
  "#aeae9a",
  "#7c7463",
  "#59534c",
  "#79888e",
  "#657285",
  "#6c3727",
  "#ac9e84",
  "#55544f",
  "#8c6031",
  "#013f3a",
  "#52575a",
  "#e2dbc8",
  "#b88858",
  "#4e3025",
  "#ddd1b7",
  "#67624e",
  "#edeee6",
  "#ded6c3",
  "#e4d0b5",
  "#645b56",
  "#814e4b",
  "#584a47",
  "#a09786",
  "#8f8878",
  "#898d9b",
  "#6a685f",
  "#6f6e6b",
  "#005b8e",
  "#ede3cd",
  "#708fa5",
  "#8db4d9",
  "#98b9bb",
  "#ece6d8",
  "#e0dbcb",
  "#555656",
  "#425465",
  "#8b4633",
  "#30673f",
  "#f0cb90",
  "#bea488",
  "#f2dbba",
  "#f5e8d2",
  "#857873",
  "#ca5b4a",
  "#503e36",
  "#f4e6c0",
  "#f2e2c6",
  "#f6ecd4",
  "#cec5b6",
  "#542840",
  "#ede3d5",
  "#acb0ae",
  "#cbc1b7",
  "#a99898",
  "#61894e",
  "#cccccb",
  "#ded0c1",
  "#cbcdcc",
  "#717876",
  "#8aa38b",
  "#60696c",
  "#5a636a",
  "#c1669d",
  "#686d70",
  "#bcc1ba",
  "#7f9881",
  "#929480",
  "#b7b8a7",
  "#716a60",
  "#583229",
  "#70677f",
  "#263b37",
  "#305244",
  "#4e3d34",
  "#978076",
  "#6a675e",
  "#d6d1bb",
  "#3a698d",
  "#d8ccc8",
  "#ebe7de",
  "#b7b3ac",
  "#b4c8cf",
  "#737372",
  "#ba9a74",
  "#d5ccc4",
  "#525234",
  "#d56e58",
  "#1f4b6d",
  "#7c735a",
  "#cccccb",
  "#dbdcda",
  "#6e7675",
  "#51b074",
  "#898d9b",
  "#edece7",
  "#afbc97",
  "#5a6368",
  "#b7657e",
  "#4e3d34",
  "#c6baa8",
  "#5e354c",
  "#ab1d2c",
  "#dcd1c0",
  "#dfcecb",
  "#6f6c6a",
  "#588dc3",
  "#dcd1c0",
  "#b2b8b9",
  "#7b7462",
  "#b1ac96",
  "#796b6b",
  "#6c6e5c",
  "#adb9bf",
  "#dbcfc0",
  "#bdbbda",
  "#8c9381",
  "#f4d088",
  "#8fc2c2",
  "#62a3ad",
  "#006065",
  "#d8d4ce",
  "#dfccb1",
  "#6c4b3d",
  "#c4c3b3",
  "#767666",
  "#7e9aac",
  "#7f7f7f",
  "#e6e1d8",
  "#b5322f",
  "#7f7b73",
  "#bab3ac",
  "#eae4d9",
  "#eee9de",
  "#9d9e9d",
  "#eed187",
  "#c0b0a2",
  "#a1b1ba",
  "#a29687",
  "#a3a19e",
  "#e4b24f",
  "#dfded8",
  "#ece3d3",
  "#f1eadc",
  "#e9ddc8",
  "#f3efe6",
  "#eae8e2",
  "#dccbb4",
  "#e2d8c7",
  "#eee6d8",
  "#eee8dd",
  "#ece7de",
  "#f1eadc",
  "#e2d3bf",
  "#dacdbd",
  "#cdbaa3",
  "#f3ede2",
  "#f0ebe2",
  "#f0ebe2",
  "#f2e9d8",
  "#f2ece1",
  "#f4ebdf",
  "#447879",
  "#4d656f",
  "#7d2328",
  "#636469",
  "#374841",
  "#355649",
  "#577879",
  "#6d756f",
  "#78423c",
  "#693e3b",
  "#d1c2b6",
  "#f0c894",
  "#fbe4c4",
  "#b7a083",
  "#666565",
  "#b1b1ac",
  "#bcb6aa",
  "#c5b9a3",
  "#938570",
  "#9c9384",
  "#644b3e",
  "#e1ccae",
  "#547280",
  "#dcd4c8",
  "#7e949d",
  "#986b57",
  "#b8ae92",
  "#a4aba5",
  "#a69e98",
  "#ccc1b3",
  "#ac9f91",
  "#beb2a5",
  "#bdb1a5",
  "#9da0a0",
  "#baa38a",
  "#cab9a2",
  "#ceb090",
  "#8e745c",
  "#776352",
  "#faf1d1",
  "#fee9aa",
  "#ffbabe",
  "#ffa7ad",
  "#f27979",
  "#f6ddd2",
  "#f6d3c5",
  "#f1c5b4",
  "#e8ac99",
  "#d58b75",
  "#bd6950",
  "#f6dfd9",
  "#ffe28e",
  "#f2d0c8",
  "#eab9b3",
  "#dc9b91",
  "#c67b71",
  "#a45449",
  "#f5dfdb",
  "#f2d5d1",
  "#e8bab9",
  "#dda09b",
  "#cf8783",
  "#f4cf5f",
  "#ab5651",
  "#f1ddd6",
  "#eacec7",
  "#e4c1b9",
  "#d9ada4",
  "#bd867a",
  "#ac5d4e",
  "#f4e0e0",
  "#f1d3d4",
  "#ecc3c7",
  "#faf2d8",
  "#e2acb0",
  "#d69598",
  "#b96667",
  "#f4dfe0",
  "#f1d4d8",
  "#edc8cd",
  "#e0b1b9",
  "#d69da7",
  "#b46971",
  "#fae5e6",
  "#fbf0ce",
  "#fadadf",
  "#ffccd8",
  "#ffc1d1",
  "#fea9c0",
  "#f27a95",
  "#f8e3e6",
  "#f8dae3",
  "#f7cbdc",
  "#f5bed2",
  "#f2a7c4",
  "#fdeec1",
  "#e2769b",
  "#f6e3e7",
  "#f5dbe6",
  "#f4cfe0",
  "#efbad5",
  "#edabcc",
  "#da72a3",
  "#f3e6ea",
  "#f2e1e9",
  "#f0d5e5",
  "#ffe9a6",
  "#ecc9e1",
  "#e5afd4",
  "#cf76af",
  "#f5e5eb",
  "#edd7de",
  "#e5c8d5",
  "#dcb5ca",
  "#cea1ba",
  "#ad6c88",
  "#f5e4eb",
  "#ffe282",
  "#f4d9e6",
  "#e9cddf",
  "#e0bbd6",
  "#cea6c6",
  "#a57299",
  "#ecdeec",
  "#e5d3e6",
  "#dec5e0",
  "#d2b0d6",
  "#c9a5d0",
  "#ffd651",
  "#ae7bb3",
  "#e8e2e9",
  "#e2d9e5",
  "#decfe1",
  "#c9b8d4",
  "#bca8ca",
  "#8c719d",
  "#e9e7ed",
  "#e0dfec",
  "#dad5e7",
  "#fbf2d6",
  "#ccc3df",
  "#bdb5d9",
  "#9183bb",
  "#e2e1e5",
  "#d4d7e1",
  "#caccd9",
  "#b5b6c7",
  "#aca8c1",
  "#7f7697",
  "#e2e4ec",
  "#fbedc4",
  "#fbeecb",
  "#d9dcea",
  "#ced3e7",
  "#b5b7da",
  "#9fa4d1",
  "#7a7bb3",
  "#e2e4ed",
  "#d7dae9",
  "#c1c8e3",
  "#abb3da",
  "#97a2d0",
  "#ffecbc",
  "#7680b9",
  "#e2e4e8",
  "#d9dce5",
  "#cad1de",
  "#bac2d4",
  "#a2aac1",
  "#767fa6",
  "#e8e9eb",
  "#d8dbe3",
  "#c3cadb",
  "#ffe7aa",
  "#adb4cc",
  "#97a0ba",
  "#6b7593",
  "#dbe4e8",
  "#d0dce4",
  "#bdcfde",
  "#a4bcd2",
  "#8eabc6",
  "#567695",
  "#d8e2e8",
  "#ffe28c",
  "#cddae4",
  "#becedd",
  "#a7bbd0",
  "#8ca5c1",
  "#59769e",
  "#dfe7ec",
  "#d6e0e6",
  "#c9d5e0",
  "#b5c5d6",
  "#9aafc6",
  "#ffd149",
  "#6581a4",
  "#dee8eb",
  "#d5e1e7",
  "#c5d5e1",
  "#a8c0d4",
  "#93b0c9",
  "#5b84b4",
  "#dce6ee",
  "#d1dceb",
  "#c3d4e8",
  "#fcf0d3",
  "#abc3e3",
  "#96b3db",
  "#607fba",
  "#d8e5ed",
  "#ccddeb",
  "#bed6eb",
  "#a7c4e3",
  "#8fb5dd",
  "#5583bd",
  "#dbe4e7",
  "#fcebc7",
  "#cadae1",
  "#bcd0dc",
  "#aac0d0",
  "#849eb2",
  "#53728b",
  "#daeaef",
  "#cce2ed",
  "#b1d4eb",
  "#a3cdea",
  "#7db5e0",
  "#ffe9b8",
  "#3987c0",
  "#cae3ee",
  "#bfddec",
  "#a8cfe7",
  "#8cc6e7",
  "#72bbe5",
  "#178ac3",
  "#d3e9ef",
  "#c4e4ee",
  "#add9ec",
  "#ffe29e",
  "#96d1ec",
  "#60bae2",
  "#0092ca",
  "#d7e3e5",
  "#ccdbe0",
  "#bdd0d8",
  "#a4bbc6",
  "#829dab",
  "#527688",
  "#d0e6e9",
  "#ffda85",
  "#c3dfe8",
  "#add5e1",
  "#91c0d3",
  "#77adc2",
  "#3f7a90",
  "#d4e9ed",
  "#c7e3ec",
  "#b4dae8",
  "#99c9de",
  "#7ebad5",
  "#fbe9b5",
  "#ffc53f",
  "#3d8daf",
  "#f3edef",
  "#ede0ec",
  "#e6d2e8",
  "#e0c5e3",
  "#d4b5d9",
  "#c6a2cd",
  "#ab7db4",
  "#6b4c79",
  "#ebe8ea",
  "#d6e7ea",
  "#ded8e0",
  "#cfc7d4",
  "#c3bac9",
  "#b9b1bf",
  "#8c8296",
  "#776e82",
  "#4f4855",
  "#ebe8eb",
  "#e6e1ea",
  "#dfd9e6",
  "#c0dee6",
  "#cdc5db",
  "#c5bdd5",
  "#aba2c1",
  "#897ea3",
  "#5c5271",
  "#e7e4ed",
  "#e0dcec",
  "#d7d2e9",
  "#cac5e3",
  "#bdb9dd",
  "#afd4e0",
  "#aba6d2",
  "#817bb4",
  "#5b5388",
  "#e6e5ee",
  "#d5d3e2",
  "#c8c6db",
  "#bfbdd2",
  "#a9a8cb",
  "#a5a4c9",
  "#7979aa",
  "#9bc7d7",
  "#515177",
  "#e6e5e6",
  "#d8d6dc",
  "#cccad2",
  "#bdbac5",
  "#b2b0ba",
  "#9593a0",
  "#6f6d7c",
  "#4e4b55",
  "#dcdbe2",
  "#71aec4",
  "#d2d1dc",
  "#bdbdcc",
  "#b0b1c1",
  "#9fa2b5",
  "#7f8095",
  "#6e6f86",
  "#4e4c5b",
  "#e1e1e8",
  "#d5d6e4",
  "#c9cbdf",
  "#23849f",
  "#afb4cf",
  "#9ba1c1",
  "#8389ae",
  "#6d779f",
  "#4f5373",
  "#e0e3ed",
  "#d7dbec",
  "#cad0e9",
  "#bdc5e4",
  "#b0bade",
  "#d0eaef",
  "#96a3d1",
  "#6a79b3",
  "#4f5a92",
  "#eef0f1",
  "#e1e6ef",
  "#ccd6ea",
  "#bbc8e6",
  "#aebedf",
  "#8ea4d1",
  "#6a7fb9",
  "#c0e1ea",
  "#434e81",
  "#e4e7eb",
  "#d0d6e3",
  "#b7c1d5",
  "#aeb9ce",
  "#939fb9",
  "#7986a3",
  "#677491",
  "#474d63",
  "#e0e3e6",
  "#add8e7",
  "#d8dce1",
  "#c4cbd5",
  "#b3bcc9",
  "#a9b2bf",
  "#8d98a8",
  "#606b7d",
  "#464b57",
  "#e8eef0",
  "#dbe6ef",
  "#c6d9ec",
  "#feecc9",
  "#8ec6d9",
  "#afc9e7",
  "#a2c1e2",
  "#7fa7d5",
  "#4f7db7",
  "#375186",
  "#e1e7eb",
  "#c8d9e8",
  "#b9cee3",
  "#adc6df",
  "#a3bed8",
  "#70bad4",
  "#87a9ca",
  "#5b82aa",
  "#21568b",
  "#e2ecef",
  "#c9dce7",
  "#bbd2e0",
  "#a8c5d8",
  "#90b2ca",
  "#7aa0bb",
  "#4b7493",
  "#1690b2",
  "#3a4e65",
  "#dee7eb",
  "#ccdce5",
  "#b0c8d8",
  "#9ab7ca",
  "#799bb3",
  "#5d809a",
  "#50748e",
  "#3b4f64",
  "#deecef",
  "#c9e9f0",
  "#c6e1ee",
  "#aed5ec",
  "#97c9e9",
  "#76b8e1",
  "#61acda",
  "#2588c1",
  "#1a5d96",
  "#e0ecee",
  "#d5e7ed",
  "#bddae7",
  "#b9e2ed",
  "#a1cade",
  "#95c2d8",
  "#6fa8c4",
  "#4485a6",
  "#2f5671",
  "#d8ebee",
  "#cbe5ed",
  "#aad6e7",
  "#91cbe1",
  "#85c3db",
  "#a2daec",
  "#59aac9",
  "#218bae",
  "#1d5f7d",
  "#dae7e9",
  "#bdd5de",
  "#aac8d4",
  "#9fc0ce",
  "#8bafbf",
  "#7199ab",
  "#496e82",
  "#7ec9e2",
  "#2b4c61",
  "#dee7e7",
  "#c9d8db",
  "#bdd1d5",
  "#adc3c9",
  "#a2b9bf",
  "#839fa6",
  "#58747c",
  "#3d4a4f",
  "#e1f2f0",
  "#5ebdda",
  "#c6e7ee",
  "#a8dcea",
  "#8ad2e4",
  "#66c5dc",
  "#41b6d1",
  "#0098b9",
  "#006682",
  "#e8eeeb",
  "#d6e5e5",
  "#bed6d9",
  "#0093b8",
  "#accad1",
  "#a2c2c8",
  "#7fa6af",
  "#547e88",
  "#3e5c64",
  "#cfeaed",
  "#c3e6eb",
  "#aedce5",
  "#97d3df",
  "#89cbd9",
  "#cee8ec",
  "#62b8c9",
  "#0c91a6",
  "#2c5969",
  "#e2f3f0",
  "#c7ebec",
  "#a9e1e6",
  "#8ed8e0",
  "#7fd0d8",
  "#42bdc7",
  "#009caa",
  "#ffe7b9",
  "#bee0e8",
  "#006b80",
  "#d3edeb",
  "#c3e6e6",
  "#b1dfdf",
  "#9cd5d7",
  "#8dcdcf",
  "#63b5b7",
  "#309396",
  "#166b6f",
  "#dfeeeb",
  "#a7d5e3",
  "#d1e7e5",
  "#c3e0de",
  "#9ec8ca",
  "#90bebe",
  "#74a7a9",
  "#487c80",
  "#39595c",
  "#e1ebe7",
  "#cbdfdc",
  "#bcd4d1",
  "#88c5d9",
  "#aac8c5",
  "#93b2af",
  "#7ea19e",
  "#547574",
  "#2c5459",
  "#e5f1ec",
  "#dbece8",
  "#c0dedb",
  "#aed4d1",
  "#a5cdc9",
  "#6bb8d1",
  "#6aa39f",
  "#4e8784",
  "#246062",
  "#d2efeb",
  "#c5ece8",
  "#b1e7e3",
  "#91ddd9",
  "#83d8d3",
  "#49c5bd",
  "#00a8a0",
  "#1787a3",
  "#00746d",
  "#d3f1eb",
  "#b0e8e1",
  "#8fe0d6",
  "#78d7cc",
  "#4cc9bb",
  "#00ab9a",
  "#007765",
  "#d3ece5",
  "#d2e7ea",
  "#c4e6df",
  "#b3ded6",
  "#a8d8d0",
  "#93ccc2",
  "#75b8ad",
  "#469186",
  "#1d6d61",
  "#d4eae2",
  "#c6e3d9",
  "#b4d9ce",
  "#c4e1e8",
  "#a4d1c5",
  "#96c7b8",
  "#78b0a0",
  "#4d8878",
  "#285b50",
  "#e5f3e7",
  "#cceddf",
  "#b5e6d7",
  "#9addcb",
  "#90d7c1",
  "#b1d5de",
  "#75cab0",
  "#39a588",
  "#20775f",
  "#e0eee5",
  "#d6e9de",
  "#bedccd",
  "#acd1c1",
  "#9ac3b0",
  "#81b09b",
  "#588974",
  "#9dc8d5",
  "#3a5e54",
  "#e7f5eb",
  "#d7f2e5",
  "#b8e9d5",
  "#a3e1c9",
  "#97ddc0",
  "#6ecaa4",
  "#3daf82",
  "#078a5a",
  "#dfeee3",
  "#7db3c4",
  "#d5e7da",
  "#b3d3bf",
  "#a4c7b0",
  "#85ae94",
  "#689278",
  "#3f6b4e",
  "#e4f3e4",
  "#d4edda",
  "#c1e5cb",
  "#ffe6b1",
  "#2b869b",
  "#afdcbd",
  "#a4d6b1",
  "#83c093",
  "#5fa373",
  "#437e4e",
  "#e3ede0",
  "#d9e6d7",
  "#c3d8c5",
  "#bad2bb",
  "#b0c9af",
  "#cceaee",
  "#93b194",
  "#709072",
  "#536c51",
  "#edf4e2",
  "#e6f2da",
  "#d7ecc8",
  "#c9e5b7",
  "#c0e1ac",
  "#a7d490",
  "#82bd6c",
  "#b9e3eb",
  "#529e43",
  "#f1f5e2",
  "#edf3db",
  "#e8f1d1",
  "#d4e7b3",
  "#cce2a4",
  "#b9d689",
  "#9ac466",
  "#74a42f",
  "#edf2e1",
  "#a7dce7",
  "#e8f0d8",
  "#dae7c6",
  "#cde0b7",
  "#c7daab",
  "#aec78d",
  "#8bab68",
  "#6a8c48",
  "#e9edde",
  "#e3e9d6",
  "#dae2cb",
  "#83cede",
  "#cdd7bd",
  "#c6d2b2",
  "#adbc94",
  "#84986d",
  "#60734b",
  "#e3e7d4",
  "#dadfc9",
  "#cfd4b9",
  "#bec4a3",
  "#aeb591",
  "#63c0d6",
  "#959e78",
  "#88926d",
  "#69714f",
  "#f2f3dd",
  "#f0f1d5",
  "#eaedc8",
  "#e0e6b6",
  "#d7e0a6",
  "#c5d288",
  "#a7bb63",
  "#009ab5",
  "#839e3e",
  "#eeefdb",
  "#e9ead2",
  "#dddebc",
  "#d4d6b0",
  "#cecfa3",
  "#b8ba86",
  "#949963",
  "#81854f",
  "#eff1d9",
  "#cde7e8",
  "#e9eccd",
  "#e1e6c0",
  "#d9dfb3",
  "#d2d7a3",
  "#bfc98b",
  "#a1af66",
  "#819145",
  "#f6f3da",
  "#f3f1d0",
  "#f1efc4",
  "#bfe1e5",
  "#ebecb4",
  "#e6e79c",
  "#dce087",
  "#c0cd5a",
  "#acb228",
  "#f4f1d5",
  "#f2eecb",
  "#ede9bc",
  "#e8e4b2",
  "#e3dc9d",
  "#acd7dd",
  "#d8d289",
  "#bab85d",
  "#a0a140",
  "#f9f4d7",
  "#f1edc9",
  "#efecc1",
  "#ece9b5",
  "#ede591",
  "#e2dc79",
  "#e0d457",
  "#ffe09d",
  "#8ec6cf",
  "#cbc83b",
  "#e9e7d4",
  "#e2dfc8",
  "#cfcdb0",
  "#c9c5a4",
  "#b9b690",
  "#a3a078",
  "#908e68",
  "#73714e",
  "#eae5d0",
  "#77b5bf",
  "#e2ddc3",
  "#d5cfae",
  "#cbc39d",
  "#b8b086",
  "#a1996e",
  "#938c62",
  "#7e774f",
  "#efead0",
  "#ece5c3",
  "#e2d9ae",
  "#36848e",
  "#dacf9c",
  "#cabf84",
  "#b9ae6d",
  "#aaa05f",
  "#958b4a",
  "#f6eed0",
  "#f4eac3",
  "#efe2b3",
  "#ebdda6",
  "#e4d492",
  "#cee9ea",
  "#decd86",
  "#c8b563",
  "#a2953d",
  "#f8f4df",
  "#fbf4d7",
  "#fef1c6",
  "#ffeeb6",
  "#f5df92",
  "#f6dd87",
  "#efd064",
  "#bee4ea",
  "#ccb01f",
  "#f8f2de",
  "#f7eed5",
  "#f5eaca",
  "#eedeb5",
  "#e8d6a5",
  "#dcc78d",
  "#c0a763",
  "#a28b44",
  "#f3ecda",
  "#a7dde5",
  "#e9ddc4",
  "#e1d3b5",
  "#dccca8",
  "#d0be96",
  "#bba77b",
  "#ab9669",
  "#7f6e44",
  "#faf3de",
  "#faefd3",
  "#f9ecc8",
  "#87d0db",
  "#f5e3b3",
  "#f1dda3",
  "#e8d18a",
  "#d4b760",
  "#b69a3b",
  "#fbf3d8",
  "#fdf1ce",
  "#ffefc1",
  "#ffecb0",
  "#ffe998",
  "#63c3d1",
  "#ffe482",
  "#ffda5b",
  "#ffc92f",
  "#faf3dd",
  "#fcf2d4",
  "#ffeec1",
  "#ffeaaf",
  "#ffe69b",
  "#ffdf80",
  "#ffd152",
  "#009daf",
  "#ffbf24",
  "#fdf2d7",
  "#feefcc",
  "#ffefc4",
  "#f4dca9",
  "#f2d69a",
  "#dfba6d",
  "#d2ab5b",
  "#bf9842",
  "#f6ead2",
  "#d5eded",
  "#f3e2c2",
  "#ecd7b1",
  "#e9d0a4",
  "#d9bb86",
  "#caa66c",
  "#bf9b60",
  "#a58147",
  "#fbf1d3",
  "#fdeec6",
  "#ffe9b7",
  "#ffd37b",
  "#c6e6e6",
  "#ffe8ae",
  "#ffe29a",
  "#ffd882",
  "#fac75c",
  "#f3b23f",
  "#fdf3da",
  "#fef0d0",
  "#ffecc3",
  "#ffe7b2",
  "#ffe3a6",
  "#b5dfe0",
  "#ffd582",
  "#f7c35d",
  "#edae41",
  "#fcf5e0",
  "#fff0cf",
  "#ffebbc",
  "#ffe6ab",
  "#ffe39d",
  "#ffd97d",
  "#ffc94e",
  "#9ad1d6",
  "#ffb50a",
  "#fff0d4",
  "#ffecc7",
  "#ffe6b7",
  "#ffdfa5",
  "#ffd995",
  "#ffc972",
  "#fcb54d",
  "#ec9f26",
  "#fbf4e3",
  "#7fbfc6",
  "#feefd5",
  "#fee6bf",
  "#fddeae",
  "#fcdaa1",
  "#f7c981",
  "#e7b05d",
  "#d5983e",
  "#f9f1e2",
  "#fcedd6",
  "#fbe4c1",
  "#3b8f98",
  "#f8d7ab",
  "#f4c991",
  "#edbb7d",
  "#dba45f",
  "#c68c46",
  "#fcf2db",
  "#ffeac5",
  "#ffe6b5",
  "#ffe0a2",
  "#ffdc96",
  "#cdeee8",
  "#ffd074",
  "#ffbc45",
  "#ffa400",
  "#feecd1",
  "#ffe8c1",
  "#ffe2b6",
  "#ffdda6",
  "#ffd999",
  "#ffbe62",
  "#ffb14d",
  "#bae8e5",
  "#f89e21",
  "#fceed7",
  "#ffebce",
  "#ffe4be",
  "#ffdaa3",
  "#ffd18c",
  "#ffc778",
  "#ffac4c",
  "#ff9525",
  "#faf1e2",
  "#a6e3e2",
  "#fde9d3",
  "#fedfc0",
  "#fcd5af",
  "#fbca9a",
  "#f5bb86",
  "#e59c5e",
  "#ca7e41",
  "#fbe9d2",
  "#fee3c6",
  "#ffdcb8",
  "#81d4d4",
  "#ffd3a7",
  "#ffce98",
  "#ffb979",
  "#ff9f54",
  "#f78230",
  "#fcead7",
  "#fde6ce",
  "#ffdbbc",
  "#fdd1ac",
  "#fdca9f",
  "#5ac9cb",
  "#f6b580",
  "#ea9a5f",
  "#d78044",
  "#fbecde",
  "#ffe1cd",
  "#ffd9c0",
  "#ffceaf",
  "#ffc8a3",
  "#ffb183",
  "#fe935d",
  "#ffbe33",
  "#00a5a7",
  "#e37543",
  "#f9efe3",
  "#fee6d6",
  "#ffd8c0",
  "#fdcbb1",
  "#fec09c",
  "#fbae86",
  "#ee9063",
  "#ce6c3f",
  "#fbe3d4",
  "#ccede9",
  "#f9dac7",
  "#f7cfb9",
  "#f5c7af",
  "#f3bea3",
  "#e7a485",
  "#d07e5d",
  "#ab6149",
  "#f9e9dc",
  "#f6dbc9",
  "#f3ccb6",
  "#bfeae6",
  "#ecbda3",
  "#e3ab8c",
  "#d99a7a",
  "#bd7759",
  "#a76246",
  "#fcebe0",
  "#fee2d4",
  "#ffd6c5",
  "#ffcab7",
  "#ffc1a7",
  "#ade6e3",
  "#ffac8c",
  "#fb8b65",
  "#ea6640",
  "#ffe5de",
  "#ffddd5",
  "#ffd3ca",
  "#fdc5ba",
  "#fbbeaf",
  "#f6a796",
  "#e2826c",
  "#8ddad6",
  "#bd5a4e",
  "#fce7e1",
  "#ffddd8",
  "#ffcfcc",
  "#ffc2bd",
  "#ffbab2",
  "#ffa49a",
  "#f88275",
  "#e35c49",
  "#fde6e5",
  "#65cfcd",
  "#ffd8d8",
  "#ffcecf",
  "#ffc4c7",
  "#fcbbba",
  "#f7a2a0",
  "#e98380",
  "#c85c53",
  "#fceae6",
  "#ffdbdb",
  "#ffd1d3",
  "#00aba4",
  "#ffc4c7",
  "#ffb1b1",
  "#fd9f9f",
  "#f47c7b",
  "#d7534a",
  "#fbe5e3",
  "#fbd3d5",
  "#f7c0c6",
  "#f3b5b8",
  "#f1acae",
  "#e2efeb",
  "#e18d90",
  "#cc6d6d",
  "#af514b",
  "#fde0e4",
  "#fed5dd",
  "#ffc8d4",
  "#fdbbc9",
  "#f9b2bf",
  "#f399aa",
  "#e07383",
  "#c7e2e2",
  "#ac3f54",
  "#faebeb",
  "#fddee5",
  "#ffcdda",
  "#ffbfd2",
  "#ffb7cb",
  "#fb99b3",
  "#f27a96",
  "#c73f4a",
  "#f4e5e3",
  "#b5d8d7",
  "#ecd3d3",
  "#e2bfc1",
  "#dcb5b5",
  "#cd9f9f",
  "#b37c7d",
  "#a36b6b",
  "#824952",
  "#fbe9e9",
  "#f6d7dd",
  "#eec2cc",
  "#ffebce",
  "#a3cbca",
  "#e8b3bd",
  "#d696a1",
  "#c8828e",
  "#b56f79",
  "#814456",
  "#f6dfe1",
  "#f3d6db",
  "#efc6cd",
  "#ebbac3",
  "#e6adb4",
  "#86b7b6",
  "#db98a1",
  "#ba6972",
  "#8c4158",
  "#f8e7ec",
  "#f9dae6",
  "#f7cde0",
  "#f6bfd9",
  "#f5b9d4",
  "#ed9ac0",
  "#dc6f9c",
  "#4e8482",
  "#8f3c55",
  "#fae9eb",
  "#fadbe6",
  "#fcd0e1",
  "#f1bfd5",
  "#e8b7cd",
  "#dc9dbb",
  "#ba7195",
  "#893e5e",
  "#f4e5e9",
  "#d7f2eb",
  "#f2dde6",
  "#edd2df",
  "#e6c4d6",
  "#dfb7cb",
  "#c68fab",
  "#b47a98",
  "#884b6f",
  "#f2e2ec",
  "#edd8e8",
  "#e7cce2",
  "#caefe5",
  "#e2c4df",
  "#dbb6d5",
  "#d0a4c9",
  "#b077a8",
  "#744664",
  "#f1e9ea",
  "#e6d6df",
  "#cfbcca",
  "#cab6c3",
  "#b098aa",
  "#aee9df",
  "#967d90",
  "#8a6c81",
  "#5e4860",
  "#e8e2e3",
  "#e0dadc",
  "#d0c7cd",
  "#cac0c3",
  "#ada0a6",
  "#96888f",
  "#83757d",
  "#99e3d5",
  "#5a4b59",
  "#e9e5e3",
  "#dcd5d5",
  "#d0c7c8",
  "#c9bfbe",
  "#b9aeae",
  "#978b8d",
  "#807577",
  "#4e444a",
  "#e7e5e3",
  "#6ad7c7",
  "#d4d3d3",
  "#b8b6b8",
  "#afacad",
  "#969394",
  "#767274",
  "#656264",
  "#4b4544",
  "#dcdddd",
  "#cfd2d4",
  "#b6bbbf",
  "#00b49a",
  "#aeb0b4",
  "#8b8f95",
  "#71757b",
  "#5f636a",
  "#46484b",
  "#eeefec",
  "#dbdedf",
  "#c6cccf",
  "#adb3b8",
  "#a1a7ab",
  "#d8f1e6",
  "#71787e",
  "#60666c",
  "#3c3b3c",
  "#d7dfe0",
  "#c4ced1",
  "#adbbc1",
  "#9ba9af",
  "#829198",
  "#6b797f",
  "#5d6a70",
  "#ffe7c2",
  "#ccefe3",
  "#4d5052",
  "#dee7e8",
  "#cdd9dd",
  "#b8c8cf",
  "#a7b9c2",
  "#9bafb7",
  "#7a909a",
  "#546772",
  "#414b52",
  "#e1e4e2",
  "#baeadd",
  "#cbd0d0",
  "#b9bdbe",
  "#abafae",
  "#8f9493",
  "#6a7071",
  "#606566",
  "#464747",
  "#ddddda",
  "#d3d2d0",
  "#c5c5c2",
  "#9edecd",
  "#b6b5b3",
  "#a8a6a3",
  "#787673",
  "#686664",
  "#484541",
  "#d3d4d1",
  "#c7c8c5",
  "#b7b9b6",
  "#aeafab",
  "#8f8f8c",
  "#85d1bd",
  "#767674",
  "#676866",
  "#4f4e4c",
  "#d8dbd8",
  "#bcc2c0",
  "#b2b9b7",
  "#a8afac",
  "#8b9290",
  "#717977",
  "#636a69",
  "#38ae8f",
  "#4b4d4c",
  "#dbdbd5",
  "#c6c7c1",
  "#babcb6",
  "#acada5",
  "#92948b",
  "#767972",
  "#6a6d66",
  "#53534d",
  "#d2d9d7",
  "#ddf2e3",
  "#c6cecc",
  "#bcc5c3",
  "#acb6b3",
  "#919d9b",
  "#778280",
  "#646f6f",
  "#474d4b",
  "#e4eae5",
  "#dbe3df",
  "#c7d3cf",
  "#cfeedd",
  "#b7c6c2",
  "#afbeb9",
  "#8da09b",
  "#56716e",
  "#3d5252",
  "#e6ebe4",
  "#d4dad3",
  "#bdc6be",
  "#acb6ab",
  "#98a397",
  "#c1e8d4",
  "#7c867c",
  "#6a746b",
  "#51574f",
  "#e5ebe1",
  "#d5ddce",
  "#becab7",
  "#b6c1ab",
  "#a4b098",
  "#849179",
  "#78866f",
  "#aaddc1",
  "#596451",
  "#dde0d6",
  "#d1d5ca",
  "#bfc3b6",
  "#b1b5a6",
  "#969b8b",
  "#818576",
  "#707668",
  "#595d51",
  "#e4e4db",
  "#93d2af",
  "#ced0c4",
  "#c0c2b2",
  "#b8b9a8",
  "#a6a795",
  "#9c9d8b",
  "#737667",
  "#5d5e51",
  "#e9ebe0",
  "#d9dccd",
  "#c5cab7",
  "#ffe0b0",
  "#59af7c",
  "#bec0ab",
  "#adb099",
  "#90947b",
  "#7e826b",
  "#606350",
  "#dfe4d4",
  "#d1d6c3",
  "#c6cdb7",
  "#bcc2a7",
  "#a1a98c",
  "#d6e5e2",
  "#8b9375",
  "#7b8468",
  "#646b52",
  "#e9e7df",
  "#d7d5ca",
  "#c2c0b3",
  "#b9b6a6",
  "#a6a394",
  "#9c9989",
  "#747265",
  "#cadcd9",
  "#605d51",
  "#e7e5df",
  "#d5d1ca",
  "#bfbbb2",
  "#b7b1a6",
  "#9a9589",
  "#7f796f",
  "#787369",
  "#554f47",
  "#f0eee6",
  "#b8d1cf",
  "#ddd7ce",
  "#d2cbc1",
  "#beb3a6",
  "#a39a90",
  "#898077",
  "#776e66",
  "#62584d",
  "#e6dfd6",
  "#dfd6cb",
  "#cac1b3",
  "#9bb7b5",
  "#c6baac",
  "#beb09f",
  "#a79886",
  "#827363",
  "#695b4c",
  "#dfdad0",
  "#d5cec3",
  "#c8c1b4",
  "#c1b8a8",
  "#a39a8a",
  "#87a7a6",
  "#8a8071",
  "#776f62",
  "#635b4f",
  "#e9e4df",
  "#dcd6cf",
  "#d0c9c1",
  "#c7beb6",
  "#b3a99d",
  "#8c8278",
  "#7a7269",
  "#587a76",
  "#585149",
  "#f4f1e8",
  "#e9e5d9",
  "#d6d1c0",
  "#cbc4b0",
  "#b2aa91",
  "#9a9178",
  "#898068",
  "#766a4f",
  "#f1ece2",
  "#dcede6",
  "#e8e0d3",
  "#ded5c6",
  "#d0c3af",
  "#b9aa93",
  "#a2917a",
  "#93826c",
  "#665847",
  "#f3ead8",
  "#efe3cc",
  "#dfcdad",
  "#d1e6df",
  "#dbc6a1",
  "#cbb188",
  "#b49a6f",
  "#aa8f65",
  "#8c744e",
  "#f2e8d7",
  "#ebe0cd",
  "#dfcfb5",
  "#dbc8a9",
  "#c7af8b",
  "#c3ded6",
  "#ba9e77",
  "#a78c67",
  "#846c4b",
  "#f3e6d0",
  "#f1ddc3",
  "#e9cfae",
  "#e7c9a2",
  "#d5b084",
  "#c69d6d",
  "#b98f61",
  "#fbe4a2",
  "#ffd698",
  "#a9cac1",
  "#99724a",
  "#efe2d0",
  "#e8d7c2",
  "#e1ccb4",
  "#ddc5a8",
  "#c8ab8a",
  "#b89875",
  "#a68766",
  "#8e6f50",
  "#f0e1cf",
  "#92b9ae",
  "#e6d3be",
  "#ddc6ae",
  "#dbbda1",
  "#c9a98a",
  "#b29172",
  "#a47f61",
  "#8e6b4e",
  "#e9ddd1",
  "#e3d3c4",
  "#d9c5b5",
  "#5d877b",
  "#d0bcaa",
  "#cab29d",
  "#af957f",
  "#8c715e",
  "#775d4b",
  "#f3e4d3",
  "#f0dcc8",
  "#edd2b9",
  "#e8cbb0",
  "#e4c2a2",
  "#d8e9df",
  "#d4ab88",
  "#b28461",
  "#9a6c4c",
  "#f4e5d8",
  "#e9d4c0",
  "#e5cab4",
  "#dcbca2",
  "#cba589",
  "#b78e70",
  "#a67d61",
  "#cde2d7",
  "#856048",
  "#f0e1d4",
  "#e4cfbe",
  "#dcc1ad",
  "#d7b8a1",
  "#bf9b83",
  "#a9836b",
  "#9c7760",
  "#87624c",
  "#f2e6dc",
  "#b3d0c3",
  "#ead4c5",
  "#dbbeab",
  "#d5b49f",
  "#be9780",
  "#ad856e",
  "#9b745f",
  "#7f5946",
  "#f9e9db",
  "#f5d8c3",
  "#efccb3",
  "#9bbdad",
  "#ebc4a8",
  "#e6bb9c",
  "#d6a07e",
  "#b87d5c",
  "#9e6446",
  "#f4e2d5",
  "#efd8c9",
  "#debca8",
  "#d9b39c",
  "#cba189",
  "#8cb1a0",
  "#ba8971",
  "#a87761",
  "#765044",
  "#f5dcd1",
  "#eecbbc",
  "#eac0b0",
  "#e4b4a2",
  "#dfaa95",
  "#cb8e79",
  "#ac6c58",
  "#688d78",
  "#9a5040",
  "#f6e5dc",
  "#f0d2c6",
  "#e3baab",
  "#ddb0a0",
  "#d19d8b",
  "#b97a67",
  "#a86b59",
  "#8a5343",
  "#faece5",
  "#e5f2e0",
  "#f7dfd5",
  "#f1c7b9",
  "#e5ac9b",
  "#e0a18e",
  "#cc8470",
  "#b36654",
  "#8c463b",
  "#eed7d1",
  "#e8c9c2",
  "#dfbab2",
  "#ffc87e",
  "#dceedb",
  "#d3a9a1",
  "#cd9e93",
  "#ac766a",
  "#966257",
  "#6d4643",
  "#ebddd6",
  "#d9c4bc",
  "#cbb3ab",
  "#c2a89e",
  "#b2968b",
  "#cbe8d0",
  "#987b71",
  "#80645b",
  "#694b40",
  "#ebdfd8",
  "#d6c9c2",
  "#cbbab3",
  "#c0afa8",
  "#b7a39b",
  "#8f776e",
  "#78615a",
  "#b5ddbb",
  "#5a443e",
  "#f9e7e1",
  "#f5d5ce",
  "#eebfb8",
  "#e5ada4",
  "#d59185",
  "#bd7367",
  "#a65a4f",
  "#884842",
  "#e9d8d5",
  "#a0d6aa",
  "#dfccc9",
  "#d6bdbb",
  "#c7acab",
  "#c1a19e",
  "#a58280",
  "#856161",
  "#6c4247",
  "#efe0e0",
  "#e7d4d5",
  "#dbc2c5",
  "#6bb372",
  "#d0b3b6",
  "#c9a8aa",
  "#b18c8f",
  "#91696c",
  "#7c4953",
  "#f3dfe2",
  "#e9c9d1",
  "#e0bac4",
  "#d9b0b9",
  "#e8f3de",
  "#c3919e",
  "#a4707c",
  "#7a445a",
  "#f3e4e5",
  "#e9d0d5",
  "#dcbac1",
  "#d6b3bb",
  "#d0a9b0",
  "#b48992",
  "#95666e",
  "#e0f1d7",
  "#784b5d",
  "#e9e0dd",
  "#d5c9c7",
  "#cabab8",
  "#bba8a6",
  "#b09d99",
  "#927d7b",
  "#735f5c",
  "#59453f",
  "#dbd1cc",
  "#d5ebcc",
  "#cfc3be",
  "#c1b4ae",
  "#b6a59e",
  "#9c8b84",
  "#817069",
  "#776760",
  "#504440",
  "#eadccd",
  "#e3d1c0",
  "#d5bfa9",
  "#c6e4b7",
  "#cfb79b",
  "#bfa389",
  "#a5876d",
  "#94775f",
  "#82644d",
  "#eae2db",
  "#dacec5",
  "#c6b8ad",
  "#beaea0",
  "#ae9c8f",
  "#b0daa3",
  "#968275",
  "#837164",
  "#655449",
  "#e5dcd3",
  "#ded2c8",
  "#d2c4b9",
  "#c5b4a8",
  "#bdaa9b",
  "#a79182",
  "#826d61",
  "#ffa840",
  "#7ebb69",
  "#645246",
  "#e4eee2",
  "#dce8da",
  "#ccddcd",
  "#b7ceb9",
  "#a1bca4",
  "#708b70",
  "#e4eedc",
  "#dde8d4",
  "#d1e0c8",
  "#fee8c9",
  "#bccfaf",
  "#a9c09a",
  "#859e6e",
  "#ebf1da",
  "#e6f0d3",
  "#d7ebc9",
  "#c6e4b3",
  "#b6dca1",
  "#86bd65",
  "#ebf2dc",
  "#ffe3ba",
  "#e7efd3",
  "#f5decd",
  "#efcfbd",
  "#e7c0ac",
  "#d7a893",
  "#c7917b",
  "#b77961",
  "#9d5e46",
  "#f2e0d4",
  "#efd6ca",
  "#dfecc8",
  "#e5c1b3",
  "#d9ad9e",
  "#c5988c",
  "#a06856",
  "#7c4637",
  "#f1d0c0",
  "#e4b7a5",
  "#d4a293",
  "#c89181",
  "#af705d",
  "#d1e5b0",
  "#a1614c",
  "#864a36",
  "#f7e7dd",
  "#f6d5cb",
  "#f0bcb1",
  "#cd8279",
  "#b2655b",
  "#894f45",
  "#833e37",
  "#ecbcb9",
  "#c4de9e",
  "#d39595",
  "#bf7d7c",
  "#b06764",
  "#a85f5a",
  "#883739",
  "#883b3c",
  "#f6ded6",
  "#e5c4c1",
  "#deb8b5",
  "#cda2a0",
  "#99c261",
  "#b78686",
  "#9a6664",
  "#794840",
  "#f6e6e2",
  "#e3c8c8",
  "#dab8bb",
  "#c69fa3",
  "#ba8b8e",
  "#926165",
  "#70423e",
  "#ebf1d8",
  "#f0d5d4",
  "#e7c9ca",
  "#e0bbbf",
  "#d2a2a9",
  "#bd8791",
  "#9f666f",
  "#784548",
  "#e6bbbd",
  "#d2a7ad",
  "#c39195",
  "#e6efd0",
  "#a97174",
  "#9f6365",
  "#804f50",
  "#713a3f",
  "#f2e2de",
  "#dec2c3",
  "#ba9aa1",
  "#a07d84",
  "#865f62",
  "#723a3e",
  "#e0ecc4",
  "#643937",
  "#d8b8be",
  "#d1aeb4",
  "#c09ca5",
  "#a87e88",
  "#8d5f64",
  "#75434e",
  "#5f3b42",
  "#e9c8cb",
  "#e0b7bd",
  "#d9e6b3",
  "#cca4ad",
  "#b28592",
  "#986973",
  "#6a3545",
  "#753843",
  "#eed5cf",
  "#e1bdb9",
  "#c59896",
  "#a56f69",
  "#834b43",
  "#d2e09d",
  "#7e4337",
  "#794135",
  "#ede0d6",
  "#e1cac0",
  "#d3b9b1",
  "#bd9d95",
  "#a6847c",
  "#8c665c",
  "#6e493d",
  "#e9dbd1",
  "#ffdeb0",
  "#aec361",
  "#d9c1b6",
  "#b79d94",
  "#a48980",
  "#96786c",
  "#7d5f53",
  "#634436",
  "#d8c8be",
  "#ccbab1",
  "#b5a097",
  "#a38b82",
  "#e7ead5",
  "#796359",
  "#644d43",
  "#463832",
  "#efdfd4",
  "#e6d4c9",
  "#d0b9ab",
  "#c6a898",
  "#b08e7e",
  "#916c5d",
  "#6f4d3f",
  "#e1e4c9",
  "#eed7c3",
  "#e4cab5",
  "#ddbea6",
  "#cba387",
  "#b3876c",
  "#a07154",
  "#835a42",
  "#efdecd",
  "#e7ccb5",
  "#debca3",
  "#d6dbbc",
  "#c9a992",
  "#ad8c74",
  "#9f7a60",
  "#926d53",
  "#f5e3cf",
  "#e5ccb5",
  "#dbbea4",
  "#cfac8e",
  "#bd9371",
  "#9c7150",
  "#c4cca4",
  "#855d43",
  "#eadcca",
  "#e2ceb9",
  "#c0a78d",
  "#af947b",
  "#9b7c61",
  "#886c52",
  "#7e5e44",
  "#ebded1",
  "#decebf",
  "#b2be90",
  "#d8c6b4",
  "#c8b7a5",
  "#b7a28d",
  "#896f59",
  "#6a5545",
  "#ede1d2",
  "#ccbaaa",
  "#bca998",
  "#ac9784",
  "#8b7562",
  "#8b975f",
  "#705a49",
  "#705844",
  "#e5ded2",
  "#dad0c4",
  "#cfc4b6",
  "#c0b4a6",
  "#a79a8a",
  "#837463",
  "#615447",
  "#ece7d9",
  "#eeefd3",
  "#dfd5c7",
  "#d0c6b8",
  "#b6ac9f",
  "#a69b8d",
  "#827665",
  "#61574b",
  "#ede7dc",
  "#ddd5cb",
  "#cdc6bb",
  "#bfb5a8",
  "#eaecc4",
  "#a89b8d",
  "#7f7366",
  "#61554c",
  "#e6ded1",
  "#ded4c5",
  "#d1c6b6",
  "#a89e92",
  "#827667",
  "#6f6355",
  "#5a4e41",
  "#e4e7b6",
  "#e6dfcc",
  "#e3d8c6",
  "#d9ceba",
  "#c0b39e",
  "#b1a390",
  "#8b7c69",
  "#695c4a",
  "#e2ddd0",
  "#dbd3c5",
  "#d2c9ba",
  "#ffd89f",
  "#dbe4a4",
  "#c2b9aa",
  "#ada08d",
  "#887964",
  "#675948",
  "#e8d1b7",
  "#e1c5a8",
  "#d3b295",
  "#bc9b7d",
  "#ac8868",
  "#9c7657",
  "#d5dd97",
  "#8c6747",
  "#eaccaa",
  "#e3bf99",
  "#d4ab83",
  "#ca9e71",
  "#ba895c",
  "#b3845d",
  "#a77953",
  "#f4e4cd",
  "#eed3b6",
  "#b9c65f",
  "#e1c3a1",
  "#debc97",
  "#d6af86",
  "#c49668",
  "#a47347",
  "#ebd6bb",
  "#e4cbac",
  "#d2b89b",
  "#bc9c7c",
  "#ae8f6c",
  "#f4f3d5",
  "#9e7d5a",
  "#8c6947",
  "#e6d3ba",
  "#dfc7a9",
  "#d1b897",
  "#be9f7a",
  "#a7825a",
  "#8b673f",
  "#7f6040",
  "#e9decf",
  "#efeec8",
  "#ddcfbb",
  "#dacab5",
  "#d0b99c",
  "#bca382",
  "#a38867",
  "#876c4c",
  "#e1d1ba",
  "#d6c3a8",
  "#c6b297",
  "#bfa88a",
  "#e9ebb9",
  "#b79b77",
  "#a18663",
  "#775e3d",
  "#f2e6d3",
  "#eadac4",
  "#e0cab0",
  "#dfc5a2",
  "#c9ae89",
  "#a48661",
  "#8d704f",
  "#e1e4a0",
  "#f2e8d5",
  "#e7d5ba",
  "#e2cdaf",
  "#d5be9e",
  "#c9ad88",
  "#b19670",
  "#8c6d46",
  "#f3e8d4",
  "#efe1c9",
  "#e2ceaf",
  "#dbe091",
  "#baa07e",
  "#b1956d",
  "#9f835c",
  "#816643",
  "#f2e7d3",
  "#f1e1c8",
  "#e3cba5",
  "#ceb692",
  "#bba179",
  "#af9266",
  "#c7d060",
  "#8e7249",
  "#ecdec6",
  "#e5d5bb",
  "#ddc9ab",
  "#d8c3a0",
  "#c4ac87",
  "#ad9168",
  "#8a714b",
  "#ece2ce",
  "#e2d2b4",
  "#f0f0dd",
  "#dbc9a7",
  "#bba57d",
  "#ad9469",
  "#917951",
  "#7f6a45",
  "#ede3ce",
  "#e0d2b7",
  "#d7c5a6",
  "#cfbd9c",
  "#c1af8a",
  "#ffc982",
  "#e9e5cc",
  "#9e8b66",
  "#796747",
  "#e5dccb",
  "#e0d3c0",
  "#c4b8a7",
  "#ac9e89",
  "#9d8d74",
  "#8e7d64",
  "#5d4d39",
  "#e7dfcc",
  "#e2dfc1",
  "#d7ccb8",
  "#cdc2ae",
  "#c7baa2",
  "#b4a78d",
  "#948366",
  "#6c5e48",
  "#ddd3be",
  "#d0c4ad",
  "#c4b69e",
  "#a8987d",
  "#d2d1a8",
  "#92856b",
  "#7a684a",
  "#746548",
  "#f3f0e5",
  "#eee9db",
  "#dedaca",
  "#c7bea7",
  "#a29374",
  "#8c7c5c",
  "#74674a",
  "#c1c394",
  "#eee7d7",
  "#e3d8c1",
  "#d0c3a6",
  "#a29475",
  "#91815e",
  "#817152",
  "#776746",
  "#dcd7ca",
  "#cac5b3",
  "#c1bead",
  "#9b9d64",
  "#ada58f",
  "#918971",
  "#706851",
  "#655b41",
  "#ebe3d2",
  "#d3cbb4",
  "#c9bfa7",
  "#a09a84",
  "#8f866d",
  "#81775f",
  "#f4ecd5",
  "#736548",
  "#eee4cb",
  "#ece1c7",
  "#decea7",
  "#d1bf92",
  "#bea874",
  "#af9a64",
  "#79683c",
  "#efe9d4",
  "#e8dcbe",
  "#f0ebd3",
  "#dfd1ae",
  "#cdbf9a",
  "#bdae85",
  "#b2a06e",
  "#7b6c39",
  "#efead3",
  "#e2d6b3",
  "#d6c9a0",
  "#c6b78f",
  "#b3a476",
  "#eae3c6",
  "#9a8959",
  "#877545",
  "#e6e4ce",
  "#dddbc1",
  "#d2cfb2",
  "#c4c1a0",
  "#b9b48f",
  "#968f64",
  "#6b6645",
  "#f3f1e7",
  "#ded6af",
  "#efecdf",
  "#dfdcce",
  "#c6c3ae",
  "#a09c7c",
  "#827f5d",
  "#63613e",
  "#ece7da",
  "#dbd5c5",
  "#c4bdac",
  "#a8a699",
  "#d3c898",
  "#959485",
  "#6c695a",
  "#5a5445",
  "#e2e0ce",
  "#d5d5c4",
  "#bcc0aa",
  "#93967a",
  "#7c7e63",
  "#595945",
  "#48493b",
  "#ffa943",
  "#b3a567",
  "#edebdc",
  "#dadcc8",
  "#c4c9af",
  "#9ba08c",
  "#868971",
  "#747860",
  "#5a5b44",
  "#e3e5dc",
  "#ced1c8",
  "#aeb4aa",
  "#f4efd1",
  "#868b80",
  "#605c50",
  "#574f42",
  "#52483c",
  "#eaebe3",
  "#dadbd4",
  "#bfc1ba",
  "#9b9e95",
  "#6f6a5e",
  "#575042",
  "#f3ecc4",
  "#4a4234",
  "#d7dbce",
  "#cdd3c6",
  "#c2c9bc",
  "#a8b2a3",
  "#96a293",
  "#717c6d",
  "#51594c",
  "#dddfd4",
  "#ced4ca",
  "#f2eab7",
  "#bec7bc",
  "#a7b2a8",
  "#919f97",
  "#69786f",
  "#485048",
  "#e6e9e0",
  "#d9e2db",
  "#c1d1ca",
  "#adc1bb",
  "#7b9290",
  "#eae19a",
  "#596e6a",
  "#274241",
  "#d8ddd3",
  "#c9d0ca",
  "#bbc4bc",
  "#aeb7b0",
  "#909b96",
  "#68706c",
  "#505854",
  "#dbe3d9",
  "#e5db8b",
  "#c9d5ce",
  "#b1c1be",
  "#9cafac",
  "#869c9b",
  "#617373",
  "#455454",
  "#c4cdc8",
  "#b9c3bf",
  "#9daaaa",
  "#7f8f90",
  "#d4ca5a",
  "#6c7978",
  "#5b6868",
  "#363c3d",
  "#dae4dd",
  "#c1d3cf",
  "#b2c6c6",
  "#94adaf",
  "#7e999d",
  "#5a7174",
  "#3e4d50",
  "#f9f3de",
  "#d6dddb",
  "#bccacc",
  "#9cb1b9",
  "#899aa2",
  "#71838c",
  "#5f6d74",
  "#48484a",
  "#e2e2dd",
  "#c8cccc",
  "#aab1b5",
  "#fbf1d1",
  "#8f99a1",
  "#697077",
  "#535b62",
  "#2e2e30",
  "#dddcda",
  "#d0d0cf",
  "#b6b8bb",
  "#9ea3aa",
  "#79818b",
  "#6b6f77",
  "#fbeec6",
  "#393a3f",
  "#e5e4dd",
  "#cbcdca",
  "#b7bab9",
  "#9aa1a3",
  "#7f8788",
  "#636869",
  "#3b3b3b",
  "#d5d4ce",
  "#c9c7c2",
  "#fbead3",
  "#fae7b2",
  "#b7b6b1",
  "#9fa09f",
  "#7f8181",
  "#434341",
  "#e2ded8",
  "#d6d1cb",
  "#c6c3be",
  "#b3b0ad",
  "#9d9d9c",
  "#f1e099",
  "#81807f",
  "#403c38",
  "#e3dcd4",
  "#d9d6d1",
  "#c8c8c5",
  "#afadab",
  "#9c9b99",
  "#756f6d",
  "#5f524d",
  "#cbc5c0",
  "#dcc759",
  "#bcb6b3",
  "#b2aba7",
  "#989493",
  "#7b7778",
  "#5f5755",
  "#453e3b",
  "#efeade",
  "#ddd4c7",
  "#d4c8ba",
  "#ada49a",
  "#f2e9d1",
  "#938c83",
  "#81796e",
  "#605447",
  "#eae2d8",
  "#cec5ba",
  "#c5bbaf",
  "#a59d93",
  "#83796d",
  "#70665c",
  "#524b40",
  "#efe2c5",
  "#d4d0c5",
  "#c0b9ac",
  "#a5a198",
  "#87847c",
  "#767166",
  "#6d685e",
  "#4c453c",
  "#d9d8d0",
  "#c4c3b9",
  "#b5b6ad",
  "#e8d7b3",
  "#838782",
  "#6d6f68",
  "#5f605b",
  "#4a4a43",
  "#dbe2e3",
  "#c1d2de",
  "#a4bdd1",
  "#7a97b2",
  "#5b7b97",
  "#557591",
  "#dccba3",
  "#394d63",
  "#c3d5e3",
  "#aec8de",
  "#a1bfda",
  "#92b2d0",
  "#729ac1",
  "#517da7",
  "#214e82",
  "#d9e3e8",
  "#cfbd90",
  "#c1d6e7",
  "#a4c1e0",
  "#8eb0d8",
  "#4475b1",
  "#2c4277",
  "#d4e2eb",
  "#b9d4e8",
  "#98bfe1",
  "#85b0da",
  "#659ace",
  "#b49c63",
  "#3f80bb",
  "#2a5089",
  "#c7dae3",
  "#b2ccdc",
  "#9dc0d6",
  "#81a5bf",
  "#6893b2",
  "#426d8c",
  "#304359",
  "#d2ddde",
  "#ece7d1",
  "#c5d2d8",
  "#b5c8d2",
  "#99afbd",
  "#849caf",
  "#597285",
  "#3f5265",
  "#dee4de",
  "#c6d3d5",
  "#b3c6cc",
  "#95adb8",
  "#f8dc8a",
  "#ffe6c6",
  "#e3dfc7",
  "#7f9ba9",
  "#55717e",
  "#3e5462",
  "#e0ebe8",
  "#c3dee8",
  "#a4d2e8",
  "#83c3e3",
  "#60acd9",
  "#0184bf",
  "#10558e",
  "#dfd6b7",
  "#c9dcde",
  "#b8d2da",
  "#a9c7d4",
  "#8ab3cb",
  "#72a1be",
  "#487e9d",
  "#335b74",
  "#d8e2df",
  "#bcd8df",
  "#a8cedb",
  "#d2c59d",
  "#8cbbce",
  "#68a4bf",
  "#357d9a",
  "#275b75",
  "#dfece9",
  "#c1e5e9",
  "#9ad8e3",
  "#72cade",
  "#4cb8d2",
  "#13a9c7",
  "#c3b68a",
  "#005b76",
  "#e7eee9",
  "#cee3e2",
  "#bcdadc",
  "#90bac2",
  "#649aa4",
  "#458087",
  "#2e545a",
  "#e0eee8",
  "#c2e8e7",
  "#a59562",
  "#97dade",
  "#65c6d0",
  "#02afbd",
  "#0098a5",
  "#006176",
  "#d1eee7",
  "#c1e8e2",
  "#a6e3dd",
  "#80d9d5",
  "#23b8b3",
  "#ece7d9",
  "#00a59d",
  "#006a63",
  "#e2ede5",
  "#d7e9e2",
  "#b7ddd7",
  "#90c2c0",
  "#5a9c98",
  "#408480",
  "#095355",
  "#dff0e7",
  "#e4dece",
  "#bee8dd",
  "#92dacb",
  "#7bcabd",
  "#50b3a5",
  "#249c8a",
  "#046657",
  "#e5ecdf",
  "#c5d8cf",
  "#b9cfc5",
  "#a8c1b6",
  "#dbd5c2",
  "#8faba0",
  "#698679",
  "#4d6458",
  "#d5e9dd",
  "#bcdfcf",
  "#a9d5c3",
  "#97c2b1",
  "#71a793",
  "#528a71",
  "#1b5240",
  "#cdc3ab",
  "#dbf0e0",
  "#c1e7d3",
  "#b0e1c9",
  "#8dcbaa",
  "#68b38c",
  "#469b6b",
  "#186d46",
  "#e3eddd",
  "#dae9d7",
  "#cae3ca",
  "#b9b098",
  "#aed2b1",
  "#81a981",
  "#6b9364",
  "#58784a",
  "#ebefe0",
  "#ddebd3",
  "#b3d9b0",
  "#a3ca9e",
  "#86b37b",
  "#699b5a",
  "#ffdcb3",
  "#908365",
  "#427736",
  "#e1ead6",
  "#c5d9c5",
  "#c0d7bf",
  "#a5c2a7",
  "#91b092",
  "#6f8e6d",
  "#4e6346",
  "#e4e5d1",
  "#d0d6c0",
  "#f3ebdb",
  "#bfcab2",
  "#b1c0a4",
  "#9ca98a",
  "#818f6e",
  "#596346",
  "#e9e9d4",
  "#d4d8bf",
  "#c8cdb0",
  "#c0c4a1",
  "#aeb58f",
  "#f0e5cf",
  "#8e9369",
  "#626641",
  "#ebecd7",
  "#d2dab9",
  "#c7d2ae",
  "#c0cba3",
  "#a9b788",
  "#8fa16e",
  "#6e7c4a",
  "#e7edd6",
  "#e9dac1",
  "#d5e5c1",
  "#c4dbaf",
  "#bbd09f",
  "#9bba7e",
  "#87a65e",
  "#67853c",
  "#f1efd9",
  "#e5e9c5",
  "#d8e2af",
  "#c9d497",
  "#dfcba9",
  "#b4c478",
  "#9eb356",
  "#819c34",
  "#efebc7",
  "#e8e6b6",
  "#e5e1ac",
  "#d8d38f",
  "#cac77a",
  "#afae54",
  "#9c9b36",
  "#cfba96",
  "#e9e7cb",
  "#dbd9b3",
  "#d3cfa1",
  "#c2be86",
  "#aba364",
  "#979251",
  "#7e7b3e",
  "#ebe3c4",
  "#e2dcb7",
  "#dad1a4",
  "#ab9064",
  "#cbbf86",
  "#beb064",
  "#ada04f",
  "#91893e",
  "#f5ecd0",
  "#f0e5bc",
  "#efdfab",
  "#e4cf8d",
  "#cfb661",
  "#bda246",
  "#f0eadc",
  "#a79038",
  "#fbf0d1",
  "#f6e0b2",
  "#f2d79f",
  "#eaca8c",
  "#dab05f",
  "#cea34c",
  "#bf943a",
  "#f6ebcc",
  "#f4e1b5",
  "#e9e2d1",
  "#f3d9a4",
  "#eecb85",
  "#eec46f",
  "#e1b45a",
  "#60696f",
  "#cf9b33",
  "#f6eed7",
  "#f8f0d7",
  "#fceec8",
  "#fddb97",
  "#fbcd74",
  "#e3d8c6",
  "#f8bf4a",
  "#eba611",
  "#f9f2da",
  "#faf1d3",
  "#fceec3",
  "#feedbd",
  "#ffda8a",
  "#fbc450",
  "#f5ae2f",
  "#f9ebc7",
  "#ffd198",
  "#d4c6ae",
  "#f9e6ab",
  "#fce198",
  "#ffdd82",
  "#face59",
  "#f6c33a",
  "#f2b71b",
  "#fbf4de",
  "#ffefc3",
  "#ffeaa3",
  "#ffd863",
  "#c4b69b",
  "#fcc719",
  "#f4bf00",
  "#f4bf00",
  "#faf4de",
  "#fdf0c8",
  "#feeeb8",
  "#ffea9b",
  "#ffe57e",
  "#ffd441",
  "#ffc60f",
  "#9b8868",
  "#f9f5e6",
  "#faf0d6",
  "#fdecc5",
  "#ffe19d",
  "#ffd77b",
  "#ffc43b",
  "#ffb400",
  "#f8eccf",
  "#fae3b6",
  "#fadea4",
  "#f3e7ce",
  "#f9d286",
  "#ecb85a",
  "#e1a845",
  "#d29a30",
  "#f4e8cf",
  "#f2e0bb",
  "#efd6a9",
  "#e2c697",
  "#c49f60",
  "#bb965b",
  "#eee0c1",
  "#a87f3d",
  "#f9e4c6",
  "#f5ddbb",
  "#f1d9b6",
  "#e0c092",
  "#d1aa73",
  "#c39a60",
  "#ab8149",
  "#f2e1c5",
  "#ead3b0",
  "#e8d9b7",
  "#e8cfa8",
  "#dcc094",
  "#c9a671",
  "#b48e55",
  "#977540",
  "#f0e0c5",
  "#ead9be",
  "#ebd2ad",
  "#d5b286",
  "#c29c6c",
  "#e5d0a7",
  "#b38d5e",
  "#96713f",
  "#f6e7ce",
  "#f5dcbc",
  "#eecea7",
  "#e0b886",
  "#d4a56d",
  "#bb8a4d",
  "#ae7d43",
  "#f0e6d2",
  "#dcc495",
  "#f6d9b4",
  "#f1cd9f",
  "#edc795",
  "#e3b780",
  "#d39d58",
  "#b37d36",
  "#f4ebd9",
  "#fae2be",
  "#f9d5a4",
  "#edbc81",
  "#c3a061",
  "#e0aa6a",
  "#d5994e",
  "#c28332",
  "#f1e2c8",
  "#f8e4c7",
  "#efd0a6",
  "#eacba2",
  "#dfba8a",
  "#c7995d",
  "#ae793b",
  "#f1e7d6",
  "#f1e7d0",
  "#fddeb2",
  "#f8d29c",
  "#f3c990",
  "#ecbd7d",
  "#dfa453",
  "#c1852e",
  "#f1eddf",
  "#f9f1db",
  "#fce5bc",
  "#ffc382",
  "#eddfca",
  "#f9d092",
  "#ebb86e",
  "#e2a74c",
  "#cc8d2a",
  "#f5ebd4",
  "#fff1d2",
  "#ffdb9f",
  "#ffd088",
  "#fdbc5c",
  "#fbae39",
  "#e8d7be",
  "#e89600",
  "#f5e7ca",
  "#ffecc3",
  "#ffe5ad",
  "#ffdc96",
  "#ffc562",
  "#ffba2e",
  "#ffa200",
  "#f4ebd6",
  "#ffedc2",
  "#dec9a9",
  "#ffe19e",
  "#ffc85e",
  "#ffb425",
  "#ffa90c",
  "#f9a00a",
  "#f4ecda",
  "#ffeac7",
  "#ffd79d",
  "#ffc87f",
  "#ffb762",
  "#d0b692",
  "#ffa335",
  "#fe8c00",
  "#f7e3c9",
  "#ffe7c5",
  "#ffd4a5",
  "#ffd19f",
  "#fba763",
  "#ff9545",
  "#f2771f",
  "#f5e2ca",
  "#be9764",
  "#fed9b7",
  "#ffca9d",
  "#fdb47d",
  "#f4a062",
  "#f89451",
  "#e57b35",
  "#f2dcc2",
  "#ffdbb8",
  "#fecfa5",
  "#f8be90",
  "#f9ecd9",
  "#eba46e",
  "#e59351",
  "#cd7933",
  "#f5ecde",
  "#fbe5cc",
  "#f5d0ab",
  "#e7b27e",
  "#cd8d4e",
  "#c17f43",
  "#b77438",
  "#f9e8cf",
  "#eedac7",
  "#f7d9c1",
  "#f3cfb3",
  "#e6b994",
  "#d29666",
  "#ce8f5b",
  "#ab6f3c",
  "#f4e5d3",
  "#f6dcc3",
  "#f5d1b3",
  "#f7ddbe",
  "#dfb496",
  "#d4a582",
  "#bf845e",
  "#a46843",
  "#edd0b8",
  "#f0c8ab",
  "#ebc1a2",
  "#ddac8d",
  "#c78e6c",
  "#b3744d",
  "#f0cea4",
  "#985b36",
  "#f2dfcb",
  "#f9dac5",
  "#f4d0b9",
  "#ebb08c",
  "#d58c61",
  "#cc8258",
  "#af673b",
  "#f2ece0",
  "#fdeddc",
  "#e9bb89",
  "#fdd5bb",
  "#fcc9aa",
  "#ec9c74",
  "#e38859",
  "#c66333",
  "#f2e9dc",
  "#fdead7",
  "#ffe4cb",
  "#feba93",
  "#fa9d70",
  "#ffa045",
  "#db964b",
  "#f98950",
  "#dd692d",
  "#f0c8ae",
  "#f2c3a7",
  "#edb091",
  "#dd9675",
  "#c9734c",
  "#a65b3b",
  "#914332",
  "#f8e2d3",
  "#faeedb",
  "#ffdcc8",
  "#ffd1b9",
  "#feb298",
  "#f39576",
  "#f57f58",
  "#e3592e",
  "#f2ddd3",
  "#fad0c1",
  "#f6c4b4",
  "#ebad9a",
  "#fcebd1",
  "#d48069",
  "#a54f38",
  "#9a4b3a",
  "#ebe0d7",
  "#f6ddd0",
  "#f1c4b2",
  "#e5a794",
  "#d49382",
  "#c07765",
  "#833928",
  "#f9e1bf",
  "#f3e6dd",
  "#fcd3c5",
  "#f4b1a2",
  "#eb9987",
  "#db7862",
  "#ba4f3f",
  "#b5503e",
  "#f3dbcf",
  "#f9dcd3",
  "#f7cec6",
  "#f6d7ab",
  "#e9aea5",
  "#d5867a",
  "#c77264",
  "#a24d3d",
  "#f2e7e0",
  "#fbe1dc",
  "#ffcdca",
  "#fdb1b0",
  "#f19092",
  "#d44539",
  "#ecbf85",
  "#b53637",
  "#f2e2d8",
  "#fad7d3",
  "#fcccc9",
  "#f2a3a1",
  "#e07d79",
  "#d96d68",
  "#b34137",
  "#f4d7d3",
  "#f5cdcb",
  "#d89f57",
  "#f0bcc0",
  "#e5a0a6",
  "#d28186",
  "#ac4844",
  "#98413e",
  "#ebbbc1",
  "#efb0b9",
  "#e0828b",
  "#cc5a61",
  "#be413e",
  "#f7ecdb",
  "#b64548",
  "#9b3e46",
  "#efe5e5",
  "#f9dde3",
  "#f8c4d0",
  "#f5b7c4",
  "#ea8797",
  "#e56e80",
  "#cc2f28",
  "#f3dddb",
  "#f5e6d1",
  "#f8d9dc",
  "#facad0",
  "#fbbcc5",
  "#eb91a0",
  "#bb2c34",
  "#962f2f",
  "#eedfe4",
  "#f7dae4",
  "#f5cddc",
  "#eeb8cc",
  "#f0dfc5",
  "#df84a0",
  "#d66a86",
  "#ae2a3a",
  "#f1dfe2",
  "#f3d1d9",
  "#e1a6b9",
  "#ca7a90",
  "#a74b5a",
  "#a13e57",
  "#9d3b62",
  "#fce7cf",
  "#e7ceaa",
  "#ebc0ca",
  "#f0bcc9",
  "#e5a1b5",
  "#c7758b",
  "#8f3e47",
  "#96434a",
  "#8b3336",
  "#eed6d7",
  "#f4d2d6",
  "#f1c4cc",
  "#d5b78d",
  "#dc9fab",
  "#ce8997",
  "#b75f6a",
  "#972438",
  "#efe4e5",
  "#f2dbe1",
  "#ecccda",
  "#e6c1d3",
  "#d3a8c0",
  "#ad7190",
  "#c89a5c",
  "#79385a",
  "#efe8e6",
  "#f5e5ea",
  "#f3d4e8",
  "#eac0de",
  "#dc9ec9",
  "#cd73ad",
  "#932e5a",
  "#eddde5",
  "#efd9e6",
  "#ede7db",
  "#e9c9e0",
  "#d1a9cd",
  "#c396c0",
  "#aa71a3",
  "#61334c",
  "#e7d8da",
  "#dec7d5",
  "#d8b8cd",
  "#b58aab",
  "#9f7598",
  "#e6ded1",
  "#8e5e80",
  "#593d4f",
  "#eae5e1",
  "#eedfe7",
  "#e9d1e5",
  "#e0c0de",
  "#b993c4",
  "#a679b0",
  "#5d3a63",
  "#e4d5df",
  "#e0d5c4",
  "#e2cfe1",
  "#dac1dd",
  "#c4abcd",
  "#ab90ba",
  "#9a7da9",
  "#52335b",
  "#e4d7e2",
  "#e2d1e5",
  "#d8c3e1",
  "#c4afd5",
  "#d1c2ad",
  "#a994c5",
  "#8c72ad",
  "#583e69",
  "#e6dde0",
  "#e0cdda",
  "#d5bdd1",
  "#beaec2",
  "#a692ad",
  "#8b7491",
  "#513d54",
  "#c2b097",
  "#e7d8d7",
  "#ddc7d2",
  "#d6bbcc",
  "#ac8ca8",
  "#967796",
  "#836381",
  "#544255",
  "#e2d4d7",
  "#ddc8d0",
  "#d1b8c3",
  "#a28b6d",
  "#b8a2b2",
  "#9b8395",
  "#7d6173",
  "#41333e",
  "#e7ddd9",
  "#e1d5d5",
  "#d4c6cb",
  "#c0abb6",
  "#af99a6",
  "#897280",
  "#eae0d3",
  "#4e3944",
  "#e0d8dc",
  "#d3c6d2",
  "#b7a8be",
  "#8f7d97",
  "#594b60",
  "#493d4a",
  "#3b3239",
  "#e6e1df",
  "#e8e1e5",
  "#fee0c2",
  "#e3d7c9",
  "#e0d9e3",
  "#cac0d8",
  "#b7aecb",
  "#9c94b8",
  "#514162",
  "#e3dee2",
  "#e1dce9",
  "#d7d1e6",
  "#c6bde0",
  "#aca8d2",
  "#dacdbd",
  "#9e99c9",
  "#4b4170",
  "#dad8de",
  "#d6d7e3",
  "#c5c8dd",
  "#9ba2c5",
  "#8b93b9",
  "#6d729b",
  "#444265",
  "#cfccda",
  "#cdbaa3",
  "#cac5da",
  "#b3b3cd",
  "#9c9fc6",
  "#9598c1",
  "#7576a8",
  "#433f66",
  "#d9dee9",
  "#d4ddee",
  "#c6d2e9",
  "#b1b9d9",
  "#bca68f",
  "#9ba2cb",
  "#686fa2",
  "#4a4e7f",
  "#e2e7ea",
  "#e0e9f1",
  "#cddbee",
  "#a3bdde",
  "#8ba8d1",
  "#6889bb",
  "#334271",
  "#8e755d",
  "#e2e2dc",
  "#cad1e0",
  "#bbc8de",
  "#a4b4d5",
  "#8ea0c8",
  "#657bae",
  "#485d90",
  "#d9d6db",
  "#d1ceda",
  "#bbb9cc",
  "#ebe5da",
  "#9fa2b7",
  "#8f93ab",
  "#62647c",
  "#403e4e",
  "#dedadb",
  "#c6c2ce",
  "#b2b1c0",
  "#9795a8",
  "#838194",
  "#777587",
  "#e4dbcd",
  "#48414f",
  "#dad4dc",
  "#d8d6de",
  "#cfcad6",
  "#b7b3c8",
  "#a6a1b9",
  "#7d7897",
  "#514259",
  "#e3dcd9",
  "#e4d9d8",
  "#dbd0c0",
  "#bab1bb",
  "#9b919c",
  "#8a7e87",
  "#786b75",
  "#4a3a49",
  "#e1dbd8",
  "#d9cfd3",
  "#ccc1c9",
  "#baafba",
  "#a397a6",
  "#cbbca8",
  "#7a6d7c",
  "#483f49",
  "#d2d1d2",
  "#ceced1",
  "#bebec5",
  "#acaeb7",
  "#9499a5",
  "#676d7b",
  "#50545f",
  "#ddc9b5",
  "#bcac96",
  "#cea897",
  "#e2d0bc",
  "#d7bca5",
  "#cea98f",
  "#c39f80",
  "#867161",
  "#e3cfba",
  "#dbbda2",
  "#bd9175",
  "#8e5f4b",
  "#ffd8b5",
  "#9b866c",
  "#c1a38d",
  "#ab8a72",
  "#8f6d53",
  "#e1cbad",
  "#d3bb9e",
  "#ad9077",
  "#7d6249",
  "#b2967c",
  "#967d68",
  "#846a56",
  "#eee9df",
  "#d7c2a9",
  "#d2bba2",
  "#b49779",
  "#a17f60",
  "#d4bd9f",
  "#c2a787",
  "#a48969",
  "#ccb08c",
  "#c9a87c",
  "#a07f5e",
  "#e7e1d6",
  "#815e44",
  "#c7a379",
  "#aa845b",
  "#8d6a42",
  "#e5caaa",
  "#dbb88e",
  "#d1aa78",
  "#c19662",
  "#d9c2a0",
  "#ccb28e",
  "#ddd6cc",
  "#9f815d",
  "#d7c5a7",
  "#cdb794",
  "#c1a67e",
  "#b09468",
  "#c4b095",
  "#ac9573",
  "#8c7655",
  "#e0d0b7",
  "#e0cbac",
  "#cfc5b7",
  "#b9a181",
  "#918877",
  "#99967e",
  "#6d7061",
  "#5c6557",
  "#979b94",
  "#85897e",
  "#757870",
  "#676a60",
  "#a4a091",
  "#b7aa98",
  "#7d7a6a",
  "#6b6757",
  "#c4c1ae",
  "#b0aa93",
  "#959178",
  "#7b785f",
  "#a5a595",
  "#91907c",
  "#797865",
  "#b7a996",
  "#94836f",
  "#a79982",
  "#81725c",
  "#5d513f",
  "#b1a283",
  "#847964",
  "#aca38e",
  "#c4bcaf",
  "#b0a798",
  "#968a77",
  "#7c705d",
  "#e2ded7",
  "#b8b3a4",
  "#a79e8d",
  "#776e5f",
  "#dacab3",
  "#b4a088",
  "#94816a",
  "#826d54",
  "#bdb09e",
  "#ae9e87",
  "#8e7c68",
  "#d8cec6",
  "#bbb0a3",
  "#ab9c8c",
  "#958677",
  "#7c6f61",
  "#ac9c8a",
  "#958676",
  "#7e6f5f",
  "#d1c6b8",
  "#b1a596",
  "#7b6e66",
  "#cbbfb7",
  "#63524f",
  "#9e9081",
  "#928676",
  "#7f7468",
  "#d6c7b7",
  "#bcac9f",
  "#998272",
  "#765e4a",
  "#a69280",
  "#7e6958",
  "#ffc89b",
  "#bdada2",
  "#6b5d54",
  "#a8b4b6",
  "#8d9a9e",
  "#626e71",
  "#566062",
  "#73808a",
  "#5f6a73",
  "#5a6e77",
  "#b4c0c5",
  "#a0afb7",
  "#b4a297",
  "#7f919d",
  "#5d6c75",
  "#49555c",
  "#8f979e",
  "#a8a7a3",
  "#999b9e",
  "#808285",
  "#606061",
  "#d8d1c5",
  "#988174",
  "#aeb0af",
  "#727575",
  "#c5c3bd",
  "#afaba4",
  "#96928d",
  "#c8c4ba",
  "#b0aba0",
  "#ecded0",
  "#e9d7c6",
  "#e4d0bf",
  "#ddc7b1",
  "#d1b69c",
  "#ac8667",
  "#efe3d7",
  "#feb982",
  "#e9dacd",
  "#e2cdbe",
  "#d4b7a4",
  "#c4a08d",
  "#a47a63",
  "#f2e2d7",
  "#efdace",
  "#dfbdae",
  "#cfa592",
  "#bf917d",
  "#e5c152",
  "#f49250",
  "#aa7661",
  "#e6d7cf",
  "#dfccc3",
  "#d5bdb2",
  "#c1a396",
  "#ae8d80",
  "#876255",
  "#e3cfca",
  "#dfc3be",
  "#d4b2ad",
  "#fbe9dc",
  "#c09690",
  "#aa7f79",
  "#835650",
  "#e6dad6",
  "#ddcec9",
  "#d3c0bc",
  "#c1a59f",
  "#ae8d87",
  "#7f5a53",
  "#e5d7d4",
  "#fde3d3",
  "#ddcac8",
  "#cebaba",
  "#bba0a0",
  "#a78a89",
  "#7e5b58",
  "#e9dfdd",
  "#ded1d2",
  "#d2c2c6",
  "#bda5a9",
  "#a88e93",
  "#ffd6c2",
  "#73595d",
  "#e0d5d4",
  "#dacfce",
  "#ccbec0",
  "#b6a4a5",
  "#a08c8d",
  "#6e595a",
  "#e5ddd8",
  "#d9ceca",
  "#c9bcb9",
  "#ffc5aa",
  "#b4a39f",
  "#9c8884",
  "#6f5b58",
  "#e0dcda",
  "#d4d0cf",
  "#c5b9b7",
  "#afa09e",
  "#978684",
  "#6a5855",
  "#e0dfdd",
  "#ffab89",
  "#d8d6d5",
  "#cbc9ca",
  "#b2b0b2",
  "#a19c9d",
  "#5d585b",
  "#dee1df",
  "#cfcfcf",
  "#c2c2c3",
  "#a6a6a7",
  "#909193",
  "#fb8a5c",
  "#636365",
  "#d9dddc",
  "#ced2d4",
  "#bbc2c8",
  "#a5a9b0",
  "#92949a",
  "#676367",
  "#d7dcdd",
  "#bac1c7",
  "#abb4b9",
  "#fae4d2",
  "#8e969e",
  "#828b92",
  "#545b62",
  "#dadfdd",
  "#ccd4d2",
  "#c1cbcb",
  "#a5afb0",
  "#909b9c",
  "#586263",
  "#dbdedc",
  "#f9dbc4",
  "#d0d3d2",
  "#c0c3c3",
  "#a9abaa",
  "#919595",
  "#636564",
  "#e4e3dd",
  "#dddbd6",
  "#d2d0cb",
  "#bcb9b4",
  "#aba8a2",
  "#f7d3b6",
  "#7f7b74",
  "#e6e3dd",
  "#ddd9d2",
  "#d2cdc5",
  "#bfb9ae",
  "#aba499",
  "#82786b",
  "#eeebe4",
  "#eae6e0",
  "#dcd7d0",
  "#f8f1de",
  "#f1c09b",
  "#ccc5bc",
  "#aea499",
  "#8e8074",
  "#dde0db",
  "#d5d6d1",
  "#c6c8c3",
  "#aeb0ab",
  "#999c96",
  "#656760",
  "#dfe3de",
  "#eaaf85",
  "#d7dcd7",
  "#cacfc9",
  "#b7bdb7",
  "#a0a8a2",
  "#767c73",
  "#e9ece2",
  "#e0e3d8",
  "#d2dacf",
  "#bbc5b7",
  "#a8b4a4",
  "#d5864f",
  "#7a8471",
  "#f9e2d2",
  "#fadac4",
  "#f8cfb6",
  "#f3c1a4",
  "#eaa378",
  "#d67e4f",
  "#f9dfd0",
  "#f7efd8",
  "#f6d4c1",
  "#f7ccb5",
  "#efb89d",
  "#e7a587",
  "#ca7451",
  "#ffe5d9",
  "#fedcd2",
  "#ffd0c5",
  "#ffbeaf",
  "#ffae9b",
  "#fbecbd",
  "#f68060",
  "#fbe2df",
  "#ffdad8",
  "#ffcecc",
  "#ffbab6",
  "#ffaaa7",
  "#f67d71",
  "#fbe4df",
  "#fed8d8",
  "#ffccd0",
  "#c25d96",
  "#d1473b",
  "#3a424a",
  "#ffba1b",
  "#734540",
  "#fa9c00",
  "#dd5033",
  "#cf502f",
  "#e75d54",
  "#ee702a",
  "#9d5041",
  "#da4a2d",
  "#c83c3c",
  "#ea634a",
  "#dacc5a",
  "#e76246",
  "#a8ad2f",
  "#e86331",
  "#4b5f3c",
  "#d0683b",
  "#4c9034",
  "#a55d41",
  "#3b5441",
  "#d15c86",
  "#815e4e",
  "#737351",
  "#845142",
  "#67634d",
  "#7b5644",
  "#63c7a5",
  "#6f4f43",
  "#009481",
  "#5c4841",
  "#006158",
  "#6a5244",
  "#a8302e",
  "#054a42",
  "#725846",
  "#00847e",
  "#635245",
  "#126466",
  "#8f614d",
  "#1e4247",
  "#9d6446",
  "#005068",
  "#bd496d",
  "#88634c",
  "#007096",
  "#e96b2e",
  "#008eab",
  "#f37847",
  "#1184ad",
  "#e17137",
  "#00577f",
  "#f07246",
  "#1d4465",
  "#f88038",
  "#9d2b29",
  "#273748",
  "#f88231",
  "#b04b77",
  "#fd9425",
  "#964f7f",
  "#ff9e0f",
  "#5c3b57",
  "#ffa700",
  "#3c3045",
  "#e36475",
  "#ffb318",
  "#645688",
  "#e2b232",
  "#3d475d",
  "#f9a832",
  "#2b3149",
  "#ffc023",
  "#953539",
  "#fdca00",
  "#954740",
  "#d7cb30",
  "#c94435",
  "#773d39",
  "#b09337",
  "#863d30",
  "#947843",
  "#803733",
  "#7b6548",
  "#4f3439",
  "#71654f",
  "#5f4242",
  "#e05b6b",
  "#70633c",
  "#b55f44",
  "#6f634a",
  "#b98838",
  "#867c52",
  "#976d40",
  "#6d6e58",
  "#a35b31",
  "#52514a",
  "#936340",
  "#5a5c4f",
  "#b82c34",
  "#806745",
  "#b6c239",
  "#625842",
  "#90b73e",
  "#cba52c",
  "#619b33",
  "#9d7b2b",
  "#5b954d",
  "#585442",
  "#884646",
  "#4c8c36",
  "#4f4935",
  "#4a814e",
  "#575a4d",
  "#449a47",
  "#46473e",
  "#3c864f",
  "#404948",
  "#42733d",
  "#734935",
  "#a93549",
  "#277041",
  "#604e42",
  "#5b675b",
  "#724637",
  "#43664d",
  "#544540",
  "#006842",
  "#7c4f3b",
  "#00905a",
  "#573f38",
  "#d74d5b",
  "#2b755b",
  "#463a39",
  "#355840",
  "#655e51",
  "#386f64",
  "#564d45",
  "#036152",
  "#745f4a",
  "#009678",
  "#5f4f42",
  "#008e81",
  "#765440",
  "#7b2e39",
  "#3e5e5e",
  "#62493c",
  "#1e5857",
  "#4a3e38",
  "#007b81",
  "#4b555b",
  "#007985",
  "#3c474b",
  "#ce4146",
  "#225159",
  "#4d5659",
  "#007391",
  "#4b545c",
  "#0072ab",
  "#4a4f55",
  "#21617f",
  "#414854",
  "#0069a2",
  "#364452",
  "#224c60",
  "#565457",
  "#284c78",
  "#403d41",
  "#35648e",
  "#313134",
  "#2f6397",
  "#32383a",
  "#485777",
  "#4e4f4f",
  "#b85551",
  "#3a5c8e",
  "#363b40",
  "#515578",
  "#4e5152",
  "#56598f",
  "#71639b",
  "#61588c",
  "#735677",
  "#ffca00",
  "#59414c",
  "#4a4e52",
  "#455153",
  "#414243",
  "#f7835b",
  "#ee6e51",
  "#b6664f",
  "#96644d",
  "#6d423f",
  "#a14746",
  "#90423e",
  "#984a3c",
  "#b8594a",
  "#a84e4d",
  "#ffd43a",
  "#ffd33f",
  "#f6b32f",
  "#caa62b",
  "#d1af2f",
  "#c18946",
  "#de9e4d",
  "#bd8c3c",
  "#ffc228",
  "#ffb02d",
  "#cb4d4e",
  "#f69d31",
  "#ef7434",
  "#df5e3e",
  "#9b4f3e",
  "#9c4640",
  "#91424b",
  "#a24151",
  "#a84e4d",
  "#cb4d4e",
  "#ba4546",
  "#ba4546",
  "#c14e50",
  "#bc4c52",
  "#764255",
  "#724146",
  "#684b4b",
  "#8d5581",
  "#7b436c",
  "#6d435e",
  "#624658",
  "#3c414d",
  "#c14e50",
  "#3e3d52",
  "#364660",
  "#2b4968",
  "#1e4f72",
  "#005d82",
  "#225469",
  "#00728f",
  "#35555d",
  "#00727e",
  "#1e6061",
  "#bc4c52",
  "#354949",
  "#628b57",
  "#81ab2d",
  "#75874f",
  "#316747",
  "#27734f",
  "#3c6a4a",
  "#3e6054",
  "#4c5c52",
  "#665447",
  "#734b53",
  "#7a634c",
  "#5a5046",
  "#5b4740",
  "#373c43",
  "#4f4f55",
  "#3b3b3c",
  "#4c4242",
  "#434c4f",
  "#46484c",
  "#363c3d",
  "#654149",
  "#545453",
  "#883e46",
  "#884a56",
  "#894758",
  "#7f4e63",
  "#ffc228",
  "#804958",
  "#82556a",
  "#814462",
  "#75415f",
  "#78517c",
  "#6b5476",
  "#583f4a",
  "#4f5170",
  "#45496f",
  "#3e3d52",
  "#f6b32f",
  "#5b5b92",
  "#534a6e",
  "#6d415d",
  "#3b5c97",
  "#314570",
  "#3b4557",
  "#394762",
  "#2e4f7b",
  "#365069",
  "#005d91",
  "#e8af51",
  "#006499",
  "#37688f",
  "#095282",
  "#00648b",
  "#00688e",
  "#00798e",
  "#006271",
  "#005969",
  "#166176",
  "#3a555f",
  "#de9e4d",
  "#0f5e7a",
  "#1f7a5d",
  "#00826b",
  "#007b61",
  "#2d5b53",
  "#374f4b",
  "#354949",
  "#008c81",
  "#29686a",
  "#006f6d",
  "#ffb02d",
  "#1e6061",
  "#007764",
  "#008074",
  "#35aa77",
  "#27734f",
  "#5aa06c",
  "#2e9c56",
  "#49865f",
  "#35584a",
  "#dad44a",
  "#ff9735",
  "#a0c54c",
  "#67b254",
  "#628b57",
  "#618152",
  "#3c6a4a",
  "#7f5642",
  "#724e40",
  "#5b4740",
  "#665447",
  "#7a634c",
  "#fd9b62",
  "#5a5046",
  "#4c4242",
  "#3b3b3c",
  "#373c43",
  "#46484c",
  "#363c3d",
  "#434c4f",
  "#ca7d50",
  "#f2e4e5",
  "#b77391",
  "#efd3dc",
  "#e2bece",
  "#cea2b7",
  "#b8889e",
  "#a4748b",
  "#dacec5",
  "#cbbcb4",
  "#b9a9a4",
  "#927e73",
  "#f2d6e6",
  "#7f6d63",
  "#f6e5e6",
  "#f5d7e2",
  "#f4bfd6",
  "#efa5c7",
  "#e88cb3",
  "#f0cfd4",
  "#e8b6c0",
  "#dc9aa7",
  "#cf808c",
  "#e6b1d6",
  "#c06a77",
  "#f2d4d3",
  "#eec1c4",
  "#de9fa4",
  "#c77b7e",
  "#b8676b",
  "#dfd3cf",
  "#ccbcb9",
  "#b8a6a5",
  "#a89392",
  "#d890c0",
  "#7e6865",
  "#ce78b1",
  "#f2d5df",
  "#ecc1d2",
  "#ddaac1",
  "#c989a4",
  "#f6d9de",
  "#d77b91",
  "#efd1cd",
  "#e2b9b6",
  "#daadaa",
  "#ce9896",
  "#ac736f",
  "#ebd9d0",
  "#e0c1b6",
  "#cba59a",
  "#c29a90",
  "#f9c5d6",
  "#a1756a",
  "#f6e2e2",
  "#f8c7d1",
  "#fcacc0",
  "#f78da8",
  "#f27693",
  "#f9ced0",
  "#f3b1b8",
  "#e999a0",
  "#dd8186",
  "#f2a4bf",
  "#cb6e73",
  "#eec6c1",
  "#e3a9a4",
  "#db9b96",
  "#cc8983",
  "#b1665f",
  "#e0d3cc",
  "#cebcb4",
  "#baa59e",
  "#927970",
  "#eb8aa9",
  "#7f675f",
  "#e8789c",
  "#f8c8d2",
  "#f5baca",
  "#f0a5b8",
  "#e48fa3",
  "#fcd7d3",
  "#bb645f",
  "#e2bbb0",
  "#d6a69a",
  "#bf877c",
  "#b07466",
  "#a26557",
  "#e0d0c7",
  "#cab4a9",
  "#baa297",
  "#a4887d",
  "#fec9c8",
  "#8d7066",
  "#ffd5cb",
  "#ffcabf",
  "#ffb5a9",
  "#fb8e7a",
  "#f9836e",
  "#f6ded6",
  "#f2cbc3",
  "#e8b1a8",
  "#cd857c",
  "#ffa5a2",
  "#a85b4f",
  "#e3c3b7",
  "#dab4a7",
  "#c89a8d",
  "#a97868",
  "#a27162",
  "#ebd6cb",
  "#dfc1b1",
  "#d7b6a6",
  "#caa393",
  "#fa8e8a",
  "#a17767",
  "#f6827f",
  "#f6cdca",
  "#ebadab",
  "#de9796",
  "#c46c68",
  "#fce4d7",
  "#c97c60",
  "#f3d9cb",
  "#eac4b2",
  "#dfb0a0",
  "#d29b86",
  "#b2745d",
  "#e9d4c5",
  "#ddbeac",
  "#d1b19f",
  "#b68e7a",
  "#ffd1c0",
  "#a57c68",
  "#fedfca",
  "#ffbe9b",
  "#ffb48e",
  "#ff9e71",
  "#fb8b5d",
  "#fce0c7",
  "#fed7b6",
  "#fbc59f",
  "#efa775",
  "#ffb5a0",
  "#e49665",
  "#f6dac9",
  "#f0c0a8",
  "#e09f84",
  "#d1886a",
  "#c1775a",
  "#ddd6cb",
  "#d0c4b6",
  "#c2b0a3",
  "#a18c80",
  "#f88d71",
  "#8c786c",
  "#f78269",
  "#f7cfbd",
  "#eeb59f",
  "#e5a289",
  "#d78c6f",
  "#ffdfc2",
  "#ed9965",
  "#f2d5bf",
  "#e7bb9d",
  "#ddaa89",
  "#cc936f",
  "#be835f",
  "#ead1c0",
  "#dec1ac",
  "#d2af97",
  "#b78c71",
  "#ffcca0",
  "#a77c62",
  "#ffdfbb",
  "#ffd6a8",
  "#ffc68f",
  "#ffb778",
  "#ff9847",
  "#ffdeba",
  "#ffd5a8",
  "#ffc38b",
  "#fca762",
  "#ffbb86",
  "#f59750",
  "#f5d6bc",
  "#efc09d",
  "#ebb691",
  "#e1a47c",
  "#c9845a",
  "#ead4c4",
  "#debeaa",
  "#d6b29c",
  "#caa08a",
  "#ffa569",
  "#a37660",
  "#ff9555",
  "#ffe1c7",
  "#ffd8b9",
  "#ffc7a1",
  "#fcb68a",
  "#fde0b8",
  "#ff9f50",
  "#fad6b3",
  "#f3c49b",
  "#edac79",
  "#df955f",
  "#d1834f",
  "#ebddcf",
  "#dfcab9",
  "#cbaf9a",
  "#af8f78",
  "#ffdba9",
  "#9f7d67",
  "#f9ebcd",
  "#ffdea9",
  "#ffd28e",
  "#ffc777",
  "#ffaa42",
  "#fbe0c0",
  "#f4d0a9",
  "#ebc296",
  "#d7a56e",
  "#ffc680",
  "#cd975f",
  "#f1dcc6",
  "#eaceb4",
  "#ddba9c",
  "#c1936f",
  "#b1825f",
  "#f0e2d3",
  "#d9bca6",
  "#cbaa90",
  "#b18767",
  "#ffaf59",
  "#a87f63",
  "#ffa348",
  "#fde6c4",
  "#ffd8a9",
  "#ffc98f",
  "#ffa95a",
  "#fce2b4",
  "#e8a950",
  "#f4e6d0",
  "#efd6b7",
  "#e5c6a2",
  "#dbb791",
  "#ba8f64",
  "#dbc9ba",
  "#cbb4a1",
  "#c2aa97",
  "#a58974",
  "#ffdfa4",
  "#9d806b",
  "#f8eed7",
  "#ffe0a4",
  "#ffd98b",
  "#ffd171",
  "#ffbe37",
  "#fbeac9",
  "#ffe1ac",
  "#ffcb7b",
  "#f9b85b",
  "#ffd389",
  "#f3ae4b",
  "#f6e1c3",
  "#eccfa6",
  "#e1bc8a",
  "#d1a76d",
  "#ca9e64",
  "#e8dacd",
  "#dbc8b8",
  "#cfb7a3",
  "#ab8d76",
  "#fecb79",
  "#a1816b",
  "#f5b654",
  "#f9edd3",
  "#ffe1af",
  "#fbc87f",
  "#f3b661",
  "#faedc0",
  "#e7b05a",
  "#f5dbb8",
  "#efcda0",
  "#e7bc86",
  "#d8a86a",
  "#cf9e60",
  "#f1e1d1",
  "#e8cfbc",
  "#c3a288",
  "#a68266",
  "#fee5a2",
  "#9d7a60",
  "#fbedc3",
  "#ffe7a8",
  "#ffdf81",
  "#ffd45f",
  "#ffcd45",
  "#f9eece",
  "#fee9b6",
  "#ffdd95",
  "#f5c569",
  "#fedd88",
  "#efba56",
  "#fcebcc",
  "#fcdcab",
  "#f3c07c",
  "#eeb466",
  "#e3a656",
  "#f1e1cf",
  "#ebd0b5",
  "#dfbd9d",
  "#b99674",
  "#fcce67",
  "#a78565",
  "#f7c04c",
  "#faebcc",
  "#fce1ae",
  "#f6cd89",
  "#efbc6b",
  "#fcebb1",
  "#d3a65f",
  "#fbecd1",
  "#fbdbb1",
  "#f1c58a",
  "#e6b16d",
  "#dca35d",
  "#eeddc8",
  "#dbc6af",
  "#d0b89d",
  "#bfa183",
  "#ffe798",
  "#b68f67",
  "#f6f2d6",
  "#fbedb4",
  "#fdeb9d",
  "#ffe785",
  "#ffde57",
  "#f8e8b8",
  "#f4dea0",
  "#edd085",
  "#dfb960",
  "#ffe482",
  "#dab155",
  "#f5e5cc",
  "#efd4b1",
  "#dcb990",
  "#c69d6f",
  "#bc9365",
  "#f4eddd",
  "#e2d1b6",
  "#ceb898",
  "#baa07c",
  "#ffdc61",
  "#ab916d",
  "#ffd544",
  "#f6e1b8",
  "#f2d49f",
  "#ebc98d",
  "#deb571",
  "#f5e8b4",
  "#caa960",
  "#f4e7cf",
  "#eed6b3",
  "#dcbc90",
  "#cca775",
  "#bd9763",
  "#ddd6c9",
  "#ccc1b2",
  "#bdaf9e",
  "#93826f",
  "#f5e49f",
  "#837462",
  "#e8ebb4",
  "#e0e49c",
  "#dadf90",
  "#c5cd69",
  "#b5c059",
  "#f5edc6",
  "#eee1a6",
  "#e6d38d",
  "#dbc46f",
  "#f0da87",
  "#cbb35d",
  "#eee1c5",
  "#e6d1ad",
  "#dbc398",
  "#bea271",
  "#a78b5a",
  "#dfd9cf",
  "#dcd3c7",
  "#c9beb1",
  "#a39584",
  "#e7cc6a",
  "#948675",
  "#ddbf55",
  "#f5ecca",
  "#f1e0b0",
  "#e7ce8e",
  "#d8b972",
  "#e8e7b8",
  "#bda861",
  "#ede5c8",
  "#e0d4a9",
  "#d4c594",
  "#c0af78",
  "#b09f67",
  "#efe6d8",
  "#ded2c0",
  "#c2b29b",
  "#ac9981",
  "#e1dea1",
  "#9c8971",
  "#e7edb8",
  "#dee89b",
  "#d4e38a",
  "#c3d76c",
  "#b2cd54",
  "#ece6b8",
  "#e4dba0",
  "#d8cf8d",
  "#c5bb6f",
  "#d8d48e",
  "#b6aa5d",
  "#f3eedd",
  "#e1d8b8",
  "#cec097",
  "#b8a97c",
  "#a69669",
  "#ece6d7",
  "#d7ceb9",
  "#c3b79e",
  "#ab9e82",
  "#c6c36f",
  "#988b6f",
  "#b7b55d",
  "#f5efd3",
  "#eee2b5",
  "#ddcc90",
  "#cbb874",
  "#e5e9c8",
  "#a99f64",
  "#e2dabb",
  "#d6cba6",
  "#c9bc92",
  "#b5a87c",
  "#a39668",
  "#ebe3d0",
  "#d7caaf",
  "#beaf91",
  "#aa9a79",
  "#d8dead",
  "#978868",
  "#e7f1c8",
  "#d8eaa9",
  "#c5e18c",
  "#b1d471",
  "#9bc65a",
  "#dfe5c1",
  "#d4dcaf",
  "#bcc88f",
  "#a8b475",
  "#c7cf91",
  "#96a563",
  "#dcddc3",
  "#ceceae",
  "#b9bb95",
  "#a2a37a",
  "#91926a",
  "#ebe5d6",
  "#cec4ad",
  "#ada288",
  "#948a6f",
  "#b2bc76",
  "#887e64",
  "#a2ad63",
  "#e9e4c5",
  "#d9d1a7",
  "#ccc391",
  "#bab077",
  "#d9e6ba",
  "#959d67",
  "#dbdac6",
  "#cccbb2",
  "#bcbba0",
  "#a2a286",
  "#909073",
  "#e1dcd1",
  "#d3cdc1",
  "#b5aea0",
  "#9d9485",
  "#cae1a7",
  "#8a8274",
  "#e5f1d2",
  "#d3ecbb",
  "#b4df95",
  "#9bcf79",
  "#84c161",
  "#e1ecd5",
  "#c8e0bd",
  "#a6ca9a",
  "#8ab67e",
  "#b9d693",
  "#74a56b",
  "#dfe3d1",
  "#c9cfb5",
  "#b3bb9e",
  "#9ca485",
  "#889070",
  "#e3e1da",
  "#d1cec7",
  "#aca9a3",
  "#918f89",
  "#a0c678",
  "#7c7a74",
  "#89b563",
  "#e7ead1",
  "#d5dab3",
  "#c3c99c",
  "#a9af78",
  "#f5f0e5",
  "#f4f0e7",
  "#f5f1e9",
  "#f3f1eb",
  "#f8f4eb",
  "#f4f2ec",
  "#eee6d8",
  "#f5eee3",
  "#f8f1e5",
  "#f6efe3",
  "#f9f2e6",
  "#f4ebdf",
  "#f8efe3",
  "#f5eee5",
  "#f7f0e8",
  "#ede5dd",
  "#f8ede4",
  "#f2ece4",
  "#ebe3d8",
  "#dfd7cc",
  "#f6f0e1",
  "#f2eee2",
  "#f3eee3",
  "#f6f3ed",
  "#eee8dc",
  "#f0ede5",
  "#ece8e0",
  "#f7f5ec",
  "#f9f2e8",
  "#f4efe4",
  "#f1eee3",
  "#e7e4db",
  "#efeadc",
  "#ece7d9",
  "#e1dbca",
  "#e4decf",
  "#f1ece0",
  "#f8f5e6",
  "#f6eede",
  "#ece1cf",
  "#f9f1e1",
  "#efe7d7",
  "#eee2cf",
  "#e4d9c8",
  "#f8ecdc",
  "#f2e3d1",
  "#eedeca",
  "#e4d9ca",
  "#f3efe6",
  "#f4ebda",
  "#ebe2d3",
  "#dad0c1",
  "#faf2e2",
  "#f5ecdc",
  "#f0e6d3",
  "#e5d8c4",
  "#f0e5ce",
  "#f0e3cf",
  "#f0e2ca",
  "#e6d6c2",
  "#d4edcb",
  "#7ca173",
  "#e1e3d0",
  "#d3d6bf",
  "#bcc1a5",
  "#989e7d",
  "#868d6e",
  "#eae7dc",
  "#d5d1c3",
  "#c4bfaf",
  "#aba797",
  "#c6e9bc",
  "#7f7c6c",
  "#e4f2df",
  "#c8ecc8",
  "#98daa0",
  "#79c984",
  "#62bc70",
  "#bedfc0",
  "#acd6b0",
  "#97ca9f",
  "#7ab684",
  "#a8dda0",
  "#62a571",
  "#d4dbc7",
  "#c5ceb4",
  "#aeba9d",
  "#94a182",
  "#818e6e",
  "#d6d6c8",
  "#c5c5b4",
  "#b7b6a4",
  "#9d9c89",
  "#88cb7e",
  "#898977",
  "#6ebd65",
  "#d3e6cc",
  "#c4dcbc",
  "#a4c69e",
  "#8db184",
  "#d1efdc",
  "#699a82",
  "#cddcc4",
  "#b8cdb0",
  "#a6bf9f",
  "#8da884",
  "#7b9671",
  "#deded0",
  "#c8c8b8",
  "#b1b3a0",
  "#9d9f8b",
  "#afe7ca",
  "#898b77",
  "#c2eddc",
  "#abe8d6",
  "#75d7bc",
  "#49c4a4",
  "#00b38c",
  "#e0eee3",
  "#d6eade",
  "#bbddcd",
  "#89c1a9",
  "#81d6ae",
  "#6aac8f",
  "#c9dbcd",
  "#b4caba",
  "#a3bcab",
  "#88a491",
  "#74907c",
  "#d8ddd2",
  "#c3cbbd",
  "#a1ab9c",
  "#879180",
  "#5fc494",
  "#768070",
  "#41b681",
  "#cce5d6",
  "#aed3c1",
  "#94c1ab",
  "#7aaa92",
  "#cef0e3",
  "#5b998a",
  "#d4e7d8",
  "#c3dccc",
  "#afcfbb",
  "#9cc1ab",
  "#81a990",
  "#ced9cb",
  "#b2c1b1",
  "#a0b1a0",
  "#859684",
  "#b2eadd",
  "#798b79",
  "#bfeae2",
  "#9ce2db",
  "#78d6d0",
  "#34bcb4",
  "#00aca4",
  "#c0e6de",
  "#99d3cb",
  "#7cc1b9",
  "#5ba9a1",
  "#75d9c7",
  "#45968d",
  "#c2d7cf",
  "#adc8bf",
  "#99b9af",
  "#7d9f94",
  "#6b8c81",
  "#daddd3",
  "#c5c9bd",
  "#afb5a8",
  "#969c8e",
  "#33c3ac",
  "#82897c",
  "#00b69c",
  "#d5eadf",
  "#c2e4d8",
  "#b0dacd",
  "#8bc3b5",
  "#c5eae4",
  "#429692",
  "#d4e5de",
  "#bed7d1",
  "#a4c4be",
  "#8fb3ad",
  "#739993",
  "#e0e7dd",
  "#ced9ce",
  "#a7b8ab",
  "#8b9d8e",
  "#a7e4e0",
  "#798b7d",
  "#bfe8e6",
  "#87d7da",
  "#5ac7cc",
  "#26b2b9",
  "#00a1a7",
  "#bee1e1",
  "#8fc6cb",
  "#74b6bd",
  "#549ea6",
  "#5ccbc8",
  "#408c94",
  "#dbe9e3",
  "#c1d7d4",
  "#acc8c6",
  "#88a9aa",
  "#5a7b7c",
  "#d2d7d0",
  "#b7beb8",
  "#a3aba6",
  "#89918b",
  "#2db7b4",
  "#767e79",
  "#00a8a4",
  "#b9e2dd",
  "#92cecb",
  "#76bfbc",
  "#55a8a4",
  "#b9e1de",
  "#2f8695",
  "#c2d9d8",
  "#9fc0c2",
  "#83aaad",
  "#689093",
  "#567c81",
  "#dce4df",
  "#c3d0cc",
  "#9dafae",
  "#829594",
  "#a1dadb",
  "#708382",
  "#d3edeb",
  "#b0e3e7",
  "#80d2da",
  "#29afba",
  "#009eab",
  "#c1e0e2",
  "#a4d0d6",
  "#88bfc7",
  "#6dadb8",
  "#7dc9cb",
  "#50939e",
  "#ddeae7",
  "#b8d3d8",
  "#92b8c0",
  "#6c969f",
  "#59838c",
  "#d4ddda",
  "#b9c7c7",
  "#a1b2b4",
  "#8da0a4",
  "#6bc2c5",
  "#728488",
  "#48abaf",
  "#aadbdd",
  "#89c6d1",
  "#76bbc7",
  "#3d909f",
  "#c3e5e7",
  "#2b8db0",
  "#b9dae4",
  "#9ac9db",
  "#6faec8",
  "#5196b3",
  "#3e82a0",
  "#c3c9c7",
  "#abb4b5",
  "#909a9c",
  "#757f82",
  "#a0d9e6",
  "#697476",
  "#ddeeed",
  "#b6e0ec",
  "#68bde1",
  "#2ba2d1",
  "#0091c3",
  "#b6dae5",
  "#8cc3d8",
  "#6caeca",
  "#4a95b4",
  "#68c2d8",
  "#3481a1",
  "#c5e0e6",
  "#aacedb",
  "#72a8bf",
  "#5890a8",
  "#447d96",
  "#b9d4dd",
  "#93b7c6",
  "#7aa5b8",
  "#5f8ca0",
  "#26a8c4",
  "#4e798d",
  "#0099b9",
  "#9ed0e2",
  "#7ec1d9",
  "#5eb0ce",
  "#3c98b9",
  "#b1d7e6",
  "#3688bd",
  "#ece3d1",
  "#bad3dc",
  "#f8ece0",
  "#f9ebd7",
  "#9bbdd0",
  "#efe3cc",
  "#7ea5bd",
  "#f1e3cc",
  "#57809b",
  "#e4d6c1",
  "#517893",
  "#f6f0de",
  "#dae6e7",
  "#f5f2df",
  "#bbd1d8",
  "#f2ebd1",
  "#95b4c1",
  "#f7f0d9",
  "#80a3b3",
  "#f1ecd6",
  "#9dcfe8",
  "#668697",
  "#f8eccf",
  "#d3e3ec",
  "#f0e0d1",
  "#f8eed7",
  "#b6cee4",
  "#f6efe2",
  "#9cbce0",
  "#f5eddf",
  "#6a94c8",
  "#eae3d3",
  "#5583ba",
  "#f6edde",
  "#cde0eb",
  "#eee3d3",
  "#b1d0e7",
  "#efe5d4",
  "#88b2d8",
  "#dbd0bf",
  "#6193c2",
  "#f7f0e2",
  "#86c3e4",
  "#4e80b3",
  "#eee7d6",
  "#c7d9e0",
  "#ecdecc",
  "#e4dbca",
  "#a8c3d2",
  "#f6ebd6",
  "#8badc1",
  "#f3ebdc",
  "#7b9fb5",
  "#ece1cb",
  "#507289",
  "#eaddc5",
  "#d7e1e1",
  "#f0ecda",
  "#b7c9cf",
  "#eae9da",
  "#8da5b1",
  "#e5e6db",
  "#6b8390",
  "#ece8cf",
  "#63b1da",
  "#5a717e",
  "#f3f0d9",
  "#f0dfcd",
  "#eeefdd",
  "#e0dfc9",
  "#f9f9f4",
  "#f4f2ed",
  "#e8e9e4",
  "#f4f1e9",
  "#eeebe3",
  "#f5f1e8",
  "#ebe9e0",
  "#3f9bcc",
  "#e5e5e0",
  "#f0e4d3",
  "#e5e7e5",
  "#e4e2e2",
  "#edebe9",
  "#ece9e8",
  "#e5e2e0",
  "#d0ccc9",
  "#f3f2ed",
  "#ebedec",
  "#dee4e6",
  "#c7e1ec",
  "#dde7e5",
  "#f1e6d3",
  "#eaf0ef",
  "#d8e2e5",
  "#d9e5e7",
  "#e3e7e1",
  "#d9ded9",
  "#edf3e9",
  "#e9eee0",
  "#e5eee2",
  "#e9f1ea",
  "#a7d0e9",
  "#daefec",
  "#f1dfc5",
  "#88bfe2",
  "#f8efe2",
  "#4f99cb",
  "#efe8dd",
  "#eaeae5",
  "#e3e2da",
  "#f9f5e4",
  "#faf4e1",
  "#eeebe0",
  "#e1dbca",
  "#f4ebda",
  "#f0e9dd",
  "#f9f2e8",
  "#f8ecdc",
  "#f6ece1",
  "#e3e2dd",
  "#faeadf",
  "#feebda",
  "#fcebda",
  "#f8ede4",
  "#f5eee5",
  "#f4eee4",
  "#dfd7cc",
  "#f6f3ed",
  "#ede5dd",
  "#efe9e0",
  "#efeede",
  "#efe1d3",
  "#f1f0e7",
  "#f0eee6",
  "#e6e2dd",
  "#e4ddd7",
  "#eaebe6",
  "#e9e5e0",
  "#f2ede6",
  "#eee8e3",
  "#eff0ee",
  "#f3f0dc",
  "#e8e9eb",
  "#f7efed",
  "#f5e5e3",
  "#eaecec",
  "#e1e7ea",
  "#ece9e9",
  "#ebe3e7",
  "#e9f0ef",
  "#e1f0ef",
  "#dfedef",
  "#eae8df",
  "#dfebea",
  "#e7f4ec",
  "#e9f5e9",
  "#e0e3e0",
  "#e4e9e7",
  "#eff5ee",
  "#d9d9d3",
  "#ebf0eb",
  "#e5ebe8",
  "#eef3ec",
  "#e4e1da",
  "#e7ebe4",
  "#e5efeb",
  "#e3f4ec",
  "#eff4e9",
  "#f0f5e6",
  "#efeadd",
  "#e4decf",
  "#e2dfd5",
  "#c1d5e6",
  "#557a96",
  "#c3d3db",
  "#a6becb",
  "#88a6b7",
  "#6c8a9d",
  "#5b778a",
  "#cfd9dc",
  "#b2c1c8",
  "#879ba7",
  "#6d818c",
  "#9fb9db",
  "#5c6e79",
  "#e0e9eb",
  "#cfdfec",
  "#a9c6e4",
  "#89aed9",
  "#6b94c7",
  "#d0d8e8",
  "#b8c3e0",
  "#a6b4d7",
  "#7a8aba",
  "#8ba9d3",
  "#6776aa",
  "#dee5e9",
  "#cfd9e7",
  "#b5c0db",
  "#96a4c9",
  "#7e8cb8",
  "#cbcece",
  "#aeb2b3",
  "#9a9ea0",
  "#808486",
  "#7090c1",
  "#6e7274",
  "#5d7eb4",
  "#ccdce2",
  "#b5ccda",
  "#82a5be",
  "#678ca7",
  "#dfe4ea",
  "#8393b1",
  "#d0d6e3",
  "#b6bfd7",
  "#99a5c4",
  "#818db1",
  "#6e7a9f",
  "#e7e9e4",
  "#c3c8ca",
  "#a2a9ae",
  "#767d83",
  "#ced6e9",
  "#646b72",
  "#e0e2ec",
  "#cfd1e7",
  "#a5aad5",
  "#8a90c4",
  "#777eb5",
  "#f2efeb",
  "#e6e2e7",
  "#d0c1d1",
  "#b4a5bc",
  "#b9c5e3",
  "#887691",
  "#d7dae3",
  "#c2c8d9",
  "#a9b1c9",
  "#969ebb",
  "#737b99",
  "#c6c5c5",
  "#b8b5b6",
  "#a4a2a4",
  "#858183",
  "#899ccb",
  "#726e70",
  "#7589bf",
  "#e6e3e9",
  "#d0ccde",
  "#bcb7d4",
  "#a9a4c7",
  "#dfd9e6",
  "#977a9c",
  "#e5e3e5",
  "#d9d2db",
  "#bdb2c3",
  "#aca1b5",
  "#7d7388",
  "#dedee0",
  "#cbc9d1",
  "#b8b4c0",
  "#a5a0b0",
  "#c9c0e0",
  "#767382",
  "#b2aad4",
  "#9c91c4",
  "#887eb7",
  "#e5d8e3",
  "#d0bcd3",
  "#bea6c3",
  "#aa8dae",
  "#d28c78",
  "#5e565b",
  "#343636",
  "#766857",
  "#848f99",
  "#86441e",
  "#e7774e",
  "#953c24",
  "#d5775e",
  "#5e6468",
  "#4e5258",
  "#4d423f",
  "#6a6c63",
  "#978d7e",
  "#9c988d",
  "#424141",
  "#a26454",
  "#925e53",
  "#373939",
  "#373939",
  "#525346",
  "#989fa3",
  "#eae3d8",
  "#b5905a",
  "#d0c6a1",
  "#ffc632",
  "#eef0d6",
  "#5397b7",
  "#824e4a",
  "#8c8782",
  "#daccb8",
  "#905551",
  "#3e3f40",
  "#858785",
  "#714243",
  "#686157",
  "#5a4a47",
  "#949287",
  "#cdc3af",
  "#918679",
  "#a19584",
  "#babebe",
  "#e8e0d0",
  "#4e3731",
  "#76797d",
  "#9e9d98",
  "#345142",
  "#e9e9e4",
  "#aba095",
  "#cbb597",
  "#c6c4b6",
  "#cdc7be",
  "#413c37",
  "#483c35",
  "#a39382",
  "#596870",
  "#e2e2de",
  "#7e7f75",
  "#c9bcac",
  "#95a8ae",
  "#e8e4d7",
  "#6d828b",
  "#dfe1dd",
  "#b9ab96",
  "#ebdec0",
  "#2e484f",
  "#fee8f5",
  "#f9d7ee",
  "#f1bfe2",
  "#e1a0cf",
  "#cd7db5",
  "#b35e97",
  "#9b4b80",
  "#fde1f0",
  "#f8d0e7",
  "#efb6d8",
  "#de96c1",
  "#c973a2",
  "#ae5883",
  "#96466a",
  "#fae2ed",
  "#f2cfe0",
  "#e4b3cc",
  "#d198b5",
  "#b87592",
  "#9d5c75",
  "#82495a",
  "#ffe3f4",
  "#ffd8f0",
  "#fabfe4",
  "#f0a0d1",
  "#e47cb8",
  "#d15b9b",
  "#ba417b",
  "#ffebf2",
  "#fbdae8",
  "#f3c3d8",
  "#e5a5c1",
  "#d182a0",
  "#b96482",
  "#9f4d65",
  "#ffe8f4",
  "#fed5e9",
  "#f8bdd9",
  "#ec9dc3",
  "#dd79a2",
  "#c95b83",
  "#b14566",
  "#ffe6f1",
  "#ffdbeb",
  "#ffc4dd",
  "#fea6c8",
  "#f485ac",
  "#e4658e",
  "#d04a70",
  "#ffe5ed",
  "#fcd2df",
  "#f2b8ca",
  "#e398af",
  "#cf758a",
  "#b95b6d",
  "#a44a56",
  "#ffe5ef",
  "#ffdae8",
  "#ffc9dd",
  "#ffadc9",
  "#fc8aaa",
  "#ee6b8b",
  "#dc506e",
  "#ffeff3",
  "#ffdbe5",
  "#ffc5d5",
  "#fea7bd",
  "#f3879c",
  "#e1697c",
  "#cc5160",
  "#ffe6ec",
  "#ffdfe8",
  "#ffc9d7",
  "#ffaec1",
  "#ff90a2",
  "#f96d7b",
  "#e34b50",
  "#ffe9ed",
  "#ffdfe5",
  "#ffc9d3",
  "#ffaebb",
  "#fa8e99",
  "#e46b71",
  "#cb5251",
  "#ffe9eb",
  "#ffd8dc",
  "#ffc0c6",
  "#f9a3aa",
  "#ea8386",
  "#d76968",
  "#c35550",
  "#ffebee",
  "#fcd8dc",
  "#f4c0c6",
  "#e5a2ab",
  "#d28085",
  "#bb6569",
  "#a65052",
  "#fff3f4",
  "#ffe7eb",
  "#ffd6dd",
  "#ffbec8",
  "#ffa2aa",
  "#ff787b",
  "#ee5851",
  "#fff1f1",
  "#ffeaeb",
  "#ffdadc",
  "#ffc3c6",
  "#ffa8a6",
  "#ff8d86",
  "#f96653",
  "#ffe8e5",
  "#facfcc",
  "#eeb5af",
  "#dd9592",
  "#c8756d",
  "#b45f56",
  "#a35046",
  "#ffe6e4",
  "#ffd9d6",
  "#ffc3bf",
  "#f4a6a1",
  "#e5867b",
  "#cc6758",
  "#b95543",
  "#fff3f0",
  "#ffece9",
  "#ffdeda",
  "#ffc9c4",
  "#ffafa3",
  "#ff9682",
  "#ff714e",
  "#fff2ef",
  "#ffe6e2",
  "#ffd3cf",
  "#ffbbb4",
  "#fb9587",
  "#e57059",
  "#c75433",
  "#ffece5",
  "#ffdcd2",
  "#ffc7b9",
  "#ffad98",
  "#fb9b82",
  "#eb7d5d",
  "#ce5f38",
  "#ffe9e1",
  "#fed6cc",
  "#f5bfb2",
  "#e5a192",
  "#d2806c",
  "#bf6955",
  "#af5b46",
  "#fff7ed",
  "#ffeee0",
  "#ffe0cb",
  "#ffcdaf",
  "#ffb48a",
  "#ff9c68",
  "#ff8449",
  "#fff6e9",
  "#fff0df",
  "#ffe3cb",
  "#ffd1af",
  "#ffb989",
  "#ffa168",
  "#ff8a4a",
  "#ffece0",
  "#ffdccc",
  "#ffc7b0",
  "#f8ac8c",
  "#ea936e",
  "#da7c55",
  "#c3663f",
  "#ffece0",
  "#ffddcd",
  "#f7c6b1",
  "#e9aa91",
  "#d78a6c",
  "#c57556",
  "#b06144",
  "#fee6dc",
  "#f9dbcf",
  "#efc5b5",
  "#dda896",
  "#c6876f",
  "#b5745c",
  "#a5654e",
  "#fff8e4",
  "#fff2d9",
  "#ffe8c3",
  "#ffd7a5",
  "#ffbb72",
  "#ff9e4b",
  "#ff8830",
  "#fff1dc",
  "#ffe4c6",
  "#ffd2a9",
  "#fbb377",
  "#eb9552",
  "#d87c3b",
  "#c66b30",
  "#fff2e4",
  "#ffe7d5",
  "#fbd5bd",
  "#f0bd9e",
  "#e09f78",
  "#cf875f",
  "#b9714a",
  "#fff4eb",
  "#fee9da",
  "#f7d8c4",
  "#e6b99f",
  "#d19776",
  "#b87a59",
  "#ae704f",
  "#fffbe8",
  "#fff8df",
  "#ffefcb",
  "#ffdea6",
  "#ffca7d",
  "#ffae52",
  "#ff9532",
  "#ffeed2",
  "#ffe6c3",
  "#ffd5a7",
  "#f9bc7d",
  "#e99e56",
  "#d4823c",
  "#bf6f31",
  "#fff4dd",
  "#ffe9c7",
  "#ffd9aa",
  "#fec382",
  "#f3ad63",
  "#e6994c",
  "#d28239",
  "#fff5e4",
  "#ffebd1",
  "#ffdcb7",
  "#fcc792",
  "#f0b073",
  "#db9351",
  "#ce8544",
  "#ffefdd",
  "#ffe2c7",
  "#f8cdaa",
  "#edb384",
  "#dc9b68",
  "#cc8654",
  "#b87243",
  "#fff0e1",
  "#fee8d6",
  "#f8d7be",
  "#ecbf9f",
  "#d9a077",
  "#c28359",
  "#b0724a",
  "#fff0e3",
  "#f9e2d0",
  "#edccb3",
  "#deb699",
  "#c89672",
  "#af7b57",
  "#9e6b4a",
  "#ffedd5",
  "#fedebc",
  "#f5c99e",
  "#e9af78",
  "#da995f",
  "#ca884e",
  "#bf7c45",
  "#fff9e7",
  "#fff1d5",
  "#ffe5bd",
  "#ffd29d",
  "#f6bc77",
  "#e6a255",
  "#d79043",
  "#fff8e1",
  "#fff3d5",
  "#ffe8bd",
  "#ffd79d",
  "#f8c275",
  "#ecae58",
  "#df9c45",
  "#fff7d8",
  "#ffefc2",
  "#ffe1a3",
  "#ffce79",
  "#f9bb59",
  "#eda740",
  "#e59b34",
  "#ffefd6",
  "#fee2be",
  "#f5ce9f",
  "#e9b679",
  "#d9a05f",
  "#cb904e",
  "#bc8143",
  "#fffce4",
  "#fff9d8",
  "#fff2c2",
  "#ffe7a3",
  "#ffd678",
  "#ffc355",
  "#ffaf37",
  "#fffee4",
  "#fffcda",
  "#fff6c2",
  "#ffeda2",
  "#ffe078",
  "#ffcf53",
  "#ffbd31",
  "#fff8da",
  "#fff0c4",
  "#ffde9c",
  "#f7c66b",
  "#e8af49",
  "#da9e38",
  "#d19431",
  "#fff2de",
  "#fae6ca",
  "#f1d5ae",
  "#e1bb87",
  "#cfa46b",
  "#bb8e55",
  "#a67a45",
  "#fff7df",
  "#feedca",
  "#f7dfaf",
  "#eecb88",
  "#deb368",
  "#ca994e",
  "#b98841",
  "#fffee6",
  "#fffed8",
  "#fffac1",
  "#fff3a1",
  "#ffe774",
  "#ffd84d",
  "#ffc82a",
  "#fffedf",
  "#fffcd3",
  "#fff6b9",
  "#ffe989",
  "#ffda68",
  "#ffc946",
  "#f9b82b",
  "#fff8d5",
  "#ffefbc",
  "#ffe29b",
  "#f6ca69",
  "#e8b447",
  "#daa436",
  "#d19b2f",
  "#fff1d8",
  "#f9e4c1",
  "#edd2a3",
  "#dfbb7e",
  "#cda563",
  "#bb9351",
  "#aa8344",
  "#fff2d7",
  "#fce5bf",
  "#f3d5a1",
  "#e7bf7b",
  "#d7aa60",
  "#c7994f",
  "#b78b43",
  "#fff6d9",
  "#ffecc2",
  "#f8dca3",
  "#eec87c",
  "#dfb45f",
  "#cfa14a",
  "#bb8d3b",
  "#fff9d8",
  "#fff0c1",
  "#fbe3a1",
  "#f2d178",
  "#e6be59",
  "#dcb149",
  "#cfa33b",
  "#ffffea",
  "#fffcdb",
  "#fff7c4",
  "#ffeea5",
  "#ffe07b",
  "#facf58",
  "#f0be3a",
  "#ffffe3",
  "#fffed7",
  "#fffabd",
  "#fff49c",
  "#ffea70",
  "#ffdd49",
  "#fecf24",
  "#ffffe8",
  "#ffffdd",
  "#fffec6",
  "#fffba8",
  "#fff47c",
  "#ffe536",
  "#ffdc00",
  "#ffffe5",
  "#fffdd8",
  "#fffac0",
  "#fff2a0",
  "#fbe573",
  "#f3d64f",
  "#e7c630",
  "#ffffe7",
  "#fffed9",
  "#fffbc1",
  "#fff4a1",
  "#fce974",
  "#f4db4f",
  "#e9cb2e",
  "#fffbd7",
  "#fff5be",
  "#fdea9f",
  "#f6da74",
  "#eac853",
  "#dcb639",
  "#c69f26",
  "#fff9dd",
  "#fef2c7",
  "#f7e5a9",
  "#edd481",
  "#e1c161",
  "#cfac47",
  "#bb993a",
  "#fef5db",
  "#f9ebc5",
  "#efdba7",
  "#e2c681",
  "#d0b064",
  "#bc9b4e",
  "#a28440",
  "#fff6d7",
  "#f9ebbf",
  "#f0dca0",
  "#e2c779",
  "#d0b25c",
  "#be9e48",
  "#a6893a",
  "#fff8d9",
  "#fcf0c2",
  "#f2e2a4",
  "#e2ca73",
  "#cfb352",
  "#bb9e3f",
  "#a58b34",
  "#faf4d4",
  "#f2e9bb",
  "#e5da9f",
  "#d4c477",
  "#bfae5b",
  "#a59344",
  "#95863c",
  "#fffcd7",
  "#fef6be",
  "#f8ec9e",
  "#efde74",
  "#e2cd52",
  "#ceb736",
  "#bba528",
  "#fef9d3",
  "#faf5c3",
  "#f3eba5",
  "#e6da78",
  "#d5c757",
  "#c1b23e",
  "#aea132",
  "#fcf7db",
  "#f6efc5",
  "#e9e1a7",
  "#dacd81",
  "#c8ba63",
  "#b4a54b",
  "#9d913c",
  "#fdf5d7",
  "#f2eabf",
  "#e3d9a0",
  "#d2c478",
  "#c0b05d",
  "#ad9e4b",
  "#9a8d3f",
  "#fdf6e7",
  "#f2efdc",
  "#e1ddbf",
  "#ccc7a1",
  "#b2aa7a",
  "#9c9463",
  "#898253",
  "#f7f2dd",
  "#ece6c8",
  "#dbd4ab",
  "#c9bd88",
  "#b7a86d",
  "#9b8e54",
  "#8e824a",
  "#f5f0d1",
  "#f1ebc8",
  "#e2dcab",
  "#d2c785",
  "#bdb268",
  "#a99e54",
  "#938a43",
  "#ffffe9",
  "#fffddd",
  "#fcf9bd",
  "#eff19d",
  "#e1e36e",
  "#d0d34d",
  "#bdc233",
  "#f4f2d3",
  "#e9e8bb",
  "#d6d69b",
  "#c3c175",
  "#aead5b",
  "#9c9c4b",
  "#8b8c40",
  "#f3f2e1",
  "#edecd7",
  "#dddcbf",
  "#c7c7a1",
  "#adac7c",
  "#969565",
  "#838254",
  "#f3f5e9",
  "#ececda",
  "#d5d8bc",
  "#bcc09e",
  "#a2a57b",
  "#8b8d63",
  "#787b54",
  "#eff2db",
  "#e3e7c4",
  "#cfd5a7",
  "#b9be82",
  "#a1a867",
  "#8e9655",
  "#7c8447",
  "#ffffec",
  "#fcfcda",
  "#f0f7c4",
  "#e1eca5",
  "#cfdd7b",
  "#b9cb5a",
  "#a1b841",
  "#ffffef",
  "#f9fdd9",
  "#eef9c1",
  "#def0a3",
  "#cae277",
  "#b3d157",
  "#98be3c",
  "#f2f1dc",
  "#e2e5c7",
  "#ced2ab",
  "#b8ba87",
  "#9fa36c",
  "#898e58",
  "#767a49",
  "#edf2e0",
  "#dce5cc",
  "#c5d2b1",
  "#acba8d",
  "#93a272",
  "#7b8b5d",
  "#67744a",
  "#f9fee9",
  "#edfad9",
  "#ddf3c2",
  "#c5e6a4",
  "#afd77f",
  "#93c460",
  "#78ae48",
  "#ebf4df",
  "#d9e8c9",
  "#c2d7ad",
  "#a9c08a",
  "#90a96e",
  "#7b9459",
  "#688049",
  "#e9f3e1",
  "#d7e7cd",
  "#bfd5b3",
  "#a5be8f",
  "#8ba673",
  "#738f5d",
  "#5e774a",
  "#f1fde9",
  "#e2f7d9",
  "#cceec2",
  "#b0dfa4",
  "#91cb7d",
  "#74b560",
  "#5a9e4b",
  "#f2faed",
  "#e4f3e0",
  "#cfe7cb",
  "#b5d5b0",
  "#9abf8d",
  "#7fa771",
  "#69905b",
  "#e1efdd",
  "#cce1c7",
  "#b1cdac",
  "#95b388",
  "#7b9a6d",
  "#68855a",
  "#58714a",
  "#f1f8ec",
  "#e3efdd",
  "#cee1c8",
  "#b3cdac",
  "#98b489",
  "#7e9c6f",
  "#69865b",
  "#e3f5e5",
  "#d6efda",
  "#bde1c4",
  "#9ecca7",
  "#7fb383",
  "#679b6a",
  "#578758",
  "#f0fded",
  "#dffae1",
  "#c8f3cd",
  "#9fe4aa",
  "#6ccc7b",
  "#41b45c",
  "#1a9d49",
  "#eaf3e6",
  "#dcecdc",
  "#c6dcc7",
  "#a8c3aa",
  "#8aa786",
  "#708d6c",
  "#5d7759",
  "#e4efe5",
  "#d7e7da",
  "#bfd4c4",
  "#a0bca7",
  "#819e84",
  "#68846a",
  "#566e57",
  "#eaefe5",
  "#e0e8db",
  "#cad6c4",
  "#aebda8",
  "#91a085",
  "#76856a",
  "#637057",
  "#e7fbec",
  "#d2f4dd",
  "#b6e9c8",
  "#94d8ac",
  "#6fc288",
  "#4faa6c",
  "#358d52",
  "#f1fbf1",
  "#dcf2e3",
  "#c5e6d1",
  "#a7d3b7",
  "#88bb95",
  "#6ca178",
  "#558961",
  "#e6fdf1",
  "#d0f7e4",
  "#b2eed3",
  "#8be0ba",
  "#5ccd97",
  "#00a466",
  "#008a51",
  "#dffbf3",
  "#c5f5e8",
  "#a2ebd8",
  "#75dbc1",
  "#38c6a1",
  "#009a70",
  "#007f59",
  "#e6f9f1",
  "#d2f2e7",
  "#b6e5d6",
  "#94d2bf",
  "#70ba9f",
  "#4fa183",
  "#398467",
  "#cff7ef",
  "#b0eee2",
  "#87e0cf",
  "#5fd1ba",
  "#34c2a7",
  "#009d7d",
  "#007a5e",
  "#e2f7f1",
  "#cbede5",
  "#aeddd3",
  "#8ac7bb",
  "#73b7a5",
  "#4f9785",
  "#3a7968",
  "#e3f1eb",
  "#cee3dc",
  "#b1cfc7",
  "#91b6ac",
  "#6f9587",
  "#577a6c",
  "#486358",
  "#e9f1ec",
  "#d8e4de",
  "#bfd1c9",
  "#a0b7ad",
  "#849c8d",
  "#677f70",
  "#53665a",
  "#d8f2ee",
  "#bee7e2",
  "#9cd4cf",
  "#77bcb6",
  "#5da99f",
  "#418d84",
  "#33746b",
  "#cff6f4",
  "#b1eae8",
  "#88d9d8",
  "#54c3c1",
  "#0daca7",
  "#00968f",
  "#007b75",
  "#ceeeef",
  "#b9e5e8",
  "#96d3d8",
  "#6dbac0",
  "#4ba4a9",
  "#2b888d",
  "#206d71",
  "#e1eeec",
  "#cadfdd",
  "#aecac8",
  "#8caeac",
  "#6a8d88",
  "#52706c",
  "#445956",
  "#d1f1f5",
  "#b4e5ec",
  "#8cd4df",
  "#5dbdcb",
  "#189fac",
  "#008794",
  "#006e7a",
  "#d8f1f4",
  "#b3e1e8",
  "#8eced8",
  "#62b4c0",
  "#3f9da9",
  "#248591",
  "#1a6c76",
  "#d6edf1",
  "#bbdee5",
  "#9acad3",
  "#74aeba",
  "#5796a1",
  "#3e7a85",
  "#33616a",
  "#d9e6e8",
  "#cadcde",
  "#adc5c9",
  "#8ba8ae",
  "#698589",
  "#50676b",
  "#415053",
  "#d1f0f6",
  "#b1e2ee",
  "#89cee0",
  "#5ab5cb",
  "#1e98ae",
  "#007b90",
  "#0e6071",
  "#d2eaf1",
  "#b3d8e5",
  "#8fc1d2",
  "#69a4b9",
  "#508fa2",
  "#3c768a",
  "#336172",
  "#dbe9ed",
  "#c2d7df",
  "#a3bfcb",
  "#80a1b0",
  "#6a8b98",
  "#4d6a77",
  "#40535d",
  "#dde8ed",
  "#c7d7e0",
  "#a8bfcc",
  "#87a1b1",
  "#718b9a",
  "#536a79",
  "#43535e",
  "#cfe5f0",
  "#b1d3e3",
  "#8dbbd1",
  "#689db7",
  "#5187a0",
  "#3e6f87",
  "#36576a",
  "#d7e6ee",
  "#bed3e1",
  "#9ebbcd",
  "#7b9cb3",
  "#65869b",
  "#4a657a",
  "#3e505f",
  "#dce4e9",
  "#c5d1da",
  "#a7b8c4",
  "#8599a8",
  "#70828f",
  "#53626e",
  "#444d56",
  "#ccebf5",
  "#abdcee",
  "#83c7df",
  "#56acca",
  "#1e8cab",
  "#02708c",
  "#20576e",
  "#d0eefb",
  "#b0e0f6",
  "#87cded",
  "#55b4de",
  "#0098c8",
  "#0077a7",
  "#00608b",
  "#d5edfb",
  "#b8dff8",
  "#92cbf1",
  "#66b2e4",
  "#3194ce",
  "#0477b4",
  "#165d95",
  "#dcecf5",
  "#c3ddee",
  "#99c1dc",
  "#73a4c6",
  "#5588ab",
  "#3f6c8f",
  "#375673",
  "#c6e3f7",
  "#b3d9f3",
  "#8ec2e7",
  "#65a5d5",
  "#3d87bb",
  "#296a9d",
  "#2d517c",
  "#d6eafc",
  "#bbdaf8",
  "#99c3f0",
  "#72a7e1",
  "#4a87cb",
  "#326ab1",
  "#1d5699",
  "#e2eaf0",
  "#c2d2e0",
  "#a3b9cd",
  "#819ab1",
  "#6c849b",
  "#52677b",
  "#424f5f",
  "#e7f0f7",
  "#cddced",
  "#b0c6df",
  "#8faaca",
  "#7896ba",
  "#577396",
  "#445a79",
  "#e0e9f3",
  "#c1d1e2",
  "#a2b7cf",
  "#7f97b5",
  "#6a819e",
  "#50647f",
  "#414d62",
  "#e0ebfa",
  "#c8daf5",
  "#a7c2eb",
  "#84a5dc",
  "#5e81c1",
  "#4664a5",
  "#3c4d85",
  "#e1e6f2",
  "#d3dbec",
  "#b9c4de",
  "#99a8c9",
  "#7886aa",
  "#637195",
  "#4e5878",
  "#e6e9f9",
  "#d2d8f4",
  "#b7c0ea",
  "#97a3da",
  "#7b85c6",
  "#5d66aa",
  "#494d8b",
  "#e5e8f2",
  "#d1d5e7",
  "#b7bdd6",
  "#979fbf",
  "#767c9e",
  "#606788",
  "#4d516c",
  "#dee1e9",
  "#cacfdc",
  "#aeb5c7",
  "#8d95aa",
  "#787e93",
  "#5c6274",
  "#494c59",
  "#e2e2ed",
  "#d0d1e1",
  "#b5b6ce",
  "#9497b3",
  "#7f809c",
  "#63647e",
  "#4e4e63",
  "#e7e6ed",
  "#d2d2df",
  "#b8b8cb",
  "#9899b0",
  "#838298",
  "#656579",
  "#4f4f5e",
  "#eee9f9",
  "#dbd7f2",
  "#c4c0e9",
  "#a6a1d7",
  "#8980c1",
  "#665d9e",
  "#4f467e",
  "#e9e4ef",
  "#d8d3e6",
  "#bfb9d5",
  "#a19abd",
  "#7f779a",
  "#6a6283",
  "#58516e",
  "#ece7f2",
  "#ded3e6",
  "#c8bad4",
  "#ab9bbc",
  "#8a779a",
  "#6d5c7b",
  "#5c4f6a",
  "#e6def0",
  "#dbd1e8",
  "#c4b7d8",
  "#a798c2",
  "#8775a1",
  "#695a82",
  "#524765",
  "#f3e9f7",
  "#e7d7ef",
  "#d3bfe5",
  "#b9a0d2",
  "#9d7eb7",
  "#7e6099",
  "#614a7b",
  "#f4eaf0",
  "#e2d4df",
  "#cdbacb",
  "#b19bb0",
  "#91788c",
  "#745e6f",
  "#665261",
  "#efe2f2",
  "#e7d6ed",
  "#d4bddf",
  "#bb9eca",
  "#9d7aac",
  "#7e5e8d",
  "#61496e",
  "#f6e5f6",
  "#e9d2ef",
  "#d6b7e2",
  "#bd97cf",
  "#a274b5",
  "#845998",
  "#68457a",
  "#ffedf8",
  "#f4daf1",
  "#e7c3e7",
  "#d3a5d6",
  "#bd83be",
  "#a063a1",
  "#804b81",
  "#f9e7f4",
  "#f0d5ea",
  "#e1bbdb",
  "#cc9dc6",
  "#b079a7",
  "#915d88",
  "#73486b",
  "#f4e9ea",
  "#e7d9db",
  "#d4c0c5",
  "#baa3a9",
  "#9e8185",
  "#806568",
  "#5f4947",
  "#f4e5e7",
  "#e8d2d6",
  "#d4b8bf",
  "#ba99a2",
  "#9d777c",
  "#825e61",
  "#654846",
  "#f7e5e6",
  "#edd1d3",
  "#dbb7bb",
  "#c4989e",
  "#a87678",
  "#8e5e5e",
  "#734a45",
  "#ede2e0",
  "#e2d5d3",
  "#cdbdba",
  "#b29e9d",
  "#917a75",
  "#78615c",
  "#604d47",
  "#ece3e1",
  "#dbd0ce",
  "#c3b4b3",
  "#a49593",
  "#86736e",
  "#6f5d57",
  "#5b4a44",
  "#eedfdd",
  "#ddc9c6",
  "#c6aeaa",
  "#a88e8b",
  "#8c6e67",
  "#765952",
  "#644b41",
  "#f0e0dc",
  "#e2ccc7",
  "#cdb1ab",
  "#b1928c",
  "#937067",
  "#7e5c52",
  "#705046",
  "#ece5e1",
  "#dcd3ce",
  "#c5b9b4",
  "#a79994",
  "#897870",
  "#726259",
  "#5e4f46",
  "#f5ece7",
  "#e8dcd5",
  "#d5c6bd",
  "#bcaa9f",
  "#9e8779",
  "#806b5d",
  "#6b574a",
  "#f5eae3",
  "#e8dad1",
  "#d6c3b9",
  "#bca59a",
  "#a08475",
  "#876d5e",
  "#6f5749",
  "#f5e4de",
  "#eed9d1",
  "#dec1b8",
  "#c6a499",
  "#ab8274",
  "#936a5b",
  "#7a5546",
  "#fae8e1",
  "#f1d7ce",
  "#e2beb4",
  "#cca195",
  "#b38070",
  "#9b6959",
  "#845544",
  "#f5e6de",
  "#eedad1",
  "#ddc3b7",
  "#c6a698",
  "#ac8674",
  "#946e5c",
  "#7b5847",
  "#fcede4",
  "#f5ded1",
  "#e8c8b8",
  "#d4ac99",
  "#c09078",
  "#a4725a",
  "#90614a",
  "#fcf0e5",
  "#f6e3d3",
  "#e9cfbb",
  "#d5b59c",
  "#be9677",
  "#a87f5f",
  "#8f684b",
  "#f9ede2",
  "#efdfcf",
  "#e1cbb6",
  "#ccaf92",
  "#b49375",
  "#9e7c5e",
  "#8b694d",
  "#f5ebe1",
  "#eee2d5",
  "#d8c7b6",
  "#bfaa97",
  "#a48b73",
  "#937a62",
  "#806852",
  "#f1e5d7",
  "#e3d2c0",
  "#cdb9a2",
  "#b59b7e",
  "#9d8164",
  "#886e54",
  "#7c644b",
  "#f5e6d3",
  "#e9d3ba",
  "#d6ba9b",
  "#c19e78",
  "#ac8760",
  "#997651",
  "#8f6e4b",
  "#f5e9d9",
  "#e9d8c2",
  "#d6c0a4",
  "#c0a480",
  "#a88b66",
  "#947754",
  "#876b4b",
  "#faeedb",
  "#f2e0c5",
  "#e3cba8",
  "#d0b082",
  "#b49161",
  "#9f7d4f",
  "#927247",
  "#fbf1df",
  "#f3e5cb",
  "#e5d2b0",
  "#d4ba8c",
  "#bfa270",
  "#a78a59",
  "#9b7e4e",
  "#fdf2db",
  "#f6e6c5",
  "#e9d4a9",
  "#dabd84",
  "#c6a668",
  "#b39355",
  "#9f8046",
  "#faf3e6",
  "#f1e7d5",
  "#e2d6bd",
  "#cebe9f",
  "#b4a07a",
  "#9d8861",
  "#8b7753",
  "#f9eedc",
  "#efe0c6",
  "#e1cead",
  "#cdb386",
  "#b89b6b",
  "#a28557",
  "#92774c",
  "#f7eedb",
  "#ece0c4",
  "#dacba7",
  "#c6b183",
  "#af9968",
  "#9a8557",
  "#857349",
  "#f0e8d9",
  "#e2d8c3",
  "#d2c6ae",
  "#bcab8c",
  "#a29171",
  "#8e7d5d",
  "#726449",
  "#f5ecdc",
  "#e8dbc5",
  "#d6c5a9",
  "#bfa984",
  "#a79069",
  "#917a56",
  "#7d6848",
  "#f4f0e3",
  "#e8dece",
  "#d5c7b3",
  "#beac90",
  "#a08d71",
  "#8b785c",
  "#706048",
  "#f5efe8",
  "#e9e2d7",
  "#d8cfc1",
  "#c1b4a0",
  "#a89983",
  "#8e7e67",
  "#746550",
  "#f4f0e8",
  "#e7e2d6",
  "#d4cebf",
  "#bbb3a2",
  "#9f947d",
  "#857a64",
  "#726854",
  "#f4f1eb",
  "#e7e3db",
  "#d4d0c5",
  "#bab6a9",
  "#9c9584",
  "#817a69",
  "#6c6556",
  "#ede9dd",
  "#dcd8c7",
  "#c5c0ac",
  "#aaa388",
  "#8f886c",
  "#7d775d",
  "#6f6a52",
  "#f3f0e8",
  "#e6e3d8",
  "#d2cfc1",
  "#b9b5a4",
  "#9c9680",
  "#817d68",
  "#6c6956",
  "#f2f1e6",
  "#e4e4d5",
  "#d1d2bf",
  "#b9b79b",
  "#9d9c7e",
  "#858365",
  "#737054",
  "#f2f0e8",
  "#e3e3d7",
  "#d0d1c1",
  "#b6b5a0",
  "#9c9c82",
  "#818068",
  "#6f6d56",
  "#f4f1e8",
  "#e2e4d7",
  "#cdd0c0",
  "#b1b6a3",
  "#93977f",
  "#7a7e66",
  "#676b55",
  "#f4f2ea",
  "#e4e4da",
  "#d0d2c5",
  "#b5b8a8",
  "#969783",
  "#7b7d69",
  "#676957",
  "#ecebe5",
  "#d9dad2",
  "#cbcdc4",
  "#afb2a7",
  "#8f9183",
  "#747769",
  "#606256",
  "#eef1ea",
  "#dfe4da",
  "#c8d1c4",
  "#acb7a8",
  "#8e9985",
  "#737d6a",
  "#5f6957",
  "#e8ebe7",
  "#d5dbd5",
  "#bcc4bd",
  "#9da7a0",
  "#7d867c",
  "#656d63",
  "#555b53",
  "#e5ebe6",
  "#d1dad5",
  "#b6c4bd",
  "#96a69f",
  "#76857b",
  "#5e6c62",
  "#4f5a51",
  "#e4ebe7",
  "#d0dbd7",
  "#b6c5c1",
  "#95a7a4",
  "#74857f",
  "#5c6b65",
  "#4c5752",
  "#e5e8e6",
  "#d1d8d6",
  "#b7c0be",
  "#97a2a0",
  "#79837f",
  "#606865",
  "#4f5552",
  "#d9dfe0",
  "#cad3d4",
  "#aeb9bc",
  "#8d9a9e",
  "#6c7779",
  "#555e5f",
  "#474c4d",
  "#e2e7e7",
  "#cfd5d7",
  "#b4bcbf",
  "#949ea2",
  "#727a7c",
  "#596062",
  "#494e4f",
  "#d9dfe3",
  "#bfc9d0",
  "#acb8c1",
  "#8a99a4",
  "#68757e",
  "#515b62",
  "#414549",
  "#e3e5e8",
  "#ccd3d8",
  "#b0b9c1",
  "#8f9aa4",
  "#6c757d",
  "#535a61",
  "#45494d",
  "#e5e7e9",
  "#d2d5da",
  "#b7bdc4",
  "#989ea7",
  "#6c7179",
  "#54585e",
  "#3e3f41",
  "#e1e3e4",
  "#d5d7d9",
  "#bbbfc3",
  "#9ca0a6",
  "#797b80",
  "#5e6063",
  "#464647",
  "#eaeaea",
  "#d8dadb",
  "#c0c3c4",
  "#a1a5a8",
  "#808283",
  "#646767",
  "#515252",
  "#e6e5e4",
  "#d3d3d2",
  "#b9baba",
  "#999b9b",
  "#787976",
  "#60605e",
  "#51504d",
  "#ecebea",
  "#dbdbda",
  "#c6c6c6",
  "#a9aaab",
  "#888786",
  "#6c6b6a",
  "#575654",
  "#dedddd",
  "#d1d0d1",
  "#b6b5b8",
  "#97969a",
  "#757374",
  "#5d5b5b",
  "#4e4b4a",
  "#e0dcdb",
  "#cbc5c6",
  "#afa8a9",
  "#8e8583",
  "#6f6665",
  "#5c5451",
  "#524a46",
  "#e6e0e0",
  "#d4cbcc",
  "#bbb0b1",
  "#9b9092",
  "#7c6e6d",
  "#655856",
  "#574a47",
  "#3b3a3a",
  "#8d4362",
  "#b7386e",
  "#9f2d47",
  "#c03543",
  "#c93543",
  "#b73d3f",
  "#b33234",
  "#bc3033",
  "#d63d3b",
  "#ce4e35",
  "#de5730",
  "#eb5030",
  "#f0622f",
  "#ff6e3a",
  "#ff8d28",
  "#ff9731",
  "#ffaa00",
  "#ffcc13",
  "#f9b500",
  "#ffd100",
  "#fdcb18",
  "#f5bc1d",
  "#d5ab2c",
  "#dad000",
  "#c6d624",
  "#a3bc3a",
  "#6cb037",
  "#38914a",
  "#4a754a",
  "#007f3a",
  "#006940",
  "#007765",
  "#006c68",
  "#00748e",
  "#006477",
  "#2a4b5f",
  "#186db6",
  "#1d4e8f",
  "#324680",
  "#2e4a7d",
  "#3c4378",
  "#534778",
  "#644982",
  "#643e65",
  "#753a58",
  "#69444f",
  "#922e4a",
  "#763b42",
  "#6b443d",
  "#85443f",
  "#a53b3d",
  "#ac3235",
  "#8f423d",
  "#af413b",
  "#a8453b",
  "#a14c3f",
  "#894c3b",
  "#7c503f",
  "#5e463c",
  "#745342",
  "#875942",
  "#695649",
  "#705a46",
  "#7f5e46",
  "#9d6f46",
  "#a17135",
  "#957046",
  "#957747",
  "#b08f42",
  "#807548",
  "#818a40",
  "#86793d",
  "#7e7150",
  "#7b7f56",
  "#5f5d48",
  "#5e6354",
  "#4d504b",
  "#355d51",
  "#155843",
  "#315955",
  "#254a47",
  "#384543",
  "#30525b",
  "#455559",
  "#3f4855",
  "#343b4e",
  "#4a4f5a",
  "#474a4e",
  "#343e54",
  "#484b62",
  "#3a3b5b",
  "#4d4860",
  "#4a3c50",
  "#593c50",
  "#663c55",
  "#635c55",
  "#605955",
  "#615b56",
  "#575452",
  "#534e4e",
  "#514c49",
  "#474545",
  "#444447",
  "#ae947e",
  "#b49d87",
  "#8b7366",
  "#cdb5a6",
  "#bba18c",
  "#94796a",
  "#4c4346",
  "#bc9981",
  "#c4a898",
  "#815e54",
  "#6f514b",
  "#63544d",
  "#463c3d",
  "#614f4a",
  "#856e6a",
  "#806a62",
  "#8a7067",
  "#a4887b",
  "#64473f",
  "#625550",
  "#65524e",
  "#4a3e3f",
  "#8d8378",
  "#9c8c7b",
  "#877b70",
  "#918373",
  "#9b907f",
  "#897f6f",
  "#d2cabc",
  "#b09d85",
  "#8e8070",
  "#86766c",
  "#8d7b6c",
  "#695c51",
  "#927f69",
  "#7a6854",
  "#756550",
  "#8d7a63",
  "#7e6954",
  "#a28b74",
  "#866d57",
  "#655a4c",
  "#5b524a",
  "#4a4140",
  "#776050",
  "#a07f64",
  "#7f614f",
  "#c3a381",
  "#baa484",
  "#beab89",
  "#a4875f",
  "#8d7a5b",
  "#7c694d",
  "#a7997f",
  "#bfb89c",
  "#c6ba98",
  "#ad9b7c",
  "#9f9372",
  "#938b73",
  "#7e735a",
  "#645c43",
  "#c8c2b0",
  "#aca38e",
  "#bcb19f",
  "#afa396",
  "#a59b8e",
  "#ccc2aa",
  "#b5ac91",
  "#8c8474",
  "#9a9683",
  "#b3ae99",
  "#6d6661",
  "#a08e78",
  "#928571",
  "#7a6e63",
  "#786e61",
  "#656056",
  "#5b584e",
  "#615d5a",
  "#464343",
  "#c8a89e",
  "#c09084",
  "#997165",
  "#e7c0ad",
  "#c8a692",
  "#784d4c",
  "#9b6957",
  "#bc896e",
  "#dcb397",
  "#e5c1a7",
  "#fadfc7",
  "#d0ab8c",
  "#745443",
  "#ab7f5b",
  "#ddb994",
  "#c8ae96",
  "#ccb49a",
  "#b69e87",
  "#a78b71",
  "#c2b1a1",
  "#ddc5aa",
  "#d2b698",
  "#f4e1c5",
  "#f3debc",
  "#ffe8c7",
  "#ead0a9",
  "#d1b791",
  "#ffdd9d",
  "#eed09d",
  "#c3a679",
  "#977b4d",
  "#dfc16d",
  "#f6df9f",
  "#fce9b9",
  "#fff4bb",
  "#fbecc9",
  "#f7e6c6",
  "#efddc3",
  "#dfc6aa",
  "#d9c09c",
  "#e5d7c4",
  "#ebdecc",
  "#f2debc",
  "#cfb999",
  "#f5e5ce",
  "#e5d0b0",
  "#d5bfa5",
  "#d5c3ad",
  "#e3d3bf",
  "#e9dcd1",
  "#9f9180",
  "#c1b5a9",
  "#ccbeac",
  "#eddcc8",
  "#e2d0b9",
  "#736354",
  "#59504c",
  "#c7b39e",
  "#ebdbca",
  "#b7a28e",
  "#b8a487",
  "#ddcdb3",
  "#f9ecd1",
  "#f6ebd3",
  "#e0cfb5",
  "#eadfce",
  "#c5b5a4",
  "#d2c5ae",
  "#efe0c9",
  "#f7ecd8",
  "#beb4a8",
  "#b3ab98",
  "#ebe1c9",
  "#d6cfbf",
  "#dbd6cb",
  "#c7c4a5",
  "#978d71",
  "#9da28e",
  "#707b71",
  "#405b50",
  "#b6baa4",
  "#959e8f",
  "#b9c3b3",
  "#c1d1c4",
  "#d7e2d5",
  "#e9e5da",
  "#d3cec5",
  "#93a8a7",
  "#6a7f7d",
  "#979d9a",
  "#cac7c4",
  "#d8d7d3",
  "#91a2a6",
  "#e9e9e1",
  "#cad2d4",
  "#c3c0bb",
  "#9dacb5",
  "#6f7476",
  "#707e84",
  "#65737e",
  "#9f8dc3",
  "#6c6ba0",
  "#413e56",
  "#744a81",
  "#6e5370",
  "#875659",
  "#715160",
  "#883946",
  "#a45d6f",
  "#e05765",
  "#c74e4d",
  "#b35661",
  "#c83f40",
  "#ac343c",
  "#c13e54",
  "#994158",
  "#bf6e7e",
  "#cd706a",
  "#cf605d",
  "#cd4d4f",
  "#c85e4b",
  "#dd4d3e",
  "#d58d3d",
  "#e7cda4",
  "#d9cc64",
  "#bba54f",
  "#e9d276",
  "#977c55",
  "#b3cb87",
  "#729b5a",
  "#63914f",
  "#537a5f",
  "#328161",
  "#85a087",
  "#a5be98",
  "#396d4f",
  "#006b59",
  "#2e5a5e",
  "#3f6d6a",
  "#287367",
  "#00a592",
  "#00897a",
  "#349698",
  "#289897",
  "#0089ad",
  "#569fa7",
  "#086e90",
  "#3d5e6a",
  "#2a39b0",
  "#334377",
  "#49527f",
  "#1d548f",
  "#177298",
  "#68abc5",
  "#81b0bb",
  "#4d70a9",
  "#4a5e86",
  "#2b5a8c",
  "#3d3f53",
  "#344a61",
  "#838287",
  "#424e4e",
  "#8d8077",
  "#9b9189",
  "#c8bdb2",
  "#a9a29b",
  "#8e8277",
  "#d4d0c6",
  "#9f9890",
  "#c1bbb2",
  "#dedad1",
  "#a39d99",
  "#a29e97",
  "#95928c",
  "#6b676b",
  "#98938c",
  "#c0b6ab",
  "#bcb9ae",
  "#aeaaa2",
  "#b8b1a9",
  "#aea79f",
  "#beb6aa",
  "#b0a69b",
  "#cdc8bc",
  "#bbb5a9",
  "#bdb6a6",
  "#968e85",
  "#a2978d",
  "#989185",
  "#9b988f",
  "#cfcabf",
  "#7f7768",
  "#a69f93",
  "#cdc9bb",
  "#a8a295",
  "#868074",
  "#aea898",
  "#ada791",
  "#88857d",
  "#a29e95",
  "#918d83",
  "#939387",
  "#9ea095",
  "#bbbcb2",
  "#b6b7a9",
  "#cbcac2",
  "#b4b0a9",
  "#aba8a1",
  "#918d87",
  "#585a5d",
  "#86837d",
  "#797672",
  "#a19e98",
  "#b4b4af",
  "#999897",
  "#5b5f5f",
  "#dddad7",
  "#c4c2be",
  "#afafac",
  "#9b9b9a",
  "#888889",
  "#757676",
  "#cbcccc",
  "#8e9294",
  "#444e50",
  "#a8aaa4",
  "#c8c8c5",
  "#b6b8b3",
  "#959592",
  "#999d9a",
  "#939a9d",
  "#989ea3",
  "#979c9d",
  "#979995",
  "#687177",
  "#878c8c",
  "#a9b1ae",
  "#8f9897",
  "#a3adb0",
  "#b7b4b7",
  "#9ba0a9",
  "#41474c",
  "#ecebe3",
  "#efefea",
  "#efefe8",
  "#e8e9e4",
  "#ebebe6",
  "#e9ebe8",
  "#eceeea",
  "#eceeec",
  "#ecedea",
  "#eaebe8",
  "#999b9b",
  "#56524e",
  "#646f60",
  "#687575",
  "#9d6559",
  "#7d665b",
  "#967a61",
  "#7e4d47",
  "#5f484c",
  "#764d43",
  "#7f443d",
  "#7e4e4c",
  "#8f4843",
  "#9d6559",
  "#865745",
  "#835949",
  "#5f4b47",
  "#6b4f48",
  "#7d5f4b",
  "#6f594b",
  "#a5774d",
  "#95735b",
  "#84604b",
  "#967a61",
  "#907f6a",
  "#997852",
  "#ba965e",
  "#dab176",
  "#dabe8d",
  "#c8c0a6",
  "#ad9f81",
  "#8d8979",
  "#62604b",
  "#8b896f",
  "#7c7863",
  "#8e9486",
  "#3d564b",
  "#3f4547",
  "#474950",
  "#434c5d",
  "#587380",
  "#6f919a",
  "#5f666a",
  "#899899",
  "#939e9f",
  "#8c8e89",
  "#848075",
  "#dfdfd7",
  "#978d81",
  "#b7af9c",
  "#a29582",
  "#948e80",
  "#c9c7b6",
  "#99948b",
  "#78746e",
  "#635c54",
  "#4c4340",
  "#3c3c3c",
  "#643b46",
  "#674247",
  "#90686c",
  "#af9690",
  "#93807f",
  "#554348",
  "#656470",
  "#4f4352",
  "#b194a6",
  "#58424c",
  "#a54049",
  "#9f414b",
  "#cb3d3c",
  "#684141",
  "#986e6e",
  "#b87f84",
  "#d2a5a3",
  "#b7737d",
  "#a34f66",
  "#b94c66",
  "#b34b47",
  "#bf4e46",
  "#994240",
  "#91433e",
  "#8b4044",
  "#8e3c3f",
  "#e26058",
  "#9e3641",
  "#aa3646",
  "#a84a49",
  "#9b5953",
  "#f3e4d3",
  "#cb8e81",
  "#d2a694",
  "#e6b4a6",
  "#ec9580",
  "#d07360",
  "#e0816f",
  "#e9786e",
  "#86493f",
  "#965849",
  "#7f4e47",
  "#76443e",
  "#834c4b",
  "#b67a63",
  "#e0b695",
  "#e2caaf",
  "#8f4b41",
  "#8a534e",
  "#d26643",
  "#935444",
  "#eec9a6",
  "#e2c4af",
  "#976352",
  "#ad735a",
  "#945c54",
  "#c8987e",
  "#cda894",
  "#a75a4c",
  "#7e5146",
  "#f3a347",
  "#f6b96b",
  "#fea051",
  "#eea372",
  "#d48c46",
  "#b67350",
  "#bf764c",
  "#9a5f3f",
  "#cc9469",
  "#daa36f",
  "#f1dda2",
  "#ddcb91",
  "#eec987",
  "#dab77f",
  "#fee2b2",
  "#d39f5f",
  "#fedcad",
  "#f5c68b",
  "#e8a64e",
  "#fcbe6a",
  "#c19851",
  "#dba637",
  "#ca9234",
  "#a47c53",
  "#ad8047",
  "#ba8a45",
  "#c69c5d",
  "#ecd0a1",
  "#e9ca94",
  "#e2cc9c",
  "#f7de9d",
  "#f3e7b4",
  "#ded1a3",
  "#f2d082",
  "#e4c683",
  "#eed053",
  "#eed683",
  "#b39953",
  "#f4c96c",
  "#f6e491",
  "#c6c191",
  "#859475",
  "#96a782",
  "#a7b191",
  "#b0b08e",
  "#90926f",
  "#a9a482",
  "#a0a160",
  "#75794a",
  "#616c51",
  "#878573",
  "#959486",
  "#a5a495",
  "#959988",
  "#939789",
  "#778071",
  "#9da693",
  "#9a9e88",
  "#5e624a",
  "#6c705e",
  "#a9b49a",
  "#669264",
  "#90a58a",
  "#99b090",
  "#5eab81",
  "#58936d",
  "#437b48",
  "#7fb377",
  "#80987a",
  "#495a4c",
  "#8cb295",
  "#658f7c",
  "#00b191",
  "#008a7d",
  "#0e695f",
  "#81b39c",
  "#20887a",
  "#416659",
  "#46554c",
  "#456252",
  "#8ea597",
  "#acbdb1",
  "#629091",
  "#61a9a5",
  "#587d79",
  "#475c62",
  "#0092a3",
  "#007c78",
  "#6fc0b1",
  "#b6d3c5",
  "#90b1ae",
  "#a9b9b5",
  "#799b96",
  "#9eb1ae",
  "#618b97",
  "#d6eae8",
  "#9dd8db",
  "#2f6679",
  "#4a5e6c",
  "#0d6183",
  "#7b9093",
  "#d1d9d7",
  "#648fa4",
  "#9ba9ab",
  "#466b82",
  "#b6caca",
  "#9cb3b5",
  "#70939e",
  "#637983",
  "#527585",
  "#7196a6",
  "#546b78",
  "#353f51",
  "#4c98c2",
  "#3b4a6c",
  "#576a7d",
  "#383e5d",
  "#3f6e8e",
  "#4d5a6b",
  "#41434e",
  "#4e5a6d",
  "#9fb6c6",
  "#494f62",
  "#3377a2",
  "#466f97",
  "#a5cde1",
  "#4470b0",
  "#3b3f66",
  "#bdcfea",
  "#698eb3",
  "#586e75",
  "#a6aeaa",
  "#565b58",
  "#5b686f",
  "#a7b3b7",
  "#70767b",
  "#676e7a",
  "#788788",
  "#46565f",
  "#a5b4b6",
  "#c7c7c2",
  "#5d625c",
  "#707c78",
  "#b3b5af",
  "#5e6d6e",
  "#61736f",
  "#869f98",
  "#a2b0a8",
  "#42544c",
  "#89978e",
  "#91989d",
  "#6a6b67",
  "#8d8f8e",
  "#777872",
  "#cecdc5",
  "#7a7b75",
  "#62696b",
  "#d9d9d6",
  "#aeadad",
  "#515153",
  "#9e9589",
  "#837871",
  "#9d928a",
  "#d0c5be",
  "#a49688",
  "#bab6ab",
  "#837e74",
  "#bab4a6",
  "#5d5b56",
  "#676965",
  "#504e47",
  "#766a5f",
  "#b9b297",
  "#c0b28e",
  "#635a4f",
  "#d5cdb4",
  "#e1d8b8",
  "#c7bda8",
  "#b8a88a",
  "#a38e6f",
  "#978b71",
  "#d5cfbd",
  "#d2cdbc",
  "#e3e1cc",
  "#dbd7c4",
  "#ebe9d8",
  "#cbb68f",
  "#e6e3d6",
  "#f0efeb",
  "#ecebe5",
  "#e3d4b9",
  "#f1e6cc",
  "#ab9a6e",
  "#ebe6d7",
  "#ebdab5",
  "#e3cfab",
  "#9d7f4c",
  "#c6b788",
  "#7e6f4f",
  "#8b714c",
  "#e7dcc1",
  "#bea781",
  "#e6d5ba",
  "#ebdbc1",
  "#ccac86",
  "#d8c095",
  "#f1e4c8",
  "#ecd8b1",
  "#bca380",
  "#f1e4cb",
  "#d8ceb9",
  "#ddcaaf",
  "#e3dac6",
  "#e2d8c2",
  "#dcd3bc",
  "#e5dfcd",
  "#ebe2cf",
  "#f4ecdb",
  "#f4f0e1",
  "#f6efe1",
  "#4f4744",
  "#745b49",
  "#896956",
  "#8d6747",
  "#a27c4f",
  "#b78d61",
  "#9d7147",
  "#ba947f",
  "#795745",
  "#8d6b4b",
  "#ab927a",
  "#53433e",
  "#a89887",
  "#655046",
  "#927f76",
  "#857767",
  "#bcab9c",
  "#5b4e4b",
  "#b19c8f",
  "#6c5654",
  "#fff4f3",
  "#fff0ea",
  "#fdefe9",
  "#faeae2",
  "#fff4e8",
  "#fff8ee",
  "#fff7e7",
  "#faeadd",
  "#fbe9d8",
  "#faecd9",
  "#f3e7db",
  "#f1e7db",
  "#f6ead8",
  "#fdf3e4",
  "#f9f0e1",
  "#f8eee3",
  "#f9f2e7",
  "#fff9ec",
  "#f7efdd",
  "#fbf1df",
  "#fff8e3",
  "#fffdeb",
  "#fff9e4",
  "#fff6da",
  "#f7efde",
  "#fffbf0",
  "#f6eedf",
  "#faf0db",
  "#f6ebd7",
  "#f6ecd6",
  "#fff9e2",
  "#ffffe9",
  "#fffae5",
  "#faf7e2",
  "#fffce3",
  "#fbf9e1",
  "#f5ebd8",
  "#fffdf2",
  "#fdf9ef",
  "#f3edde",
  "#fdfaf1",
  "#f8f5e9",
  "#f2edec",
  "#fcf7eb",
  "#fffbee",
  "#fbf4e8",
  "#f7f1e2",
  "#fffeed",
  "#fffcec",
  "#f3f3d9",
  "#fbfbe5",
  "#ece6d5",
  "#f3f3e6",
  "#f8f7e6",
  "#faf7eb",
  "#e8e8d4",
  "#f3f9e9",
  "#f9f8ef",
  "#faf7f0",
  "#f7f9e9",
  "#f8faee",
  "#f1f9ec",
  "#f4f7ee",
  "#ecfcec",
  "#f1faea",
  "#eef0e7",
  "#ebf8ef",
  "#f8fff8",
  "#e9f9f5",
  "#eff3f0",
  "#e5eae6",
  "#ebeee8",
  "#f6fdfa",
  "#e7fafa",
  "#e0f6fb",
  "#e8f7fd",
  "#eaf2f1",
  "#f1f8fa",
  "#e2ecf2",
  "#fdfcfa",
  "#ffffff",
  "#f6f4ef",
  "#eae8e4",
  "#fdfbf8",
  "#eff0f0",
  "#f3f4f4",
  "#f1f0ef",
  "#f2f7fd",
  "#e5edf1",
  "#ebeef3",
  "#e8eff8",
  "#f1f3f9",
  "#efeeef",
  "#efecef",
  "#f7f5f6",
  "#dcd8d4",
  "#efedee",
  "#f4efee",
  "#f8f3f6",
  "#f8eef4",
  "#b1a39a",
  "#d8ccc5",
  "#e3d9cf",
  "#c564a0",
  "#cf79b1",
  "#e0a1cd",
  "#e9b8d9",
  "#f1d1e4",
  "#f5e2ea",
  "#5a466b",
  "#88749e",
  "#a18cb0",
  "#b9a9c8",
  "#d1c3db",
  "#63577a",
  "#887ca1",
  "#a091b3",
  "#b9aecc",
  "#d5ccdc",
  "#5c4a50",
  "#e9ddea",
  "#ae85be",
  "#734682",
  "#edcee2",
  "#ba7cb4",
  "#8d4c89",
  "#f0dce4",
  "#e09bc9",
  "#8c2d60",
  "#f0d1d9",
  "#e68bab",
  "#a21f4e",
  "#f4dee0",
  "#f6afb9",
  "#ad273f",
  "#7c6c72",
  "#fbcec8",
  "#f8a49a",
  "#ab3037",
  "#fcd2c4",
  "#f69278",
  "#c23b22",
  "#fcddcb",
  "#faa981",
  "#a23d28",
  "#ffd9b8",
  "#feaa73",
  "#e35a09",
  "#f2e3d1",
  "#ffae68",
  "#c05c1c",
  "#ffe3c0",
  "#ff9d45",
  "#df7601",
  "#fedbb2",
  "#fbb16d",
  "#f79322",
  "#faecdb",
  "#ffae52",
  "#e8983d",
  "#ffdba1",
  "#ffb64a",
  "#ee8e01",
  "#ffe8bf",
  "#ffd174",
  "#ffa901",
  "#fcf0cd",
  "#ffdd75",
  "#ffbd15",
  "#ffeaaa",
  "#ffdb63",
  "#efb901",
  "#f6e3a6",
  "#f3cf63",
  "#cf9501",
  "#f9ebaf",
  "#ebc746",
  "#c9a935",
  "#eeebb5",
  "#cdca54",
  "#9aa22a",
  "#dfe5b9",
  "#adb977",
  "#70802c",
  "#cfe5b5",
  "#92b34d",
  "#668a15",
  "#d0e7be",
  "#8bc076",
  "#40862d",
  "#cfebce",
  "#77c27e",
  "#017029",
  "#c9e5c8",
  "#88b999",
  "#137547",
  "#c8ebd9",
  "#73d4bc",
  "#01755c",
  "#b1e2d7",
  "#74d3c7",
  "#018b7f",
  "#ade0dc",
  "#50c7c1",
  "#019692",
  "#b0e1e0",
  "#30b6bf",
  "#016f78",
  "#c9e8ea",
  "#57bed7",
  "#01738e",
  "#d3e9ec",
  "#76c7e2",
  "#0189ac",
  "#c8e5ec",
  "#59bcda",
  "#016784",
  "#b2dded",
  "#47a8d8",
  "#0178aa",
  "#bfdae9",
  "#68b6e0",
  "#016ca0",
  "#b0cee6",
  "#4b98cc",
  "#015e98",
  "#c9dae8",
  "#80a5cd",
  "#2b63a0",
  "#c2cde0",
  "#a2aed2",
  "#45558d",
  "#e7d6e5",
  "#d9c1e0",
  "#c2a6cc",
  "#b499bf",
  "#81658e",
  "#553763",
  "#e7d1df",
  "#dbb5ca",
  "#cda8be",
  "#b987a7",
  "#9b6f8f",
  "#633457",
  "#ebcfe0",
  "#eac0dc",
  "#dca2c1",
  "#c684a6",
  "#996084",
  "#68374e",
  "#f2d8de",
  "#f3cfd9",
  "#f4bfd0",
  "#cd8999",
  "#99546d",
  "#7c3147",
  "#fad6d4",
  "#facecd",
  "#f2b4b1",
  "#e99296",
  "#ac545a",
  "#80323c",
  "#faded7",
  "#fcccc3",
  "#f7b7aa",
  "#dc7b67",
  "#ba4c4e",
  "#8d2e32",
  "#f8d4c6",
  "#ecbba8",
  "#de9e85",
  "#d28165",
  "#b8694a",
  "#904929",
  "#fdd7ba",
  "#f3be9b",
  "#efb28b",
  "#da936c",
  "#ba6c3d",
  "#8b4d2b",
  "#fbe0ce",
  "#fec8a9",
  "#faac81",
  "#d98151",
  "#c5652a",
  "#a85722",
  "#ffdab5",
  "#ffcd9e",
  "#ffbf89",
  "#f1a564",
  "#c1722a",
  "#9c5d22",
  "#f9e3cc",
  "#fccea8",
  "#f2c196",
  "#daa57a",
  "#b1723c",
  "#955e29",
  "#ffdbb5",
  "#ffd19f",
  "#fbc287",
  "#eca75e",
  "#d58b3d",
  "#b6762b",
  "#f5ddbf",
  "#f3c58f",
  "#e6a961",
  "#d28c38",
  "#ac6b11",
  "#946221",
  "#fbe6c1",
  "#f5ce9c",
  "#e1ac6a",
  "#cd8e43",
  "#b9813d",
  "#976b38",
  "#ffdca7",
  "#f8c681",
  "#e4ab5a",
  "#de9e40",
  "#d1902d",
  "#a77634",
  "#f1dfaf",
  "#f6d299",
  "#f7c880",
  "#ebb047",
  "#da940f",
  "#b47b14",
  "#feebb3",
  "#fde399",
  "#fac875",
  "#e4b054",
  "#cd961f",
  "#9f7111",
  "#efdeb8",
  "#edd39f",
  "#debb74",
  "#c8a24f",
  "#bc953f",
  "#92702e",
  "#f2e0a8",
  "#e2cc8b",
  "#d3be7d",
  "#bda459",
  "#a88b2d",
  "#887536",
  "#efe8b7",
  "#e4db9e",
  "#d0c379",
  "#b3a85b",
  "#9d9033",
  "#827d19",
  "#e3e2c1",
  "#d8d7a9",
  "#cdcd97",
  "#b7b678",
  "#9a9859",
  "#757648",
  "#dde5bf",
  "#d8ddb8",
  "#c3c89d",
  "#aeb087",
  "#95976d",
  "#666944",
  "#e0ebd3",
  "#d3e2c2",
  "#bcd2a0",
  "#9fb683",
  "#879e6a",
  "#597042",
  "#d5e0c8",
  "#bbcbaa",
  "#afc199",
  "#93a67f",
  "#788e60",
  "#385d2b",
  "#c8e1c8",
  "#b1ceb0",
  "#96b395",
  "#7b9a7b",
  "#587657",
  "#285838",
  "#c1e1d2",
  "#9dccbb",
  "#7cb6a1",
  "#619b87",
  "#427764",
  "#014b39",
  "#c8dcd4",
  "#b0d5ce",
  "#8cc1b5",
  "#77b5a8",
  "#3e786d",
  "#01493e",
  "#cce8e2",
  "#b5e1da",
  "#9bd8d3",
  "#84c0bc",
  "#2d7870",
  "#015b52",
  "#bededd",
  "#a9d6d5",
  "#87bdbc",
  "#6ea3a3",
  "#227878",
  "#01555b",
  "#b9dee2",
  "#a3d6dc",
  "#7ebfc5",
  "#64a4ab",
  "#1c808a",
  "#01535d",
  "#c1dae1",
  "#aed2dc",
  "#86bac8",
  "#5f9faf",
  "#408798",
  "#015063",
  "#c4dce5",
  "#b9ddeb",
  "#97c6da",
  "#6b9db6",
  "#306d88",
  "#015068",
  "#c2d8e5",
  "#a9d0e6",
  "#8bc4e0",
  "#72b7d9",
  "#4083a2",
  "#014b6b",
  "#adcee1",
  "#95c3df",
  "#74b5da",
  "#489bc6",
  "#2077a0",
  "#01557d",
  "#c3d7e6",
  "#b7cfe2",
  "#95bfe1",
  "#71a6ce",
  "#498bb8",
  "#01537f",
  "#cbd8e8",
  "#b8cce5",
  "#93b1d6",
  "#87a4c8",
  "#647e9e",
  "#0c3b5d",
  "#d0dae8",
  "#bfcde2",
  "#aebfda",
  "#a2b2ce",
  "#606e9c",
  "#2b406f",
  "#ddd7de",
  "#d4c9d7",
  "#bdabc1",
  "#a391a7",
  "#736275",
  "#524055",
  "#dfd5de",
  "#cbbbc4",
  "#bcafba",
  "#a2949f",
  "#958793",
  "#594052",
  "#e4d4df",
  "#dbc5d3",
  "#c9abb9",
  "#af929f",
  "#796172",
  "#5e3b55",
  "#e8d3d9",
  "#e3c9c9",
  "#c8aeb0",
  "#ae9395",
  "#836468",
  "#663f44",
  "#fadcdb",
  "#e3b8b9",
  "#ce9ea0",
  "#c38c8f",
  "#ab7378",
  "#8a5255",
  "#f0d5cf",
  "#f4c7bd",
  "#e6ada0",
  "#c0827b",
  "#a36a64",
  "#703d3d",
  "#f4e3da",
  "#f0d4ca",
  "#dfac9e",
  "#bd8574",
  "#956354",
  "#7a422a",
  "#f3d7c8",
  "#e8bca7",
  "#c6937c",
  "#b48672",
  "#946651",
  "#6c442d",
  "#f9e3d1",
  "#ebcab8",
  "#d0a38b",
  "#b5886f",
  "#9f735b",
  "#7b4e35",
  "#f4e1d2",
  "#e7ccba",
  "#c8a389",
  "#a58065",
  "#8b6a52",
  "#604735",
  "#f9e5d2",
  "#f0ccac",
  "#d4a482",
  "#b58a6b",
  "#8a5f3e",
  "#795338",
  "#f4dac3",
  "#e3c2a3",
  "#cfa682",
  "#aa815b",
  "#946a42",
  "#6d4925",
  "#fbeadb",
  "#e7cdb7",
  "#c4a68c",
  "#b28e6d",
  "#84603e",
  "#4d3c2a",
  "#f1dbc3",
  "#d9c1a8",
  "#c4a889",
  "#bb9a75",
  "#7f5f42",
  "#6f543a",
  "#eed9bc",
  "#e1c19e",
  "#d0a97f",
  "#b48e63",
  "#966938",
  "#896134",
  "#ebdbc4",
  "#e4ceb1",
  "#c8aa83",
  "#a88353",
  "#956f3e",
  "#87622f",
  "#e3d0b0",
  "#e1c49b",
  "#d1ab76",
  "#b38146",
  "#93621d",
  "#7c5723",
  "#eddcbe",
  "#eac892",
  "#d7ad6c",
  "#c49046",
  "#a27740",
  "#87632e",
  "#f1dcb9",
  "#e0c59b",
  "#c5ab7f",
  "#ab9164",
  "#907850",
  "#715830",
  "#ded2bb",
  "#d4c4a4",
  "#c7b695",
  "#a69269",
  "#846f43",
  "#79653a",
  "#dad2b5",
  "#cec8aa",
  "#c4ba97",
  "#a9a07c",
  "#6f6b34",
  "#665f31",
  "#dedbc9",
  "#c7c5ae",
  "#b7ae89",
  "#a19569",
  "#79704a",
  "#4f5529",
  "#d4ddca",
  "#bdc6b3",
  "#a6ae9b",
  "#8b9480",
  "#67715e",
  "#515b47",
  "#d2ded0",
  "#b7c5b7",
  "#a0ada0",
  "#869384",
  "#6d7c6c",
  "#455042",
  "#dfe7e0",
  "#c6d0c7",
  "#a8b8af",
  "#9aaba1",
  "#819288",
  "#485a50",
  "#d1ded8",
  "#c3d2cc",
  "#b3c6c2",
  "#98aba7",
  "#778580",
  "#495954",
  "#dae4df",
  "#ccded8",
  "#afc7c2",
  "#94aea9",
  "#6d8887",
  "#1e4540",
  "#c9dcdb",
  "#bad3d3",
  "#aec7c6",
  "#8eadac",
  "#6d9495",
  "#466863",
  "#dbe7e6",
  "#b5d4d8",
  "#9bb9bd",
  "#729397",
  "#4c7075",
  "#014849",
  "#bcdbe3",
  "#b2d1da",
  "#81acb8",
  "#5993a3",
  "#4b7c89",
  "#244e59",
  "#d6e5e8",
  "#bed1d6",
  "#62534d",
  "#9fb9bf",
  "#859ea5",
  "#556f77",
  "#1f4049",
  "#c6dae2",
  "#b5d1dc",
  "#99b8c4",
  "#7f9ca8",
  "#597986",
  "#396475",
  "#c7d8e2",
  "#bfcfd9",
  "#b2c3cd",
  "#93aab8",
  "#4e6d7f",
  "#274b5e",
  "#cbdbe2",
  "#b9cfdc",
  "#9ab5c6",
  "#7d9db0",
  "#4b7891",
  "#203e4f",
  "#d6e4ea",
  "#bfcfdb",
  "#afc3d3",
  "#8ba9c1",
  "#557690",
  "#1d4864",
  "#dbe3ea",
  "#cbd8e3",
  "#bbcee0",
  "#9db4cc",
  "#7d98b3",
  "#234766",
  "#d0d7e1",
  "#b4c1d1",
  "#a8b4c4",
  "#7c8da2",
  "#576b80",
  "#30495e",
  "#dee1e5",
  "#caced2",
  "#656b6f",
  "#d5d6da",
  "#959b9e",
  "#454b4f",
  "#c0c2c2",
  "#6c767c",
  "#2f2f2f",
  "#d6dadb",
  "#a1a8a9",
  "#70777a",
  "#bcc2c2",
  "#959c9c",
  "#4f5556",
  "#d3dadb",
  "#adb4b4",
  "#707778",
  "#dbdad4",
  "#a9a8a2",
  "#787772",
  "#b7b5b0",
  "#8e8d88",
  "#3f3e39",
  "#d1d0ca",
  "#9a9b97",
  "#3a3c3d",
  "#b5b5b0",
  "#a7a7a2",
  "#6c6c67",
  "#ded9d0",
  "#bab5ac",
  "#676259",
  "#d4cfc7",
  "#958f88",
  "#3c3e3c",
  "#dcd8d6",
  "#d2cfcd",
  "#b8b4b4",
  "#9d999a",
  "#777575",
  "#4d494c",
  "#dcd8d7",
  "#d1cbcf",
  "#b8b3b6",
  "#9b999e",
  "#6d696e",
  "#3d3940",
  "#dfd5d3",
  "#d2c0be",
  "#c4b1af",
  "#aa9694",
  "#766769",
  "#594645",
  "#e1dbda",
  "#d4cdcb",
  "#c9bfbd",
  "#b0a5a4",
  "#7f7574",
  "#6a5f5e",
  "#7f706a",
  "#e6d5d0",
  "#ddcac6",
  "#d1beba",
  "#b7a49f",
  "#7b6863",
  "#4a3a39",
  "#e0d6ce",
  "#dacdc2",
  "#cfc0b6",
  "#b8a59b",
  "#967e71",
  "#6a5245",
  "#d3cdc6",
  "#cdc2ba",
  "#b5a69b",
  "#9c8e83",
  "#7a6b61",
  "#57483d",
  "#e8d7c8",
  "#d4bfac",
  "#c9b3a0",
  "#bba592",
  "#8b7464",
  "#665244",
  "#e5d9cc",
  "#d1c0b0",
  "#c7b6a6",
  "#b7a595",
  "#928070",
  "#5b4937",
  "#e9dac9",
  "#dcccbb",
  "#d2c2b1",
  "#b7a695",
  "#98816e",
  "#685545",
  "#ddd1bd",
  "#d4c3ac",
  "#c8b59d",
  "#af9a84",
  "#95806a",
  "#473d32",
  "#dacfc0",
  "#cdc2b2",
  "#c1b6a5",
  "#b7a895",
  "#9e8f7b",
  "#72624d",
  "#d0cccd",
  "#bfc0c6",
  "#b1b3b9",
  "#989aa0",
  "#7c7f86",
  "#636a74",
  "#d2dae1",
  "#c4ccd3",
  "#bbc3ca",
  "#97a7b4",
  "#7b8c99",
  "#596c77",
  "#dde5e6",
  "#c6cfd4",
  "#aab7bf",
  "#7a8f97",
  "#586c74",
  "#334c57",
  "#ced9db",
  "#b5c4c7",
  "#a9b8bb",
  "#9aa9ac",
  "#637a80",
  "#344c52",
  "#d8dbd7",
  "#cbd0c9",
  "#b3b8b2",
  "#969b96",
  "#7f837d",
  "#464c47",
  "#dfe5df",
  "#d2dbd6",
  "#c5ceca",
  "#b0b9b4",
  "#656f6b",
  "#1d3233",
  "#e4e4db",
  "#cdd0c7",
  "#b5b7af",
  "#8e9087",
  "#6c6e66",
  "#4c4b46",
  "#e4e5e0",
  "#d8dad2",
  "#bfc5bb",
  "#a6aba1",
  "#757a70",
  "#494e42",
  "#dadbcd",
  "#d0d1c4",
  "#b8b8aa",
  "#a9aa9c",
  "#9b8c87",
  "#8f9082",
  "#6d6f61",
  "#dcdad0",
  "#c6c4bb",
  "#a8a89f",
  "#918f85",
  "#716f60",
  "#4d4b41",
  "#d3cfc2",
  "#ccc6b4",
  "#c2b8a1",
  "#a69d86",
  "#776e56",
  "#635a41",
  "#d1c5b0",
  "#c4b7a2",
  "#ac9c82",
  "#9b9079",
  "#7a6f58",
  "#625745",
  "#f6f6f1",
  "#eaecea",
  "#f3f2ed",
  "#f2efe6",
  "#f7f5eb",
  "#f3eee2",
  "#ebe5d9",
  "#f0ede4",
  "#f3eee7",
  "#f0ede7",
  "#eceae4",
  "#e4e2dd",
  "#e7edea",
  "#e4e4e2",
  "#e6e5e1",
  "#ece8db",
  "#f6eddc",
  "#f5e5cb",
  "#e9dac7",
  "#e8e4db",
  "#efe4d5",
  "#ede3db",
  "#e9e2dc",
  "#d9d8d6",
  "#dbdad6",
  "#dadcd8",
  "#dedad1",
  "#e8e9e0",
  "#efe6d6",
  "#e3d8c8",
  "#e0ceb6",
  "#e1d9cd",
  "#f7e3cc",
  "#e8e1da",
  "#e2d9cf",
  "#dfd9d2",
  "#c8bdc4",
  "#a27e9c",
  "#a53143",
  "#e2cbc7",
  "#916356",
  "#a45b4c",
  "#b8775e",
  "#e49e7e",
  "#f5cbae",
  "#ac6721",
  "#e9c19a",
  "#cbb399",
  "#ecb479",
  "#f2c58c",
  "#ffcf8f",
  "#dbc2a0",
  "#e8d3a6",
  "#dabe76",
  "#d9cc93",
  "#a39f31",
  "#c2b279",
  "#aca371",
  "#797a63",
  "#daddcd",
  "#a7bca6",
  "#015e3d",
  "#7da29c",
  "#a1c8c6",
  "#01646b",
  "#c1d1d4",
  "#015c76",
  "#a4b7be",
  "#619cbe",
  "#2a4763",
  "#bbc3c8",
  "#c9d9e5",
  "#536984",
  "#9a898d",
  "#e0c6d8",
  "#8c2840",
  "#5f2d3a",
  "#fdc3b3",
  "#f7e1d8",
  "#964231",
  "#ac978c",
  "#ae5f37",
  "#b66c42",
  "#f4c092",
  "#b77430",
  "#7e5629",
  "#fee4c5",
  "#b68e65",
  "#a98d6e",
  "#976e32",
  "#e5cb8d",
  "#d2af68",
  "#b9a461",
  "#8a872a",
  "#b5b968",
  "#919d5a",
  "#b7bca0",
  "#93a091",
  "#738d72",
  "#4f7569",
  "#01645c",
  "#c5e9e3",
  "#019ba4",
  "#8a9ea3",
  "#86b9cb",
  "#5c90a4",
  "#01628a",
  "#a8c3d3",
  "#8bb5d9",
  "#a4bddc",
  "#557ab1",
  "#c1a2a4",
  "#874b66",
  "#f5e7e5",
  "#d37b72",
  "#6a2e34",
  "#973a3c",
  "#f5d6cc",
  "#ce865f",
  "#ba8969",
  "#dac1aa",
  "#d48a43",
  "#946c41",
  "#e7b67f",
  "#f4d1a4",
  "#cb9c61",
  "#b79355",
  "#cfa342",
  "#e6d5a0",
  "#a77e23",
  "#c9c088",
  "#8b8e4f",
  "#c8bc8a",
  "#7a8975",
  "#8ca97a",
  "#3c633e",
  "#90b39b",
  "#9bbab4",
  "#017b7f",
  "#b1c4c6",
  "#375054",
  "#d3e6ea",
  "#8bc6df",
  "#6d8fa2",
  "#8dc2e1",
  "#bacedd",
  "#265e83",
  "#a9bdde",
  "#57444a",
  "#9b9893",
  "#edd9c5",
  "#a95849",
  "#ae9986",
  "#f7e0c6",
  "#4b3b30",
  "#f0d19f",
  "#dfd1b6",
  "#c2ab7b",
  "#c7c2b4",
  "#9e8c80",
  "#9c6250",
  "#e1af92",
  "#d49866",
  "#dcc0a3",
  "#f6dbba",
  "#dbc6a8",
  "#7c6d58",
  "#d3b68e",
  "#bca498",
  "#543d27",
  "#642e32",
  "#a36343",
  "#dcb490",
  "#78542f",
  "#e7c198",
  "#ae8d68",
  "#cab598",
  "#cb903b",
  "#513833",
  "#b3a79a",
  "#ccb39d",
  "#c5b6ae",
  "#cda387",
  "#a38163",
  "#c0a88d",
  "#8d6a49",
  "#e4d1ac",
  "#c59c69",
  "#ebb570",
  "#8e635e",
  "#f8efe2",
  "#a28c78",
  "#eed9c8",
  "#bf6f3a",
  "#c88b57",
  "#cba77c",
  "#b09a7d",
  "#f3d0a2",
  "#6f644c",
  "#decdbc",
  "#7e4b40",
  "#bb9877",
  "#8a5c30",
  "#b98b61",
  "#e6c298",
  "#9c6d2a",
  "#61492b",
  "#c79e5f",
  "#d7b888",
  "#f49381",
  "#ae668e",
  "#f8c5ba",
  "#c8c5b7",
  "#ffd1af",
  "#7d786a",
  "#4d7530",
  "#adbbad",
  "#014f63",
  "#cccdd3",
  "#ece2dc",
  "#c23730",
  "#eae5da",
  "#e17669",
  "#453747",
  "#3f7b63",
  "#88671e",
  "#b1dfe4",
  "#a8a7a5",
  "#8795b4",
  "#9c2e50",
  "#f3e7d2",
  "#a25462",
  "#323453",
  "#9e8d75",
  "#eba101",
  "#94cdc2",
  "#a3b6bb",
  "#01597c",
  "#d7cdc6",
  "#54525a",
  "#da854a",
  "#d6d7e7",
  "#c68a98",
  "#f3cca7",
  "#bdcbb0",
  "#5f4273",
  "#017b77",
  "#dae1eb",
  "#25416d",
  "#c5b9d5",
  "#613035",
  "#cec2b4",
  "#d5d2c0",
  "#b18443",
  "#6d6d2f",
  "#69492a",
  "#dbdba4",
  "#01a7b8",
  "#252d31",
  "#8f3028",
  "#c3c4b8",
  "#9d363a",
  "#cfb98b",
  "#635840",
  "#d08301",
  "#493d34",
  "#5fbba5",
  "#878e8f",
  "#3f7993",
  "#bdc8b1",
  "#cec3ae",
  "#95bfb1",
  "#6b9297",
  "#017887",
  "#015261",
  "#b2cede",
  "#c4cfd1",
  "#738092",
  "#424a4b",
  "#aaab99",
  "#eae5d3",
  "#a8bab3",
  "#ded2ca",
  "#c2dcde",
  "#a6c8c3",
  "#b0c4c8",
  "#015a75",
  "#233e51",
  "#dfe5e3",
  "#bcc2bf",
  "#f3e8d3",
  "#57726e",
  "#c3d5c2",
  "#33747c",
  "#93c8cf",
  "#d3e6ed",
  "#99c4d5",
  "#abc3cc",
  "#9db2c2",
  "#5b6064",
  "#504a3c",
  "#bac5bb",
  "#789292",
  "#43595c",
  "#c9d9d7",
  "#3d6f82",
  "#c5d9dd",
  "#0d4c67",
  "#838b93",
  "#bab3b0",
  "#c8c2b6",
  "#dfdccc",
  "#82908b",
  "#9fb8b7",
  "#016168",
  "#959c98",
  "#5190a9",
  "#8097ae",
  "#bdc1c7",
  "#706a67",
  "#b5a893",
  "#918e80",
  "#9ebcb2",
  "#c1c5b9",
  "#769097",
  "#bac4c2",
  "#848f92",
  "#4d565f",
  "#8a97a7",
  "#5e6262",
  "#4f4845",
  "#694a5a",
  "#78363c",
  "#78442b",
  "#8f5e39",
  "#99693b",
  "#ce9c65",
  "#ad8450",
  "#b19361",
  "#a2985e",
  "#87817b",
  "#8a6c7a",
  "#862f31",
  "#b06525",
  "#dba57d",
  "#c9a789",
  "#e1aa6a",
  "#cb9e61",
  "#d6b888",
  "#ae945d",
  "#a09995",
  "#908696",
  "#d7b0a1",
  "#b46b49",
  "#ebceb3",
  "#e9cdaf",
  "#efceaa",
  "#dfb883",
  "#ead0a4",
  "#c6ac77",
  "#b8b5b1",
  "#c8bebf",
  "#e5d5ce",
  "#dac0b0",
  "#e2cebb",
  "#e6cfb6",
  "#f9dcb4",
  "#eccea7",
  "#f8deb2",
  "#e0d0b0",
  "#ddd9d5",
  "#e5e2e3",
  "#e9dfdd",
  "#ece3d9",
  "#f8ebdc",
  "#faedd9",
  "#fbe6c8",
  "#e9d0ae",
  "#fbe8c8",
  "#f3e5c9",
  "#ebe9e4",
  "#dcd6d8",
  "#e2d8d3",
  "#b7476e",
  "#e9d8ce",
  "#dad0c1",
  "#f3e4d1",
  "#ded0bc",
  "#f6e6ce",
  "#e7dbc6",
  "#e8dbbf",
  "#d0cdc8",
  "#d7ccca",
  "#c4b3ab",
  "#e0cec3",
  "#bca695",
  "#e1cfb8",
  "#d0c2ae",
  "#e9dac1",
  "#c9b798",
  "#ccb692",
  "#b7b4b0",
  "#b1a4a7",
  "#baa299",
  "#c0a397",
  "#aa978d",
  "#d5c2ae",
  "#bea98c",
  "#c2a987",
  "#c0b6a0",
  "#ae9c7d",
  "#7c7771",
  "#887e80",
  "#704036",
  "#7a5e53",
  "#675348",
  "#aa8b74",
  "#95846b",
  "#8f795b",
  "#a79b85",
  "#988364",
  "#6a6156",
  "#827072",
  "#5e342b",
  "#63453a",
  "#513b33",
  "#624830",
  "#786344",
  "#4e3f28",
  "#786d5b",
  "#847963",
  "#6a8097",
  "#184052",
  "#1e586c",
  "#2b5a65",
  "#427475",
  "#667063",
  "#3a5049",
  "#515a4d",
  "#5d583f",
  "#787153",
  "#8da6b9",
  "#4e7795",
  "#708e9a",
  "#869f9f",
  "#77938a",
  "#7e8773",
  "#95a088",
  "#7a7c60",
  "#888870",
  "#a59e80",
  "#a6b5c1",
  "#7f9bac",
  "#abc4ca",
  "#b3c6c4",
  "#8d9f95",
  "#afb9a8",
  "#a3ab9e",
  "#b7baa3",
  "#bbbaa3",
  "#c7b996",
  "#b2c1cf",
  "#a6c4d0",
  "#cbdddf",
  "#c5cfcd",
  "#b5c6bc",
  "#c7d3c2",
  "#bbc5b8",
  "#c4c6af",
  "#dbddcc",
  "#cbc5ad",
  "#d4d8dc",
  "#dae4e8",
  "#d9e6e9",
  "#d7dcd9",
  "#b7c5bf",
  "#c8d1c3",
  "#d3dcce",
  "#d2d3c2",
  "#eeefe0",
  "#d8d1ba",
  "#e1e3e3",
  "#d1dade",
  "#cfdde0",
  "#c86190",
  "#cbd1ce",
  "#dee5e0",
  "#d6dbd0",
  "#e1e6da",
  "#d8d9d0",
  "#d1cfc1",
  "#f5f1e3",
  "#c4ced9",
  "#c3cfd5",
  "#bdced5",
  "#b7c3c5",
  "#d3dddb",
  "#d1dbd4",
  "#e3e6df",
  "#d0cfc6",
  "#c8c5b3",
  "#e0dac9",
  "#aab5bf",
  "#b6c3ca",
  "#afc2c9",
  "#abb6b4",
  "#b9c2be",
  "#cad0c6",
  "#b7b8a6",
  "#bdc2bc",
  "#aca996",
  "#cfc6af",
  "#7f8b97",
  "#a1b7c3",
  "#9fb7c1",
  "#99a9a7",
  "#a0aaa6",
  "#b1b7ad",
  "#959e91",
  "#989b93",
  "#92907d",
  "#bcb5a2",
  "#292f35",
  "#63777f",
  "#889aa2",
  "#728687",
  "#6e7975",
  "#898f85",
  "#7e867a",
  "#6a6e68",
  "#403f35",
  "#646356",
  "#d483a6",
  "#eaa4bf",
  "#f1c5d7",
  "#e3d1df",
  "#f2deeb",
  "#8b717f",
  "#ad96a3",
  "#eadbdd",
  "#574540",
  "#7b685f",
  "#8d7970",
  "#ab9795",
  "#e1d7d5",
  "#dd6f92",
  "#eb97b2",
  "#f0aec4",
  "#f6c8d9",
  "#f8d9e3",
  "#7a4b70",
  "#a977a2",
  "#c49bbf",
  "#ddcad3",
  "#776867",
  "#988583",
  "#bca8a3",
  "#d5c3be",
  "#e0d3ce",
  "#b93e4e",
  "#dc607a",
  "#e77893",
  "#f199b1",
  "#f9cad5",
  "#f9e2e7",
  "#874763",
  "#af7193",
  "#cb98b2",
  "#dcb0c8",
  "#eac8d9",
  "#eed7e2",
  "#624647",
  "#826466",
  "#a1878e",
  "#baa0a7",
  "#dfcacb",
  "#5b413b",
  "#79615b",
  "#987e78",
  "#b39089",
  "#c8ada8",
  "#d9c0bb",
  "#eb768f",
  "#f6aebf",
  "#f9cbd8",
  "#f9dee5",
  "#e8d6d3",
  "#613b2f",
  "#7a5855",
  "#a07d77",
  "#b69589",
  "#cdaca2",
  "#e2cfc7",
  "#c8404c",
  "#e2656d",
  "#e78287",
  "#f39aa4",
  "#fbcac7",
  "#95454e",
  "#ac5a66",
  "#cda4af",
  "#e0c4cc",
  "#efdcde",
  "#663d3a",
  "#8e6262",
  "#9f7271",
  "#be9695",
  "#d4b4b4",
  "#ead5d4",
  "#714d41",
  "#967066",
  "#c29685",
  "#d7b5a9",
  "#eddcd4",
  "#df726d",
  "#e2807b",
  "#ee9b98",
  "#b24a55",
  "#d6798d",
  "#e89aac",
  "#edb9c6",
  "#f5cfd9",
  "#f9dbe2",
  "#9c636d",
  "#c59098",
  "#ecddd7",
  "#7b5145",
  "#9b7063",
  "#af8172",
  "#c49f90",
  "#dec1b4",
  "#e25b4f",
  "#ed7b76",
  "#f59491",
  "#f8ada8",
  "#fac2be",
  "#ca7983",
  "#da939b",
  "#e7b5bd",
  "#f3cfd5",
  "#8e484b",
  "#ac6769",
  "#bc7b7e",
  "#d09091",
  "#f1d0cf",
  "#7b433d",
  "#a05d57",
  "#ba7f78",
  "#c6908b",
  "#dfb8b4",
  "#ecd0cb",
  "#9e786b",
  "#b28a79",
  "#bf3934",
  "#b0212a",
  "#8a181f",
  "#731b2b",
  "#714061",
  "#d03739",
  "#7c1e20",
  "#61201f",
  "#6d3f48",
  "#5d1a37",
  "#d63d2b",
  "#433531",
  "#942425",
  "#93161f",
  "#71201e",
  "#5c2126",
  "#481e28",
  "#352125",
  "#382534",
  "#edded3",
  "#e76344",
  "#f1846e",
  "#f99b83",
  "#fbac95",
  "#fdcec1",
  "#fae2d8",
  "#ac4d4c",
  "#c16566",
  "#da8283",
  "#ebbdbe",
  "#a2483b",
  "#c46a64",
  "#d98883",
  "#ebb3b0",
  "#f3cdca",
  "#864335",
  "#a9695b",
  "#bb8273",
  "#e1b9ad",
  "#ebcbc1",
  "#755042",
  "#e55b2b",
  "#f48357",
  "#fc9f74",
  "#fed4bc",
  "#fce2cf",
  "#c86361",
  "#dd8a89",
  "#efb8b8",
  "#8d3c30",
  "#c37466",
  "#cf8374",
  "#dd998d",
  "#ecb8ae",
  "#874933",
  "#e0b4a2",
  "#f0d1c3",
  "#bda49a",
  "#d7c0b6",
  "#e0cec5",
  "#ec793c",
  "#f39562",
  "#f8aa77",
  "#ffb384",
  "#ffc9a3",
  "#fcd7cc",
  "#98503d",
  "#b86b56",
  "#cf866f",
  "#e9a58c",
  "#f2c9ba",
  "#7b4232",
  "#a4624d",
  "#be816a",
  "#dca78f",
  "#fbe5d2",
  "#6a4b3d",
  "#896b5e",
  "#a08173",
  "#c2a798",
  "#d5c5b9",
  "#e8ddd0",
  "#c44c38",
  "#dd705a",
  "#e98c76",
  "#f99f8c",
  "#fccfc1",
  "#fae3da",
  "#ab603f",
  "#c47954",
  "#d48e68",
  "#e6ac89",
  "#eec6ac",
  "#f8dac6",
  "#8d5b41",
  "#b8896b",
  "#cc9f80",
  "#ddbaa1",
  "#674c3d",
  "#826455",
  "#a28576",
  "#ccb9ac",
  "#e9dcd2",
  "#be8158",
  "#f7dfca",
  "#b17857",
  "#c49072",
  "#dbad93",
  "#624b3f",
  "#8b7161",
  "#a28776",
  "#ae9685",
  "#c2b5a7",
  "#e0d8cf",
  "#fec7a5",
  "#d49a71",
  "#e8be9e",
  "#f4d5be",
  "#e7d3c3",
  "#846b59",
  "#988170",
  "#baa693",
  "#c4b3a4",
  "#ffaa3e",
  "#ffb861",
  "#ffc16f",
  "#ffd293",
  "#ee8441",
  "#f79751",
  "#feb175",
  "#ffc999",
  "#ffdcb5",
  "#fbe6d0",
  "#b86e4a",
  "#d88c5f",
  "#dd9971",
  "#f4e3ce",
  "#8c6149",
  "#a57758",
  "#eddac9",
  "#8d7562",
  "#ae9886",
  "#c7b5a4",
  "#dacab9",
  "#ebe0d4",
  "#fe9a20",
  "#895c3d",
  "#8c6343",
  "#b48765",
  "#c29875",
  "#ceaf93",
  "#e5ccb6",
  "#6d5747",
  "#b49d88",
  "#5e3d2f",
  "#694134",
  "#ea6313",
  "#fc8901",
  "#543f36",
  "#a64740",
  "#76422d",
  "#923f2d",
  "#624035",
  "#d6bba6",
  "#e1cdbc",
  "#ffa501",
  "#fdeecf",
  "#d7873f",
  "#e09655",
  "#f5be86",
  "#fcd1a4",
  "#f7e4ca",
  "#eeb377",
  "#fce7ca",
  "#7a5844",
  "#99755d",
  "#bc9579",
  "#cdab92",
  "#917158",
  "#b29175",
  "#d1b390",
  "#dec5a7",
  "#e4d6c3",
  "#ffc03c",
  "#ffcf6d",
  "#ffe19c",
  "#ffe9be",
  "#e89629",
  "#f9b24e",
  "#ffc168",
  "#fdcb85",
  "#ffdba6",
  "#ca8c4d",
  "#dca46e",
  "#eab583",
  "#f3ca9c",
  "#f3d3ab",
  "#9a6944",
  "#b38159",
  "#c99870",
  "#edcfb2",
  "#f3e1cd",
  "#7f5b43",
  "#8f6f51",
  "#b79878",
  "#c6af98",
  "#d1beaa",
  "#e6dccc",
  "#ffb701",
  "#ffcd44",
  "#ffd971",
  "#ffe298",
  "#fee6c0",
  "#bc7f3e",
  "#cf904f",
  "#deaf79",
  "#efcca1",
  "#f3dabb",
  "#8c6343",
  "#a97a51",
  "#b88654",
  "#d6b080",
  "#f4e6d1",
  "#9a7e65",
  "#b59a7c",
  "#c5a887",
  "#dfc5a9",
  "#e6d5be",
  "#ffbd27",
  "#ffc12b",
  "#d09040",
  "#dfa45d",
  "#eec58e",
  "#f3d1a3",
  "#fde5c2",
  "#c99c69",
  "#e1c097",
  "#eed5b1",
  "#f4e4ca",
  "#7d5d42",
  "#99795a",
  "#a78967",
  "#d5bd99",
  "#dac5a8",
  "#fde9b7",
  "#b9803c",
  "#dbaa6d",
  "#e7be84",
  "#ecca9b",
  "#f1d8b7",
  "#b28344",
  "#cc9f61",
  "#e7bf87",
  "#f2d3a8",
  "#f6e5be",
  "#927144",
  "#bda076",
  "#ece5d6",
  "#e9b745",
  "#f8c452",
  "#f9d275",
  "#f8db91",
  "#f7e1ab",
  "#fcecc4",
  "#d29038",
  "#e5a956",
  "#f3be79",
  "#fed498",
  "#fcdcab",
  "#b18f62",
  "#ece1cb",
  "#7e633f",
  "#bfa98c",
  "#d1bea1",
  "#daccb7",
  "#fbefc6",
  "#e7c455",
  "#f4d77f",
  "#b3883b",
  "#cba25e",
  "#dfbb7d",
  "#ebcb94",
  "#f4dfb8",
  "#c7ab7b",
  "#dfc69c",
  "#746045",
  "#927d60",
  "#a9967b",
  "#c6b6a0",
  "#e1d6c4",
  "#ede6da",
  "#ffce01",
  "#ffd542",
  "#ffde76",
  "#ffe692",
  "#fdeab3",
  "#f9eec9",
  "#c99e3a",
  "#d3b05e",
  "#e1c073",
  "#efd59c",
  "#b49d5f",
  "#bda975",
  "#cfbc8b",
  "#dccaa2",
  "#6c5a47",
  "#968066",
  "#b97d2a",
  "#b5723b",
  "#524237",
  "#ffb801",
  "#c3813d",
  "#9e633e",
  "#6d4934",
  "#9b622a",
  "#985330",
  "#945b3d",
  "#684930",
  "#caa6cf",
  "#ab7db2",
  "#7e4883",
  "#d4d0cf",
  "#b8b0ae",
  "#8a8486",
  "#7d777a",
  "#b7abb8",
  "#a697a6",
  "#806f7d",
  "#534654",
  "#f6e8ec",
  "#e3d1e4",
  "#dcc1dd",
  "#b99ecd",
  "#997bb5",
  "#77508b",
  "#cec7c4",
  "#b3a8a4",
  "#433631",
  "#dfdade",
  "#c6c9db",
  "#a6abc6",
  "#98a0c1",
  "#71799f",
  "#4c557d",
  "#e3dae8",
  "#dacee2",
  "#d5c3e1",
  "#664f8b",
  "#dad9d4",
  "#cbc9c4",
  "#a9a39d",
  "#736e6a",
  "#57524e",
  "#d4dde0",
  "#cfd6dd",
  "#aeb6c3",
  "#6d7686",
  "#505a6d",
  "#8da6ca",
  "#7893bf",
  "#58739b",
  "#a1abd7",
  "#6c7cb8",
  "#4b5795",
  "#d5d3cc",
  "#b3b4b0",
  "#a1a09b",
  "#81817e",
  "#656764",
  "#909dac",
  "#717f90",
  "#5f6d7d",
  "#405162",
  "#a8c3d8",
  "#87a8c2",
  "#6890ae",
  "#4f718a",
  "#39607f",
  "#dbdeec",
  "#c4cee7",
  "#6e92c8",
  "#d5d6d4",
  "#c3c6c7",
  "#a9acad",
  "#7d7f83",
  "#616467",
  "#46484a",
  "#c6d3db",
  "#a7bac9",
  "#8598a7",
  "#70869b",
  "#576f85",
  "#415262",
  "#c4d7e1",
  "#aac5d4",
  "#88a7ba",
  "#7797ac",
  "#3f576a",
  "#e3ecf0",
  "#c9d8ea",
  "#acc3e2",
  "#8eabd3",
  "#78b1d8",
  "#4491c8",
  "#cacece",
  "#b2b8bc",
  "#959a9d",
  "#727a80",
  "#5f676d",
  "#484b50",
  "#baccd6",
  "#9fb4c2",
  "#86a1b1",
  "#6c889a",
  "#587487",
  "#d3e6f1",
  "#afcae1",
  "#cce3f0",
  "#afd4eb",
  "#9cc8e9",
  "#58a9d3",
  "#339bcf",
  "#0169a7",
  "#ced3d2",
  "#aeb6b7",
  "#919a9b",
  "#7c878b",
  "#687276",
  "#454a4c",
  "#d2dadd",
  "#b3bfc5",
  "#8696a0",
  "#60717c",
  "#536470",
  "#3d4b54",
  "#d7e2e4",
  "#9dbcc9",
  "#7a9cab",
  "#517689",
  "#34576a",
  "#cde1e9",
  "#b4d4e8",
  "#99c1dd",
  "#76a8cd",
  "#9fd0e7",
  "#53b5df",
  "#0192cc",
  "#0178b6",
  "#cccecc",
  "#b1b4b2",
  "#959896",
  "#808585",
  "#6b7071",
  "#4e5150",
  "#d1dbdc",
  "#b7c5cc",
  "#8ba1ac",
  "#698593",
  "#6b808c",
  "#39444d",
  "#bed5de",
  "#a3c2d0",
  "#7aa0b2",
  "#5d8699",
  "#51788b",
  "#c2e0ed",
  "#c9e1ea",
  "#a0d5ec",
  "#76c2e3",
  "#2e2e30",
  "#343e49",
  "#1f4c68",
  "#3a4044",
  "#433267",
  "#22394a",
  "#2a436a",
  "#323f76",
  "#292a2d",
  "#2b3140",
  "#214c5f",
  "#2f3465",
  "#6fb8d3",
  "#3f9fc2",
  "#1080a7",
  "#aebabd",
  "#8a989a",
  "#6d7c81",
  "#59686c",
  "#4b5558",
  "#c8cfcc",
  "#9bacac",
  "#859694",
  "#6d8484",
  "#414d4f",
  "#c7dadd",
  "#a0c2c9",
  "#81a9b2",
  "#618f99",
  "#497a84",
  "#395c65",
  "#99c8dd",
  "#66a8c5",
  "#4891b0",
  "#3481a1",
  "#2aaaca",
  "#0195b7",
  "#017fa4",
  "#ced5ce",
  "#b1b8b3",
  "#939a91",
  "#7f8984",
  "#6d7671",
  "#494e49",
  "#c7d6cd",
  "#b8cbc4",
  "#789692",
  "#6d8c8b",
  "#cee9e9",
  "#b3dce4",
  "#84c1cf",
  "#67afbe",
  "#358f9f",
  "#0c5f6c",
  "#cee5eb",
  "#aed9e7",
  "#78c6e3",
  "#6ac2d6",
  "#d5dad0",
  "#969d8f",
  "#808374",
  "#71796c",
  "#a8baaf",
  "#8a9f95",
  "#c2d7d3",
  "#456b65",
  "#c6e8ef",
  "#acdde8",
  "#91d2e4",
  "#52bfc7",
  "#01a2ad",
  "#017b86",
  "#54584a",
  "#dde7e1",
  "#bfc7bb",
  "#6f847a",
  "#415a51",
  "#aac2b2",
  "#4e8a7e",
  "#4a9ca6",
  "#3c8b95",
  "#d7f1ed",
  "#b9e0e5",
  "#84d2d8",
  "#979b92",
  "#797c72",
  "#5c5f56",
  "#dbded4",
  "#cacdc1",
  "#678c77",
  "#637f6f",
  "#445c4c",
  "#4bc3bc",
  "#10b0ac",
  "#018380",
  "#c8c7bf",
  "#b8b9b2",
  "#a2a199",
  "#7b7b73",
  "#585953",
  "#bcc5b1",
  "#a7b49f",
  "#929d86",
  "#7a856f",
  "#4b5847",
  "#dbe8dd",
  "#c4d5c8",
  "#99b6a2",
  "#c7e4e2",
  "#a8d7d7",
  "#8ccacb",
  "#68b6b6",
  "#3d979b",
  "#217c80",
  "#b0e3df",
  "#83d6d1",
  "#53bdb2",
  "#01a298",
  "#018d82",
  "#d8d8ce",
  "#a9aaa0",
  "#97978c",
  "#7f7f75",
  "#5e5d53",
  "#d9dccc",
  "#c9d1c0",
  "#a4ae8f",
  "#8b9476",
  "#788366",
  "#565e43",
  "#cbdcc0",
  "#bfd1b5",
  "#a0b692",
  "#88a27d",
  "#78926b",
  "#617a51",
  "#bde2dc",
  "#a9d2cc",
  "#8bc8c3",
  "#4aaba6",
  "#39918e",
  "#a8dacf",
  "#6ec9c2",
  "#60d0b9",
  "#01b79e",
  "#018f70",
  "#d0cbbd",
  "#bcb5a5",
  "#938c75",
  "#797056",
  "#dfe2d2",
  "#d6e5cc",
  "#c0d7b4",
  "#a2c094",
  "#8aad7d",
  "#7b9f6d",
  "#5f8349",
  "#d0e8e0",
  "#c3ece2",
  "#a8e3d7",
  "#93dece",
  "#354140",
  "#016282",
  "#424d58",
  "#3b4843",
  "#015b51",
  "#016c51",
  "#0f6761",
  "#2f3837",
  "#293944",
  "#2b3f40",
  "#2c4841",
  "#207b6f",
  "#2d3435",
  "#2f3238",
  "#23424a",
  "#017067",
  "#d5d2c4",
  "#585445",
  "#dedcc9",
  "#c9c8b1",
  "#8f9073",
  "#808063",
  "#636347",
  "#d4dab8",
  "#c4cb9f",
  "#a6b483",
  "#90a372",
  "#6d7e4f",
  "#cde6d7",
  "#bfe0ce",
  "#a3ceb6",
  "#8abea2",
  "#629c80",
  "#2d6e4b",
  "#6bc9a9",
  "#41bc97",
  "#019f7d",
  "#e2dfd5",
  "#a9a191",
  "#a29b8d",
  "#857d6d",
  "#dfddc3",
  "#cecaa4",
  "#b9b891",
  "#a29f73",
  "#908e62",
  "#7a774c",
  "#cae5d5",
  "#b6e5cd",
  "#80d4b7",
  "#60bd8e",
  "#46ac79",
  "#199d67",
  "#ddd6c9",
  "#bdb6aa",
  "#8d8679",
  "#7a7467",
  "#534c41",
  "#e2ddc3",
  "#dbe0b4",
  "#cbcf97",
  "#bac17e",
  "#a3ad69",
  "#7c873a",
  "#ceecdb",
  "#ade1c5",
  "#81cea4",
  "#79c080",
  "#64b169",
  "#42a04d",
  "#eae8e1",
  "#b8b4aa",
  "#b0a69a",
  "#9e978c",
  "#817b72",
  "#e5edd3",
  "#d9e9c3",
  "#c2e5c3",
  "#94cf97",
  "#a9cf7e",
  "#8bc063",
  "#69a934",
  "#e3dcd0",
  "#d0c9ba",
  "#aca194",
  "#9e9386",
  "#83786d",
  "#c9c5b3",
  "#b9b18d",
  "#a49e7e",
  "#87805f",
  "#605930",
  "#dad5a4",
  "#c3bd83",
  "#b0a866",
  "#9f9956",
  "#81804a",
  "#e4edd5",
  "#b8d892",
  "#e8dac6",
  "#f4efe7",
  "#eee7d9",
  "#edede9",
  "#eee9de",
  "#a4c65e",
  "#87b743",
  "#dad2c5",
  "#cec1ae",
  "#baac9a",
  "#998976",
  "#857666",
  "#5c4e3e",
  "#dcd6ba",
  "#c7bf9e",
  "#655f45",
  "#e3d9b7",
  "#cac19a",
  "#a79d6a",
  "#a19464",
  "#ededcd",
  "#e7ebc7",
  "#dde7b9",
  "#d2e1a0",
  "#dcdb76",
  "#8f7e68",
  "#e1d5b8",
  "#c1b28b",
  "#a7986b",
  "#98895d",
  "#8a7c52",
  "#e7e1c2",
  "#dbd1a4",
  "#cdc186",
  "#baab5d",
  "#b3a34c",
  "#9e9341",
  "#ebebb9",
  "#d9df8c",
  "#c5d165",
  "#b6c957",
  "#acc137",
  "#e2df84",
  "#c4b7a2",
  "#92846a",
  "#65563f",
  "#e5dbc5",
  "#d9c9ab",
  "#cbb995",
  "#bda982",
  "#a18d65",
  "#806d46",
  "#f4e8c7",
  "#f3e3b7",
  "#ece8b1",
  "#c6c13b",
  "#b1b323",
  "#f2eabc",
  "#443f3e",
  "#96a52b",
  "#365542",
  "#316736",
  "#466330",
  "#473a31",
  "#038038",
  "#3a3530",
  "#333b2f",
  "#215f3c",
  "#589837",
  "#ecd7d0",
  "#e4e2df",
  "#e4e0dc",
  "#e4d5cf",
  "#f7eeea",
  "#e4ded7",
  "#e0d5c8",
  "#f4e6d2",
  "#eae2d5",
  "#eadfcc",
  "#f2ede2",
  "#f1efe7",
  "#f9e7d7",
  "#f9ead6",
  "#f0e6d8",
  "#f2e1ca",
  "#f1ecde",
  "#f1efe9",
  "#f2ede3",
  "#f2ede3",
  "#dbcebc",
  "#e8d8bd",
  "#f2e6ce",
  "#f0ecdf",
  "#e5d9c3",
  "#f5f1e2",
  "#f2e6d1",
  "#ecddc6",
  "#e7e4e3",
  "#d7d9da",
  "#eaecea",
  "#dfe1e1",
  "#e6e9e4",
  "#dadedb",
  "#d7d5d1",
  "#e0e1de",
  "#e1dfe3",
  "#d1d3d1",
  "#e2e4de",
  "#ebebe8",
  "#d7dbda",
  "#e4eded",
  "#dde8e8",
  "#e3e1df",
  "#f8f4e5",
  "#d9ede9",
  "#e5ebe0",
  "#e5e0d5",
  "#ebece6",
  "#e1ddd1",
  "#eae7e1",
  "#dfdfd9",
  "#eceae1",
  "#f8f8f3",
  "#f0ede7",
  "#e0dccf",
  "#f1e7d4",
  "#e5e4d8",
  "#e9e0d2",
  "#d1cbc1",
  "#f6ddde",
  "#f9cdcf",
  "#fad6d4",
  "#fbd8d4",
  "#f7b7aa",
  "#c33d25",
  "#f07346",
  "#de7231",
  "#d3891e",
  "#734682",
  "#c49832",
  "#efb901",
  "#ffedb5",
  "#e8ce6c",
  "#e7c148",
  "#e1b801",
  "#f9ec9f",
  "#f5e47a",
  "#f1da65",
  "#d7b526",
  "#bfa303",
  "#b29308",
  "#ede8c1",
  "#f2e7b1",
  "#ecda99",
  "#e2d388",
  "#d8c360",
  "#bca62a",
  "#a69511",
  "#dbd564",
  "#9aa22a",
  "#bfd785",
  "#639d01",
  "#966e9c",
  "#633570",
  "#cfebce",
  "#01866e",
  "#01755c",
  "#018077",
  "#016f78",
  "#1fa9c3",
  "#01819a",
  "#017388",
  "#ac4b7e",
  "#c5e2eb",
  "#b2dae9",
  "#9ed2e6",
  "#016892",
  "#b2dded",
  "#83c1e2",
  "#68b6e0",
  "#3780b9",
  "#10659f",
  "#9ec3e2",
  "#88b0d7",
  "#5287b9",
  "#28679e",
  "#214f86",
  "#d2dfee",
  "#5985c0",
  "#245b9e",
  "#dde0ed",
  "#b5c1e3",
  "#dfdeec",
  "#cecfe8",
  "#b3b5dd",
  "#959ccd",
  "#7e85bd",
  "#4c5192",
  "#3d4281",
  "#e4dfed",
  "#d6d0e8",
  "#c6bee0",
  "#a199c7",
  "#8679b5",
  "#a21f4e",
  "#bc4666",
  "#bf4a60",
  "#ab3148",
  "#ad273f",
  "#f393a9",
  "#f6dfe3",
  "#f0cacd",
  "#f2b2b8",
  "#e18d94",
  "#c6616a",
  "#a82e33",
  "#f9d9d0",
  "#f8d4c6",
  "#ecbba8",
  "#de9e85",
  "#d28165",
  "#b8694a",
  "#904929",
  "#7f3d29",
  "#f7dac1",
  "#f0bf9b",
  "#ecb28a",
  "#b06525",
  "#eabc86",
  "#d09a62",
  "#e9c091",
  "#d5a472",
  "#c38b4c",
  "#bb813e",
  "#a36b27",
  "#f3ddc2",
  "#ac783f",
  "#e7e0e9",
  "#d8cadf",
  "#b2711c",
  "#f8e6c8",
  "#ca9142",
  "#c1904c",
  "#9b6a13",
  "#9f7111",
  "#e5cb8d",
  "#9e772e",
  "#f2e0a8",
  "#e2cc8b",
  "#d3be7d",
  "#bda459",
  "#a88b2d",
  "#877a23",
  "#ecebcc",
  "#63652e",
  "#e5e9ce",
  "#6d803b",
  "#e6e9ce",
  "#58713f",
  "#dfc4d8",
  "#dabdd6",
  "#d4e8bd",
  "#c7e1ac",
  "#a5cd8b",
  "#88ae6e",
  "#6b9252",
  "#567c3e",
  "#d5e6d6",
  "#cae1ce",
  "#b3d3b7",
  "#8aba97",
  "#76a984",
  "#5a8961",
  "#355d3d",
  "#d9e6df",
  "#c5dbd3",
  "#adcdc5",
  "#8bb6ae",
  "#cce8e2",
  "#015d61",
  "#b9dee2",
  "#a3d6dc",
  "#7ebfc5",
  "#01535d",
  "#dce9e9",
  "#bfe0e7",
  "#c8e5ec",
  "#b5dfeb",
  "#96d2e5",
  "#6fbdd3",
  "#3da1b8",
  "#017b92",
  "#015d72",
  "#b8d7de",
  "#a2c9d6",
  "#89b8c7",
  "#72a7b9",
  "#3e8094",
  "#1f6071",
  "#1a4858",
  "#b8dfee",
  "#01688a",
  "#015474",
  "#a0c5d7",
  "#90bdd3",
  "#73a9c2",
  "#43809f",
  "#106081",
  "#cee4ed",
  "#498bb8",
  "#015b8a",
  "#01537f",
  "#c9d8e6",
  "#b6cce0",
  "#92b2d1",
  "#769bc1",
  "#557ca2",
  "#305d84",
  "#0f456e",
  "#d0dae8",
  "#bfcde2",
  "#aebfda",
  "#e0d6e6",
  "#503f5b",
  "#f0d1d9",
  "#eaa8a8",
  "#973a3c",
  "#f1d9d3",
  "#eec2bb",
  "#efaea7",
  "#edd7c9",
  "#e8c7b4",
  "#deb58e",
  "#f3e4d1",
  "#dab390",
  "#cca683",
  "#ba8c64",
  "#eed9bc",
  "#d7bb98",
  "#a38365",
  "#624830",
  "#ddd7de",
  "#beb3be",
  "#f1e6d5",
  "#dbc2a0",
  "#dab88d",
  "#c29d74",
  "#a27a48",
  "#815b28",
  "#f3e6d0",
  "#e9d1b0",
  "#dfc19a",
  "#cca97c",
  "#b58d53",
  "#a57a3b",
  "#8f672f",
  "#efe3d1",
  "#e1ceb3",
  "#654a24",
  "#e5d1b0",
  "#b4945d",
  "#977638",
  "#816328",
  "#e5d6b5",
  "#957c37",
  "#f1e8d7",
  "#70602f",
  "#ebe6cc",
  "#807854",
  "#e4e0cb",
  "#d3ceb3",
  "#c4bca0",
  "#a69e7e",
  "#827a53",
  "#716a42",
  "#5d5934",
  "#eeecd9",
  "#e2dec5",
  "#cfcaa7",
  "#beb88f",
  "#9c955f",
  "#827e49",
  "#706d37",
  "#5f5f46",
  "#e2d4d9",
  "#cfbcc3",
  "#7e6472",
  "#5a4050",
  "#bbbca4",
  "#a9ab94",
  "#d3d8c4",
  "#cacfb2",
  "#d2ded0",
  "#c7d3c2",
  "#a7bca6",
  "#ccd6cd",
  "#c1ccc3",
  "#b1bcb1",
  "#9faa9e",
  "#748377",
  "#4f5b51",
  "#8da898",
  "#4f6d5f",
  "#d6e1d4",
  "#c7d5c9",
  "#485a50",
  "#99b6b3",
  "#1e4540",
  "#dbe7e6",
  "#aec7c6",
  "#8eadac",
  "#476462",
  "#d6e5e8",
  "#bdd0d0",
  "#a5bfc2",
  "#95b0b5",
  "#78969a",
  "#496c73",
  "#3c5355",
  "#c0d6de",
  "#aac8d5",
  "#94b8c7",
  "#739fb1",
  "#497a8d",
  "#316073",
  "#2b4a56",
  "#c9d9e0",
  "#b7ced6",
  "#d9e6e9",
  "#d6e4ea",
  "#5a7589",
  "#c6d9e6",
  "#20415c",
  "#c2cedf",
  "#afbfd3",
  "#9aafc7",
  "#8396b0",
  "#607895",
  "#475671",
  "#2a364e",
  "#d3d8e5",
  "#b3bad1",
  "#a3abc5",
  "#8e96b5",
  "#72799b",
  "#556082",
  "#404565",
  "#d0d1de",
  "#bdbfd1",
  "#acaec4",
  "#8e91ab",
  "#666b89",
  "#4f546d",
  "#40425a",
  "#dec1bf",
  "#f0d4ca",
  "#ce9382",
  "#ecd2cb",
  "#ecdfd5",
  "#ebd8cc",
  "#e2cec2",
  "#e8d7c8",
  "#aa8064",
  "#decdbc",
  "#dac1aa",
  "#c4a68c",
  "#efdfcb",
  "#e8d4bc",
  "#d6bea1",
  "#c9aa87",
  "#b38f67",
  "#9c7a56",
  "#826340",
  "#e2cfb2",
  "#cbb393",
  "#ae9271",
  "#8c6c43",
  "#61492b",
  "#d1cbcf",
  "#b8b3b6",
  "#979193",
  "#7f7a7d",
  "#676064",
  "#3d3940",
  "#d1c5b0",
  "#ac9c82",
  "#7a6f58",
  "#625745",
  "#746132",
  "#ece5d0",
  "#ded4ba",
  "#cdc09f",
  "#b9ab88",
  "#a69672",
  "#897a4d",
  "#756737",
  "#e1dbcb",
  "#cac2ad",
  "#b4ac95",
  "#a59c85",
  "#99907a",
  "#7d7256",
  "#534828",
  "#c2b8a1",
  "#a69d86",
  "#dddace",
  "#cecbbd",
  "#c0bdae",
  "#a6a290",
  "#928e7d",
  "#6d6953",
  "#59563f",
  "#bcbcae",
  "#6d6c62",
  "#b8bbac",
  "#a1a292",
  "#7c7f70",
  "#e4e4db",
  "#d0d1c4",
  "#b8b8aa",
  "#a9aa9c",
  "#e0d7db",
  "#d2c8cd",
  "#c3b7bc",
  "#9a898d",
  "#3d2f30",
  "#d8dad2",
  "#cdd0c7",
  "#b5b7af",
  "#8e9087",
  "#6c6e66",
  "#b5bcad",
  "#d8dbd7",
  "#cbd0c9",
  "#bfc5bb",
  "#a6aba1",
  "#757a70",
  "#dce2df",
  "#a3afac",
  "#d7dfdc",
  "#b7c1bd",
  "#a1afaa",
  "#889594",
  "#697473",
  "#d6e1dd",
  "#b9c8c9",
  "#acbcbd",
  "#ced9db",
  "#bfcbcd",
  "#b5c4c7",
  "#a9b8bb",
  "#9aa9ac",
  "#637a80",
  "#344c52",
  "#b4c5cb",
  "#9fb4bd",
  "#93a8b1",
  "#7a8f97",
  "#586c74",
  "#334c57",
  "#cfdee1",
  "#c5d8de",
  "#a2b9c1",
  "#849ea8",
  "#3d5f6d",
  "#e1dbda",
  "#d4cdcb",
  "#c9bfbd",
  "#b0a5a4",
  "#7f7574",
  "#6a5f5e",
  "#a4b7be",
  "#5c6c76",
  "#c8d1d6",
  "#a2b1ba",
  "#b2c3cd",
  "#bdc9d9",
  "#a4b1c1",
  "#d9dfe7",
  "#c6ccd6",
  "#99a0b2",
  "#d5d6da",
  "#bfc0c6",
  "#b1b3b9",
  "#989aa0",
  "#7c7f86",
  "#636a74",
  "#dadbde",
  "#c0c2ca",
  "#adb0ba",
  "#9396a2",
  "#6d6f7a",
  "#53545e",
  "#454751",
  "#d5d4d6",
  "#c7c5cc",
  "#b6b4bb",
  "#9d9ba7",
  "#888591",
  "#5f5a63",
  "#383238",
  "#dfd5d3",
  "#d2c0be",
  "#c4b1af",
  "#594645",
  "#ddcac6",
  "#d1beba",
  "#b7a49f",
  "#a38e89",
  "#7b6863",
  "#4a3a39",
  "#4e342d",
  "#d7cdc6",
  "#cfc0b6",
  "#b8a59b",
  "#dacdc2",
  "#967e71",
  "#6a5245",
  "#cdc2ba",
  "#9c8e83",
  "#7a6b61",
  "#57483d",
  "#dcd8d6",
  "#cfc9c8",
  "#a7a0a1",
  "#534c4c",
  "#dbdad6",
  "#958f88",
  "#3f3e39",
  "#ded9d0",
  "#d4cfc7",
  "#676259",
  "#e0dbd2",
  "#bfb6aa",
  "#dacfc0",
  "#cdc2b2",
  "#c1b6a5",
  "#b7a895",
  "#9e8f7b",
  "#473d32",
  "#ddcfb9",
  "#d4c3ac",
  "#d1c4b6",
  "#b5a79a",
  "#928070",
  "#786c5e",
  "#5b4937",
  "#e5d9cc",
  "#d1c0b0",
  "#614632",
  "#d5d8d7",
  "#d9d9d9",
  "#cacaca",
  "#c0c2c2",
  "#9d9c9c",
  "#757576",
  "#424040",
  "#cac8cb",
  "#b8b4b4",
  "#9d999a",
  "#777575",
  "#4d494c",
  "#2f2f2f",
  "#b0a998",
  "#4d4b41",
  "#d6d2ca",
  "#d0cabf",
  "#c1bbb0",
  "#a8a298",
  "#8e8a81",
  "#4a4641",
  "#dbdad4",
  "#918f85",
  "#d1d0ca",
  "#3c3e3c",
  "#dfe0e3",
  "#caced2",
  "#959b9e",
  "#70777a",
  "#656b6f",
  "#454b4f",
  "#c9d0d4",
  "#b8c2c8",
  "#a6b1b9",
  "#87949e",
  "#6d7983",
  "#4b565d",
  "#22262b",
  "#e2d3c0",
  "#f8efe2",
  "#fbe8d0",
  "#e9d8c5",
  "#e6e2df",
  "#dfdcda",
  "#e7e3dc",
  "#e4ded7",
  "#e7e7e6",
  "#f0f3f0",
  "#edefeb",
  "#eaf0f0",
  "#dde5e6",
  "#ddedee",
  "#f7f4eb",
  "#ebeae4",
  "#e6e5de",
  "#f6f5eb",
  "#f3f1e4",
  "#f2f4ea",
  "#f0f1e7",
  "#f3f2ed",
  "#f5f5ef",
  "#ecebe8",
  "#f6f0e2",
  "#f8f3e6",
  "#f9f4de",
  "#e0d6c3",
  "#a2794a",
  "#62615d",
  "#6e3831",
  "#365f76",
  "#375348",
  "#cecccb",
  "#5b6163",
  "#8f5a40",
  "#79343c",
];
